import { r as e } from "./rolldown-runtime-D4WipbvC.mjs";
import * as t from "react";
import n, { createContext as r, forwardRef as i, memo as a, startTransition as o, useCallback as s, useContext as c, useDeferredValue as l, useEffect as u, useLayoutEffect as d, useMemo as f, useReducer as p, useRef as m, useState as h } from "react";
import { Fragment as g, jsx as _, jsxs as v } from "react/jsx-runtime";
import y, { createPortal as b } from "react-dom";
import { Link as x, NavLink as S, Outlet as C } from "react-router-dom";
//#region src/utils/logger.ts
var w = {
	debug: 0,
	info: 1,
	warn: 2,
	error: 3
}, T = process.env.NODE_ENV === "production" ? "info" : "debug", E = () => {
	try {
		return (typeof window < "u" ? localStorage.getItem("logLevel") : null) || T;
	} catch {
		return T;
	}
}, D = (e) => {
	let t = (e) => {
		let t = E();
		return w[e] >= w[t];
	};
	return {
		debug: (n, ...r) => {
			t("debug") && console.debug(`[${e}]`, n, ...r);
		},
		info: (n, ...r) => {
			t("info") && console.info(`[${e}]`, n, ...r);
		},
		warn: (n, ...r) => {
			t("warn") && console.warn(`[${e}]`, n, ...r);
		},
		error: (n, ...r) => {
			t("error") && console.error(`[${e}]`, n, ...r);
		}
	};
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/bind.js
function O(e, t) {
	return function() {
		return e.apply(t, arguments);
	};
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/utils.js
var { toString: k } = Object.prototype, { getPrototypeOf: A } = Object, { iterator: j, toStringTag: M } = Symbol, N = ((e) => (t) => {
	let n = k.call(t);
	return e[n] || (e[n] = n.slice(8, -1).toLowerCase());
})(Object.create(null)), P = (e) => (e = e.toLowerCase(), (t) => N(t) === e), F = (e) => (t) => typeof t === e, { isArray: I } = Array, L = F("undefined");
function R(e) {
	return e !== null && !L(e) && e.constructor !== null && !L(e.constructor) && H(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
var z = P("ArrayBuffer");
function B(e) {
	let t;
	return t = typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(e) : e && e.buffer && z(e.buffer), t;
}
var V = F("string"), H = F("function"), ee = F("number"), U = (e) => typeof e == "object" && !!e, te = (e) => e === !0 || e === !1, W = (e) => {
	if (N(e) !== "object") return !1;
	let t = A(e);
	return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(M in e) && !(j in e);
}, ne = (e) => {
	if (!U(e) || R(e)) return !1;
	try {
		return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
	} catch {
		return !1;
	}
}, re = P("Date"), ie = P("File"), ae = (e) => !!(e && e.uri !== void 0), oe = (e) => e && e.getParts !== void 0, se = P("Blob"), ce = P("FileList"), le = (e) => U(e) && H(e.pipe);
function ue() {
	return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
var de = ue(), fe = de.FormData === void 0 ? void 0 : de.FormData, pe = (e) => {
	if (!e) return !1;
	if (fe && e instanceof fe) return !0;
	let t = A(e);
	if (!t || t === Object.prototype || !H(e.append)) return !1;
	let n = N(e);
	return n === "formdata" || n === "object" && H(e.toString) && e.toString() === "[object FormData]";
}, me = P("URLSearchParams"), [he, ge, _e, ve] = [
	"ReadableStream",
	"Request",
	"Response",
	"Headers"
].map(P), ye = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function be(e, t, { allOwnKeys: n = !1 } = {}) {
	if (e == null) return;
	let r, i;
	if (typeof e != "object" && (e = [e]), I(e)) for (r = 0, i = e.length; r < i; r++) t.call(null, e[r], r, e);
	else {
		if (R(e)) return;
		let i = n ? Object.getOwnPropertyNames(e) : Object.keys(e), a = i.length, o;
		for (r = 0; r < a; r++) o = i[r], t.call(null, e[o], o, e);
	}
}
function xe(e, t) {
	if (R(e)) return null;
	t = t.toLowerCase();
	let n = Object.keys(e), r = n.length, i;
	for (; r-- > 0;) if (i = n[r], t === i.toLowerCase()) return i;
	return null;
}
var Se = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Ce = (e) => !L(e) && e !== Se;
function we(...e) {
	let { caseless: t, skipUndefined: n } = Ce(this) && this || {}, r = {}, i = (e, i) => {
		if (i === "__proto__" || i === "constructor" || i === "prototype") return;
		let a = t && xe(r, i) || i, o = Pe(r, a) ? r[a] : void 0;
		W(o) && W(e) ? r[a] = we(o, e) : W(e) ? r[a] = we({}, e) : I(e) ? r[a] = e.slice() : (!n || !L(e)) && (r[a] = e);
	};
	for (let t = 0, n = e.length; t < n; t++) e[t] && be(e[t], i);
	return r;
}
var G = (e, t, n, { allOwnKeys: r } = {}) => (be(t, (t, r) => {
	n && H(t) ? Object.defineProperty(e, r, {
		__proto__: null,
		value: O(t, n),
		writable: !0,
		enumerable: !0,
		configurable: !0
	}) : Object.defineProperty(e, r, {
		__proto__: null,
		value: t,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}, { allOwnKeys: r }), e), Te = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), Ee = (e, t, n, r) => {
	e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
		__proto__: null,
		value: e,
		writable: !0,
		enumerable: !1,
		configurable: !0
	}), Object.defineProperty(e, "super", {
		__proto__: null,
		value: t.prototype
	}), n && Object.assign(e.prototype, n);
}, K = (e, t, n, r) => {
	let i, a, o, s = {};
	if (t ||= {}, e == null) return t;
	do {
		for (i = Object.getOwnPropertyNames(e), a = i.length; a-- > 0;) o = i[a], (!r || r(o, e, t)) && !s[o] && (t[o] = e[o], s[o] = !0);
		e = n !== !1 && A(e);
	} while (e && (!n || n(e, t)) && e !== Object.prototype);
	return t;
}, De = (e, t, n) => {
	e = String(e), (n === void 0 || n > e.length) && (n = e.length), n -= t.length;
	let r = e.indexOf(t, n);
	return r !== -1 && r === n;
}, Oe = (e) => {
	if (!e) return null;
	if (I(e)) return e;
	let t = e.length;
	if (!ee(t)) return null;
	let n = Array(t);
	for (; t-- > 0;) n[t] = e[t];
	return n;
}, ke = ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && A(Uint8Array)), Ae = (e, t) => {
	let n = (e && e[j]).call(e), r;
	for (; (r = n.next()) && !r.done;) {
		let n = r.value;
		t.call(e, n[0], n[1]);
	}
}, je = (e, t) => {
	let n, r = [];
	for (; (n = e.exec(t)) !== null;) r.push(n);
	return r;
}, Me = P("HTMLFormElement"), Ne = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(e, t, n) {
	return t.toUpperCase() + n;
}), Pe = (({ hasOwnProperty: e }) => (t, n) => e.call(t, n))(Object.prototype), Fe = P("RegExp"), Ie = (e, t) => {
	let n = Object.getOwnPropertyDescriptors(e), r = {};
	be(n, (n, i) => {
		let a;
		(a = t(n, i, e)) !== !1 && (r[i] = a || n);
	}), Object.defineProperties(e, r);
}, Le = (e) => {
	Ie(e, (t, n) => {
		if (H(e) && [
			"arguments",
			"caller",
			"callee"
		].includes(n)) return !1;
		let r = e[n];
		if (H(r)) {
			if (t.enumerable = !1, "writable" in t) {
				t.writable = !1;
				return;
			}
			t.set ||= () => {
				throw Error("Can not rewrite read-only method '" + n + "'");
			};
		}
	});
}, Re = (e, t) => {
	let n = {}, r = (e) => {
		e.forEach((e) => {
			n[e] = !0;
		});
	};
	return I(e) ? r(e) : r(String(e).split(t)), n;
}, ze = () => {}, Be = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function Ve(e) {
	return !!(e && H(e.append) && e[M] === "FormData" && e[j]);
}
var He = (e) => {
	let t = /* @__PURE__ */ new WeakSet(), n = (e) => {
		if (U(e)) {
			if (t.has(e)) return;
			if (R(e)) return e;
			if (!("toJSON" in e)) {
				t.add(e);
				let r = I(e) ? [] : {};
				return be(e, (e, t) => {
					let i = n(e);
					!L(i) && (r[t] = i);
				}), t.delete(e), r;
			}
		}
		return e;
	};
	return n(e);
}, Ue = P("AsyncFunction"), q = (e) => e && (U(e) || H(e)) && H(e.then) && H(e.catch), We = ((e, t) => e ? setImmediate : t ? ((e, t) => (Se.addEventListener("message", ({ source: n, data: r }) => {
	n === Se && r === e && t.length && t.shift()();
}, !1), (n) => {
	t.push(n), Se.postMessage(e, "*");
}))(`axios@${Math.random()}`, []) : (e) => setTimeout(e))(typeof setImmediate == "function", H(Se.postMessage)), J = {
	isArray: I,
	isArrayBuffer: z,
	isBuffer: R,
	isFormData: pe,
	isArrayBufferView: B,
	isString: V,
	isNumber: ee,
	isBoolean: te,
	isObject: U,
	isPlainObject: W,
	isEmptyObject: ne,
	isReadableStream: he,
	isRequest: ge,
	isResponse: _e,
	isHeaders: ve,
	isUndefined: L,
	isDate: re,
	isFile: ie,
	isReactNativeBlob: ae,
	isReactNative: oe,
	isBlob: se,
	isRegExp: Fe,
	isFunction: H,
	isStream: le,
	isURLSearchParams: me,
	isTypedArray: ke,
	isFileList: ce,
	forEach: be,
	merge: we,
	extend: G,
	trim: ye,
	stripBOM: Te,
	inherits: Ee,
	toFlatObject: K,
	kindOf: N,
	kindOfTest: P,
	endsWith: De,
	toArray: Oe,
	forEachEntry: Ae,
	matchAll: je,
	isHTMLForm: Me,
	hasOwnProperty: Pe,
	hasOwnProp: Pe,
	reduceDescriptors: Ie,
	freezeMethods: Le,
	toObjectSet: Re,
	toCamelCase: Ne,
	noop: ze,
	toFiniteNumber: Be,
	findKey: xe,
	global: Se,
	isContextDefined: Ce,
	isSpecCompliantForm: Ve,
	toJSONObject: He,
	isAsyncFn: Ue,
	isThenable: q,
	setImmediate: We,
	asap: typeof queueMicrotask < "u" ? queueMicrotask.bind(Se) : typeof process < "u" && process.nextTick || We,
	isIterable: (e) => e != null && H(e[j])
}, Ge = J.toObjectSet([
	"age",
	"authorization",
	"content-length",
	"content-type",
	"etag",
	"expires",
	"from",
	"host",
	"if-modified-since",
	"if-unmodified-since",
	"last-modified",
	"location",
	"max-forwards",
	"proxy-authorization",
	"referer",
	"retry-after",
	"user-agent"
]), Ke = (e) => {
	let t = {}, n, r, i;
	return e && e.split("\n").forEach(function(e) {
		i = e.indexOf(":"), n = e.substring(0, i).trim().toLowerCase(), r = e.substring(i + 1).trim(), !(!n || t[n] && Ge[n]) && (n === "set-cookie" ? t[n] ? t[n].push(r) : t[n] = [r] : t[n] = t[n] ? t[n] + ", " + r : r);
	}), t;
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/sanitizeHeaderValue.js
function qe(e) {
	let t = 0, n = e.length;
	for (; t < n;) {
		let n = e.charCodeAt(t);
		if (n !== 9 && n !== 32) break;
		t += 1;
	}
	for (; n > t;) {
		let t = e.charCodeAt(n - 1);
		if (t !== 9 && t !== 32) break;
		--n;
	}
	return t === 0 && n === e.length ? e : e.slice(t, n);
}
var Je = /* @__PURE__ */ RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), Ye = /* @__PURE__ */ RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function Xe(e, t) {
	return J.isArray(e) ? e.map((e) => Xe(e, t)) : qe(String(e).replace(t, ""));
}
var Ze = (e) => Xe(e, Je), Qe = (e) => Xe(e, Ye);
function $e(e) {
	let t = Object.create(null);
	return J.forEach(e.toJSON(), (e, n) => {
		t[n] = Qe(e);
	}), t;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/AxiosHeaders.js
var et = Symbol("internals");
function tt(e) {
	return e && String(e).trim().toLowerCase();
}
function nt(e) {
	return e === !1 || e == null ? e : J.isArray(e) ? e.map(nt) : Ze(String(e));
}
function rt(e) {
	let t = Object.create(null), n = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g, r;
	for (; r = n.exec(e);) t[r[1]] = r[2];
	return t;
}
var it = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function at(e, t, n, r, i) {
	if (J.isFunction(r)) return r.call(this, t, n);
	if (i && (t = n), J.isString(t)) {
		if (J.isString(r)) return t.indexOf(r) !== -1;
		if (J.isRegExp(r)) return r.test(t);
	}
}
function ot(e) {
	return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, t, n) => t.toUpperCase() + n);
}
function st(e, t) {
	let n = J.toCamelCase(" " + t);
	[
		"get",
		"set",
		"has"
	].forEach((r) => {
		Object.defineProperty(e, r + n, {
			__proto__: null,
			value: function(e, n, i) {
				return this[r].call(this, t, e, n, i);
			},
			configurable: !0
		});
	});
}
var ct = class {
	constructor(e) {
		e && this.set(e);
	}
	set(e, t, n) {
		let r = this;
		function i(e, t, n) {
			let i = tt(t);
			if (!i) throw Error("header name must be a non-empty string");
			let a = J.findKey(r, i);
			(!a || r[a] === void 0 || n === !0 || n === void 0 && r[a] !== !1) && (r[a || t] = nt(e));
		}
		let a = (e, t) => J.forEach(e, (e, n) => i(e, n, t));
		if (J.isPlainObject(e) || e instanceof this.constructor) a(e, t);
		else if (J.isString(e) && (e = e.trim()) && !it(e)) a(Ke(e), t);
		else if (J.isObject(e) && J.isIterable(e)) {
			let n = {}, r, i;
			for (let t of e) {
				if (!J.isArray(t)) throw TypeError("Object iterator must return a key-value pair");
				n[i = t[0]] = (r = n[i]) ? J.isArray(r) ? [...r, t[1]] : [r, t[1]] : t[1];
			}
			a(n, t);
		} else e != null && i(t, e, n);
		return this;
	}
	get(e, t) {
		if (e = tt(e), e) {
			let n = J.findKey(this, e);
			if (n) {
				let e = this[n];
				if (!t) return e;
				if (t === !0) return rt(e);
				if (J.isFunction(t)) return t.call(this, e, n);
				if (J.isRegExp(t)) return t.exec(e);
				throw TypeError("parser must be boolean|regexp|function");
			}
		}
	}
	has(e, t) {
		if (e = tt(e), e) {
			let n = J.findKey(this, e);
			return !!(n && this[n] !== void 0 && (!t || at(this, this[n], n, t)));
		}
		return !1;
	}
	delete(e, t) {
		let n = this, r = !1;
		function i(e) {
			if (e = tt(e), e) {
				let i = J.findKey(n, e);
				i && (!t || at(n, n[i], i, t)) && (delete n[i], r = !0);
			}
		}
		return J.isArray(e) ? e.forEach(i) : i(e), r;
	}
	clear(e) {
		let t = Object.keys(this), n = t.length, r = !1;
		for (; n--;) {
			let i = t[n];
			(!e || at(this, this[i], i, e, !0)) && (delete this[i], r = !0);
		}
		return r;
	}
	normalize(e) {
		let t = this, n = {};
		return J.forEach(this, (r, i) => {
			let a = J.findKey(n, i);
			if (a) {
				t[a] = nt(r), delete t[i];
				return;
			}
			let o = e ? ot(i) : String(i).trim();
			o !== i && delete t[i], t[o] = nt(r), n[o] = !0;
		}), this;
	}
	concat(...e) {
		return this.constructor.concat(this, ...e);
	}
	toJSON(e) {
		let t = Object.create(null);
		return J.forEach(this, (n, r) => {
			n != null && n !== !1 && (t[r] = e && J.isArray(n) ? n.join(", ") : n);
		}), t;
	}
	[Symbol.iterator]() {
		return Object.entries(this.toJSON())[Symbol.iterator]();
	}
	toString() {
		return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join("\n");
	}
	getSetCookie() {
		return this.get("set-cookie") || [];
	}
	get [Symbol.toStringTag]() {
		return "AxiosHeaders";
	}
	static from(e) {
		return e instanceof this ? e : new this(e);
	}
	static concat(e, ...t) {
		let n = new this(e);
		return t.forEach((e) => n.set(e)), n;
	}
	static accessor(e) {
		let t = (this[et] = this[et] = { accessors: {} }).accessors, n = this.prototype;
		function r(e) {
			let r = tt(e);
			t[r] || (st(n, e), t[r] = !0);
		}
		return J.isArray(e) ? e.forEach(r) : r(e), this;
	}
};
ct.accessor([
	"Content-Type",
	"Content-Length",
	"Accept",
	"Accept-Encoding",
	"User-Agent",
	"Authorization"
]), J.reduceDescriptors(ct.prototype, ({ value: e }, t) => {
	let n = t[0].toUpperCase() + t.slice(1);
	return {
		get: () => e,
		set(e) {
			this[n] = e;
		}
	};
}), J.freezeMethods(ct);
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/AxiosError.js
var lt = "[REDACTED ****]";
function ut(e) {
	if (J.hasOwnProp(e, "toJSON")) return !0;
	let t = Object.getPrototypeOf(e);
	for (; t && t !== Object.prototype;) {
		if (J.hasOwnProp(t, "toJSON")) return !0;
		t = Object.getPrototypeOf(t);
	}
	return !1;
}
function dt(e, t) {
	let n = new Set(t.map((e) => String(e).toLowerCase())), r = [], i = (e) => {
		if (typeof e != "object" || !e || J.isBuffer(e)) return e;
		if (r.indexOf(e) !== -1) return;
		e instanceof ct && (e = e.toJSON()), r.push(e);
		let t;
		if (J.isArray(e)) t = [], e.forEach((e, n) => {
			let r = i(e);
			J.isUndefined(r) || (t[n] = r);
		});
		else {
			if (!J.isPlainObject(e) && ut(e)) return r.pop(), e;
			t = Object.create(null);
			for (let [r, a] of Object.entries(e)) {
				let e = n.has(r.toLowerCase()) ? lt : i(a);
				J.isUndefined(e) || (t[r] = e);
			}
		}
		return r.pop(), t;
	};
	return i(e);
}
var Y = class e extends Error {
	static from(t, n, r, i, a, o) {
		let s = new e(t.message, n || t.code, r, i, a);
		return s.cause = t, s.name = t.name, t.status != null && s.status == null && (s.status = t.status), o && Object.assign(s, o), s;
	}
	constructor(e, t, n, r, i) {
		super(e), Object.defineProperty(this, "message", {
			__proto__: null,
			value: e,
			enumerable: !0,
			writable: !0,
			configurable: !0
		}), this.name = "AxiosError", this.isAxiosError = !0, t && (this.code = t), n && (this.config = n), r && (this.request = r), i && (this.response = i, this.status = i.status);
	}
	toJSON() {
		let e = this.config, t = e && J.hasOwnProp(e, "redact") ? e.redact : void 0, n = J.isArray(t) && t.length > 0 ? dt(e, t) : J.toJSONObject(e);
		return {
			message: this.message,
			name: this.name,
			description: this.description,
			number: this.number,
			fileName: this.fileName,
			lineNumber: this.lineNumber,
			columnNumber: this.columnNumber,
			stack: this.stack,
			config: n,
			code: this.code,
			status: this.status
		};
	}
};
Y.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE", Y.ERR_BAD_OPTION = "ERR_BAD_OPTION", Y.ECONNABORTED = "ECONNABORTED", Y.ETIMEDOUT = "ETIMEDOUT", Y.ECONNREFUSED = "ECONNREFUSED", Y.ERR_NETWORK = "ERR_NETWORK", Y.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS", Y.ERR_DEPRECATED = "ERR_DEPRECATED", Y.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE", Y.ERR_BAD_REQUEST = "ERR_BAD_REQUEST", Y.ERR_CANCELED = "ERR_CANCELED", Y.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT", Y.ERR_INVALID_URL = "ERR_INVALID_URL", Y.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/toFormData.js
function ft(e) {
	return J.isPlainObject(e) || J.isArray(e);
}
function pt(e) {
	return J.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function mt(e, t, n) {
	return e ? e.concat(t).map(function(e, t) {
		return e = pt(e), !n && t ? "[" + e + "]" : e;
	}).join(n ? "." : "") : t;
}
function ht(e) {
	return J.isArray(e) && !e.some(ft);
}
var gt = J.toFlatObject(J, {}, null, function(e) {
	return /^is[A-Z]/.test(e);
});
function _t(e, t, n) {
	if (!J.isObject(e)) throw TypeError("target must be an object");
	t ||= new FormData(), n = J.toFlatObject(n, {
		metaTokens: !0,
		dots: !1,
		indexes: !1
	}, !1, function(e, t) {
		return !J.isUndefined(t[e]);
	});
	let r = n.metaTokens, i = n.visitor || d, a = n.dots, o = n.indexes, s = n.Blob || typeof Blob < "u" && Blob, c = n.maxDepth === void 0 ? 100 : n.maxDepth, l = s && J.isSpecCompliantForm(t);
	if (!J.isFunction(i)) throw TypeError("visitor must be a function");
	function u(e) {
		if (e === null) return "";
		if (J.isDate(e)) return e.toISOString();
		if (J.isBoolean(e)) return e.toString();
		if (!l && J.isBlob(e)) throw new Y("Blob is not supported. Use a Buffer instead.");
		return J.isArrayBuffer(e) || J.isTypedArray(e) ? l && typeof Blob == "function" ? new Blob([e]) : Buffer.from(e) : e;
	}
	function d(e, n, i) {
		let s = e;
		if (J.isReactNative(t) && J.isReactNativeBlob(e)) return t.append(mt(i, n, a), u(e)), !1;
		if (e && !i && typeof e == "object") {
			if (J.endsWith(n, "{}")) n = r ? n : n.slice(0, -2), e = JSON.stringify(e);
			else if (J.isArray(e) && ht(e) || (J.isFileList(e) || J.endsWith(n, "[]")) && (s = J.toArray(e))) return n = pt(n), s.forEach(function(e, r) {
				!(J.isUndefined(e) || e === null) && t.append(o === !0 ? mt([n], r, a) : o === null ? n : n + "[]", u(e));
			}), !1;
		}
		return ft(e) ? !0 : (t.append(mt(i, n, a), u(e)), !1);
	}
	let f = [], p = Object.assign(gt, {
		defaultVisitor: d,
		convertValue: u,
		isVisitable: ft
	});
	function m(e, n, r = 0) {
		if (!J.isUndefined(e)) {
			if (r > c) throw new Y("Object is too deeply nested (" + r + " levels). Max depth: " + c, Y.ERR_FORM_DATA_DEPTH_EXCEEDED);
			if (f.indexOf(e) !== -1) throw Error("Circular reference detected in " + n.join("."));
			f.push(e), J.forEach(e, function(e, a) {
				(!(J.isUndefined(e) || e === null) && i.call(t, e, J.isString(a) ? a.trim() : a, n, p)) === !0 && m(e, n ? n.concat(a) : [a], r + 1);
			}), f.pop();
		}
	}
	if (!J.isObject(e)) throw TypeError("data must be an object");
	return m(e), t;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/AxiosURLSearchParams.js
function vt(e) {
	let t = {
		"!": "%21",
		"'": "%27",
		"(": "%28",
		")": "%29",
		"~": "%7E",
		"%20": "+"
	};
	return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(e) {
		return t[e];
	});
}
function yt(e, t) {
	this._pairs = [], e && _t(e, this, t);
}
var bt = yt.prototype;
bt.append = function(e, t) {
	this._pairs.push([e, t]);
}, bt.toString = function(e) {
	let t = e ? function(t) {
		return e.call(this, t, vt);
	} : vt;
	return this._pairs.map(function(e) {
		return t(e[0]) + "=" + t(e[1]);
	}, "").join("&");
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/buildURL.js
function xt(e) {
	return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function St(e, t, n) {
	if (!t) return e;
	let r = n && n.encode || xt, i = J.isFunction(n) ? { serialize: n } : n, a = i && i.serialize, o;
	if (o = a ? a(t, i) : J.isURLSearchParams(t) ? t.toString() : new yt(t, i).toString(r), o) {
		let t = e.indexOf("#");
		t !== -1 && (e = e.slice(0, t)), e += (e.indexOf("?") === -1 ? "?" : "&") + o;
	}
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/InterceptorManager.js
var Ct = class {
	constructor() {
		this.handlers = [];
	}
	use(e, t, n) {
		return this.handlers.push({
			fulfilled: e,
			rejected: t,
			synchronous: n ? n.synchronous : !1,
			runWhen: n ? n.runWhen : null
		}), this.handlers.length - 1;
	}
	eject(e) {
		this.handlers[e] && (this.handlers[e] = null);
	}
	clear() {
		this.handlers &&= [];
	}
	forEach(e) {
		J.forEach(this.handlers, function(t) {
			t !== null && e(t);
		});
	}
}, wt = {
	silentJSONParsing: !0,
	forcedJSONParsing: !0,
	clarifyTimeoutError: !1,
	legacyInterceptorReqResOrdering: !0
}, Tt = {
	isBrowser: !0,
	classes: {
		URLSearchParams: typeof URLSearchParams < "u" ? URLSearchParams : yt,
		FormData: typeof FormData < "u" ? FormData : null,
		Blob: typeof Blob < "u" ? Blob : null
	},
	protocols: [
		"http",
		"https",
		"file",
		"blob",
		"url",
		"data"
	]
}, Et = /* @__PURE__ */ e({
	hasBrowserEnv: () => Dt,
	hasStandardBrowserEnv: () => kt,
	hasStandardBrowserWebWorkerEnv: () => At,
	navigator: () => Ot,
	origin: () => jt
}), Dt = typeof window < "u" && typeof document < "u", Ot = typeof navigator == "object" && navigator || void 0, kt = Dt && (!Ot || [
	"ReactNative",
	"NativeScript",
	"NS"
].indexOf(Ot.product) < 0), At = typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function", jt = Dt && window.location.href || "http://localhost", Mt = {
	...Et,
	...Tt
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/toURLEncodedForm.js
function Nt(e, t) {
	return _t(e, new Mt.classes.URLSearchParams(), {
		visitor: function(e, t, n, r) {
			return Mt.isNode && J.isBuffer(e) ? (this.append(t, e.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
		},
		...t
	});
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/formDataToJSON.js
function Pt(e) {
	return J.matchAll(/\w+|\[(\w*)]/g, e).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function Ft(e) {
	let t = {}, n = Object.keys(e), r, i = n.length, a;
	for (r = 0; r < i; r++) a = n[r], t[a] = e[a];
	return t;
}
function It(e) {
	function t(e, n, r, i) {
		let a = e[i++];
		if (a === "__proto__") return !0;
		let o = Number.isFinite(+a), s = i >= e.length;
		return a = !a && J.isArray(r) ? r.length : a, s ? (J.hasOwnProp(r, a) ? r[a] = J.isArray(r[a]) ? r[a].concat(n) : [r[a], n] : r[a] = n, !o) : ((!J.hasOwnProp(r, a) || !J.isObject(r[a])) && (r[a] = []), t(e, n, r[a], i) && J.isArray(r[a]) && (r[a] = Ft(r[a])), !o);
	}
	if (J.isFormData(e) && J.isFunction(e.entries)) {
		let n = {};
		return J.forEachEntry(e, (e, r) => {
			t(Pt(e), r, n, 0);
		}), n;
	}
	return null;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/defaults/index.js
var Lt = (e, t) => e != null && J.hasOwnProp(e, t) ? e[t] : void 0;
function Rt(e, t, n) {
	if (J.isString(e)) try {
		return (t || JSON.parse)(e), J.trim(e);
	} catch (e) {
		if (e.name !== "SyntaxError") throw e;
	}
	return (n || JSON.stringify)(e);
}
var zt = {
	transitional: wt,
	adapter: [
		"xhr",
		"http",
		"fetch"
	],
	transformRequest: [function(e, t) {
		let n = t.getContentType() || "", r = n.indexOf("application/json") > -1, i = J.isObject(e);
		if (i && J.isHTMLForm(e) && (e = new FormData(e)), J.isFormData(e)) return r ? JSON.stringify(It(e)) : e;
		if (J.isArrayBuffer(e) || J.isBuffer(e) || J.isStream(e) || J.isFile(e) || J.isBlob(e) || J.isReadableStream(e)) return e;
		if (J.isArrayBufferView(e)) return e.buffer;
		if (J.isURLSearchParams(e)) return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
		let a;
		if (i) {
			let t = Lt(this, "formSerializer");
			if (n.indexOf("application/x-www-form-urlencoded") > -1) return Nt(e, t).toString();
			if ((a = J.isFileList(e)) || n.indexOf("multipart/form-data") > -1) {
				let n = Lt(this, "env"), r = n && n.FormData;
				return _t(a ? { "files[]": e } : e, r && new r(), t);
			}
		}
		return i || r ? (t.setContentType("application/json", !1), Rt(e)) : e;
	}],
	transformResponse: [function(e) {
		let t = Lt(this, "transitional") || zt.transitional, n = t && t.forcedJSONParsing, r = Lt(this, "responseType"), i = r === "json";
		if (J.isResponse(e) || J.isReadableStream(e)) return e;
		if (e && J.isString(e) && (n && !r || i)) {
			let n = !(t && t.silentJSONParsing) && i;
			try {
				return JSON.parse(e, Lt(this, "parseReviver"));
			} catch (e) {
				if (n) throw e.name === "SyntaxError" ? Y.from(e, Y.ERR_BAD_RESPONSE, this, null, Lt(this, "response")) : e;
			}
		}
		return e;
	}],
	timeout: 0,
	xsrfCookieName: "XSRF-TOKEN",
	xsrfHeaderName: "X-XSRF-TOKEN",
	maxContentLength: -1,
	maxBodyLength: -1,
	env: {
		FormData: Mt.classes.FormData,
		Blob: Mt.classes.Blob
	},
	validateStatus: function(e) {
		return e >= 200 && e < 300;
	},
	headers: { common: {
		Accept: "application/json, text/plain, */*",
		"Content-Type": void 0
	} }
};
J.forEach([
	"delete",
	"get",
	"head",
	"post",
	"put",
	"patch",
	"query"
], (e) => {
	zt.headers[e] = {};
});
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/transformData.js
function Bt(e, t) {
	let n = this || zt, r = t || n, i = ct.from(r.headers), a = r.data;
	return J.forEach(e, function(e) {
		a = e.call(n, a, i.normalize(), t ? t.status : void 0);
	}), i.normalize(), a;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/cancel/isCancel.js
function Vt(e) {
	return !!(e && e.__CANCEL__);
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/cancel/CanceledError.js
var Ht = class extends Y {
	constructor(e, t, n) {
		super(e ?? "canceled", Y.ERR_CANCELED, t, n), this.name = "CanceledError", this.__CANCEL__ = !0;
	}
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/settle.js
function Ut(e, t, n) {
	let r = n.config.validateStatus;
	!n.status || !r || r(n.status) ? e(n) : t(new Y("Request failed with status code " + n.status, n.status >= 400 && n.status < 500 ? Y.ERR_BAD_REQUEST : Y.ERR_BAD_RESPONSE, n.config, n.request, n));
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/parseProtocol.js
function Wt(e) {
	let t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
	return t && t[1] || "";
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/speedometer.js
function Gt(e, t) {
	e ||= 10;
	let n = Array(e), r = Array(e), i = 0, a = 0, o;
	return t = t === void 0 ? 1e3 : t, function(s) {
		let c = Date.now(), l = r[a];
		o ||= c, n[i] = s, r[i] = c;
		let u = a, d = 0;
		for (; u !== i;) d += n[u++], u %= e;
		if (i = (i + 1) % e, i === a && (a = (a + 1) % e), c - o < t) return;
		let f = l && c - l;
		return f ? Math.round(d * 1e3 / f) : void 0;
	};
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/throttle.js
function Kt(e, t) {
	let n = 0, r = 1e3 / t, i, a, o = (t, r = Date.now()) => {
		n = r, i = null, a &&= (clearTimeout(a), null), e(...t);
	};
	return [(...e) => {
		let t = Date.now(), s = t - n;
		s >= r ? o(e, t) : (i = e, a ||= setTimeout(() => {
			a = null, o(i);
		}, r - s));
	}, () => i && o(i)];
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/progressEventReducer.js
var qt = (e, t, n = 3) => {
	let r = 0, i = Gt(50, 250);
	return Kt((n) => {
		if (!n || typeof n.loaded != "number") return;
		let a = n.loaded, o = n.lengthComputable ? n.total : void 0, s = o == null ? a : Math.min(a, o), c = Math.max(0, s - r), l = i(c);
		r = Math.max(r, s), e({
			loaded: s,
			total: o,
			progress: o ? s / o : void 0,
			bytes: c,
			rate: l || void 0,
			estimated: l && o ? (o - s) / l : void 0,
			event: n,
			lengthComputable: o != null,
			[t ? "download" : "upload"]: !0
		});
	}, n);
}, Jt = (e, t) => {
	let n = e != null;
	return [(r) => t[0]({
		lengthComputable: n,
		total: e,
		loaded: r
	}), t[1]];
}, Yt = (e) => (...t) => J.asap(() => e(...t)), Xt = Mt.hasStandardBrowserEnv ? ((e, t) => (n) => (n = new URL(n, Mt.origin), e.protocol === n.protocol && e.host === n.host && (t || e.port === n.port)))(new URL(Mt.origin), Mt.navigator && /(msie|trident)/i.test(Mt.navigator.userAgent)) : () => !0, Zt = Mt.hasStandardBrowserEnv ? {
	write(e, t, n, r, i, a, o) {
		if (typeof document > "u") return;
		let s = [`${e}=${encodeURIComponent(t)}`];
		J.isNumber(n) && s.push(`expires=${new Date(n).toUTCString()}`), J.isString(r) && s.push(`path=${r}`), J.isString(i) && s.push(`domain=${i}`), a === !0 && s.push("secure"), J.isString(o) && s.push(`SameSite=${o}`), document.cookie = s.join("; ");
	},
	read(e) {
		if (typeof document > "u") return null;
		let t = document.cookie.split(";");
		for (let n = 0; n < t.length; n++) {
			let r = t[n].replace(/^\s+/, ""), i = r.indexOf("=");
			if (i !== -1 && r.slice(0, i) === e) return decodeURIComponent(r.slice(i + 1));
		}
		return null;
	},
	remove(e) {
		this.write(e, "", Date.now() - 864e5, "/");
	}
} : {
	write() {},
	read() {
		return null;
	},
	remove() {}
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/isAbsoluteURL.js
function Qt(e) {
	return typeof e == "string" ? /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e) : !1;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/combineURLs.js
function $t(e, t) {
	return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/buildFullPath.js
function en(e, t, n) {
	let r = !Qt(t);
	return e && (r || n === !1) ? $t(e, t) : t;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/mergeConfig.js
var tn = (e) => e instanceof ct ? { ...e } : e;
function nn(e, t) {
	t ||= {};
	let n = Object.create(null);
	Object.defineProperty(n, "hasOwnProperty", {
		__proto__: null,
		value: Object.prototype.hasOwnProperty,
		enumerable: !1,
		writable: !0,
		configurable: !0
	});
	function r(e, t, n, r) {
		return J.isPlainObject(e) && J.isPlainObject(t) ? J.merge.call({ caseless: r }, e, t) : J.isPlainObject(t) ? J.merge({}, t) : J.isArray(t) ? t.slice() : t;
	}
	function i(e, t, n, i) {
		if (!J.isUndefined(t)) return r(e, t, n, i);
		if (!J.isUndefined(e)) return r(void 0, e, n, i);
	}
	function a(e, t) {
		if (!J.isUndefined(t)) return r(void 0, t);
	}
	function o(e, t) {
		if (!J.isUndefined(t)) return r(void 0, t);
		if (!J.isUndefined(e)) return r(void 0, e);
	}
	function s(n, i, a) {
		if (J.hasOwnProp(t, a)) return r(n, i);
		if (J.hasOwnProp(e, a)) return r(void 0, n);
	}
	let c = {
		url: a,
		method: a,
		data: a,
		baseURL: o,
		transformRequest: o,
		transformResponse: o,
		paramsSerializer: o,
		timeout: o,
		timeoutMessage: o,
		withCredentials: o,
		withXSRFToken: o,
		adapter: o,
		responseType: o,
		xsrfCookieName: o,
		xsrfHeaderName: o,
		onUploadProgress: o,
		onDownloadProgress: o,
		decompress: o,
		maxContentLength: o,
		maxBodyLength: o,
		beforeRedirect: o,
		transport: o,
		httpAgent: o,
		httpsAgent: o,
		cancelToken: o,
		socketPath: o,
		allowedSocketPaths: o,
		responseEncoding: o,
		validateStatus: s,
		headers: (e, t, n) => i(tn(e), tn(t), n, !0)
	};
	return J.forEach(Object.keys({
		...e,
		...t
	}), function(r) {
		if (r === "__proto__" || r === "constructor" || r === "prototype") return;
		let a = J.hasOwnProp(c, r) ? c[r] : i, o = a(J.hasOwnProp(e, r) ? e[r] : void 0, J.hasOwnProp(t, r) ? t[r] : void 0, r);
		J.isUndefined(o) && a !== s || (n[r] = o);
	}), n;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/resolveConfig.js
var rn = ["content-type", "content-length"];
function an(e, t, n) {
	if (n !== "content-only") {
		e.set(t);
		return;
	}
	Object.entries(t).forEach(([t, n]) => {
		rn.includes(t.toLowerCase()) && e.set(t, n);
	});
}
var on = (e) => encodeURIComponent(e).replace(/%([0-9A-F]{2})/gi, (e, t) => String.fromCharCode(parseInt(t, 16))), sn = (e) => {
	let t = nn({}, e), n = (e) => J.hasOwnProp(t, e) ? t[e] : void 0, r = n("data"), i = n("withXSRFToken"), a = n("xsrfHeaderName"), o = n("xsrfCookieName"), s = n("headers"), c = n("auth"), l = n("baseURL"), u = n("allowAbsoluteUrls"), d = n("url");
	if (t.headers = s = ct.from(s), t.url = St(en(l, d, u), e.params, e.paramsSerializer), c && s.set("Authorization", "Basic " + btoa((c.username || "") + ":" + (c.password ? on(c.password) : ""))), J.isFormData(r) && (Mt.hasStandardBrowserEnv || Mt.hasStandardBrowserWebWorkerEnv ? s.setContentType(void 0) : J.isFunction(r.getHeaders) && an(s, r.getHeaders(), n("formDataHeaderPolicy"))), Mt.hasStandardBrowserEnv && (J.isFunction(i) && (i = i(t)), i === !0 || i == null && Xt(t.url))) {
		let e = a && o && Zt.read(o);
		e && s.set(a, e);
	}
	return t;
}, cn = typeof XMLHttpRequest < "u" && function(e) {
	return new Promise(function(t, n) {
		let r = sn(e), i = r.data, a = ct.from(r.headers).normalize(), { responseType: o, onUploadProgress: s, onDownloadProgress: c } = r, l, u, d, f, p;
		function m() {
			f && f(), p && p(), r.cancelToken && r.cancelToken.unsubscribe(l), r.signal && r.signal.removeEventListener("abort", l);
		}
		let h = new XMLHttpRequest();
		h.open(r.method.toUpperCase(), r.url, !0), h.timeout = r.timeout;
		function g() {
			if (!h) return;
			let r = ct.from("getAllResponseHeaders" in h && h.getAllResponseHeaders());
			Ut(function(e) {
				t(e), m();
			}, function(e) {
				n(e), m();
			}, {
				data: !o || o === "text" || o === "json" ? h.responseText : h.response,
				status: h.status,
				statusText: h.statusText,
				headers: r,
				config: e,
				request: h
			}), h = null;
		}
		"onloadend" in h ? h.onloadend = g : h.onreadystatechange = function() {
			!h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.startsWith("file:")) || setTimeout(g);
		}, h.onabort = function() {
			h &&= (n(new Y("Request aborted", Y.ECONNABORTED, e, h)), m(), null);
		}, h.onerror = function(t) {
			let r = new Y(t && t.message ? t.message : "Network Error", Y.ERR_NETWORK, e, h);
			r.event = t || null, n(r), m(), h = null;
		}, h.ontimeout = function() {
			let t = r.timeout ? "timeout of " + r.timeout + "ms exceeded" : "timeout exceeded", i = r.transitional || wt;
			r.timeoutErrorMessage && (t = r.timeoutErrorMessage), n(new Y(t, i.clarifyTimeoutError ? Y.ETIMEDOUT : Y.ECONNABORTED, e, h)), m(), h = null;
		}, i === void 0 && a.setContentType(null), "setRequestHeader" in h && J.forEach($e(a), function(e, t) {
			h.setRequestHeader(t, e);
		}), J.isUndefined(r.withCredentials) || (h.withCredentials = !!r.withCredentials), o && o !== "json" && (h.responseType = r.responseType), c && ([d, p] = qt(c, !0), h.addEventListener("progress", d)), s && h.upload && ([u, f] = qt(s), h.upload.addEventListener("progress", u), h.upload.addEventListener("loadend", f)), (r.cancelToken || r.signal) && (l = (t) => {
			h &&= (n(!t || t.type ? new Ht(null, e, h) : t), h.abort(), m(), null);
		}, r.cancelToken && r.cancelToken.subscribe(l), r.signal && (r.signal.aborted ? l() : r.signal.addEventListener("abort", l)));
		let _ = Wt(r.url);
		if (_ && !Mt.protocols.includes(_)) {
			n(new Y("Unsupported protocol " + _ + ":", Y.ERR_BAD_REQUEST, e));
			return;
		}
		h.send(i || null);
	});
}, ln = (e, t) => {
	if (e = e ? e.filter(Boolean) : [], !t && !e.length) return;
	let n = new AbortController(), r = !1, i = function(e) {
		if (!r) {
			r = !0, o();
			let t = e instanceof Error ? e : this.reason;
			n.abort(t instanceof Y ? t : new Ht(t instanceof Error ? t.message : t));
		}
	}, a = t && setTimeout(() => {
		a = null, i(new Y(`timeout of ${t}ms exceeded`, Y.ETIMEDOUT));
	}, t), o = () => {
		e &&= (a && clearTimeout(a), a = null, e.forEach((e) => {
			e.unsubscribe ? e.unsubscribe(i) : e.removeEventListener("abort", i);
		}), null);
	};
	e.forEach((e) => e.addEventListener("abort", i));
	let { signal: s } = n;
	return s.unsubscribe = () => J.asap(o), s;
}, un = function* (e, t) {
	let n = e.byteLength;
	if (!t || n < t) {
		yield e;
		return;
	}
	let r = 0, i;
	for (; r < n;) i = r + t, yield e.slice(r, i), r = i;
}, dn = async function* (e, t) {
	for await (let n of fn(e)) yield* un(n, t);
}, fn = async function* (e) {
	if (e[Symbol.asyncIterator]) {
		yield* e;
		return;
	}
	let t = e.getReader();
	try {
		for (;;) {
			let { done: e, value: n } = await t.read();
			if (e) break;
			yield n;
		}
	} finally {
		await t.cancel();
	}
}, pn = (e, t, n, r) => {
	let i = dn(e, t), a = 0, o, s = (e) => {
		o || (o = !0, r && r(e));
	};
	return new ReadableStream({
		async pull(e) {
			try {
				let { done: t, value: r } = await i.next();
				if (t) {
					s(), e.close();
					return;
				}
				let o = r.byteLength;
				n && n(a += o), e.enqueue(new Uint8Array(r));
			} catch (e) {
				throw s(e), e;
			}
		},
		cancel(e) {
			return s(e), i.return();
		}
	}, { highWaterMark: 2 });
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/estimateDataURLDecodedBytes.js
function mn(e) {
	if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
	let t = e.indexOf(",");
	if (t < 0) return 0;
	let n = e.slice(5, t), r = e.slice(t + 1);
	if (/;base64/i.test(n)) {
		let e = r.length, t = r.length;
		for (let n = 0; n < t; n++) if (r.charCodeAt(n) === 37 && n + 2 < t) {
			let t = r.charCodeAt(n + 1), i = r.charCodeAt(n + 2);
			(t >= 48 && t <= 57 || t >= 65 && t <= 70 || t >= 97 && t <= 102) && (i >= 48 && i <= 57 || i >= 65 && i <= 70 || i >= 97 && i <= 102) && (e -= 2, n += 2);
		}
		let n = 0, i = t - 1, a = (e) => e >= 2 && r.charCodeAt(e - 2) === 37 && r.charCodeAt(e - 1) === 51 && (r.charCodeAt(e) === 68 || r.charCodeAt(e) === 100);
		i >= 0 && (r.charCodeAt(i) === 61 ? (n++, i--) : a(i) && (n++, i -= 3)), n === 1 && i >= 0 && (r.charCodeAt(i) === 61 || a(i)) && n++;
		let o = Math.floor(e / 4) * 3 - (n || 0);
		return o > 0 ? o : 0;
	}
	if (typeof Buffer < "u" && typeof Buffer.byteLength == "function") return Buffer.byteLength(r, "utf8");
	let i = 0;
	for (let e = 0, t = r.length; e < t; e++) {
		let n = r.charCodeAt(e);
		if (n < 128) i += 1;
		else if (n < 2048) i += 2;
		else if (n >= 55296 && n <= 56319 && e + 1 < t) {
			let t = r.charCodeAt(e + 1);
			t >= 56320 && t <= 57343 ? (i += 4, e++) : i += 3;
		} else i += 3;
	}
	return i;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/env/data.js
var hn = "1.16.1", gn = 64 * 1024, { isFunction: _n } = J, vn = (e, ...t) => {
	try {
		return !!e(...t);
	} catch {
		return !1;
	}
}, yn = (e) => {
	let t = J.global !== void 0 && J.global !== null ? J.global : globalThis, { ReadableStream: n, TextEncoder: r } = t;
	e = J.merge.call({ skipUndefined: !0 }, {
		Request: t.Request,
		Response: t.Response
	}, e);
	let { fetch: i, Request: a, Response: o } = e, s = i ? _n(i) : typeof fetch == "function", c = _n(a), l = _n(o);
	if (!s) return !1;
	let u = s && _n(n), d = s && (typeof r == "function" ? ((e) => (t) => e.encode(t))(new r()) : async (e) => new Uint8Array(await new a(e).arrayBuffer())), f = c && u && vn(() => {
		let e = !1, t = new a(Mt.origin, {
			body: new n(),
			method: "POST",
			get duplex() {
				return e = !0, "half";
			}
		}), r = t.headers.has("Content-Type");
		return t.body != null && t.body.cancel(), e && !r;
	}), p = l && u && vn(() => J.isReadableStream(new o("").body)), m = { stream: p && ((e) => e.body) };
	s && [
		"text",
		"arrayBuffer",
		"blob",
		"formData",
		"stream"
	].forEach((e) => {
		!m[e] && (m[e] = (t, n) => {
			let r = t && t[e];
			if (r) return r.call(t);
			throw new Y(`Response type '${e}' is not supported`, Y.ERR_NOT_SUPPORT, n);
		});
	});
	let h = async (e) => {
		if (e == null) return 0;
		if (J.isBlob(e)) return e.size;
		if (J.isSpecCompliantForm(e)) return (await new a(Mt.origin, {
			method: "POST",
			body: e
		}).arrayBuffer()).byteLength;
		if (J.isArrayBufferView(e) || J.isArrayBuffer(e)) return e.byteLength;
		if (J.isURLSearchParams(e) && (e += ""), J.isString(e)) return (await d(e)).byteLength;
	}, g = async (e, t) => J.toFiniteNumber(e.getContentLength()) ?? h(t);
	return async (e) => {
		let { url: t, method: n, data: s, signal: l, cancelToken: u, timeout: d, onDownloadProgress: h, onUploadProgress: _, responseType: v, headers: y, withCredentials: b = "same-origin", fetchOptions: x, maxContentLength: S, maxBodyLength: C } = sn(e), w = J.isNumber(S) && S > -1, T = J.isNumber(C) && C > -1, E = i || fetch;
		v = v ? (v + "").toLowerCase() : "text";
		let D = ln([l, u && u.toAbortSignal()], d), O = null, k = D && D.unsubscribe && (() => {
			D.unsubscribe();
		}), A;
		try {
			if (w && typeof t == "string" && t.startsWith("data:") && mn(t) > S) throw new Y("maxContentLength size of " + S + " exceeded", Y.ERR_BAD_RESPONSE, e, O);
			if (T && n !== "get" && n !== "head") {
				let t = await g(y, s);
				if (typeof t == "number" && isFinite(t) && t > C) throw new Y("Request body larger than maxBodyLength limit", Y.ERR_BAD_REQUEST, e, O);
			}
			if (_ && f && n !== "get" && n !== "head" && (A = await g(y, s)) !== 0) {
				let e = new a(t, {
					method: "POST",
					body: s,
					duplex: "half"
				}), n;
				if (J.isFormData(s) && (n = e.headers.get("content-type")) && y.setContentType(n), e.body) {
					let [t, n] = Jt(A, qt(Yt(_)));
					s = pn(e.body, gn, t, n);
				}
			}
			J.isString(b) || (b = b ? "include" : "omit");
			let i = c && "credentials" in a.prototype;
			if (J.isFormData(s)) {
				let e = y.getContentType();
				e && /^multipart\/form-data/i.test(e) && !/boundary=/i.test(e) && y.delete("content-type");
			}
			y.set("User-Agent", "axios/" + hn, !1);
			let l = {
				...x,
				signal: D,
				method: n.toUpperCase(),
				headers: $e(y.normalize()),
				body: s,
				duplex: "half",
				credentials: i ? b : void 0
			};
			O = c && new a(t, l);
			let u = await (c ? E(O, x) : E(t, l));
			if (w) {
				let t = J.toFiniteNumber(u.headers.get("content-length"));
				if (t != null && t > S) throw new Y("maxContentLength size of " + S + " exceeded", Y.ERR_BAD_RESPONSE, e, O);
			}
			let d = p && (v === "stream" || v === "response");
			if (p && u.body && (h || w || d && k)) {
				let t = {};
				[
					"status",
					"statusText",
					"headers"
				].forEach((e) => {
					t[e] = u[e];
				});
				let n = J.toFiniteNumber(u.headers.get("content-length")), [r, i] = h && Jt(n, qt(Yt(h), !0)) || [], a = 0;
				u = new o(pn(u.body, gn, (t) => {
					if (w && (a = t, a > S)) throw new Y("maxContentLength size of " + S + " exceeded", Y.ERR_BAD_RESPONSE, e, O);
					r && r(t);
				}, () => {
					i && i(), k && k();
				}), t);
			}
			v ||= "text";
			let j = await m[J.findKey(m, v) || "text"](u, e);
			if (w && !p && !d) {
				let t;
				if (j != null && (typeof j.byteLength == "number" ? t = j.byteLength : typeof j.size == "number" ? t = j.size : typeof j == "string" && (t = typeof r == "function" ? new r().encode(j).byteLength : j.length)), typeof t == "number" && t > S) throw new Y("maxContentLength size of " + S + " exceeded", Y.ERR_BAD_RESPONSE, e, O);
			}
			return !d && k && k(), await new Promise((t, n) => {
				Ut(t, n, {
					data: j,
					headers: ct.from(u.headers),
					status: u.status,
					statusText: u.statusText,
					config: e,
					request: O
				});
			});
		} catch (t) {
			if (k && k(), D && D.aborted && D.reason instanceof Y) {
				let n = D.reason;
				throw n.config = e, O && (n.request = O), t !== n && (n.cause = t), n;
			}
			throw t && t.name === "TypeError" && /Load failed|fetch/i.test(t.message) ? Object.assign(new Y("Network Error", Y.ERR_NETWORK, e, O, t && t.response), { cause: t.cause || t }) : Y.from(t, t && t.code, e, O, t && t.response);
		}
	};
}, bn = /* @__PURE__ */ new Map(), xn = (e) => {
	let t = e && e.env || {}, { fetch: n, Request: r, Response: i } = t, a = [
		r,
		i,
		n
	], o = a.length, s, c, l = bn;
	for (; o--;) s = a[o], c = l.get(s), c === void 0 && l.set(s, c = o ? /* @__PURE__ */ new Map() : yn(t)), l = c;
	return c;
};
xn();
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/adapters/adapters.js
var Sn = {
	http: null,
	xhr: cn,
	fetch: { get: xn }
};
J.forEach(Sn, (e, t) => {
	if (e) {
		try {
			Object.defineProperty(e, "name", {
				__proto__: null,
				value: t
			});
		} catch {}
		Object.defineProperty(e, "adapterName", {
			__proto__: null,
			value: t
		});
	}
});
var Cn = (e) => `- ${e}`, wn = (e) => J.isFunction(e) || e === null || e === !1;
function Tn(e, t) {
	e = J.isArray(e) ? e : [e];
	let { length: n } = e, r, i, a = {};
	for (let o = 0; o < n; o++) {
		r = e[o];
		let n;
		if (i = r, !wn(r) && (i = Sn[(n = String(r)).toLowerCase()], i === void 0)) throw new Y(`Unknown adapter '${n}'`);
		if (i && (J.isFunction(i) || (i = i.get(t)))) break;
		a[n || "#" + o] = i;
	}
	if (!i) {
		let e = Object.entries(a).map(([e, t]) => `adapter ${e} ` + (t === !1 ? "is not supported by the environment" : "is not available in the build"));
		throw new Y("There is no suitable adapter to dispatch the request " + (n ? e.length > 1 ? "since :\n" + e.map(Cn).join("\n") : " " + Cn(e[0]) : "as no adapter specified"), "ERR_NOT_SUPPORT");
	}
	return i;
}
var En = {
	getAdapter: Tn,
	adapters: Sn
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/core/dispatchRequest.js
function Dn(e) {
	if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted) throw new Ht(null, e);
}
function On(e) {
	return Dn(e), e.headers = ct.from(e.headers), e.data = Bt.call(e, e.transformRequest), [
		"post",
		"put",
		"patch"
	].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), En.getAdapter(e.adapter || zt.adapter, e)(e).then(function(t) {
		Dn(e), e.response = t;
		try {
			t.data = Bt.call(e, e.transformResponse, t);
		} finally {
			delete e.response;
		}
		return t.headers = ct.from(t.headers), t;
	}, function(t) {
		if (!Vt(t) && (Dn(e), t && t.response)) {
			e.response = t.response;
			try {
				t.response.data = Bt.call(e, e.transformResponse, t.response);
			} finally {
				delete e.response;
			}
			t.response.headers = ct.from(t.response.headers);
		}
		return Promise.reject(t);
	});
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/validator.js
var kn = {};
[
	"object",
	"boolean",
	"number",
	"function",
	"string",
	"symbol"
].forEach((e, t) => {
	kn[e] = function(n) {
		return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
	};
});
var An = {};
kn.transitional = function(e, t, n) {
	function r(e, t) {
		return "[Axios v" + hn + "] Transitional option '" + e + "'" + t + (n ? ". " + n : "");
	}
	return (n, i, a) => {
		if (e === !1) throw new Y(r(i, " has been removed" + (t ? " in " + t : "")), Y.ERR_DEPRECATED);
		return t && !An[i] && (An[i] = !0, console.warn(r(i, " has been deprecated since v" + t + " and will be removed in the near future"))), e ? e(n, i, a) : !0;
	};
}, kn.spelling = function(e) {
	return (t, n) => (console.warn(`${n} is likely a misspelling of ${e}`), !0);
};
function jn(e, t, n) {
	if (typeof e != "object") throw new Y("options must be an object", Y.ERR_BAD_OPTION_VALUE);
	let r = Object.keys(e), i = r.length;
	for (; i-- > 0;) {
		let a = r[i], o = Object.prototype.hasOwnProperty.call(t, a) ? t[a] : void 0;
		if (o) {
			let t = e[a], n = t === void 0 || o(t, a, e);
			if (n !== !0) throw new Y("option " + a + " must be " + n, Y.ERR_BAD_OPTION_VALUE);
			continue;
		}
		if (n !== !0) throw new Y("Unknown option " + a, Y.ERR_BAD_OPTION);
	}
}
var Mn = {
	assertOptions: jn,
	validators: kn
}, Nn = Mn.validators, Pn = class {
	constructor(e) {
		this.defaults = e || {}, this.interceptors = {
			request: new Ct(),
			response: new Ct()
		};
	}
	async request(e, t) {
		try {
			return await this._request(e, t);
		} catch (e) {
			if (e instanceof Error) {
				let t = {};
				Error.captureStackTrace ? Error.captureStackTrace(t) : t = /* @__PURE__ */ Error();
				let n = (() => {
					if (!t.stack) return "";
					let e = t.stack.indexOf("\n");
					return e === -1 ? "" : t.stack.slice(e + 1);
				})();
				try {
					if (!e.stack) e.stack = n;
					else if (n) {
						let t = n.indexOf("\n"), r = t === -1 ? -1 : n.indexOf("\n", t + 1), i = r === -1 ? "" : n.slice(r + 1);
						String(e.stack).endsWith(i) || (e.stack += "\n" + n);
					}
				} catch {}
			}
			throw e;
		}
	}
	_request(e, t) {
		typeof e == "string" ? (t ||= {}, t.url = e) : t = e || {}, t = nn(this.defaults, t);
		let { transitional: n, paramsSerializer: r, headers: i } = t;
		n !== void 0 && Mn.assertOptions(n, {
			silentJSONParsing: Nn.transitional(Nn.boolean),
			forcedJSONParsing: Nn.transitional(Nn.boolean),
			clarifyTimeoutError: Nn.transitional(Nn.boolean),
			legacyInterceptorReqResOrdering: Nn.transitional(Nn.boolean)
		}, !1), r != null && (J.isFunction(r) ? t.paramsSerializer = { serialize: r } : Mn.assertOptions(r, {
			encode: Nn.function,
			serialize: Nn.function
		}, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls === void 0 ? t.allowAbsoluteUrls = !0 : t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls), Mn.assertOptions(t, {
			baseUrl: Nn.spelling("baseURL"),
			withXsrfToken: Nn.spelling("withXSRFToken")
		}, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
		let a = i && J.merge(i.common, i[t.method]);
		i && J.forEach([
			"delete",
			"get",
			"head",
			"post",
			"put",
			"patch",
			"query",
			"common"
		], (e) => {
			delete i[e];
		}), t.headers = ct.concat(a, i);
		let o = [], s = !0;
		this.interceptors.request.forEach(function(e) {
			if (typeof e.runWhen == "function" && e.runWhen(t) === !1) return;
			s &&= e.synchronous;
			let n = t.transitional || wt;
			n && n.legacyInterceptorReqResOrdering ? o.unshift(e.fulfilled, e.rejected) : o.push(e.fulfilled, e.rejected);
		});
		let c = [];
		this.interceptors.response.forEach(function(e) {
			c.push(e.fulfilled, e.rejected);
		});
		let l, u = 0, d;
		if (!s) {
			let e = [On.bind(this), void 0];
			for (e.unshift(...o), e.push(...c), d = e.length, l = Promise.resolve(t); u < d;) l = l.then(e[u++], e[u++]);
			return l;
		}
		d = o.length;
		let f = t;
		for (; u < d;) {
			let e = o[u++], t = o[u++];
			try {
				f = e(f);
			} catch (e) {
				t.call(this, e);
				break;
			}
		}
		try {
			l = On.call(this, f);
		} catch (e) {
			return Promise.reject(e);
		}
		for (u = 0, d = c.length; u < d;) l = l.then(c[u++], c[u++]);
		return l;
	}
	getUri(e) {
		return e = nn(this.defaults, e), St(en(e.baseURL, e.url, e.allowAbsoluteUrls), e.params, e.paramsSerializer);
	}
};
J.forEach([
	"delete",
	"get",
	"head",
	"options"
], function(e) {
	Pn.prototype[e] = function(t, n) {
		return this.request(nn(n || {}, {
			method: e,
			url: t,
			data: (n || {}).data
		}));
	};
}), J.forEach([
	"post",
	"put",
	"patch",
	"query"
], function(e) {
	function t(t) {
		return function(n, r, i) {
			return this.request(nn(i || {}, {
				method: e,
				headers: t ? { "Content-Type": "multipart/form-data" } : {},
				url: n,
				data: r
			}));
		};
	}
	Pn.prototype[e] = t(), e !== "query" && (Pn.prototype[e + "Form"] = t(!0));
});
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/cancel/CancelToken.js
var Fn = class e {
	constructor(e) {
		if (typeof e != "function") throw TypeError("executor must be a function.");
		let t;
		this.promise = new Promise(function(e) {
			t = e;
		});
		let n = this;
		this.promise.then((e) => {
			if (!n._listeners) return;
			let t = n._listeners.length;
			for (; t-- > 0;) n._listeners[t](e);
			n._listeners = null;
		}), this.promise.then = (e) => {
			let t, r = new Promise((e) => {
				n.subscribe(e), t = e;
			}).then(e);
			return r.cancel = function() {
				n.unsubscribe(t);
			}, r;
		}, e(function(e, r, i) {
			n.reason || (n.reason = new Ht(e, r, i), t(n.reason));
		});
	}
	throwIfRequested() {
		if (this.reason) throw this.reason;
	}
	subscribe(e) {
		if (this.reason) {
			e(this.reason);
			return;
		}
		this._listeners ? this._listeners.push(e) : this._listeners = [e];
	}
	unsubscribe(e) {
		if (!this._listeners) return;
		let t = this._listeners.indexOf(e);
		t !== -1 && this._listeners.splice(t, 1);
	}
	toAbortSignal() {
		let e = new AbortController(), t = (t) => {
			e.abort(t);
		};
		return this.subscribe(t), e.signal.unsubscribe = () => this.unsubscribe(t), e.signal;
	}
	static source() {
		let t;
		return {
			token: new e(function(e) {
				t = e;
			}),
			cancel: t
		};
	}
};
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/spread.js
function In(e) {
	return function(t) {
		return e.apply(null, t);
	};
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/isAxiosError.js
function Ln(e) {
	return J.isObject(e) && e.isAxiosError === !0;
}
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/helpers/HttpStatusCode.js
var Rn = {
	Continue: 100,
	SwitchingProtocols: 101,
	Processing: 102,
	EarlyHints: 103,
	Ok: 200,
	Created: 201,
	Accepted: 202,
	NonAuthoritativeInformation: 203,
	NoContent: 204,
	ResetContent: 205,
	PartialContent: 206,
	MultiStatus: 207,
	AlreadyReported: 208,
	ImUsed: 226,
	MultipleChoices: 300,
	MovedPermanently: 301,
	Found: 302,
	SeeOther: 303,
	NotModified: 304,
	UseProxy: 305,
	Unused: 306,
	TemporaryRedirect: 307,
	PermanentRedirect: 308,
	BadRequest: 400,
	Unauthorized: 401,
	PaymentRequired: 402,
	Forbidden: 403,
	NotFound: 404,
	MethodNotAllowed: 405,
	NotAcceptable: 406,
	ProxyAuthenticationRequired: 407,
	RequestTimeout: 408,
	Conflict: 409,
	Gone: 410,
	LengthRequired: 411,
	PreconditionFailed: 412,
	PayloadTooLarge: 413,
	UriTooLong: 414,
	UnsupportedMediaType: 415,
	RangeNotSatisfiable: 416,
	ExpectationFailed: 417,
	ImATeapot: 418,
	MisdirectedRequest: 421,
	UnprocessableEntity: 422,
	Locked: 423,
	FailedDependency: 424,
	TooEarly: 425,
	UpgradeRequired: 426,
	PreconditionRequired: 428,
	TooManyRequests: 429,
	RequestHeaderFieldsTooLarge: 431,
	UnavailableForLegalReasons: 451,
	InternalServerError: 500,
	NotImplemented: 501,
	BadGateway: 502,
	ServiceUnavailable: 503,
	GatewayTimeout: 504,
	HttpVersionNotSupported: 505,
	VariantAlsoNegotiates: 506,
	InsufficientStorage: 507,
	LoopDetected: 508,
	NotExtended: 510,
	NetworkAuthenticationRequired: 511,
	WebServerIsDown: 521,
	ConnectionTimedOut: 522,
	OriginIsUnreachable: 523,
	TimeoutOccurred: 524,
	SslHandshakeFailed: 525,
	InvalidSslCertificate: 526
};
Object.entries(Rn).forEach(([e, t]) => {
	Rn[t] = e;
});
//#endregion
//#region ../node_modules/.pnpm/axios@1.16.1/node_modules/axios/lib/axios.js
function zn(e) {
	let t = new Pn(e), n = O(Pn.prototype.request, t);
	return J.extend(n, Pn.prototype, t, { allOwnKeys: !0 }), J.extend(n, t, null, { allOwnKeys: !0 }), n.create = function(t) {
		return zn(nn(e, t));
	}, n;
}
var Bn = zn(zt);
Bn.Axios = Pn, Bn.CanceledError = Ht, Bn.CancelToken = Fn, Bn.isCancel = Vt, Bn.VERSION = hn, Bn.toFormData = _t, Bn.AxiosError = Y, Bn.Cancel = Bn.CanceledError, Bn.all = function(e) {
	return Promise.all(e);
}, Bn.spread = In, Bn.isAxiosError = Ln, Bn.mergeConfig = nn, Bn.AxiosHeaders = ct, Bn.formToJSON = (e) => It(J.isHTMLForm(e) ? new FormData(e) : e), Bn.getAdapter = En.getAdapter, Bn.HttpStatusCode = Rn, Bn.default = Bn;
//#endregion
//#region src/services/config.ts
var Vn = new Set([
	"3000",
	"3200",
	"3213",
	"4173",
	"4273",
	"5173"
]), Hn = "/grillmyskills-api", Un = "user@example.com", Wn = "string";
function Gn(e) {
	return e && e.replace(/\/+$/, "") || "/";
}
function Kn(e, t = !1) {
	if (!e) return t;
	let n = e.trim().toLowerCase();
	return n === "true" || n === "1" ? !0 : n === "false" || n === "0" ? !1 : t;
}
function qn(e) {
	let t = {
		BASE_URL: "/",
		DEV: !1,
		MODE: "production",
		PROD: !0,
		SSR: !1,
		VITE_API_BASE_URL: "http://localhost:5001",
		VITE_DEMO_EMAIL: "user@example.com",
		VITE_DEMO_PASSWORD: "string",
		VITE_ENABLE_HOTMART_INTEL: "true"
	}[e];
	if (typeof t != "string") return;
	let n = t.trim();
	return n.length > 0 ? n : void 0;
}
function Jn(e) {
	for (let t of e) {
		let e = qn(t);
		if (e) return e;
	}
}
function Yn() {
	return {
		email: qn("VITE_DEMO_EMAIL") ?? Un,
		password: qn("VITE_DEMO_PASSWORD") ?? Wn
	};
}
function Xn(e = Jn(["VITE_API_BASE_URL", "VITE_DATASERVER_BASE_URL"])) {
	let t = Gn(e || "/");
	if (t !== "/" || typeof window > "u") return t;
	let { hostname: n, origin: r, port: i } = window.location;
	return Vn.has(i) ? "/" : i === "5001" ? r : n === "localhost" || n === "127.0.0.1" ? "http://127.0.0.1:5001" : t;
}
function Zn(e = Jn(["VITE_GRILLMYSKILLS_SERVICE_URL", "VITE_GRILLMYSKILLS_BASE_URL"])) {
	let t = Gn(e || Hn);
	if (e && t !== Hn || typeof window > "u") return t;
	let { hostname: n, port: r } = window.location;
	return Vn.has(r) ? Hn : n === "localhost" || n === "127.0.0.1" ? "http://127.0.0.1:3003" : Hn;
}
Kn(qn("VITE_ENABLE_DATA_OBSERVATORY"), !0), Kn(qn("VITE_ENABLE_HOTMART_INTEL"), !1);
var X = {
	baseUrl: Xn(),
	grillmyskillsBaseUrl: Zn(),
	endpoints: {
		tables: {
			list: (e) => `/v1/databases/${e}/tables`,
			data: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}`,
			schema: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/schema`,
			uniqueValues: (e, t, n) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/column/${encodeURIComponent(String(n))}/unique-values`,
			count: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/count`,
			sampleCount: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/sample-count`,
			indexes: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/indexes`,
			record: {
				get: (e, t, n) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/record/${n}`,
				update: (e, t, n) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/record/${n}`,
				delete: (e, t, n) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/record/${n}`,
				create: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/record`,
				bulkCreate: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/records`,
				bulkUpdate: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}/records`,
				bulkDelete: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}`
			},
			tableData: (e, t) => `/v1/databases/${e}/tables/${encodeURIComponent(String(t))}`
		},
		queryWork: { history: "/v1/query-work/history" },
		gate: {
			batchHistory: "/v1/gate/evaluate/history",
			batchResult: (e) => `/v1/gate/evaluate/${encodeURIComponent(e)}`
		},
		conflict: {
			compare: "/v1/conflict/compare",
			sessions: (e) => `/v1/conflict/sessions/${encodeURIComponent(e)}`
		},
		metadataSource: {
			tables: "/v1/metadata-source/tables",
			tableData: (e) => `/v1/metadata-source/tables/${encodeURIComponent(String(e))}`
		},
		externalPostgres: {
			tables: (e) => `/v1/external-sources/postgres/${encodeURIComponent(e)}/tables`,
			tableData: (e, t) => `/v1/external-sources/postgres/${encodeURIComponent(e)}/tables/${encodeURIComponent(String(t))}`,
			schema: (e, t) => `/v1/external-sources/postgres/${encodeURIComponent(e)}/tables/${encodeURIComponent(String(t))}/schema`,
			count: (e, t) => `/v1/external-sources/postgres/${encodeURIComponent(e)}/tables/${encodeURIComponent(String(t))}/count`,
			info: (e) => `/v1/external-sources/postgres/${encodeURIComponent(e)}/info`
		},
		auth: {
			login: "/v1/auth/login",
			register: "/v1/auth/register",
			logout: "/v1/auth/logout",
			refreshToken: "/v1/auth/refresh"
		},
		stats: {
			columnStats: "/v1/stats/compute-stats",
			missingData: "/v1/stats/compute-missing-data",
			sunburst: "/v1/stats/compute-sunburst",
			timeSeries: "/v1/stats/compute-time-series",
			sample: "/v1/stats/sample",
			sampleMethods: "/v1/stats/sample/methods",
			anomalies: "/v1/stats/anomalies"
		},
		warehouseCost: {
			runs: "/v1/warehouse-cost/runs",
			ledger: (e) => `/v1/warehouse-cost/runs/${encodeURIComponent(e)}/ledger`,
			packet: (e, t) => `/v1/warehouse-cost/runs/${encodeURIComponent(e)}/packets/${encodeURIComponent(t)}`,
			export: (e) => `/v1/warehouse-cost/runs/${encodeURIComponent(e)}/export`
		},
		typeInference: {
			columnTypes: (e, t) => `/v1/validations/type-inference/${e}/tables/${encodeURIComponent(String(t))}/column-types`,
			columnType: (e, t, n) => `/v1/validations/type-inference/${e}/tables/${encodeURIComponent(String(t))}/columns/${encodeURIComponent(String(n))}/type`
		},
		validation: {
			overview: "/v1/validations/overview",
			businessLogic: (e, t) => `/v1/validations/business-logic/${e}/tables/${encodeURIComponent(String(t))}`,
			dataQuality: (e, t) => `/v1/validations/data-quality/${e}/tables/${encodeURIComponent(String(t))}`,
			missingData: (e, t) => `/v1/validations/missing-data/${e}/tables/${encodeURIComponent(String(t))}`,
			nullCheck: (e, t) => `/v1/validations/null-check/${e}/tables/${encodeURIComponent(String(t))}`,
			patterns: (e, t) => `/v1/validations/patterns/${e}/tables/${encodeURIComponent(String(t))}`,
			constraints: () => "/v1/validations/constraints/validate",
			tableStructure: (e, t) => `/v1/validations/table-structure/${e}/tables/${encodeURIComponent(String(t))}`,
			timeSequence: (e, t) => `/v1/validations/time-sequence/${e}/tables/${encodeURIComponent(String(t))}`,
			commonTableStructure: (e, t) => `/v1/validations/common-table-structure/${e}/tables/${encodeURIComponent(String(t))}`,
			syntheticComparison: (e, t) => `/v1/validations/synthetic-comparison/${e}/tables/${encodeURIComponent(String(t))}`,
			crossTable: (e) => `/v1/validations/cross-table/${e}`,
			cdmValidation: (e, t, n) => `/v1/validations/cdm/${encodeURIComponent(e)}/${t}/tables/${encodeURIComponent(String(n))}`,
			fhirStandards: (e, t) => `/v1/validations/cdm/fhir/${e}/tables/${encodeURIComponent(String(t))}`,
			dataDictionary: (e, t) => `/v1/validations/data-dictionary/${e}/tables/${encodeURIComponent(String(t))}`
		},
		clientPortal: {
			latest: "/v1/client-portal/me",
			history: "/v1/client-portal/me/history",
			publication: (e) => `/v1/client-portal/me/publications/${encodeURIComponent(String(e))}`
		},
		privacy: {
			phiDetectionDatabase: (e) => `/v1/privacy/phi/database/${e}`,
			phiDetection: (e, t) => `/v1/privacy/phi/database/${e}/table/${encodeURIComponent(String(t))}`,
			quasiIdentifiers: (e, t) => `/v1/privacy/quasi/database/${e}/table/${encodeURIComponent(String(t))}`,
			reidentificationRisk: (e, t) => `/v1/privacy/reidentification/database/${e}/table/${encodeURIComponent(String(t))}`,
			dataMasking: (e, t) => `/v1/privacy/mask-data/${e}/tables/${encodeURIComponent(String(t))}`,
			differentialPrivacy: (e, t) => `/v1/privacy/differential-privacy/${e}/tables/${encodeURIComponent(String(t))}`,
			complianceWorkbookTemplates: "/v1/privacy/compliance-workbooks/templates",
			complianceWorkbookPreview: "/v1/privacy/compliance-workbooks/preview",
			complianceWorkbookRuns: "/v1/privacy/compliance-workbooks/runs",
			complianceWorkbookHistory: "/v1/privacy/compliance-workbooks/history",
			complianceWorkbookExceptionNote: (e) => `/v1/privacy/compliance-workbooks/runs/${encodeURIComponent(e)}/exception-notes`,
			complianceWorkbookExport: (e, t = "markdown") => `/v1/privacy/compliance-workbooks/exports/${encodeURIComponent(e)}?format=${encodeURIComponent(t)}`
		},
		domainAnalytics: {
			metrics: (e, t) => `/v1/analytics/domain-metrics/${e}/tables/${encodeURIComponent(String(t))}`,
			temporal: (e, t) => `/v1/analytics/temporal/${e}/tables/${encodeURIComponent(String(t))}`
		},
		database: {
			info: (e) => `/v1/databases/${e}`,
			metadata: (e) => `/v1/databases/${e}/metadata`,
			metadataSummary: (e) => `/v1/databases/${e}/metadata/summary`,
			qualityChecks: (e) => `/v1/databases/${e}/quality-checks`,
			latestQualityChecks: (e) => `/v1/databases/${e}/quality-checks/latest`,
			relationships: (e) => `/v1/databases/${e}/relationships`,
			views: (e) => `/v1/databases/${e}/views`
		},
		governance: {
			columns: (e) => `/v1/databases/governance/${e}/columns`,
			ownership: (e) => `/v1/databases/governance/${e}/ownership`,
			privacyProfile: (e) => `/v1/databases/governance/${e}/privacy-profile`,
			tags: "/v1/governance/tags",
			databaseTags: (e) => `/v1/governance/databases/${e}/tags`,
			reviewQueue: "/v1/governance/review-queue",
			search: "/v1/governance/search",
			workflowTemplates: "/v1/governance/workflows/templates",
			workflowTemplate: (e) => `/v1/governance/workflows/templates/${encodeURIComponent(e)}`,
			workflowRuns: "/v1/governance/workflows/runs",
			workflowRun: (e) => `/v1/governance/workflows/runs/${encodeURIComponent(e)}`,
			workflowRunTrigger: "/v1/governance/workflows/runs/trigger",
			workflowRunTransition: (e) => `/v1/governance/workflows/runs/${encodeURIComponent(e)}/transition`,
			workflowRunAuditExport: (e) => `/v1/governance/workflows/runs/${encodeURIComponent(e)}/audit-export`
		},
		analytics: { databases: (e) => `/v1/analytics/databases/${e}/tables` },
		relationships: {
			analyzeColumns: "/api/relationships/analyze-columns",
			discover: "/api/relationships/discover",
			validateFilters: "/api/relationships/validate-filters"
		},
		dataQuality: { assess: "/api/data-quality/assess" },
		timeseries: { analyze: "/v1/stats/compute-time-series" },
		grillmyskills: {
			ideas: "/v1/ideas",
			nextIdea: "/v1/ideas/next",
			dependencies: (e) => `/v1/ideas/${encodeURIComponent(e)}/dependencies`,
			vote: (e) => `/v1/ideas/${encodeURIComponent(e)}/vote`,
			save: (e) => `/v1/ideas/${encodeURIComponent(e)}/save`,
			flag: (e) => `/v1/ideas/${encodeURIComponent(e)}/flag`,
			topics: "/v1/topics",
			graph: "/v1/ecosystem/graph?includeIdeas=true",
			materialize: (e) => `/v1/admin/ideas/${encodeURIComponent(e)}/materialize`
		}
	}
}, Qn = {
	getToken: () => null,
	setToken: () => void 0,
	clearToken: () => void 0
}, $n = { ...Qn };
function er() {
	return $n;
}
function tr(e) {
	return $n = {
		...Qn,
		...e
	}, $n;
}
function nr() {
	return $n = { ...Qn }, $n;
}
function rr(e = null) {
	let t = e;
	return {
		get: () => t,
		set: (e) => {
			t = e;
		},
		clear: () => {
			t = null;
		}
	};
}
function ir(e = "vibelibs.datagrid.accessToken", t) {
	let n = t ?? (typeof globalThis < "u" && "localStorage" in globalThis ? globalThis.localStorage : void 0);
	return {
		get: () => n?.getItem(e) ?? null,
		set: (t) => {
			n?.setItem(e, t);
		},
		clear: () => {
			n?.removeItem(e);
		}
	};
}
function ar(e) {
	let { tokenStore: t } = e;
	return {
		getToken: () => t.get(),
		setToken: (e) => {
			t.set(e);
		},
		clearToken: () => {
			t.clear();
		},
		refreshToken: e.refreshToken ? async (n) => {
			let r = await e.refreshToken?.({
				...n,
				currentToken: t.get()
			});
			return r && t.set(r), r ?? null;
		} : void 0,
		onAuthFailure: (n) => {
			t.clear(), e.onAuthFailure?.(n);
		},
		getUserPermissions: e.getUserPermissions,
		recordAuditEvent: e.recordAuditEvent
	};
}
//#endregion
//#region src/utils/tokenUtils.ts
var or = D("tokenUtils"), sr = {
	getToken: () => typeof localStorage > "u" ? null : localStorage.getItem("token"),
	setToken: (e) => {
		typeof localStorage > "u" || localStorage.setItem("token", e);
	},
	removeToken: () => {
		typeof localStorage > "u" || localStorage.removeItem("token");
	},
	decodeToken: (e) => {
		try {
			let t = e.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), n = decodeURIComponent(window.atob(t).split("").map((e) => `%${`00${e.charCodeAt(0).toString(16)}`.slice(-2)}`).join(""));
			return JSON.parse(n);
		} catch (e) {
			return or.error("Error decoding token:", e), null;
		}
	},
	isTokenExpired: (e) => {
		if (!e) return !0;
		try {
			let t = sr.decodeToken(e);
			if (!t) return !0;
			let n = Date.now() / 1e3;
			return t.exp <= n + 30;
		} catch (e) {
			return or.error("Error checking token expiration:", e), !0;
		}
	},
	isTokenExpiringSoon: (e, t = 300) => {
		if (!e) return !0;
		try {
			let n = sr.decodeToken(e);
			if (!n) return !0;
			let r = Date.now() / 1e3;
			return n.exp < r + t;
		} catch (e) {
			return or.error("Error checking token expiration:", e), !0;
		}
	},
	getTokenRemainingTime: (e) => {
		if (!e) return 0;
		try {
			let t = sr.decodeToken(e);
			if (!t) return 0;
			let n = Date.now() / 1e3, r = t.exp - n;
			return r > 0 ? Math.floor(r) : 0;
		} catch (e) {
			return or.error("Error getting token remaining time:", e), 0;
		}
	}
}, cr = D("apiClient"), lr = 2, ur = 500, dr = 1e4;
function fr(e) {
	return new Promise((t) => setTimeout(t, e));
}
function pr(e) {
	if (e == null) return null;
	let t = (Array.isArray(e) ? e[0] : String(e)).trim();
	if (!t) return null;
	let n = Number(t);
	if (Number.isFinite(n) && n >= 0) return Math.max(0, Math.round(n * 1e3));
	let r = Date.parse(t);
	return Number.isNaN(r) ? null : Math.max(0, r - Date.now());
}
function mr(e, t) {
	if (t != null) return Math.min(dr, t);
	let n = ur * 2 ** Math.max(0, e), r = 1 + Math.random() * .2;
	return Math.min(dr, Math.round(n * r));
}
var Z = new class {
	instance;
	pendingRequests = /* @__PURE__ */ new Map();
	standardizeResponse(e) {
		return e && (e.status === "success" || e.status === "error") ? e : {
			status: "success",
			data: e
		};
	}
	constructor() {
		this.instance = Bn.create({
			baseURL: X.baseUrl,
			headers: { "Content-Type": "application/json" },
			timeout: 3e4
		}), this.setupInterceptors();
	}
	setupInterceptors() {
		this.instance.interceptors.request.use((e) => {
			let t = er().getToken?.() ?? null;
			return t ? sr.isTokenExpired(t) ? (cr.warn("Attempting to use expired token, will likely trigger refresh"), e.headers.Authorization = `Bearer ${t}`) : (e.headers.Authorization = `Bearer ${t}`, cr.debug("Request:", {
				url: e.url,
				method: e.method
			})) : cr.debug("Request without auth token:", {
				url: e.url,
				method: e.method
			}), e;
		}, (e) => (cr.error("Request error:", e), Promise.reject(e))), this.instance.interceptors.response.use((e) => {
			if (e.data) {
				if (e.data.status === "success" || e.data.status === "error") return e;
				if (Array.isArray(e.data) && !("rows" in e.data) && !("data" in e.data)) return e.data = {
					status: "success",
					data: {
						rows: e.data,
						total: e.data.length,
						columns: e.data.length > 0 ? Object.keys(e.data[0]) : []
					}
				}, e;
				typeof e.data == "object" && !("status" in e.data) && (e.data = {
					status: "success",
					data: e.data
				});
			}
			return e;
		}, async (e) => {
			if (e.code === "ERR_CANCELED") return cr.debug("Request canceled", {
				url: e.config?.url,
				method: e.config?.method
			}), Promise.reject(e);
			let t = e.config;
			if (e.response?.status === 429 && t) {
				let n = Number(t._rateLimitRetryCount ?? 0);
				if (n < lr) {
					let r = pr(e.response.headers?.["retry-after"]), i = mr(n, r);
					return t._rateLimitRetryCount = n + 1, cr.warn("Rate limited by API; retrying request", {
						url: t?.url,
						method: t?.method,
						attempt: n + 1,
						maxAttempts: lr,
						delayMs: i,
						retryAfterMs: r
					}), await fr(i), this.instance(t);
				}
			}
			if (e.response?.status === 401 && !t._retry && t?.url !== X.endpoints.auth.refreshToken && t?.url !== X.endpoints.auth.login) {
				t._retry = !0;
				let n = er();
				cr.debug("401 received, attempting auth recovery", {
					url: t?.url,
					statusText: e.response?.statusText,
					data: e.response?.data
				});
				try {
					let e = n.refreshToken ? await n.refreshToken({ force: !0 }) : null;
					if (e) return cr.debug("Token refreshed successfully, retrying request"), n.setToken?.(e), t.headers = t.headers ?? {}, t.headers.Authorization = `Bearer ${e}`, this.instance(t);
				} catch (e) {
					cr.error("Token refresh failed", e), n.clearToken?.(), n.onAuthFailure?.(e);
				}
				n.clearToken?.(), n.onAuthFailure?.(e);
			}
			let n = {
				status: "error",
				errors: [{
					code: "UNKNOWN_ERROR",
					message: "An unknown error occurred"
				}]
			};
			if (e.code === "ERR_NETWORK") cr.error("Network error - unable to connect to server", {
				url: e.config?.url,
				method: e.config?.method,
				code: e.code
			}), n = {
				status: "error",
				errors: [{
					code: "NETWORK_ERROR",
					message: "Unable to connect to server. Please check your internet connection."
				}]
			};
			else if (e.response) if ((e.config?.suppressErrorStatuses ?? []).includes(e.response.status) || cr.error(`HTTP error ${e.response.status}`, {
				status: e.response.status,
				statusText: e.response.statusText,
				url: e.config?.url,
				method: e.config?.method,
				data: e.response.data
			}), e.response.status === 500) {
				let t = "The server encountered an internal error", r = "", i = e.response.data;
				i && (typeof i == "string" ? t = i : typeof i == "object" && (i.error ? (t = typeof i.error == "string" ? i.error : i.error.message || t, typeof i.error == "object" && i.error.details && (r = i.error.details)) : i.message ? t = i.message : i.data && i.data.error && (t = typeof i.data.error == "string" ? i.data.error : i.data.error.message || t))), n = {
					status: "error",
					errors: [{
						code: "SERVER_ERROR",
						message: t
					}]
				}, r && cr.error("Server error details:", r);
			} else {
				let t = e.response.data;
				if (t && t.status === "error" && Array.isArray(t.errors)) n = {
					status: "error",
					errors: t.errors
				};
				else {
					let r = "An error occurred";
					t && typeof t == "object" ? r = t.message || t.error || e.response.statusText || `HTTP error ${e.response.status}` : typeof t == "string" && (r = t), n = {
						status: "error",
						errors: [{
							code: `HTTP_${e.response.status}`,
							message: r
						}]
					};
				}
			}
			else cr.error("API client error", {
				message: e.message,
				url: e.config?.url,
				method: e.config?.method
			}), n = {
				status: "error",
				errors: [{
					code: "CLIENT_ERROR",
					message: e.message || "An unknown error occurred"
				}]
			};
			let r = e;
			return r.standardizedError = n, Promise.reject(e);
		});
	}
	createRequestKey(e) {
		let { url: t, method: n, params: r, data: i } = e;
		return `${n}:${t}:${JSON.stringify(r)}:${JSON.stringify(i)}`;
	}
	async request(e) {
		if (e.signal) return this.instance.request(e);
		let t = this.createRequestKey(e);
		if (this.pendingRequests.has(t)) return this.pendingRequests.get(t);
		let n = this.instance.request(e).finally(() => {
			this.pendingRequests.delete(t);
		});
		return this.pendingRequests.set(t, n), n;
	}
	async get(e, t) {
		return this.request({
			...t,
			method: "GET",
			url: e
		});
	}
	async post(e, t, n) {
		return this.request({
			...n,
			method: "POST",
			url: e,
			data: t
		});
	}
	async put(e, t, n) {
		return this.request({
			...n,
			method: "PUT",
			url: e,
			data: t
		});
	}
	async patch(e, t, n) {
		return this.request({
			...n,
			method: "PATCH",
			url: e,
			data: t
		});
	}
	async delete(e, t) {
		return this.request({
			...t,
			method: "DELETE",
			url: e
		});
	}
}(), hr = class extends Error {
	status;
	payload;
	constructor(e, t, n) {
		super(e), this.name = "DatagridApiError", this.status = t, this.payload = n;
	}
};
function gr(e) {
	return typeof FormData < "u" && e instanceof FormData;
}
function _r(e) {
	if (X.baseUrl === "/") return e;
	let t = X.baseUrl.startsWith("http") ? X.baseUrl : new URL(X.baseUrl, window.location.origin).toString();
	return new URL(e.replace(/^\//, ""), t.endsWith("/") ? t : `${t}/`).toString();
}
function vr(e, t) {
	return e?.errors?.[0]?.message ?? (typeof e?.error == "string" ? e.error : e?.error?.message) ?? e?.message ?? `Datagrid request failed with status ${t}`;
}
async function yr(e) {
	try {
		return await e.json();
	} catch {
		return null;
	}
}
async function br(e, t = {}) {
	let { body: n, unwrapData: r, ...i } = t, a = er(), o = a.getToken?.() ?? null, s = new Headers(i.headers ?? {}), c = i.method ?? "GET";
	o && s.set("Authorization", `Bearer ${o}`), n !== void 0 && !gr(n) && s.set("Content-Type", "application/json");
	let l = () => ({
		...i,
		method: c,
		headers: s,
		credentials: "omit",
		body: gr(n) ? n : n === void 0 ? void 0 : JSON.stringify(n)
	}), u = await fetch(_r(e), l());
	if (u.status === 401 && a.refreshToken) {
		let t = await a.refreshToken({ force: !0 });
		t && (a.setToken?.(t), s.set("Authorization", `Bearer ${t}`), u = await fetch(_r(e), l()));
	}
	return u;
}
async function xr(e, t = {}) {
	let n = await br(e, t), r = await yr(n);
	if (!n.ok) throw new hr(vr(r, n.status), n.status, r);
	return r && t.unwrapData !== !1 && "data" in r ? r.data : r;
}
async function Sr(e, t = {}) {
	let n = await br(e, t);
	if (!n.ok) {
		let e = await yr(n);
		throw new hr(vr(e, n.status), n.status, e);
	}
	return n.blob();
}
//#endregion
//#region src/utils/debugUtils.ts
var Cr = D("debugUtils");
function wr(e) {
	if (!e) return !1;
	let t = typeof e.message == "string" ? e.message.toLowerCase() : "";
	return e.name === "AbortError" || e.name === "CanceledError" || e.code === "ERR_CANCELED" || t === "canceled" || t.includes("err_canceled");
}
function Tr(e, t) {
	return ((...n) => {
		let r = n.length > 2 ? n[2] : void 0;
		return Cr.debug(`API Call [${t}] - Request params:`, {
			args: n.slice(0, 2),
			params: r,
			hasFilters: !!(r && r.filters),
			filterKeys: r && r.filters ? Object.keys(r.filters) : [],
			filterQueryParams: r ? Object.keys(r).filter((e) => e.startsWith("filter[")) : []
		}), e(...n).then((e) => (Cr.debug(`API Call [${t}] - Response:`, {
			status: e?.status || "unknown",
			dataRows: e?.data?.rows?.length,
			dataTotal: e?.data?.total
		}), e)).catch((e) => {
			throw wr(e) ? (Cr.debug(`API Call [${t}] - Request canceled`, {
				message: e.message,
				code: e.code
			}), e) : (Cr.error(`API Call [${t}] - Error:`, {
				message: e.message,
				status: e.response?.status,
				data: e.response?.data
			}), e);
		});
	});
}
function Er(e, t) {
	let n = { ...e };
	return Object.keys(e).forEach((r) => {
		let i = e[r];
		typeof i == "function" && (n[r] = Tr(i, `${t}.${r}`));
	}), n;
}
//#endregion
//#region src/services/tableService.ts
var Q = D("tableService");
function Dr(e) {
	if (e == null) return null;
	let t = (Array.isArray(e) ? e[0] : String(e)).trim();
	if (!t) return null;
	let n = Number(t);
	if (Number.isFinite(n) && n >= 0) return Math.max(0, Math.round(n * 1e3));
	let r = Date.parse(t);
	return Number.isNaN(r) ? null : Math.max(0, r - Date.now());
}
var Or = Er({
	retryWithBackoff: async (e, t = 3, n = 200) => {
		let r = 0, i = null;
		for (; r < t;) try {
			return await e();
		} catch (e) {
			let a = e.code === "ERR_NETWORK", o = e.response && e.response.status === 429, s = e.response && e.response.status >= 500, c = e.response && e.response.status === 401, l = e.response && e.response.status >= 400 && e.response.status < 500;
			if (c || l && !s && !o || !a && !s && !o) throw e;
			if (i = e, r++, r >= t) throw Q.error(`Failed after ${t} retries`, { error: e }), e;
			let u = o ? Dr(e.response?.headers?.["retry-after"]) : null, d = u == null ? n * 2 ** (r - 1) * (1 + Math.random() * .1) : Math.min(u, 1e4);
			Q.debug(`Retrying request (attempt ${r}/${t}) after ${d.toFixed(0)}ms`, {
				error: e.message,
				status: e.response?.status,
				retryAfterMs: u
			}), await new Promise((e) => setTimeout(e, d));
		}
		throw i;
	},
	fetchTables: async (e) => {
		let t = X.endpoints.tables.list(e);
		return Or.retryWithBackoff(async () => {
			let e = await Z.get(t), n = Z.standardizeResponse(e.data), r = (n.data?.tables ?? []).map((e) => {
				if (typeof e == "string") return e;
				if (e && typeof e == "object" && typeof e.name == "string") return e.name;
			}).filter((e) => typeof e == "string" && e.length > 0);
			return {
				...n,
				data: {
					tables: r,
					total: n.data?.total ?? r.length
				}
			};
		});
	},
	serializeFilters: (e) => {
		if (!(!e || Object.keys(e).length === 0)) try {
			if (typeof e == "string") return JSON.parse(e), e;
			let t = JSON.parse(JSON.stringify(e, (e, t) => t == null ? null : t instanceof Date ? t.toISOString() : t instanceof RegExp ? t.toString() : typeof t == "number" && !isFinite(t) ? String(t) : t));
			return JSON.stringify(t);
		} catch (t) {
			Q.error("Error serializing filters", {
				filters: e,
				error: t,
				filterType: typeof e,
				hasCircularRef: "Possible circular reference"
			});
			try {
				let t = {};
				return Object.keys(e).forEach((n) => {
					try {
						let r = e[n];
						if (r === void 0) return;
						if (Array.isArray(r)) t[n] = r.filter((e) => e !== void 0).map((e) => e instanceof Date ? e.toISOString() : e instanceof RegExp ? e.toString() : e);
						else if (r instanceof Date) t[n] = r.toISOString();
						else if (r instanceof RegExp) t[n] = r.toString();
						else if (typeof r == "object" && r) {
							let e = {};
							Object.keys(r).forEach((t) => {
								let n = r[t];
								n !== void 0 && (n instanceof Date ? e[t] = n.toISOString() : n instanceof RegExp ? e[t] = n.toString() : typeof n == "number" && !isFinite(n) ? e[t] = String(n) : e[t] = n);
							}), t[n] = e;
						} else typeof r == "number" && !isFinite(r) ? t[n] = String(r) : t[n] = r;
					} catch (e) {
						Q.warn(`Skipping problematic filter for key "${n}"`, e);
					}
				}), JSON.stringify(t);
			} catch (e) {
				return Q.error("Fallback serialization also failed", e), JSON.stringify({});
			}
		}
	},
	fetchTableData: async (e, t, n) => {
		let r = X.endpoints.tables.data(e, t);
		Q.debug("fetchTableData called with filter params:", {
			databaseId: e,
			tableName: t,
			paramsReceived: n,
			hasFilters: n?.filters !== void 0 && n?.filters !== null,
			filtersType: n?.filters ? typeof n.filters : "none",
			filtersValue: n?.filters
		});
		let i = { ...n }, a = i?.signal;
		if ("signal" in i && delete i.signal, i?.pageSize && !i?.limit && (i.limit = i.pageSize, delete i.pageSize), i?.page && !i?.offset && (i.offset = (i.page - 1) * (i.limit || 20), delete i.page), Array.isArray(i?.columns)) {
			let e = i.columns.filter((e) => typeof e == "string" && e.trim().length > 0).map((e) => e.trim());
			e.length > 0 ? i.columns = JSON.stringify(e) : delete i.columns;
		}
		if (i?.filters) {
			Q.debug("Processing filters in fetchTableData:", {
				filtersType: typeof i.filters,
				hasFilters: i.filters !== void 0 && i.filters !== null,
				isObject: typeof i.filters == "object",
				isArray: Array.isArray(i.filters),
				keysCount: typeof i.filters == "object" ? Object.keys(i.filters || {}).length : 0
			});
			try {
				if (typeof i.filters == "string") try {
					let e = JSON.parse(i.filters);
					Q.debug("Parsed string filters for flattening:", e), Object.keys(e).length === 0 ? (delete i.filters, Q.debug("Empty parsed filters object removed")) : i.filters = e;
				} catch (e) {
					Q.error("Failed to parse filter string:", e), delete i.filters;
				}
				typeof i.filters == "object" && i.filters !== null ? !i.filters || Object.keys(i.filters).length === 0 ? (delete i.filters, Q.debug("Empty filters object removed")) : (i.filters = JSON.stringify(i.filters), Q.debug("Serialized filter params for dataserver:", i.filters)) : i.filters !== void 0 && (Q.debug("Filters not processed - unexpected type:", typeof i.filters), delete i.filters);
			} catch (e) {
				Q.error("Invalid filter format", {
					filters: i.filters,
					error: e
				}), delete i.filters;
			}
		}
		if (i.sortOptions) try {
			if (Array.isArray(i.sortOptions)) {
				let e = i.sortOptions.filter((e) => e && typeof e == "object" && "column" in e && "direction" in e);
				e.length > 0 ? i.sortOptions = JSON.stringify(e) : delete i.sortOptions;
			} else typeof i.sortOptions == "string" ? JSON.parse(i.sortOptions) : delete i.sortOptions;
		} catch (e) {
			Q.error("Error serializing sort options", {
				sortOptions: i.sortOptions,
				error: e
			}), delete i.sortOptions;
		}
		Q.debug("Fetching table data with params:", {
			url: r,
			params: i
		});
		try {
			let e = await Z.get(r, {
				params: i,
				...a ? { signal: a } : {}
			}), t = Z.standardizeResponse(e.data), n = t.data, o = n?.run ?? n?.metadata?.run, s = n?.rows ?? o?.result?.rows ?? [], c = n?.columns ?? o?.result?.columns ?? [], l = typeof n?.total == "number" ? n.total : typeof o?.rowCount == "number" ? o.rowCount : n?.metadata?.totalRows, u = {
				...n?.metadata ?? {},
				...o ? { run: o } : {},
				...o && n?.metadata?.runId == null ? { runId: o.id } : {},
				...o && n?.metadata?.workspaceKey == null ? { workspaceKey: o.workspaceKey } : {},
				...o && n?.metadata?.queryHash == null ? { queryHash: o.queryHash } : {},
				...o && n?.metadata?.telemetrySource == null ? { telemetrySource: o.telemetrySource } : {},
				...o && n?.metadata?.totalRows == null && typeof o.rowCount == "number" ? { totalRows: o.rowCount } : {},
				...o && n?.metadata?.sourceRowCount == null && typeof o.sourceRowCount == "number" ? { sourceRowCount: o.sourceRowCount } : {},
				...o && n?.metadata?.appliedLimit == null && typeof o.result?.appliedLimit == "number" ? { appliedLimit: o.result.appliedLimit } : {},
				...o && n?.metadata?.offset == null && typeof o.result?.appliedOffset == "number" ? { offset: o.result.appliedOffset } : {},
				...o && n?.metadata?.hasMore == null && typeof o.result?.hasMore == "boolean" ? { hasMore: o.result.hasMore } : {},
				...o && n?.metadata?.cacheStatus == null ? { cacheStatus: o.cacheStatus } : {}
			};
			return Q.debug("Table data fetch response:", {
				status: e.status,
				rowCount: s.length,
				totalRows: l ?? 0,
				runId: o?.id
			}), {
				status: t.status,
				data: {
					...n ?? {
						rows: [],
						columns: []
					},
					rows: s,
					columns: c,
					...typeof l == "number" ? { total: l } : {},
					metadata: u,
					...o ? { run: o } : {}
				},
				...t.errors ? { errors: t.errors } : {},
				...t.jobId ? { jobId: t.jobId } : {}
			};
		} catch (e) {
			throw e?.code === "ERR_CANCELED" || e?.name === "CanceledError" || e?.name === "AbortError" ? (Q.debug("Table data request canceled", {
				url: r,
				params: i
			}), e) : (Q.error("Failed to fetch table data", {
				url: r,
				params: i,
				error: e.message,
				status: e.response?.status,
				responseData: e.response?.data
			}), e);
		}
	},
	fetchTableColumns: async (e, t) => {
		let n = X.endpoints.tables.schema(e, t), r = await Z.get(n);
		return (Z.standardizeResponse(r.data).data?.columns ?? []).map((e) => e?.name).filter((e) => typeof e == "string" && e.length > 0);
	},
	fetchUniqueColumnValues: async (e, t, n, r = "", i = 100) => {
		try {
			let a = X.endpoints.tables.uniqueValues(e, t, n);
			Q.debug(`Trying primary unique values endpoint: ${a}`, {
				searchTerm: r,
				limit: i
			});
			let o = {
				search: r,
				searchTerm: r,
				limit: i
			};
			try {
				let e = await Z.get(a, { params: o });
				Q.debug("Unique values response from primary endpoint:", e.data);
				let t = Z.standardizeResponse(e.data);
				if (t.status === "success" && t.data) {
					if (Q.debug("Successfully standardized response with envelope format"), t.data.values && Array.isArray(t.data.values)) return Q.debug(`Found ${t.data.values.length} values in standardized data`), t.data.values.map((e) => String(e));
					if (t.data.uniqueValues && Array.isArray(t.data.uniqueValues)) return Q.debug(`Found ${t.data.uniqueValues.length} uniqueValues in standardized data`), t.data.uniqueValues.map((e) => String(e));
				}
				let n = e.data;
				if (n?.values && Array.isArray(n.values)) return Q.debug(`Found ${n.values.length} values in response.data.values`), n.values.map(String);
				if (n?.uniqueValues && Array.isArray(n.uniqueValues)) return Q.debug(`Found ${n.uniqueValues.length} values in response.data.uniqueValues`), n.uniqueValues.map(String);
				if (Array.isArray(n)) return Q.debug(`Found array directly in response.data with ${n.length} items`), n.map(String);
				Q.warn("Unexpected response format from primary endpoint", n);
				try {
					let e = n?.data || n;
					if (e) {
						if (e.values && Array.isArray(e.values)) return Q.debug(`Extracted ${e.values.length} values from data object`), e.values.map((e) => String(e));
						if (e.uniqueValues && Array.isArray(e.uniqueValues)) return Q.debug(`Extracted ${e.uniqueValues.length} unique values from data object`), e.uniqueValues.map((e) => String(e));
						if (Array.isArray(e)) return Q.debug(`Using data object as array with ${e.length} items`), e.map((e) => String(e));
						for (let [t, n] of Object.entries(e)) if (Array.isArray(n)) return Q.debug(`Found array in property "${t}" with ${n.length} items`), n.map((e) => String(e));
					}
				} catch (e) {
					Q.error("Error trying to extract unique values in unusual format", e);
				}
			} catch (e) {
				Q.warn(`Primary endpoint failed: ${e instanceof Error ? e.message : "Unknown error"}`);
			}
			let s = `/api/databases/${e}/tables/${t}/column/${n}/unique-values`;
			Q.debug(`Trying alternative endpoint: ${s}`);
			let c = await Z.get(s, { params: o });
			if (Q.debug("Unique values response from alternative endpoint:", c.data), c.data?.status === "success" && c.data?.data) {
				if (Q.debug("Found success status and data object in alternative response"), c.data.data.values && Array.isArray(c.data.data.values)) return Q.debug(`Found ${c.data.data.values.length} values in alt response data.data.values`), c.data.data.values.map((e) => String(e));
				if (Array.isArray(c.data.data)) return Q.debug(`Found array directly in alt response data.data with ${c.data.data.length} items`), c.data.data.map((e) => String(e));
			}
			if (c.data?.uniqueValues && Array.isArray(c.data.uniqueValues)) return Q.debug(`Found ${c.data.uniqueValues.length} values in alt response uniqueValues`), c.data.uniqueValues.map((e) => String(e));
			if (c.data?.values && Array.isArray(c.data.values)) return Q.debug(`Found ${c.data.values.length} values in alt response values`), c.data.values.map((e) => String(e));
			try {
				let e = c.data?.data || c.data;
				if (e) {
					if (e.values && Array.isArray(e.values)) return Q.debug(`Extracted ${e.values.length} values from alt data object`), e.values.map((e) => String(e));
					if (typeof e == "object") {
						for (let [t, n] of Object.entries(e)) if (Array.isArray(n)) return Q.debug(`Found array in alt response property "${t}" with ${n.length} items`), n.map((e) => String(e));
					}
				}
				Q.warn("Unexpected response format from alternative endpoint, trying last-resort extraction", c.data);
			} catch (e) {
				Q.error("Error extracting unique values from alternative response", e);
			}
			if (Array.isArray(c.data)) return c.data;
			if (c.data && (Q.warn("Unexpected response format from alternative endpoint", c.data), typeof c.data == "object")) {
				for (let e in c.data) if (Array.isArray(c.data[e])) return c.data[e];
			}
			return Q.error("Could not extract unique values from response"), [];
		} catch (r) {
			return Q.error("Failed to fetch unique column values", {
				error: r,
				databaseId: e,
				tableName: t,
				columnName: n
			}), [];
		}
	},
	exportTableToCSV: async (e, t, n, r = "") => {
		try {
			let i = `/api/databases/${e}/tables/${t}/export`, a = n ? { ...n } : {}, o = {
				format: "csv",
				...a,
				fileName: r || void 0
			};
			Q.debug(`Exporting table to CSV: ${i}`, {
				filters: a,
				fileName: r
			});
			let s = await Z.get(i, {
				params: o,
				responseType: "blob"
			}), c = new Blob([s.data], { type: "text/csv" }), l = r || `${t}_export_${(/* @__PURE__ */ new Date()).toISOString().substring(0, 10)}.csv`, u = document.createElement("a"), d = window.URL.createObjectURL(c);
			return u.href = d, u.download = l, document.body.appendChild(u), u.click(), setTimeout(() => {
				document.body.removeChild(u), window.URL.revokeObjectURL(d);
			}, 100), Q.debug(`CSV export successful: ${l}`), {
				status: "success",
				data: {
					is404: !1,
					filters: n
				},
				success: !0
			};
		} catch (e) {
			let t = e?.response?.status === 404;
			return t ? Q.warn("Export endpoint not found (404). Will use client-side export as fallback.") : Q.error("Export to CSV failed", e), {
				status: "error",
				errors: [{ message: e instanceof Error ? e.message : "Unknown error" }],
				success: !1,
				error: e instanceof Error ? e.message : "Unknown error",
				is404: t,
				filters: n
			};
		}
	},
	fetchRecord: async (e, t, n) => {
		try {
			let r = X.endpoints.tables.record.get(e, t, n);
			return Q.debug(`Fetching record: ${r}`), (await Z.get(r)).data;
		} catch (e) {
			throw Q.error(`Failed to fetch record: ${n}`, { error: e }), e;
		}
	},
	updateRecord: async (e, t, n, r) => {
		try {
			let i = X.endpoints.tables.record.update(e, t, n);
			return Q.debug(`Updating record: ${i}`), (await Z.put(i, r)).data;
		} catch (e) {
			throw Q.error(`Failed to update record: ${n}`, { error: e }), e;
		}
	},
	createRecord: async (e, t, n) => {
		try {
			let r = X.endpoints.tables.record.create(e, t);
			Q.debug(`Creating new record: ${r}`, { tableName: t });
			let i = await Z.post(r, n);
			return Q.debug("Successfully created new record"), i.data;
		} catch (e) {
			throw Q.error("Failed to create new record", {
				error: e,
				tableName: t
			}), e;
		}
	},
	deleteRecord: async (e, t, n) => {
		try {
			let r = X.endpoints.tables.record.delete(e, t, n);
			Q.debug(`Deleting record: ${r}`), await Z.delete(r);
		} catch (e) {
			throw Q.error(`Failed to delete record: ${n}`, { error: e }), e;
		}
	},
	bulkDeleteRecords: async (e, t, n) => {
		try {
			let r = X.endpoints.tables.record.bulkDelete(e, t);
			Q.debug(`Bulk deleting records: ${r}`, { count: n.length }), await Z.delete(r, { data: { recordIds: n } }), Q.debug(`Successfully deleted ${n.length} records`);
		} catch (e) {
			throw Q.error("Failed to bulk delete records", {
				error: e,
				count: n.length
			}), e;
		}
	},
	fetchColumnStats: async (e, t, n, r = {}) => {
		try {
			let i = X.endpoints.stats.columnStats;
			Q.debug(`Fetching column stats: ${i}`, {
				databaseId: e,
				tableName: t,
				columnName: n,
				hasFilters: r.filters && Object.keys(r.filters).length > 0
			});
			let a = {
				databaseId: Number(e),
				tableName: String(t),
				samplePercentage: r.samplePercentage || 100,
				randomSample: !0
			};
			n && (a.columnName = String(n)), r.filters && Object.keys(r.filters).length > 0 && (a.filters = r.filters);
			let o = await Z.post(i, a), s = Z.standardizeResponse(o.data);
			if (s.status === "success" && s.data) return s.data;
			if (s.status === "error") {
				let e = s.errors?.[0]?.message || "Error fetching column stats";
				throw Q.error(e, { errors: s.errors }), Error(e);
			}
			return s.data || {};
		} catch (e) {
			throw Q.error(`Failed to fetch column stats for ${n}`, { error: e }), e;
		}
	},
	fetchMissingData: async (e, t, n = {}) => {
		try {
			let r = X.endpoints.stats.missingData;
			Q.debug(`Fetching missing data: ${r}`, {
				databaseId: e,
				tableName: t
			});
			let i = {
				databaseId: Number(e),
				tableName: String(t),
				maxSampleSize: n.maxSampleSize || 1e3,
				fullAnalysis: n.fullAnalysis || !1
			};
			return n.columnName && (i.columnName = n.columnName), n.filters && Object.keys(n.filters).length > 0 && (i.filters = n.filters), (await Z.post(r, i)).data;
		} catch (e) {
			throw Q.error(`Failed to fetch missing data for ${t}`, { error: e }), e;
		}
	},
	fetchDatabaseInfo: async (e) => {
		try {
			let t = X.endpoints.database.info(e);
			return Q.debug(`Fetching database info: ${t}`), Or.retryWithBackoff(async () => (await Z.get(t)).data);
		} catch (t) {
			throw Q.error(`Failed to fetch database info for ${e}`, { error: t }), t;
		}
	},
	fetchSamplingMethods: async () => {
		try {
			let e = X.endpoints.stats.sampleMethods;
			Q.debug(`Fetching available sampling methods: ${e}`);
			let t = await Z.get(e);
			return (Z.standardizeResponse(t.data).data ?? []).map((e) => {
				if (typeof e == "string") return e;
				if (e && typeof e == "object" && typeof e.id == "string") return e.id;
			}).filter((e) => typeof e == "string" && e.length > 0);
		} catch (e) {
			return Q.error("Failed to fetch sampling methods", { error: e }), [
				"random",
				"systematic",
				"stratified",
				"weighted",
				"cluster",
				"first-n"
			];
		}
	},
	applySampling: async (e, t, n) => {
		try {
			let r = X.endpoints.stats.sample;
			Q.debug("applySampling options received:", n), Q.debug(`Applying sampling to table: ${r}`, {
				databaseId: e,
				tableName: t,
				method: n.method,
				hasFilters: n.filters && Object.keys(n.filters).length > 0
			});
			let i = {
				databaseId: Number(e),
				tableName: String(t),
				method: n.method,
				...n.samplePercentage !== void 0 && { samplePercentage: n.samplePercentage },
				...n.maxRows !== void 0 && { maxRows: n.maxRows },
				...n.stratifyColumn && { stratifyColumn: n.stratifyColumn },
				...n.orderBy && { orderBy: n.orderBy },
				...n.seed !== void 0 && { seed: n.seed },
				...n.columns && { columns: n.columns },
				...n.filters && { filters: n.filters },
				...Array.isArray(n.sortBy) && (n.method === "first-n" || n.method === "last-n") && { sortBy: n.sortBy }
			}, a = await Z.post(r, i), o = Z.standardizeResponse(a.data).data ?? a.data, s = o.metadata.sampledRows, c = o.metadata.totalRows;
			return Q.debug(`Successfully applied sampling: ${s} rows from ${c} total`), o;
		} catch (e) {
			throw Q.error(`Failed to apply sampling to ${t}`, {
				error: e,
				options: n
			}), e;
		}
	},
	fetchColumnTypes: async (e, t, n = {}) => {
		try {
			let r = X.endpoints.typeInference.columnTypes(e, t);
			Q.debug(`Fetching column types from server: ${r}`);
			let i = {
				sampleSize: n.sampleSize || 100,
				includeExplanations: n.includeExplanations || !1
			}, a = await Z.post(r, void 0, { params: i }), o = Z.standardizeResponse(a.data).data ?? a.data;
			if (o && typeof o == "object") {
				let e = {}, t = o;
				if ("findings" in t && Array.isArray(t.findings)) t.findings.forEach((t) => {
					if (t.columnName && t.typeGroup) {
						let n = "categorical";
						switch (t.typeGroup.toLowerCase()) {
							case "numeric":
							case "integer":
							case "double":
							case "float":
							case "number":
							case "numerical":
								n = "numerical";
								break;
							case "temporal":
							case "date":
							case "datetime":
							case "timestamp":
								n = "date";
								break;
							case "media":
								n = "media";
								break;
							default: n = "categorical";
						}
						e[t.columnName] = n;
					}
				}), e.rowid ||= "numerical";
				else if (Array.isArray(a.data)) a.data.forEach((t) => {
					if (t.column && t.type) {
						let n = "categorical";
						switch (t.type.toLowerCase()) {
							case "numeric":
							case "integer":
							case "double":
							case "float":
							case "number":
							case "numerical":
								n = "numerical";
								break;
							case "date":
							case "datetime":
							case "timestamp":
								n = "date";
								break;
							default: n = "categorical";
						}
						e[t.column] = n;
					}
				});
				else if ("columns" in t) {
					let n = t.columns;
					Object.entries(n).forEach(([t, n]) => {
						if (t) {
							let r = "categorical";
							if (typeof n == "string") switch (n.toLowerCase()) {
								case "numeric":
								case "integer":
								case "double":
								case "float":
								case "number":
								case "numerical":
									r = "numerical";
									break;
								case "date":
								case "datetime":
								case "timestamp":
									r = "date";
									break;
							}
							else if (n && typeof n == "object" && "type" in n) switch (n.type.toLowerCase()) {
								case "numeric":
								case "integer":
								case "double":
								case "float":
								case "number":
								case "numerical":
									r = "numerical";
									break;
								case "date":
								case "datetime":
								case "timestamp":
									r = "date";
									break;
							}
							e[t] = r;
						}
					});
				} else Object.entries(t).forEach(([t, n]) => {
					if (t && t !== "databaseName" && t !== "findings" && t !== "summary" && t !== "timestamp") {
						let r = "categorical";
						if (typeof n == "string") switch (n.toLowerCase()) {
							case "numeric":
							case "integer":
							case "double":
							case "float":
							case "number":
							case "numerical":
								r = "numerical";
								break;
							case "date":
							case "datetime":
							case "timestamp":
								r = "date";
								break;
						}
						else if (n && typeof n == "object" && "type" in n) switch (n.type.toLowerCase()) {
							case "numeric":
							case "integer":
							case "double":
							case "float":
							case "number":
							case "numerical":
								r = "numerical";
								break;
							case "date":
							case "datetime":
							case "timestamp":
								r = "date";
								break;
						}
						e[t] = r;
					}
				});
				if (("rowid" in e || t.columns?.rowid || Object.keys(t).includes("rowid")) && (e.rowid = "numerical"), Object.keys(e).length === 0) throw Error(`No column types found in server response: ${JSON.stringify(o)}`);
				return Q.debug(`Successfully fetched column types for ${Object.keys(e).length} columns`), e;
			}
			throw Error(`Unexpected response format from fetchColumnTypes: ${JSON.stringify(o)}`);
		} catch (n) {
			throw Q.error(`Failed to fetch column types for ${t}`, {
				error: n,
				databaseId: e
			}), n;
		}
	},
	fetchTableRowCount: async (e, t, n) => {
		let r = X.endpoints.tables.count(e, t), i = {};
		n && (i.filters = JSON.stringify(n));
		let a = await Z.get(r, { params: i });
		return Z.standardizeResponse(a.data).data?.count ?? 0;
	},
	fetchQueryHistory: async (e, t = 20) => {
		let n = await Z.get(X.endpoints.queryWork.history, { params: {
			workspaceKey: e,
			limit: t
		} });
		return Z.standardizeResponse(n.data).data ?? {
			workspaceKey: e,
			runs: [],
			versions: [],
			pinnedVersionId: null
		};
	},
	fetchTableIndexes: async (e, t) => {
		let n = await Z.get(X.endpoints.tables.indexes(e, t));
		return Z.standardizeResponse(n.data).data ?? {
			indexes: [],
			total: 0
		};
	},
	createTableView: async (e, t, n, r) => {
		let i = await Z.post(X.endpoints.database.views(e), {
			viewName: t,
			sql: n,
			sourceTable: r?.sourceTable ?? null
		});
		return Z.standardizeResponse(i.data).data ?? {
			view: {
				name: t,
				sql: n,
				sourceTable: r?.sourceTable ?? null
			},
			createdAt: (/* @__PURE__ */ new Date()).toISOString()
		};
	}
}, "tableService"), kr = {
	async listSlaRules(e, t) {
		let n = new URL(_r(`/v1/databases/${e}/sla-rules`), window.location.origin);
		return t && n.searchParams.set("table_name", t), (await xr(n.toString())).rules ?? [];
	},
	async listAuditReports(e, t = 10) {
		let n = new URL(_r(`/v1/databases/${e}/audit-reports`), window.location.origin);
		return n.searchParams.set("limit", String(t)), (await xr(n.toString())).reports ?? [];
	},
	async generateAuditReport(e, t, n) {
		return (await xr(`/v1/databases/${e}/audit-reports`, {
			method: "POST",
			body: {
				format: t,
				...typeof n == "number" ? { qualityCheckRunId: n } : {}
			}
		})).report;
	},
	parseSummary(e) {
		if (!e?.json_blob) return null;
		try {
			return JSON.parse(e.json_blob);
		} catch {
			return null;
		}
	},
	async downloadAuditReport(e, t) {
		return t.format === "json" && t.json_blob ? new Blob([t.json_blob], { type: "application/json" }) : Sr(`/v1/databases/${e}/audit-reports/${t.id}/download`);
	},
	triggerBrowserDownload(e, t) {
		let n = window.URL.createObjectURL(e), r = document.createElement("a");
		r.href = n, r.download = t, document.body.appendChild(r), r.click(), document.body.removeChild(r), window.URL.revokeObjectURL(n);
	}
}, Ar = {
	async listReports() {
		return (await xr("/v1/reports")).reports ?? [];
	},
	async getMarkdownContent(e) {
		return (await xr(`/v1/reports/${encodeURIComponent(e)}/content`)).content ?? "";
	},
	async downloadReport(e) {
		return Sr(`/v1/reports/${encodeURIComponent(e)}/download`);
	},
	async getReportDetails(e) {
		return xr(`/v1/reports/${encodeURIComponent(e)}/details`);
	},
	triggerBrowserDownload(e, t) {
		let n = window.URL.createObjectURL(e), r = document.createElement("a");
		r.href = n, r.download = t, document.body.appendChild(r), r.click(), document.body.removeChild(r), window.URL.revokeObjectURL(n);
	},
	async previewBoardPacket() {
		return (await xr("/v1/reports/board-packet/preview", {
			method: "POST",
			body: Pr()
		})).packet;
	},
	async exportBoardPacket() {
		return xr("/v1/reports/board-packet/export", {
			method: "POST",
			body: Pr()
		});
	},
	async signOffBoardPacket(e) {
		return (await xr("/v1/reports/board-packet/signoff", {
			method: "POST",
			body: Pr({ review: {
				reviewerName: e.reviewerName,
				reviewerEmail: e.reviewerEmail,
				acceptsNoFinancialCertification: !0
			} })
		})).packet;
	},
	async markBoardPacketRawSourcesDeleted(e) {
		return (await xr("/v1/reports/board-packet/raw-sources/delete", {
			method: "POST",
			body: Pr({ review: {
				reviewerName: e.reviewerName,
				reviewerEmail: e.reviewerEmail ?? void 0,
				signedOffAt: e.signedOffAt
			} })
		})).packet;
	},
	async previewReportReadiness() {
		return (await xr("/v1/reports/readiness/preview", {
			method: "POST",
			body: {
				manifest: Ir(),
				now: "2026-05-01T10:00:00.000Z",
				runId: "weekly-kpi-pack-readiness"
			}
		})).run;
	},
	async signOffReportReadiness(e, t) {
		return (await xr("/v1/reports/readiness/signoff", {
			method: "POST",
			body: {
				run: e,
				attestation: {
					actorName: t.actorName,
					actorEmail: t.actorEmail,
					role: t.role
				}
			}
		})).run;
	},
	async exportReportReadiness(e) {
		return xr("/v1/reports/readiness/export", {
			method: "POST",
			body: { run: e }
		});
	}
}, jr = [{
	periodKey: "2026-03",
	startDate: "2026-03-01",
	endDate: "2026-03-31"
}, {
	periodKey: "2026-04",
	startDate: "2026-04-01",
	endDate: "2026-04-30"
}];
function Mr(e) {
	return {
		id: `${e}-export`,
		category: e,
		fileName: `${e}.csv`,
		exportedAt: "2026-04-25T00:00:00.000Z",
		periods: jr
	};
}
function Nr(e, t, n) {
	return {
		sourceId: `${e}-export`,
		category: e,
		periodKey: t,
		values: n
	};
}
function Pr(e = {}) {
	return {
		packetId: "acme-saas-2026-04-board-packet",
		companyName: "Acme SaaS",
		currentPeriodKey: "2026-04",
		comparisonPeriodKey: "2026-03",
		metricIds: [
			"arr",
			"net_revenue_retention",
			"sales_pipeline",
			"gross_margin",
			"cash_runway_months",
			"active_customers",
			"support_sla_attainment"
		],
		asOfDate: "2026-04-27T00:00:00.000Z",
		sources: [
			{
				source: Mr("billing"),
				rows: [Nr("billing", "2026-03", {
					startingMrr: 9e4,
					endingMrr: 1e5,
					newCustomerMrr: 6e3,
					expansionMrr: 7e3,
					contractionMrr: 1e3,
					churnedMrr: 2e3,
					startingCustomerCount: 100,
					churnedCustomerCount: 2
				}), Nr("billing", "2026-04", {
					startingMrr: 1e5,
					endingMrr: 125e3,
					newCustomerMrr: 13e3,
					expansionMrr: 15e3,
					contractionMrr: 1e3,
					churnedMrr: 2e3,
					startingCustomerCount: 105,
					churnedCustomerCount: 1
				})]
			},
			{
				source: Mr("crm"),
				rows: [Nr("crm", "2026-03", {
					openQualifiedPipelineValue: 5e5,
					closedWonOpportunities: 8,
					closedOpportunities: 20
				}), Nr("crm", "2026-04", {
					openQualifiedPipelineValue: 65e4,
					closedWonOpportunities: 12,
					closedOpportunities: 24
				})]
			},
			{
				source: Mr("accounting"),
				rows: [Nr("accounting", "2026-03", {
					revenue: 12e4,
					costOfGoodsSold: 36e3,
					netBurn: 1e5,
					cashBalance: 1e6,
					monthlyNetBurn: 1e5
				}), Nr("accounting", "2026-04", {
					revenue: 15e4,
					costOfGoodsSold: 39e3,
					netBurn: 13e4,
					cashBalance: 9e5,
					monthlyNetBurn: 9e4
				})]
			},
			{
				source: Mr("product_analytics"),
				rows: [Nr("product_analytics", "2026-03", { activeCustomerAccounts: 92 }), Nr("product_analytics", "2026-04", { activeCustomerAccounts: 118 })]
			},
			{
				source: Mr("support"),
				rows: [Nr("support", "2026-03", {
					ticketsResolvedWithinSla: 90,
					resolvedTickets: 100
				}), Nr("support", "2026-04", {
					ticketsResolvedWithinSla: 114,
					resolvedTickets: 120
				})]
			}
		],
		retention: {
			rawSourceRetentionDays: 30,
			deleteRawSourcesAfterAcceptance: !0
		},
		...e
	};
}
var Fr = "Ready based on declared sources and supplied artifacts; not a certification of BI-tool correctness or the full delivery chain.";
function Ir() {
	return {
		version: "report-readiness/v1",
		reportId: "board-pack-weekly-kpi",
		reportName: "Weekly Executive KPI Pack",
		owner: {
			name: "Maya BI Owner",
			email: "maya@example.com",
			team: "Business Intelligence"
		},
		cadence: "weekly",
		dueWindow: {
			startsAt: "2026-05-01T09:00:00.000Z",
			endsAt: "2026-05-01T17:00:00.000Z"
		},
		expectedArtifact: {
			artifactId: "weekly-kpi-pack-md",
			fileName: "weekly-kpi-pack-2026-05-01.md",
			format: "md",
			required: !0,
			minBytes: 1,
			minRows: 1,
			observed: {
				exists: !0,
				sizeBytes: 2048,
				rowCount: 12,
				updatedAt: "2026-05-01T08:30:00.000Z"
			}
		},
		sources: [
			{
				type: "report_artifact",
				id: "weekly-kpi-pack-2026-05-01.md",
				label: "Generated markdown report",
				observedAt: "2026-05-01T08:30:00.000Z"
			},
			{
				type: "job",
				id: "job-weekly-kpi-refresh",
				label: "Weekly KPI refresh job",
				observedAt: "2026-05-01T08:15:00.000Z"
			},
			{
				type: "catalog_item",
				id: "catalog.revenue.weekly_kpi",
				label: "Revenue weekly KPI table",
				observedAt: "2026-05-01T08:00:00.000Z"
			},
			{
				type: "quality_run",
				id: "quality-run-weekly-kpi",
				label: "Latest quality overview",
				observedAt: "2026-05-01T08:20:00.000Z"
			}
		],
		thresholds: {
			freshnessSlaHours: 24,
			minRows: 1,
			minBytes: 1,
			schemaFields: [
				"account_id",
				"period",
				"metric_value"
			]
		},
		requiredChecks: [
			"manifest_complete",
			"owner_covered",
			"artifact_present",
			"artifact_nonempty",
			"job_recent",
			"source_fresh",
			"schema_threshold_met",
			"row_count_threshold_met",
			"quality_failures_clear",
			"evidence_timestamps_present"
		],
		signoffRole: "owner",
		claimBoundary: Fr
	};
}
//#endregion
//#region src/services/validationOverviewService.ts
function Lr(e) {
	return e && typeof e == "object" && "data" in e && e.data !== void 0 ? e.data : e;
}
function Rr(e) {
	try {
		return JSON.parse(e);
	} catch {
		return e;
	}
}
function zr(e) {
	return typeof e == "string" ? zr(Rr(e)) : !e || typeof e != "object" ? null : e;
}
function Br(e) {
	let t = zr(e.response?.data);
	return e.standardizedError?.errors?.[0]?.code ?? t?.errors?.[0]?.code ?? (typeof t?.error == "object" ? t.error?.code ?? null : null);
}
function Vr(e) {
	let t = zr(e.response?.data), n = typeof t?.error == "object" ? t.error.message : typeof t?.error == "string" ? t.error : null;
	return t?.errors?.[0]?.message ?? n ?? t?.message ?? e.standardizedError?.errors?.[0]?.message ?? e.message ?? null;
}
function Hr(e, t, n) {
	if (e === 401 || e === 403 || t?.startsWith("AUTH_") || t === "HTTP_401" || t === "HTTP_403") return !0;
	let r = n?.toLowerCase() ?? "";
	return r.includes("authentication required") || r.includes("token expired") || r.includes("invalid token") || r.includes("session expired") || r.includes("session is invalid") || r.includes("session invalid");
}
function Ur(e, t) {
	let n = t?.toLowerCase() ?? "";
	return e === "NETWORK_ERROR" || n.includes("unable to connect to server") || n.includes("network error");
}
function Wr(e) {
	let t = e, n = t.response?.status, r = Br(t), i = Vr(t);
	return Hr(n, r, i) ? "Your session expired. Sign in again to load Observatory quality data." : Ur(r, i) ? "Unable to reach the API. Check the dataserver connection and try again." : typeof i == "string" && i.trim().length > 0 ? i.trim() : "Unable to load the cross-dataset quality overview.";
}
var Gr = { async getOverview() {
	try {
		return Lr((await Z.get(X.endpoints.validation.overview)).data);
	} catch (e) {
		throw Error(Wr(e));
	}
} };
//#endregion
//#region src/services/gateTriageService.ts
function Kr(e) {
	return e?.data ?? e;
}
async function qr({ workspaceId: e, sourceName: t, limit: n = 30 }) {
	return Kr((await Z.get(X.endpoints.gate.batchHistory, { params: {
		workspaceId: e,
		sourceName: t,
		limit: n
	} })).data);
}
//#endregion
//#region src/services/governancePanelService.ts
function Jr(e) {
	return new URL(_r(e), window.location.origin);
}
function Yr(e) {
	return { "x-workspace-id": e };
}
function Xr(e) {
	if (Array.isArray(e)) return e;
	if (!(typeof e != "string" || e.trim().length === 0)) try {
		let t = JSON.parse(e);
		return Array.isArray(t) ? t : void 0;
	} catch {
		return;
	}
}
function Zr(e) {
	return {
		name: typeof e.name == "string" ? e.name : "unknown",
		title: typeof e.title == "string" ? e.title : void 0,
		description: typeof e.description == "string" ? e.description : void 0,
		type: typeof e.type == "string" ? e.type : "unknown",
		constraints: Xr(e.constraints),
		required: e.required === !0,
		position: typeof e.position == "number" ? e.position : void 0
	};
}
function Qr(e) {
	if (typeof e != "string" || e.trim().length === 0) return null;
	try {
		let t = JSON.parse(e);
		return typeof t == "object" && t ? t : null;
	} catch {
		return null;
	}
}
function $r(e) {
	if (!e) return null;
	if (typeof e == "object" && !Array.isArray(e)) return e;
	if (typeof e != "string") return null;
	try {
		let t = JSON.parse(e);
		return t && typeof t == "object" && !Array.isArray(t) ? t : null;
	} catch {
		return null;
	}
}
function ei(e) {
	return typeof e == "number" && Number.isFinite(e) ? e : void 0;
}
function ti(e, t) {
	if (e) for (let n of t) {
		let t = ei(e[n]);
		if (t !== void 0) return t;
	}
}
function ni(e) {
	let t = ti($r(e.details), [
		"maximumRR",
		"maxRisk",
		"maximumRr"
	]);
	return t === void 0 ? typeof e.overall_score == "number" ? Math.max(0, Math.min(1, 1 - e.overall_score / 100)) : void 0 : t;
}
function ri(e) {
	return ti($r(e.details), [
		"averageRR",
		"avgRisk",
		"averageRr"
	]);
}
function ii(e) {
	if (!(e === void 0 || e <= 0)) return Number((1 / e).toFixed(2));
}
function ai(e) {
	let t = $r(e.details), n = (Array.isArray(t?.columns) ? t.columns.filter((e) => !!e && typeof e == "object" && !Array.isArray(e)) : []).map((e) => ({
		...typeof e.columnName == "string" ? { columnName: e.columnName } : {},
		nue: ei(e.nue)
	})).filter((e) => e.nue !== void 0).sort((e, t) => t.nue - e.nue)[0];
	if (n) return n;
	let r = ti($r(t?.summary), ["averageNue"]);
	return r === void 0 ? typeof e.overall_score == "number" ? { nue: Math.max(0, Math.min(1, e.overall_score / 100)) } : {} : { nue: r };
}
var oi = {
	async fetchPrivacyScan(e) {
		return xr(`/v1/privacy/phi/database/${encodeURIComponent(String(e))}?sampleSize=60&confidenceThreshold=0.35&includeExplanations=true`);
	},
	async fetchPrivacyProfile(e) {
		try {
			return (await xr(X.endpoints.governance.privacyProfile(e))).profile ?? null;
		} catch (e) {
			if (e instanceof hr && e.status === 404) return null;
			throw e;
		}
	},
	async fetchOrhbrMetricSummary(e) {
		let t = (await xr(X.endpoints.database.latestQualityChecks(e), { unwrapData: !1 })).data ?? [], n = t.filter((e) => e.check_type === "reidentification_risk"), r = t.filter((e) => e.check_type === "nue_metric"), i = n.map(ni).filter((e) => e !== void 0).sort((e, t) => t - e)[0], a = n.map(ri).filter((e) => e !== void 0), o = a.length > 0 ? Number((a.reduce((e, t) => e + t, 0) / a.length).toFixed(4)) : void 0, s = r.map(ai).filter((e) => e.nue !== void 0).sort((e, t) => t.nue - e.nue)[0], c = t.map((e) => e.run_at).filter((e) => typeof e == "string").sort(), l = c[c.length - 1];
		return {
			maximumRR: i,
			averageRR: o,
			nue: s?.nue,
			nueColumnName: s?.columnName,
			achievedK: ii(i),
			updatedAt: l
		};
	},
	async fetchRRTrend(e) {
		let t = Jr(X.endpoints.database.qualityChecks(e));
		return t.searchParams.set("checkType", "reidentification_risk"), t.searchParams.set("limit", "10"), ((await xr(t.toString(), { unwrapData: !1 })).data ?? []).map((e) => {
			let t = ni(e);
			return t === void 0 || !e.run_at ? null : {
				runAt: e.run_at,
				maximumRR: t
			};
		}).filter((e) => e !== null).reverse();
	},
	async listSchemas() {
		return ((await xr("/v1/schema")).schemas ?? []).map((e) => ({
			id: typeof e.id == "string" ? e.id : crypto.randomUUID(),
			name: typeof e.name == "string" ? e.name : "unknown-schema",
			title: typeof e.title == "string" ? e.title : null,
			description: typeof e.description == "string" ? e.description : null,
			version: typeof e.version == "string" ? e.version : "0.0.0",
			tags: typeof e.tags == "string" ? e.tags : null,
			fields: Array.isArray(e.fields) ? e.fields.map((e) => Zr(e)) : []
		}));
	},
	async getSchemaHistory(e) {
		return ((await xr(`/v1/schema/${encodeURIComponent(e)}/history`)).history ?? []).map((t, n) => {
			let r = Qr(t.snapshot), i = Array.isArray(r?.fields) ? r.fields.map((e) => Zr(e)) : [];
			return {
				id: typeof t.id == "string" ? t.id : `${e}-${n}`,
				version: typeof t.version == "string" ? t.version : `v-${n}`,
				changeLog: typeof t.changeLog == "string" ? t.changeLog : null,
				createdAt: typeof t.createdAt == "string" ? t.createdAt : void 0,
				fields: i,
				title: typeof r?.title == "string" ? r.title : void 0,
				description: typeof r?.description == "string" ? r.description : void 0
			};
		});
	},
	async fetchReviewQueue(e) {
		let t = Jr(X.endpoints.governance.reviewQueue);
		return t.searchParams.set("limit", "50"), e && t.searchParams.set("reason", e), xr(t.toString(), { unwrapData: !1 });
	},
	async searchGovernance(e = {}) {
		let t = Jr(X.endpoints.governance.search);
		return t.searchParams.set("limit", "50"), e.tag && t.searchParams.set("tag", e.tag), e.classification && t.searchParams.set("classification", e.classification), e.certificationStatus && t.searchParams.set("certificationStatus", e.certificationStatus), xr(t.toString(), { unwrapData: !1 });
	},
	async listTags(e) {
		let t = Jr(X.endpoints.governance.tags);
		return e && t.searchParams.set("namespace", e), (await xr(t.toString())).tags ?? [];
	},
	async createTag(e) {
		return (await xr(X.endpoints.governance.tags, {
			method: "POST",
			body: e
		})).tag;
	},
	async attachTagToDatabase(e, t) {
		await xr(X.endpoints.governance.databaseTags(e), {
			method: "POST",
			body: { tagId: t }
		});
	},
	async detachTagFromDatabase(e, t) {
		await xr(`${X.endpoints.governance.databaseTags(e)}/${t}`, { method: "DELETE" });
	},
	async listWorkflowTemplates(e) {
		return (await xr(X.endpoints.governance.workflowTemplates, { headers: Yr(e) })).templates ?? [];
	},
	async saveWorkflowTemplate(e, t) {
		let n = !!t.id;
		return (await xr(n && t.id ? X.endpoints.governance.workflowTemplate(t.id) : X.endpoints.governance.workflowTemplates, {
			method: n ? "PUT" : "POST",
			headers: Yr(e),
			body: {
				name: t.name,
				triggerType: t.triggerType,
				steps: t.steps
			}
		})).template;
	},
	async archiveWorkflowTemplate(e, t) {
		return (await xr(X.endpoints.governance.workflowTemplate(t), {
			method: "DELETE",
			headers: Yr(e)
		})).template;
	},
	async listWorkflowRuns(e, t) {
		let n = Jr(X.endpoints.governance.workflowRuns);
		return t && n.searchParams.set("status", t), (await xr(n.toString(), { headers: Yr(e) })).runs ?? [];
	},
	async triggerWorkflowRun(e, t) {
		return (await xr(X.endpoints.governance.workflowRunTrigger, {
			method: "POST",
			headers: Yr(e),
			body: t
		})).run;
	},
	async transitionWorkflowRun(e, t, n, r, i) {
		return (await xr(X.endpoints.governance.workflowRunTransition(t), {
			method: "PATCH",
			headers: Yr(e),
			body: {
				action: n,
				...r ? { actorId: r } : {},
				...i ? { note: i } : {}
			}
		})).run;
	},
	async exportWorkflowAuditLog(e, t, n) {
		let r = Jr(X.endpoints.governance.workflowRunAuditExport(t));
		return r.searchParams.set("format", n), Sr(r.toString(), { headers: Yr(e) });
	}
};
//#endregion
//#region src/services/lineageService.ts
function si(e) {
	return e && typeof e == "object" && "data" in e && e.data !== void 0 ? e.data : e;
}
function ci(e) {
	try {
		return JSON.parse(e);
	} catch {
		return e;
	}
}
function li(e) {
	return typeof e == "string" ? li(ci(e)) : !e || typeof e != "object" ? null : e;
}
function ui(e) {
	let t = li(e.response?.data);
	return e.standardizedError?.errors?.[0]?.code ?? t?.errors?.[0]?.code ?? (typeof t?.error == "object" ? t.error.code ?? null : null);
}
function di(e) {
	let t = li(e.response?.data), n = typeof t?.error == "object" ? t.error.message : typeof t?.error == "string" ? t.error : null;
	return t?.errors?.[0]?.message ?? n ?? t?.message ?? e.standardizedError?.errors?.[0]?.message ?? e.message ?? null;
}
function fi(e, t, n) {
	if (e === 401 || e === 403 || t?.startsWith("AUTH_") || t === "HTTP_401" || t === "HTTP_403") return !0;
	let r = n?.toLowerCase() ?? "";
	return r.includes("authentication required") || r.includes("token expired") || r.includes("invalid token") || r.includes("session expired") || r.includes("session invalid");
}
function pi(e, t) {
	let n = t?.toLowerCase() ?? "";
	return e === "NETWORK_ERROR" || n.includes("unable to connect to server") || n.includes("network error");
}
function mi(e) {
	let t = e, n = t.response?.status, r = ui(t), i = di(t);
	return fi(n, r, i) ? "Your session expired. Sign in again to load lineage data." : pi(r, i) ? "Unable to reach the API. Check the dataserver connection and try again." : typeof i == "string" && i.trim().length > 0 ? i.trim() : "Unable to load lineage data.";
}
function hi(e) {
	let t = new URLSearchParams();
	for (let [n, r] of Object.entries(e)) r !== void 0 && t.set(n, String(r));
	let n = t.toString();
	return n.length > 0 ? `?${n}` : "";
}
var gi = {
	async getDatabaseLineage(e, t = 3, n = "internal") {
		try {
			return si((await Z.get(`/v1/lineage/${e}${hi({
				depth: t,
				datasourceType: n
			})}`)).data);
		} catch (e) {
			throw Error(mi(e));
		}
	},
	async getTableLineage(e, t, n, r = 4, i = "internal") {
		try {
			let a = encodeURIComponent(t);
			return si((await Z.get(`/v1/lineage/${e}/tables/${a}${hi({
				depth: r,
				datasourceType: i,
				schemaName: n
			})}`)).data);
		} catch (e) {
			throw Error(mi(e));
		}
	}
};
//#endregion
//#region src/services/clientPortalService.ts
function _i(e) {
	return e && typeof e == "object" && "data" in e && e.data !== void 0 ? e.data : e;
}
function vi(e, t) {
	let n = e, r = n.response?.status, i = n.standardizedError?.errors?.[0]?.message ?? n.message ?? null;
	return r === 401 || r === 403 ? "Your session expired. Sign in again to load the client portal." : typeof i == "string" && i.trim().length > 0 ? i.trim() : t;
}
var yi = {
	async getLatest() {
		try {
			return _i((await Z.get(X.endpoints.clientPortal.latest)).data);
		} catch (e) {
			throw Error(vi(e, "Unable to load the latest client portal update."));
		}
	},
	async getHistory() {
		try {
			return _i((await Z.get(X.endpoints.clientPortal.history)).data).publications ?? [];
		} catch (e) {
			throw Error(vi(e, "Unable to load the client portal publication history."));
		}
	},
	async getPublication(e) {
		try {
			return _i((await Z.get(X.endpoints.clientPortal.publication(e))).data).publication;
		} catch (e) {
			throw Error(vi(e, "Unable to load the selected client portal publication."));
		}
	}
};
//#endregion
//#region src/services/conflictMatrixService.ts
function bi(e) {
	return e?.data ?? e;
}
async function xi(e) {
	return bi((await Z.post(X.endpoints.conflict.compare, e)).data);
}
async function Si({ workspaceId: e, limit: t = 100 }) {
	return bi((await Z.get(X.endpoints.conflict.sessions(e), { params: { limit: t } })).data);
}
//#endregion
//#region src/provider/default.ts
var Ci = Or;
function wi() {
	return Ci;
}
//#endregion
//#region src/provider/context.tsx
var Ti = r({ provider: wi() });
function Ei({ provider: e, children: t }) {
	let n = f(() => ({ provider: e ?? wi() }), [e]);
	return /* @__PURE__ */ _(Ti.Provider, {
		value: n,
		children: t
	});
}
function Di() {
	return c(Ti).provider;
}
function Oi() {
	return wi();
}
//#endregion
//#region src/hooks/tableLocalTransforms.ts
function ki(e, t) {
	return !t || Object.keys(t).length === 0 ? e : e.filter((e) => Object.entries(t).every(([t, n]) => {
		let r = e[t];
		if (r == null) return !1;
		if (Array.isArray(n)) return n.some((e) => String(r).toLowerCase() === String(e).toLowerCase());
		if (typeof n == "object" && n) {
			let { min: e, max: t } = n, i = Number(r);
			return Number.isNaN(i) ? !1 : e !== void 0 && t !== void 0 ? i >= Number(e) && i <= Number(t) : e === void 0 ? t === void 0 ? !0 : i <= Number(t) : i >= Number(e);
		}
		return String(r).toLowerCase() === String(n).toLowerCase();
	}));
}
function Ai(e, t, n) {
	if (!t) return e;
	let r = n === "desc" ? -1 : 1;
	return [...e].sort((e, n) => {
		let i = e?.[t], a = n?.[t];
		if (i === a) return 0;
		if (i == null || i === "") return 1;
		if (a == null || a === "") return -1;
		let o = Number(i), s = Number(a);
		if (Number.isFinite(o) && Number.isFinite(s)) return (o - s) * r;
		let c = typeof i == "string" ? Date.parse(i) : NaN, l = typeof a == "string" ? Date.parse(a) : NaN;
		return Number.isFinite(c) && Number.isFinite(l) ? (c - l) * r : String(i).localeCompare(String(a), void 0, {
			numeric: !0,
			sensitivity: "base"
		}) * r;
	});
}
function ji(e, t, n, r) {
	return Ai(ki(e ?? [], t), n, r);
}
//#endregion
//#region src/hooks/useTableData.ts
var Mi = D("useTableData"), Ni = 150, Pi = (e) => JSON.stringify(e), Fi = 100, Ii = 3e5, Li = (e, t) => Math.max(1, Math.ceil(Math.max(0, e) / Math.max(1, t))), Ri = (e, t, n, r, i, a, o, c, l, d, p, g, _, v, y, b, x, S, C, w) => {
	let T = Di(), E = !!b, D = _ && _.length > 0 ? _[0] : 20, [O, k] = h(e ?? []), [A, j] = h(i || ""), [M, N] = h(a || "asc"), [P, F] = h(o || 1), [I, L] = h(c || D), [R, z] = h(l ?? (E ? (e ?? []).length : 0)), [B, V] = h(d || 1), [H, ee] = h(p), [U, te] = h(!1), [W, ne] = h(null), [re, ie] = h(!1), [ae, oe] = h(x ?? !1), se = s((t) => {
		oe(t), F(1), k(e ?? []);
	}, [
		e,
		F,
		k
	]), ce = s(() => {
		ae && P < B && !U && F((e) => e + 1);
	}, [
		ae,
		P,
		B,
		U
	]), le = ae ? P < B : !1, ue = m(p), de = m(!0), fe = m(/* @__PURE__ */ new Map()), pe = m(!1), me = m(!0), he = m(null), ge = m(g), _e = m(""), ve = m(H), ye = m(JSON.stringify(p || {})), be = m(e), xe = m(v), Se = m(null), Ce = m({}), we = m(""), G = m(null), Te = m(null);
	u(() => {
		ge.current = g;
	}, [g]), u(() => {
		ve.current = H;
	}, [H]), u(() => {
		xe.current = v;
	}, [v]);
	let Ee = f(() => t === void 0 ? void 0 : String(t), [t]), K = m(`${c ?? "unset"}:${r ?? "unset"}:${Ee ?? "unset"}:${n ?? "unset"}`), De = s((e) => {
		k(e), ge.current && ge.current(e);
	}, []), Oe = s(() => {
		G.current &&= (clearTimeout(G.current), null), Te.current = null;
	}, []), ke = s((e, t, n, r) => {
		let i = (t - 1) * n + e;
		return Math.max(r, i, 0);
	}, []), Ae = s(async ({ response: e, dbId: t, tblName: n, requestFilters: r, requestedPage: i, requestedPageSize: a, previousTotalRows: o }) => {
		let s = e?.data?.total;
		if (typeof s == "number" && s >= 0) return s;
		let c = e?.data?.metadata?.totalRows;
		if (typeof c == "number" && c >= 0) return c;
		if (typeof T.fetchTableRowCount == "function") try {
			let e = await T.fetchTableRowCount(t, n, r);
			if (typeof e == "number" && e >= 0) return e;
		} catch (e) {
			Mi.warn("Failed to fetch table row count fallback", {
				databaseId: t,
				tableName: n,
				error: e
			});
		}
		return ke(e?.data?.rows?.length ?? 0, i, a, o);
	}, [ke, T]);
	u(() => () => {
		Oe();
	}, [Oe]);
	let je = s((e, t = p) => ji(e, t || {}, A, M), [
		p,
		M,
		A
	]);
	function Me(e) {
		if (e && e.__sampling) {
			let { strategy: t, samplePercentage: n, stratifyColumn: r } = e.__sampling;
			return {
				strategy: t,
				samplePercentage: n,
				stratifyColumn: r
			};
		}
		return null;
	}
	let Ne = f(() => {
		if (!Ee || !n) return null;
		let e = {
			limit: I,
			offset: (P - 1) * I,
			sortBy: A || void 0,
			order: M || void 0
		};
		typeof C == "number" && Number.isFinite(C) && C > 0 && (e.resultLimit = C), w && w.length > 0 && (e.columns = w), typeof r == "number" && r > 0 && (e.requestNonce = r);
		let t = H, i = null;
		if (t && typeof t == "object" && "__sampling" in t) {
			i = Me(t);
			let { __sampling: n, ...r } = t;
			t = r, i && (e.sampleStrategy = i.strategy, e.samplePercentage = i.samplePercentage, i.stratifyColumn && (e.stratifyColumn = i.stratifyColumn));
		}
		return t && Object.keys(t).length > 0 ? (e.filters = t, Mi.debug("Including filters in request params:", {
			filterKeys: Object.keys(t),
			sortBy: e.sortBy,
			order: e.order
		})) : delete e.filters, xe.current && Array.isArray(xe.current) && xe.current.length > 0 && (e.sortOptions = xe.current), {
			databaseId: Ee,
			tableName: n,
			...e
		};
	}, [
		Ee,
		n,
		P,
		I,
		r,
		C,
		w,
		A,
		M,
		H,
		v
	]), Pe = f(() => JSON.stringify(H || {}), [H]), Fe = s(() => {
		if (fe.current.size === 0) return;
		let e = Date.now(), t = [];
		if (fe.current.forEach((n, r) => {
			e - n.timestamp > Ii && t.push(r);
		}), t.length > 0 && (Mi.debug(`Cleaning up ${t.length} stale requests`), t.forEach((e) => {
			fe.current.delete(e);
		})), fe.current.size > Fi) {
			let e = Array.from(fe.current.keys());
			e.sort((e, t) => (fe.current.get(e)?.timestamp || 0) - (fe.current.get(t)?.timestamp || 0));
			let t = fe.current.size - Math.floor(Fi * .75);
			Mi.debug(`Map too large (${fe.current.size}), removing ${t} oldest entries`);
			for (let n = 0; n < t; n++) n < e.length && fe.current.delete(e[n]);
		}
	}, []);
	u(() => (Se.current = window.setInterval(Fe, 6e4), () => {
		Se.current !== null && clearInterval(Se.current);
	}), [Fe]);
	let Ie = s(async () => {
		if (E || !Ne) return null;
		let e = Pi(Ne), t = fe.current.get(e);
		if (t) return Mi.debug("Skipping duplicate request:", { requestKey: e }), t.promise;
		Mi.debug("Processing data request with filters", {
			requestKey: e,
			hasFilters: ve.current && Object.keys(ve.current).length > 0,
			filterKeys: ve.current ? Object.keys(ve.current) : []
		}), Fe(), Mi.debug("Proceeding with request:", {
			requestKey: e,
			hasFilters: !!Ne.filters,
			sortBy: Ne.sortBy,
			order: Ne.order
		}), he.current && he.current.abort(), he.current = new AbortController(), te(!0), ne(null), Oe();
		try {
			let { databaseId: t, tableName: n, requestNonce: r, ...i } = Ne;
			if (!t || !n) throw Error("Missing required databaseId or tableName");
			let a = Date.now(), s = T.fetchTableData(t, n, {
				...i,
				signal: he.current.signal
			});
			fe.current.set(e, {
				promise: s,
				timestamp: Date.now()
			});
			let c = await s;
			if (fe.current.delete(e), !me.current) return null;
			let u = c?.data?.rows || [], d = { ...c?.data?.metadata && typeof c.data.metadata == "object" ? c.data.metadata : {} }, f = c?.data?.run && typeof c.data.run == "object" ? c.data.run : void 0, p = f?.status === "queued" || f?.status === "running", m = await Ae({
				response: c,
				dbId: t,
				tblName: n,
				requestFilters: i.filters,
				requestedPage: P,
				requestedPageSize: I,
				previousTotalRows: l ?? R
			});
			d && typeof d.sampledRows == "number" && (m = d.sampledRows), typeof C == "number" && Number.isFinite(C) && C > 0 && (m = Math.min(m, C));
			let h = (e, t) => {
				S?.({
					durationMs: Date.now() - a,
					fetchedAt: (/* @__PURE__ */ new Date()).toISOString(),
					totalRows: t ?? m,
					cacheStatus: typeof d?.cacheStatus == "string" ? d.cacheStatus : "unknown",
					metadata: e
				});
			};
			if (p && typeof T.fetchQueryHistory == "function" && typeof f?.workspaceKey == "string") {
				Oe(), Te.current = e, h({
					...d && typeof d == "object" ? d : {},
					pendingRun: f
				}, l ?? R), pe.current = !0, te(!1);
				let t = async () => {
					if (!(!me.current || Te.current !== e)) try {
						let e = (await T.fetchQueryHistory?.(f.workspaceKey, 1))?.runs?.[0];
						if (!e) {
							G.current = setTimeout(() => {
								t();
							}, Ni);
							return;
						}
						if (e.status === "queued" || e.status === "running") {
							h({
								...d && typeof d == "object" ? d : {},
								pendingRun: e
							}, l ?? R), G.current = setTimeout(() => {
								t();
							}, Ni);
							return;
						}
						if (Oe(), e.status !== "succeeded" || !e.result) {
							h({
								...d && typeof d == "object" ? d : {},
								latestRun: e
							}, l ?? R);
							return;
						}
						let n = e.result.rows ?? [], r = typeof e.rowCount == "number" ? e.rowCount : n.length, i = {
							totalRows: r,
							sourceRowCount: e.sourceRowCount,
							appliedLimit: e.result.appliedLimit,
							offset: e.result.appliedOffset,
							hasMore: e.result.hasMore,
							runId: e.id,
							workspaceKey: e.workspaceKey,
							queryHash: e.queryHash,
							telemetrySource: e.telemetrySource,
							cacheStatus: e.cacheStatus,
							run: e
						};
						Mi.debug("Applying completed queued run to table data", {
							runId: e.id,
							rowCount: n.length,
							totalRows: r
						}), De(n), z(r), V(Math.max(1, Math.ceil(r / I))), pe.current = !0, h(i, r);
					} catch (t) {
						Mi.warn("Queued run polling failed", {
							workspaceKey: f.workspaceKey,
							requestKey: e,
							error: t
						}), Oe();
					}
				};
				return G.current = setTimeout(() => {
					t();
				}, Ni), c;
			}
			h(d && typeof d == "object" ? d : void 0);
			let g = ae && P > (o || 1);
			return g && u.length > 0 ? k((e) => {
				let t = [...e, ...u];
				return ge.current && ge.current(t), t;
			}) : g && u.length === 0 ? Mi.debug("Infinite scroll reached terminal empty page; preserving existing rows", {
				page: P,
				totalRows: m
			}) : (Mi.debug("Updating table data with filtered results:", {
				rowCount: u.length,
				filteredTotal: m,
				hasFilters: !!(Ne && Ne.filters)
			}), De(u)), z(m), V(Li(m, I)), pe.current = !0, c;
		} catch (t) {
			if (fe.current.delete(e), t.name === "AbortError" || t.name === "CanceledError" || t.code === "ERR_CANCELED") return null;
			let r = "Failed to fetch table data";
			t.code === "ERR_NETWORK" || t.message?.includes("Network Error") ? r = "Cannot connect to data. Please check if the server is running and try again." : t.response ? t.response.status === 404 ? r = `Table "${n}" not found on the server.` : t.response.status === 401 || t.response.status === 403 ? r = "You do not have permission to access this data." : t.response.status >= 500 ? r = "The server encountered an error. Please try again later." : t.response.data?.message && (r = t.response.data.message) : t.message && (r = t.message), Mi.error("Failed to fetch data:", {
				error: r,
				code: t.code,
				isNetworkError: t.code === "ERR_NETWORK"
			}), me.current && ne(r);
			let i = Error(r);
			throw i.name = t.name, i.stack = t.stack, i;
		} finally {
			fe.current.delete(e), de.current = !1, me.current && te(!1);
		}
		return null;
	}, [
		E,
		Ne,
		P,
		I,
		C,
		Fe,
		T,
		Ae,
		l,
		R,
		De,
		ae,
		ge
	]);
	u(() => (me.current = !0, () => {
		me.current = !1, he.current && he.current.abort(), fe.current.clear(), Se.current !== null && clearInterval(Se.current), Object.values(Ce.current || {}).forEach((e) => {
			e && clearTimeout(e);
		}), Ce.current = {};
	}), []), u(() => {
		let t = p && Object.keys(p).length === 0 ? void 0 : p, r = JSON.stringify(t || {});
		if (r === ye.current) return;
		Mi.debug("External filters changed:", {
			filterKeys: t ? Object.keys(t) : [],
			hasFilters: t && Object.keys(t).length > 0,
			filterValues: t
		});
		let i = ve.current;
		ye.current = r, ee(t), ue.current = t, ve.current = t, pe.current && (F(1), Ee && n ? Mi.debug("Filter state changed, forcing immediate fetch", {
			prevFilterCount: i ? Object.keys(i).length : 0,
			newFilterCount: t ? Object.keys(t).length : 0,
			hasActiveFilters: t && Object.keys(t).length > 0
		}) : E && De(je(e, t)));
	}, [
		p,
		Ee,
		n,
		E,
		e,
		De,
		je,
		Ie,
		A,
		M
	]), u(() => {
		if (E && !pe.current) {
			let t = je(e, p);
			De(t);
			let n = l ?? t.length;
			z(n), V(Math.max(1, Math.ceil(n / I))), pe.current = !0;
		}
	}, [
		E,
		e,
		l,
		I,
		De,
		p,
		je
	]), u(() => {
		if (e === void 0 || be.current === e) return;
		be.current = e;
		let t = E ? je(e, p) : e ?? [];
		De(t);
		let n = l ?? t.length;
		z(n), V(Math.max(1, Math.ceil(n / I))), pe.current = !0;
	}, [
		e,
		l,
		I,
		De,
		E,
		je,
		p
	]), u(() => {
		let t = `${Ee ?? ""}:${n ?? ""}`;
		if (t !== we.current) {
			if (we.current = t, pe.current = !1, _e.current = "", E) {
				let t = je(e, p), n = l ?? t.length;
				De(t), z(n), V(Math.max(1, Math.ceil(n / I)));
			} else De([]), z(0), V(1);
			F(o || 1), ne(null);
		}
	}, [
		Ee,
		n,
		o,
		De,
		E,
		p,
		e,
		l,
		I,
		je
	]), u(() => {
		if (!E || !pe.current) return;
		let t = je(e, p), n = l ?? t.length;
		De(t), z(n), V(Math.max(1, Math.ceil(n / I)));
	}, [
		E,
		A,
		M,
		e,
		p,
		l,
		I,
		je,
		De
	]), u(() => {
		if (!E && Ee && n) {
			if (Pe !== ye.current) {
				Mi.debug("Waiting for internal filters to sync before fetching", {
					internalFiltersKey: Pe,
					externalFiltersKey: ye.current
				});
				return;
			}
			let e = Ne ? Pi(Ne) : "";
			if (!e || e === _e.current) return;
			_e.current = e, Ie().catch((e) => {
				e?.code !== "ERR_CANCELED" && e?.name !== "CanceledError" && e?.name !== "AbortError" && Mi.error("Error fetching data after parameter change:", e);
			});
		}
	}, [
		E,
		Ee,
		n,
		Ne,
		Ie,
		Pe
	]), u(() => {
		o !== void 0 && o !== P && F(o);
	}, [o, P]), u(() => {
		let e = `${c ?? "unset"}:${r ?? "unset"}:${Ee ?? "unset"}:${n ?? "unset"}`;
		K.current !== e && (K.current = e, c !== void 0 && c !== I && (L(c), c > 0 && F(1)));
	}, [
		Ee,
		c,
		I,
		r,
		n
	]), u(() => {
		l !== void 0 && l !== R && z(l);
	}, [l, R]), u(() => {
		d !== void 0 && d !== B && V(d);
	}, [d, B]);
	let Le = m(null), Re = m(0), ze = s(() => {
		Le.current &&= (Mi.debug(`Cancelling request: ${Le.current.id}`), Le.current.abortController.abort(), null);
	}, []), Be = s(async (e = "initial") => {
		if (E || !t || !n) return;
		_e.current = "", ze();
		let r = `${e}-${++Re.current}-${Date.now()}`, i = new AbortController();
		Le.current = {
			id: r,
			abortController: i,
			timestamp: Date.now(),
			type: e
		}, Mi.debug(`Starting ${e} data fetch: ${r}`);
		try {
			if (ie(!0), te(!0), ne(null), i.signal.aborted) return;
			let e = {
				limit: I,
				offset: (P - 1) * I,
				sortBy: A || void 0,
				order: M || void 0,
				...typeof C == "number" && Number.isFinite(C) && C > 0 ? { resultLimit: C } : {},
				...w && w.length > 0 ? { columns: w } : {},
				filters: H || {},
				sortOptions: v || [],
				signal: i.signal
			}, a = await T.fetchTableData(t, n, e);
			if (Le.current?.id !== r) {
				Mi.debug(`Request ${r} completed but is no longer current`);
				return;
			}
			if (i.signal.aborted) return;
			if (a?.status === "success" && a.data) {
				let { rows: e = [], metadata: i } = a.data, o = await Ae({
					response: a,
					dbId: String(t),
					tblName: n,
					requestFilters: H,
					requestedPage: P,
					requestedPageSize: I,
					previousTotalRows: l ?? R
				});
				i && typeof i.sampledRows == "number" && (o = i.sampledRows), typeof C == "number" && Number.isFinite(C) && C > 0 && (o = Math.min(o, C)), k(e), z(o), V(Li(o, I)), g?.(e), Mi.debug(`Request ${r} completed successfully: ${e.length} rows`), Le.current = null;
			} else throw Error(a?.errors?.[0]?.message || "Failed to fetch data");
		} catch (e) {
			if (e.name === "AbortError" || e.name === "CanceledError" || e.code === "ERR_CANCELED" || i.signal.aborted) {
				Mi.debug(`Request ${r} was cancelled`);
				return;
			}
			Le.current?.id === r && (Mi.error(`Request ${r} failed:`, e), ne(e.message), Le.current = null);
		} finally {
			me.current && ie(!1), (Le.current?.id === r || !Le.current) && te(!1);
		}
	}, [
		E,
		t,
		n,
		P,
		I,
		C,
		w,
		A,
		M,
		H,
		v,
		g,
		ze,
		T,
		Ae,
		l,
		R
	]);
	return u(() => () => {
		ze();
	}, [ze]), s((e) => {
		let t;
		t = A === e && M === "asc" ? "desc" : "asc", j(e), N(t), F(1), y && y(e, t);
	}, [
		A,
		M,
		y
	]), {
		tableData: O,
		isLoading: U,
		error: W,
		page: P,
		setPage: F,
		pageSize: I,
		setPageSize: L,
		totalRows: R,
		totalPages: B,
		sortBy: A,
		setSortBy: j,
		order: M,
		setOrder: N,
		filters: H,
		setFilters: ee,
		fetchData: Ie,
		refetch: () => Be("initial"),
		isRefetching: re,
		updateTableData: De,
		toggleInfiniteScroll: se,
		loadMoreData: ce,
		hasMoreItems: le,
		setTableData: De,
		_cleanupStaleRequests: Fe
	};
}, zi = (e, t, n) => {
	if ("rowid" in e) return String(e.rowid);
	if (n && n in e) return String(e[n]);
	let r = [
		"id",
		"_id",
		"ID",
		"uuid",
		"guid",
		...Object.keys(e).filter((e) => e.endsWith("_id") || e.endsWith("Id"))
	];
	for (let t of r) if (t in e && e[t] !== void 0 && e[t] !== null) return String(e[t]);
	let i = Object.values(e)[0] || "";
	return `idx-${t}-${String(i).substring(0, 8)}`;
}, Bi = (e, t) => {
	if (!e) return null;
	if ("rowid" in e && e.rowid !== void 0 && e.rowid !== null) return e.rowid;
	if (t && t in e && e[t] !== void 0 && e[t] !== null) return e[t];
	for (let t of [
		"id",
		"_id",
		"ID",
		"uuid",
		"guid"
	]) if (t in e && e[t] !== void 0 && e[t] !== null) return e[t];
	return null;
}, Vi = (e, t) => e == null || t == null ? !1 : String(e) === String(t), Hi = (e, t, n) => e.find((e) => Vi(Bi(e, n), t)), Ui = (e, t) => {
	let [n, r] = h(/* @__PURE__ */ new Set()), i = (e) => Bi(e, t), a = (e) => {
		r((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, o = e.length > 0 && n.size === e.length;
	return {
		selectedRows: n,
		setSelectedRows: r,
		onRowSelect: a,
		isAllSelected: o,
		onToggleSelectAll: () => {
			if (o) r(/* @__PURE__ */ new Set());
			else {
				let n = e.map((e, n) => i(e) ?? zi(e, n, t));
				r(new Set(n));
			}
		}
	};
}, Wi = (e) => {
	let t = e?.minLoadingTime || 500, [n, r] = h(e?.initialOpen || !1), [i, a] = h(null), [o, c] = h(null), [l, d] = h(!1), f = m(null), p = m(null), g = m(0), _ = m(!1);
	return u(() => () => {
		p.current &&= (clearTimeout(p.current), null);
	}, []), {
		statsPanelOpen: n,
		selectedColumn: i,
		statsData: o,
		isLoadingStats: l,
		handleStatsPanelChange: s((e, n, i, o) => {
			g.current++;
			let s = g.current;
			if (console.log("Stats panel change:", {
				isOpen: e,
				column: n,
				hasStats: !!i,
				loading: o,
				changeCount: s
			}), e && _.current) {
				console.log("Blocking reopen attempt after user explicitly closed the panel");
				return;
			}
			if (r(e), n !== void 0 && a(n), o !== void 0) {
				if (o) f.current = Date.now(), d(!0);
				else if (f.current !== null) {
					let e = Date.now() - f.current;
					if (e >= t) d(!1), f.current = null;
					else {
						let n = t - e;
						p.current && clearTimeout(p.current), p.current = setTimeout(() => {
							d(!1), f.current = null, p.current = null, i !== void 0 && c(i);
						}, n);
						return;
					}
				}
			}
			i !== void 0 && c(i);
		}, [t]),
		openStatsPanel: s((e) => {
			if (_.current) {
				console.log("Blocking openStatsPanel call - user explicitly closed the panel");
				return;
			}
			console.log("Opening stats panel for column:", e), a(e), c(null), f.current = Date.now(), d(!0), r(!0), _.current = !1;
		}, []),
		closeStatsPanel: s(() => {
			console.log("Closing stats panel"), _.current = !0, r(!1), p.current &&= (clearTimeout(p.current), null), f.current = null;
		}, [])
	};
}, Gi = [
	{
		id: "first-n",
		name: "First N% Rows",
		description: "Take the first N% of rows"
	},
	{
		id: "last-n",
		name: "Last N% Rows",
		description: "Take the last N% of rows"
	},
	{
		id: "random",
		name: "Random Sample",
		description: "Select random rows from the dataset"
	},
	{
		id: "systematic",
		name: "Systematic Sample",
		description: "Select rows at regular intervals"
	},
	{
		id: "stratified",
		name: "Stratified Sample",
		description: "Maintain proportions based on a column",
		requiresColumn: !0
	},
	{
		id: "weighted",
		name: "Weighted Sample",
		description: "Higher values in column have higher selection probability",
		requiresColumn: !0,
		requiresNumerical: !0
	},
	{
		id: "cluster",
		name: "Cluster Sample",
		description: "Group similar values and sample from each group",
		requiresColumn: !0,
		requiresNumerical: !0
	}
], Ki = (e) => Gi.find((t) => t.id === e) || Gi[0], qi = ({ databaseId: e, tableName: t, columns: n, filters: r, onSampleApplied: i }) => {
	let [a, o] = h(!1), [c, l] = h("random"), [d, p] = h(10), [m, g] = h(n[0]), [_, v] = h(void 0), [y, b] = h([]), x = f(() => Ki(c), [c]);
	u(() => {
		b(n);
	}, [n]), u(() => {
		if (n.length === 0) {
			g(void 0);
			return;
		}
		g((e) => e && n.includes(e) ? e : n[0]);
	}, [n]);
	let S = s(() => {
		o((e) => !e);
	}, []), C = s((e) => {
		let t = Ki(e);
		l(e), t.requiresColumn ? t.requiresNumerical && y.length > 0 ? g(y[0]) : n.length > 0 && g(n[0]) : g(void 0);
	}, [n, y]), w = s(() => {
		i && i([]);
	}, [i]), T = f(() => ({
		isSamplingEnabled: a,
		currentStrategy: x,
		samplePercentage: d,
		selectedColumn: m,
		totalRows: 0,
		sampledRows: 0,
		isLoading: !1,
		error: void 0,
		seed: _
	}), [
		a,
		x,
		d,
		m,
		_
	]), E = s((e) => {
		g(e);
	}, []), D = s((e) => {
		p(Math.max(1, Math.min(100, Math.round(e))));
	}, []);
	return f(() => ({
		samplingState: T,
		toggleSampling: S,
		changeStrategy: C,
		applySampling: w,
		setSelectedColumn: E,
		setSamplePercentage: D,
		setSeed: v,
		samplingStrategies: Gi,
		numericColumns: y,
		columns: n
	}), [
		T,
		S,
		C,
		w,
		E,
		D,
		v,
		y,
		n
	]);
}, Ji = D("reqDedup"), Yi = () => {
	let e = /* @__PURE__ */ new Map();
	return { preventDuplication: (t, n) => {
		if (e.has(t)) return Ji.debug(`Skipping duplicate request: ${t}`), e.get(t);
		let r = n();
		return e.set(t, r), r.finally(() => {
			e.delete(t);
		}), r;
	} };
}, Xi = D("useColumnTypes"), Zi = (e, t, n = [], r) => {
	let [i, a] = h({}), [o, s] = h(!1), [c, l] = h(null), d = m(Yi()), f = m(!0);
	u(() => (f.current = !0, () => {
		f.current = !1;
	}), []);
	let p = async () => {
		if (!e || !t || n.length === 0 || !r) {
			l("Missing required parameters: databaseId, tableName, or columns");
			return;
		}
		try {
			s(!0), l(null);
			let n = await d.current.preventDuplication(`column-types-${e}-${t}`, () => r.fetchColumnTypes(e, t));
			if (!f.current) return;
			a(n || {}), Xi.debug(`Inferred column types for ${Object.keys(n || {}).length} columns`, {
				databaseId: e,
				tableName: t,
				resultTypes: n
			});
		} catch (e) {
			if (f.current) {
				let t = "Failed to infer column types";
				Xi.error("Failed to infer column types:", {
					error: t,
					code: e.code,
					isNetworkError: e.code === "ERR_NETWORK"
				}), l(t), a({});
			}
		} finally {
			f.current && s(!1);
		}
	};
	return u(() => {
		p();
	}, [
		e,
		t,
		n.length,
		r
	]), {
		columnTypes: i,
		isLoading: o,
		error: c,
		refreshTypes: p
	};
}, Qi = D("useViewModal"), $i = ({ databaseId: e, tableName: t, idField: n, onDataRefresh: r, provider: i }) => {
	let [a, o] = h(!1), [c, l] = h(null), [u, d] = h("view"), [f, p] = h("View Row Details"), g = m(null), _ = s((e, t = "view", n) => {
		l(e), d(t), p(n || (t === "edit" ? "Edit Row" : t === "create" ? "Create New Record" : "View Row Details")), o(!0), g.current = null;
	}, []), v = s(() => {
		o(!1), setTimeout(() => {
			l(null), d("view"), p("View Row Details");
		}, 300);
	}, []), y = s(async (n) => {
		if (!e || !t) return Qi.error("Cannot fetch row: missing databaseId or tableName"), null;
		try {
			Qi.debug(`Fetching row ${n} from API`);
			let r = await i?.fetchRecord(e, t, n);
			return r ? (Qi.debug(`Successfully fetched row ${n} from API`), r) : (Qi.warn(`API returned no data for row ${n}`), null);
		} catch (e) {
			return Qi.error(`Failed to fetch row ${n} from API:`, e), null;
		}
	}, [
		e,
		t,
		i
	]);
	return {
		viewModalOpen: a,
		selectedRow: c,
		viewModalMode: u,
		viewModalTitle: f,
		openViewModal: _,
		closeViewModal: v,
		handleRowSave: async (a) => {
			try {
				if (!e || !t) {
					Qi.error("Missing required parameters for save operation");
					return;
				}
				if (u === "create") {
					Qi.debug("Creating new record", { tableName: t });
					let n = await i?.createRecord(e, t, a);
					Qi.debug("Successfully created new record", { response: n });
				} else {
					let r = Bi(a, n);
					if (r == null) throw Qi.error("Missing ID field for update operation"), Error("Missing ID field for update operation");
					await i?.updateRecord(e, t, r, a), Qi.debug(`Successfully updated row with ID ${r}`);
				}
				l(a), typeof r == "function" && r();
			} catch (e) {
				throw Qi.error(`Error ${u === "create" ? "creating" : "saving"} row data:`, e), e;
			}
		},
		findAndOpenRow: s(async (r, i, a) => {
			Qi.debug(`Finding and opening row with ID: ${r} in ${i} mode`);
			let o = Hi(a, r, n);
			if (o) {
				Qi.debug(`Found row ${r} in current data`), _(o, i, i === "edit" ? "Edit Row" : "View Row Details");
				return;
			}
			if (e && t) {
				Qi.debug(`Row ${r} not found in current data, fetching from API...`);
				let e = await y(r);
				if (e) {
					Qi.debug(`Successfully retrieved row ${r} from API`), _(e, i, i === "edit" ? "Edit Row" : "View Row Details");
					return;
				}
			}
			Qi.error(`Could not find row with id ${r} in current data or API`), g.current = {
				id: r,
				mode: i
			};
		}, [
			n,
			_,
			e,
			t,
			y
		]),
		checkPendingRowLookup: s((e) => {}, [])
	};
}, ea = D("useFilterManagement"), ta = ({ externalApplyFilter: e, externalClearFilter: t, initialFilters: n = {}, onFiltersChange: r }) => {
	let [i, a] = h(n), o = m(JSON.stringify(n || {})), c = m(!1), l = m(/* @__PURE__ */ new Set()), d = m(null), f = m(""), p = m(!1), g = s((e) => {
		let t = JSON.stringify(e);
		t !== f.current && (d.current && clearTimeout(d.current), d.current = setTimeout(() => {
			f.current = t, r?.(e), p.current = !1, ea.debug("Batched filter change notification sent", {
				filters: e,
				shouldRefresh: p.current
			});
		}, 5));
	}, [r]), _ = s((t, n) => {
		if (ea.debug("Applying filter:", {
			column: t,
			filterValue: n
		}), l.current.add(t), p.current = !0, a((e) => {
			l.current.has(t) && l.current.size > 1 && ea.debug("Filter update in progress for column, queueing...", t);
			let r = { ...e }, i;
			if (Array.isArray(n)) i = n.filter((e) => e != null);
			else if (typeof n == "object" && n) {
				let e = Object.keys(n);
				e.every((e) => !isNaN(parseInt(e)) && parseInt(e).toString() === e) && e.length > 0 ? (i = e.map((e) => n[e]).filter((e) => e != null), ea.debug("Converted object-like array to proper array:", {
					column: t,
					before: n,
					after: i
				})) : i = { ...n };
			} else i = n;
			if (JSON.stringify(r[t]) === JSON.stringify(i)) return l.current.delete(t), r;
			let a = {
				...r,
				[t]: i
			};
			return ea.debug("Filter applied locally:", {
				column: t,
				value: i
			}), l.current.delete(t), g(a), a;
		}), c.current = !0, e) try {
			e(t, n);
		} catch (e) {
			ea.error("External apply filter failed:", e), l.current.delete(t);
		}
	}, [e, g]), v = s((e) => {
		if (ea.debug("Clearing filter for column:", e), l.current.add(e), p.current = !0, a((t) => {
			let n = { ...t };
			if (!(e in n)) return l.current.delete(e), n;
			let r = { ...n };
			return delete r[e], ea.debug("Filter cleared locally:", e), l.current.delete(e), g(r), r;
		}), t) try {
			t(e);
		} catch (t) {
			ea.error("External clear filter failed:", t), l.current.delete(e);
		}
	}, [t, g]);
	return u(() => () => {
		d.current && clearTimeout(d.current);
	}, []), u(() => {
		let e = JSON.stringify(n || {});
		e !== o.current && (o.current = e, a(n));
	}, [n]), {
		effectiveFilters: i,
		handleApplyFilter: _,
		handleClearFilter: v,
		shouldRefreshImmediately: p.current
	};
}, na = (e, t, n = "table_export.csv", r = {}) => {
	if (!e || e.length === 0) {
		console.warn("No data to export");
		return;
	}
	let i = r.delimiter || ",", a = r.includeHeaders !== !1, o = r.nullValue || "", s = t || Object.keys(e[0] || {}), c = (e, t) => {
		if (r.processCell) return r.processCell(e, t);
		if (e == null) return o;
		if (typeof e == "object") {
			if (Array.isArray(e)) return `"${e.join("; ")}"`;
			if (e instanceof Date) return r.dateFormat ? `"${e.toLocaleDateString(void 0, { dateStyle: "short" })}"` : `"${e.toISOString()}"`;
			try {
				return `"${JSON.stringify(e).replace(/"/g, "\"\"")}"`;
			} catch {
				return "\"[Complex Object]\"";
			}
		}
		let n = String(e);
		return n.includes(i) || n.includes("\"") || n.includes("\n") ? `"${n.replace(/"/g, "\"\"")}"` : n;
	};
	try {
		let t = "";
		t = "﻿", a && (t += s.map((e) => c(e, e)).join(i) + "\n"), t += e.map((e) => s.map((t) => c(e[t], t)).join(i)).join("\n");
		let r = new Blob([t], { type: "text/csv;charset=utf-8;" }), o = document.createElement("a"), l = URL.createObjectURL(r);
		return o.setAttribute("href", l), o.setAttribute("download", n), o.style.visibility = "hidden", document.body.appendChild(o), o.click(), document.body.removeChild(o), URL.revokeObjectURL(l), !0;
	} catch (e) {
		return console.error("Error exporting to CSV:", e), !1;
	}
}, ra = D("useExport"), ia = ({ databaseId: e, tableName: t, data: n, columns: r, filters: i = {}, customFileName: a }) => {
	let [o, c] = h(!1);
	return {
		handleExport: s(async () => {
			c(!0);
			try {
				na(n, r, `${a || t || "data"}_export_${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.csv`, {
					delimiter: ",",
					includeHeaders: !0,
					dateFormat: "short"
				});
			} catch (e) {
				ra.error("Export operation failed:", e);
			} finally {
				c(!1);
			}
		}, [
			r,
			a,
			n,
			t
		]),
		exportSingleRow: s((e, i) => {
			c(!0);
			try {
				let o = i ?? n.find((t) => "rowid" in t && t.rowid === e || t.id === e);
				if (!o) {
					ra.error(`Could not find row with ID ${e} for export`);
					return;
				}
				na([o], r, `${a || t || "row"}_${e}_export_${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.csv`);
			} catch (t) {
				ra.error(`Error exporting row ${e}:`, t);
			} finally {
				c(!1);
			}
		}, [
			r,
			a,
			n,
			t
		]),
		exportMultipleRows: s((e) => {
			c(!0);
			try {
				if (!e.length) {
					ra.warn("No row IDs provided for multiple export");
					return;
				}
				let i = n.filter((t) => {
					let n = "rowid" in t ? t.rowid : t.id;
					return n !== void 0 && e.includes(n);
				});
				if (i.length === 0) {
					ra.error(`Could not find any rows matching IDs: ${e.join(", ")}`);
					return;
				}
				na(i, r, `${a || t || "rows"}_export_${e.length}_items_${(/* @__PURE__ */ new Date()).toISOString().slice(0, 10)}.csv`, {
					delimiter: ",",
					includeHeaders: !0,
					dateFormat: "short"
				});
			} catch (e) {
				ra.error("Error exporting multiple rows:", e);
			} finally {
				c(!1);
			}
		}, [
			r,
			a,
			n,
			t
		]),
		isExporting: o
	};
}, $ = /* @__PURE__ */ function(e) {
	return e.VIEW = "view", e.EDIT = "edit", e.DELETE = "delete", e.SELECT = "select", e.EXPORT = "export", e.CREATE = "create", e.THEME = "theme", e;
}({}), aa = {
	internal: {
		canCreate: !0,
		canEdit: !0,
		canDelete: !0,
		canExport: !0,
		canRunStats: !0
	},
	metadata: {
		canCreate: !1,
		canEdit: !1,
		canDelete: !1,
		canExport: !0,
		canRunStats: !1
	},
	external_pg: {
		canCreate: !1,
		canEdit: !1,
		canDelete: !1,
		canExport: !0,
		canRunStats: !1
	},
	json: {
		canCreate: !1,
		canEdit: !1,
		canDelete: !1,
		canExport: !0,
		canRunStats: !0
	}
}, oa = /* @__PURE__ */ function(e) {
	return e.SELECT = "select", e.VIEW = "view", e.EDIT = "edit", e.DELETE = "delete", e.CREATE = "create", e.EXPORT = "export", e.FILTER = "filter", e.THEME = "theme", e.SAMPLE = "sample", e;
}({}), sa = D("useActionHandlers"), ca = ({ externalHandlers: e, databaseId: t, tableName: n, onOpenViewModal: r, onFindAndOpenRow: i, onExportRow: a, onDataRefresh: o, effectiveData: c, idField: l }) => {
	s((e) => {
		let t = Hi(c, e, l);
		return t || sa.warn(`Row with ID ${e} not found in current dataset (${c.length} rows)`), t;
	}, [c, l]);
	let u = {
		onView: s((e, t) => {}, []),
		onEdit: s((e, t) => {}, []),
		onThemeChange: s((e) => {}, []),
		onCreate: s(() => {}, []),
		onDelete: s(async (e) => {}, []),
		onExport: s((e) => {}, [])
	}, d = Object.fromEntries(Object.values(oa).map((t) => {
		let n = `on${t.charAt(0).toUpperCase() + t.slice(1)}`;
		return [n, e[n] || u[n]];
	}));
	return {
		...e,
		...d
	};
}, la = D("useDatabaseInfo");
function ua(e) {
	return e?.data?.data ?? e?.data ?? e ?? null;
}
var da = (e, t, n) => {
	let [r, i] = h(""), [a, o] = h(null), [c, l] = h(!1), [d, f] = h(null), p = m(Yi()), g = m(!0), _ = m(e);
	return u(() => (g.current = !0, () => {
		g.current = !1;
	}), []), u(() => {
		_.current !== e && (_.current = e, i(""), o(null), f(null), l(!1));
	}, [e]), {
		originalFileName: r,
		databaseInfo: a,
		isLoading: c,
		error: d,
		loadDatabaseInfo: s(async () => {
			if (!(!e || !t || c || a)) try {
				l(!0), f(null);
				let r = await p.current.preventDuplication(`db-info-${e}`, () => t.fetchDatabaseInfo(e));
				if (!g.current) return;
				let a = ua(r), s = a;
				if (n?.enhanceDatabaseInfo) {
					let r = await n.enhanceDatabaseInfo({
						databaseId: e,
						provider: t,
						databaseInfo: a
					});
					s = {
						...a ?? {},
						...r ?? {}
					};
				}
				o(s);
				let c = s?.original_file_name;
				c ? (i(c || ""), la.debug(`Fetched file name: ${c}`)) : la.warn("No original file name found in database info");
			} catch (e) {
				g.current && (la.error("Failed to fetch database info:", e), f(e.message || "Failed to fetch database info"));
			} finally {
				g.current && l(!1);
			}
		}, [
			n,
			e,
			t,
			c,
			a
		])
	};
};
//#endregion
//#region src/hooks/useVendorAudit.ts
function fa(e) {
	return e.length === 0 ? null : e.some((e) => !e.passed) ? "FAIL" : e.some((e) => e.warned) ? "WARN" : "PASS";
}
function pa(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) {
		let e = n.rule.column_name;
		if (!e) continue;
		let r = n.passed ? n.warned ? "WARN" : "PASS" : "FAIL", i = t.get(e);
		i !== "FAIL" && (i === "WARN" && r === "PASS" || t.set(e, r));
	}
	return Object.fromEntries(t.entries());
}
function ma(e) {
	if (typeof e == "number") return Number.isFinite(e) && e > 0;
	if (typeof e != "string") return !1;
	let t = e.trim();
	return /^\d+$/.test(t) && Number(t) > 0;
}
function ha(e, t, n) {
	let [r, i] = h([]), [a, o] = h([]), [c, l] = h(!1), [d, p] = h(null), m = !!n && ma(e), g = s(async () => {
		if (!n || !ma(e)) {
			i([]), o([]), p(null), l(!1);
			return;
		}
		l(!0), p(null);
		try {
			let [r, a] = await Promise.all([n.listSlaRules(e, t), n.listAuditReports(e, 12)]);
			i(r), o(a);
		} catch (e) {
			p(e?.message || "Unable to load vendor audit data");
		} finally {
			l(!1);
		}
	}, [
		n,
		e,
		m,
		t
	]);
	u(() => {
		g();
	}, [g]);
	let _ = f(() => a.find((e) => e.format === "json" && typeof e.json_blob == "string") ?? null, [a]), v = f(() => a.find((e) => e.format === "pdf") ?? null, [a]), y = f(() => n?.parseSummary(_) ?? null, [n, _]), b = f(() => {
		let e = y?.results ?? [];
		return t ? e.filter((e) => e.rule.table_name === t) : e;
	}, [y, t]), x = f(() => pa(b), [b]), S = f(() => fa(b), [b]), C = s(async (t) => {
		!n || !ma(e) || await n.downloadAuditReport(e, t);
	}, [
		n,
		e,
		m
	]), w = s(async (t) => {
		if (!n || !ma(e)) return null;
		l(!0), p(null);
		try {
			let r = await n.generateAuditReport(e, t);
			return await g(), r;
		} catch (e) {
			return p(e?.message || `Unable to generate ${t.toUpperCase()} audit report`), null;
		} finally {
			l(!1);
		}
	}, [
		n,
		e,
		g,
		m
	]);
	return {
		hasActiveRules: r.length > 0,
		activeRuleCount: r.length,
		latestSummary: y,
		latestJsonReport: _,
		latestPdfReport: v,
		columnStatusMap: x,
		tableGrade: S,
		reports: a,
		loading: c,
		error: d,
		refresh: g,
		generateReport: w,
		downloadReport: C
	};
}
//#endregion
//#region src/hooks/useBulkActions.ts
var ga = D("useBulkActions"), _a = ({ databaseId: e, tableName: t, onDataRefresh: n, onExternalBulkDelete: r, onSelectionClear: i, provider: a }) => ({ onBulkAction: s(async (o, s) => {
	switch (ga.info(`Processing bulk action: ${o} for ${s.size} rows`), o) {
		case "delete": {
			if (s.size === 0) return;
			let o = Array.from(s);
			if (r) await r(o);
			else if (e && t && a) await a.bulkDeleteRecords(e, t, o);
			else throw Error("Cannot delete: missing database context or bulk delete handler");
			n(), i();
			break;
		}
		case "filter":
			ga.info("Filter action is handled through the filters UI");
			break;
		default:
			ga.info(`Unsupported bulk action: ${o}`);
			break;
	}
}, [
	e,
	n,
	r,
	i,
	a,
	t
]) }), va = typeof D == "function" ? D("useTableHandlers") : console, ya = ({ sortBy: e, setSortBy: t, order: n, setOrder: r, externalHandleSort: i, page: a, setPage: o, pageSize: c, setPageSize: l, externalHandlePageChange: u, externalHandlePageSizeChange: d, effectiveFilters: f, handleClearFilter: p, selectedRows: m, onBulkAction: h, handleExport: g, exportSingleRow: _, exportMultipleRows: v, isInfiniteScroll: y = !1, setTableData: b, setLoadedPages: x, setHasMoreItems: S }) => ({
	handleSort: s((a) => {
		if (i) i(a);
		else {
			if (y && b && (b([]), x && x(1), S && S(!0)), e === a) {
				let e = n === "asc" ? "desc" : "asc";
				r(e), va.debug(`Sorting by ${a} in ${e} order`);
			} else t(a), r("asc"), va.debug(`Sorting new ${a} in asc order`);
			o(1);
		}
	}, [
		i,
		y,
		b,
		x,
		S,
		e,
		n,
		r,
		t,
		o
	]),
	handlePageChange: s((e) => {
		va.debug("Page change requested:", e, "current page:", a), u ? u(e) : e !== a && o(e);
	}, [
		u,
		a,
		o
	]),
	handlePageSizeChange: s((e) => {
		let t;
		t = typeof e == "number" ? e : Number(e.target.value), va.debug("Page size change requested:", t, "current size:", c), d && typeof e != "number" ? d(e) : t !== c && (l(t), o(1));
	}, [
		d,
		c,
		l,
		o
	]),
	handleBulkAction: s(async (e) => {
		m.size > 0 && (e === "export" && v ? (va.debug(`Exporting ${m.size} rows as a single file`), v(Array.from(m))) : await h(e, m));
	}, [
		m,
		v,
		h
	]),
	handleClearAllFilters: s(() => {
		va.debug("Clearing all filters"), Object.keys(f || {}).forEach((e) => {
			p(e);
		});
	}, [f, p]),
	handleExport: g,
	exportSingleRow: _
});
//#endregion
//#region src/hooks/useDatagridController.ts
function ba(e) {
	if (!(e == null || e === "")) return typeof e == "number" ? `${e}px` : e;
}
function xa({ mode: e, data: t, databaseId: n, tableName: r, queryColumns: i }) {
	let a = e === "controlled" || e === void 0 && t !== void 0, o = f(() => (i ?? []).filter((e) => e.trim().length > 0), [i]);
	return {
		isControlledMode: a,
		controlledData: a ? t ?? [] : void 0,
		providerDatabaseId: a ? void 0 : n,
		providerTableName: a ? void 0 : r,
		displayDatabaseId: n,
		displayTableName: r ?? (a ? "controlled-data" : ""),
		hasExternalData: a,
		normalizedQueryColumns: o
	};
}
function Sa({ hasExternalData: e, controlledData: t, internalData: n, externalColumns: r, internalColumns: i, externalSortBy: a, externalOrder: o, externalPage: s, externalPageSize: c, externalTotalRows: l, internalTotalRows: u, resultLimit: d, externalTotalPages: p, layoutOptions: m }) {
	return f(() => {
		let f = r.length > 0 ? r : i;
		return {
			data: e ? t ?? [] : n,
			columns: f,
			sortBy: a,
			order: o,
			page: s,
			pageSize: c,
			totalRows: l ?? u,
			resultLimit: d,
			totalPages: p,
			maxHeight: ba(m?.maxHeight) ?? "100%",
			minHeight: ba(m?.minHeight),
			heightMode: m?.heightMode ?? "fill",
			isStatsPanelInitiallyOpen: m?.isStatsPanelOpen || !1,
			isExternallyControlled: e,
			enableHorizontalScroll: f.length > 10
		};
	}, [
		e,
		t,
		n,
		r,
		i,
		a,
		o,
		s,
		c,
		l,
		u,
		d,
		p,
		m
	]);
}
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/AdjustmentsHorizontalIcon.js
function Ca({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75"
	}));
}
var wa = /*#__PURE__*/ t.forwardRef(Ca);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowDownCircleIcon.js
function Ta({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var Ea = /*#__PURE__*/ t.forwardRef(Ta);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowDownTrayIcon.js
function Da({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3"
	}));
}
var Oa = /*#__PURE__*/ t.forwardRef(Da);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowLeftIcon.js
function ka({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18"
	}));
}
var Aa = /*#__PURE__*/ t.forwardRef(ka);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowPathIcon.js
function ja({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
	}));
}
var Ma = /*#__PURE__*/ t.forwardRef(ja);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowRightIcon.js
function Na({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M13.5 4.5 21 12m0 0-7.5 7.5M21 12H3"
	}));
}
var Pa = /*#__PURE__*/ t.forwardRef(Na);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowUpCircleIcon.js
function Fa({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var Ia = /*#__PURE__*/ t.forwardRef(Fa);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowsPointingInIcon.js
function La({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 9V4.5M9 9H4.5M9 9 3.75 3.75M9 15v4.5M9 15H4.5M9 15l-5.25 5.25M15 9h4.5M15 9V4.5M15 9l5.25-5.25M15 15h4.5M15 15v4.5m0-4.5 5.25 5.25"
	}));
}
var Ra = /*#__PURE__*/ t.forwardRef(La);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowsPointingOutIcon.js
function za({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.75 3.75v4.5m0-4.5h4.5m-4.5 0L9 9M3.75 20.25v-4.5m0 4.5h4.5m-4.5 0L9 15M20.25 3.75h-4.5m4.5 0v4.5m0-4.5L15 9m5.25 11.25h-4.5m4.5 0v-4.5m0 4.5L15 15"
	}));
}
var Ba = /*#__PURE__*/ t.forwardRef(za);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ArrowsRightLeftIcon.js
function Va({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5"
	}));
}
var Ha = /*#__PURE__*/ t.forwardRef(Va);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/BeakerIcon.js
function Ua({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5"
	}));
}
var Wa = /*#__PURE__*/ t.forwardRef(Ua);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/BoltIcon.js
function Ga({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z"
	}));
}
var Ka = /*#__PURE__*/ t.forwardRef(Ga);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/BookmarkSlashIcon.js
function qa({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m3 3 1.664 1.664M21 21l-1.5-1.5m-5.485-1.242L12 17.25 4.5 21V8.742m.164-4.078a2.15 2.15 0 0 1 1.743-1.342 48.507 48.507 0 0 1 11.186 0c1.1.128 1.907 1.077 1.907 2.185V19.5M4.664 4.664 19.5 19.5"
	}));
}
var Ja = /*#__PURE__*/ t.forwardRef(qa);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/BookmarkSquareIcon.js
function Ya({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M16.5 3.75V16.5L12 14.25 7.5 16.5V3.75m9 0H18A2.25 2.25 0 0 1 20.25 6v12A2.25 2.25 0 0 1 18 20.25H6A2.25 2.25 0 0 1 3.75 18V6A2.25 2.25 0 0 1 6 3.75h1.5m9 0h-9"
	}));
}
var Xa = /*#__PURE__*/ t.forwardRef(Ya);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/BookmarkIcon.js
function Za({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M17.593 3.322c1.1.128 1.907 1.077 1.907 2.185V21L12 17.25 4.5 21V5.507c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0 1 11.186 0Z"
	}));
}
var Qa = /*#__PURE__*/ t.forwardRef(Za);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/CalendarDaysIcon.js
function $a({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z"
	}));
}
var eo = /*#__PURE__*/ t.forwardRef($a);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/CalendarIcon.js
function to({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5"
	}));
}
var no = /*#__PURE__*/ t.forwardRef(to);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ChartBarIcon.js
function ro({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 0 1 3 19.875v-6.75ZM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V8.625ZM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.125Z"
	}));
}
var io = /*#__PURE__*/ t.forwardRef(ro);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/CheckCircleIcon.js
function ao({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var oo = /*#__PURE__*/ t.forwardRef(ao);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ChevronDoubleRightIcon.js
function so({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5"
	}));
}
var co = /*#__PURE__*/ t.forwardRef(so);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ChevronDownIcon.js
function lo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m19.5 8.25-7.5 7.5-7.5-7.5"
	}));
}
var uo = /*#__PURE__*/ t.forwardRef(lo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ChevronLeftIcon.js
function fo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15.75 19.5 8.25 12l7.5-7.5"
	}));
}
var po = /*#__PURE__*/ t.forwardRef(fo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js
function mo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m8.25 4.5 7.5 7.5-7.5 7.5"
	}));
}
var ho = /*#__PURE__*/ t.forwardRef(mo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ClipboardDocumentListIcon.js
function go({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
	}));
}
var _o = /*#__PURE__*/ t.forwardRef(go);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/CubeTransparentIcon.js
function vo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 7.5-2.25-1.313M21 7.5v2.25m0-2.25-2.25 1.313M3 7.5l2.25-1.313M3 7.5l2.25 1.313M3 7.5v2.25m9 3 2.25-1.313M12 12.75l-2.25-1.313M12 12.75V15m0 6.75 2.25-1.313M12 21.75V19.5m0 2.25-2.25-1.313m0-16.875L12 2.25l2.25 1.313M21 14.25v2.25l-2.25 1.313m-13.5 0L3 16.5v-2.25"
	}));
}
var yo = /*#__PURE__*/ t.forwardRef(vo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/CursorArrowRaysIcon.js
function bo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15.042 21.672 13.684 16.6m0 0-2.51 2.225.569-9.47 5.227 7.917-3.286-.672ZM12 2.25V4.5m5.834.166-1.591 1.591M20.25 10.5H18M7.757 14.743l-1.59 1.59M6 10.5H3.75m4.007-4.243-1.59-1.59"
	}));
}
var xo = /*#__PURE__*/ t.forwardRef(bo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/DocumentArrowDownIcon.js
function So({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
	}));
}
var Co = /*#__PURE__*/ t.forwardRef(So);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/DocumentDuplicateIcon.js
function wo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 0 1-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 0 1 1.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 0 0-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 0 1-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 0 0-3.375-3.375h-1.5a1.125 1.125 0 0 1-1.125-1.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H9.75"
	}));
}
var To = /*#__PURE__*/ t.forwardRef(wo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/DocumentTextIcon.js
function Eo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
	}));
}
var Do = /*#__PURE__*/ t.forwardRef(Eo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/EllipsisVerticalIcon.js
function Oo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 6.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 12.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM12 18.75a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5Z"
	}));
}
var ko = /*#__PURE__*/ t.forwardRef(Oo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ExclamationCircleIcon.js
function Ao({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
	}));
}
var jo = /*#__PURE__*/ t.forwardRef(Ao);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ExclamationTriangleIcon.js
function Mo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
	}));
}
var No = /*#__PURE__*/ t.forwardRef(Mo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/EyeIcon.js
function Po({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
	}), /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
	}));
}
var Fo = /*#__PURE__*/ t.forwardRef(Po);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/FunnelIcon.js
function Io({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
	}));
}
var Lo = /*#__PURE__*/ t.forwardRef(Io);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/HashtagIcon.js
function Ro({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M5.25 8.25h15m-16.5 7.5h15m-1.8-13.5-3.9 19.5m-2.1-19.5-3.9 19.5"
	}));
}
var zo = /*#__PURE__*/ t.forwardRef(Ro);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/IdentificationIcon.js
function Bo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 0 0 2.25-2.25V6.75A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25v10.5A2.25 2.25 0 0 0 4.5 19.5Zm6-10.125a1.875 1.875 0 1 1-3.75 0 1.875 1.875 0 0 1 3.75 0Zm1.294 6.336a6.721 6.721 0 0 1-3.17.789 6.721 6.721 0 0 1-3.168-.789 3.376 3.376 0 0 1 6.338 0Z"
	}));
}
var Vo = /*#__PURE__*/ t.forwardRef(Bo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/InformationCircleIcon.js
function Ho({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z"
	}));
}
var Uo = /*#__PURE__*/ t.forwardRef(Ho);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/MagnifyingGlassIcon.js
function Wo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
	}));
}
var Go = /*#__PURE__*/ t.forwardRef(Wo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/MinusIcon.js
function Ko({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M5 12h14"
	}));
}
var qo = /*#__PURE__*/ t.forwardRef(Ko);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/PaperAirplaneIcon.js
function Jo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
	}));
}
var Yo = /*#__PURE__*/ t.forwardRef(Jo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/PencilIcon.js
function Xo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
	}));
}
var Zo = /*#__PURE__*/ t.forwardRef(Xo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/PlayIcon.js
function Qo({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.347a1.125 1.125 0 0 1 0 1.972l-11.54 6.347a1.125 1.125 0 0 1-1.667-.986V5.653Z"
	}));
}
var $o = /*#__PURE__*/ t.forwardRef(Qo);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/PlusCircleIcon.js
function es({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 9v6m3-3H9m12 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var ts = /*#__PURE__*/ t.forwardRef(es);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/PlusIcon.js
function ns({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M12 4.5v15m7.5-7.5h-15"
	}));
}
var rs = /*#__PURE__*/ t.forwardRef(ns);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/QueueListIcon.js
function is({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.75 12h16.5m-16.5 3.75h16.5M3.75 19.5h16.5M5.625 4.5h12.75a1.875 1.875 0 0 1 0 3.75H5.625a1.875 1.875 0 0 1 0-3.75Z"
	}));
}
var as = /*#__PURE__*/ t.forwardRef(is);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ShieldCheckIcon.js
function os({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 12.75 11.25 15 15 9.75m-3-7.036A11.959 11.959 0 0 1 3.598 6 11.99 11.99 0 0 0 3 9.749c0 5.592 3.824 10.29 9 11.623 5.176-1.332 9-6.03 9-11.622 0-1.31-.21-2.571-.598-3.751h-.152c-3.196 0-6.1-1.248-8.25-3.285Z"
	}));
}
var ss = /*#__PURE__*/ t.forwardRef(os);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/Squares2X2Icon.js
function cs({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.75 6A2.25 2.25 0 0 1 6 3.75h2.25A2.25 2.25 0 0 1 10.5 6v2.25a2.25 2.25 0 0 1-2.25 2.25H6a2.25 2.25 0 0 1-2.25-2.25V6ZM3.75 15.75A2.25 2.25 0 0 1 6 13.5h2.25a2.25 2.25 0 0 1 2.25 2.25V18a2.25 2.25 0 0 1-2.25 2.25H6A2.25 2.25 0 0 1 3.75 18v-2.25ZM13.5 6a2.25 2.25 0 0 1 2.25-2.25H18A2.25 2.25 0 0 1 20.25 6v2.25A2.25 2.25 0 0 1 18 10.5h-2.25a2.25 2.25 0 0 1-2.25-2.25V6ZM13.5 15.75a2.25 2.25 0 0 1 2.25-2.25H18a2.25 2.25 0 0 1 2.25 2.25V18A2.25 2.25 0 0 1 18 20.25h-2.25A2.25 2.25 0 0 1 13.5 18v-2.25Z"
	}));
}
var ls = /*#__PURE__*/ t.forwardRef(cs);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/SwatchIcon.js
function us({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M4.098 19.902a3.75 3.75 0 0 0 5.304 0l6.401-6.402M6.75 21A3.75 3.75 0 0 1 3 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 0 0 3.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008Z"
	}));
}
var ds = /*#__PURE__*/ t.forwardRef(us);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/TableCellsIcon.js
function fs({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 0 1-1.125-1.125M3.375 19.5h7.5c.621 0 1.125-.504 1.125-1.125m-9.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-7.5A1.125 1.125 0 0 1 12 18.375m9.75-12.75c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125m19.5 0v1.5c0 .621-.504 1.125-1.125 1.125M2.25 5.625v1.5c0 .621.504 1.125 1.125 1.125m0 0h17.25m-17.25 0h7.5c.621 0 1.125.504 1.125 1.125M3.375 8.25c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m17.25-3.75h-7.5c-.621 0-1.125.504-1.125 1.125m8.625-1.125c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M12 10.875v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125M13.125 12h7.5m-7.5 0c-.621 0-1.125.504-1.125 1.125M20.625 12c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h7.5M12 14.625v-1.5m0 1.5c0 .621-.504 1.125-1.125 1.125M12 14.625c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m0 1.5v-1.5m0 0c0-.621.504-1.125 1.125-1.125m0 0h7.5"
	}));
}
var ps = /*#__PURE__*/ t.forwardRef(fs);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/TrashIcon.js
function ms({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m14.74 9-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 0 1-2.244 2.077H8.084a2.25 2.25 0 0 1-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 0 0-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 0 1 3.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 0 0-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 0 0-7.5 0"
	}));
}
var hs = /*#__PURE__*/ t.forwardRef(ms);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/ViewColumnsIcon.js
function gs({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M9 4.5v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.625c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.5 3 5.004 3 5.625v12.75c0 .621.504 1.125 1.125 1.125Z"
	}));
}
var _s = /*#__PURE__*/ t.forwardRef(gs);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/XCircleIcon.js
function vs({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
	}));
}
var ys = /*#__PURE__*/ t.forwardRef(vs);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/outline/esm/XMarkIcon.js
function bs({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		fill: "none",
		viewBox: "0 0 24 24",
		strokeWidth: 1.5,
		stroke: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M6 18 18 6M6 6l12 12"
	}));
}
var xs = /*#__PURE__*/ t.forwardRef(bs), Ss = ({ width: e = "96px", height: t = "48px", message: n = "Loading data...", className: r = "" }) => /* @__PURE__ */ v("div", {
	className: `flex flex-col items-center ${r}`,
	children: [/* @__PURE__ */ v("div", {
		className: "water-wave-container",
		style: {
			width: e,
			height: t
		},
		children: [
			/* @__PURE__ */ _("div", { className: "water-wave water-wave-1" }),
			/* @__PURE__ */ _("div", { className: "water-wave water-wave-2" }),
			/* @__PURE__ */ _("div", { className: "water-wave water-wave-3" })
		]
	}), n && /* @__PURE__ */ _("span", {
		className: "text-sm text-primary",
		children: n
	})]
});
//#endregion
//#region ../node_modules/.pnpm/@kurkle+color@0.3.4/node_modules/@kurkle/color/dist/color.esm.js
function Cs(e) {
	return e + .5 | 0;
}
var ws = (e, t, n) => Math.max(Math.min(e, n), t);
function Ts(e) {
	return ws(Cs(e * 2.55), 0, 255);
}
function Es(e) {
	return ws(Cs(e * 255), 0, 255);
}
function Ds(e) {
	return ws(Cs(e / 2.55) / 100, 0, 1);
}
function Os(e) {
	return ws(Cs(e * 100), 0, 100);
}
var ks = {
	0: 0,
	1: 1,
	2: 2,
	3: 3,
	4: 4,
	5: 5,
	6: 6,
	7: 7,
	8: 8,
	9: 9,
	A: 10,
	B: 11,
	C: 12,
	D: 13,
	E: 14,
	F: 15,
	a: 10,
	b: 11,
	c: 12,
	d: 13,
	e: 14,
	f: 15
}, As = [..."0123456789ABCDEF"], js = (e) => As[e & 15], Ms = (e) => As[(e & 240) >> 4] + As[e & 15], Ns = (e) => (e & 240) >> 4 == (e & 15), Ps = (e) => Ns(e.r) && Ns(e.g) && Ns(e.b) && Ns(e.a);
function Fs(e) {
	var t = e.length, n;
	return e[0] === "#" && (t === 4 || t === 5 ? n = {
		r: 255 & ks[e[1]] * 17,
		g: 255 & ks[e[2]] * 17,
		b: 255 & ks[e[3]] * 17,
		a: t === 5 ? ks[e[4]] * 17 : 255
	} : (t === 7 || t === 9) && (n = {
		r: ks[e[1]] << 4 | ks[e[2]],
		g: ks[e[3]] << 4 | ks[e[4]],
		b: ks[e[5]] << 4 | ks[e[6]],
		a: t === 9 ? ks[e[7]] << 4 | ks[e[8]] : 255
	})), n;
}
var Is = (e, t) => e < 255 ? t(e) : "";
function Ls(e) {
	var t = Ps(e) ? js : Ms;
	return e ? "#" + t(e.r) + t(e.g) + t(e.b) + Is(e.a, t) : void 0;
}
var Rs = /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
function zs(e, t, n) {
	let r = t * Math.min(n, 1 - n), i = (t, i = (t + e / 30) % 12) => n - r * Math.max(Math.min(i - 3, 9 - i, 1), -1);
	return [
		i(0),
		i(8),
		i(4)
	];
}
function Bs(e, t, n) {
	let r = (r, i = (r + e / 60) % 6) => n - n * t * Math.max(Math.min(i, 4 - i, 1), 0);
	return [
		r(5),
		r(3),
		r(1)
	];
}
function Vs(e, t, n) {
	let r = zs(e, 1, .5), i;
	for (t + n > 1 && (i = 1 / (t + n), t *= i, n *= i), i = 0; i < 3; i++) r[i] *= 1 - t - n, r[i] += t;
	return r;
}
function Hs(e, t, n, r, i) {
	return e === i ? (t - n) / r + (t < n ? 6 : 0) : t === i ? (n - e) / r + 2 : (e - t) / r + 4;
}
function Us(e) {
	let t = e.r / 255, n = e.g / 255, r = e.b / 255, i = Math.max(t, n, r), a = Math.min(t, n, r), o = (i + a) / 2, s, c, l;
	return i !== a && (l = i - a, c = o > .5 ? l / (2 - i - a) : l / (i + a), s = Hs(t, n, r, l, i), s = s * 60 + .5), [
		s | 0,
		c || 0,
		o
	];
}
function Ws(e, t, n, r) {
	return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Es);
}
function Gs(e, t, n) {
	return Ws(zs, e, t, n);
}
function Ks(e, t, n) {
	return Ws(Vs, e, t, n);
}
function qs(e, t, n) {
	return Ws(Bs, e, t, n);
}
function Js(e) {
	return (e % 360 + 360) % 360;
}
function Ys(e) {
	let t = Rs.exec(e), n = 255, r;
	if (!t) return;
	t[5] !== r && (n = t[6] ? Ts(+t[5]) : Es(+t[5]));
	let i = Js(+t[2]), a = t[3] / 100, o = t[4] / 100;
	return r = t[1] === "hwb" ? Ks(i, a, o) : t[1] === "hsv" ? qs(i, a, o) : Gs(i, a, o), {
		r: r[0],
		g: r[1],
		b: r[2],
		a: n
	};
}
function Xs(e, t) {
	var n = Us(e);
	n[0] = Js(n[0] + t), n = Gs(n), e.r = n[0], e.g = n[1], e.b = n[2];
}
function Zs(e) {
	if (!e) return;
	let t = Us(e), n = t[0], r = Os(t[1]), i = Os(t[2]);
	return e.a < 255 ? `hsla(${n}, ${r}%, ${i}%, ${Ds(e.a)})` : `hsl(${n}, ${r}%, ${i}%)`;
}
var Qs = {
	x: "dark",
	Z: "light",
	Y: "re",
	X: "blu",
	W: "gr",
	V: "medium",
	U: "slate",
	A: "ee",
	T: "ol",
	S: "or",
	B: "ra",
	C: "lateg",
	D: "ights",
	R: "in",
	Q: "turquois",
	E: "hi",
	P: "ro",
	O: "al",
	N: "le",
	M: "de",
	L: "yello",
	F: "en",
	K: "ch",
	G: "arks",
	H: "ea",
	I: "ightg",
	J: "wh"
}, $s = {
	OiceXe: "f0f8ff",
	antiquewEte: "faebd7",
	aqua: "ffff",
	aquamarRe: "7fffd4",
	azuY: "f0ffff",
	beige: "f5f5dc",
	bisque: "ffe4c4",
	black: "0",
	blanKedOmond: "ffebcd",
	Xe: "ff",
	XeviTet: "8a2be2",
	bPwn: "a52a2a",
	burlywood: "deb887",
	caMtXe: "5f9ea0",
	KartYuse: "7fff00",
	KocTate: "d2691e",
	cSO: "ff7f50",
	cSnflowerXe: "6495ed",
	cSnsilk: "fff8dc",
	crimson: "dc143c",
	cyan: "ffff",
	xXe: "8b",
	xcyan: "8b8b",
	xgTMnPd: "b8860b",
	xWay: "a9a9a9",
	xgYF: "6400",
	xgYy: "a9a9a9",
	xkhaki: "bdb76b",
	xmagFta: "8b008b",
	xTivegYF: "556b2f",
	xSange: "ff8c00",
	xScEd: "9932cc",
	xYd: "8b0000",
	xsOmon: "e9967a",
	xsHgYF: "8fbc8f",
	xUXe: "483d8b",
	xUWay: "2f4f4f",
	xUgYy: "2f4f4f",
	xQe: "ced1",
	xviTet: "9400d3",
	dAppRk: "ff1493",
	dApskyXe: "bfff",
	dimWay: "696969",
	dimgYy: "696969",
	dodgerXe: "1e90ff",
	fiYbrick: "b22222",
	flSOwEte: "fffaf0",
	foYstWAn: "228b22",
	fuKsia: "ff00ff",
	gaRsbSo: "dcdcdc",
	ghostwEte: "f8f8ff",
	gTd: "ffd700",
	gTMnPd: "daa520",
	Way: "808080",
	gYF: "8000",
	gYFLw: "adff2f",
	gYy: "808080",
	honeyMw: "f0fff0",
	hotpRk: "ff69b4",
	RdianYd: "cd5c5c",
	Rdigo: "4b0082",
	ivSy: "fffff0",
	khaki: "f0e68c",
	lavFMr: "e6e6fa",
	lavFMrXsh: "fff0f5",
	lawngYF: "7cfc00",
	NmoncEffon: "fffacd",
	ZXe: "add8e6",
	ZcSO: "f08080",
	Zcyan: "e0ffff",
	ZgTMnPdLw: "fafad2",
	ZWay: "d3d3d3",
	ZgYF: "90ee90",
	ZgYy: "d3d3d3",
	ZpRk: "ffb6c1",
	ZsOmon: "ffa07a",
	ZsHgYF: "20b2aa",
	ZskyXe: "87cefa",
	ZUWay: "778899",
	ZUgYy: "778899",
	ZstAlXe: "b0c4de",
	ZLw: "ffffe0",
	lime: "ff00",
	limegYF: "32cd32",
	lRF: "faf0e6",
	magFta: "ff00ff",
	maPon: "800000",
	VaquamarRe: "66cdaa",
	VXe: "cd",
	VScEd: "ba55d3",
	VpurpN: "9370db",
	VsHgYF: "3cb371",
	VUXe: "7b68ee",
	VsprRggYF: "fa9a",
	VQe: "48d1cc",
	VviTetYd: "c71585",
	midnightXe: "191970",
	mRtcYam: "f5fffa",
	mistyPse: "ffe4e1",
	moccasR: "ffe4b5",
	navajowEte: "ffdead",
	navy: "80",
	Tdlace: "fdf5e6",
	Tive: "808000",
	TivedBb: "6b8e23",
	Sange: "ffa500",
	SangeYd: "ff4500",
	ScEd: "da70d6",
	pOegTMnPd: "eee8aa",
	pOegYF: "98fb98",
	pOeQe: "afeeee",
	pOeviTetYd: "db7093",
	papayawEp: "ffefd5",
	pHKpuff: "ffdab9",
	peru: "cd853f",
	pRk: "ffc0cb",
	plum: "dda0dd",
	powMrXe: "b0e0e6",
	purpN: "800080",
	YbeccapurpN: "663399",
	Yd: "ff0000",
	Psybrown: "bc8f8f",
	PyOXe: "4169e1",
	saddNbPwn: "8b4513",
	sOmon: "fa8072",
	sandybPwn: "f4a460",
	sHgYF: "2e8b57",
	sHshell: "fff5ee",
	siFna: "a0522d",
	silver: "c0c0c0",
	skyXe: "87ceeb",
	UXe: "6a5acd",
	UWay: "708090",
	UgYy: "708090",
	snow: "fffafa",
	sprRggYF: "ff7f",
	stAlXe: "4682b4",
	tan: "d2b48c",
	teO: "8080",
	tEstN: "d8bfd8",
	tomato: "ff6347",
	Qe: "40e0d0",
	viTet: "ee82ee",
	JHt: "f5deb3",
	wEte: "ffffff",
	wEtesmoke: "f5f5f5",
	Lw: "ffff00",
	LwgYF: "9acd32"
};
function ec() {
	let e = {}, t = Object.keys($s), n = Object.keys(Qs), r, i, a, o, s;
	for (r = 0; r < t.length; r++) {
		for (o = s = t[r], i = 0; i < n.length; i++) a = n[i], s = s.replace(a, Qs[a]);
		a = parseInt($s[o], 16), e[s] = [
			a >> 16 & 255,
			a >> 8 & 255,
			a & 255
		];
	}
	return e;
}
var tc;
function nc(e) {
	tc || (tc = ec(), tc.transparent = [
		0,
		0,
		0,
		0
	]);
	let t = tc[e.toLowerCase()];
	return t && {
		r: t[0],
		g: t[1],
		b: t[2],
		a: t.length === 4 ? t[3] : 255
	};
}
var rc = /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/;
function ic(e) {
	let t = rc.exec(e), n = 255, r, i, a;
	if (t) {
		if (t[7] !== r) {
			let e = +t[7];
			n = t[8] ? Ts(e) : ws(e * 255, 0, 255);
		}
		return r = +t[1], i = +t[3], a = +t[5], r = 255 & (t[2] ? Ts(r) : ws(r, 0, 255)), i = 255 & (t[4] ? Ts(i) : ws(i, 0, 255)), a = 255 & (t[6] ? Ts(a) : ws(a, 0, 255)), {
			r,
			g: i,
			b: a,
			a: n
		};
	}
}
function ac(e) {
	return e && (e.a < 255 ? `rgba(${e.r}, ${e.g}, ${e.b}, ${Ds(e.a)})` : `rgb(${e.r}, ${e.g}, ${e.b})`);
}
var oc = (e) => e <= .0031308 ? e * 12.92 : e ** (1 / 2.4) * 1.055 - .055, sc = (e) => e <= .04045 ? e / 12.92 : ((e + .055) / 1.055) ** 2.4;
function cc(e, t, n) {
	let r = sc(Ds(e.r)), i = sc(Ds(e.g)), a = sc(Ds(e.b));
	return {
		r: Es(oc(r + n * (sc(Ds(t.r)) - r))),
		g: Es(oc(i + n * (sc(Ds(t.g)) - i))),
		b: Es(oc(a + n * (sc(Ds(t.b)) - a))),
		a: e.a + n * (t.a - e.a)
	};
}
function lc(e, t, n) {
	if (e) {
		let r = Us(e);
		r[t] = Math.max(0, Math.min(r[t] + r[t] * n, t === 0 ? 360 : 1)), r = Gs(r), e.r = r[0], e.g = r[1], e.b = r[2];
	}
}
function uc(e, t) {
	return e && Object.assign(t || {}, e);
}
function dc(e) {
	var t = {
		r: 0,
		g: 0,
		b: 0,
		a: 255
	};
	return Array.isArray(e) ? e.length >= 3 && (t = {
		r: e[0],
		g: e[1],
		b: e[2],
		a: 255
	}, e.length > 3 && (t.a = Es(e[3]))) : (t = uc(e, {
		r: 0,
		g: 0,
		b: 0,
		a: 1
	}), t.a = Es(t.a)), t;
}
function fc(e) {
	return e.charAt(0) === "r" ? ic(e) : Ys(e);
}
var pc = class e {
	constructor(t) {
		if (t instanceof e) return t;
		let n = typeof t, r;
		n === "object" ? r = dc(t) : n === "string" && (r = Fs(t) || nc(t) || fc(t)), this._rgb = r, this._valid = !!r;
	}
	get valid() {
		return this._valid;
	}
	get rgb() {
		var e = uc(this._rgb);
		return e && (e.a = Ds(e.a)), e;
	}
	set rgb(e) {
		this._rgb = dc(e);
	}
	rgbString() {
		return this._valid ? ac(this._rgb) : void 0;
	}
	hexString() {
		return this._valid ? Ls(this._rgb) : void 0;
	}
	hslString() {
		return this._valid ? Zs(this._rgb) : void 0;
	}
	mix(e, t) {
		if (e) {
			let n = this.rgb, r = e.rgb, i, a = t === i ? .5 : t, o = 2 * a - 1, s = n.a - r.a, c = ((o * s === -1 ? o : (o + s) / (1 + o * s)) + 1) / 2;
			i = 1 - c, n.r = 255 & c * n.r + i * r.r + .5, n.g = 255 & c * n.g + i * r.g + .5, n.b = 255 & c * n.b + i * r.b + .5, n.a = a * n.a + (1 - a) * r.a, this.rgb = n;
		}
		return this;
	}
	interpolate(e, t) {
		return e && (this._rgb = cc(this._rgb, e._rgb, t)), this;
	}
	clone() {
		return new e(this.rgb);
	}
	alpha(e) {
		return this._rgb.a = Es(e), this;
	}
	clearer(e) {
		let t = this._rgb;
		return t.a *= 1 - e, this;
	}
	greyscale() {
		let e = this._rgb;
		return e.r = e.g = e.b = Cs(e.r * .3 + e.g * .59 + e.b * .11), this;
	}
	opaquer(e) {
		let t = this._rgb;
		return t.a *= 1 + e, this;
	}
	negate() {
		let e = this._rgb;
		return e.r = 255 - e.r, e.g = 255 - e.g, e.b = 255 - e.b, this;
	}
	lighten(e) {
		return lc(this._rgb, 2, e), this;
	}
	darken(e) {
		return lc(this._rgb, 2, -e), this;
	}
	saturate(e) {
		return lc(this._rgb, 1, e), this;
	}
	desaturate(e) {
		return lc(this._rgb, 1, -e), this;
	}
	rotate(e) {
		return Xs(this._rgb, e), this;
	}
};
//#endregion
//#region ../node_modules/.pnpm/chart.js@4.5.1/node_modules/chart.js/dist/chunks/helpers.dataset.js
function mc() {}
var hc = (() => {
	let e = 0;
	return () => e++;
})();
function gc(e) {
	return e == null;
}
function _c(e) {
	if (Array.isArray && Array.isArray(e)) return !0;
	let t = Object.prototype.toString.call(e);
	return t.slice(0, 7) === "[object" && t.slice(-6) === "Array]";
}
function vc(e) {
	return e !== null && Object.prototype.toString.call(e) === "[object Object]";
}
function yc(e) {
	return (typeof e == "number" || e instanceof Number) && isFinite(+e);
}
function bc(e, t) {
	return yc(e) ? e : t;
}
function xc(e, t) {
	return e === void 0 ? t : e;
}
var Sc = (e, t) => typeof e == "string" && e.endsWith("%") ? parseFloat(e) / 100 * t : +e;
function Cc(e, t, n) {
	if (e && typeof e.call == "function") return e.apply(n, t);
}
function wc(e, t, n, r) {
	let i, a, o;
	if (_c(e)) if (a = e.length, r) for (i = a - 1; i >= 0; i--) t.call(n, e[i], i);
	else for (i = 0; i < a; i++) t.call(n, e[i], i);
	else if (vc(e)) for (o = Object.keys(e), a = o.length, i = 0; i < a; i++) t.call(n, e[o[i]], o[i]);
}
function Tc(e, t) {
	let n, r, i, a;
	if (!e || !t || e.length !== t.length) return !1;
	for (n = 0, r = e.length; n < r; ++n) if (i = e[n], a = t[n], i.datasetIndex !== a.datasetIndex || i.index !== a.index) return !1;
	return !0;
}
function Ec(e) {
	if (_c(e)) return e.map(Ec);
	if (vc(e)) {
		let t = Object.create(null), n = Object.keys(e), r = n.length, i = 0;
		for (; i < r; ++i) t[n[i]] = Ec(e[n[i]]);
		return t;
	}
	return e;
}
function Dc(e) {
	return [
		"__proto__",
		"prototype",
		"constructor"
	].indexOf(e) === -1;
}
function Oc(e, t, n, r) {
	if (!Dc(e)) return;
	let i = t[e], a = n[e];
	vc(i) && vc(a) ? kc(i, a, r) : t[e] = Ec(a);
}
function kc(e, t, n) {
	let r = _c(t) ? t : [t], i = r.length;
	if (!vc(e)) return e;
	n ||= {};
	let a = n.merger || Oc, o;
	for (let t = 0; t < i; ++t) {
		if (o = r[t], !vc(o)) continue;
		let i = Object.keys(o);
		for (let t = 0, r = i.length; t < r; ++t) a(i[t], e, o, n);
	}
	return e;
}
function Ac(e, t) {
	return kc(e, t, { merger: jc });
}
function jc(e, t, n) {
	if (!Dc(e)) return;
	let r = t[e], i = n[e];
	vc(r) && vc(i) ? Ac(r, i) : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = Ec(i));
}
var Mc = {
	"": (e) => e,
	x: (e) => e.x,
	y: (e) => e.y
};
function Nc(e) {
	let t = e.split("."), n = [], r = "";
	for (let e of t) r += e, r.endsWith("\\") ? r = r.slice(0, -1) + "." : (n.push(r), r = "");
	return n;
}
function Pc(e) {
	let t = Nc(e);
	return (e) => {
		for (let n of t) {
			if (n === "") break;
			e &&= e[n];
		}
		return e;
	};
}
function Fc(e, t) {
	return (Mc[t] || (Mc[t] = Pc(t)))(e);
}
function Ic(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
var Lc = (e) => e !== void 0, Rc = (e) => typeof e == "function", zc = (e, t) => {
	if (e.size !== t.size) return !1;
	for (let n of e) if (!t.has(n)) return !1;
	return !0;
};
function Bc(e) {
	return e.type === "mouseup" || e.type === "click" || e.type === "contextmenu";
}
var Vc = Math.PI, Hc = 2 * Vc, Uc = Hc + Vc, Wc = Infinity, Gc = Vc / 180, Kc = Vc / 2, qc = Vc / 4, Jc = Vc * 2 / 3, Yc = Math.log10, Xc = Math.sign;
function Zc(e, t, n) {
	return Math.abs(e - t) < n;
}
function Qc(e) {
	let t = Math.round(e);
	e = Zc(e, t, e / 1e3) ? t : e;
	let n = 10 ** Math.floor(Yc(e)), r = e / n;
	return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
}
function $c(e) {
	let t = [], n = Math.sqrt(e), r;
	for (r = 1; r < n; r++) e % r === 0 && (t.push(r), t.push(e / r));
	return n === (n | 0) && t.push(n), t.sort((e, t) => e - t).pop(), t;
}
function el(e) {
	return typeof e == "symbol" || typeof e == "object" && !!e && !(Symbol.toPrimitive in e || "toString" in e || "valueOf" in e);
}
function tl(e) {
	return !el(e) && !isNaN(parseFloat(e)) && isFinite(e);
}
function nl(e, t) {
	let n = Math.round(e);
	return n - t <= e && n + t >= e;
}
function rl(e, t, n) {
	let r, i, a;
	for (r = 0, i = e.length; r < i; r++) a = e[r][n], isNaN(a) || (t.min = Math.min(t.min, a), t.max = Math.max(t.max, a));
}
function il(e) {
	return Vc / 180 * e;
}
function al(e) {
	return 180 / Vc * e;
}
function ol(e) {
	if (!yc(e)) return;
	let t = 1, n = 0;
	for (; Math.round(e * t) / t !== e;) t *= 10, n++;
	return n;
}
function sl(e, t) {
	let n = t.x - e.x, r = t.y - e.y, i = Math.sqrt(n * n + r * r), a = Math.atan2(r, n);
	return a < -.5 * Vc && (a += Hc), {
		angle: a,
		distance: i
	};
}
function cl(e, t) {
	return Math.sqrt((t.x - e.x) ** 2 + (t.y - e.y) ** 2);
}
function ll(e, t) {
	return (e - t + Uc) % Hc - Vc;
}
function ul(e) {
	return (e % Hc + Hc) % Hc;
}
function dl(e, t, n, r) {
	let i = ul(e), a = ul(t), o = ul(n), s = ul(a - i), c = ul(o - i), l = ul(i - a), u = ul(i - o);
	return i === a || i === o || r && a === o || s > c && l < u;
}
function fl(e, t, n) {
	return Math.max(t, Math.min(n, e));
}
function pl(e) {
	return fl(e, -32768, 32767);
}
function ml(e, t, n, r = 1e-6) {
	return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
}
function hl(e, t, n) {
	n ||= ((n) => e[n] < t);
	let r = e.length - 1, i = 0, a;
	for (; r - i > 1;) a = i + r >> 1, n(a) ? i = a : r = a;
	return {
		lo: i,
		hi: r
	};
}
var gl = (e, t, n, r) => hl(e, n, r ? (r) => {
	let i = e[r][t];
	return i < n || i === n && e[r + 1][t] === n;
} : (r) => e[r][t] < n), _l = (e, t, n) => hl(e, n, (r) => e[r][t] >= n);
function vl(e, t, n) {
	let r = 0, i = e.length;
	for (; r < i && e[r] < t;) r++;
	for (; i > r && e[i - 1] > n;) i--;
	return r > 0 || i < e.length ? e.slice(r, i) : e;
}
var yl = [
	"push",
	"pop",
	"shift",
	"splice",
	"unshift"
];
function bl(e, t) {
	if (e._chartjs) {
		e._chartjs.listeners.push(t);
		return;
	}
	Object.defineProperty(e, "_chartjs", {
		configurable: !0,
		enumerable: !1,
		value: { listeners: [t] }
	}), yl.forEach((t) => {
		let n = "_onData" + Ic(t), r = e[t];
		Object.defineProperty(e, t, {
			configurable: !0,
			enumerable: !1,
			value(...t) {
				let i = r.apply(this, t);
				return e._chartjs.listeners.forEach((e) => {
					typeof e[n] == "function" && e[n](...t);
				}), i;
			}
		});
	});
}
function xl(e, t) {
	let n = e._chartjs;
	if (!n) return;
	let r = n.listeners, i = r.indexOf(t);
	i !== -1 && r.splice(i, 1), !(r.length > 0) && (yl.forEach((t) => {
		delete e[t];
	}), delete e._chartjs);
}
function Sl(e) {
	let t = new Set(e);
	return t.size === e.length ? e : Array.from(t);
}
var Cl = function() {
	return typeof window > "u" ? function(e) {
		return e();
	} : window.requestAnimationFrame;
}();
function wl(e, t) {
	let n = [], r = !1;
	return function(...i) {
		n = i, r || (r = !0, Cl.call(window, () => {
			r = !1, e.apply(t, n);
		}));
	};
}
function Tl(e, t) {
	let n;
	return function(...r) {
		return t ? (clearTimeout(n), n = setTimeout(e, t, r)) : e.apply(this, r), t;
	};
}
var El = (e) => e === "start" ? "left" : e === "end" ? "right" : "center", Dl = (e, t, n) => e === "start" ? t : e === "end" ? n : (t + n) / 2, Ol = (e, t, n, r) => e === (r ? "left" : "right") ? n : e === "center" ? (t + n) / 2 : t;
function kl(e, t, n) {
	let r = t.length, i = 0, a = r;
	if (e._sorted) {
		let { iScale: o, vScale: s, _parsed: c } = e, l = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null, u = o.axis, { min: d, max: f, minDefined: p, maxDefined: m } = o.getUserBounds();
		if (p) {
			if (i = Math.min(gl(c, u, d).lo, n ? r : gl(t, u, o.getPixelForValue(d)).lo), l) {
				let e = c.slice(0, i + 1).reverse().findIndex((e) => !gc(e[s.axis]));
				i -= Math.max(0, e);
			}
			i = fl(i, 0, r - 1);
		}
		if (m) {
			let e = Math.max(gl(c, o.axis, f, !0).hi + 1, n ? 0 : gl(t, u, o.getPixelForValue(f), !0).hi + 1);
			if (l) {
				let t = c.slice(e - 1).findIndex((e) => !gc(e[s.axis]));
				e += Math.max(0, t);
			}
			a = fl(e, i, r) - i;
		} else a = r - i;
	}
	return {
		start: i,
		count: a
	};
}
function Al(e) {
	let { xScale: t, yScale: n, _scaleRanges: r } = e, i = {
		xmin: t.min,
		xmax: t.max,
		ymin: n.min,
		ymax: n.max
	};
	if (!r) return e._scaleRanges = i, !0;
	let a = r.xmin !== t.min || r.xmax !== t.max || r.ymin !== n.min || r.ymax !== n.max;
	return Object.assign(r, i), a;
}
var jl = (e) => e === 0 || e === 1, Ml = (e, t, n) => -(2 ** (10 * --e) * Math.sin((e - t) * Hc / n)), Nl = (e, t, n) => 2 ** (-10 * e) * Math.sin((e - t) * Hc / n) + 1, Pl = {
	linear: (e) => e,
	easeInQuad: (e) => e * e,
	easeOutQuad: (e) => -e * (e - 2),
	easeInOutQuad: (e) => (e /= .5) < 1 ? .5 * e * e : -.5 * (--e * (e - 2) - 1),
	easeInCubic: (e) => e * e * e,
	easeOutCubic: (e) => --e * e * e + 1,
	easeInOutCubic: (e) => (e /= .5) < 1 ? .5 * e * e * e : .5 * ((e -= 2) * e * e + 2),
	easeInQuart: (e) => e * e * e * e,
	easeOutQuart: (e) => -(--e * e * e * e - 1),
	easeInOutQuart: (e) => (e /= .5) < 1 ? .5 * e * e * e * e : -.5 * ((e -= 2) * e * e * e - 2),
	easeInQuint: (e) => e * e * e * e * e,
	easeOutQuint: (e) => --e * e * e * e * e + 1,
	easeInOutQuint: (e) => (e /= .5) < 1 ? .5 * e * e * e * e * e : .5 * ((e -= 2) * e * e * e * e + 2),
	easeInSine: (e) => -Math.cos(e * Kc) + 1,
	easeOutSine: (e) => Math.sin(e * Kc),
	easeInOutSine: (e) => -.5 * (Math.cos(Vc * e) - 1),
	easeInExpo: (e) => e === 0 ? 0 : 2 ** (10 * (e - 1)),
	easeOutExpo: (e) => e === 1 ? 1 : -(2 ** (-10 * e)) + 1,
	easeInOutExpo: (e) => jl(e) ? e : e < .5 ? .5 * 2 ** (10 * (e * 2 - 1)) : .5 * (-(2 ** (-10 * (e * 2 - 1))) + 2),
	easeInCirc: (e) => e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1),
	easeOutCirc: (e) => Math.sqrt(1 - --e * e),
	easeInOutCirc: (e) => (e /= .5) < 1 ? -.5 * (Math.sqrt(1 - e * e) - 1) : .5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
	easeInElastic: (e) => jl(e) ? e : Ml(e, .075, .3),
	easeOutElastic: (e) => jl(e) ? e : Nl(e, .075, .3),
	easeInOutElastic(e) {
		let t = .1125, n = .45;
		return jl(e) ? e : e < .5 ? .5 * Ml(e * 2, t, n) : .5 + .5 * Nl(e * 2 - 1, t, n);
	},
	easeInBack(e) {
		return e * e * (2.70158 * e - 1.70158);
	},
	easeOutBack(e) {
		return --e * e * (2.70158 * e + 1.70158) + 1;
	},
	easeInOutBack(e) {
		let t = 1.70158;
		return (e /= .5) < 1 ? .5 * (e * e * (((t *= 1.525) + 1) * e - t)) : .5 * ((e -= 2) * e * (((t *= 1.525) + 1) * e + t) + 2);
	},
	easeInBounce: (e) => 1 - Pl.easeOutBounce(1 - e),
	easeOutBounce(e) {
		let t = 7.5625, n = 2.75;
		return e < 1 / n ? t * e * e : e < 2 / n ? t * (e -= 1.5 / n) * e + .75 : e < 2.5 / n ? t * (e -= 2.25 / n) * e + .9375 : t * (e -= 2.625 / n) * e + .984375;
	},
	easeInOutBounce: (e) => e < .5 ? Pl.easeInBounce(e * 2) * .5 : Pl.easeOutBounce(e * 2 - 1) * .5 + .5
};
function Fl(e) {
	if (e && typeof e == "object") {
		let t = e.toString();
		return t === "[object CanvasPattern]" || t === "[object CanvasGradient]";
	}
	return !1;
}
function Il(e) {
	return Fl(e) ? e : new pc(e);
}
function Ll(e) {
	return Fl(e) ? e : new pc(e).saturate(.5).darken(.1).hexString();
}
var Rl = [
	"x",
	"y",
	"borderWidth",
	"radius",
	"tension"
], zl = [
	"color",
	"borderColor",
	"backgroundColor"
];
function Bl(e) {
	e.set("animation", {
		delay: void 0,
		duration: 1e3,
		easing: "easeOutQuart",
		fn: void 0,
		from: void 0,
		loop: void 0,
		to: void 0,
		type: void 0
	}), e.describe("animation", {
		_fallback: !1,
		_indexable: !1,
		_scriptable: (e) => e !== "onProgress" && e !== "onComplete" && e !== "fn"
	}), e.set("animations", {
		colors: {
			type: "color",
			properties: zl
		},
		numbers: {
			type: "number",
			properties: Rl
		}
	}), e.describe("animations", { _fallback: "animation" }), e.set("transitions", {
		active: { animation: { duration: 400 } },
		resize: { animation: { duration: 0 } },
		show: { animations: {
			colors: { from: "transparent" },
			visible: {
				type: "boolean",
				duration: 0
			}
		} },
		hide: { animations: {
			colors: { to: "transparent" },
			visible: {
				type: "boolean",
				easing: "linear",
				fn: (e) => e | 0
			}
		} }
	});
}
function Vl(e) {
	e.set("layout", {
		autoPadding: !0,
		padding: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		}
	});
}
var Hl = /* @__PURE__ */ new Map();
function Ul(e, t) {
	t ||= {};
	let n = e + JSON.stringify(t), r = Hl.get(n);
	return r || (r = new Intl.NumberFormat(e, t), Hl.set(n, r)), r;
}
function Wl(e, t, n) {
	return Ul(t, n).format(e);
}
var Gl = {
	values(e) {
		return _c(e) ? e : "" + e;
	},
	numeric(e, t, n) {
		if (e === 0) return "0";
		let r = this.chart.options.locale, i, a = e;
		if (n.length > 1) {
			let t = Math.max(Math.abs(n[0].value), Math.abs(n[n.length - 1].value));
			(t < 1e-4 || t > 0x38d7ea4c68000) && (i = "scientific"), a = Kl(e, n);
		}
		let o = Yc(Math.abs(a)), s = isNaN(o) ? 1 : Math.max(Math.min(-1 * Math.floor(o), 20), 0), c = {
			notation: i,
			minimumFractionDigits: s,
			maximumFractionDigits: s
		};
		return Object.assign(c, this.options.ticks.format), Wl(e, r, c);
	},
	logarithmic(e, t, n) {
		if (e === 0) return "0";
		let r = n[t].significand || e / 10 ** Math.floor(Yc(e));
		return [
			1,
			2,
			3,
			5,
			10,
			15
		].includes(r) || t > .8 * n.length ? Gl.numeric.call(this, e, t, n) : "";
	}
};
function Kl(e, t) {
	let n = t.length > 3 ? t[2].value - t[1].value : t[1].value - t[0].value;
	return Math.abs(n) >= 1 && e !== Math.floor(e) && (n = e - Math.floor(e)), n;
}
var ql = { formatters: Gl };
function Jl(e) {
	e.set("scale", {
		display: !0,
		offset: !1,
		reverse: !1,
		beginAtZero: !1,
		bounds: "ticks",
		clip: !0,
		grace: 0,
		grid: {
			display: !0,
			lineWidth: 1,
			drawOnChartArea: !0,
			drawTicks: !0,
			tickLength: 8,
			tickWidth: (e, t) => t.lineWidth,
			tickColor: (e, t) => t.color,
			offset: !1
		},
		border: {
			display: !0,
			dash: [],
			dashOffset: 0,
			width: 1
		},
		title: {
			display: !1,
			text: "",
			padding: {
				top: 4,
				bottom: 4
			}
		},
		ticks: {
			minRotation: 0,
			maxRotation: 50,
			mirror: !1,
			textStrokeWidth: 0,
			textStrokeColor: "",
			padding: 3,
			display: !0,
			autoSkip: !0,
			autoSkipPadding: 3,
			labelOffset: 0,
			callback: ql.formatters.values,
			minor: {},
			major: {},
			align: "center",
			crossAlign: "near",
			showLabelBackdrop: !1,
			backdropColor: "rgba(255, 255, 255, 0.75)",
			backdropPadding: 2
		}
	}), e.route("scale.ticks", "color", "", "color"), e.route("scale.grid", "color", "", "borderColor"), e.route("scale.border", "color", "", "borderColor"), e.route("scale.title", "color", "", "color"), e.describe("scale", {
		_fallback: !1,
		_scriptable: (e) => !e.startsWith("before") && !e.startsWith("after") && e !== "callback" && e !== "parser",
		_indexable: (e) => e !== "borderDash" && e !== "tickBorderDash" && e !== "dash"
	}), e.describe("scales", { _fallback: "scale" }), e.describe("scale.ticks", {
		_scriptable: (e) => e !== "backdropPadding" && e !== "callback",
		_indexable: (e) => e !== "backdropPadding"
	});
}
var Yl = Object.create(null), Xl = Object.create(null);
function Zl(e, t) {
	if (!t) return e;
	let n = t.split(".");
	for (let t = 0, r = n.length; t < r; ++t) {
		let r = n[t];
		e = e[r] || (e[r] = Object.create(null));
	}
	return e;
}
function Ql(e, t, n) {
	return typeof t == "string" ? kc(Zl(e, t), n) : kc(Zl(e, ""), t);
}
var $l = /* #__PURE__ */ new class {
	constructor(e, t) {
		this.animation = void 0, this.backgroundColor = "rgba(0,0,0,0.1)", this.borderColor = "rgba(0,0,0,0.1)", this.color = "#666", this.datasets = {}, this.devicePixelRatio = (e) => e.chart.platform.getDevicePixelRatio(), this.elements = {}, this.events = [
			"mousemove",
			"mouseout",
			"click",
			"touchstart",
			"touchmove"
		], this.font = {
			family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
			size: 12,
			style: "normal",
			lineHeight: 1.2,
			weight: null
		}, this.hover = {}, this.hoverBackgroundColor = (e, t) => Ll(t.backgroundColor), this.hoverBorderColor = (e, t) => Ll(t.borderColor), this.hoverColor = (e, t) => Ll(t.color), this.indexAxis = "x", this.interaction = {
			mode: "nearest",
			intersect: !0,
			includeInvisible: !1
		}, this.maintainAspectRatio = !0, this.onHover = null, this.onClick = null, this.parsing = !0, this.plugins = {}, this.responsive = !0, this.scale = void 0, this.scales = {}, this.showLine = !0, this.drawActiveElementsOnTop = !0, this.describe(e), this.apply(t);
	}
	set(e, t) {
		return Ql(this, e, t);
	}
	get(e) {
		return Zl(this, e);
	}
	describe(e, t) {
		return Ql(Xl, e, t);
	}
	override(e, t) {
		return Ql(Yl, e, t);
	}
	route(e, t, n, r) {
		let i = Zl(this, e), a = Zl(this, n), o = "_" + t;
		Object.defineProperties(i, {
			[o]: {
				value: i[t],
				writable: !0
			},
			[t]: {
				enumerable: !0,
				get() {
					let e = this[o], t = a[r];
					return vc(e) ? Object.assign({}, t, e) : xc(e, t);
				},
				set(e) {
					this[o] = e;
				}
			}
		});
	}
	apply(e) {
		e.forEach((e) => e(this));
	}
}({
	_scriptable: (e) => !e.startsWith("on"),
	_indexable: (e) => e !== "events",
	hover: { _fallback: "interaction" },
	interaction: {
		_scriptable: !1,
		_indexable: !1
	}
}, [
	Bl,
	Vl,
	Jl
]);
function eu(e) {
	return !e || gc(e.size) || gc(e.family) ? null : (e.style ? e.style + " " : "") + (e.weight ? e.weight + " " : "") + e.size + "px " + e.family;
}
function tu(e, t, n, r, i) {
	let a = t[i];
	return a || (a = t[i] = e.measureText(i).width, n.push(i)), a > r && (r = a), r;
}
function nu(e, t, n, r) {
	r ||= {};
	let i = r.data = r.data || {}, a = r.garbageCollect = r.garbageCollect || [];
	r.font !== t && (i = r.data = {}, a = r.garbageCollect = [], r.font = t), e.save(), e.font = t;
	let o = 0, s = n.length, c, l, u, d, f;
	for (c = 0; c < s; c++) if (d = n[c], d != null && !_c(d)) o = tu(e, i, a, o, d);
	else if (_c(d)) for (l = 0, u = d.length; l < u; l++) f = d[l], f != null && !_c(f) && (o = tu(e, i, a, o, f));
	e.restore();
	let p = a.length / 2;
	if (p > n.length) {
		for (c = 0; c < p; c++) delete i[a[c]];
		a.splice(0, p);
	}
	return o;
}
function ru(e, t, n) {
	let r = e.currentDevicePixelRatio, i = n === 0 ? 0 : Math.max(n / 2, .5);
	return Math.round((t - i) * r) / r + i;
}
function iu(e, t) {
	!t && !e || (t ||= e.getContext("2d"), t.save(), t.resetTransform(), t.clearRect(0, 0, e.width, e.height), t.restore());
}
function au(e, t, n, r) {
	ou(e, t, n, r, null);
}
function ou(e, t, n, r, i) {
	let a, o, s, c, l, u, d, f, p = t.pointStyle, m = t.rotation, h = t.radius, g = (m || 0) * Gc;
	if (p && typeof p == "object" && (a = p.toString(), a === "[object HTMLImageElement]" || a === "[object HTMLCanvasElement]")) {
		e.save(), e.translate(n, r), e.rotate(g), e.drawImage(p, -p.width / 2, -p.height / 2, p.width, p.height), e.restore();
		return;
	}
	if (!(isNaN(h) || h <= 0)) {
		switch (e.beginPath(), p) {
			default:
				i ? e.ellipse(n, r, i / 2, h, 0, 0, Hc) : e.arc(n, r, h, 0, Hc), e.closePath();
				break;
			case "triangle":
				u = i ? i / 2 : h, e.moveTo(n + Math.sin(g) * u, r - Math.cos(g) * h), g += Jc, e.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * h), g += Jc, e.lineTo(n + Math.sin(g) * u, r - Math.cos(g) * h), e.closePath();
				break;
			case "rectRounded":
				l = h * .516, c = h - l, o = Math.cos(g + qc) * c, d = Math.cos(g + qc) * (i ? i / 2 - l : c), s = Math.sin(g + qc) * c, f = Math.sin(g + qc) * (i ? i / 2 - l : c), e.arc(n - d, r - s, l, g - Vc, g - Kc), e.arc(n + f, r - o, l, g - Kc, g), e.arc(n + d, r + s, l, g, g + Kc), e.arc(n - f, r + o, l, g + Kc, g + Vc), e.closePath();
				break;
			case "rect":
				if (!m) {
					c = Math.SQRT1_2 * h, u = i ? i / 2 : c, e.rect(n - u, r - c, 2 * u, 2 * c);
					break;
				}
				g += qc;
			case "rectRot":
				d = Math.cos(g) * (i ? i / 2 : h), o = Math.cos(g) * h, s = Math.sin(g) * h, f = Math.sin(g) * (i ? i / 2 : h), e.moveTo(n - d, r - s), e.lineTo(n + f, r - o), e.lineTo(n + d, r + s), e.lineTo(n - f, r + o), e.closePath();
				break;
			case "crossRot": g += qc;
			case "cross":
				d = Math.cos(g) * (i ? i / 2 : h), o = Math.cos(g) * h, s = Math.sin(g) * h, f = Math.sin(g) * (i ? i / 2 : h), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o);
				break;
			case "star":
				d = Math.cos(g) * (i ? i / 2 : h), o = Math.cos(g) * h, s = Math.sin(g) * h, f = Math.sin(g) * (i ? i / 2 : h), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o), g += qc, d = Math.cos(g) * (i ? i / 2 : h), o = Math.cos(g) * h, s = Math.sin(g) * h, f = Math.sin(g) * (i ? i / 2 : h), e.moveTo(n - d, r - s), e.lineTo(n + d, r + s), e.moveTo(n + f, r - o), e.lineTo(n - f, r + o);
				break;
			case "line":
				o = i ? i / 2 : Math.cos(g) * h, s = Math.sin(g) * h, e.moveTo(n - o, r - s), e.lineTo(n + o, r + s);
				break;
			case "dash":
				e.moveTo(n, r), e.lineTo(n + Math.cos(g) * (i ? i / 2 : h), r + Math.sin(g) * h);
				break;
			case !1:
				e.closePath();
				break;
		}
		e.fill(), t.borderWidth > 0 && e.stroke();
	}
}
function su(e, t, n) {
	return n ||= .5, !t || e && e.x > t.left - n && e.x < t.right + n && e.y > t.top - n && e.y < t.bottom + n;
}
function cu(e, t) {
	e.save(), e.beginPath(), e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top), e.clip();
}
function lu(e) {
	e.restore();
}
function uu(e, t, n, r, i) {
	if (!t) return e.lineTo(n.x, n.y);
	if (i === "middle") {
		let r = (t.x + n.x) / 2;
		e.lineTo(r, t.y), e.lineTo(r, n.y);
	} else i === "after" == !!r ? e.lineTo(n.x, t.y) : e.lineTo(t.x, n.y);
	e.lineTo(n.x, n.y);
}
function du(e, t, n, r) {
	if (!t) return e.lineTo(n.x, n.y);
	e.bezierCurveTo(r ? t.cp1x : t.cp2x, r ? t.cp1y : t.cp2y, r ? n.cp2x : n.cp1x, r ? n.cp2y : n.cp1y, n.x, n.y);
}
function fu(e, t) {
	t.translation && e.translate(t.translation[0], t.translation[1]), gc(t.rotation) || e.rotate(t.rotation), t.color && (e.fillStyle = t.color), t.textAlign && (e.textAlign = t.textAlign), t.textBaseline && (e.textBaseline = t.textBaseline);
}
function pu(e, t, n, r, i) {
	if (i.strikethrough || i.underline) {
		let a = e.measureText(r), o = t - a.actualBoundingBoxLeft, s = t + a.actualBoundingBoxRight, c = n - a.actualBoundingBoxAscent, l = n + a.actualBoundingBoxDescent, u = i.strikethrough ? (c + l) / 2 : l;
		e.strokeStyle = e.fillStyle, e.beginPath(), e.lineWidth = i.decorationWidth || 2, e.moveTo(o, u), e.lineTo(s, u), e.stroke();
	}
}
function mu(e, t) {
	let n = e.fillStyle;
	e.fillStyle = t.color, e.fillRect(t.left, t.top, t.width, t.height), e.fillStyle = n;
}
function hu(e, t, n, r, i, a = {}) {
	let o = _c(t) ? t : [t], s = a.strokeWidth > 0 && a.strokeColor !== "", c, l;
	for (e.save(), e.font = i.string, fu(e, a), c = 0; c < o.length; ++c) l = o[c], a.backdrop && mu(e, a.backdrop), s && (a.strokeColor && (e.strokeStyle = a.strokeColor), gc(a.strokeWidth) || (e.lineWidth = a.strokeWidth), e.strokeText(l, n, r, a.maxWidth)), e.fillText(l, n, r, a.maxWidth), pu(e, n, r, l, a), r += Number(i.lineHeight);
	e.restore();
}
function gu(e, t) {
	let { x: n, y: r, w: i, h: a, radius: o } = t;
	e.arc(n + o.topLeft, r + o.topLeft, o.topLeft, 1.5 * Vc, Vc, !0), e.lineTo(n, r + a - o.bottomLeft), e.arc(n + o.bottomLeft, r + a - o.bottomLeft, o.bottomLeft, Vc, Kc, !0), e.lineTo(n + i - o.bottomRight, r + a), e.arc(n + i - o.bottomRight, r + a - o.bottomRight, o.bottomRight, Kc, 0, !0), e.lineTo(n + i, r + o.topRight), e.arc(n + i - o.topRight, r + o.topRight, o.topRight, 0, -Kc, !0), e.lineTo(n + o.topLeft, r);
}
var _u = /^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/, vu = /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/;
function yu(e, t) {
	let n = ("" + e).match(_u);
	if (!n || n[1] === "normal") return t * 1.2;
	switch (e = +n[2], n[3]) {
		case "px": return e;
		case "%":
			e /= 100;
			break;
	}
	return t * e;
}
var bu = (e) => +e || 0;
function xu(e, t) {
	let n = {}, r = vc(t), i = r ? Object.keys(t) : t, a = vc(e) ? r ? (n) => xc(e[n], e[t[n]]) : (t) => e[t] : () => e;
	for (let e of i) n[e] = bu(a(e));
	return n;
}
function Su(e) {
	return xu(e, {
		top: "y",
		right: "x",
		bottom: "y",
		left: "x"
	});
}
function Cu(e) {
	return xu(e, [
		"topLeft",
		"topRight",
		"bottomLeft",
		"bottomRight"
	]);
}
function wu(e) {
	let t = Su(e);
	return t.width = t.left + t.right, t.height = t.top + t.bottom, t;
}
function Tu(e, t) {
	e ||= {}, t ||= $l.font;
	let n = xc(e.size, t.size);
	typeof n == "string" && (n = parseInt(n, 10));
	let r = xc(e.style, t.style);
	r && !("" + r).match(vu) && (console.warn("Invalid font style specified: \"" + r + "\""), r = void 0);
	let i = {
		family: xc(e.family, t.family),
		lineHeight: yu(xc(e.lineHeight, t.lineHeight), n),
		size: n,
		style: r,
		weight: xc(e.weight, t.weight),
		string: ""
	};
	return i.string = eu(i), i;
}
function Eu(e, t, n, r) {
	let i = !0, a, o, s;
	for (a = 0, o = e.length; a < o; ++a) if (s = e[a], s !== void 0 && (t !== void 0 && typeof s == "function" && (s = s(t), i = !1), n !== void 0 && _c(s) && (s = s[n % s.length], i = !1), s !== void 0)) return r && !i && (r.cacheable = !1), s;
}
function Du(e, t, n) {
	let { min: r, max: i } = e, a = Sc(t, (i - r) / 2), o = (e, t) => n && e === 0 ? 0 : e + t;
	return {
		min: o(r, -Math.abs(a)),
		max: o(i, a)
	};
}
function Ou(e, t) {
	return Object.assign(Object.create(e), t);
}
function ku(e, t = [""], n, r, i = () => e[0]) {
	let a = n || e;
	return r === void 0 && (r = Gu("_fallback", e)), new Proxy({
		[Symbol.toStringTag]: "Object",
		_cacheable: !0,
		_scopes: e,
		_rootScopes: a,
		_fallback: r,
		_getTarget: i,
		override: (n) => ku([n, ...e], t, a, r)
	}, {
		deleteProperty(t, n) {
			return delete t[n], delete t._keys, delete e[0][n], !0;
		},
		get(n, r) {
			return Pu(n, r, () => Wu(r, t, e, n));
		},
		getOwnPropertyDescriptor(e, t) {
			return Reflect.getOwnPropertyDescriptor(e._scopes[0], t);
		},
		getPrototypeOf() {
			return Reflect.getPrototypeOf(e[0]);
		},
		has(e, t) {
			return Ku(e).includes(t);
		},
		ownKeys(e) {
			return Ku(e);
		},
		set(e, t, n) {
			let r = e._storage ||= i();
			return e[t] = r[t] = n, delete e._keys, !0;
		}
	});
}
function Au(e, t, n, r) {
	let i = {
		_cacheable: !1,
		_proxy: e,
		_context: t,
		_subProxy: n,
		_stack: /* @__PURE__ */ new Set(),
		_descriptors: ju(e, r),
		setContext: (t) => Au(e, t, n, r),
		override: (i) => Au(e.override(i), t, n, r)
	};
	return new Proxy(i, {
		deleteProperty(t, n) {
			return delete t[n], delete e[n], !0;
		},
		get(e, t, n) {
			return Pu(e, t, () => Fu(e, t, n));
		},
		getOwnPropertyDescriptor(t, n) {
			return t._descriptors.allKeys ? Reflect.has(e, n) ? {
				enumerable: !0,
				configurable: !0
			} : void 0 : Reflect.getOwnPropertyDescriptor(e, n);
		},
		getPrototypeOf() {
			return Reflect.getPrototypeOf(e);
		},
		has(t, n) {
			return Reflect.has(e, n);
		},
		ownKeys() {
			return Reflect.ownKeys(e);
		},
		set(t, n, r) {
			return e[n] = r, delete t[n], !0;
		}
	});
}
function ju(e, t = {
	scriptable: !0,
	indexable: !0
}) {
	let { _scriptable: n = t.scriptable, _indexable: r = t.indexable, _allKeys: i = t.allKeys } = e;
	return {
		allKeys: i,
		scriptable: n,
		indexable: r,
		isScriptable: Rc(n) ? n : () => n,
		isIndexable: Rc(r) ? r : () => r
	};
}
var Mu = (e, t) => e ? e + Ic(t) : t, Nu = (e, t) => vc(t) && e !== "adapters" && (Object.getPrototypeOf(t) === null || t.constructor === Object);
function Pu(e, t, n) {
	if (Object.prototype.hasOwnProperty.call(e, t) || t === "constructor") return e[t];
	let r = n();
	return e[t] = r, r;
}
function Fu(e, t, n) {
	let { _proxy: r, _context: i, _subProxy: a, _descriptors: o } = e, s = r[t];
	return Rc(s) && o.isScriptable(t) && (s = Iu(t, s, e, n)), _c(s) && s.length && (s = Lu(t, s, e, o.isIndexable)), Nu(t, s) && (s = Au(s, i, a && a[t], o)), s;
}
function Iu(e, t, n, r) {
	let { _proxy: i, _context: a, _subProxy: o, _stack: s } = n;
	if (s.has(e)) throw Error("Recursion detected: " + Array.from(s).join("->") + "->" + e);
	s.add(e);
	let c = t(a, o || r);
	return s.delete(e), Nu(e, c) && (c = Vu(i._scopes, i, e, c)), c;
}
function Lu(e, t, n, r) {
	let { _proxy: i, _context: a, _subProxy: o, _descriptors: s } = n;
	if (a.index !== void 0 && r(e)) return t[a.index % t.length];
	if (vc(t[0])) {
		let n = t, r = i._scopes.filter((e) => e !== n);
		t = [];
		for (let c of n) {
			let n = Vu(r, i, e, c);
			t.push(Au(n, a, o && o[e], s));
		}
	}
	return t;
}
function Ru(e, t, n) {
	return Rc(e) ? e(t, n) : e;
}
var zu = (e, t) => e === !0 ? t : typeof e == "string" ? Fc(t, e) : void 0;
function Bu(e, t, n, r, i) {
	for (let a of t) {
		let t = zu(n, a);
		if (t) {
			e.add(t);
			let a = Ru(t._fallback, n, i);
			if (a !== void 0 && a !== n && a !== r) return a;
		} else if (t === !1 && r !== void 0 && n !== r) return null;
	}
	return !1;
}
function Vu(e, t, n, r) {
	let i = t._rootScopes, a = Ru(t._fallback, n, r), o = [...e, ...i], s = /* @__PURE__ */ new Set();
	s.add(r);
	let c = Hu(s, o, n, a || n, r);
	return c === null || a !== void 0 && a !== n && (c = Hu(s, o, a, c, r), c === null) ? !1 : ku(Array.from(s), [""], i, a, () => Uu(t, n, r));
}
function Hu(e, t, n, r, i) {
	for (; n;) n = Bu(e, t, n, r, i);
	return n;
}
function Uu(e, t, n) {
	let r = e._getTarget();
	t in r || (r[t] = {});
	let i = r[t];
	return _c(i) && vc(n) ? n : i || {};
}
function Wu(e, t, n, r) {
	let i;
	for (let a of t) if (i = Gu(Mu(a, e), n), i !== void 0) return Nu(e, i) ? Vu(n, r, e, i) : i;
}
function Gu(e, t) {
	for (let n of t) {
		if (!n) continue;
		let t = n[e];
		if (t !== void 0) return t;
	}
}
function Ku(e) {
	let t = e._keys;
	return t ||= e._keys = qu(e._scopes), t;
}
function qu(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e) for (let e of Object.keys(n).filter((e) => !e.startsWith("_"))) t.add(e);
	return Array.from(t);
}
var Ju = 2 ** -52 || 1e-14, Yu = (e, t) => t < e.length && !e[t].skip && e[t], Xu = (e) => e === "x" ? "y" : "x";
function Zu(e, t, n, r) {
	let i = e.skip ? t : e, a = t, o = n.skip ? t : n, s = cl(a, i), c = cl(o, a), l = s / (s + c), u = c / (s + c);
	l = isNaN(l) ? 0 : l, u = isNaN(u) ? 0 : u;
	let d = r * l, f = r * u;
	return {
		previous: {
			x: a.x - d * (o.x - i.x),
			y: a.y - d * (o.y - i.y)
		},
		next: {
			x: a.x + f * (o.x - i.x),
			y: a.y + f * (o.y - i.y)
		}
	};
}
function Qu(e, t, n) {
	let r = e.length, i, a, o, s, c, l = Yu(e, 0);
	for (let u = 0; u < r - 1; ++u) if (c = l, l = Yu(e, u + 1), !(!c || !l)) {
		if (Zc(t[u], 0, Ju)) {
			n[u] = n[u + 1] = 0;
			continue;
		}
		i = n[u] / t[u], a = n[u + 1] / t[u], s = i ** 2 + a ** 2, !(s <= 9) && (o = 3 / Math.sqrt(s), n[u] = i * o * t[u], n[u + 1] = a * o * t[u]);
	}
}
function $u(e, t, n = "x") {
	let r = Xu(n), i = e.length, a, o, s, c = Yu(e, 0);
	for (let l = 0; l < i; ++l) {
		if (o = s, s = c, c = Yu(e, l + 1), !s) continue;
		let i = s[n], u = s[r];
		o && (a = (i - o[n]) / 3, s[`cp1${n}`] = i - a, s[`cp1${r}`] = u - a * t[l]), c && (a = (c[n] - i) / 3, s[`cp2${n}`] = i + a, s[`cp2${r}`] = u + a * t[l]);
	}
}
function ed(e, t = "x") {
	let n = Xu(t), r = e.length, i = Array(r).fill(0), a = Array(r), o, s, c, l = Yu(e, 0);
	for (o = 0; o < r; ++o) if (s = c, c = l, l = Yu(e, o + 1), c) {
		if (l) {
			let e = l[t] - c[t];
			i[o] = e === 0 ? 0 : (l[n] - c[n]) / e;
		}
		a[o] = s ? l ? Xc(i[o - 1]) === Xc(i[o]) ? (i[o - 1] + i[o]) / 2 : 0 : i[o - 1] : i[o];
	}
	Qu(e, i, a), $u(e, a, t);
}
function td(e, t, n) {
	return Math.max(Math.min(e, n), t);
}
function nd(e, t) {
	let n, r, i, a, o, s = su(e[0], t);
	for (n = 0, r = e.length; n < r; ++n) o = a, a = s, s = n < r - 1 && su(e[n + 1], t), a && (i = e[n], o && (i.cp1x = td(i.cp1x, t.left, t.right), i.cp1y = td(i.cp1y, t.top, t.bottom)), s && (i.cp2x = td(i.cp2x, t.left, t.right), i.cp2y = td(i.cp2y, t.top, t.bottom)));
}
function rd(e, t, n, r, i) {
	let a, o, s, c;
	if (t.spanGaps && (e = e.filter((e) => !e.skip)), t.cubicInterpolationMode === "monotone") ed(e, i);
	else {
		let n = r ? e[e.length - 1] : e[0];
		for (a = 0, o = e.length; a < o; ++a) s = e[a], c = Zu(n, s, e[Math.min(a + 1, o - +!r) % o], t.tension), s.cp1x = c.previous.x, s.cp1y = c.previous.y, s.cp2x = c.next.x, s.cp2y = c.next.y, n = s;
	}
	t.capBezierPoints && nd(e, n);
}
function id() {
	return typeof window < "u" && typeof document < "u";
}
function ad(e) {
	let t = e.parentNode;
	return t && t.toString() === "[object ShadowRoot]" && (t = t.host), t;
}
function od(e, t, n) {
	let r;
	return typeof e == "string" ? (r = parseInt(e, 10), e.indexOf("%") !== -1 && (r = r / 100 * t.parentNode[n])) : r = e, r;
}
var sd = (e) => e.ownerDocument.defaultView.getComputedStyle(e, null);
function cd(e, t) {
	return sd(e).getPropertyValue(t);
}
var ld = [
	"top",
	"right",
	"bottom",
	"left"
];
function ud(e, t, n) {
	let r = {};
	n = n ? "-" + n : "";
	for (let i = 0; i < 4; i++) {
		let a = ld[i];
		r[a] = parseFloat(e[t + "-" + a + n]) || 0;
	}
	return r.width = r.left + r.right, r.height = r.top + r.bottom, r;
}
var dd = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
function fd(e, t) {
	let n = e.touches, r = n && n.length ? n[0] : e, { offsetX: i, offsetY: a } = r, o = !1, s, c;
	if (dd(i, a, e.target)) s = i, c = a;
	else {
		let e = t.getBoundingClientRect();
		s = r.clientX - e.left, c = r.clientY - e.top, o = !0;
	}
	return {
		x: s,
		y: c,
		box: o
	};
}
function pd(e, t) {
	if ("native" in e) return e;
	let { canvas: n, currentDevicePixelRatio: r } = t, i = sd(n), a = i.boxSizing === "border-box", o = ud(i, "padding"), s = ud(i, "border", "width"), { x: c, y: l, box: u } = fd(e, n), d = o.left + (u && s.left), f = o.top + (u && s.top), { width: p, height: m } = t;
	return a && (p -= o.width + s.width, m -= o.height + s.height), {
		x: Math.round((c - d) / p * n.width / r),
		y: Math.round((l - f) / m * n.height / r)
	};
}
function md(e, t, n) {
	let r, i;
	if (t === void 0 || n === void 0) {
		let a = e && ad(e);
		if (!a) t = e.clientWidth, n = e.clientHeight;
		else {
			let e = a.getBoundingClientRect(), o = sd(a), s = ud(o, "border", "width"), c = ud(o, "padding");
			t = e.width - c.width - s.width, n = e.height - c.height - s.height, r = od(o.maxWidth, a, "clientWidth"), i = od(o.maxHeight, a, "clientHeight");
		}
	}
	return {
		width: t,
		height: n,
		maxWidth: r || Wc,
		maxHeight: i || Wc
	};
}
var hd = (e) => Math.round(e * 10) / 10;
function gd(e, t, n, r) {
	let i = sd(e), a = ud(i, "margin"), o = od(i.maxWidth, e, "clientWidth") || Wc, s = od(i.maxHeight, e, "clientHeight") || Wc, c = md(e, t, n), { width: l, height: u } = c;
	if (i.boxSizing === "content-box") {
		let e = ud(i, "border", "width"), t = ud(i, "padding");
		l -= t.width + e.width, u -= t.height + e.height;
	}
	return l = Math.max(0, l - a.width), u = Math.max(0, r ? l / r : u - a.height), l = hd(Math.min(l, o, c.maxWidth)), u = hd(Math.min(u, s, c.maxHeight)), l && !u && (u = hd(l / 2)), (t !== void 0 || n !== void 0) && r && c.height && u > c.height && (u = c.height, l = hd(Math.floor(u * r))), {
		width: l,
		height: u
	};
}
function _d(e, t, n) {
	let r = t || 1, i = hd(e.height * r), a = hd(e.width * r);
	e.height = hd(e.height), e.width = hd(e.width);
	let o = e.canvas;
	return o.style && (n || !o.style.height && !o.style.width) && (o.style.height = `${e.height}px`, o.style.width = `${e.width}px`), e.currentDevicePixelRatio !== r || o.height !== i || o.width !== a ? (e.currentDevicePixelRatio = r, o.height = i, o.width = a, e.ctx.setTransform(r, 0, 0, r, 0, 0), !0) : !1;
}
var vd = function() {
	let e = !1;
	try {
		let t = { get passive() {
			return e = !0, !1;
		} };
		id() && (window.addEventListener("test", null, t), window.removeEventListener("test", null, t));
	} catch {}
	return e;
}();
function yd(e, t) {
	let n = cd(e, t), r = n && n.match(/^(\d+)(\.\d+)?px$/);
	return r ? +r[1] : void 0;
}
function bd(e, t, n, r) {
	return {
		x: e.x + n * (t.x - e.x),
		y: e.y + n * (t.y - e.y)
	};
}
function xd(e, t, n, r) {
	return {
		x: e.x + n * (t.x - e.x),
		y: r === "middle" ? n < .5 ? e.y : t.y : r === "after" ? n < 1 ? e.y : t.y : n > 0 ? t.y : e.y
	};
}
function Sd(e, t, n, r) {
	let i = {
		x: e.cp2x,
		y: e.cp2y
	}, a = {
		x: t.cp1x,
		y: t.cp1y
	}, o = bd(e, i, n), s = bd(i, a, n), c = bd(a, t, n);
	return bd(bd(o, s, n), bd(s, c, n), n);
}
var Cd = function(e, t) {
	return {
		x(n) {
			return e + e + t - n;
		},
		setWidth(e) {
			t = e;
		},
		textAlign(e) {
			return e === "center" ? e : e === "right" ? "left" : "right";
		},
		xPlus(e, t) {
			return e - t;
		},
		leftForLtr(e, t) {
			return e - t;
		}
	};
}, wd = function() {
	return {
		x(e) {
			return e;
		},
		setWidth(e) {},
		textAlign(e) {
			return e;
		},
		xPlus(e, t) {
			return e + t;
		},
		leftForLtr(e, t) {
			return e;
		}
	};
};
function Td(e, t, n) {
	return e ? Cd(t, n) : wd();
}
function Ed(e, t) {
	let n, r;
	(t === "ltr" || t === "rtl") && (n = e.canvas.style, r = [n.getPropertyValue("direction"), n.getPropertyPriority("direction")], n.setProperty("direction", t, "important"), e.prevTextDirection = r);
}
function Dd(e, t) {
	t !== void 0 && (delete e.prevTextDirection, e.canvas.style.setProperty("direction", t[0], t[1]));
}
function Od(e) {
	return e === "angle" ? {
		between: dl,
		compare: ll,
		normalize: ul
	} : {
		between: ml,
		compare: (e, t) => e - t,
		normalize: (e) => e
	};
}
function kd({ start: e, end: t, count: n, loop: r, style: i }) {
	return {
		start: e % n,
		end: t % n,
		loop: r && (t - e + 1) % n === 0,
		style: i
	};
}
function Ad(e, t, n) {
	let { property: r, start: i, end: a } = n, { between: o, normalize: s } = Od(r), c = t.length, { start: l, end: u, loop: d } = e, f, p;
	if (d) {
		for (l += c, u += c, f = 0, p = c; f < p && o(s(t[l % c][r]), i, a); ++f) l--, u--;
		l %= c, u %= c;
	}
	return u < l && (u += c), {
		start: l,
		end: u,
		loop: d,
		style: e.style
	};
}
function jd(e, t, n) {
	if (!n) return [e];
	let { property: r, start: i, end: a } = n, o = t.length, { compare: s, between: c, normalize: l } = Od(r), { start: u, end: d, loop: f, style: p } = Ad(e, t, n), m = [], h = !1, g = null, _, v, y, b = () => c(i, y, _) && s(i, y) !== 0, x = () => s(a, _) === 0 || c(a, y, _), S = () => h || b(), C = () => !h || x();
	for (let e = u, n = u; e <= d; ++e) v = t[e % o], !v.skip && (_ = l(v[r]), _ !== y && (h = c(_, i, a), g === null && S() && (g = s(_, i) === 0 ? e : n), g !== null && C() && (m.push(kd({
		start: g,
		end: e,
		loop: f,
		count: o,
		style: p
	})), g = null), n = e, y = _));
	return g !== null && m.push(kd({
		start: g,
		end: d,
		loop: f,
		count: o,
		style: p
	})), m;
}
function Md(e, t) {
	let n = [], r = e.segments;
	for (let i = 0; i < r.length; i++) {
		let a = jd(r[i], e.points, t);
		a.length && n.push(...a);
	}
	return n;
}
function Nd(e, t, n, r) {
	let i = 0, a = t - 1;
	if (n && !r) for (; i < t && !e[i].skip;) i++;
	for (; i < t && e[i].skip;) i++;
	for (i %= t, n && (a += i); a > i && e[a % t].skip;) a--;
	return a %= t, {
		start: i,
		end: a
	};
}
function Pd(e, t, n, r) {
	let i = e.length, a = [], o = t, s = e[t], c;
	for (c = t + 1; c <= n; ++c) {
		let n = e[c % i];
		n.skip || n.stop ? s.skip || (r = !1, a.push({
			start: t % i,
			end: (c - 1) % i,
			loop: r
		}), t = o = n.stop ? c : null) : (o = c, s.skip && (t = c)), s = n;
	}
	return o !== null && a.push({
		start: t % i,
		end: o % i,
		loop: r
	}), a;
}
function Fd(e, t) {
	let n = e.points, r = e.options.spanGaps, i = n.length;
	if (!i) return [];
	let a = !!e._loop, { start: o, end: s } = Nd(n, i, a, r);
	return r === !0 ? Id(e, [{
		start: o,
		end: s,
		loop: a
	}], n, t) : Id(e, Pd(n, o, s < o ? s + i : s, !!e._fullLoop && o === 0 && s === i - 1), n, t);
}
function Id(e, t, n, r) {
	return !r || !r.setContext || !n ? t : Ld(e, t, n, r);
}
function Ld(e, t, n, r) {
	let i = e._chart.getContext(), a = Rd(e.options), { _datasetIndex: o, options: { spanGaps: s } } = e, c = n.length, l = [], u = a, d = t[0].start, f = d;
	function p(e, t, r, i) {
		let a = s ? -1 : 1;
		if (e !== t) {
			for (e += c; n[e % c].skip;) e -= a;
			for (; n[t % c].skip;) t += a;
			e % c !== t % c && (l.push({
				start: e % c,
				end: t % c,
				loop: r,
				style: i
			}), u = i, d = t % c);
		}
	}
	for (let e of t) {
		d = s ? d : e.start;
		let t = n[d % c], a;
		for (f = d + 1; f <= e.end; f++) {
			let s = n[f % c];
			a = Rd(r.setContext(Ou(i, {
				type: "segment",
				p0: t,
				p1: s,
				p0DataIndex: (f - 1) % c,
				p1DataIndex: f % c,
				datasetIndex: o
			}))), zd(a, u) && p(d, f - 1, e.loop, u), t = s, u = a;
		}
		d < f - 1 && p(d, f - 1, e.loop, u);
	}
	return l;
}
function Rd(e) {
	return {
		backgroundColor: e.backgroundColor,
		borderCapStyle: e.borderCapStyle,
		borderDash: e.borderDash,
		borderDashOffset: e.borderDashOffset,
		borderJoinStyle: e.borderJoinStyle,
		borderWidth: e.borderWidth,
		borderColor: e.borderColor
	};
}
function zd(e, t) {
	if (!t) return !1;
	let n = [], r = function(e, t) {
		return Fl(t) ? (n.includes(t) || n.push(t), n.indexOf(t)) : t;
	};
	return JSON.stringify(e, r) !== JSON.stringify(t, r);
}
function Bd(e, t, n) {
	return e.options.clip ? e[n] : t[n];
}
function Vd(e, t) {
	let { xScale: n, yScale: r } = e;
	return n && r ? {
		left: Bd(n, t, "left"),
		right: Bd(n, t, "right"),
		top: Bd(r, t, "top"),
		bottom: Bd(r, t, "bottom")
	} : t;
}
function Hd(e, t) {
	let n = t._clip;
	if (n.disabled) return !1;
	let r = Vd(t, e.chartArea);
	return {
		left: n.left === !1 ? 0 : r.left - (n.left === !0 ? 0 : n.left),
		right: n.right === !1 ? e.width : r.right + (n.right === !0 ? 0 : n.right),
		top: n.top === !1 ? 0 : r.top - (n.top === !0 ? 0 : n.top),
		bottom: n.bottom === !1 ? e.height : r.bottom + (n.bottom === !0 ? 0 : n.bottom)
	};
}
var Ud = /* #__PURE__ */ new class {
	constructor() {
		this._request = null, this._charts = /* @__PURE__ */ new Map(), this._running = !1, this._lastDate = void 0;
	}
	_notify(e, t, n, r) {
		let i = t.listeners[r], a = t.duration;
		i.forEach((r) => r({
			chart: e,
			initial: t.initial,
			numSteps: a,
			currentStep: Math.min(n - t.start, a)
		}));
	}
	_refresh() {
		this._request ||= (this._running = !0, Cl.call(window, () => {
			this._update(), this._request = null, this._running && this._refresh();
		}));
	}
	_update(e = Date.now()) {
		let t = 0;
		this._charts.forEach((n, r) => {
			if (!n.running || !n.items.length) return;
			let i = n.items, a = i.length - 1, o = !1, s;
			for (; a >= 0; --a) s = i[a], s._active ? (s._total > n.duration && (n.duration = s._total), s.tick(e), o = !0) : (i[a] = i[i.length - 1], i.pop());
			o && (r.draw(), this._notify(r, n, e, "progress")), i.length || (n.running = !1, this._notify(r, n, e, "complete"), n.initial = !1), t += i.length;
		}), this._lastDate = e, t === 0 && (this._running = !1);
	}
	_getAnims(e) {
		let t = this._charts, n = t.get(e);
		return n || (n = {
			running: !1,
			initial: !0,
			items: [],
			listeners: {
				complete: [],
				progress: []
			}
		}, t.set(e, n)), n;
	}
	listen(e, t, n) {
		this._getAnims(e).listeners[t].push(n);
	}
	add(e, t) {
		!t || !t.length || this._getAnims(e).items.push(...t);
	}
	has(e) {
		return this._getAnims(e).items.length > 0;
	}
	start(e) {
		let t = this._charts.get(e);
		t && (t.running = !0, t.start = Date.now(), t.duration = t.items.reduce((e, t) => Math.max(e, t._duration), 0), this._refresh());
	}
	running(e) {
		if (!this._running) return !1;
		let t = this._charts.get(e);
		return !(!t || !t.running || !t.items.length);
	}
	stop(e) {
		let t = this._charts.get(e);
		if (!t || !t.items.length) return;
		let n = t.items, r = n.length - 1;
		for (; r >= 0; --r) n[r].cancel();
		t.items = [], this._notify(e, t, Date.now(), "complete");
	}
	remove(e) {
		return this._charts.delete(e);
	}
}(), Wd = "transparent", Gd = {
	boolean(e, t, n) {
		return n > .5 ? t : e;
	},
	color(e, t, n) {
		let r = Il(e || Wd), i = r.valid && Il(t || Wd);
		return i && i.valid ? i.mix(r, n).hexString() : t;
	},
	number(e, t, n) {
		return e + (t - e) * n;
	}
}, Kd = class {
	constructor(e, t, n, r) {
		let i = t[n];
		r = Eu([
			e.to,
			r,
			i,
			e.from
		]);
		let a = Eu([
			e.from,
			i,
			r
		]);
		this._active = !0, this._fn = e.fn || Gd[e.type || typeof a], this._easing = Pl[e.easing] || Pl.linear, this._start = Math.floor(Date.now() + (e.delay || 0)), this._duration = this._total = Math.floor(e.duration), this._loop = !!e.loop, this._target = t, this._prop = n, this._from = a, this._to = r, this._promises = void 0;
	}
	active() {
		return this._active;
	}
	update(e, t, n) {
		if (this._active) {
			this._notify(!1);
			let r = this._target[this._prop], i = n - this._start, a = this._duration - i;
			this._start = n, this._duration = Math.floor(Math.max(a, e.duration)), this._total += i, this._loop = !!e.loop, this._to = Eu([
				e.to,
				t,
				r,
				e.from
			]), this._from = Eu([
				e.from,
				r,
				t
			]);
		}
	}
	cancel() {
		this._active && (this.tick(Date.now()), this._active = !1, this._notify(!1));
	}
	tick(e) {
		let t = e - this._start, n = this._duration, r = this._prop, i = this._from, a = this._loop, o = this._to, s;
		if (this._active = i !== o && (a || t < n), !this._active) {
			this._target[r] = o, this._notify(!0);
			return;
		}
		if (t < 0) {
			this._target[r] = i;
			return;
		}
		s = t / n % 2, s = a && s > 1 ? 2 - s : s, s = this._easing(Math.min(1, Math.max(0, s))), this._target[r] = this._fn(i, o, s);
	}
	wait() {
		let e = this._promises ||= [];
		return new Promise((t, n) => {
			e.push({
				res: t,
				rej: n
			});
		});
	}
	_notify(e) {
		let t = e ? "res" : "rej", n = this._promises || [];
		for (let e = 0; e < n.length; e++) n[e][t]();
	}
}, qd = class {
	constructor(e, t) {
		this._chart = e, this._properties = /* @__PURE__ */ new Map(), this.configure(t);
	}
	configure(e) {
		if (!vc(e)) return;
		let t = Object.keys($l.animation), n = this._properties;
		Object.getOwnPropertyNames(e).forEach((r) => {
			let i = e[r];
			if (!vc(i)) return;
			let a = {};
			for (let e of t) a[e] = i[e];
			(_c(i.properties) && i.properties || [r]).forEach((e) => {
				(e === r || !n.has(e)) && n.set(e, a);
			});
		});
	}
	_animateOptions(e, t) {
		let n = t.options, r = Yd(e, n);
		if (!r) return [];
		let i = this._createAnimations(r, n);
		return n.$shared && Jd(e.options.$animations, n).then(() => {
			e.options = n;
		}, () => {}), i;
	}
	_createAnimations(e, t) {
		let n = this._properties, r = [], i = e.$animations ||= {}, a = Object.keys(t), o = Date.now(), s;
		for (s = a.length - 1; s >= 0; --s) {
			let c = a[s];
			if (c.charAt(0) === "$") continue;
			if (c === "options") {
				r.push(...this._animateOptions(e, t));
				continue;
			}
			let l = t[c], u = i[c], d = n.get(c);
			if (u) if (d && u.active()) {
				u.update(d, l, o);
				continue;
			} else u.cancel();
			if (!d || !d.duration) {
				e[c] = l;
				continue;
			}
			i[c] = u = new Kd(d, e, c, l), r.push(u);
		}
		return r;
	}
	update(e, t) {
		if (this._properties.size === 0) {
			Object.assign(e, t);
			return;
		}
		let n = this._createAnimations(e, t);
		if (n.length) return Ud.add(this._chart, n), !0;
	}
};
function Jd(e, t) {
	let n = [], r = Object.keys(t);
	for (let t = 0; t < r.length; t++) {
		let i = e[r[t]];
		i && i.active() && n.push(i.wait());
	}
	return Promise.all(n);
}
function Yd(e, t) {
	if (!t) return;
	let n = e.options;
	if (!n) {
		e.options = t;
		return;
	}
	return n.$shared && (e.options = n = Object.assign({}, n, {
		$shared: !1,
		$animations: {}
	})), n;
}
function Xd(e, t) {
	let n = e && e.options || {}, r = n.reverse, i = n.min === void 0 ? t : 0, a = n.max === void 0 ? t : 0;
	return {
		start: r ? a : i,
		end: r ? i : a
	};
}
function Zd(e, t, n) {
	if (n === !1) return !1;
	let r = Xd(e, n), i = Xd(t, n);
	return {
		top: i.end,
		right: r.end,
		bottom: i.start,
		left: r.start
	};
}
function Qd(e) {
	let t, n, r, i;
	return vc(e) ? (t = e.top, n = e.right, r = e.bottom, i = e.left) : t = n = r = i = e, {
		top: t,
		right: n,
		bottom: r,
		left: i,
		disabled: e === !1
	};
}
function $d(e, t) {
	let n = [], r = e._getSortedDatasetMetas(t), i, a;
	for (i = 0, a = r.length; i < a; ++i) n.push(r[i].index);
	return n;
}
function ef(e, t, n, r = {}) {
	let i = e.keys, a = r.mode === "single", o, s, c, l;
	if (t === null) return;
	let u = !1;
	for (o = 0, s = i.length; o < s; ++o) {
		if (c = +i[o], c === n) {
			if (u = !0, r.all) continue;
			break;
		}
		l = e.values[c], yc(l) && (a || t === 0 || Xc(t) === Xc(l)) && (t += l);
	}
	return !u && !r.all ? 0 : t;
}
function tf(e, t) {
	let { iScale: n, vScale: r } = t, i = n.axis === "x" ? "x" : "y", a = r.axis === "x" ? "x" : "y", o = Object.keys(e), s = Array(o.length), c, l, u;
	for (c = 0, l = o.length; c < l; ++c) u = o[c], s[c] = {
		[i]: u,
		[a]: e[u]
	};
	return s;
}
function nf(e, t) {
	let n = e && e.options.stacked;
	return n || n === void 0 && t.stack !== void 0;
}
function rf(e, t, n) {
	return `${e.id}.${t.id}.${n.stack || n.type}`;
}
function af(e) {
	let { min: t, max: n, minDefined: r, maxDefined: i } = e.getUserBounds();
	return {
		min: r ? t : -Infinity,
		max: i ? n : Infinity
	};
}
function of(e, t, n) {
	let r = e[t] || (e[t] = {});
	return r[n] || (r[n] = {});
}
function sf(e, t, n, r) {
	for (let i of t.getMatchingVisibleMetas(r).reverse()) {
		let t = e[i.index];
		if (n && t > 0 || !n && t < 0) return i.index;
	}
	return null;
}
function cf(e, t) {
	let { chart: n, _cachedMeta: r } = e, i = n._stacks ||= {}, { iScale: a, vScale: o, index: s } = r, c = a.axis, l = o.axis, u = rf(a, o, r), d = t.length, f;
	for (let e = 0; e < d; ++e) {
		let n = t[e], { [c]: a, [l]: d } = n, p = n._stacks ||= {};
		f = p[l] = of(i, u, a), f[s] = d, f._top = sf(f, o, !0, r.type), f._bottom = sf(f, o, !1, r.type);
		let m = f._visualValues ||= {};
		m[s] = d;
	}
}
function lf(e, t) {
	let n = e.scales;
	return Object.keys(n).filter((e) => n[e].axis === t).shift();
}
function uf(e, t) {
	return Ou(e, {
		active: !1,
		dataset: void 0,
		datasetIndex: t,
		index: t,
		mode: "default",
		type: "dataset"
	});
}
function df(e, t, n) {
	return Ou(e, {
		active: !1,
		dataIndex: t,
		parsed: void 0,
		raw: void 0,
		element: n,
		index: t,
		mode: "default",
		type: "data"
	});
}
function ff(e, t) {
	let n = e.controller.index, r = e.vScale && e.vScale.axis;
	if (r) {
		t ||= e._parsed;
		for (let e of t) {
			let t = e._stacks;
			if (!t || t[r] === void 0 || t[r][n] === void 0) return;
			delete t[r][n], t[r]._visualValues !== void 0 && t[r]._visualValues[n] !== void 0 && delete t[r]._visualValues[n];
		}
	}
}
var pf = (e) => e === "reset" || e === "none", mf = (e, t) => t ? e : Object.assign({}, e), hf = (e, t, n) => e && !t.hidden && t._stacked && {
	keys: $d(n, !0),
	values: null
}, gf = class {
	static defaults = {};
	static datasetElementType = null;
	static dataElementType = null;
	constructor(e, t) {
		this.chart = e, this._ctx = e.ctx, this.index = t, this._cachedDataOpts = {}, this._cachedMeta = this.getMeta(), this._type = this._cachedMeta.type, this.options = void 0, this._parsing = !1, this._data = void 0, this._objectData = void 0, this._sharedOptions = void 0, this._drawStart = void 0, this._drawCount = void 0, this.enableOptionSharing = !1, this.supportsDecimation = !1, this.$context = void 0, this._syncList = [], this.datasetElementType = new.target.datasetElementType, this.dataElementType = new.target.dataElementType, this.initialize();
	}
	initialize() {
		let e = this._cachedMeta;
		this.configure(), this.linkScales(), e._stacked = nf(e.vScale, e), this.addElements(), this.options.fill && !this.chart.isPluginEnabled("filler") && console.warn("Tried to use the 'fill' option without the 'Filler' plugin enabled. Please import and register the 'Filler' plugin and make sure it is not disabled in the options");
	}
	updateIndex(e) {
		this.index !== e && ff(this._cachedMeta), this.index = e;
	}
	linkScales() {
		let e = this.chart, t = this._cachedMeta, n = this.getDataset(), r = (e, t, n, r) => e === "x" ? t : e === "r" ? r : n, i = t.xAxisID = xc(n.xAxisID, lf(e, "x")), a = t.yAxisID = xc(n.yAxisID, lf(e, "y")), o = t.rAxisID = xc(n.rAxisID, lf(e, "r")), s = t.indexAxis, c = t.iAxisID = r(s, i, a, o), l = t.vAxisID = r(s, a, i, o);
		t.xScale = this.getScaleForId(i), t.yScale = this.getScaleForId(a), t.rScale = this.getScaleForId(o), t.iScale = this.getScaleForId(c), t.vScale = this.getScaleForId(l);
	}
	getDataset() {
		return this.chart.data.datasets[this.index];
	}
	getMeta() {
		return this.chart.getDatasetMeta(this.index);
	}
	getScaleForId(e) {
		return this.chart.scales[e];
	}
	_getOtherScale(e) {
		let t = this._cachedMeta;
		return e === t.iScale ? t.vScale : t.iScale;
	}
	reset() {
		this._update("reset");
	}
	_destroy() {
		let e = this._cachedMeta;
		this._data && xl(this._data, this), e._stacked && ff(e);
	}
	_dataCheck() {
		let e = this.getDataset(), t = e.data ||= [], n = this._data;
		if (vc(t)) {
			let e = this._cachedMeta;
			this._data = tf(t, e);
		} else if (n !== t) {
			if (n) {
				xl(n, this);
				let e = this._cachedMeta;
				ff(e), e._parsed = [];
			}
			t && Object.isExtensible(t) && bl(t, this), this._syncList = [], this._data = t;
		}
	}
	addElements() {
		let e = this._cachedMeta;
		this._dataCheck(), this.datasetElementType && (e.dataset = new this.datasetElementType());
	}
	buildOrUpdateElements(e) {
		let t = this._cachedMeta, n = this.getDataset(), r = !1;
		this._dataCheck();
		let i = t._stacked;
		t._stacked = nf(t.vScale, t), t.stack !== n.stack && (r = !0, ff(t), t.stack = n.stack), this._resyncElements(e), (r || i !== t._stacked) && (cf(this, t._parsed), t._stacked = nf(t.vScale, t));
	}
	configure() {
		let e = this.chart.config, t = e.datasetScopeKeys(this._type), n = e.getOptionScopes(this.getDataset(), t, !0);
		this.options = e.createResolver(n, this.getContext()), this._parsing = this.options.parsing, this._cachedDataOpts = {};
	}
	parse(e, t) {
		let { _cachedMeta: n, _data: r } = this, { iScale: i, _stacked: a } = n, o = i.axis, s = e === 0 && t === r.length ? !0 : n._sorted, c = e > 0 && n._parsed[e - 1], l, u, d;
		if (this._parsing === !1) n._parsed = r, n._sorted = !0, d = r;
		else {
			d = _c(r[e]) ? this.parseArrayData(n, r, e, t) : vc(r[e]) ? this.parseObjectData(n, r, e, t) : this.parsePrimitiveData(n, r, e, t);
			let i = () => u[o] === null || c && u[o] < c[o];
			for (l = 0; l < t; ++l) n._parsed[l + e] = u = d[l], s && (i() && (s = !1), c = u);
			n._sorted = s;
		}
		a && cf(this, d);
	}
	parsePrimitiveData(e, t, n, r) {
		let { iScale: i, vScale: a } = e, o = i.axis, s = a.axis, c = i.getLabels(), l = i === a, u = Array(r), d, f, p;
		for (d = 0, f = r; d < f; ++d) p = d + n, u[d] = {
			[o]: l || i.parse(c[p], p),
			[s]: a.parse(t[p], p)
		};
		return u;
	}
	parseArrayData(e, t, n, r) {
		let { xScale: i, yScale: a } = e, o = Array(r), s, c, l, u;
		for (s = 0, c = r; s < c; ++s) l = s + n, u = t[l], o[s] = {
			x: i.parse(u[0], l),
			y: a.parse(u[1], l)
		};
		return o;
	}
	parseObjectData(e, t, n, r) {
		let { xScale: i, yScale: a } = e, { xAxisKey: o = "x", yAxisKey: s = "y" } = this._parsing, c = Array(r), l, u, d, f;
		for (l = 0, u = r; l < u; ++l) d = l + n, f = t[d], c[l] = {
			x: i.parse(Fc(f, o), d),
			y: a.parse(Fc(f, s), d)
		};
		return c;
	}
	getParsed(e) {
		return this._cachedMeta._parsed[e];
	}
	getDataElement(e) {
		return this._cachedMeta.data[e];
	}
	applyStack(e, t, n) {
		let r = this.chart, i = this._cachedMeta, a = t[e.axis];
		return ef({
			keys: $d(r, !0),
			values: t._stacks[e.axis]._visualValues
		}, a, i.index, { mode: n });
	}
	updateRangeFromParsed(e, t, n, r) {
		let i = n[t.axis], a = i === null ? NaN : i, o = r && n._stacks[t.axis];
		r && o && (r.values = o, a = ef(r, i, this._cachedMeta.index)), e.min = Math.min(e.min, a), e.max = Math.max(e.max, a);
	}
	getMinMax(e, t) {
		let n = this._cachedMeta, r = n._parsed, i = n._sorted && e === n.iScale, a = r.length, o = this._getOtherScale(e), s = hf(t, n, this.chart), c = {
			min: Infinity,
			max: -Infinity
		}, { min: l, max: u } = af(o), d, f;
		function p() {
			f = r[d];
			let t = f[o.axis];
			return !yc(f[e.axis]) || l > t || u < t;
		}
		for (d = 0; d < a && !(!p() && (this.updateRangeFromParsed(c, e, f, s), i)); ++d);
		if (i) {
			for (d = a - 1; d >= 0; --d) if (!p()) {
				this.updateRangeFromParsed(c, e, f, s);
				break;
			}
		}
		return c;
	}
	getAllParsedValues(e) {
		let t = this._cachedMeta._parsed, n = [], r, i, a;
		for (r = 0, i = t.length; r < i; ++r) a = t[r][e.axis], yc(a) && n.push(a);
		return n;
	}
	getMaxOverflow() {
		return !1;
	}
	getLabelAndValue(e) {
		let t = this._cachedMeta, n = t.iScale, r = t.vScale, i = this.getParsed(e);
		return {
			label: n ? "" + n.getLabelForValue(i[n.axis]) : "",
			value: r ? "" + r.getLabelForValue(i[r.axis]) : ""
		};
	}
	_update(e) {
		let t = this._cachedMeta;
		this.update(e || "default"), t._clip = Qd(xc(this.options.clip, Zd(t.xScale, t.yScale, this.getMaxOverflow())));
	}
	update(e) {}
	draw() {
		let e = this._ctx, t = this.chart, n = this._cachedMeta, r = n.data || [], i = t.chartArea, a = [], o = this._drawStart || 0, s = this._drawCount || r.length - o, c = this.options.drawActiveElementsOnTop, l;
		for (n.dataset && n.dataset.draw(e, i, o, s), l = o; l < o + s; ++l) {
			let t = r[l];
			t.hidden || (t.active && c ? a.push(t) : t.draw(e, i));
		}
		for (l = 0; l < a.length; ++l) a[l].draw(e, i);
	}
	getStyle(e, t) {
		let n = t ? "active" : "default";
		return e === void 0 && this._cachedMeta.dataset ? this.resolveDatasetElementOptions(n) : this.resolveDataElementOptions(e || 0, n);
	}
	getContext(e, t, n) {
		let r = this.getDataset(), i;
		if (e >= 0 && e < this._cachedMeta.data.length) {
			let t = this._cachedMeta.data[e];
			i = t.$context ||= df(this.getContext(), e, t), i.parsed = this.getParsed(e), i.raw = r.data[e], i.index = i.dataIndex = e;
		} else i = this.$context ||= uf(this.chart.getContext(), this.index), i.dataset = r, i.index = i.datasetIndex = this.index;
		return i.active = !!t, i.mode = n, i;
	}
	resolveDatasetElementOptions(e) {
		return this._resolveElementOptions(this.datasetElementType.id, e);
	}
	resolveDataElementOptions(e, t) {
		return this._resolveElementOptions(this.dataElementType.id, t, e);
	}
	_resolveElementOptions(e, t = "default", n) {
		let r = t === "active", i = this._cachedDataOpts, a = e + "-" + t, o = i[a], s = this.enableOptionSharing && Lc(n);
		if (o) return mf(o, s);
		let c = this.chart.config, l = c.datasetElementScopeKeys(this._type, e), u = r ? [
			`${e}Hover`,
			"hover",
			e,
			""
		] : [e, ""], d = c.getOptionScopes(this.getDataset(), l), f = Object.keys($l.elements[e]), p = c.resolveNamedOptions(d, f, () => this.getContext(n, r, t), u);
		return p.$shared && (p.$shared = s, i[a] = Object.freeze(mf(p, s))), p;
	}
	_resolveAnimations(e, t, n) {
		let r = this.chart, i = this._cachedDataOpts, a = `animation-${t}`, o = i[a];
		if (o) return o;
		let s;
		if (r.options.animation !== !1) {
			let r = this.chart.config, i = r.datasetAnimationScopeKeys(this._type, t), a = r.getOptionScopes(this.getDataset(), i);
			s = r.createResolver(a, this.getContext(e, n, t));
		}
		let c = new qd(r, s && s.animations);
		return s && s._cacheable && (i[a] = Object.freeze(c)), c;
	}
	getSharedOptions(e) {
		if (e.$shared) return this._sharedOptions ||= Object.assign({}, e);
	}
	includeOptions(e, t) {
		return !t || pf(e) || this.chart._animationsDisabled;
	}
	_getSharedOptions(e, t) {
		let n = this.resolveDataElementOptions(e, t), r = this._sharedOptions, i = this.getSharedOptions(n), a = this.includeOptions(t, i) || i !== r;
		return this.updateSharedOptions(i, t, n), {
			sharedOptions: i,
			includeOptions: a
		};
	}
	updateElement(e, t, n, r) {
		pf(r) ? Object.assign(e, n) : this._resolveAnimations(t, r).update(e, n);
	}
	updateSharedOptions(e, t, n) {
		e && !pf(t) && this._resolveAnimations(void 0, t).update(e, n);
	}
	_setStyle(e, t, n, r) {
		e.active = r;
		let i = this.getStyle(t, r);
		this._resolveAnimations(t, n, r).update(e, { options: !r && this.getSharedOptions(i) || i });
	}
	removeHoverStyle(e, t, n) {
		this._setStyle(e, n, "active", !1);
	}
	setHoverStyle(e, t, n) {
		this._setStyle(e, n, "active", !0);
	}
	_removeDatasetHoverStyle() {
		let e = this._cachedMeta.dataset;
		e && this._setStyle(e, void 0, "active", !1);
	}
	_setDatasetHoverStyle() {
		let e = this._cachedMeta.dataset;
		e && this._setStyle(e, void 0, "active", !0);
	}
	_resyncElements(e) {
		let t = this._data, n = this._cachedMeta.data;
		for (let [e, t, n] of this._syncList) this[e](t, n);
		this._syncList = [];
		let r = n.length, i = t.length, a = Math.min(i, r);
		a && this.parse(0, a), i > r ? this._insertElements(r, i - r, e) : i < r && this._removeElements(i, r - i);
	}
	_insertElements(e, t, n = !0) {
		let r = this._cachedMeta, i = r.data, a = e + t, o, s = (e) => {
			for (e.length += t, o = e.length - 1; o >= a; o--) e[o] = e[o - t];
		};
		for (s(i), o = e; o < a; ++o) i[o] = new this.dataElementType();
		this._parsing && s(r._parsed), this.parse(e, t), n && this.updateElements(i, e, t, "reset");
	}
	updateElements(e, t, n, r) {}
	_removeElements(e, t) {
		let n = this._cachedMeta;
		if (this._parsing) {
			let r = n._parsed.splice(e, t);
			n._stacked && ff(n, r);
		}
		n.data.splice(e, t);
	}
	_sync(e) {
		if (this._parsing) this._syncList.push(e);
		else {
			let [t, n, r] = e;
			this[t](n, r);
		}
		this.chart._dataChanges.push([this.index, ...e]);
	}
	_onDataPush() {
		let e = arguments.length;
		this._sync([
			"_insertElements",
			this.getDataset().data.length - e,
			e
		]);
	}
	_onDataPop() {
		this._sync([
			"_removeElements",
			this._cachedMeta.data.length - 1,
			1
		]);
	}
	_onDataShift() {
		this._sync([
			"_removeElements",
			0,
			1
		]);
	}
	_onDataSplice(e, t) {
		t && this._sync([
			"_removeElements",
			e,
			t
		]);
		let n = arguments.length - 2;
		n && this._sync([
			"_insertElements",
			e,
			n
		]);
	}
	_onDataUnshift() {
		this._sync([
			"_insertElements",
			0,
			arguments.length
		]);
	}
};
function _f(e, t) {
	if (!e._cache.$bar) {
		let n = e.getMatchingVisibleMetas(t), r = [];
		for (let t = 0, i = n.length; t < i; t++) r = r.concat(n[t].controller.getAllParsedValues(e));
		e._cache.$bar = Sl(r.sort((e, t) => e - t));
	}
	return e._cache.$bar;
}
function vf(e) {
	let t = e.iScale, n = _f(t, e.type), r = t._length, i, a, o, s, c = () => {
		o === 32767 || o === -32768 || (Lc(s) && (r = Math.min(r, Math.abs(o - s) || r)), s = o);
	};
	for (i = 0, a = n.length; i < a; ++i) o = t.getPixelForValue(n[i]), c();
	for (s = void 0, i = 0, a = t.ticks.length; i < a; ++i) o = t.getPixelForTick(i), c();
	return r;
}
function yf(e, t, n, r) {
	let i = n.barThickness, a, o;
	return gc(i) ? (a = t.min * n.categoryPercentage, o = n.barPercentage) : (a = i * r, o = 1), {
		chunk: a / r,
		ratio: o,
		start: t.pixels[e] - a / 2
	};
}
function bf(e, t, n, r) {
	let i = t.pixels, a = i[e], o = e > 0 ? i[e - 1] : null, s = e < i.length - 1 ? i[e + 1] : null, c = n.categoryPercentage;
	o === null && (o = a - (s === null ? t.end - t.start : s - a)), s === null && (s = a + a - o);
	let l = a - (a - Math.min(o, s)) / 2 * c;
	return {
		chunk: Math.abs(s - o) / 2 * c / r,
		ratio: n.barPercentage,
		start: l
	};
}
function xf(e, t, n, r) {
	let i = n.parse(e[0], r), a = n.parse(e[1], r), o = Math.min(i, a), s = Math.max(i, a), c = o, l = s;
	Math.abs(o) > Math.abs(s) && (c = s, l = o), t[n.axis] = l, t._custom = {
		barStart: c,
		barEnd: l,
		start: i,
		end: a,
		min: o,
		max: s
	};
}
function Sf(e, t, n, r) {
	return _c(e) ? xf(e, t, n, r) : t[n.axis] = n.parse(e, r), t;
}
function Cf(e, t, n, r) {
	let i = e.iScale, a = e.vScale, o = i.getLabels(), s = i === a, c = [], l, u, d, f;
	for (l = n, u = n + r; l < u; ++l) f = t[l], d = {}, d[i.axis] = s || i.parse(o[l], l), c.push(Sf(f, d, a, l));
	return c;
}
function wf(e) {
	return e && e.barStart !== void 0 && e.barEnd !== void 0;
}
function Tf(e, t, n) {
	return e === 0 ? (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1) : Xc(e);
}
function Ef(e) {
	let t, n, r, i, a;
	return e.horizontal ? (t = e.base > e.x, n = "left", r = "right") : (t = e.base < e.y, n = "bottom", r = "top"), t ? (i = "end", a = "start") : (i = "start", a = "end"), {
		start: n,
		end: r,
		reverse: t,
		top: i,
		bottom: a
	};
}
function Df(e, t, n, r) {
	let i = t.borderSkipped, a = {};
	if (!i) {
		e.borderSkipped = a;
		return;
	}
	if (i === !0) {
		e.borderSkipped = {
			top: !0,
			right: !0,
			bottom: !0,
			left: !0
		};
		return;
	}
	let { start: o, end: s, reverse: c, top: l, bottom: u } = Ef(e);
	i === "middle" && n && (e.enableBorderRadius = !0, (n._top || 0) === r ? i = l : (n._bottom || 0) === r ? i = u : (a[Of(u, o, s, c)] = !0, i = l)), a[Of(i, o, s, c)] = !0, e.borderSkipped = a;
}
function Of(e, t, n, r) {
	return r ? (e = kf(e, t, n), e = Af(e, n, t)) : e = Af(e, t, n), e;
}
function kf(e, t, n) {
	return e === t ? n : e === n ? t : e;
}
function Af(e, t, n) {
	return e === "start" ? t : e === "end" ? n : e;
}
function jf(e, { inflateAmount: t }, n) {
	e.inflateAmount = t === "auto" ? n === 1 ? .33 : 0 : t;
}
var Mf = class extends gf {
	static id = "bar";
	static defaults = {
		datasetElementType: !1,
		dataElementType: "bar",
		categoryPercentage: .8,
		barPercentage: .9,
		grouped: !0,
		animations: { numbers: {
			type: "number",
			properties: [
				"x",
				"y",
				"base",
				"width",
				"height"
			]
		} }
	};
	static overrides = { scales: {
		_index_: {
			type: "category",
			offset: !0,
			grid: { offset: !0 }
		},
		_value_: {
			type: "linear",
			beginAtZero: !0
		}
	} };
	parsePrimitiveData(e, t, n, r) {
		return Cf(e, t, n, r);
	}
	parseArrayData(e, t, n, r) {
		return Cf(e, t, n, r);
	}
	parseObjectData(e, t, n, r) {
		let { iScale: i, vScale: a } = e, { xAxisKey: o = "x", yAxisKey: s = "y" } = this._parsing, c = i.axis === "x" ? o : s, l = a.axis === "x" ? o : s, u = [], d, f, p, m;
		for (d = n, f = n + r; d < f; ++d) m = t[d], p = {}, p[i.axis] = i.parse(Fc(m, c), d), u.push(Sf(Fc(m, l), p, a, d));
		return u;
	}
	updateRangeFromParsed(e, t, n, r) {
		super.updateRangeFromParsed(e, t, n, r);
		let i = n._custom;
		i && t === this._cachedMeta.vScale && (e.min = Math.min(e.min, i.min), e.max = Math.max(e.max, i.max));
	}
	getMaxOverflow() {
		return 0;
	}
	getLabelAndValue(e) {
		let { iScale: t, vScale: n } = this._cachedMeta, r = this.getParsed(e), i = r._custom, a = wf(i) ? "[" + i.start + ", " + i.end + "]" : "" + n.getLabelForValue(r[n.axis]);
		return {
			label: "" + t.getLabelForValue(r[t.axis]),
			value: a
		};
	}
	initialize() {
		this.enableOptionSharing = !0, super.initialize();
		let e = this._cachedMeta;
		e.stack = this.getDataset().stack;
	}
	update(e) {
		let t = this._cachedMeta;
		this.updateElements(t.data, 0, t.data.length, e);
	}
	updateElements(e, t, n, r) {
		let i = r === "reset", { index: a, _cachedMeta: { vScale: o } } = this, s = o.getBasePixel(), c = o.isHorizontal(), l = this._getRuler(), { sharedOptions: u, includeOptions: d } = this._getSharedOptions(t, r);
		for (let f = t; f < t + n; f++) {
			let t = this.getParsed(f), n = i || gc(t[o.axis]) ? {
				base: s,
				head: s
			} : this._calculateBarValuePixels(f), p = this._calculateBarIndexPixels(f, l), m = (t._stacks || {})[o.axis], h = {
				horizontal: c,
				base: n.base,
				enableBorderRadius: !m || wf(t._custom) || a === m._top || a === m._bottom,
				x: c ? n.head : p.center,
				y: c ? p.center : n.head,
				height: c ? p.size : Math.abs(n.size),
				width: c ? Math.abs(n.size) : p.size
			};
			d && (h.options = u || this.resolveDataElementOptions(f, e[f].active ? "active" : r));
			let g = h.options || e[f].options;
			Df(h, g, m, a), jf(h, g, l.ratio), this.updateElement(e[f], f, h, r);
		}
	}
	_getStacks(e, t) {
		let { iScale: n } = this._cachedMeta, r = n.getMatchingVisibleMetas(this._type).filter((e) => e.controller.options.grouped), i = n.options.stacked, a = [], o = this._cachedMeta.controller.getParsed(t), s = o && o[n.axis], c = (e) => {
			let t = e._parsed.find((e) => e[n.axis] === s), r = t && t[e.vScale.axis];
			if (gc(r) || isNaN(r)) return !0;
		};
		for (let n of r) if (!(t !== void 0 && c(n)) && ((i === !1 || a.indexOf(n.stack) === -1 || i === void 0 && n.stack === void 0) && a.push(n.stack), n.index === e)) break;
		return a.length || a.push(void 0), a;
	}
	_getStackCount(e) {
		return this._getStacks(void 0, e).length;
	}
	_getAxisCount() {
		return this._getAxis().length;
	}
	getFirstScaleIdForIndexAxis() {
		let e = this.chart.scales, t = this.chart.options.indexAxis;
		return Object.keys(e).filter((n) => e[n].axis === t).shift();
	}
	_getAxis() {
		let e = {}, t = this.getFirstScaleIdForIndexAxis();
		for (let n of this.chart.data.datasets) e[xc(this.chart.options.indexAxis === "x" ? n.xAxisID : n.yAxisID, t)] = !0;
		return Object.keys(e);
	}
	_getStackIndex(e, t, n) {
		let r = this._getStacks(e, n), i = t === void 0 ? -1 : r.indexOf(t);
		return i === -1 ? r.length - 1 : i;
	}
	_getRuler() {
		let e = this.options, t = this._cachedMeta, n = t.iScale, r = [], i, a;
		for (i = 0, a = t.data.length; i < a; ++i) r.push(n.getPixelForValue(this.getParsed(i)[n.axis], i));
		let o = e.barThickness;
		return {
			min: o || vf(t),
			pixels: r,
			start: n._startPixel,
			end: n._endPixel,
			stackCount: this._getStackCount(),
			scale: n,
			grouped: e.grouped,
			ratio: o ? 1 : e.categoryPercentage * e.barPercentage
		};
	}
	_calculateBarValuePixels(e) {
		let { _cachedMeta: { vScale: t, _stacked: n, index: r }, options: { base: i, minBarLength: a } } = this, o = i || 0, s = this.getParsed(e), c = s._custom, l = wf(c), u = s[t.axis], d = 0, f = n ? this.applyStack(t, s, n) : u, p, m;
		f !== u && (d = f - u, f = u), l && (u = c.barStart, f = c.barEnd - c.barStart, u !== 0 && Xc(u) !== Xc(c.barEnd) && (d = 0), d += u);
		let h = !gc(i) && !l ? i : d, g = t.getPixelForValue(h);
		if (p = this.chart.getDataVisibility(e) ? t.getPixelForValue(d + f) : g, m = p - g, Math.abs(m) < a) {
			m = Tf(m, t, o) * a, u === o && (g -= m / 2);
			let e = t.getPixelForDecimal(0), i = t.getPixelForDecimal(1);
			g = Math.max(Math.min(g, Math.max(e, i)), Math.min(e, i)), p = g + m, n && !l && (s._stacks[t.axis]._visualValues[r] = t.getValueForPixel(p) - t.getValueForPixel(g));
		}
		if (g === t.getPixelForValue(o)) {
			let e = Xc(m) * t.getLineWidthForValue(o) / 2;
			g += e, m -= e;
		}
		return {
			size: m,
			base: g,
			head: p,
			center: p + m / 2
		};
	}
	_calculateBarIndexPixels(e, t) {
		let n = t.scale, r = this.options, i = r.skipNull, a = xc(r.maxBarThickness, Infinity), o, s, c = this._getAxisCount();
		if (t.grouped) {
			let n = i ? this._getStackCount(e) : t.stackCount, l = r.barThickness === "flex" ? bf(e, t, r, n * c) : yf(e, t, r, n * c), u = this.chart.options.indexAxis === "x" ? this.getDataset().xAxisID : this.getDataset().yAxisID, d = this._getAxis().indexOf(xc(u, this.getFirstScaleIdForIndexAxis())), f = this._getStackIndex(this.index, this._cachedMeta.stack, i ? e : void 0) + d;
			o = l.start + l.chunk * f + l.chunk / 2, s = Math.min(a, l.chunk * l.ratio);
		} else o = n.getPixelForValue(this.getParsed(e)[n.axis], e), s = Math.min(a, t.min * t.ratio);
		return {
			base: o - s / 2,
			head: o + s / 2,
			center: o,
			size: s
		};
	}
	draw() {
		let e = this._cachedMeta, t = e.vScale, n = e.data, r = n.length, i = 0;
		for (; i < r; ++i) this.getParsed(i)[t.axis] !== null && !n[i].hidden && n[i].draw(this._ctx);
	}
}, Nf = class extends gf {
	static id = "line";
	static defaults = {
		datasetElementType: "line",
		dataElementType: "point",
		showLine: !0,
		spanGaps: !1
	};
	static overrides = { scales: {
		_index_: { type: "category" },
		_value_: { type: "linear" }
	} };
	initialize() {
		this.enableOptionSharing = !0, this.supportsDecimation = !0, super.initialize();
	}
	update(e) {
		let t = this._cachedMeta, { dataset: n, data: r = [], _dataset: i } = t, a = this.chart._animationsDisabled, { start: o, count: s } = kl(t, r, a);
		this._drawStart = o, this._drawCount = s, Al(t) && (o = 0, s = r.length), n._chart = this.chart, n._datasetIndex = this.index, n._decimated = !!i._decimated, n.points = r;
		let c = this.resolveDatasetElementOptions(e);
		this.options.showLine || (c.borderWidth = 0), c.segment = this.options.segment, this.updateElement(n, void 0, {
			animated: !a,
			options: c
		}, e), this.updateElements(r, o, s, e);
	}
	updateElements(e, t, n, r) {
		let i = r === "reset", { iScale: a, vScale: o, _stacked: s, _dataset: c } = this._cachedMeta, { sharedOptions: l, includeOptions: u } = this._getSharedOptions(t, r), d = a.axis, f = o.axis, { spanGaps: p, segment: m } = this.options, h = tl(p) ? p : Infinity, g = this.chart._animationsDisabled || i || r === "none", _ = t + n, v = e.length, y = t > 0 && this.getParsed(t - 1);
		for (let n = 0; n < v; ++n) {
			let p = e[n], v = g ? p : {};
			if (n < t || n >= _) {
				v.skip = !0;
				continue;
			}
			let b = this.getParsed(n), x = gc(b[f]), S = v[d] = a.getPixelForValue(b[d], n), C = v[f] = i || x ? o.getBasePixel() : o.getPixelForValue(s ? this.applyStack(o, b, s) : b[f], n);
			v.skip = isNaN(S) || isNaN(C) || x, v.stop = n > 0 && Math.abs(b[d] - y[d]) > h, m && (v.parsed = b, v.raw = c.data[n]), u && (v.options = l || this.resolveDataElementOptions(n, p.active ? "active" : r)), g || this.updateElement(p, n, v, r), y = b;
		}
	}
	getMaxOverflow() {
		let e = this._cachedMeta, t = e.dataset, n = t.options && t.options.borderWidth || 0, r = e.data || [];
		if (!r.length) return n;
		let i = r[0].size(this.resolveDataElementOptions(0)), a = r[r.length - 1].size(this.resolveDataElementOptions(r.length - 1));
		return Math.max(n, i, a) / 2;
	}
	draw() {
		let e = this._cachedMeta;
		e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis), super.draw();
	}
};
function Pf() {
	throw Error("This method is not implemented: Check that a complete date adapter is provided.");
}
var Ff = { _date: class e {
	static override(t) {
		Object.assign(e.prototype, t);
	}
	options;
	constructor(e) {
		this.options = e || {};
	}
	init() {}
	formats() {
		return Pf();
	}
	parse() {
		return Pf();
	}
	format() {
		return Pf();
	}
	add() {
		return Pf();
	}
	diff() {
		return Pf();
	}
	startOf() {
		return Pf();
	}
	endOf() {
		return Pf();
	}
} };
function If(e, t, n, r) {
	let { controller: i, data: a, _sorted: o } = e, s = i._cachedMeta.iScale, c = e.dataset && e.dataset.options ? e.dataset.options.spanGaps : null;
	if (s && t === s.axis && t !== "r" && o && a.length) {
		let o = s._reversePixels ? _l : gl;
		if (!r) {
			let r = o(a, t, n);
			if (c) {
				let { vScale: t } = i._cachedMeta, { _parsed: n } = e, a = n.slice(0, r.lo + 1).reverse().findIndex((e) => !gc(e[t.axis]));
				r.lo -= Math.max(0, a);
				let o = n.slice(r.hi).findIndex((e) => !gc(e[t.axis]));
				r.hi += Math.max(0, o);
			}
			return r;
		} else if (i._sharedOptions) {
			let e = a[0], r = typeof e.getRange == "function" && e.getRange(t);
			if (r) {
				let e = o(a, t, n - r), i = o(a, t, n + r);
				return {
					lo: e.lo,
					hi: i.hi
				};
			}
		}
	}
	return {
		lo: 0,
		hi: a.length - 1
	};
}
function Lf(e, t, n, r, i) {
	let a = e.getSortedVisibleDatasetMetas(), o = n[t];
	for (let e = 0, n = a.length; e < n; ++e) {
		let { index: n, data: s } = a[e], { lo: c, hi: l } = If(a[e], t, o, i);
		for (let e = c; e <= l; ++e) {
			let t = s[e];
			t.skip || r(t, n, e);
		}
	}
}
function Rf(e) {
	let t = e.indexOf("x") !== -1, n = e.indexOf("y") !== -1;
	return function(e, r) {
		let i = t ? Math.abs(e.x - r.x) : 0, a = n ? Math.abs(e.y - r.y) : 0;
		return Math.sqrt(i ** 2 + a ** 2);
	};
}
function zf(e, t, n, r, i) {
	let a = [];
	return !i && !e.isPointInArea(t) || Lf(e, n, t, function(n, o, s) {
		!i && !su(n, e.chartArea, 0) || n.inRange(t.x, t.y, r) && a.push({
			element: n,
			datasetIndex: o,
			index: s
		});
	}, !0), a;
}
function Bf(e, t, n, r) {
	let i = [];
	function a(e, n, a) {
		let { startAngle: o, endAngle: s } = e.getProps(["startAngle", "endAngle"], r), { angle: c } = sl(e, {
			x: t.x,
			y: t.y
		});
		dl(c, o, s) && i.push({
			element: e,
			datasetIndex: n,
			index: a
		});
	}
	return Lf(e, n, t, a), i;
}
function Vf(e, t, n, r, i, a) {
	let o = [], s = Rf(n), c = Infinity;
	function l(n, l, u) {
		let d = n.inRange(t.x, t.y, i);
		if (r && !d) return;
		let f = n.getCenterPoint(i);
		if (!(a || e.isPointInArea(f)) && !d) return;
		let p = s(t, f);
		p < c ? (o = [{
			element: n,
			datasetIndex: l,
			index: u
		}], c = p) : p === c && o.push({
			element: n,
			datasetIndex: l,
			index: u
		});
	}
	return Lf(e, n, t, l), o;
}
function Hf(e, t, n, r, i, a) {
	return !a && !e.isPointInArea(t) ? [] : n === "r" && !r ? Bf(e, t, n, i) : Vf(e, t, n, r, i, a);
}
function Uf(e, t, n, r, i) {
	let a = [], o = n === "x" ? "inXRange" : "inYRange", s = !1;
	return Lf(e, n, t, (e, r, c) => {
		e[o] && e[o](t[n], i) && (a.push({
			element: e,
			datasetIndex: r,
			index: c
		}), s ||= e.inRange(t.x, t.y, i));
	}), r && !s ? [] : a;
}
var Wf = {
	evaluateInteractionItems: Lf,
	modes: {
		index(e, t, n, r) {
			let i = pd(t, e), a = n.axis || "x", o = n.includeInvisible || !1, s = n.intersect ? zf(e, i, a, r, o) : Hf(e, i, a, !1, r, o), c = [];
			return s.length ? (e.getSortedVisibleDatasetMetas().forEach((e) => {
				let t = s[0].index, n = e.data[t];
				n && !n.skip && c.push({
					element: n,
					datasetIndex: e.index,
					index: t
				});
			}), c) : [];
		},
		dataset(e, t, n, r) {
			let i = pd(t, e), a = n.axis || "xy", o = n.includeInvisible || !1, s = n.intersect ? zf(e, i, a, r, o) : Hf(e, i, a, !1, r, o);
			if (s.length > 0) {
				let t = s[0].datasetIndex, n = e.getDatasetMeta(t).data;
				s = [];
				for (let e = 0; e < n.length; ++e) s.push({
					element: n[e],
					datasetIndex: t,
					index: e
				});
			}
			return s;
		},
		point(e, t, n, r) {
			return zf(e, pd(t, e), n.axis || "xy", r, n.includeInvisible || !1);
		},
		nearest(e, t, n, r) {
			let i = pd(t, e), a = n.axis || "xy", o = n.includeInvisible || !1;
			return Hf(e, i, a, n.intersect, r, o);
		},
		x(e, t, n, r) {
			return Uf(e, pd(t, e), "x", n.intersect, r);
		},
		y(e, t, n, r) {
			return Uf(e, pd(t, e), "y", n.intersect, r);
		}
	}
}, Gf = [
	"left",
	"top",
	"right",
	"bottom"
];
function Kf(e, t) {
	return e.filter((e) => e.pos === t);
}
function qf(e, t) {
	return e.filter((e) => Gf.indexOf(e.pos) === -1 && e.box.axis === t);
}
function Jf(e, t) {
	return e.sort((e, n) => {
		let r = t ? n : e, i = t ? e : n;
		return r.weight === i.weight ? r.index - i.index : r.weight - i.weight;
	});
}
function Yf(e) {
	let t = [], n, r, i, a, o, s;
	for (n = 0, r = (e || []).length; n < r; ++n) i = e[n], {position: a, options: {stack: o, stackWeight: s = 1}} = i, t.push({
		index: n,
		box: i,
		pos: a,
		horizontal: i.isHorizontal(),
		weight: i.weight,
		stack: o && a + o,
		stackWeight: s
	});
	return t;
}
function Xf(e) {
	let t = {};
	for (let n of e) {
		let { stack: e, pos: r, stackWeight: i } = n;
		if (!e || !Gf.includes(r)) continue;
		let a = t[e] || (t[e] = {
			count: 0,
			placed: 0,
			weight: 0,
			size: 0
		});
		a.count++, a.weight += i;
	}
	return t;
}
function Zf(e, t) {
	let n = Xf(e), { vBoxMaxWidth: r, hBoxMaxHeight: i } = t, a, o, s;
	for (a = 0, o = e.length; a < o; ++a) {
		s = e[a];
		let { fullSize: o } = s.box, c = n[s.stack], l = c && s.stackWeight / c.weight;
		s.horizontal ? (s.width = l ? l * r : o && t.availableWidth, s.height = i) : (s.width = r, s.height = l ? l * i : o && t.availableHeight);
	}
	return n;
}
function Qf(e) {
	let t = Yf(e), n = Jf(t.filter((e) => e.box.fullSize), !0), r = Jf(Kf(t, "left"), !0), i = Jf(Kf(t, "right")), a = Jf(Kf(t, "top"), !0), o = Jf(Kf(t, "bottom")), s = qf(t, "x"), c = qf(t, "y");
	return {
		fullSize: n,
		leftAndTop: r.concat(a),
		rightAndBottom: i.concat(c).concat(o).concat(s),
		chartArea: Kf(t, "chartArea"),
		vertical: r.concat(i).concat(c),
		horizontal: a.concat(o).concat(s)
	};
}
function $f(e, t, n, r) {
	return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
}
function ep(e, t) {
	e.top = Math.max(e.top, t.top), e.left = Math.max(e.left, t.left), e.bottom = Math.max(e.bottom, t.bottom), e.right = Math.max(e.right, t.right);
}
function tp(e, t, n, r) {
	let { pos: i, box: a } = n, o = e.maxPadding;
	if (!vc(i)) {
		n.size && (e[i] -= n.size);
		let t = r[n.stack] || {
			size: 0,
			count: 1
		};
		t.size = Math.max(t.size, n.horizontal ? a.height : a.width), n.size = t.size / t.count, e[i] += n.size;
	}
	a.getPadding && ep(o, a.getPadding());
	let s = Math.max(0, t.outerWidth - $f(o, e, "left", "right")), c = Math.max(0, t.outerHeight - $f(o, e, "top", "bottom")), l = s !== e.w, u = c !== e.h;
	return e.w = s, e.h = c, n.horizontal ? {
		same: l,
		other: u
	} : {
		same: u,
		other: l
	};
}
function np(e) {
	let t = e.maxPadding;
	function n(n) {
		let r = Math.max(t[n] - e[n], 0);
		return e[n] += r, r;
	}
	e.y += n("top"), e.x += n("left"), n("right"), n("bottom");
}
function rp(e, t) {
	let n = t.maxPadding;
	function r(e) {
		let r = {
			left: 0,
			top: 0,
			right: 0,
			bottom: 0
		};
		return e.forEach((e) => {
			r[e] = Math.max(t[e], n[e]);
		}), r;
	}
	return r(e ? ["left", "right"] : ["top", "bottom"]);
}
function ip(e, t, n, r) {
	let i = [], a, o, s, c, l, u;
	for (a = 0, o = e.length, l = 0; a < o; ++a) {
		s = e[a], c = s.box, c.update(s.width || t.w, s.height || t.h, rp(s.horizontal, t));
		let { same: o, other: d } = tp(t, n, s, r);
		l |= o && i.length, u ||= d, c.fullSize || i.push(s);
	}
	return l && ip(i, t, n, r) || u;
}
function ap(e, t, n, r, i) {
	e.top = n, e.left = t, e.right = t + r, e.bottom = n + i, e.width = r, e.height = i;
}
function op(e, t, n, r) {
	let i = n.padding, { x: a, y: o } = t;
	for (let s of e) {
		let e = s.box, c = r[s.stack] || {
			count: 1,
			placed: 0,
			weight: 1
		}, l = s.stackWeight / c.weight || 1;
		if (s.horizontal) {
			let r = t.w * l, a = c.size || e.height;
			Lc(c.start) && (o = c.start), e.fullSize ? ap(e, i.left, o, n.outerWidth - i.right - i.left, a) : ap(e, t.left + c.placed, o, r, a), c.start = o, c.placed += r, o = e.bottom;
		} else {
			let r = t.h * l, o = c.size || e.width;
			Lc(c.start) && (a = c.start), e.fullSize ? ap(e, a, i.top, o, n.outerHeight - i.bottom - i.top) : ap(e, a, t.top + c.placed, o, r), c.start = a, c.placed += r, a = e.right;
		}
	}
	t.x = a, t.y = o;
}
var sp = {
	addBox(e, t) {
		e.boxes ||= [], t.fullSize = t.fullSize || !1, t.position = t.position || "top", t.weight = t.weight || 0, t._layers = t._layers || function() {
			return [{
				z: 0,
				draw(e) {
					t.draw(e);
				}
			}];
		}, e.boxes.push(t);
	},
	removeBox(e, t) {
		let n = e.boxes ? e.boxes.indexOf(t) : -1;
		n !== -1 && e.boxes.splice(n, 1);
	},
	configure(e, t, n) {
		t.fullSize = n.fullSize, t.position = n.position, t.weight = n.weight;
	},
	update(e, t, n, r) {
		if (!e) return;
		let i = wu(e.options.layout.padding), a = Math.max(t - i.width, 0), o = Math.max(n - i.height, 0), s = Qf(e.boxes), c = s.vertical, l = s.horizontal;
		wc(e.boxes, (e) => {
			typeof e.beforeLayout == "function" && e.beforeLayout();
		});
		let u = c.reduce((e, t) => t.box.options && t.box.options.display === !1 ? e : e + 1, 0) || 1, d = Object.freeze({
			outerWidth: t,
			outerHeight: n,
			padding: i,
			availableWidth: a,
			availableHeight: o,
			vBoxMaxWidth: a / 2 / u,
			hBoxMaxHeight: o / 2
		}), f = Object.assign({}, i);
		ep(f, wu(r));
		let p = Object.assign({
			maxPadding: f,
			w: a,
			h: o,
			x: i.left,
			y: i.top
		}, i), m = Zf(c.concat(l), d);
		ip(s.fullSize, p, d, m), ip(c, p, d, m), ip(l, p, d, m) && ip(c, p, d, m), np(p), op(s.leftAndTop, p, d, m), p.x += p.w, p.y += p.h, op(s.rightAndBottom, p, d, m), e.chartArea = {
			left: p.left,
			top: p.top,
			right: p.left + p.w,
			bottom: p.top + p.h,
			height: p.h,
			width: p.w
		}, wc(s.chartArea, (t) => {
			let n = t.box;
			Object.assign(n, e.chartArea), n.update(p.w, p.h, {
				left: 0,
				top: 0,
				right: 0,
				bottom: 0
			});
		});
	}
}, cp = class {
	acquireContext(e, t) {}
	releaseContext(e) {
		return !1;
	}
	addEventListener(e, t, n) {}
	removeEventListener(e, t, n) {}
	getDevicePixelRatio() {
		return 1;
	}
	getMaximumSize(e, t, n, r) {
		return t = Math.max(0, t || e.width), n ||= e.height, {
			width: t,
			height: Math.max(0, r ? Math.floor(t / r) : n)
		};
	}
	isAttached(e) {
		return !0;
	}
	updateConfig(e) {}
}, lp = class extends cp {
	acquireContext(e) {
		return e && e.getContext && e.getContext("2d") || null;
	}
	updateConfig(e) {
		e.options.animation = !1;
	}
}, up = "$chartjs", dp = {
	touchstart: "mousedown",
	touchmove: "mousemove",
	touchend: "mouseup",
	pointerenter: "mouseenter",
	pointerdown: "mousedown",
	pointermove: "mousemove",
	pointerup: "mouseup",
	pointerleave: "mouseout",
	pointerout: "mouseout"
}, fp = (e) => e === null || e === "";
function pp(e, t) {
	let n = e.style, r = e.getAttribute("height"), i = e.getAttribute("width");
	if (e[up] = { initial: {
		height: r,
		width: i,
		style: {
			display: n.display,
			height: n.height,
			width: n.width
		}
	} }, n.display = n.display || "block", n.boxSizing = n.boxSizing || "border-box", fp(i)) {
		let t = yd(e, "width");
		t !== void 0 && (e.width = t);
	}
	if (fp(r)) if (e.style.height === "") e.height = e.width / (t || 2);
	else {
		let t = yd(e, "height");
		t !== void 0 && (e.height = t);
	}
	return e;
}
var mp = vd ? { passive: !0 } : !1;
function hp(e, t, n) {
	e && e.addEventListener(t, n, mp);
}
function gp(e, t, n) {
	e && e.canvas && e.canvas.removeEventListener(t, n, mp);
}
function _p(e, t) {
	let n = dp[e.type] || e.type, { x: r, y: i } = pd(e, t);
	return {
		type: n,
		chart: t,
		native: e,
		x: r === void 0 ? null : r,
		y: i === void 0 ? null : i
	};
}
function vp(e, t) {
	for (let n of e) if (n === t || n.contains(t)) return !0;
}
function yp(e, t, n) {
	let r = e.canvas, i = new MutationObserver((e) => {
		let t = !1;
		for (let n of e) t ||= vp(n.addedNodes, r), t &&= !vp(n.removedNodes, r);
		t && n();
	});
	return i.observe(document, {
		childList: !0,
		subtree: !0
	}), i;
}
function bp(e, t, n) {
	let r = e.canvas, i = new MutationObserver((e) => {
		let t = !1;
		for (let n of e) t ||= vp(n.removedNodes, r), t &&= !vp(n.addedNodes, r);
		t && n();
	});
	return i.observe(document, {
		childList: !0,
		subtree: !0
	}), i;
}
var xp = /* @__PURE__ */ new Map(), Sp = 0;
function Cp() {
	let e = window.devicePixelRatio;
	e !== Sp && (Sp = e, xp.forEach((t, n) => {
		n.currentDevicePixelRatio !== e && t();
	}));
}
function wp(e, t) {
	xp.size || window.addEventListener("resize", Cp), xp.set(e, t);
}
function Tp(e) {
	xp.delete(e), xp.size || window.removeEventListener("resize", Cp);
}
function Ep(e, t, n) {
	let r = e.canvas, i = r && ad(r);
	if (!i) return;
	let a = wl((e, t) => {
		let r = i.clientWidth;
		n(e, t), r < i.clientWidth && n();
	}, window), o = new ResizeObserver((e) => {
		let t = e[0], n = t.contentRect.width, r = t.contentRect.height;
		n === 0 && r === 0 || a(n, r);
	});
	return o.observe(i), wp(e, a), o;
}
function Dp(e, t, n) {
	n && n.disconnect(), t === "resize" && Tp(e);
}
function Op(e, t, n) {
	let r = e.canvas, i = wl((t) => {
		e.ctx !== null && n(_p(t, e));
	}, e);
	return hp(r, t, i), i;
}
var kp = class extends cp {
	acquireContext(e, t) {
		let n = e && e.getContext && e.getContext("2d");
		return n && n.canvas === e ? (pp(e, t), n) : null;
	}
	releaseContext(e) {
		let t = e.canvas;
		if (!t[up]) return !1;
		let n = t[up].initial;
		["height", "width"].forEach((e) => {
			let r = n[e];
			gc(r) ? t.removeAttribute(e) : t.setAttribute(e, r);
		});
		let r = n.style || {};
		return Object.keys(r).forEach((e) => {
			t.style[e] = r[e];
		}), t.width = t.width, delete t[up], !0;
	}
	addEventListener(e, t, n) {
		this.removeEventListener(e, t);
		let r = e.$proxies ||= {};
		r[t] = ({
			attach: yp,
			detach: bp,
			resize: Ep
		}[t] || Op)(e, t, n);
	}
	removeEventListener(e, t) {
		let n = e.$proxies ||= {}, r = n[t];
		r && (({
			attach: Dp,
			detach: Dp,
			resize: Dp
		}[t] || gp)(e, t, r), n[t] = void 0);
	}
	getDevicePixelRatio() {
		return window.devicePixelRatio;
	}
	getMaximumSize(e, t, n, r) {
		return gd(e, t, n, r);
	}
	isAttached(e) {
		let t = e && ad(e);
		return !!(t && t.isConnected);
	}
};
function Ap(e) {
	return !id() || typeof OffscreenCanvas < "u" && e instanceof OffscreenCanvas ? lp : kp;
}
var jp = class {
	static defaults = {};
	static defaultRoutes = void 0;
	x;
	y;
	active = !1;
	options;
	$animations;
	tooltipPosition(e) {
		let { x: t, y: n } = this.getProps(["x", "y"], e);
		return {
			x: t,
			y: n
		};
	}
	hasValue() {
		return tl(this.x) && tl(this.y);
	}
	getProps(e, t) {
		let n = this.$animations;
		if (!t || !n) return this;
		let r = {};
		return e.forEach((e) => {
			r[e] = n[e] && n[e].active() ? n[e]._to : this[e];
		}), r;
	}
};
function Mp(e, t) {
	let n = e.options.ticks, r = Np(e), i = Math.min(n.maxTicksLimit || r, r), a = n.major.enabled ? Fp(t) : [], o = a.length, s = a[0], c = a[o - 1], l = [];
	if (o > i) return Ip(t, l, a, o / i), l;
	let u = Pp(a, t, i);
	if (o > 0) {
		let e, n, r = o > 1 ? Math.round((c - s) / (o - 1)) : null;
		for (Lp(t, l, u, gc(r) ? 0 : s - r, s), e = 0, n = o - 1; e < n; e++) Lp(t, l, u, a[e], a[e + 1]);
		return Lp(t, l, u, c, gc(r) ? t.length : c + r), l;
	}
	return Lp(t, l, u), l;
}
function Np(e) {
	let t = e.options.offset, n = e._tickSize(), r = e._length / n + +!t, i = e._maxLength / n;
	return Math.floor(Math.min(r, i));
}
function Pp(e, t, n) {
	let r = Rp(e), i = t.length / n;
	if (!r) return Math.max(i, 1);
	let a = $c(r);
	for (let e = 0, t = a.length - 1; e < t; e++) {
		let t = a[e];
		if (t > i) return t;
	}
	return Math.max(i, 1);
}
function Fp(e) {
	let t = [], n, r;
	for (n = 0, r = e.length; n < r; n++) e[n].major && t.push(n);
	return t;
}
function Ip(e, t, n, r) {
	let i = 0, a = n[0], o;
	for (r = Math.ceil(r), o = 0; o < e.length; o++) o === a && (t.push(e[o]), i++, a = n[i * r]);
}
function Lp(e, t, n, r, i) {
	let a = xc(r, 0), o = Math.min(xc(i, e.length), e.length), s = 0, c, l, u;
	for (n = Math.ceil(n), i && (c = i - r, n = c / Math.floor(c / n)), u = a; u < 0;) s++, u = Math.round(a + s * n);
	for (l = Math.max(a, 0); l < o; l++) l === u && (t.push(e[l]), s++, u = Math.round(a + s * n));
}
function Rp(e) {
	let t = e.length, n, r;
	if (t < 2) return !1;
	for (r = e[0], n = 1; n < t; ++n) if (e[n] - e[n - 1] !== r) return !1;
	return r;
}
var zp = (e) => e === "left" ? "right" : e === "right" ? "left" : e, Bp = (e, t, n) => t === "top" || t === "left" ? e[t] + n : e[t] - n, Vp = (e, t) => Math.min(t || e, e);
function Hp(e, t) {
	let n = [], r = e.length / t, i = e.length, a = 0;
	for (; a < i; a += r) n.push(e[Math.floor(a)]);
	return n;
}
function Up(e, t, n) {
	let r = e.ticks.length, i = Math.min(t, r - 1), a = e._startPixel, o = e._endPixel, s = 1e-6, c = e.getPixelForTick(i), l;
	if (!(n && (l = r === 1 ? Math.max(c - a, o - c) : t === 0 ? (e.getPixelForTick(1) - c) / 2 : (c - e.getPixelForTick(i - 1)) / 2, c += i < t ? l : -l, c < a - s || c > o + s))) return c;
}
function Wp(e, t) {
	wc(e, (e) => {
		let n = e.gc, r = n.length / 2, i;
		if (r > t) {
			for (i = 0; i < r; ++i) delete e.data[n[i]];
			n.splice(0, r);
		}
	});
}
function Gp(e) {
	return e.drawTicks ? e.tickLength : 0;
}
function Kp(e, t) {
	if (!e.display) return 0;
	let n = Tu(e.font, t), r = wu(e.padding);
	return (_c(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
}
function qp(e, t) {
	return Ou(e, {
		scale: t,
		type: "scale"
	});
}
function Jp(e, t, n) {
	return Ou(e, {
		tick: n,
		index: t,
		type: "tick"
	});
}
function Yp(e, t, n) {
	let r = El(e);
	return (n && t !== "right" || !n && t === "right") && (r = zp(r)), r;
}
function Xp(e, t, n, r) {
	let { top: i, left: a, bottom: o, right: s, chart: c } = e, { chartArea: l, scales: u } = c, d = 0, f, p, m, h = o - i, g = s - a;
	if (e.isHorizontal()) {
		if (p = Dl(r, a, s), vc(n)) {
			let e = Object.keys(n)[0], r = n[e];
			m = u[e].getPixelForValue(r) + h - t;
		} else m = n === "center" ? (l.bottom + l.top) / 2 + h - t : Bp(e, n, t);
		f = s - a;
	} else {
		if (vc(n)) {
			let e = Object.keys(n)[0], r = n[e];
			p = u[e].getPixelForValue(r) - g + t;
		} else p = n === "center" ? (l.left + l.right) / 2 - g + t : Bp(e, n, t);
		m = Dl(r, o, i), d = n === "left" ? -Kc : Kc;
	}
	return {
		titleX: p,
		titleY: m,
		maxWidth: f,
		rotation: d
	};
}
var Zp = class e extends jp {
	constructor(e) {
		super(), this.id = e.id, this.type = e.type, this.options = void 0, this.ctx = e.ctx, this.chart = e.chart, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this._margins = {
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, this.maxWidth = void 0, this.maxHeight = void 0, this.paddingTop = void 0, this.paddingBottom = void 0, this.paddingLeft = void 0, this.paddingRight = void 0, this.axis = void 0, this.labelRotation = void 0, this.min = void 0, this.max = void 0, this._range = void 0, this.ticks = [], this._gridLineItems = null, this._labelItems = null, this._labelSizes = null, this._length = 0, this._maxLength = 0, this._longestTextCache = {}, this._startPixel = void 0, this._endPixel = void 0, this._reversePixels = !1, this._userMax = void 0, this._userMin = void 0, this._suggestedMax = void 0, this._suggestedMin = void 0, this._ticksLength = 0, this._borderValue = 0, this._cache = {}, this._dataLimitsCached = !1, this.$context = void 0;
	}
	init(e) {
		this.options = e.setContext(this.getContext()), this.axis = e.axis, this._userMin = this.parse(e.min), this._userMax = this.parse(e.max), this._suggestedMin = this.parse(e.suggestedMin), this._suggestedMax = this.parse(e.suggestedMax);
	}
	parse(e, t) {
		return e;
	}
	getUserBounds() {
		let { _userMin: e, _userMax: t, _suggestedMin: n, _suggestedMax: r } = this;
		return e = bc(e, Infinity), t = bc(t, -Infinity), n = bc(n, Infinity), r = bc(r, -Infinity), {
			min: bc(e, n),
			max: bc(t, r),
			minDefined: yc(e),
			maxDefined: yc(t)
		};
	}
	getMinMax(e) {
		let { min: t, max: n, minDefined: r, maxDefined: i } = this.getUserBounds(), a;
		if (r && i) return {
			min: t,
			max: n
		};
		let o = this.getMatchingVisibleMetas();
		for (let s = 0, c = o.length; s < c; ++s) a = o[s].controller.getMinMax(this, e), r || (t = Math.min(t, a.min)), i || (n = Math.max(n, a.max));
		return t = i && t > n ? n : t, n = r && t > n ? t : n, {
			min: bc(t, bc(n, t)),
			max: bc(n, bc(t, n))
		};
	}
	getPadding() {
		return {
			left: this.paddingLeft || 0,
			top: this.paddingTop || 0,
			right: this.paddingRight || 0,
			bottom: this.paddingBottom || 0
		};
	}
	getTicks() {
		return this.ticks;
	}
	getLabels() {
		let e = this.chart.data;
		return this.options.labels || (this.isHorizontal() ? e.xLabels : e.yLabels) || e.labels || [];
	}
	getLabelItems(e = this.chart.chartArea) {
		return this._labelItems ||= this._computeLabelItems(e);
	}
	beforeLayout() {
		this._cache = {}, this._dataLimitsCached = !1;
	}
	beforeUpdate() {
		Cc(this.options.beforeUpdate, [this]);
	}
	update(e, t, n) {
		let { beginAtZero: r, grace: i, ticks: a } = this.options, o = a.sampleSize;
		this.beforeUpdate(), this.maxWidth = e, this.maxHeight = t, this._margins = n = Object.assign({
			left: 0,
			right: 0,
			top: 0,
			bottom: 0
		}, n), this.ticks = null, this._labelSizes = null, this._gridLineItems = null, this._labelItems = null, this.beforeSetDimensions(), this.setDimensions(), this.afterSetDimensions(), this._maxLength = this.isHorizontal() ? this.width + n.left + n.right : this.height + n.top + n.bottom, this._dataLimitsCached ||= (this.beforeDataLimits(), this.determineDataLimits(), this.afterDataLimits(), this._range = Du(this, i, r), !0), this.beforeBuildTicks(), this.ticks = this.buildTicks() || [], this.afterBuildTicks();
		let s = o < this.ticks.length;
		this._convertTicksToLabels(s ? Hp(this.ticks, o) : this.ticks), this.configure(), this.beforeCalculateLabelRotation(), this.calculateLabelRotation(), this.afterCalculateLabelRotation(), a.display && (a.autoSkip || a.source === "auto") && (this.ticks = Mp(this, this.ticks), this._labelSizes = null, this.afterAutoSkip()), s && this._convertTicksToLabels(this.ticks), this.beforeFit(), this.fit(), this.afterFit(), this.afterUpdate();
	}
	configure() {
		let e = this.options.reverse, t, n;
		this.isHorizontal() ? (t = this.left, n = this.right) : (t = this.top, n = this.bottom, e = !e), this._startPixel = t, this._endPixel = n, this._reversePixels = e, this._length = n - t, this._alignToPixels = this.options.alignToPixels;
	}
	afterUpdate() {
		Cc(this.options.afterUpdate, [this]);
	}
	beforeSetDimensions() {
		Cc(this.options.beforeSetDimensions, [this]);
	}
	setDimensions() {
		this.isHorizontal() ? (this.width = this.maxWidth, this.left = 0, this.right = this.width) : (this.height = this.maxHeight, this.top = 0, this.bottom = this.height), this.paddingLeft = 0, this.paddingTop = 0, this.paddingRight = 0, this.paddingBottom = 0;
	}
	afterSetDimensions() {
		Cc(this.options.afterSetDimensions, [this]);
	}
	_callHooks(e) {
		this.chart.notifyPlugins(e, this.getContext()), Cc(this.options[e], [this]);
	}
	beforeDataLimits() {
		this._callHooks("beforeDataLimits");
	}
	determineDataLimits() {}
	afterDataLimits() {
		this._callHooks("afterDataLimits");
	}
	beforeBuildTicks() {
		this._callHooks("beforeBuildTicks");
	}
	buildTicks() {
		return [];
	}
	afterBuildTicks() {
		this._callHooks("afterBuildTicks");
	}
	beforeTickToLabelConversion() {
		Cc(this.options.beforeTickToLabelConversion, [this]);
	}
	generateTickLabels(e) {
		let t = this.options.ticks, n, r, i;
		for (n = 0, r = e.length; n < r; n++) i = e[n], i.label = Cc(t.callback, [
			i.value,
			n,
			e
		], this);
	}
	afterTickToLabelConversion() {
		Cc(this.options.afterTickToLabelConversion, [this]);
	}
	beforeCalculateLabelRotation() {
		Cc(this.options.beforeCalculateLabelRotation, [this]);
	}
	calculateLabelRotation() {
		let e = this.options, t = e.ticks, n = Vp(this.ticks.length, e.ticks.maxTicksLimit), r = t.minRotation || 0, i = t.maxRotation, a = r, o, s, c;
		if (!this._isVisible() || !t.display || r >= i || n <= 1 || !this.isHorizontal()) {
			this.labelRotation = r;
			return;
		}
		let l = this._getLabelSizes(), u = l.widest.width, d = l.highest.height, f = fl(this.chart.width - u, 0, this.maxWidth);
		o = e.offset ? this.maxWidth / n : f / (n - 1), u + 6 > o && (o = f / (n - (e.offset ? .5 : 1)), s = this.maxHeight - Gp(e.grid) - t.padding - Kp(e.title, this.chart.options.font), c = Math.sqrt(u * u + d * d), a = al(Math.min(Math.asin(fl((l.highest.height + 6) / o, -1, 1)), Math.asin(fl(s / c, -1, 1)) - Math.asin(fl(d / c, -1, 1)))), a = Math.max(r, Math.min(i, a))), this.labelRotation = a;
	}
	afterCalculateLabelRotation() {
		Cc(this.options.afterCalculateLabelRotation, [this]);
	}
	afterAutoSkip() {}
	beforeFit() {
		Cc(this.options.beforeFit, [this]);
	}
	fit() {
		let e = {
			width: 0,
			height: 0
		}, { chart: t, options: { ticks: n, title: r, grid: i } } = this, a = this._isVisible(), o = this.isHorizontal();
		if (a) {
			let a = Kp(r, t.options.font);
			if (o ? (e.width = this.maxWidth, e.height = Gp(i) + a) : (e.height = this.maxHeight, e.width = Gp(i) + a), n.display && this.ticks.length) {
				let { first: t, last: r, widest: i, highest: a } = this._getLabelSizes(), s = n.padding * 2, c = il(this.labelRotation), l = Math.cos(c), u = Math.sin(c);
				if (o) {
					let t = n.mirror ? 0 : u * i.width + l * a.height;
					e.height = Math.min(this.maxHeight, e.height + t + s);
				} else {
					let t = n.mirror ? 0 : l * i.width + u * a.height;
					e.width = Math.min(this.maxWidth, e.width + t + s);
				}
				this._calculatePadding(t, r, u, l);
			}
		}
		this._handleMargins(), o ? (this.width = this._length = t.width - this._margins.left - this._margins.right, this.height = e.height) : (this.width = e.width, this.height = this._length = t.height - this._margins.top - this._margins.bottom);
	}
	_calculatePadding(e, t, n, r) {
		let { ticks: { align: i, padding: a }, position: o } = this.options, s = this.labelRotation !== 0, c = o !== "top" && this.axis === "x";
		if (this.isHorizontal()) {
			let o = this.getPixelForTick(0) - this.left, l = this.right - this.getPixelForTick(this.ticks.length - 1), u = 0, d = 0;
			s ? c ? (u = r * e.width, d = n * t.height) : (u = n * e.height, d = r * t.width) : i === "start" ? d = t.width : i === "end" ? u = e.width : i !== "inner" && (u = e.width / 2, d = t.width / 2), this.paddingLeft = Math.max((u - o + a) * this.width / (this.width - o), 0), this.paddingRight = Math.max((d - l + a) * this.width / (this.width - l), 0);
		} else {
			let n = t.height / 2, r = e.height / 2;
			i === "start" ? (n = 0, r = e.height) : i === "end" && (n = t.height, r = 0), this.paddingTop = n + a, this.paddingBottom = r + a;
		}
	}
	_handleMargins() {
		this._margins && (this._margins.left = Math.max(this.paddingLeft, this._margins.left), this._margins.top = Math.max(this.paddingTop, this._margins.top), this._margins.right = Math.max(this.paddingRight, this._margins.right), this._margins.bottom = Math.max(this.paddingBottom, this._margins.bottom));
	}
	afterFit() {
		Cc(this.options.afterFit, [this]);
	}
	isHorizontal() {
		let { axis: e, position: t } = this.options;
		return t === "top" || t === "bottom" || e === "x";
	}
	isFullSize() {
		return this.options.fullSize;
	}
	_convertTicksToLabels(e) {
		this.beforeTickToLabelConversion(), this.generateTickLabels(e);
		let t, n;
		for (t = 0, n = e.length; t < n; t++) gc(e[t].label) && (e.splice(t, 1), n--, t--);
		this.afterTickToLabelConversion();
	}
	_getLabelSizes() {
		let e = this._labelSizes;
		if (!e) {
			let t = this.options.ticks.sampleSize, n = this.ticks;
			t < n.length && (n = Hp(n, t)), this._labelSizes = e = this._computeLabelSizes(n, n.length, this.options.ticks.maxTicksLimit);
		}
		return e;
	}
	_computeLabelSizes(e, t, n) {
		let { ctx: r, _longestTextCache: i } = this, a = [], o = [], s = Math.floor(t / Vp(t, n)), c = 0, l = 0, u, d, f, p, m, h, g, _, v, y, b;
		for (u = 0; u < t; u += s) {
			if (p = e[u].label, m = this._resolveTickFontOptions(u), r.font = h = m.string, g = i[h] = i[h] || {
				data: {},
				gc: []
			}, _ = m.lineHeight, v = y = 0, !gc(p) && !_c(p)) v = tu(r, g.data, g.gc, v, p), y = _;
			else if (_c(p)) for (d = 0, f = p.length; d < f; ++d) b = p[d], !gc(b) && !_c(b) && (v = tu(r, g.data, g.gc, v, b), y += _);
			a.push(v), o.push(y), c = Math.max(v, c), l = Math.max(y, l);
		}
		Wp(i, t);
		let x = a.indexOf(c), S = o.indexOf(l), C = (e) => ({
			width: a[e] || 0,
			height: o[e] || 0
		});
		return {
			first: C(0),
			last: C(t - 1),
			widest: C(x),
			highest: C(S),
			widths: a,
			heights: o
		};
	}
	getLabelForValue(e) {
		return e;
	}
	getPixelForValue(e, t) {
		return NaN;
	}
	getValueForPixel(e) {}
	getPixelForTick(e) {
		let t = this.ticks;
		return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
	}
	getPixelForDecimal(e) {
		this._reversePixels && (e = 1 - e);
		let t = this._startPixel + e * this._length;
		return pl(this._alignToPixels ? ru(this.chart, t, 0) : t);
	}
	getDecimalForPixel(e) {
		let t = (e - this._startPixel) / this._length;
		return this._reversePixels ? 1 - t : t;
	}
	getBasePixel() {
		return this.getPixelForValue(this.getBaseValue());
	}
	getBaseValue() {
		let { min: e, max: t } = this;
		return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0;
	}
	getContext(e) {
		let t = this.ticks || [];
		if (e >= 0 && e < t.length) {
			let n = t[e];
			return n.$context ||= Jp(this.getContext(), e, n);
		}
		return this.$context ||= qp(this.chart.getContext(), this);
	}
	_tickSize() {
		let e = this.options.ticks, t = il(this.labelRotation), n = Math.abs(Math.cos(t)), r = Math.abs(Math.sin(t)), i = this._getLabelSizes(), a = e.autoSkipPadding || 0, o = i ? i.widest.width + a : 0, s = i ? i.highest.height + a : 0;
		return this.isHorizontal() ? s * n > o * r ? o / n : s / r : s * r < o * n ? s / n : o / r;
	}
	_isVisible() {
		let e = this.options.display;
		return e === "auto" ? this.getMatchingVisibleMetas().length > 0 : !!e;
	}
	_computeGridLineItems(e) {
		let t = this.axis, n = this.chart, r = this.options, { grid: i, position: a, border: o } = r, s = i.offset, c = this.isHorizontal(), l = this.ticks.length + +!!s, u = Gp(i), d = [], f = o.setContext(this.getContext()), p = f.display ? f.width : 0, m = p / 2, h = function(e) {
			return ru(n, e, p);
		}, g, _, v, y, b, x, S, C, w, T, E, D;
		if (a === "top") g = h(this.bottom), x = this.bottom - u, C = g - m, T = h(e.top) + m, D = e.bottom;
		else if (a === "bottom") g = h(this.top), T = e.top, D = h(e.bottom) - m, x = g + m, C = this.top + u;
		else if (a === "left") g = h(this.right), b = this.right - u, S = g - m, w = h(e.left) + m, E = e.right;
		else if (a === "right") g = h(this.left), w = e.left, E = h(e.right) - m, b = g + m, S = this.left + u;
		else if (t === "x") {
			if (a === "center") g = h((e.top + e.bottom) / 2 + .5);
			else if (vc(a)) {
				let e = Object.keys(a)[0], t = a[e];
				g = h(this.chart.scales[e].getPixelForValue(t));
			}
			T = e.top, D = e.bottom, x = g + m, C = x + u;
		} else if (t === "y") {
			if (a === "center") g = h((e.left + e.right) / 2);
			else if (vc(a)) {
				let e = Object.keys(a)[0], t = a[e];
				g = h(this.chart.scales[e].getPixelForValue(t));
			}
			b = g - m, S = b - u, w = e.left, E = e.right;
		}
		let O = xc(r.ticks.maxTicksLimit, l), k = Math.max(1, Math.ceil(l / O));
		for (_ = 0; _ < l; _ += k) {
			let e = this.getContext(_), t = i.setContext(e), r = o.setContext(e), a = t.lineWidth, l = t.color, u = r.dash || [], f = r.dashOffset, p = t.tickWidth, m = t.tickColor, h = t.tickBorderDash || [], g = t.tickBorderDashOffset;
			v = Up(this, _, s), v !== void 0 && (y = ru(n, v, a), c ? b = S = w = E = y : x = C = T = D = y, d.push({
				tx1: b,
				ty1: x,
				tx2: S,
				ty2: C,
				x1: w,
				y1: T,
				x2: E,
				y2: D,
				width: a,
				color: l,
				borderDash: u,
				borderDashOffset: f,
				tickWidth: p,
				tickColor: m,
				tickBorderDash: h,
				tickBorderDashOffset: g
			}));
		}
		return this._ticksLength = l, this._borderValue = g, d;
	}
	_computeLabelItems(e) {
		let t = this.axis, n = this.options, { position: r, ticks: i } = n, a = this.isHorizontal(), o = this.ticks, { align: s, crossAlign: c, padding: l, mirror: u } = i, d = Gp(n.grid), f = d + l, p = u ? -l : f, m = -il(this.labelRotation), h = [], g, _, v, y, b, x, S, C, w, T, E, D, O = "middle";
		if (r === "top") x = this.bottom - p, S = this._getXAxisLabelAlignment();
		else if (r === "bottom") x = this.top + p, S = this._getXAxisLabelAlignment();
		else if (r === "left") {
			let e = this._getYAxisLabelAlignment(d);
			S = e.textAlign, b = e.x;
		} else if (r === "right") {
			let e = this._getYAxisLabelAlignment(d);
			S = e.textAlign, b = e.x;
		} else if (t === "x") {
			if (r === "center") x = (e.top + e.bottom) / 2 + f;
			else if (vc(r)) {
				let e = Object.keys(r)[0], t = r[e];
				x = this.chart.scales[e].getPixelForValue(t) + f;
			}
			S = this._getXAxisLabelAlignment();
		} else if (t === "y") {
			if (r === "center") b = (e.left + e.right) / 2 - f;
			else if (vc(r)) {
				let e = Object.keys(r)[0], t = r[e];
				b = this.chart.scales[e].getPixelForValue(t);
			}
			S = this._getYAxisLabelAlignment(d).textAlign;
		}
		t === "y" && (s === "start" ? O = "top" : s === "end" && (O = "bottom"));
		let k = this._getLabelSizes();
		for (g = 0, _ = o.length; g < _; ++g) {
			v = o[g], y = v.label;
			let e = i.setContext(this.getContext(g));
			C = this.getPixelForTick(g) + i.labelOffset, w = this._resolveTickFontOptions(g), T = w.lineHeight, E = _c(y) ? y.length : 1;
			let t = E / 2, n = e.color, s = e.textStrokeColor, l = e.textStrokeWidth, d = S;
			a ? (b = C, S === "inner" && (d = g === _ - 1 ? this.options.reverse ? "left" : "right" : g === 0 ? this.options.reverse ? "right" : "left" : "center"), D = r === "top" ? c === "near" || m !== 0 ? -E * T + T / 2 : c === "center" ? -k.highest.height / 2 - t * T + T : -k.highest.height + T / 2 : c === "near" || m !== 0 ? T / 2 : c === "center" ? k.highest.height / 2 - t * T : k.highest.height - E * T, u && (D *= -1), m !== 0 && !e.showLabelBackdrop && (b += T / 2 * Math.sin(m))) : (x = C, D = (1 - E) * T / 2);
			let f;
			if (e.showLabelBackdrop) {
				let t = wu(e.backdropPadding), n = k.heights[g], r = k.widths[g], i = D - t.top, a = 0 - t.left;
				switch (O) {
					case "middle":
						i -= n / 2;
						break;
					case "bottom":
						i -= n;
						break;
				}
				switch (S) {
					case "center":
						a -= r / 2;
						break;
					case "right":
						a -= r;
						break;
					case "inner":
						g === _ - 1 ? a -= r : g > 0 && (a -= r / 2);
						break;
				}
				f = {
					left: a,
					top: i,
					width: r + t.width,
					height: n + t.height,
					color: e.backdropColor
				};
			}
			h.push({
				label: y,
				font: w,
				textOffset: D,
				options: {
					rotation: m,
					color: n,
					strokeColor: s,
					strokeWidth: l,
					textAlign: d,
					textBaseline: O,
					translation: [b, x],
					backdrop: f
				}
			});
		}
		return h;
	}
	_getXAxisLabelAlignment() {
		let { position: e, ticks: t } = this.options;
		if (-il(this.labelRotation)) return e === "top" ? "left" : "right";
		let n = "center";
		return t.align === "start" ? n = "left" : t.align === "end" ? n = "right" : t.align === "inner" && (n = "inner"), n;
	}
	_getYAxisLabelAlignment(e) {
		let { position: t, ticks: { crossAlign: n, mirror: r, padding: i } } = this.options, a = this._getLabelSizes(), o = e + i, s = a.widest.width, c, l;
		return t === "left" ? r ? (l = this.right + i, n === "near" ? c = "left" : n === "center" ? (c = "center", l += s / 2) : (c = "right", l += s)) : (l = this.right - o, n === "near" ? c = "right" : n === "center" ? (c = "center", l -= s / 2) : (c = "left", l = this.left)) : t === "right" ? r ? (l = this.left + i, n === "near" ? c = "right" : n === "center" ? (c = "center", l -= s / 2) : (c = "left", l -= s)) : (l = this.left + o, n === "near" ? c = "left" : n === "center" ? (c = "center", l += s / 2) : (c = "right", l = this.right)) : c = "right", {
			textAlign: c,
			x: l
		};
	}
	_computeLabelArea() {
		if (this.options.ticks.mirror) return;
		let e = this.chart, t = this.options.position;
		if (t === "left" || t === "right") return {
			top: 0,
			left: this.left,
			bottom: e.height,
			right: this.right
		};
		if (t === "top" || t === "bottom") return {
			top: this.top,
			left: 0,
			bottom: this.bottom,
			right: e.width
		};
	}
	drawBackground() {
		let { ctx: e, options: { backgroundColor: t }, left: n, top: r, width: i, height: a } = this;
		t && (e.save(), e.fillStyle = t, e.fillRect(n, r, i, a), e.restore());
	}
	getLineWidthForValue(e) {
		let t = this.options.grid;
		if (!this._isVisible() || !t.display) return 0;
		let n = this.ticks.findIndex((t) => t.value === e);
		return n >= 0 ? t.setContext(this.getContext(n)).lineWidth : 0;
	}
	drawGrid(e) {
		let t = this.options.grid, n = this.ctx, r = this._gridLineItems ||= this._computeGridLineItems(e), i, a, o = (e, t, r) => {
			!r.width || !r.color || (n.save(), n.lineWidth = r.width, n.strokeStyle = r.color, n.setLineDash(r.borderDash || []), n.lineDashOffset = r.borderDashOffset, n.beginPath(), n.moveTo(e.x, e.y), n.lineTo(t.x, t.y), n.stroke(), n.restore());
		};
		if (t.display) for (i = 0, a = r.length; i < a; ++i) {
			let e = r[i];
			t.drawOnChartArea && o({
				x: e.x1,
				y: e.y1
			}, {
				x: e.x2,
				y: e.y2
			}, e), t.drawTicks && o({
				x: e.tx1,
				y: e.ty1
			}, {
				x: e.tx2,
				y: e.ty2
			}, {
				color: e.tickColor,
				width: e.tickWidth,
				borderDash: e.tickBorderDash,
				borderDashOffset: e.tickBorderDashOffset
			});
		}
	}
	drawBorder() {
		let { chart: e, ctx: t, options: { border: n, grid: r } } = this, i = n.setContext(this.getContext()), a = n.display ? i.width : 0;
		if (!a) return;
		let o = r.setContext(this.getContext(0)).lineWidth, s = this._borderValue, c, l, u, d;
		this.isHorizontal() ? (c = ru(e, this.left, a) - a / 2, l = ru(e, this.right, o) + o / 2, u = d = s) : (u = ru(e, this.top, a) - a / 2, d = ru(e, this.bottom, o) + o / 2, c = l = s), t.save(), t.lineWidth = i.width, t.strokeStyle = i.color, t.beginPath(), t.moveTo(c, u), t.lineTo(l, d), t.stroke(), t.restore();
	}
	drawLabels(e) {
		if (!this.options.ticks.display) return;
		let t = this.ctx, n = this._computeLabelArea();
		n && cu(t, n);
		let r = this.getLabelItems(e);
		for (let e of r) {
			let n = e.options, r = e.font, i = e.label, a = e.textOffset;
			hu(t, i, 0, a, r, n);
		}
		n && lu(t);
	}
	drawTitle() {
		let { ctx: e, options: { position: t, title: n, reverse: r } } = this;
		if (!n.display) return;
		let i = Tu(n.font), a = wu(n.padding), o = n.align, s = i.lineHeight / 2;
		t === "bottom" || t === "center" || vc(t) ? (s += a.bottom, _c(n.text) && (s += i.lineHeight * (n.text.length - 1))) : s += a.top;
		let { titleX: c, titleY: l, maxWidth: u, rotation: d } = Xp(this, s, t, o);
		hu(e, n.text, 0, 0, i, {
			color: n.color,
			maxWidth: u,
			rotation: d,
			textAlign: Yp(o, t, r),
			textBaseline: "middle",
			translation: [c, l]
		});
	}
	draw(e) {
		this._isVisible() && (this.drawBackground(), this.drawGrid(e), this.drawBorder(), this.drawTitle(), this.drawLabels(e));
	}
	_layers() {
		let t = this.options, n = t.ticks && t.ticks.z || 0, r = xc(t.grid && t.grid.z, -1), i = xc(t.border && t.border.z, 0);
		return !this._isVisible() || this.draw !== e.prototype.draw ? [{
			z: n,
			draw: (e) => {
				this.draw(e);
			}
		}] : [
			{
				z: r,
				draw: (e) => {
					this.drawBackground(), this.drawGrid(e), this.drawTitle();
				}
			},
			{
				z: i,
				draw: () => {
					this.drawBorder();
				}
			},
			{
				z: n,
				draw: (e) => {
					this.drawLabels(e);
				}
			}
		];
	}
	getMatchingVisibleMetas(e) {
		let t = this.chart.getSortedVisibleDatasetMetas(), n = this.axis + "AxisID", r = [], i, a;
		for (i = 0, a = t.length; i < a; ++i) {
			let a = t[i];
			a[n] === this.id && (!e || a.type === e) && r.push(a);
		}
		return r;
	}
	_resolveTickFontOptions(e) {
		return Tu(this.options.ticks.setContext(this.getContext(e)).font);
	}
	_maxDigits() {
		let e = this._resolveTickFontOptions(0).lineHeight;
		return (this.isHorizontal() ? this.width : this.height) / e;
	}
}, Qp = class {
	constructor(e, t, n) {
		this.type = e, this.scope = t, this.override = n, this.items = Object.create(null);
	}
	isForType(e) {
		return Object.prototype.isPrototypeOf.call(this.type.prototype, e.prototype);
	}
	register(e) {
		let t = Object.getPrototypeOf(e), n;
		tm(t) && (n = this.register(t));
		let r = this.items, i = e.id, a = this.scope + "." + i;
		if (!i) throw Error("class does not have id: " + e);
		return i in r ? a : (r[i] = e, $p(e, a, n), this.override && $l.override(e.id, e.overrides), a);
	}
	get(e) {
		return this.items[e];
	}
	unregister(e) {
		let t = this.items, n = e.id, r = this.scope;
		n in t && delete t[n], r && n in $l[r] && (delete $l[r][n], this.override && delete Yl[n]);
	}
};
function $p(e, t, n) {
	let r = kc(Object.create(null), [
		n ? $l.get(n) : {},
		$l.get(t),
		e.defaults
	]);
	$l.set(t, r), e.defaultRoutes && em(t, e.defaultRoutes), e.descriptors && $l.describe(t, e.descriptors);
}
function em(e, t) {
	Object.keys(t).forEach((n) => {
		let r = n.split("."), i = r.pop(), a = [e].concat(r).join("."), o = t[n].split("."), s = o.pop(), c = o.join(".");
		$l.route(a, i, c, s);
	});
}
function tm(e) {
	return "id" in e && "defaults" in e;
}
var nm = /* #__PURE__ */ new class {
	constructor() {
		this.controllers = new Qp(gf, "datasets", !0), this.elements = new Qp(jp, "elements"), this.plugins = new Qp(Object, "plugins"), this.scales = new Qp(Zp, "scales"), this._typedRegistries = [
			this.controllers,
			this.scales,
			this.elements
		];
	}
	add(...e) {
		this._each("register", e);
	}
	remove(...e) {
		this._each("unregister", e);
	}
	addControllers(...e) {
		this._each("register", e, this.controllers);
	}
	addElements(...e) {
		this._each("register", e, this.elements);
	}
	addPlugins(...e) {
		this._each("register", e, this.plugins);
	}
	addScales(...e) {
		this._each("register", e, this.scales);
	}
	getController(e) {
		return this._get(e, this.controllers, "controller");
	}
	getElement(e) {
		return this._get(e, this.elements, "element");
	}
	getPlugin(e) {
		return this._get(e, this.plugins, "plugin");
	}
	getScale(e) {
		return this._get(e, this.scales, "scale");
	}
	removeControllers(...e) {
		this._each("unregister", e, this.controllers);
	}
	removeElements(...e) {
		this._each("unregister", e, this.elements);
	}
	removePlugins(...e) {
		this._each("unregister", e, this.plugins);
	}
	removeScales(...e) {
		this._each("unregister", e, this.scales);
	}
	_each(e, t, n) {
		[...t].forEach((t) => {
			let r = n || this._getRegistryForType(t);
			n || r.isForType(t) || r === this.plugins && t.id ? this._exec(e, r, t) : wc(t, (t) => {
				let r = n || this._getRegistryForType(t);
				this._exec(e, r, t);
			});
		});
	}
	_exec(e, t, n) {
		let r = Ic(e);
		Cc(n["before" + r], [], n), t[e](n), Cc(n["after" + r], [], n);
	}
	_getRegistryForType(e) {
		for (let t = 0; t < this._typedRegistries.length; t++) {
			let n = this._typedRegistries[t];
			if (n.isForType(e)) return n;
		}
		return this.plugins;
	}
	_get(e, t, n) {
		let r = t.get(e);
		if (r === void 0) throw Error("\"" + e + "\" is not a registered " + n + ".");
		return r;
	}
}(), rm = class {
	constructor() {
		this._init = void 0;
	}
	notify(e, t, n, r) {
		if (t === "beforeInit" && (this._init = this._createDescriptors(e, !0), this._notify(this._init, e, "install")), this._init === void 0) return;
		let i = r ? this._descriptors(e).filter(r) : this._descriptors(e), a = this._notify(i, e, t, n);
		return t === "afterDestroy" && (this._notify(i, e, "stop"), this._notify(this._init, e, "uninstall"), this._init = void 0), a;
	}
	_notify(e, t, n, r) {
		r ||= {};
		for (let i of e) {
			let e = i.plugin, a = e[n];
			if (Cc(a, [
				t,
				r,
				i.options
			], e) === !1 && r.cancelable) return !1;
		}
		return !0;
	}
	invalidate() {
		gc(this._cache) || (this._oldCache = this._cache, this._cache = void 0);
	}
	_descriptors(e) {
		if (this._cache) return this._cache;
		let t = this._cache = this._createDescriptors(e);
		return this._notifyStateChanges(e), t;
	}
	_createDescriptors(e, t) {
		let n = e && e.config, r = xc(n.options && n.options.plugins, {}), i = im(n);
		return r === !1 && !t ? [] : om(e, i, r, t);
	}
	_notifyStateChanges(e) {
		let t = this._oldCache || [], n = this._cache, r = (e, t) => e.filter((e) => !t.some((t) => e.plugin.id === t.plugin.id));
		this._notify(r(t, n), e, "stop"), this._notify(r(n, t), e, "start");
	}
};
function im(e) {
	let t = {}, n = [], r = Object.keys(nm.plugins.items);
	for (let e = 0; e < r.length; e++) n.push(nm.getPlugin(r[e]));
	let i = e.plugins || [];
	for (let e = 0; e < i.length; e++) {
		let r = i[e];
		n.indexOf(r) === -1 && (n.push(r), t[r.id] = !0);
	}
	return {
		plugins: n,
		localIds: t
	};
}
function am(e, t) {
	return !t && e === !1 ? null : e === !0 ? {} : e;
}
function om(e, { plugins: t, localIds: n }, r, i) {
	let a = [], o = e.getContext();
	for (let s of t) {
		let t = s.id, c = am(r[t], i);
		c !== null && a.push({
			plugin: s,
			options: sm(e.config, {
				plugin: s,
				local: n[t]
			}, c, o)
		});
	}
	return a;
}
function sm(e, { plugin: t, local: n }, r, i) {
	let a = e.pluginScopeKeys(t), o = e.getOptionScopes(r, a);
	return n && t.defaults && o.push(t.defaults), e.createResolver(o, i, [""], {
		scriptable: !1,
		indexable: !1,
		allKeys: !0
	});
}
function cm(e, t) {
	let n = $l.datasets[e] || {};
	return ((t.datasets || {})[e] || {}).indexAxis || t.indexAxis || n.indexAxis || "x";
}
function lm(e, t) {
	let n = e;
	return e === "_index_" ? n = t : e === "_value_" && (n = t === "x" ? "y" : "x"), n;
}
function um(e, t) {
	return e === t ? "_index_" : "_value_";
}
function dm(e) {
	if (e === "x" || e === "y" || e === "r") return e;
}
function fm(e) {
	if (e === "top" || e === "bottom") return "x";
	if (e === "left" || e === "right") return "y";
}
function pm(e, ...t) {
	if (dm(e)) return e;
	for (let n of t) {
		let t = n.axis || fm(n.position) || e.length > 1 && dm(e[0].toLowerCase());
		if (t) return t;
	}
	throw Error(`Cannot determine type of '${e}' axis. Please provide 'axis' or 'position' option.`);
}
function mm(e, t, n) {
	if (n[t + "AxisID"] === e) return { axis: t };
}
function hm(e, t) {
	if (t.data && t.data.datasets) {
		let n = t.data.datasets.filter((t) => t.xAxisID === e || t.yAxisID === e);
		if (n.length) return mm(e, "x", n[0]) || mm(e, "y", n[0]);
	}
	return {};
}
function gm(e, t) {
	let n = Yl[e.type] || { scales: {} }, r = t.scales || {}, i = cm(e.type, t), a = Object.create(null);
	return Object.keys(r).forEach((t) => {
		let o = r[t];
		if (!vc(o)) return console.error(`Invalid scale configuration for scale: ${t}`);
		if (o._proxy) return console.warn(`Ignoring resolver passed as options for scale: ${t}`);
		let s = pm(t, o, hm(t, e), $l.scales[o.type]), c = um(s, i), l = n.scales || {};
		a[t] = Ac(Object.create(null), [
			{ axis: s },
			o,
			l[s],
			l[c]
		]);
	}), e.data.datasets.forEach((n) => {
		let i = n.type || e.type, o = n.indexAxis || cm(i, t), s = (Yl[i] || {}).scales || {};
		Object.keys(s).forEach((e) => {
			let t = lm(e, o), i = n[t + "AxisID"] || t;
			a[i] = a[i] || Object.create(null), Ac(a[i], [
				{ axis: t },
				r[i],
				s[e]
			]);
		});
	}), Object.keys(a).forEach((e) => {
		let t = a[e];
		Ac(t, [$l.scales[t.type], $l.scale]);
	}), a;
}
function _m(e) {
	let t = e.options ||= {};
	t.plugins = xc(t.plugins, {}), t.scales = gm(e, t);
}
function vm(e) {
	return e ||= {}, e.datasets = e.datasets || [], e.labels = e.labels || [], e;
}
function ym(e) {
	return e ||= {}, e.data = vm(e.data), _m(e), e;
}
var bm = /* @__PURE__ */ new Map(), xm = /* @__PURE__ */ new Set();
function Sm(e, t) {
	let n = bm.get(e);
	return n || (n = t(), bm.set(e, n), xm.add(n)), n;
}
var Cm = (e, t, n) => {
	let r = Fc(t, n);
	r !== void 0 && e.add(r);
}, wm = class {
	constructor(e) {
		this._config = ym(e), this._scopeCache = /* @__PURE__ */ new Map(), this._resolverCache = /* @__PURE__ */ new Map();
	}
	get platform() {
		return this._config.platform;
	}
	get type() {
		return this._config.type;
	}
	set type(e) {
		this._config.type = e;
	}
	get data() {
		return this._config.data;
	}
	set data(e) {
		this._config.data = vm(e);
	}
	get options() {
		return this._config.options;
	}
	set options(e) {
		this._config.options = e;
	}
	get plugins() {
		return this._config.plugins;
	}
	update() {
		let e = this._config;
		this.clearCache(), _m(e);
	}
	clearCache() {
		this._scopeCache.clear(), this._resolverCache.clear();
	}
	datasetScopeKeys(e) {
		return Sm(e, () => [[`datasets.${e}`, ""]]);
	}
	datasetAnimationScopeKeys(e, t) {
		return Sm(`${e}.transition.${t}`, () => [[`datasets.${e}.transitions.${t}`, `transitions.${t}`], [`datasets.${e}`, ""]]);
	}
	datasetElementScopeKeys(e, t) {
		return Sm(`${e}-${t}`, () => [[
			`datasets.${e}.elements.${t}`,
			`datasets.${e}`,
			`elements.${t}`,
			""
		]]);
	}
	pluginScopeKeys(e) {
		let t = e.id, n = this.type;
		return Sm(`${n}-plugin-${t}`, () => [[`plugins.${t}`, ...e.additionalOptionScopes || []]]);
	}
	_cachedScopes(e, t) {
		let n = this._scopeCache, r = n.get(e);
		return (!r || t) && (r = /* @__PURE__ */ new Map(), n.set(e, r)), r;
	}
	getOptionScopes(e, t, n) {
		let { options: r, type: i } = this, a = this._cachedScopes(e, n), o = a.get(t);
		if (o) return o;
		let s = /* @__PURE__ */ new Set();
		t.forEach((t) => {
			e && (s.add(e), t.forEach((t) => Cm(s, e, t))), t.forEach((e) => Cm(s, r, e)), t.forEach((e) => Cm(s, Yl[i] || {}, e)), t.forEach((e) => Cm(s, $l, e)), t.forEach((e) => Cm(s, Xl, e));
		});
		let c = Array.from(s);
		return c.length === 0 && c.push(Object.create(null)), xm.has(t) && a.set(t, c), c;
	}
	chartOptionScopes() {
		let { options: e, type: t } = this;
		return [
			e,
			Yl[t] || {},
			$l.datasets[t] || {},
			{ type: t },
			$l,
			Xl
		];
	}
	resolveNamedOptions(e, t, n, r = [""]) {
		let i = { $shared: !0 }, { resolver: a, subPrefixes: o } = Tm(this._resolverCache, e, r), s = a;
		if (Dm(a, t)) {
			i.$shared = !1, n = Rc(n) ? n() : n;
			let t = this.createResolver(e, n, o);
			s = Au(a, n, t);
		}
		for (let e of t) i[e] = s[e];
		return i;
	}
	createResolver(e, t, n = [""], r) {
		let { resolver: i } = Tm(this._resolverCache, e, n);
		return vc(t) ? Au(i, t, void 0, r) : i;
	}
};
function Tm(e, t, n) {
	let r = e.get(t);
	r || (r = /* @__PURE__ */ new Map(), e.set(t, r));
	let i = n.join(), a = r.get(i);
	return a || (a = {
		resolver: ku(t, n),
		subPrefixes: n.filter((e) => !e.toLowerCase().includes("hover"))
	}, r.set(i, a)), a;
}
var Em = (e) => vc(e) && Object.getOwnPropertyNames(e).some((t) => Rc(e[t]));
function Dm(e, t) {
	let { isScriptable: n, isIndexable: r } = ju(e);
	for (let i of t) {
		let t = n(i), a = r(i), o = (a || t) && e[i];
		if (t && (Rc(o) || Em(o)) || a && _c(o)) return !0;
	}
	return !1;
}
var Om = "4.5.1", km = [
	"top",
	"bottom",
	"left",
	"right",
	"chartArea"
];
function Am(e, t) {
	return e === "top" || e === "bottom" || km.indexOf(e) === -1 && t === "x";
}
function jm(e, t) {
	return function(n, r) {
		return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
	};
}
function Mm(e) {
	let t = e.chart, n = t.options.animation;
	t.notifyPlugins("afterRender"), Cc(n && n.onComplete, [e], t);
}
function Nm(e) {
	let t = e.chart, n = t.options.animation;
	Cc(n && n.onProgress, [e], t);
}
function Pm(e) {
	return id() && typeof e == "string" ? e = document.getElementById(e) : e && e.length && (e = e[0]), e && e.canvas && (e = e.canvas), e;
}
var Fm = {}, Im = (e) => {
	let t = Pm(e);
	return Object.values(Fm).filter((e) => e.canvas === t).pop();
};
function Lm(e, t, n) {
	let r = Object.keys(e);
	for (let i of r) {
		let r = +i;
		if (r >= t) {
			let a = e[i];
			delete e[i], (n > 0 || r > t) && (e[r + n] = a);
		}
	}
}
function Rm(e, t, n, r) {
	return !n || e.type === "mouseout" ? null : r ? t : e;
}
var zm = class {
	static defaults = $l;
	static instances = Fm;
	static overrides = Yl;
	static registry = nm;
	static version = Om;
	static getChart = Im;
	static register(...e) {
		nm.add(...e), Bm();
	}
	static unregister(...e) {
		nm.remove(...e), Bm();
	}
	constructor(e, t) {
		let n = this.config = new wm(t), r = Pm(e), i = Im(r);
		if (i) throw Error("Canvas is already in use. Chart with ID '" + i.id + "' must be destroyed before the canvas with ID '" + i.canvas.id + "' can be reused.");
		let a = n.createResolver(n.chartOptionScopes(), this.getContext());
		this.platform = new (n.platform || (Ap(r)))(), this.platform.updateConfig(n);
		let o = this.platform.acquireContext(r, a.aspectRatio), s = o && o.canvas, c = s && s.height, l = s && s.width;
		if (this.id = hc(), this.ctx = o, this.canvas = s, this.width = l, this.height = c, this._options = a, this._aspectRatio = this.aspectRatio, this._layers = [], this._metasets = [], this._stacks = void 0, this.boxes = [], this.currentDevicePixelRatio = void 0, this.chartArea = void 0, this._active = [], this._lastEvent = void 0, this._listeners = {}, this._responsiveListeners = void 0, this._sortedMetasets = [], this.scales = {}, this._plugins = new rm(), this.$proxies = {}, this._hiddenIndices = {}, this.attached = !1, this._animationsDisabled = void 0, this.$context = void 0, this._doResize = Tl((e) => this.update(e), a.resizeDelay || 0), this._dataChanges = [], Fm[this.id] = this, !o || !s) {
			console.error("Failed to create chart: can't acquire context from the given item");
			return;
		}
		Ud.listen(this, "complete", Mm), Ud.listen(this, "progress", Nm), this._initialize(), this.attached && this.update();
	}
	get aspectRatio() {
		let { options: { aspectRatio: e, maintainAspectRatio: t }, width: n, height: r, _aspectRatio: i } = this;
		return gc(e) ? t && i ? i : r ? n / r : null : e;
	}
	get data() {
		return this.config.data;
	}
	set data(e) {
		this.config.data = e;
	}
	get options() {
		return this._options;
	}
	set options(e) {
		this.config.options = e;
	}
	get registry() {
		return nm;
	}
	_initialize() {
		return this.notifyPlugins("beforeInit"), this.options.responsive ? this.resize() : _d(this, this.options.devicePixelRatio), this.bindEvents(), this.notifyPlugins("afterInit"), this;
	}
	clear() {
		return iu(this.canvas, this.ctx), this;
	}
	stop() {
		return Ud.stop(this), this;
	}
	resize(e, t) {
		Ud.running(this) ? this._resizeBeforeDraw = {
			width: e,
			height: t
		} : this._resize(e, t);
	}
	_resize(e, t) {
		let n = this.options, r = this.canvas, i = n.maintainAspectRatio && this.aspectRatio, a = this.platform.getMaximumSize(r, e, t, i), o = n.devicePixelRatio || this.platform.getDevicePixelRatio(), s = this.width ? "resize" : "attach";
		this.width = a.width, this.height = a.height, this._aspectRatio = this.aspectRatio, _d(this, o, !0) && (this.notifyPlugins("resize", { size: a }), Cc(n.onResize, [this, a], this), this.attached && this._doResize(s) && this.render());
	}
	ensureScalesHaveIDs() {
		wc(this.options.scales || {}, (e, t) => {
			e.id = t;
		});
	}
	buildOrUpdateScales() {
		let e = this.options, t = e.scales, n = this.scales, r = Object.keys(n).reduce((e, t) => (e[t] = !1, e), {}), i = [];
		t && (i = i.concat(Object.keys(t).map((e) => {
			let n = t[e], r = pm(e, n), i = r === "r", a = r === "x";
			return {
				options: n,
				dposition: i ? "chartArea" : a ? "bottom" : "left",
				dtype: i ? "radialLinear" : a ? "category" : "linear"
			};
		}))), wc(i, (t) => {
			let i = t.options, a = i.id, o = pm(a, i), s = xc(i.type, t.dtype);
			(i.position === void 0 || Am(i.position, o) !== Am(t.dposition)) && (i.position = t.dposition), r[a] = !0;
			let c = null;
			a in n && n[a].type === s ? c = n[a] : (c = new (nm.getScale(s))({
				id: a,
				type: s,
				ctx: this.ctx,
				chart: this
			}), n[c.id] = c), c.init(i, e);
		}), wc(r, (e, t) => {
			e || delete n[t];
		}), wc(n, (e) => {
			sp.configure(this, e, e.options), sp.addBox(this, e);
		});
	}
	_updateMetasets() {
		let e = this._metasets, t = this.data.datasets.length, n = e.length;
		if (e.sort((e, t) => e.index - t.index), n > t) {
			for (let e = t; e < n; ++e) this._destroyDatasetMeta(e);
			e.splice(t, n - t);
		}
		this._sortedMetasets = e.slice(0).sort(jm("order", "index"));
	}
	_removeUnreferencedMetasets() {
		let { _metasets: e, data: { datasets: t } } = this;
		e.length > t.length && delete this._stacks, e.forEach((e, n) => {
			t.filter((t) => t === e._dataset).length === 0 && this._destroyDatasetMeta(n);
		});
	}
	buildOrUpdateControllers() {
		let e = [], t = this.data.datasets, n, r;
		for (this._removeUnreferencedMetasets(), n = 0, r = t.length; n < r; n++) {
			let r = t[n], i = this.getDatasetMeta(n), a = r.type || this.config.type;
			if (i.type && i.type !== a && (this._destroyDatasetMeta(n), i = this.getDatasetMeta(n)), i.type = a, i.indexAxis = r.indexAxis || cm(a, this.options), i.order = r.order || 0, i.index = n, i.label = "" + r.label, i.visible = this.isDatasetVisible(n), i.controller) i.controller.updateIndex(n), i.controller.linkScales();
			else {
				let t = nm.getController(a), { datasetElementType: r, dataElementType: o } = $l.datasets[a];
				Object.assign(t, {
					dataElementType: nm.getElement(o),
					datasetElementType: r && nm.getElement(r)
				}), i.controller = new t(this, n), e.push(i.controller);
			}
		}
		return this._updateMetasets(), e;
	}
	_resetElements() {
		wc(this.data.datasets, (e, t) => {
			this.getDatasetMeta(t).controller.reset();
		}, this);
	}
	reset() {
		this._resetElements(), this.notifyPlugins("reset");
	}
	update(e) {
		let t = this.config;
		t.update();
		let n = this._options = t.createResolver(t.chartOptionScopes(), this.getContext()), r = this._animationsDisabled = !n.animation;
		if (this._updateScales(), this._checkEventBindings(), this._updateHiddenIndices(), this._plugins.invalidate(), this.notifyPlugins("beforeUpdate", {
			mode: e,
			cancelable: !0
		}) === !1) return;
		let i = this.buildOrUpdateControllers();
		this.notifyPlugins("beforeElementsUpdate");
		let a = 0;
		for (let e = 0, t = this.data.datasets.length; e < t; e++) {
			let { controller: t } = this.getDatasetMeta(e), n = !r && i.indexOf(t) === -1;
			t.buildOrUpdateElements(n), a = Math.max(+t.getMaxOverflow(), a);
		}
		a = this._minPadding = n.layout.autoPadding ? a : 0, this._updateLayout(a), r || wc(i, (e) => {
			e.reset();
		}), this._updateDatasets(e), this.notifyPlugins("afterUpdate", { mode: e }), this._layers.sort(jm("z", "_idx"));
		let { _active: o, _lastEvent: s } = this;
		s ? this._eventHandler(s, !0) : o.length && this._updateHoverStyles(o, o, !0), this.render();
	}
	_updateScales() {
		wc(this.scales, (e) => {
			sp.removeBox(this, e);
		}), this.ensureScalesHaveIDs(), this.buildOrUpdateScales();
	}
	_checkEventBindings() {
		let e = this.options;
		(!zc(new Set(Object.keys(this._listeners)), new Set(e.events)) || !!this._responsiveListeners !== e.responsive) && (this.unbindEvents(), this.bindEvents());
	}
	_updateHiddenIndices() {
		let { _hiddenIndices: e } = this, t = this._getUniformDataChanges() || [];
		for (let { method: n, start: r, count: i } of t) Lm(e, r, n === "_removeElements" ? -i : i);
	}
	_getUniformDataChanges() {
		let e = this._dataChanges;
		if (!e || !e.length) return;
		this._dataChanges = [];
		let t = this.data.datasets.length, n = (t) => new Set(e.filter((e) => e[0] === t).map((e, t) => t + "," + e.splice(1).join(","))), r = n(0);
		for (let e = 1; e < t; e++) if (!zc(r, n(e))) return;
		return Array.from(r).map((e) => e.split(",")).map((e) => ({
			method: e[1],
			start: +e[2],
			count: +e[3]
		}));
	}
	_updateLayout(e) {
		if (this.notifyPlugins("beforeLayout", { cancelable: !0 }) === !1) return;
		sp.update(this, this.width, this.height, e);
		let t = this.chartArea, n = t.width <= 0 || t.height <= 0;
		this._layers = [], wc(this.boxes, (e) => {
			n && e.position === "chartArea" || (e.configure && e.configure(), this._layers.push(...e._layers()));
		}, this), this._layers.forEach((e, t) => {
			e._idx = t;
		}), this.notifyPlugins("afterLayout");
	}
	_updateDatasets(e) {
		if (this.notifyPlugins("beforeDatasetsUpdate", {
			mode: e,
			cancelable: !0
		}) !== !1) {
			for (let e = 0, t = this.data.datasets.length; e < t; ++e) this.getDatasetMeta(e).controller.configure();
			for (let t = 0, n = this.data.datasets.length; t < n; ++t) this._updateDataset(t, Rc(e) ? e({ datasetIndex: t }) : e);
			this.notifyPlugins("afterDatasetsUpdate", { mode: e });
		}
	}
	_updateDataset(e, t) {
		let n = this.getDatasetMeta(e), r = {
			meta: n,
			index: e,
			mode: t,
			cancelable: !0
		};
		this.notifyPlugins("beforeDatasetUpdate", r) !== !1 && (n.controller._update(t), r.cancelable = !1, this.notifyPlugins("afterDatasetUpdate", r));
	}
	render() {
		this.notifyPlugins("beforeRender", { cancelable: !0 }) !== !1 && (Ud.has(this) ? this.attached && !Ud.running(this) && Ud.start(this) : (this.draw(), Mm({ chart: this })));
	}
	draw() {
		let e;
		if (this._resizeBeforeDraw) {
			let { width: e, height: t } = this._resizeBeforeDraw;
			this._resizeBeforeDraw = null, this._resize(e, t);
		}
		if (this.clear(), this.width <= 0 || this.height <= 0 || this.notifyPlugins("beforeDraw", { cancelable: !0 }) === !1) return;
		let t = this._layers;
		for (e = 0; e < t.length && t[e].z <= 0; ++e) t[e].draw(this.chartArea);
		for (this._drawDatasets(); e < t.length; ++e) t[e].draw(this.chartArea);
		this.notifyPlugins("afterDraw");
	}
	_getSortedDatasetMetas(e) {
		let t = this._sortedMetasets, n = [], r, i;
		for (r = 0, i = t.length; r < i; ++r) {
			let i = t[r];
			(!e || i.visible) && n.push(i);
		}
		return n;
	}
	getSortedVisibleDatasetMetas() {
		return this._getSortedDatasetMetas(!0);
	}
	_drawDatasets() {
		if (this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 }) === !1) return;
		let e = this.getSortedVisibleDatasetMetas();
		for (let t = e.length - 1; t >= 0; --t) this._drawDataset(e[t]);
		this.notifyPlugins("afterDatasetsDraw");
	}
	_drawDataset(e) {
		let t = this.ctx, n = {
			meta: e,
			index: e.index,
			cancelable: !0
		}, r = Hd(this, e);
		this.notifyPlugins("beforeDatasetDraw", n) !== !1 && (r && cu(t, r), e.controller.draw(), r && lu(t), n.cancelable = !1, this.notifyPlugins("afterDatasetDraw", n));
	}
	isPointInArea(e) {
		return su(e, this.chartArea, this._minPadding);
	}
	getElementsAtEventForMode(e, t, n, r) {
		let i = Wf.modes[t];
		return typeof i == "function" ? i(this, e, n, r) : [];
	}
	getDatasetMeta(e) {
		let t = this.data.datasets[e], n = this._metasets, r = n.filter((e) => e && e._dataset === t).pop();
		return r || (r = {
			type: null,
			data: [],
			dataset: null,
			controller: null,
			hidden: null,
			xAxisID: null,
			yAxisID: null,
			order: t && t.order || 0,
			index: e,
			_dataset: t,
			_parsed: [],
			_sorted: !1
		}, n.push(r)), r;
	}
	getContext() {
		return this.$context ||= Ou(null, {
			chart: this,
			type: "chart"
		});
	}
	getVisibleDatasetCount() {
		return this.getSortedVisibleDatasetMetas().length;
	}
	isDatasetVisible(e) {
		let t = this.data.datasets[e];
		if (!t) return !1;
		let n = this.getDatasetMeta(e);
		return typeof n.hidden == "boolean" ? !n.hidden : !t.hidden;
	}
	setDatasetVisibility(e, t) {
		let n = this.getDatasetMeta(e);
		n.hidden = !t;
	}
	toggleDataVisibility(e) {
		this._hiddenIndices[e] = !this._hiddenIndices[e];
	}
	getDataVisibility(e) {
		return !this._hiddenIndices[e];
	}
	_updateVisibility(e, t, n) {
		let r = n ? "show" : "hide", i = this.getDatasetMeta(e), a = i.controller._resolveAnimations(void 0, r);
		Lc(t) ? (i.data[t].hidden = !n, this.update()) : (this.setDatasetVisibility(e, n), a.update(i, { visible: n }), this.update((t) => t.datasetIndex === e ? r : void 0));
	}
	hide(e, t) {
		this._updateVisibility(e, t, !1);
	}
	show(e, t) {
		this._updateVisibility(e, t, !0);
	}
	_destroyDatasetMeta(e) {
		let t = this._metasets[e];
		t && t.controller && t.controller._destroy(), delete this._metasets[e];
	}
	_stop() {
		let e, t;
		for (this.stop(), Ud.remove(this), e = 0, t = this.data.datasets.length; e < t; ++e) this._destroyDatasetMeta(e);
	}
	destroy() {
		this.notifyPlugins("beforeDestroy");
		let { canvas: e, ctx: t } = this;
		this._stop(), this.config.clearCache(), e && (this.unbindEvents(), iu(e, t), this.platform.releaseContext(t), this.canvas = null, this.ctx = null), delete Fm[this.id], this.notifyPlugins("afterDestroy");
	}
	toBase64Image(...e) {
		return this.canvas.toDataURL(...e);
	}
	bindEvents() {
		this.bindUserEvents(), this.options.responsive ? this.bindResponsiveEvents() : this.attached = !0;
	}
	bindUserEvents() {
		let e = this._listeners, t = this.platform, n = (n, r) => {
			t.addEventListener(this, n, r), e[n] = r;
		}, r = (e, t, n) => {
			e.offsetX = t, e.offsetY = n, this._eventHandler(e);
		};
		wc(this.options.events, (e) => n(e, r));
	}
	bindResponsiveEvents() {
		this._responsiveListeners ||= {};
		let e = this._responsiveListeners, t = this.platform, n = (n, r) => {
			t.addEventListener(this, n, r), e[n] = r;
		}, r = (n, r) => {
			e[n] && (t.removeEventListener(this, n, r), delete e[n]);
		}, i = (e, t) => {
			this.canvas && this.resize(e, t);
		}, a, o = () => {
			r("attach", o), this.attached = !0, this.resize(), n("resize", i), n("detach", a);
		};
		a = () => {
			this.attached = !1, r("resize", i), this._stop(), this._resize(0, 0), n("attach", o);
		}, t.isAttached(this.canvas) ? o() : a();
	}
	unbindEvents() {
		wc(this._listeners, (e, t) => {
			this.platform.removeEventListener(this, t, e);
		}), this._listeners = {}, wc(this._responsiveListeners, (e, t) => {
			this.platform.removeEventListener(this, t, e);
		}), this._responsiveListeners = void 0;
	}
	updateHoverStyle(e, t, n) {
		let r = n ? "set" : "remove", i, a, o, s;
		for (t === "dataset" && (i = this.getDatasetMeta(e[0].datasetIndex), i.controller["_" + r + "DatasetHoverStyle"]()), o = 0, s = e.length; o < s; ++o) {
			a = e[o];
			let t = a && this.getDatasetMeta(a.datasetIndex).controller;
			t && t[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
		}
	}
	getActiveElements() {
		return this._active || [];
	}
	setActiveElements(e) {
		let t = this._active || [], n = e.map(({ datasetIndex: e, index: t }) => {
			let n = this.getDatasetMeta(e);
			if (!n) throw Error("No dataset found at index " + e);
			return {
				datasetIndex: e,
				element: n.data[t],
				index: t
			};
		});
		Tc(n, t) || (this._active = n, this._lastEvent = null, this._updateHoverStyles(n, t));
	}
	notifyPlugins(e, t, n) {
		return this._plugins.notify(this, e, t, n);
	}
	isPluginEnabled(e) {
		return this._plugins._cache.filter((t) => t.plugin.id === e).length === 1;
	}
	_updateHoverStyles(e, t, n) {
		let r = this.options.hover, i = (e, t) => e.filter((e) => !t.some((t) => e.datasetIndex === t.datasetIndex && e.index === t.index)), a = i(t, e), o = n ? e : i(e, t);
		a.length && this.updateHoverStyle(a, r.mode, !1), o.length && r.mode && this.updateHoverStyle(o, r.mode, !0);
	}
	_eventHandler(e, t) {
		let n = {
			event: e,
			replay: t,
			cancelable: !0,
			inChartArea: this.isPointInArea(e)
		}, r = (t) => (t.options.events || this.options.events).includes(e.native.type);
		if (this.notifyPlugins("beforeEvent", n, r) === !1) return;
		let i = this._handleEvent(e, t, n.inChartArea);
		return n.cancelable = !1, this.notifyPlugins("afterEvent", n, r), (i || n.changed) && this.render(), this;
	}
	_handleEvent(e, t, n) {
		let { _active: r = [], options: i } = this, a = t, o = this._getActiveElements(e, r, n, a), s = Bc(e), c = Rm(e, this._lastEvent, n, s);
		n && (this._lastEvent = null, Cc(i.onHover, [
			e,
			o,
			this
		], this), s && Cc(i.onClick, [
			e,
			o,
			this
		], this));
		let l = !Tc(o, r);
		return (l || t) && (this._active = o, this._updateHoverStyles(o, r, t)), this._lastEvent = c, l;
	}
	_getActiveElements(e, t, n, r) {
		if (e.type === "mouseout") return [];
		if (!n) return t;
		let i = this.options.hover;
		return this.getElementsAtEventForMode(e, i.mode, i, r);
	}
};
function Bm() {
	return wc(zm.instances, (e) => e._plugins.invalidate());
}
function Vm(e, t, n = t) {
	e.lineCap = xc(n.borderCapStyle, t.borderCapStyle), e.setLineDash(xc(n.borderDash, t.borderDash)), e.lineDashOffset = xc(n.borderDashOffset, t.borderDashOffset), e.lineJoin = xc(n.borderJoinStyle, t.borderJoinStyle), e.lineWidth = xc(n.borderWidth, t.borderWidth), e.strokeStyle = xc(n.borderColor, t.borderColor);
}
function Hm(e, t, n) {
	e.lineTo(n.x, n.y);
}
function Um(e) {
	return e.stepped ? uu : e.tension || e.cubicInterpolationMode === "monotone" ? du : Hm;
}
function Wm(e, t, n = {}) {
	let r = e.length, { start: i = 0, end: a = r - 1 } = n, { start: o, end: s } = t, c = Math.max(i, o), l = Math.min(a, s), u = i < o && a < o || i > s && a > s;
	return {
		count: r,
		start: c,
		loop: t.loop,
		ilen: l < c && !u ? r + l - c : l - c
	};
}
function Gm(e, t, n, r) {
	let { points: i, options: a } = t, { count: o, start: s, loop: c, ilen: l } = Wm(i, n, r), u = Um(a), { move: d = !0, reverse: f } = r || {}, p, m, h;
	for (p = 0; p <= l; ++p) m = i[(s + (f ? l - p : p)) % o], !m.skip && (d ? (e.moveTo(m.x, m.y), d = !1) : u(e, h, m, f, a.stepped), h = m);
	return c && (m = i[(s + (f ? l : 0)) % o], u(e, h, m, f, a.stepped)), !!c;
}
function Km(e, t, n, r) {
	let i = t.points, { count: a, start: o, ilen: s } = Wm(i, n, r), { move: c = !0, reverse: l } = r || {}, u = 0, d = 0, f, p, m, h, g, _, v = (e) => (o + (l ? s - e : e)) % a, y = () => {
		h !== g && (e.lineTo(u, g), e.lineTo(u, h), e.lineTo(u, _));
	};
	for (c && (p = i[v(0)], e.moveTo(p.x, p.y)), f = 0; f <= s; ++f) {
		if (p = i[v(f)], p.skip) continue;
		let t = p.x, n = p.y, r = t | 0;
		r === m ? (n < h ? h = n : n > g && (g = n), u = (d * u + t) / ++d) : (y(), e.lineTo(t, n), m = r, d = 0, h = g = n), _ = n;
	}
	y();
}
function qm(e) {
	let t = e.options, n = t.borderDash && t.borderDash.length;
	return !e._decimated && !e._loop && !t.tension && t.cubicInterpolationMode !== "monotone" && !t.stepped && !n ? Km : Gm;
}
function Jm(e) {
	return e.stepped ? xd : e.tension || e.cubicInterpolationMode === "monotone" ? Sd : bd;
}
function Ym(e, t, n, r) {
	let i = t._path;
	i || (i = t._path = new Path2D(), t.path(i, n, r) && i.closePath()), Vm(e, t.options), e.stroke(i);
}
function Xm(e, t, n, r) {
	let { segments: i, options: a } = t, o = qm(t);
	for (let s of i) Vm(e, a, s.style), e.beginPath(), o(e, t, s, {
		start: n,
		end: n + r - 1
	}) && e.closePath(), e.stroke();
}
var Zm = typeof Path2D == "function";
function Qm(e, t, n, r) {
	Zm && !t.options.segment ? Ym(e, t, n, r) : Xm(e, t, n, r);
}
var $m = class extends jp {
	static id = "line";
	static defaults = {
		borderCapStyle: "butt",
		borderDash: [],
		borderDashOffset: 0,
		borderJoinStyle: "miter",
		borderWidth: 3,
		capBezierPoints: !0,
		cubicInterpolationMode: "default",
		fill: !1,
		spanGaps: !1,
		stepped: !1,
		tension: 0
	};
	static defaultRoutes = {
		backgroundColor: "backgroundColor",
		borderColor: "borderColor"
	};
	static descriptors = {
		_scriptable: !0,
		_indexable: (e) => e !== "borderDash" && e !== "fill"
	};
	constructor(e) {
		super(), this.animated = !0, this.options = void 0, this._chart = void 0, this._loop = void 0, this._fullLoop = void 0, this._path = void 0, this._points = void 0, this._segments = void 0, this._decimated = !1, this._pointsUpdated = !1, this._datasetIndex = void 0, e && Object.assign(this, e);
	}
	updateControlPoints(e, t) {
		let n = this.options;
		if ((n.tension || n.cubicInterpolationMode === "monotone") && !n.stepped && !this._pointsUpdated) {
			let r = n.spanGaps ? this._loop : this._fullLoop;
			rd(this._points, n, e, r, t), this._pointsUpdated = !0;
		}
	}
	set points(e) {
		this._points = e, delete this._segments, delete this._path, this._pointsUpdated = !1;
	}
	get points() {
		return this._points;
	}
	get segments() {
		return this._segments ||= Fd(this, this.options.segment);
	}
	first() {
		let e = this.segments, t = this.points;
		return e.length && t[e[0].start];
	}
	last() {
		let e = this.segments, t = this.points, n = e.length;
		return n && t[e[n - 1].end];
	}
	interpolate(e, t) {
		let n = this.options, r = e[t], i = this.points, a = Md(this, {
			property: t,
			start: r,
			end: r
		});
		if (!a.length) return;
		let o = [], s = Jm(n), c, l;
		for (c = 0, l = a.length; c < l; ++c) {
			let { start: l, end: u } = a[c], d = i[l], f = i[u];
			if (d === f) {
				o.push(d);
				continue;
			}
			let p = s(d, f, Math.abs((r - d[t]) / (f[t] - d[t])), n.stepped);
			p[t] = e[t], o.push(p);
		}
		return o.length === 1 ? o[0] : o;
	}
	pathSegment(e, t, n) {
		return qm(this)(e, this, t, n);
	}
	path(e, t, n) {
		let r = this.segments, i = qm(this), a = this._loop;
		t ||= 0, n ||= this.points.length - t;
		for (let o of r) a &= i(e, this, o, {
			start: t,
			end: t + n - 1
		});
		return !!a;
	}
	draw(e, t, n, r) {
		let i = this.options || {};
		(this.points || []).length && i.borderWidth && (e.save(), Qm(e, this, n, r), e.restore()), this.animated && (this._pointsUpdated = !1, this._path = void 0);
	}
};
function eh(e, t, n, r) {
	let i = e.options, { [n]: a } = e.getProps([n], r);
	return Math.abs(t - a) < i.radius + i.hitRadius;
}
var th = class extends jp {
	static id = "point";
	parsed;
	skip;
	stop;
	static defaults = {
		borderWidth: 1,
		hitRadius: 1,
		hoverBorderWidth: 1,
		hoverRadius: 4,
		pointStyle: "circle",
		radius: 3,
		rotation: 0
	};
	static defaultRoutes = {
		backgroundColor: "backgroundColor",
		borderColor: "borderColor"
	};
	constructor(e) {
		super(), this.options = void 0, this.parsed = void 0, this.skip = void 0, this.stop = void 0, e && Object.assign(this, e);
	}
	inRange(e, t, n) {
		let r = this.options, { x: i, y: a } = this.getProps(["x", "y"], n);
		return (e - i) ** 2 + (t - a) ** 2 < (r.hitRadius + r.radius) ** 2;
	}
	inXRange(e, t) {
		return eh(this, e, "x", t);
	}
	inYRange(e, t) {
		return eh(this, e, "y", t);
	}
	getCenterPoint(e) {
		let { x: t, y: n } = this.getProps(["x", "y"], e);
		return {
			x: t,
			y: n
		};
	}
	size(e) {
		e = e || this.options || {};
		let t = e.radius || 0;
		t = Math.max(t, t && e.hoverRadius || 0);
		let n = t && e.borderWidth || 0;
		return (t + n) * 2;
	}
	draw(e, t) {
		let n = this.options;
		this.skip || n.radius < .1 || !su(this, t, this.size(n) / 2) || (e.strokeStyle = n.borderColor, e.lineWidth = n.borderWidth, e.fillStyle = n.backgroundColor, au(e, n, this.x, this.y));
	}
	getRange() {
		let e = this.options || {};
		return e.radius + e.hitRadius;
	}
};
function nh(e, t) {
	let { x: n, y: r, base: i, width: a, height: o } = e.getProps([
		"x",
		"y",
		"base",
		"width",
		"height"
	], t), s, c, l, u, d;
	return e.horizontal ? (d = o / 2, s = Math.min(n, i), c = Math.max(n, i), l = r - d, u = r + d) : (d = a / 2, s = n - d, c = n + d, l = Math.min(r, i), u = Math.max(r, i)), {
		left: s,
		top: l,
		right: c,
		bottom: u
	};
}
function rh(e, t, n, r) {
	return e ? 0 : fl(t, n, r);
}
function ih(e, t, n) {
	let r = e.options.borderWidth, i = e.borderSkipped, a = Su(r);
	return {
		t: rh(i.top, a.top, 0, n),
		r: rh(i.right, a.right, 0, t),
		b: rh(i.bottom, a.bottom, 0, n),
		l: rh(i.left, a.left, 0, t)
	};
}
function ah(e, t, n) {
	let { enableBorderRadius: r } = e.getProps(["enableBorderRadius"]), i = e.options.borderRadius, a = Cu(i), o = Math.min(t, n), s = e.borderSkipped, c = r || vc(i);
	return {
		topLeft: rh(!c || s.top || s.left, a.topLeft, 0, o),
		topRight: rh(!c || s.top || s.right, a.topRight, 0, o),
		bottomLeft: rh(!c || s.bottom || s.left, a.bottomLeft, 0, o),
		bottomRight: rh(!c || s.bottom || s.right, a.bottomRight, 0, o)
	};
}
function oh(e) {
	let t = nh(e), n = t.right - t.left, r = t.bottom - t.top, i = ih(e, n / 2, r / 2), a = ah(e, n / 2, r / 2);
	return {
		outer: {
			x: t.left,
			y: t.top,
			w: n,
			h: r,
			radius: a
		},
		inner: {
			x: t.left + i.l,
			y: t.top + i.t,
			w: n - i.l - i.r,
			h: r - i.t - i.b,
			radius: {
				topLeft: Math.max(0, a.topLeft - Math.max(i.t, i.l)),
				topRight: Math.max(0, a.topRight - Math.max(i.t, i.r)),
				bottomLeft: Math.max(0, a.bottomLeft - Math.max(i.b, i.l)),
				bottomRight: Math.max(0, a.bottomRight - Math.max(i.b, i.r))
			}
		}
	};
}
function sh(e, t, n, r) {
	let i = t === null, a = n === null, o = e && !(i && a) && nh(e, r);
	return o && (i || ml(t, o.left, o.right)) && (a || ml(n, o.top, o.bottom));
}
function ch(e) {
	return e.topLeft || e.topRight || e.bottomLeft || e.bottomRight;
}
function lh(e, t) {
	e.rect(t.x, t.y, t.w, t.h);
}
function uh(e, t, n = {}) {
	let r = e.x === n.x ? 0 : -t, i = e.y === n.y ? 0 : -t, a = (e.x + e.w === n.x + n.w ? 0 : t) - r, o = (e.y + e.h === n.y + n.h ? 0 : t) - i;
	return {
		x: e.x + r,
		y: e.y + i,
		w: e.w + a,
		h: e.h + o,
		radius: e.radius
	};
}
var dh = class extends jp {
	static id = "bar";
	static defaults = {
		borderSkipped: "start",
		borderWidth: 0,
		borderRadius: 0,
		inflateAmount: "auto",
		pointStyle: void 0
	};
	static defaultRoutes = {
		backgroundColor: "backgroundColor",
		borderColor: "borderColor"
	};
	constructor(e) {
		super(), this.options = void 0, this.horizontal = void 0, this.base = void 0, this.width = void 0, this.height = void 0, this.inflateAmount = void 0, e && Object.assign(this, e);
	}
	draw(e) {
		let { inflateAmount: t, options: { borderColor: n, backgroundColor: r } } = this, { inner: i, outer: a } = oh(this), o = ch(a.radius) ? gu : lh;
		e.save(), (a.w !== i.w || a.h !== i.h) && (e.beginPath(), o(e, uh(a, t, i)), e.clip(), o(e, uh(i, -t, a)), e.fillStyle = n, e.fill("evenodd")), e.beginPath(), o(e, uh(i, t)), e.fillStyle = r, e.fill(), e.restore();
	}
	inRange(e, t, n) {
		return sh(this, e, t, n);
	}
	inXRange(e, t) {
		return sh(this, e, null, t);
	}
	inYRange(e, t) {
		return sh(this, null, e, t);
	}
	getCenterPoint(e) {
		let { x: t, y: n, base: r, horizontal: i } = this.getProps([
			"x",
			"y",
			"base",
			"horizontal"
		], e);
		return {
			x: i ? (t + r) / 2 : t,
			y: i ? n : (n + r) / 2
		};
	}
	getRange(e) {
		return e === "x" ? this.width / 2 : this.height / 2;
	}
};
function fh(e, t, n) {
	let r = e.segments, i = e.points, a = t.points, o = [];
	for (let e of r) {
		let { start: r, end: s } = e;
		s = hh(r, s, i);
		let c = ph(n, i[r], i[s], e.loop);
		if (!t.segments) {
			o.push({
				source: e,
				target: c,
				start: i[r],
				end: i[s]
			});
			continue;
		}
		let l = Md(t, c);
		for (let t of l) {
			let r = ph(n, a[t.start], a[t.end], t.loop), s = jd(e, i, r);
			for (let e of s) o.push({
				source: e,
				target: t,
				start: { [n]: gh(c, r, "start", Math.max) },
				end: { [n]: gh(c, r, "end", Math.min) }
			});
		}
	}
	return o;
}
function ph(e, t, n, r) {
	if (r) return;
	let i = t[e], a = n[e];
	return e === "angle" && (i = ul(i), a = ul(a)), {
		property: e,
		start: i,
		end: a
	};
}
function mh(e, t) {
	let { x: n = null, y: r = null } = e || {}, i = t.points, a = [];
	return t.segments.forEach(({ start: e, end: t }) => {
		t = hh(e, t, i);
		let o = i[e], s = i[t];
		r === null ? n !== null && (a.push({
			x: n,
			y: o.y
		}), a.push({
			x: n,
			y: s.y
		})) : (a.push({
			x: o.x,
			y: r
		}), a.push({
			x: s.x,
			y: r
		}));
	}), a;
}
function hh(e, t, n) {
	for (; t > e; t--) {
		let e = n[t];
		if (!isNaN(e.x) && !isNaN(e.y)) break;
	}
	return t;
}
function gh(e, t, n, r) {
	return e && t ? r(e[n], t[n]) : e ? e[n] : t ? t[n] : 0;
}
function _h(e, t) {
	let n = [], r = !1;
	return _c(e) ? (r = !0, n = e) : n = mh(e, t), n.length ? new $m({
		points: n,
		options: { tension: 0 },
		_loop: r,
		_fullLoop: r
	}) : null;
}
function vh(e) {
	return e && e.fill !== !1;
}
function yh(e, t, n) {
	let r = e[t].fill, i = [t], a;
	if (!n) return r;
	for (; r !== !1 && i.indexOf(r) === -1;) {
		if (!yc(r)) return r;
		if (a = e[r], !a) return !1;
		if (a.visible) return r;
		i.push(r), r = a.fill;
	}
	return !1;
}
function bh(e, t, n) {
	let r = wh(e);
	if (vc(r)) return isNaN(r.value) ? !1 : r;
	let i = parseFloat(r);
	return yc(i) && Math.floor(i) === i ? xh(r[0], t, i, n) : [
		"origin",
		"start",
		"end",
		"stack",
		"shape"
	].indexOf(r) >= 0 && r;
}
function xh(e, t, n, r) {
	return (e === "-" || e === "+") && (n = t + n), n === t || n < 0 || n >= r ? !1 : n;
}
function Sh(e, t) {
	let n = null;
	return e === "start" ? n = t.bottom : e === "end" ? n = t.top : vc(e) ? n = t.getPixelForValue(e.value) : t.getBasePixel && (n = t.getBasePixel()), n;
}
function Ch(e, t, n) {
	let r;
	return r = e === "start" ? n : e === "end" ? t.options.reverse ? t.min : t.max : vc(e) ? e.value : t.getBaseValue(), r;
}
function wh(e) {
	let t = e.options, n = t.fill, r = xc(n && n.target, n);
	return r === void 0 && (r = !!t.backgroundColor), r === !1 || r === null ? !1 : r === !0 ? "origin" : r;
}
function Th(e) {
	let { scale: t, index: n, line: r } = e, i = [], a = r.segments, o = r.points, s = Eh(t, n);
	s.push(_h({
		x: null,
		y: t.bottom
	}, r));
	for (let e = 0; e < a.length; e++) {
		let t = a[e];
		for (let e = t.start; e <= t.end; e++) Dh(i, o[e], s);
	}
	return new $m({
		points: i,
		options: {}
	});
}
function Eh(e, t) {
	let n = [], r = e.getMatchingVisibleMetas("line");
	for (let e = 0; e < r.length; e++) {
		let i = r[e];
		if (i.index === t) break;
		i.hidden || n.unshift(i.dataset);
	}
	return n;
}
function Dh(e, t, n) {
	let r = [];
	for (let i = 0; i < n.length; i++) {
		let a = n[i], { first: o, last: s, point: c } = Oh(a, t, "x");
		if (!(!c || o && s)) {
			if (o) r.unshift(c);
			else if (e.push(c), !s) break;
		}
	}
	e.push(...r);
}
function Oh(e, t, n) {
	let r = e.interpolate(t, n);
	if (!r) return {};
	let i = r[n], a = e.segments, o = e.points, s = !1, c = !1;
	for (let e = 0; e < a.length; e++) {
		let t = a[e], r = o[t.start][n], l = o[t.end][n];
		if (ml(i, r, l)) {
			s = i === r, c = i === l;
			break;
		}
	}
	return {
		first: s,
		last: c,
		point: r
	};
}
var kh = class {
	constructor(e) {
		this.x = e.x, this.y = e.y, this.radius = e.radius;
	}
	pathSegment(e, t, n) {
		let { x: r, y: i, radius: a } = this;
		return t ||= {
			start: 0,
			end: Hc
		}, e.arc(r, i, a, t.end, t.start, !0), !n.bounds;
	}
	interpolate(e) {
		let { x: t, y: n, radius: r } = this, i = e.angle;
		return {
			x: t + Math.cos(i) * r,
			y: n + Math.sin(i) * r,
			angle: i
		};
	}
};
function Ah(e) {
	let { chart: t, fill: n, line: r } = e;
	if (yc(n)) return jh(t, n);
	if (n === "stack") return Th(e);
	if (n === "shape") return !0;
	let i = Mh(e);
	return i instanceof kh ? i : _h(i, r);
}
function jh(e, t) {
	let n = e.getDatasetMeta(t);
	return n && e.isDatasetVisible(t) ? n.dataset : null;
}
function Mh(e) {
	return (e.scale || {}).getPointPositionForValue ? Ph(e) : Nh(e);
}
function Nh(e) {
	let { scale: t = {}, fill: n } = e, r = Sh(n, t);
	if (yc(r)) {
		let e = t.isHorizontal();
		return {
			x: e ? r : null,
			y: e ? null : r
		};
	}
	return null;
}
function Ph(e) {
	let { scale: t, fill: n } = e, r = t.options, i = t.getLabels().length, a = r.reverse ? t.max : t.min, o = Ch(n, t, a), s = [];
	if (r.grid.circular) {
		let e = t.getPointPositionForValue(0, a);
		return new kh({
			x: e.x,
			y: e.y,
			radius: t.getDistanceFromCenterForValue(o)
		});
	}
	for (let e = 0; e < i; ++e) s.push(t.getPointPositionForValue(e, o));
	return s;
}
function Fh(e, t, n) {
	let r = Ah(t), { chart: i, index: a, line: o, scale: s, axis: c } = t, l = o.options, u = l.fill, d = l.backgroundColor, { above: f = d, below: p = d } = u || {}, m = Hd(i, i.getDatasetMeta(a));
	r && o.points.length && (cu(e, n), Ih(e, {
		line: o,
		target: r,
		above: f,
		below: p,
		area: n,
		scale: s,
		axis: c,
		clip: m
	}), lu(e));
}
function Ih(e, t) {
	let { line: n, target: r, above: i, below: a, area: o, scale: s, clip: c } = t, l = n._loop ? "angle" : t.axis;
	e.save();
	let u = a;
	a !== i && (l === "x" ? (Lh(e, r, o.top), zh(e, {
		line: n,
		target: r,
		color: i,
		scale: s,
		property: l,
		clip: c
	}), e.restore(), e.save(), Lh(e, r, o.bottom)) : l === "y" && (Rh(e, r, o.left), zh(e, {
		line: n,
		target: r,
		color: a,
		scale: s,
		property: l,
		clip: c
	}), e.restore(), e.save(), Rh(e, r, o.right), u = i)), zh(e, {
		line: n,
		target: r,
		color: u,
		scale: s,
		property: l,
		clip: c
	}), e.restore();
}
function Lh(e, t, n) {
	let { segments: r, points: i } = t, a = !0, o = !1;
	e.beginPath();
	for (let s of r) {
		let { start: r, end: c } = s, l = i[r], u = i[hh(r, c, i)];
		a ? (e.moveTo(l.x, l.y), a = !1) : (e.lineTo(l.x, n), e.lineTo(l.x, l.y)), o = !!t.pathSegment(e, s, { move: o }), o ? e.closePath() : e.lineTo(u.x, n);
	}
	e.lineTo(t.first().x, n), e.closePath(), e.clip();
}
function Rh(e, t, n) {
	let { segments: r, points: i } = t, a = !0, o = !1;
	e.beginPath();
	for (let s of r) {
		let { start: r, end: c } = s, l = i[r], u = i[hh(r, c, i)];
		a ? (e.moveTo(l.x, l.y), a = !1) : (e.lineTo(n, l.y), e.lineTo(l.x, l.y)), o = !!t.pathSegment(e, s, { move: o }), o ? e.closePath() : e.lineTo(n, u.y);
	}
	e.lineTo(n, t.first().y), e.closePath(), e.clip();
}
function zh(e, t) {
	let { line: n, target: r, property: i, color: a, scale: o, clip: s } = t, c = fh(n, r, i);
	for (let { source: t, target: l, start: u, end: d } of c) {
		let { style: { backgroundColor: c = a } = {} } = t, f = r !== !0;
		e.save(), e.fillStyle = c, Bh(e, o, s, f && ph(i, u, d)), e.beginPath();
		let p = !!n.pathSegment(e, t), m;
		if (f) {
			p ? e.closePath() : Vh(e, r, d, i);
			let t = !!r.pathSegment(e, l, {
				move: p,
				reverse: !0
			});
			m = p && t, m || Vh(e, r, u, i);
		}
		e.closePath(), e.fill(m ? "evenodd" : "nonzero"), e.restore();
	}
}
function Bh(e, t, n, r) {
	let i = t.chart.chartArea, { property: a, start: o, end: s } = r || {};
	if (a === "x" || a === "y") {
		let t, r, c, l;
		a === "x" ? (t = o, r = i.top, c = s, l = i.bottom) : (t = i.left, r = o, c = i.right, l = s), e.beginPath(), n && (t = Math.max(t, n.left), c = Math.min(c, n.right), r = Math.max(r, n.top), l = Math.min(l, n.bottom)), e.rect(t, r, c - t, l - r), e.clip();
	}
}
function Vh(e, t, n, r) {
	let i = t.interpolate(n, r);
	i && e.lineTo(i.x, i.y);
}
var Hh = {
	id: "filler",
	afterDatasetsUpdate(e, t, n) {
		let r = (e.data.datasets || []).length, i = [], a, o, s, c;
		for (o = 0; o < r; ++o) a = e.getDatasetMeta(o), s = a.dataset, c = null, s && s.options && s instanceof $m && (c = {
			visible: e.isDatasetVisible(o),
			index: o,
			fill: bh(s, o, r),
			chart: e,
			axis: a.controller.options.indexAxis,
			scale: a.vScale,
			line: s
		}), a.$filler = c, i.push(c);
		for (o = 0; o < r; ++o) c = i[o], !(!c || c.fill === !1) && (c.fill = yh(i, o, n.propagate));
	},
	beforeDraw(e, t, n) {
		let r = n.drawTime === "beforeDraw", i = e.getSortedVisibleDatasetMetas(), a = e.chartArea;
		for (let t = i.length - 1; t >= 0; --t) {
			let n = i[t].$filler;
			n && (n.line.updateControlPoints(a, n.axis), r && n.fill && Fh(e.ctx, n, a));
		}
	},
	beforeDatasetsDraw(e, t, n) {
		if (n.drawTime !== "beforeDatasetsDraw") return;
		let r = e.getSortedVisibleDatasetMetas();
		for (let t = r.length - 1; t >= 0; --t) {
			let n = r[t].$filler;
			vh(n) && Fh(e.ctx, n, e.chartArea);
		}
	},
	beforeDatasetDraw(e, t, n) {
		let r = t.meta.$filler;
		!vh(r) || n.drawTime !== "beforeDatasetDraw" || Fh(e.ctx, r, e.chartArea);
	},
	defaults: {
		propagate: !0,
		drawTime: "beforeDatasetDraw"
	}
}, Uh = (e, t) => {
	let { boxHeight: n = t, boxWidth: r = t } = e;
	return e.usePointStyle && (n = Math.min(n, t), r = e.pointStyleWidth || Math.min(r, t)), {
		boxWidth: r,
		boxHeight: n,
		itemHeight: Math.max(t, n)
	};
}, Wh = (e, t) => e !== null && t !== null && e.datasetIndex === t.datasetIndex && e.index === t.index, Gh = class extends jp {
	constructor(e) {
		super(), this._added = !1, this.legendHitBoxes = [], this._hoveredItem = null, this.doughnutMode = !1, this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this.legendItems = void 0, this.columnSizes = void 0, this.lineWidths = void 0, this.maxHeight = void 0, this.maxWidth = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.height = void 0, this.width = void 0, this._margins = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
	}
	update(e, t, n) {
		this.maxWidth = e, this.maxHeight = t, this._margins = n, this.setDimensions(), this.buildLabels(), this.fit();
	}
	setDimensions() {
		this.isHorizontal() ? (this.width = this.maxWidth, this.left = this._margins.left, this.right = this.width) : (this.height = this.maxHeight, this.top = this._margins.top, this.bottom = this.height);
	}
	buildLabels() {
		let e = this.options.labels || {}, t = Cc(e.generateLabels, [this.chart], this) || [];
		e.filter && (t = t.filter((t) => e.filter(t, this.chart.data))), e.sort && (t = t.sort((t, n) => e.sort(t, n, this.chart.data))), this.options.reverse && t.reverse(), this.legendItems = t;
	}
	fit() {
		let { options: e, ctx: t } = this;
		if (!e.display) {
			this.width = this.height = 0;
			return;
		}
		let n = e.labels, r = Tu(n.font), i = r.size, a = this._computeTitleHeight(), { boxWidth: o, itemHeight: s } = Uh(n, i), c, l;
		t.font = r.string, this.isHorizontal() ? (c = this.maxWidth, l = this._fitRows(a, i, o, s) + 10) : (l = this.maxHeight, c = this._fitCols(a, r, o, s) + 10), this.width = Math.min(c, e.maxWidth || this.maxWidth), this.height = Math.min(l, e.maxHeight || this.maxHeight);
	}
	_fitRows(e, t, n, r) {
		let { ctx: i, maxWidth: a, options: { labels: { padding: o } } } = this, s = this.legendHitBoxes = [], c = this.lineWidths = [0], l = r + o, u = e;
		i.textAlign = "left", i.textBaseline = "middle";
		let d = -1, f = -l;
		return this.legendItems.forEach((e, p) => {
			let m = n + t / 2 + i.measureText(e.text).width;
			(p === 0 || c[c.length - 1] + m + 2 * o > a) && (u += l, c[c.length - (p > 0 ? 0 : 1)] = 0, f += l, d++), s[p] = {
				left: 0,
				top: f,
				row: d,
				width: m,
				height: r
			}, c[c.length - 1] += m + o;
		}), u;
	}
	_fitCols(e, t, n, r) {
		let { ctx: i, maxHeight: a, options: { labels: { padding: o } } } = this, s = this.legendHitBoxes = [], c = this.columnSizes = [], l = a - e, u = o, d = 0, f = 0, p = 0, m = 0;
		return this.legendItems.forEach((e, a) => {
			let { itemWidth: h, itemHeight: g } = Kh(n, t, i, e, r);
			a > 0 && f + g + 2 * o > l && (u += d + o, c.push({
				width: d,
				height: f
			}), p += d + o, m++, d = f = 0), s[a] = {
				left: p,
				top: f,
				col: m,
				width: h,
				height: g
			}, d = Math.max(d, h), f += g + o;
		}), u += d, c.push({
			width: d,
			height: f
		}), u;
	}
	adjustHitBoxes() {
		if (!this.options.display) return;
		let e = this._computeTitleHeight(), { legendHitBoxes: t, options: { align: n, labels: { padding: r }, rtl: i } } = this, a = Td(i, this.left, this.width);
		if (this.isHorizontal()) {
			let i = 0, o = Dl(n, this.left + r, this.right - this.lineWidths[i]);
			for (let s of t) i !== s.row && (i = s.row, o = Dl(n, this.left + r, this.right - this.lineWidths[i])), s.top += this.top + e + r, s.left = a.leftForLtr(a.x(o), s.width), o += s.width + r;
		} else {
			let i = 0, o = Dl(n, this.top + e + r, this.bottom - this.columnSizes[i].height);
			for (let s of t) s.col !== i && (i = s.col, o = Dl(n, this.top + e + r, this.bottom - this.columnSizes[i].height)), s.top = o, s.left += this.left + r, s.left = a.leftForLtr(a.x(s.left), s.width), o += s.height + r;
		}
	}
	isHorizontal() {
		return this.options.position === "top" || this.options.position === "bottom";
	}
	draw() {
		if (this.options.display) {
			let e = this.ctx;
			cu(e, this), this._draw(), lu(e);
		}
	}
	_draw() {
		let { options: e, columnSizes: t, lineWidths: n, ctx: r } = this, { align: i, labels: a } = e, o = $l.color, s = Td(e.rtl, this.left, this.width), c = Tu(a.font), { padding: l } = a, u = c.size, d = u / 2, f;
		this.drawTitle(), r.textAlign = s.textAlign("left"), r.textBaseline = "middle", r.lineWidth = .5, r.font = c.string;
		let { boxWidth: p, boxHeight: m, itemHeight: h } = Uh(a, u), g = function(e, t, n) {
			if (isNaN(p) || p <= 0 || isNaN(m) || m < 0) return;
			r.save();
			let i = xc(n.lineWidth, 1);
			if (r.fillStyle = xc(n.fillStyle, o), r.lineCap = xc(n.lineCap, "butt"), r.lineDashOffset = xc(n.lineDashOffset, 0), r.lineJoin = xc(n.lineJoin, "miter"), r.lineWidth = i, r.strokeStyle = xc(n.strokeStyle, o), r.setLineDash(xc(n.lineDash, [])), a.usePointStyle) ou(r, {
				radius: m * Math.SQRT2 / 2,
				pointStyle: n.pointStyle,
				rotation: n.rotation,
				borderWidth: i
			}, s.xPlus(e, p / 2), t + d, a.pointStyleWidth && p);
			else {
				let a = t + Math.max((u - m) / 2, 0), o = s.leftForLtr(e, p), c = Cu(n.borderRadius);
				r.beginPath(), Object.values(c).some((e) => e !== 0) ? gu(r, {
					x: o,
					y: a,
					w: p,
					h: m,
					radius: c
				}) : r.rect(o, a, p, m), r.fill(), i !== 0 && r.stroke();
			}
			r.restore();
		}, _ = function(e, t, n) {
			hu(r, n.text, e, t + h / 2, c, {
				strikethrough: n.hidden,
				textAlign: s.textAlign(n.textAlign)
			});
		}, v = this.isHorizontal(), y = this._computeTitleHeight();
		f = v ? {
			x: Dl(i, this.left + l, this.right - n[0]),
			y: this.top + l + y,
			line: 0
		} : {
			x: this.left + l,
			y: Dl(i, this.top + y + l, this.bottom - t[0].height),
			line: 0
		}, Ed(this.ctx, e.textDirection);
		let b = h + l;
		this.legendItems.forEach((o, u) => {
			r.strokeStyle = o.fontColor, r.fillStyle = o.fontColor;
			let m = r.measureText(o.text).width, h = s.textAlign(o.textAlign ||= a.textAlign), x = p + d + m, S = f.x, C = f.y;
			if (s.setWidth(this.width), v ? u > 0 && S + x + l > this.right && (C = f.y += b, f.line++, S = f.x = Dl(i, this.left + l, this.right - n[f.line])) : u > 0 && C + b > this.bottom && (S = f.x = S + t[f.line].width + l, f.line++, C = f.y = Dl(i, this.top + y + l, this.bottom - t[f.line].height)), g(s.x(S), C, o), S = Ol(h, S + p + d, v ? S + x : this.right, e.rtl), _(s.x(S), C, o), v) f.x += x + l;
			else if (typeof o.text != "string") {
				let e = c.lineHeight;
				f.y += Yh(o, e) + l;
			} else f.y += b;
		}), Dd(this.ctx, e.textDirection);
	}
	drawTitle() {
		let e = this.options, t = e.title, n = Tu(t.font), r = wu(t.padding);
		if (!t.display) return;
		let i = Td(e.rtl, this.left, this.width), a = this.ctx, o = t.position, s = n.size / 2, c = r.top + s, l, u = this.left, d = this.width;
		if (this.isHorizontal()) d = Math.max(...this.lineWidths), l = this.top + c, u = Dl(e.align, u, this.right - d);
		else {
			let t = this.columnSizes.reduce((e, t) => Math.max(e, t.height), 0);
			l = c + Dl(e.align, this.top, this.bottom - t - e.labels.padding - this._computeTitleHeight());
		}
		let f = Dl(o, u, u + d);
		a.textAlign = i.textAlign(El(o)), a.textBaseline = "middle", a.strokeStyle = t.color, a.fillStyle = t.color, a.font = n.string, hu(a, t.text, f, l, n);
	}
	_computeTitleHeight() {
		let e = this.options.title, t = Tu(e.font), n = wu(e.padding);
		return e.display ? t.lineHeight + n.height : 0;
	}
	_getLegendItemAt(e, t) {
		let n, r, i;
		if (ml(e, this.left, this.right) && ml(t, this.top, this.bottom)) {
			for (i = this.legendHitBoxes, n = 0; n < i.length; ++n) if (r = i[n], ml(e, r.left, r.left + r.width) && ml(t, r.top, r.top + r.height)) return this.legendItems[n];
		}
		return null;
	}
	handleEvent(e) {
		let t = this.options;
		if (!Xh(e.type, t)) return;
		let n = this._getLegendItemAt(e.x, e.y);
		if (e.type === "mousemove" || e.type === "mouseout") {
			let r = this._hoveredItem, i = Wh(r, n);
			r && !i && Cc(t.onLeave, [
				e,
				r,
				this
			], this), this._hoveredItem = n, n && !i && Cc(t.onHover, [
				e,
				n,
				this
			], this);
		} else n && Cc(t.onClick, [
			e,
			n,
			this
		], this);
	}
};
function Kh(e, t, n, r, i) {
	return {
		itemWidth: qh(r, e, t, n),
		itemHeight: Jh(i, r, t.lineHeight)
	};
}
function qh(e, t, n, r) {
	let i = e.text;
	return i && typeof i != "string" && (i = i.reduce((e, t) => e.length > t.length ? e : t)), t + n.size / 2 + r.measureText(i).width;
}
function Jh(e, t, n) {
	let r = e;
	return typeof t.text != "string" && (r = Yh(t, n)), r;
}
function Yh(e, t) {
	return t * (e.text ? e.text.length : 0);
}
function Xh(e, t) {
	return !!((e === "mousemove" || e === "mouseout") && (t.onHover || t.onLeave) || t.onClick && (e === "click" || e === "mouseup"));
}
var Zh = {
	id: "legend",
	_element: Gh,
	start(e, t, n) {
		let r = e.legend = new Gh({
			ctx: e.ctx,
			options: n,
			chart: e
		});
		sp.configure(e, r, n), sp.addBox(e, r);
	},
	stop(e) {
		sp.removeBox(e, e.legend), delete e.legend;
	},
	beforeUpdate(e, t, n) {
		let r = e.legend;
		sp.configure(e, r, n), r.options = n;
	},
	afterUpdate(e) {
		let t = e.legend;
		t.buildLabels(), t.adjustHitBoxes();
	},
	afterEvent(e, t) {
		t.replay || e.legend.handleEvent(t.event);
	},
	defaults: {
		display: !0,
		position: "top",
		align: "center",
		fullSize: !0,
		reverse: !1,
		weight: 1e3,
		onClick(e, t, n) {
			let r = t.datasetIndex, i = n.chart;
			i.isDatasetVisible(r) ? (i.hide(r), t.hidden = !0) : (i.show(r), t.hidden = !1);
		},
		onHover: null,
		onLeave: null,
		labels: {
			color: (e) => e.chart.options.color,
			boxWidth: 40,
			padding: 10,
			generateLabels(e) {
				let t = e.data.datasets, { labels: { usePointStyle: n, pointStyle: r, textAlign: i, color: a, useBorderRadius: o, borderRadius: s } } = e.legend.options;
				return e._getSortedDatasetMetas().map((e) => {
					let c = e.controller.getStyle(n ? 0 : void 0), l = wu(c.borderWidth);
					return {
						text: t[e.index].label,
						fillStyle: c.backgroundColor,
						fontColor: a,
						hidden: !e.visible,
						lineCap: c.borderCapStyle,
						lineDash: c.borderDash,
						lineDashOffset: c.borderDashOffset,
						lineJoin: c.borderJoinStyle,
						lineWidth: (l.width + l.height) / 4,
						strokeStyle: c.borderColor,
						pointStyle: r || c.pointStyle,
						rotation: c.rotation,
						textAlign: i || c.textAlign,
						borderRadius: o && (s || c.borderRadius),
						datasetIndex: e.index
					};
				}, this);
			}
		},
		title: {
			color: (e) => e.chart.options.color,
			display: !1,
			position: "center",
			text: ""
		}
	},
	descriptors: {
		_scriptable: (e) => !e.startsWith("on"),
		labels: { _scriptable: (e) => ![
			"generateLabels",
			"filter",
			"sort"
		].includes(e) }
	}
}, Qh = class extends jp {
	constructor(e) {
		super(), this.chart = e.chart, this.options = e.options, this.ctx = e.ctx, this._padding = void 0, this.top = void 0, this.bottom = void 0, this.left = void 0, this.right = void 0, this.width = void 0, this.height = void 0, this.position = void 0, this.weight = void 0, this.fullSize = void 0;
	}
	update(e, t) {
		let n = this.options;
		if (this.left = 0, this.top = 0, !n.display) {
			this.width = this.height = this.right = this.bottom = 0;
			return;
		}
		this.width = this.right = e, this.height = this.bottom = t;
		let r = _c(n.text) ? n.text.length : 1;
		this._padding = wu(n.padding);
		let i = r * Tu(n.font).lineHeight + this._padding.height;
		this.isHorizontal() ? this.height = i : this.width = i;
	}
	isHorizontal() {
		let e = this.options.position;
		return e === "top" || e === "bottom";
	}
	_drawArgs(e) {
		let { top: t, left: n, bottom: r, right: i, options: a } = this, o = a.align, s = 0, c, l, u;
		return this.isHorizontal() ? (l = Dl(o, n, i), u = t + e, c = i - n) : (a.position === "left" ? (l = n + e, u = Dl(o, r, t), s = Vc * -.5) : (l = i - e, u = Dl(o, t, r), s = Vc * .5), c = r - t), {
			titleX: l,
			titleY: u,
			maxWidth: c,
			rotation: s
		};
	}
	draw() {
		let e = this.ctx, t = this.options;
		if (!t.display) return;
		let n = Tu(t.font), r = n.lineHeight / 2 + this._padding.top, { titleX: i, titleY: a, maxWidth: o, rotation: s } = this._drawArgs(r);
		hu(e, t.text, 0, 0, n, {
			color: t.color,
			maxWidth: o,
			rotation: s,
			textAlign: El(t.align),
			textBaseline: "middle",
			translation: [i, a]
		});
	}
};
function $h(e, t) {
	let n = new Qh({
		ctx: e.ctx,
		options: t,
		chart: e
	});
	sp.configure(e, n, t), sp.addBox(e, n), e.titleBlock = n;
}
var eg = {
	id: "title",
	_element: Qh,
	start(e, t, n) {
		$h(e, n);
	},
	stop(e) {
		let t = e.titleBlock;
		sp.removeBox(e, t), delete e.titleBlock;
	},
	beforeUpdate(e, t, n) {
		let r = e.titleBlock;
		sp.configure(e, r, n), r.options = n;
	},
	defaults: {
		align: "center",
		display: !1,
		font: { weight: "bold" },
		fullSize: !0,
		padding: 10,
		position: "top",
		text: "",
		weight: 2e3
	},
	defaultRoutes: { color: "color" },
	descriptors: {
		_scriptable: !0,
		_indexable: !1
	}
}, tg = {
	average(e) {
		if (!e.length) return !1;
		let t, n, r = /* @__PURE__ */ new Set(), i = 0, a = 0;
		for (t = 0, n = e.length; t < n; ++t) {
			let n = e[t].element;
			if (n && n.hasValue()) {
				let e = n.tooltipPosition();
				r.add(e.x), i += e.y, ++a;
			}
		}
		return a === 0 || r.size === 0 ? !1 : {
			x: [...r].reduce((e, t) => e + t) / r.size,
			y: i / a
		};
	},
	nearest(e, t) {
		if (!e.length) return !1;
		let n = t.x, r = t.y, i = Infinity, a, o, s;
		for (a = 0, o = e.length; a < o; ++a) {
			let n = e[a].element;
			if (n && n.hasValue()) {
				let e = cl(t, n.getCenterPoint());
				e < i && (i = e, s = n);
			}
		}
		if (s) {
			let e = s.tooltipPosition();
			n = e.x, r = e.y;
		}
		return {
			x: n,
			y: r
		};
	}
};
function ng(e, t) {
	return t && (_c(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
}
function rg(e) {
	return (typeof e == "string" || e instanceof String) && e.indexOf("\n") > -1 ? e.split("\n") : e;
}
function ig(e, t) {
	let { element: n, datasetIndex: r, index: i } = t, a = e.getDatasetMeta(r).controller, { label: o, value: s } = a.getLabelAndValue(i);
	return {
		chart: e,
		label: o,
		parsed: a.getParsed(i),
		raw: e.data.datasets[r].data[i],
		formattedValue: s,
		dataset: a.getDataset(),
		dataIndex: i,
		datasetIndex: r,
		element: n
	};
}
function ag(e, t) {
	let n = e.chart.ctx, { body: r, footer: i, title: a } = e, { boxWidth: o, boxHeight: s } = t, c = Tu(t.bodyFont), l = Tu(t.titleFont), u = Tu(t.footerFont), d = a.length, f = i.length, p = r.length, m = wu(t.padding), h = m.height, g = 0, _ = r.reduce((e, t) => e + t.before.length + t.lines.length + t.after.length, 0);
	if (_ += e.beforeBody.length + e.afterBody.length, d && (h += d * l.lineHeight + (d - 1) * t.titleSpacing + t.titleMarginBottom), _) {
		let e = t.displayColors ? Math.max(s, c.lineHeight) : c.lineHeight;
		h += p * e + (_ - p) * c.lineHeight + (_ - 1) * t.bodySpacing;
	}
	f && (h += t.footerMarginTop + f * u.lineHeight + (f - 1) * t.footerSpacing);
	let v = 0, y = function(e) {
		g = Math.max(g, n.measureText(e).width + v);
	};
	return n.save(), n.font = l.string, wc(e.title, y), n.font = c.string, wc(e.beforeBody.concat(e.afterBody), y), v = t.displayColors ? o + 2 + t.boxPadding : 0, wc(r, (e) => {
		wc(e.before, y), wc(e.lines, y), wc(e.after, y);
	}), v = 0, n.font = u.string, wc(e.footer, y), n.restore(), g += m.width, {
		width: g,
		height: h
	};
}
function og(e, t) {
	let { y: n, height: r } = t;
	return n < r / 2 ? "top" : n > e.height - r / 2 ? "bottom" : "center";
}
function sg(e, t, n, r) {
	let { x: i, width: a } = r, o = n.caretSize + n.caretPadding;
	if (e === "left" && i + a + o > t.width || e === "right" && i - a - o < 0) return !0;
}
function cg(e, t, n, r) {
	let { x: i, width: a } = n, { width: o, chartArea: { left: s, right: c } } = e, l = "center";
	return r === "center" ? l = i <= (s + c) / 2 ? "left" : "right" : i <= a / 2 ? l = "left" : i >= o - a / 2 && (l = "right"), sg(l, e, t, n) && (l = "center"), l;
}
function lg(e, t, n) {
	let r = n.yAlign || t.yAlign || og(e, n);
	return {
		xAlign: n.xAlign || t.xAlign || cg(e, t, n, r),
		yAlign: r
	};
}
function ug(e, t) {
	let { x: n, width: r } = e;
	return t === "right" ? n -= r : t === "center" && (n -= r / 2), n;
}
function dg(e, t, n) {
	let { y: r, height: i } = e;
	return t === "top" ? r += n : t === "bottom" ? r -= i + n : r -= i / 2, r;
}
function fg(e, t, n, r) {
	let { caretSize: i, caretPadding: a, cornerRadius: o } = e, { xAlign: s, yAlign: c } = n, l = i + a, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: p } = Cu(o), m = ug(t, s), h = dg(t, c, l);
	return c === "center" ? s === "left" ? m += l : s === "right" && (m -= l) : s === "left" ? m -= Math.max(u, f) + i : s === "right" && (m += Math.max(d, p) + i), {
		x: fl(m, 0, r.width - t.width),
		y: fl(h, 0, r.height - t.height)
	};
}
function pg(e, t, n) {
	let r = wu(n.padding);
	return t === "center" ? e.x + e.width / 2 : t === "right" ? e.x + e.width - r.right : e.x + r.left;
}
function mg(e) {
	return ng([], rg(e));
}
function hg(e, t, n) {
	return Ou(e, {
		tooltip: t,
		tooltipItems: n,
		type: "tooltip"
	});
}
function gg(e, t) {
	let n = t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
	return n ? e.override(n) : e;
}
var _g = {
	beforeTitle: mc,
	title(e) {
		if (e.length > 0) {
			let t = e[0], n = t.chart.data.labels, r = n ? n.length : 0;
			if (this && this.options && this.options.mode === "dataset") return t.dataset.label || "";
			if (t.label) return t.label;
			if (r > 0 && t.dataIndex < r) return n[t.dataIndex];
		}
		return "";
	},
	afterTitle: mc,
	beforeBody: mc,
	beforeLabel: mc,
	label(e) {
		if (this && this.options && this.options.mode === "dataset") return e.label + ": " + e.formattedValue || e.formattedValue;
		let t = e.dataset.label || "";
		t && (t += ": ");
		let n = e.formattedValue;
		return gc(n) || (t += n), t;
	},
	labelColor(e) {
		let t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
		return {
			borderColor: t.borderColor,
			backgroundColor: t.backgroundColor,
			borderWidth: t.borderWidth,
			borderDash: t.borderDash,
			borderDashOffset: t.borderDashOffset,
			borderRadius: 0
		};
	},
	labelTextColor() {
		return this.options.bodyColor;
	},
	labelPointStyle(e) {
		let t = e.chart.getDatasetMeta(e.datasetIndex).controller.getStyle(e.dataIndex);
		return {
			pointStyle: t.pointStyle,
			rotation: t.rotation
		};
	},
	afterLabel: mc,
	afterBody: mc,
	beforeFooter: mc,
	footer: mc,
	afterFooter: mc
};
function vg(e, t, n, r) {
	let i = e[t].call(n, r);
	return i === void 0 ? _g[t].call(n, r) : i;
}
var yg = class extends jp {
	static positioners = tg;
	constructor(e) {
		super(), this.opacity = 0, this._active = [], this._eventPosition = void 0, this._size = void 0, this._cachedAnimations = void 0, this._tooltipItems = [], this.$animations = void 0, this.$context = void 0, this.chart = e.chart, this.options = e.options, this.dataPoints = void 0, this.title = void 0, this.beforeBody = void 0, this.body = void 0, this.afterBody = void 0, this.footer = void 0, this.xAlign = void 0, this.yAlign = void 0, this.x = void 0, this.y = void 0, this.height = void 0, this.width = void 0, this.caretX = void 0, this.caretY = void 0, this.labelColors = void 0, this.labelPointStyles = void 0, this.labelTextColors = void 0;
	}
	initialize(e) {
		this.options = e, this._cachedAnimations = void 0, this.$context = void 0;
	}
	_resolveAnimations() {
		let e = this._cachedAnimations;
		if (e) return e;
		let t = this.chart, n = this.options.setContext(this.getContext()), r = n.enabled && t.options.animation && n.animations, i = new qd(this.chart, r);
		return r._cacheable && (this._cachedAnimations = Object.freeze(i)), i;
	}
	getContext() {
		return this.$context ||= hg(this.chart.getContext(), this, this._tooltipItems);
	}
	getTitle(e, t) {
		let { callbacks: n } = t, r = vg(n, "beforeTitle", this, e), i = vg(n, "title", this, e), a = vg(n, "afterTitle", this, e), o = [];
		return o = ng(o, rg(r)), o = ng(o, rg(i)), o = ng(o, rg(a)), o;
	}
	getBeforeBody(e, t) {
		return mg(vg(t.callbacks, "beforeBody", this, e));
	}
	getBody(e, t) {
		let { callbacks: n } = t, r = [];
		return wc(e, (e) => {
			let t = {
				before: [],
				lines: [],
				after: []
			}, i = gg(n, e);
			ng(t.before, rg(vg(i, "beforeLabel", this, e))), ng(t.lines, vg(i, "label", this, e)), ng(t.after, rg(vg(i, "afterLabel", this, e))), r.push(t);
		}), r;
	}
	getAfterBody(e, t) {
		return mg(vg(t.callbacks, "afterBody", this, e));
	}
	getFooter(e, t) {
		let { callbacks: n } = t, r = vg(n, "beforeFooter", this, e), i = vg(n, "footer", this, e), a = vg(n, "afterFooter", this, e), o = [];
		return o = ng(o, rg(r)), o = ng(o, rg(i)), o = ng(o, rg(a)), o;
	}
	_createItems(e) {
		let t = this._active, n = this.chart.data, r = [], i = [], a = [], o = [], s, c;
		for (s = 0, c = t.length; s < c; ++s) o.push(ig(this.chart, t[s]));
		return e.filter && (o = o.filter((t, r, i) => e.filter(t, r, i, n))), e.itemSort && (o = o.sort((t, r) => e.itemSort(t, r, n))), wc(o, (t) => {
			let n = gg(e.callbacks, t);
			r.push(vg(n, "labelColor", this, t)), i.push(vg(n, "labelPointStyle", this, t)), a.push(vg(n, "labelTextColor", this, t));
		}), this.labelColors = r, this.labelPointStyles = i, this.labelTextColors = a, this.dataPoints = o, o;
	}
	update(e, t) {
		let n = this.options.setContext(this.getContext()), r = this._active, i, a = [];
		if (!r.length) this.opacity !== 0 && (i = { opacity: 0 });
		else {
			let e = tg[n.position].call(this, r, this._eventPosition);
			a = this._createItems(n), this.title = this.getTitle(a, n), this.beforeBody = this.getBeforeBody(a, n), this.body = this.getBody(a, n), this.afterBody = this.getAfterBody(a, n), this.footer = this.getFooter(a, n);
			let t = this._size = ag(this, n), o = Object.assign({}, e, t), s = lg(this.chart, n, o), c = fg(n, o, s, this.chart);
			this.xAlign = s.xAlign, this.yAlign = s.yAlign, i = {
				opacity: 1,
				x: c.x,
				y: c.y,
				width: t.width,
				height: t.height,
				caretX: e.x,
				caretY: e.y
			};
		}
		this._tooltipItems = a, this.$context = void 0, i && this._resolveAnimations().update(this, i), e && n.external && n.external.call(this, {
			chart: this.chart,
			tooltip: this,
			replay: t
		});
	}
	drawCaret(e, t, n, r) {
		let i = this.getCaretPosition(e, n, r);
		t.lineTo(i.x1, i.y1), t.lineTo(i.x2, i.y2), t.lineTo(i.x3, i.y3);
	}
	getCaretPosition(e, t, n) {
		let { xAlign: r, yAlign: i } = this, { caretSize: a, cornerRadius: o } = n, { topLeft: s, topRight: c, bottomLeft: l, bottomRight: u } = Cu(o), { x: d, y: f } = e, { width: p, height: m } = t, h, g, _, v, y, b;
		return i === "center" ? (y = f + m / 2, r === "left" ? (h = d, g = h - a, v = y + a, b = y - a) : (h = d + p, g = h + a, v = y - a, b = y + a), _ = h) : (g = r === "left" ? d + Math.max(s, l) + a : r === "right" ? d + p - Math.max(c, u) - a : this.caretX, i === "top" ? (v = f, y = v - a, h = g - a, _ = g + a) : (v = f + m, y = v + a, h = g + a, _ = g - a), b = v), {
			x1: h,
			x2: g,
			x3: _,
			y1: v,
			y2: y,
			y3: b
		};
	}
	drawTitle(e, t, n) {
		let r = this.title, i = r.length, a, o, s;
		if (i) {
			let c = Td(n.rtl, this.x, this.width);
			for (e.x = pg(this, n.titleAlign, n), t.textAlign = c.textAlign(n.titleAlign), t.textBaseline = "middle", a = Tu(n.titleFont), o = n.titleSpacing, t.fillStyle = n.titleColor, t.font = a.string, s = 0; s < i; ++s) t.fillText(r[s], c.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + o, s + 1 === i && (e.y += n.titleMarginBottom - o);
		}
	}
	_drawColorBox(e, t, n, r, i) {
		let a = this.labelColors[n], o = this.labelPointStyles[n], { boxHeight: s, boxWidth: c } = i, l = Tu(i.bodyFont), u = pg(this, "left", i), d = r.x(u), f = s < l.lineHeight ? (l.lineHeight - s) / 2 : 0, p = t.y + f;
		if (i.usePointStyle) {
			let t = {
				radius: Math.min(c, s) / 2,
				pointStyle: o.pointStyle,
				rotation: o.rotation,
				borderWidth: 1
			}, n = r.leftForLtr(d, c) + c / 2, l = p + s / 2;
			e.strokeStyle = i.multiKeyBackground, e.fillStyle = i.multiKeyBackground, au(e, t, n, l), e.strokeStyle = a.borderColor, e.fillStyle = a.backgroundColor, au(e, t, n, l);
		} else {
			e.lineWidth = vc(a.borderWidth) ? Math.max(...Object.values(a.borderWidth)) : a.borderWidth || 1, e.strokeStyle = a.borderColor, e.setLineDash(a.borderDash || []), e.lineDashOffset = a.borderDashOffset || 0;
			let t = r.leftForLtr(d, c), n = r.leftForLtr(r.xPlus(d, 1), c - 2), o = Cu(a.borderRadius);
			Object.values(o).some((e) => e !== 0) ? (e.beginPath(), e.fillStyle = i.multiKeyBackground, gu(e, {
				x: t,
				y: p,
				w: c,
				h: s,
				radius: o
			}), e.fill(), e.stroke(), e.fillStyle = a.backgroundColor, e.beginPath(), gu(e, {
				x: n,
				y: p + 1,
				w: c - 2,
				h: s - 2,
				radius: o
			}), e.fill()) : (e.fillStyle = i.multiKeyBackground, e.fillRect(t, p, c, s), e.strokeRect(t, p, c, s), e.fillStyle = a.backgroundColor, e.fillRect(n, p + 1, c - 2, s - 2));
		}
		e.fillStyle = this.labelTextColors[n];
	}
	drawBody(e, t, n) {
		let { body: r } = this, { bodySpacing: i, bodyAlign: a, displayColors: o, boxHeight: s, boxWidth: c, boxPadding: l } = n, u = Tu(n.bodyFont), d = u.lineHeight, f = 0, p = Td(n.rtl, this.x, this.width), m = function(n) {
			t.fillText(n, p.x(e.x + f), e.y + d / 2), e.y += d + i;
		}, h = p.textAlign(a), g, _, v, y, b, x, S;
		for (t.textAlign = a, t.textBaseline = "middle", t.font = u.string, e.x = pg(this, h, n), t.fillStyle = n.bodyColor, wc(this.beforeBody, m), f = o && h !== "right" ? a === "center" ? c / 2 + l : c + 2 + l : 0, y = 0, x = r.length; y < x; ++y) {
			for (g = r[y], _ = this.labelTextColors[y], t.fillStyle = _, wc(g.before, m), v = g.lines, o && v.length && (this._drawColorBox(t, e, y, p, n), d = Math.max(u.lineHeight, s)), b = 0, S = v.length; b < S; ++b) m(v[b]), d = u.lineHeight;
			wc(g.after, m);
		}
		f = 0, d = u.lineHeight, wc(this.afterBody, m), e.y -= i;
	}
	drawFooter(e, t, n) {
		let r = this.footer, i = r.length, a, o;
		if (i) {
			let s = Td(n.rtl, this.x, this.width);
			for (e.x = pg(this, n.footerAlign, n), e.y += n.footerMarginTop, t.textAlign = s.textAlign(n.footerAlign), t.textBaseline = "middle", a = Tu(n.footerFont), t.fillStyle = n.footerColor, t.font = a.string, o = 0; o < i; ++o) t.fillText(r[o], s.x(e.x), e.y + a.lineHeight / 2), e.y += a.lineHeight + n.footerSpacing;
		}
	}
	drawBackground(e, t, n, r) {
		let { xAlign: i, yAlign: a } = this, { x: o, y: s } = e, { width: c, height: l } = n, { topLeft: u, topRight: d, bottomLeft: f, bottomRight: p } = Cu(r.cornerRadius);
		t.fillStyle = r.backgroundColor, t.strokeStyle = r.borderColor, t.lineWidth = r.borderWidth, t.beginPath(), t.moveTo(o + u, s), a === "top" && this.drawCaret(e, t, n, r), t.lineTo(o + c - d, s), t.quadraticCurveTo(o + c, s, o + c, s + d), a === "center" && i === "right" && this.drawCaret(e, t, n, r), t.lineTo(o + c, s + l - p), t.quadraticCurveTo(o + c, s + l, o + c - p, s + l), a === "bottom" && this.drawCaret(e, t, n, r), t.lineTo(o + f, s + l), t.quadraticCurveTo(o, s + l, o, s + l - f), a === "center" && i === "left" && this.drawCaret(e, t, n, r), t.lineTo(o, s + u), t.quadraticCurveTo(o, s, o + u, s), t.closePath(), t.fill(), r.borderWidth > 0 && t.stroke();
	}
	_updateAnimationTarget(e) {
		let t = this.chart, n = this.$animations, r = n && n.x, i = n && n.y;
		if (r || i) {
			let n = tg[e.position].call(this, this._active, this._eventPosition);
			if (!n) return;
			let a = this._size = ag(this, e), o = Object.assign({}, n, this._size), s = lg(t, e, o), c = fg(e, o, s, t);
			(r._to !== c.x || i._to !== c.y) && (this.xAlign = s.xAlign, this.yAlign = s.yAlign, this.width = a.width, this.height = a.height, this.caretX = n.x, this.caretY = n.y, this._resolveAnimations().update(this, c));
		}
	}
	_willRender() {
		return !!this.opacity;
	}
	draw(e) {
		let t = this.options.setContext(this.getContext()), n = this.opacity;
		if (!n) return;
		this._updateAnimationTarget(t);
		let r = {
			width: this.width,
			height: this.height
		}, i = {
			x: this.x,
			y: this.y
		};
		n = Math.abs(n) < .001 ? 0 : n;
		let a = wu(t.padding), o = this.title.length || this.beforeBody.length || this.body.length || this.afterBody.length || this.footer.length;
		t.enabled && o && (e.save(), e.globalAlpha = n, this.drawBackground(i, e, r, t), Ed(e, t.textDirection), i.y += a.top, this.drawTitle(i, e, t), this.drawBody(i, e, t), this.drawFooter(i, e, t), Dd(e, t.textDirection), e.restore());
	}
	getActiveElements() {
		return this._active || [];
	}
	setActiveElements(e, t) {
		let n = this._active, r = e.map(({ datasetIndex: e, index: t }) => {
			let n = this.chart.getDatasetMeta(e);
			if (!n) throw Error("Cannot find a dataset at index " + e);
			return {
				datasetIndex: e,
				element: n.data[t],
				index: t
			};
		}), i = !Tc(n, r), a = this._positionChanged(r, t);
		(i || a) && (this._active = r, this._eventPosition = t, this._ignoreReplayEvents = !0, this.update(!0));
	}
	handleEvent(e, t, n = !0) {
		if (t && this._ignoreReplayEvents) return !1;
		this._ignoreReplayEvents = !1;
		let r = this.options, i = this._active || [], a = this._getActiveElements(e, i, t, n), o = this._positionChanged(a, e), s = t || !Tc(a, i) || o;
		return s && (this._active = a, (r.enabled || r.external) && (this._eventPosition = {
			x: e.x,
			y: e.y
		}, this.update(!0, t))), s;
	}
	_getActiveElements(e, t, n, r) {
		let i = this.options;
		if (e.type === "mouseout") return [];
		if (!r) return t.filter((e) => this.chart.data.datasets[e.datasetIndex] && this.chart.getDatasetMeta(e.datasetIndex).controller.getParsed(e.index) !== void 0);
		let a = this.chart.getElementsAtEventForMode(e, i.mode, i, n);
		return i.reverse && a.reverse(), a;
	}
	_positionChanged(e, t) {
		let { caretX: n, caretY: r, options: i } = this, a = tg[i.position].call(this, e, t);
		return a !== !1 && (n !== a.x || r !== a.y);
	}
}, bg = {
	id: "tooltip",
	_element: yg,
	positioners: tg,
	afterInit(e, t, n) {
		n && (e.tooltip = new yg({
			chart: e,
			options: n
		}));
	},
	beforeUpdate(e, t, n) {
		e.tooltip && e.tooltip.initialize(n);
	},
	reset(e, t, n) {
		e.tooltip && e.tooltip.initialize(n);
	},
	afterDraw(e) {
		let t = e.tooltip;
		if (t && t._willRender()) {
			let n = { tooltip: t };
			if (e.notifyPlugins("beforeTooltipDraw", {
				...n,
				cancelable: !0
			}) === !1) return;
			t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
		}
	},
	afterEvent(e, t) {
		if (e.tooltip) {
			let n = t.replay;
			e.tooltip.handleEvent(t.event, n, t.inChartArea) && (t.changed = !0);
		}
	},
	defaults: {
		enabled: !0,
		external: null,
		position: "average",
		backgroundColor: "rgba(0,0,0,0.8)",
		titleColor: "#fff",
		titleFont: { weight: "bold" },
		titleSpacing: 2,
		titleMarginBottom: 6,
		titleAlign: "left",
		bodyColor: "#fff",
		bodySpacing: 2,
		bodyFont: {},
		bodyAlign: "left",
		footerColor: "#fff",
		footerSpacing: 2,
		footerMarginTop: 6,
		footerFont: { weight: "bold" },
		footerAlign: "left",
		padding: 6,
		caretPadding: 2,
		caretSize: 5,
		cornerRadius: 6,
		boxHeight: (e, t) => t.bodyFont.size,
		boxWidth: (e, t) => t.bodyFont.size,
		multiKeyBackground: "#fff",
		displayColors: !0,
		boxPadding: 0,
		borderColor: "rgba(0,0,0,0)",
		borderWidth: 0,
		animation: {
			duration: 400,
			easing: "easeOutQuart"
		},
		animations: {
			numbers: {
				type: "number",
				properties: [
					"x",
					"y",
					"width",
					"height",
					"caretX",
					"caretY"
				]
			},
			opacity: {
				easing: "linear",
				duration: 200
			}
		},
		callbacks: _g
	},
	defaultRoutes: {
		bodyFont: "font",
		footerFont: "font",
		titleFont: "font"
	},
	descriptors: {
		_scriptable: (e) => e !== "filter" && e !== "itemSort" && e !== "external",
		_indexable: !1,
		callbacks: {
			_scriptable: !1,
			_indexable: !1
		},
		animation: { _fallback: !1 },
		animations: { _fallback: "animation" }
	},
	additionalOptionScopes: ["interaction"]
}, xg = (e, t, n, r) => (typeof t == "string" ? (n = e.push(t) - 1, r.unshift({
	index: n,
	label: t
})) : isNaN(t) && (n = null), n);
function Sg(e, t, n, r) {
	let i = e.indexOf(t);
	return i === -1 ? xg(e, t, n, r) : i === e.lastIndexOf(t) ? i : n;
}
var Cg = (e, t) => e === null ? null : fl(Math.round(e), 0, t);
function wg(e) {
	let t = this.getLabels();
	return e >= 0 && e < t.length ? t[e] : e;
}
var Tg = class extends Zp {
	static id = "category";
	static defaults = { ticks: { callback: wg } };
	constructor(e) {
		super(e), this._startValue = void 0, this._valueRange = 0, this._addedLabels = [];
	}
	init(e) {
		let t = this._addedLabels;
		if (t.length) {
			let e = this.getLabels();
			for (let { index: n, label: r } of t) e[n] === r && e.splice(n, 1);
			this._addedLabels = [];
		}
		super.init(e);
	}
	parse(e, t) {
		if (gc(e)) return null;
		let n = this.getLabels();
		return t = isFinite(t) && n[t] === e ? t : Sg(n, e, xc(t, e), this._addedLabels), Cg(t, n.length - 1);
	}
	determineDataLimits() {
		let { minDefined: e, maxDefined: t } = this.getUserBounds(), { min: n, max: r } = this.getMinMax(!0);
		this.options.bounds === "ticks" && (e || (n = 0), t || (r = this.getLabels().length - 1)), this.min = n, this.max = r;
	}
	buildTicks() {
		let e = this.min, t = this.max, n = this.options.offset, r = [], i = this.getLabels();
		i = e === 0 && t === i.length - 1 ? i : i.slice(e, t + 1), this._valueRange = Math.max(i.length - +!n, 1), this._startValue = this.min - (n ? .5 : 0);
		for (let n = e; n <= t; n++) r.push({ value: n });
		return r;
	}
	getLabelForValue(e) {
		return wg.call(this, e);
	}
	configure() {
		super.configure(), this.isHorizontal() || (this._reversePixels = !this._reversePixels);
	}
	getPixelForValue(e) {
		return typeof e != "number" && (e = this.parse(e)), e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
	}
	getPixelForTick(e) {
		let t = this.ticks;
		return e < 0 || e > t.length - 1 ? null : this.getPixelForValue(t[e].value);
	}
	getValueForPixel(e) {
		return Math.round(this._startValue + this.getDecimalForPixel(e) * this._valueRange);
	}
	getBasePixel() {
		return this.bottom;
	}
};
function Eg(e, t) {
	let n = [], { bounds: r, step: i, min: a, max: o, precision: s, count: c, maxTicks: l, maxDigits: u, includeBounds: d } = e, f = i || 1, p = l - 1, { min: m, max: h } = t, g = !gc(a), _ = !gc(o), v = !gc(c), y = (h - m) / (u + 1), b = Qc((h - m) / p / f) * f, x, S, C, w;
	if (b < 1e-14 && !g && !_) return [{ value: m }, { value: h }];
	w = Math.ceil(h / b) - Math.floor(m / b), w > p && (b = Qc(w * b / p / f) * f), gc(s) || (x = 10 ** s, b = Math.ceil(b * x) / x), r === "ticks" ? (S = Math.floor(m / b) * b, C = Math.ceil(h / b) * b) : (S = m, C = h), g && _ && i && nl((o - a) / i, b / 1e3) ? (w = Math.round(Math.min((o - a) / b, l)), b = (o - a) / w, S = a, C = o) : v ? (S = g ? a : S, C = _ ? o : C, w = c - 1, b = (C - S) / w) : (w = (C - S) / b, w = Zc(w, Math.round(w), b / 1e3) ? Math.round(w) : Math.ceil(w));
	let T = Math.max(ol(b), ol(S));
	x = 10 ** (gc(s) ? T : s), S = Math.round(S * x) / x, C = Math.round(C * x) / x;
	let E = 0;
	for (g && (d && S !== a ? (n.push({ value: a }), S < a && E++, Zc(Math.round((S + E * b) * x) / x, a, Dg(a, y, e)) && E++) : S < a && E++); E < w; ++E) {
		let e = Math.round((S + E * b) * x) / x;
		if (_ && e > o) break;
		n.push({ value: e });
	}
	return _ && d && C !== o ? n.length && Zc(n[n.length - 1].value, o, Dg(o, y, e)) ? n[n.length - 1].value = o : n.push({ value: o }) : (!_ || C === o) && n.push({ value: C }), n;
}
function Dg(e, t, { horizontal: n, minRotation: r }) {
	let i = il(r), a = (n ? Math.sin(i) : Math.cos(i)) || .001, o = .75 * t * ("" + e).length;
	return Math.min(t / a, o);
}
var Og = class extends Zp {
	constructor(e) {
		super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._endValue = void 0, this._valueRange = 0;
	}
	parse(e, t) {
		return gc(e) || (typeof e == "number" || e instanceof Number) && !isFinite(+e) ? null : +e;
	}
	handleTickRangeOptions() {
		let { beginAtZero: e } = this.options, { minDefined: t, maxDefined: n } = this.getUserBounds(), { min: r, max: i } = this, a = (e) => r = t ? r : e, o = (e) => i = n ? i : e;
		if (e) {
			let e = Xc(r), t = Xc(i);
			e < 0 && t < 0 ? o(0) : e > 0 && t > 0 && a(0);
		}
		if (r === i) {
			let t = i === 0 ? 1 : Math.abs(i * .05);
			o(i + t), e || a(r - t);
		}
		this.min = r, this.max = i;
	}
	getTickLimit() {
		let { maxTicksLimit: e, stepSize: t } = this.options.ticks, n;
		return t ? (n = Math.ceil(this.max / t) - Math.floor(this.min / t) + 1, n > 1e3 && (console.warn(`scales.${this.id}.ticks.stepSize: ${t} would result generating up to ${n} ticks. Limiting to 1000.`), n = 1e3)) : (n = this.computeTickLimit(), e ||= 11), e && (n = Math.min(e, n)), n;
	}
	computeTickLimit() {
		return Infinity;
	}
	buildTicks() {
		let e = this.options, t = e.ticks, n = this.getTickLimit();
		n = Math.max(2, n);
		let r = Eg({
			maxTicks: n,
			bounds: e.bounds,
			min: e.min,
			max: e.max,
			precision: t.precision,
			step: t.stepSize,
			count: t.count,
			maxDigits: this._maxDigits(),
			horizontal: this.isHorizontal(),
			minRotation: t.minRotation || 0,
			includeBounds: t.includeBounds !== !1
		}, this._range || this);
		return e.bounds === "ticks" && rl(r, this, "value"), e.reverse ? (r.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), r;
	}
	configure() {
		let e = this.ticks, t = this.min, n = this.max;
		if (super.configure(), this.options.offset && e.length) {
			let r = (n - t) / Math.max(e.length - 1, 1) / 2;
			t -= r, n += r;
		}
		this._startValue = t, this._endValue = n, this._valueRange = n - t;
	}
	getLabelForValue(e) {
		return Wl(e, this.chart.options.locale, this.options.ticks.format);
	}
}, kg = class extends Og {
	static id = "linear";
	static defaults = { ticks: { callback: ql.formatters.numeric } };
	determineDataLimits() {
		let { min: e, max: t } = this.getMinMax(!0);
		this.min = yc(e) ? e : 0, this.max = yc(t) ? t : 1, this.handleTickRangeOptions();
	}
	computeTickLimit() {
		let e = this.isHorizontal(), t = e ? this.width : this.height, n = il(this.options.ticks.minRotation), r = (e ? Math.sin(n) : Math.cos(n)) || .001, i = this._resolveTickFontOptions(0);
		return Math.ceil(t / Math.min(40, i.lineHeight / r));
	}
	getPixelForValue(e) {
		return e === null ? NaN : this.getPixelForDecimal((e - this._startValue) / this._valueRange);
	}
	getValueForPixel(e) {
		return this._startValue + this.getDecimalForPixel(e) * this._valueRange;
	}
}, Ag = (e) => Math.floor(Yc(e)), jg = (e, t) => 10 ** (Ag(e) + t);
function Mg(e) {
	return e / 10 ** Ag(e) == 1;
}
function Ng(e, t, n) {
	let r = 10 ** n, i = Math.floor(e / r);
	return Math.ceil(t / r) - i;
}
function Pg(e, t) {
	let n = Ag(t - e);
	for (; Ng(e, t, n) > 10;) n++;
	for (; Ng(e, t, n) < 10;) n--;
	return Math.min(n, Ag(e));
}
function Fg(e, { min: t, max: n }) {
	t = bc(e.min, t);
	let r = [], i = Ag(t), a = Pg(t, n), o = a < 0 ? 10 ** Math.abs(a) : 1, s = 10 ** a, c = i > a ? 10 ** i : 0, l = Math.round((t - c) * o) / o, u = Math.floor((t - c) / s / 10) * s * 10, d = Math.floor((l - u) / 10 ** a), f = bc(e.min, Math.round((c + u + d * 10 ** a) * o) / o);
	for (; f < n;) r.push({
		value: f,
		major: Mg(f),
		significand: d
	}), d >= 10 ? d = d < 15 ? 15 : 20 : d++, d >= 20 && (a++, d = 2, o = a >= 0 ? 1 : o), f = Math.round((c + u + d * 10 ** a) * o) / o;
	let p = bc(e.max, f);
	return r.push({
		value: p,
		major: Mg(p),
		significand: d
	}), r;
}
(class extends Zp {
	static id = "logarithmic";
	static defaults = { ticks: {
		callback: ql.formatters.logarithmic,
		major: { enabled: !0 }
	} };
	constructor(e) {
		super(e), this.start = void 0, this.end = void 0, this._startValue = void 0, this._valueRange = 0;
	}
	parse(e, t) {
		let n = Og.prototype.parse.apply(this, [e, t]);
		if (n === 0) {
			this._zero = !0;
			return;
		}
		return yc(n) && n > 0 ? n : null;
	}
	determineDataLimits() {
		let { min: e, max: t } = this.getMinMax(!0);
		this.min = yc(e) ? Math.max(0, e) : null, this.max = yc(t) ? Math.max(0, t) : null, this.options.beginAtZero && (this._zero = !0), this._zero && this.min !== this._suggestedMin && !yc(this._userMin) && (this.min = e === jg(this.min, 0) ? jg(this.min, -1) : jg(this.min, 0)), this.handleTickRangeOptions();
	}
	handleTickRangeOptions() {
		let { minDefined: e, maxDefined: t } = this.getUserBounds(), n = this.min, r = this.max, i = (t) => n = e ? n : t, a = (e) => r = t ? r : e;
		n === r && (n <= 0 ? (i(1), a(10)) : (i(jg(n, -1)), a(jg(r, 1)))), n <= 0 && i(jg(r, -1)), r <= 0 && a(jg(n, 1)), this.min = n, this.max = r;
	}
	buildTicks() {
		let e = this.options, t = Fg({
			min: this._userMin,
			max: this._userMax
		}, this);
		return e.bounds === "ticks" && rl(t, this, "value"), e.reverse ? (t.reverse(), this.start = this.max, this.end = this.min) : (this.start = this.min, this.end = this.max), t;
	}
	getLabelForValue(e) {
		return e === void 0 ? "0" : Wl(e, this.chart.options.locale, this.options.ticks.format);
	}
	configure() {
		let e = this.min;
		super.configure(), this._startValue = Yc(e), this._valueRange = Yc(this.max) - Yc(e);
	}
	getPixelForValue(e) {
		return (e === void 0 || e === 0) && (e = this.min), e === null || isNaN(e) ? NaN : this.getPixelForDecimal(e === this.min ? 0 : (Yc(e) - this._startValue) / this._valueRange);
	}
	getValueForPixel(e) {
		let t = this.getDecimalForPixel(e);
		return 10 ** (this._startValue + t * this._valueRange);
	}
});
function Ig(e) {
	let t = e.ticks;
	if (t.display && e.display) {
		let e = wu(t.backdropPadding);
		return xc(t.font && t.font.size, $l.font.size) + e.height;
	}
	return 0;
}
function Lg(e, t, n) {
	return n = _c(n) ? n : [n], {
		w: nu(e, t.string, n),
		h: n.length * t.lineHeight
	};
}
function Rg(e, t, n, r, i) {
	return e === r || e === i ? {
		start: t - n / 2,
		end: t + n / 2
	} : e < r || e > i ? {
		start: t - n,
		end: t
	} : {
		start: t,
		end: t + n
	};
}
function zg(e) {
	let t = {
		l: e.left + e._padding.left,
		r: e.right - e._padding.right,
		t: e.top + e._padding.top,
		b: e.bottom - e._padding.bottom
	}, n = Object.assign({}, t), r = [], i = [], a = e._pointLabels.length, o = e.options.pointLabels, s = o.centerPointLabels ? Vc / a : 0;
	for (let c = 0; c < a; c++) {
		let a = o.setContext(e.getPointLabelContext(c));
		i[c] = a.padding;
		let l = e.getPointPosition(c, e.drawingArea + i[c], s), u = Tu(a.font), d = Lg(e.ctx, u, e._pointLabels[c]);
		r[c] = d;
		let f = ul(e.getIndexAngle(c) + s), p = Math.round(al(f));
		Bg(n, t, f, Rg(p, l.x, d.w, 0, 180), Rg(p, l.y, d.h, 90, 270));
	}
	e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b), e._pointLabelItems = Ug(e, r, i);
}
function Bg(e, t, n, r, i) {
	let a = Math.abs(Math.sin(n)), o = Math.abs(Math.cos(n)), s = 0, c = 0;
	r.start < t.l ? (s = (t.l - r.start) / a, e.l = Math.min(e.l, t.l - s)) : r.end > t.r && (s = (r.end - t.r) / a, e.r = Math.max(e.r, t.r + s)), i.start < t.t ? (c = (t.t - i.start) / o, e.t = Math.min(e.t, t.t - c)) : i.end > t.b && (c = (i.end - t.b) / o, e.b = Math.max(e.b, t.b + c));
}
function Vg(e, t, n) {
	let r = e.drawingArea, { extra: i, additionalAngle: a, padding: o, size: s } = n, c = e.getPointPosition(t, r + i + o, a), l = Math.round(al(ul(c.angle + Kc))), u = Kg(c.y, s.h, l), d = Wg(l), f = Gg(c.x, s.w, d);
	return {
		visible: !0,
		x: c.x,
		y: u,
		textAlign: d,
		left: f,
		top: u,
		right: f + s.w,
		bottom: u + s.h
	};
}
function Hg(e, t) {
	if (!t) return !0;
	let { left: n, top: r, right: i, bottom: a } = e;
	return !(su({
		x: n,
		y: r
	}, t) || su({
		x: n,
		y: a
	}, t) || su({
		x: i,
		y: r
	}, t) || su({
		x: i,
		y: a
	}, t));
}
function Ug(e, t, n) {
	let r = [], i = e._pointLabels.length, a = e.options, { centerPointLabels: o, display: s } = a.pointLabels, c = {
		extra: Ig(a) / 2,
		additionalAngle: o ? Vc / i : 0
	}, l;
	for (let a = 0; a < i; a++) {
		c.padding = n[a], c.size = t[a];
		let i = Vg(e, a, c);
		r.push(i), s === "auto" && (i.visible = Hg(i, l), i.visible && (l = i));
	}
	return r;
}
function Wg(e) {
	return e === 0 || e === 180 ? "center" : e < 180 ? "left" : "right";
}
function Gg(e, t, n) {
	return n === "right" ? e -= t : n === "center" && (e -= t / 2), e;
}
function Kg(e, t, n) {
	return n === 90 || n === 270 ? e -= t / 2 : (n > 270 || n < 90) && (e -= t), e;
}
function qg(e, t, n) {
	let { left: r, top: i, right: a, bottom: o } = n, { backdropColor: s } = t;
	if (!gc(s)) {
		let n = Cu(t.borderRadius), c = wu(t.backdropPadding);
		e.fillStyle = s;
		let l = r - c.left, u = i - c.top, d = a - r + c.width, f = o - i + c.height;
		Object.values(n).some((e) => e !== 0) ? (e.beginPath(), gu(e, {
			x: l,
			y: u,
			w: d,
			h: f,
			radius: n
		}), e.fill()) : e.fillRect(l, u, d, f);
	}
}
function Jg(e, t) {
	let { ctx: n, options: { pointLabels: r } } = e;
	for (let i = t - 1; i >= 0; i--) {
		let t = e._pointLabelItems[i];
		if (!t.visible) continue;
		let a = r.setContext(e.getPointLabelContext(i));
		qg(n, a, t);
		let o = Tu(a.font), { x: s, y: c, textAlign: l } = t;
		hu(n, e._pointLabels[i], s, c + o.lineHeight / 2, o, {
			color: a.color,
			textAlign: l,
			textBaseline: "middle"
		});
	}
}
function Yg(e, t, n, r) {
	let { ctx: i } = e;
	if (n) i.arc(e.xCenter, e.yCenter, t, 0, Hc);
	else {
		let n = e.getPointPosition(0, t);
		i.moveTo(n.x, n.y);
		for (let a = 1; a < r; a++) n = e.getPointPosition(a, t), i.lineTo(n.x, n.y);
	}
}
function Xg(e, t, n, r, i) {
	let a = e.ctx, o = t.circular, { color: s, lineWidth: c } = t;
	!o && !r || !s || !c || n < 0 || (a.save(), a.strokeStyle = s, a.lineWidth = c, a.setLineDash(i.dash || []), a.lineDashOffset = i.dashOffset, a.beginPath(), Yg(e, n, o, r), a.closePath(), a.stroke(), a.restore());
}
function Zg(e, t, n) {
	return Ou(e, {
		label: n,
		index: t,
		type: "pointLabel"
	});
}
(class extends Og {
	static id = "radialLinear";
	static defaults = {
		display: !0,
		animate: !0,
		position: "chartArea",
		angleLines: {
			display: !0,
			lineWidth: 1,
			borderDash: [],
			borderDashOffset: 0
		},
		grid: { circular: !1 },
		startAngle: 0,
		ticks: {
			showLabelBackdrop: !0,
			callback: ql.formatters.numeric
		},
		pointLabels: {
			backdropColor: void 0,
			backdropPadding: 2,
			display: !0,
			font: { size: 10 },
			callback(e) {
				return e;
			},
			padding: 5,
			centerPointLabels: !1
		}
	};
	static defaultRoutes = {
		"angleLines.color": "borderColor",
		"pointLabels.color": "color",
		"ticks.color": "color"
	};
	static descriptors = { angleLines: { _fallback: "grid" } };
	constructor(e) {
		super(e), this.xCenter = void 0, this.yCenter = void 0, this.drawingArea = void 0, this._pointLabels = [], this._pointLabelItems = [];
	}
	setDimensions() {
		let e = this._padding = wu(Ig(this.options) / 2), t = this.width = this.maxWidth - e.width, n = this.height = this.maxHeight - e.height;
		this.xCenter = Math.floor(this.left + t / 2 + e.left), this.yCenter = Math.floor(this.top + n / 2 + e.top), this.drawingArea = Math.floor(Math.min(t, n) / 2);
	}
	determineDataLimits() {
		let { min: e, max: t } = this.getMinMax(!1);
		this.min = yc(e) && !isNaN(e) ? e : 0, this.max = yc(t) && !isNaN(t) ? t : 0, this.handleTickRangeOptions();
	}
	computeTickLimit() {
		return Math.ceil(this.drawingArea / Ig(this.options));
	}
	generateTickLabels(e) {
		Og.prototype.generateTickLabels.call(this, e), this._pointLabels = this.getLabels().map((e, t) => {
			let n = Cc(this.options.pointLabels.callback, [e, t], this);
			return n || n === 0 ? n : "";
		}).filter((e, t) => this.chart.getDataVisibility(t));
	}
	fit() {
		let e = this.options;
		e.display && e.pointLabels.display ? zg(this) : this.setCenterPoint(0, 0, 0, 0);
	}
	setCenterPoint(e, t, n, r) {
		this.xCenter += Math.floor((e - t) / 2), this.yCenter += Math.floor((n - r) / 2), this.drawingArea -= Math.min(this.drawingArea / 2, Math.max(e, t, n, r));
	}
	getIndexAngle(e) {
		let t = Hc / (this._pointLabels.length || 1), n = this.options.startAngle || 0;
		return ul(e * t + il(n));
	}
	getDistanceFromCenterForValue(e) {
		if (gc(e)) return NaN;
		let t = this.drawingArea / (this.max - this.min);
		return this.options.reverse ? (this.max - e) * t : (e - this.min) * t;
	}
	getValueForDistanceFromCenter(e) {
		if (gc(e)) return NaN;
		let t = e / (this.drawingArea / (this.max - this.min));
		return this.options.reverse ? this.max - t : this.min + t;
	}
	getPointLabelContext(e) {
		let t = this._pointLabels || [];
		if (e >= 0 && e < t.length) {
			let n = t[e];
			return Zg(this.getContext(), e, n);
		}
	}
	getPointPosition(e, t, n = 0) {
		let r = this.getIndexAngle(e) - Kc + n;
		return {
			x: Math.cos(r) * t + this.xCenter,
			y: Math.sin(r) * t + this.yCenter,
			angle: r
		};
	}
	getPointPositionForValue(e, t) {
		return this.getPointPosition(e, this.getDistanceFromCenterForValue(t));
	}
	getBasePosition(e) {
		return this.getPointPositionForValue(e || 0, this.getBaseValue());
	}
	getPointLabelPosition(e) {
		let { left: t, top: n, right: r, bottom: i } = this._pointLabelItems[e];
		return {
			left: t,
			top: n,
			right: r,
			bottom: i
		};
	}
	drawBackground() {
		let { backgroundColor: e, grid: { circular: t } } = this.options;
		if (e) {
			let n = this.ctx;
			n.save(), n.beginPath(), Yg(this, this.getDistanceFromCenterForValue(this._endValue), t, this._pointLabels.length), n.closePath(), n.fillStyle = e, n.fill(), n.restore();
		}
	}
	drawGrid() {
		let e = this.ctx, t = this.options, { angleLines: n, grid: r, border: i } = t, a = this._pointLabels.length, o, s, c;
		if (t.pointLabels.display && Jg(this, a), r.display && this.ticks.forEach((e, t) => {
			if (t !== 0 || t === 0 && this.min < 0) {
				s = this.getDistanceFromCenterForValue(e.value);
				let n = this.getContext(t), o = r.setContext(n), c = i.setContext(n);
				Xg(this, o, s, a, c);
			}
		}), n.display) {
			for (e.save(), o = a - 1; o >= 0; o--) {
				let r = n.setContext(this.getPointLabelContext(o)), { color: i, lineWidth: a } = r;
				!a || !i || (e.lineWidth = a, e.strokeStyle = i, e.setLineDash(r.borderDash), e.lineDashOffset = r.borderDashOffset, s = this.getDistanceFromCenterForValue(t.reverse ? this.min : this.max), c = this.getPointPosition(o, s), e.beginPath(), e.moveTo(this.xCenter, this.yCenter), e.lineTo(c.x, c.y), e.stroke());
			}
			e.restore();
		}
	}
	drawBorder() {}
	drawLabels() {
		let e = this.ctx, t = this.options, n = t.ticks;
		if (!n.display) return;
		let r = this.getIndexAngle(0), i, a;
		e.save(), e.translate(this.xCenter, this.yCenter), e.rotate(r), e.textAlign = "center", e.textBaseline = "middle", this.ticks.forEach((r, o) => {
			if (o === 0 && this.min >= 0 && !t.reverse) return;
			let s = n.setContext(this.getContext(o)), c = Tu(s.font);
			if (i = this.getDistanceFromCenterForValue(this.ticks[o].value), s.showLabelBackdrop) {
				e.font = c.string, a = e.measureText(r.label).width, e.fillStyle = s.backdropColor;
				let t = wu(s.backdropPadding);
				e.fillRect(-a / 2 - t.left, -i - c.size / 2 - t.top, a + t.width, c.size + t.height);
			}
			hu(e, r.label, 0, -i, c, {
				color: s.color,
				strokeColor: s.textStrokeColor,
				strokeWidth: s.textStrokeWidth
			});
		}), e.restore();
	}
	drawTitle() {}
});
var Qg = {
	millisecond: {
		common: !0,
		size: 1,
		steps: 1e3
	},
	second: {
		common: !0,
		size: 1e3,
		steps: 60
	},
	minute: {
		common: !0,
		size: 6e4,
		steps: 60
	},
	hour: {
		common: !0,
		size: 36e5,
		steps: 24
	},
	day: {
		common: !0,
		size: 864e5,
		steps: 30
	},
	week: {
		common: !1,
		size: 6048e5,
		steps: 4
	},
	month: {
		common: !0,
		size: 2628e6,
		steps: 12
	},
	quarter: {
		common: !1,
		size: 7884e6,
		steps: 4
	},
	year: {
		common: !0,
		size: 3154e7
	}
}, $g = /* #__PURE__ */ Object.keys(Qg);
function e_(e, t) {
	return e - t;
}
function t_(e, t) {
	if (gc(t)) return null;
	let n = e._adapter, { parser: r, round: i, isoWeekday: a } = e._parseOpts, o = t;
	return typeof r == "function" && (o = r(o)), yc(o) || (o = typeof r == "string" ? n.parse(o, r) : n.parse(o)), o === null ? null : (i && (o = i === "week" && (tl(a) || a === !0) ? n.startOf(o, "isoWeek", a) : n.startOf(o, i)), +o);
}
function n_(e, t, n, r) {
	let i = $g.length;
	for (let a = $g.indexOf(e); a < i - 1; ++a) {
		let e = Qg[$g[a]], i = e.steps ? e.steps : 2 ** 53 - 1;
		if (e.common && Math.ceil((n - t) / (i * e.size)) <= r) return $g[a];
	}
	return $g[i - 1];
}
function r_(e, t, n, r, i) {
	for (let a = $g.length - 1; a >= $g.indexOf(n); a--) {
		let n = $g[a];
		if (Qg[n].common && e._adapter.diff(i, r, n) >= t - 1) return n;
	}
	return $g[n ? $g.indexOf(n) : 0];
}
function i_(e) {
	for (let t = $g.indexOf(e) + 1, n = $g.length; t < n; ++t) if (Qg[$g[t]].common) return $g[t];
}
function a_(e, t, n) {
	if (!n) e[t] = !0;
	else if (n.length) {
		let { lo: r, hi: i } = hl(n, t), a = n[r] >= t ? n[r] : n[i];
		e[a] = !0;
	}
}
function o_(e, t, n, r) {
	let i = e._adapter, a = +i.startOf(t[0].value, r), o = t[t.length - 1].value, s, c;
	for (s = a; s <= o; s = +i.add(s, 1, r)) c = n[s], c >= 0 && (t[c].major = !0);
	return t;
}
function s_(e, t, n) {
	let r = [], i = {}, a = t.length, o, s;
	for (o = 0; o < a; ++o) s = t[o], i[s] = o, r.push({
		value: s,
		major: !1
	});
	return a === 0 || !n ? r : o_(e, r, i, n);
}
var c_ = class extends Zp {
	static id = "time";
	static defaults = {
		bounds: "data",
		adapters: {},
		time: {
			parser: !1,
			unit: !1,
			round: !1,
			isoWeekday: !1,
			minUnit: "millisecond",
			displayFormats: {}
		},
		ticks: {
			source: "auto",
			callback: !1,
			major: { enabled: !1 }
		}
	};
	constructor(e) {
		super(e), this._cache = {
			data: [],
			labels: [],
			all: []
		}, this._unit = "day", this._majorUnit = void 0, this._offsets = {}, this._normalized = !1, this._parseOpts = void 0;
	}
	init(e, t = {}) {
		let n = e.time ||= {}, r = this._adapter = new Ff._date(e.adapters.date);
		r.init(t), Ac(n.displayFormats, r.formats()), this._parseOpts = {
			parser: n.parser,
			round: n.round,
			isoWeekday: n.isoWeekday
		}, super.init(e), this._normalized = t.normalized;
	}
	parse(e, t) {
		return e === void 0 ? null : t_(this, e);
	}
	beforeLayout() {
		super.beforeLayout(), this._cache = {
			data: [],
			labels: [],
			all: []
		};
	}
	determineDataLimits() {
		let e = this.options, t = this._adapter, n = e.time.unit || "day", { min: r, max: i, minDefined: a, maxDefined: o } = this.getUserBounds();
		function s(e) {
			!a && !isNaN(e.min) && (r = Math.min(r, e.min)), !o && !isNaN(e.max) && (i = Math.max(i, e.max));
		}
		(!a || !o) && (s(this._getLabelBounds()), (e.bounds !== "ticks" || e.ticks.source !== "labels") && s(this.getMinMax(!1))), r = yc(r) && !isNaN(r) ? r : +t.startOf(Date.now(), n), i = yc(i) && !isNaN(i) ? i : +t.endOf(Date.now(), n) + 1, this.min = Math.min(r, i - 1), this.max = Math.max(r + 1, i);
	}
	_getLabelBounds() {
		let e = this.getLabelTimestamps(), t = Infinity, n = -Infinity;
		return e.length && (t = e[0], n = e[e.length - 1]), {
			min: t,
			max: n
		};
	}
	buildTicks() {
		let e = this.options, t = e.time, n = e.ticks, r = n.source === "labels" ? this.getLabelTimestamps() : this._generate();
		e.bounds === "ticks" && r.length && (this.min = this._userMin || r[0], this.max = this._userMax || r[r.length - 1]);
		let i = this.min, a = this.max, o = vl(r, i, a);
		return this._unit = t.unit || (n.autoSkip ? n_(t.minUnit, this.min, this.max, this._getLabelCapacity(i)) : r_(this, o.length, t.minUnit, this.min, this.max)), this._majorUnit = !n.major.enabled || this._unit === "year" ? void 0 : i_(this._unit), this.initOffsets(r), e.reverse && o.reverse(), s_(this, o, this._majorUnit);
	}
	afterAutoSkip() {
		this.options.offsetAfterAutoskip && this.initOffsets(this.ticks.map((e) => +e.value));
	}
	initOffsets(e = []) {
		let t = 0, n = 0, r, i;
		this.options.offset && e.length && (r = this.getDecimalForValue(e[0]), t = e.length === 1 ? 1 - r : (this.getDecimalForValue(e[1]) - r) / 2, i = this.getDecimalForValue(e[e.length - 1]), n = e.length === 1 ? i : (i - this.getDecimalForValue(e[e.length - 2])) / 2);
		let a = e.length < 3 ? .5 : .25;
		t = fl(t, 0, a), n = fl(n, 0, a), this._offsets = {
			start: t,
			end: n,
			factor: 1 / (t + 1 + n)
		};
	}
	_generate() {
		let e = this._adapter, t = this.min, n = this.max, r = this.options, i = r.time, a = i.unit || n_(i.minUnit, t, n, this._getLabelCapacity(t)), o = xc(r.ticks.stepSize, 1), s = a === "week" ? i.isoWeekday : !1, c = tl(s) || s === !0, l = {}, u = t, d, f;
		if (c && (u = +e.startOf(u, "isoWeek", s)), u = +e.startOf(u, c ? "day" : a), e.diff(n, t, a) > 1e5 * o) throw Error(t + " and " + n + " are too far apart with stepSize of " + o + " " + a);
		let p = r.ticks.source === "data" && this.getDataTimestamps();
		for (d = u, f = 0; d < n; d = +e.add(d, o, a), f++) a_(l, d, p);
		return (d === n || r.bounds === "ticks" || f === 1) && a_(l, d, p), Object.keys(l).sort(e_).map((e) => +e);
	}
	getLabelForValue(e) {
		let t = this._adapter, n = this.options.time;
		return n.tooltipFormat ? t.format(e, n.tooltipFormat) : t.format(e, n.displayFormats.datetime);
	}
	format(e, t) {
		let n = this.options.time.displayFormats, r = this._unit, i = t || n[r];
		return this._adapter.format(e, i);
	}
	_tickFormatFunction(e, t, n, r) {
		let i = this.options, a = i.ticks.callback;
		if (a) return Cc(a, [
			e,
			t,
			n
		], this);
		let o = i.time.displayFormats, s = this._unit, c = this._majorUnit, l = s && o[s], u = c && o[c], d = n[t], f = c && u && d && d.major;
		return this._adapter.format(e, r || (f ? u : l));
	}
	generateTickLabels(e) {
		let t, n, r;
		for (t = 0, n = e.length; t < n; ++t) r = e[t], r.label = this._tickFormatFunction(r.value, t, e);
	}
	getDecimalForValue(e) {
		return e === null ? NaN : (e - this.min) / (this.max - this.min);
	}
	getPixelForValue(e) {
		let t = this._offsets, n = this.getDecimalForValue(e);
		return this.getPixelForDecimal((t.start + n) * t.factor);
	}
	getValueForPixel(e) {
		let t = this._offsets, n = this.getDecimalForPixel(e) / t.factor - t.end;
		return this.min + n * (this.max - this.min);
	}
	_getLabelSize(e) {
		let t = this.options.ticks, n = this.ctx.measureText(e).width, r = il(this.isHorizontal() ? t.maxRotation : t.minRotation), i = Math.cos(r), a = Math.sin(r), o = this._resolveTickFontOptions(0).size;
		return {
			w: n * i + o * a,
			h: n * a + o * i
		};
	}
	_getLabelCapacity(e) {
		let t = this.options.time, n = t.displayFormats, r = n[t.unit] || n.millisecond, i = this._tickFormatFunction(e, 0, s_(this, [e], this._majorUnit), r), a = this._getLabelSize(i), o = Math.floor(this.isHorizontal() ? this.width / a.w : this.height / a.h) - 1;
		return o > 0 ? o : 1;
	}
	getDataTimestamps() {
		let e = this._cache.data || [], t, n;
		if (e.length) return e;
		let r = this.getMatchingVisibleMetas();
		if (this._normalized && r.length) return this._cache.data = r[0].controller.getAllParsedValues(this);
		for (t = 0, n = r.length; t < n; ++t) e = e.concat(r[t].controller.getAllParsedValues(this));
		return this._cache.data = this.normalize(e);
	}
	getLabelTimestamps() {
		let e = this._cache.labels || [], t, n;
		if (e.length) return e;
		let r = this.getLabels();
		for (t = 0, n = r.length; t < n; ++t) e.push(t_(this, r[t]));
		return this._cache.labels = this._normalized ? e : this.normalize(e);
	}
	normalize(e) {
		return Sl(e.sort(e_));
	}
};
function l_(e, t, n) {
	let r = 0, i = e.length - 1, a, o, s, c;
	n ? (t >= e[r].pos && t <= e[i].pos && ({lo: r, hi: i} = gl(e, "pos", t)), {pos: a, time: s} = e[r], {pos: o, time: c} = e[i]) : (t >= e[r].time && t <= e[i].time && ({lo: r, hi: i} = gl(e, "time", t)), {time: a, pos: s} = e[r], {time: o, pos: c} = e[i]);
	let l = o - a;
	return l ? s + (c - s) * (t - a) / l : s;
}
(class extends c_ {
	static id = "timeseries";
	static defaults = c_.defaults;
	constructor(e) {
		super(e), this._table = [], this._minPos = void 0, this._tableRange = void 0;
	}
	initOffsets() {
		let e = this._getTimestampsForTable(), t = this._table = this.buildLookupTable(e);
		this._minPos = l_(t, this.min), this._tableRange = l_(t, this.max) - this._minPos, super.initOffsets(e);
	}
	buildLookupTable(e) {
		let { min: t, max: n } = this, r = [], i = [], a, o, s, c, l;
		for (a = 0, o = e.length; a < o; ++a) c = e[a], c >= t && c <= n && r.push(c);
		if (r.length < 2) return [{
			time: t,
			pos: 0
		}, {
			time: n,
			pos: 1
		}];
		for (a = 0, o = r.length; a < o; ++a) l = r[a + 1], s = r[a - 1], c = r[a], Math.round((l + s) / 2) !== c && i.push({
			time: c,
			pos: a / (o - 1)
		});
		return i;
	}
	_generate() {
		let e = this.min, t = this.max, n = super.getDataTimestamps();
		return (!n.includes(e) || !n.length) && n.splice(0, 0, e), (!n.includes(t) || n.length === 1) && n.push(t), n.sort((e, t) => e - t);
	}
	_getTimestampsForTable() {
		let e = this._cache.all || [];
		if (e.length) return e;
		let t = this.getDataTimestamps(), n = this.getLabelTimestamps();
		return e = t.length && n.length ? this.normalize(t.concat(n)) : t.length ? t : n, e = this._cache.all = e, e;
	}
	getDecimalForValue(e) {
		return (l_(this._table, e) - this._minPos) / this._tableRange;
	}
	getValueForPixel(e) {
		let t = this._offsets, n = this.getDecimalForPixel(e) / t.factor - t.end;
		return l_(this._table, n * this._tableRange + this._minPos, !0);
	}
});
//#endregion
//#region ../node_modules/.pnpm/react-chartjs-2@5.3.1_chart.js@4.5.1_react@19.2.7/node_modules/react-chartjs-2/dist/index.js
var u_ = "label";
function d_(e, t) {
	typeof e == "function" ? e(t) : e && (e.current = t);
}
function f_(e, t) {
	let n = e.options;
	n && t && Object.assign(n, t);
}
function p_(e, t) {
	e.labels = t;
}
function m_(e, t, n = u_) {
	let r = [];
	e.datasets = t.map((t) => {
		let i = e.datasets.find((e) => e[n] === t[n]);
		return !i || !t.data || r.includes(i) ? { ...t } : (r.push(i), Object.assign(i, t), i);
	});
}
function h_(e, t = u_) {
	let n = {
		labels: [],
		datasets: []
	};
	return p_(n, e.labels), m_(n, e.datasets, t), n;
}
function g_(e, t) {
	let { height: n = 150, width: r = 300, redraw: i = !1, datasetIdKey: a, type: o, data: s, options: c, plugins: l = [], fallbackContent: d, updateMode: f, ...p } = e, h = m(null), g = m(null), v = () => {
		h.current && (g.current = new zm(h.current, {
			type: o,
			data: h_(s, a),
			options: c && { ...c },
			plugins: l
		}), d_(t, g.current));
	}, y = () => {
		d_(t, null), g.current &&= (g.current.destroy(), null);
	};
	return u(() => {
		!i && g.current && c && f_(g.current, c);
	}, [i, c]), u(() => {
		!i && g.current && p_(g.current.config.data, s.labels);
	}, [i, s.labels]), u(() => {
		!i && g.current && s.datasets && m_(g.current.config.data, s.datasets, a);
	}, [i, s.datasets]), u(() => {
		g.current && (i ? (y(), setTimeout(v)) : g.current.update(f));
	}, [
		i,
		c,
		s.labels,
		s.datasets,
		f
	]), u(() => {
		g.current && (y(), setTimeout(v));
	}, [o]), u(() => (v(), () => y()), []), /*#__PURE__*/ _("canvas", {
		ref: h,
		role: "img",
		height: n,
		width: r,
		...p,
		children: d
	});
}
var __ = /*#__PURE__*/ i(g_);
function v_(e, t) {
	return zm.register(t), /*#__PURE__*/ i((t, n) => /*#__PURE__*/ _(__, {
		...t,
		ref: n,
		type: e
	}));
}
var y_ = /* #__PURE__ */ v_("line", Nf), b_ = /* #__PURE__ */ v_("bar", Mf), x_ = (e) => {
	if (e == null) return null;
	if (e instanceof Date) return e;
	if (typeof e == "number") {
		let t = new Date(e);
		return isNaN(t.getTime()) ? null : t;
	}
	if (typeof e == "string") {
		let t = new Date(e);
		if (!isNaN(t.getTime())) return t;
		let n = e.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/);
		if (n) {
			let [e, r, i, a] = n;
			if (t = new Date(parseInt(a), parseInt(i) - 1, parseInt(r)), !isNaN(t.getTime())) return t;
		}
		if (n = e.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/), n) {
			let [e, r, i, a] = n;
			if (t = new Date(parseInt(a), parseInt(r) - 1, parseInt(i)), !isNaN(t.getTime())) return t;
		}
		if (n = e.match(/^(\d{4})[\/\-\.](\d{1,2})[\/\-\.](\d{1,2})$/), n) {
			let [e, r, i, a] = n;
			if (t = new Date(parseInt(r), parseInt(i) - 1, parseInt(a)), !isNaN(t.getTime())) return t;
		}
	}
	return null;
}, S_ = (e, t = "medium") => {
	if (!e) return "";
	let n = x_(e);
	if (!n) return "Invalid Date";
	try {
		switch (t) {
			case "short": return n.toLocaleDateString();
			case "long": return n.toLocaleString();
			default: return n.toLocaleDateString(void 0, {
				year: "numeric",
				month: "short",
				day: "numeric"
			});
		}
	} catch {
		return n.toString();
	}
}, C_ = (e) => {
	let t = /^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/, n = 0, r = 0;
	for (let i of e) if (typeof i == "string" && (r++, t.test(i))) {
		let [e, r, a, o] = i.match(t) || [], s = parseInt(r), c = parseInt(a);
		s >= 1 && s <= 31 && c >= 1 && c <= 12 && n++;
	}
	return r > 0 && n / r >= .5;
}, w_ = (e) => typeof window < "u" && document ? getComputedStyle(document.documentElement).getPropertyValue(e).trim() : "", T_ = {
	numeric: "#007AFF",
	categorical: "#FF9F0A",
	date: "#2ba172"
}, E_ = (e, t) => w_(e) || t, D_ = (e, t = .2) => e.startsWith("#") ? `rgba(${parseInt(e.slice(1, 3), 16)}, ${parseInt(e.slice(3, 5), 16)}, ${parseInt(e.slice(5, 7), 16)}, ${t})` : e.startsWith("rgb") ? e.replace("rgb", "rgba").replace(")", `, ${t})`) : e || `rgba(0, 122, 255, ${t})`, O_ = {
	numeric: {
		get primary() {
			return E_("--color-datatype-numeric", T_.numeric);
		},
		get light() {
			return E_("--color-datatype-numeric-light", "#B8E2FF");
		},
		get background() {
			return D_(E_("--color-datatype-numeric", T_.numeric), .2);
		},
		get border() {
			return D_(E_("--color-datatype-numeric", T_.numeric), .8);
		}
	},
	categorical: {
		get primary() {
			return E_("--color-datatype-categorical", T_.categorical);
		},
		get light() {
			return E_("--color-datatype-categorical-light", "#FFD699");
		},
		get background() {
			return D_(E_("--color-datatype-categorical", T_.categorical), .2);
		},
		get border() {
			return D_(E_("--color-datatype-categorical", T_.categorical), .8);
		}
	},
	date: {
		get primary() {
			return E_("--color-datatype-date", T_.date);
		},
		get light() {
			return E_("--color-datatype-date-light", "#D4F8D3");
		},
		get background() {
			return D_(E_("--color-datatype-date", T_.date), .2);
		},
		get border() {
			return D_(E_("--color-datatype-date", T_.date), .8);
		}
	}
};
n.createContext(null);
var k_ = (e) => {
	let t = (e) => {
		let t = [
			{
				bg: "rgba(99, 102, 241, 0.2)",
				border: "rgb(99, 102, 241)"
			},
			{
				bg: "rgba(168, 85, 247, 0.2)",
				border: "rgb(168, 85, 247)"
			},
			{
				bg: "rgba(236, 72, 153, 0.2)",
				border: "rgb(236, 72, 153)"
			},
			{
				bg: "rgba(239, 68, 68, 0.2)",
				border: "rgb(239, 68, 68)"
			},
			{
				bg: "rgba(249, 115, 22, 0.2)",
				border: "rgb(249, 115, 22)"
			},
			{
				bg: "rgba(234, 179, 8, 0.2)",
				border: "rgb(234, 179, 8)"
			},
			{
				bg: "rgba(34, 197, 94, 0.2)",
				border: "rgb(34, 197, 94)"
			},
			{
				bg: "rgba(6, 182, 212, 0.2)",
				border: "rgb(6, 182, 212)"
			},
			{
				bg: "rgba(59, 130, 246, 0.2)",
				border: "rgb(59, 130, 246)"
			},
			{
				bg: "rgba(147, 51, 234, 0.2)",
				border: "rgb(147, 51, 234)"
			},
			{
				bg: "rgba(240, 171, 124, 0.2)",
				border: "rgb(240, 171, 124)"
			},
			{
				bg: "rgba(125, 211, 252, 0.2)",
				border: "rgb(125, 211, 252)"
			},
			{
				bg: "rgba(167, 243, 208, 0.2)",
				border: "rgb(167, 243, 208)"
			},
			{
				bg: "rgba(253, 186, 116, 0.2)",
				border: "rgb(253, 186, 116)"
			}
		], n = {
			bg: "rgba(156, 163, 175, 0.2)",
			border: "rgb(156, 163, 175)"
		};
		return Array(e).fill(null).map((e, r) => r < t.length ? t[r] : n);
	};
	if (!e || Object.keys(e).length === 0) return {
		labels: [],
		datasets: [{
			label: "Count",
			data: [],
			backgroundColor: [],
			borderColor: [],
			borderWidth: 1
		}]
	};
	let n = Object.entries(e).sort((e, t) => t[1] - e[1]), r = n.slice(0, 14), i = n.slice(14).reduce((e, [, t]) => e + t, 0), a = i > 0 ? [...r, ["Other", i]] : r, o = t(a.length);
	return {
		labels: a.map(([e]) => e),
		datasets: [{
			label: "Count",
			data: a.map(([, e]) => e),
			backgroundColor: o.map((e) => e.bg),
			borderColor: o.map((e) => e.border),
			borderWidth: 1,
			borderRadius: 4,
			barThickness: 16
		}]
	};
}, A_ = (e, t = { showEmptyBins: !1 }) => {
	let n = O_.numeric.background, r = O_.numeric.border;
	if (!e) return console.warn("Histogram data is null or undefined"), {
		labels: [],
		datasets: [{
			label: "Frequency",
			data: [],
			backgroundColor: n,
			borderColor: r,
			borderWidth: 1
		}]
	};
	if (e && typeof e == "object" && !Array.isArray(e) && "bins" in e && "counts" in e) {
		let { bins: i, counts: a } = e;
		if (!Array.isArray(i) || !Array.isArray(a) || i.length === 0 || a.length === 0) return console.warn("Invalid histogram data structure", e), {
			labels: [],
			datasets: [{
				label: "Frequency",
				data: [],
				backgroundColor: n,
				borderColor: r,
				borderWidth: 1
			}]
		};
		let o = i.slice(0, -1).map((e, t) => {
			let n = i[t + 1];
			return `${e.toFixed(1)} - ${n.toFixed(1)}`;
		}), s = o, c = a;
		if (!t.showEmptyBins) {
			let e = a.map((e, t) => ({
				count: e,
				index: t
			})).filter((e) => e.count > 0).map((e) => e.index);
			s = e.map((e) => o[e]), c = e.map((e) => a[e]);
		}
		return {
			labels: s,
			datasets: [{
				label: "Frequency",
				data: c,
				backgroundColor: n,
				borderColor: r,
				borderWidth: 1,
				barPercentage: 1,
				categoryPercentage: .9
			}]
		};
	}
	if (Array.isArray(e)) {
		let i = e.filter((e) => typeof e == "number" && !isNaN(e));
		if (i.length === 0) return console.warn("No valid numeric data for histogram"), {
			labels: [],
			datasets: [{
				label: "Frequency",
				data: [],
				backgroundColor: n,
				borderColor: r,
				borderWidth: 1
			}]
		};
		let { bins: a, counts: o } = M_(i), s = a, c = o;
		if (!t.showEmptyBins) {
			let e = o.map((e, t) => ({
				count: e,
				index: t
			})).filter((e) => e.count > 0).map((e) => e.index);
			s = e.map((e) => a[e]), c = e.map((e) => o[e]);
		}
		return {
			labels: s,
			datasets: [{
				label: "Frequency",
				data: c,
				backgroundColor: n,
				borderColor: r,
				borderWidth: 1,
				barPercentage: 1,
				categoryPercentage: .9
			}]
		};
	}
	return console.warn("Unrecognized data format for histogram", e), {
		labels: [],
		datasets: [{
			label: "Frequency",
			data: [],
			backgroundColor: n,
			borderColor: r,
			borderWidth: 1
		}]
	};
}, j_ = (e, t = { showEmptyBins: !1 }) => {
	let n = O_.date.background, r = O_.date.border, i = O_.date.primary, a = "rgb(28, 27, 27)";
	if (!e) return console.warn("Date distribution data is null or undefined"), {
		labels: [],
		datasets: [{
			label: "Frequency",
			data: [],
			backgroundColor: n,
			borderColor: r,
			borderWidth: 2,
			fill: !0
		}]
	};
	if (e && typeof e == "object" && !Array.isArray(e) && ("bins" in e && "counts" in e || "labels" in e && "counts" in e)) {
		let o = "bins" in e ? e.bins : e.labels, { counts: s } = e;
		if (!Array.isArray(o) || !Array.isArray(s) || o.length === 0 || s.length === 0) return console.warn("Invalid date histogram data structure", e), {
			labels: [],
			datasets: [{
				label: "Frequency",
				data: [],
				backgroundColor: n,
				borderColor: r,
				borderWidth: 2,
				fill: !0
			}]
		};
		let c = o, l = s;
		if (!t.showEmptyBins) {
			let e = s.map((e, t) => ({
				count: e,
				index: t
			})).filter((e) => e.count > 0).map((e) => e.index);
			c = e.map((e) => o[e]), l = e.map((e) => s[e]);
		}
		return {
			labels: c,
			datasets: [{
				label: "Frequency",
				data: l,
				backgroundColor: n,
				borderColor: r,
				borderWidth: 2,
				fill: !0,
				tension: .3,
				pointBackgroundColor: i,
				pointBorderColor: a,
				pointBorderWidth: 1,
				pointRadius: 3,
				pointHoverRadius: 5
			}]
		};
	}
	if (Array.isArray(e)) {
		let o = e.map((e) => x_(e)).filter(Boolean);
		if (o.length === 0) return console.warn("No valid date data for histogram"), {
			labels: [],
			datasets: [{
				label: "Frequency",
				data: [],
				backgroundColor: n,
				borderColor: r,
				borderWidth: 2,
				fill: !0
			}]
		};
		o.sort((e, t) => e.getTime() - t.getTime());
		let s = o[0], c = o[o.length - 1], l = (c.getTime() - s.getTime()) / (1e3 * 60 * 60 * 24), u, d;
		l <= 1 ? (u = 1e3 * 60 * 60, d = (e) => e.toLocaleTimeString([], {
			hour: "2-digit",
			minute: "2-digit"
		})) : l <= 31 ? (u = 1e3 * 60 * 60 * 24, d = (e) => e.toLocaleDateString([], {
			month: "short",
			day: "numeric"
		})) : l <= 365 ? (u = 1e3 * 60 * 60 * 24 * 30, d = (e) => e.toLocaleDateString([], {
			month: "short",
			year: "numeric"
		})) : (u = 1e3 * 60 * 60 * 24 * 365, d = (e) => e.getFullYear().toString());
		let f = [], p = [], m = new Date(s), h = new Date(m.getTime() + u);
		for (; m <= c;) {
			let e = o.filter((e) => e >= m && e < h).length;
			f.push(d(m)), p.push(e), m = new Date(m.getTime() + u), h = new Date(m.getTime() + u);
		}
		let g = f, _ = p;
		if (!t.showEmptyBins) {
			let e = p.map((e, t) => ({
				count: e,
				index: t
			})).filter((e) => e.count > 0).map((e) => e.index);
			g = e.map((e) => f[e]), _ = e.map((e) => p[e]);
		}
		return {
			labels: g,
			datasets: [{
				label: "Frequency",
				data: _,
				backgroundColor: n,
				borderColor: r,
				borderWidth: 2,
				fill: !0,
				tension: .3,
				pointBackgroundColor: i,
				pointBorderColor: a,
				pointBorderWidth: 1,
				pointRadius: 3,
				pointHoverRadius: 5
			}]
		};
	}
	return console.warn("Unrecognized data format for date histogram", e), {
		labels: [],
		datasets: [{
			label: "Frequency",
			data: [],
			backgroundColor: n,
			borderColor: r,
			borderWidth: 2,
			fill: !0
		}]
	};
}, M_ = (e, t = 10) => {
	let n = e.filter((e) => typeof e == "number" && !isNaN(e));
	if (n.length === 0) return {
		bins: [],
		counts: []
	};
	let r = Math.min(...n), i = Math.max(...n);
	if (r === i) return {
		bins: [r.toFixed(2)],
		counts: [n.length]
	};
	let a = (i - r) / t, o = Array.from({ length: t }, (e, t) => r + t * a), s = Array(t).fill(0);
	return n.forEach((e) => {
		let n = Math.floor((e - r) / a);
		n === t && (n = t - 1), s[n]++;
	}), {
		bins: o.map((e, n) => {
			let r = n < t - 1 ? o[n + 1] : i;
			return `${e.toFixed(1)} - ${r.toFixed(1)}`;
		}),
		counts: s
	};
}, N_ = (e, t = "bar", n = !1) => {
	let r = w_("--color-info-dark"), i = w_("--color-info-light"), a = w_("--color-muted-dark"), o = {
		responsive: !0,
		maintainAspectRatio: !1,
		backgroundColor: w_("--color-background-light"),
		layout: { padding: {
			top: 4,
			right: 4,
			bottom: 16,
			left: 4
		} },
		plugins: {
			legend: { display: !1 },
			title: {
				display: !0,
				text: e,
				color: w_("--color-text"),
				font: {
					size: 12,
					weight: "bold"
				},
				padding: {
					top: 0,
					bottom: 4
				}
			}
		},
		scales: {
			x: {
				grid: {
					display: !1,
					drawBorder: !1
				},
				border: { display: !1 },
				ticks: {
					maxRotation: 45,
					minRotation: 45,
					autoSkip: !0,
					maxTicksLimit: 12,
					color: i,
					padding: 0,
					font: { size: 9 },
					callback: function(e) {
						return e.toString();
					}
				}
			},
			y: {
				border: { display: !1 },
				position: "left",
				grid: {
					color: a,
					lineWidth: .5,
					drawBorder: !1
				},
				ticks: {
					color: r,
					padding: 2,
					font: { size: 9 },
					count: 5,
					maxTicksLimit: 5,
					callback: function(e) {
						return e >= 1e3 ? (e / 1e3).toFixed(1) + "k" : e;
					}
				}
			}
		}
	};
	return n ? {
		...o,
		indexAxis: "y",
		plugins: {
			...o.plugins,
			tooltip: { callbacks: { label: (e) => {
				let t = e.raw, n = (t / e.dataset.data.reduce((e, t) => e + t, 0) * 100).toFixed(1);
				return `${t.toLocaleString()} (${n}%)`;
			} } }
		},
		scales: {
			x: {
				grid: {
					display: !0,
					color: a,
					lineWidth: .5
				},
				ticks: {
					color: i,
					font: { size: 9 },
					callback: (e) => e.toLocaleString()
				}
			},
			y: {
				grid: { display: !1 },
				ticks: {
					color: i,
					font: { size: 10 }
				}
			}
		},
		layout: { padding: {
			left: 0,
			right: 16,
			top: 8,
			bottom: 8
		} }
	} : t === "line" ? {
		...o,
		elements: {
			line: {
				tension: .2,
				borderWidth: 2,
				fill: !0
			},
			point: {
				radius: 0,
				hitRadius: 8,
				hoverRadius: 4
			}
		}
	} : o;
};
//#endregion
//#region src/components/panel/StatisticsChartCard.tsx
zm.register(Tg, kg, dh, $m, th, eg, bg, Zh, Hh);
function P_(e) {
	return typeof e == "number" && Number.isFinite(e);
}
function F_(e, t = 2) {
	return P_(e) ? e.toFixed(t) : "Not available";
}
function I_(e) {
	return P_(e) ? Math.round(e).toLocaleString() : "0";
}
function L_(e) {
	return !e || typeof e != "object" ? "unknown" : e.type === "numeric" || e.type === "categorical" || e.type === "date" ? e.type : e.histogram || P_(e.mean) && P_(e.min) && P_(e.max) ? "numeric" : e.categories && Object.keys(e.categories).length > 0 ? "categorical" : e.distribution || e.minDate && e.maxDate || e.min && e.max && !P_(e.mean) ? "date" : "unknown";
}
function R_(e) {
	switch (e) {
		case "numeric": return "border-datatype-numeric";
		case "date": return "border-datatype-date";
		case "categorical": return "border-datatype-categorical";
		default: return "border-slate-200";
	}
}
function z_(e) {
	switch (e) {
		case "numeric": return "text-datatype-numeric";
		case "date": return "text-datatype-date";
		case "categorical": return "text-datatype-categorical";
		default: return "text-slate-600";
	}
}
function B_(e, t, n) {
	try {
		switch (t) {
			case "numeric": return e.histogram ? A_(e.histogram, { showEmptyBins: n }) : e.data ? A_(e.data, { showEmptyBins: n }) : null;
			case "date": return e.distribution ? j_(e.distribution, { showEmptyBins: n }) : null;
			case "categorical": return e.categories ? k_(e.categories) : null;
			default: return null;
		}
	} catch {
		return null;
	}
}
function V_(e, t, n) {
	return t === "date" && e.distribution ? N_(`Time Series: ${n}`, "line") : t === "categorical" ? N_(`Distribution: ${n}`, "bar", !0) : N_(`Histogram: ${n}`);
}
function H_(e, t) {
	let n = z_(t);
	if (t === "numeric") return /* @__PURE__ */ v("div", {
		className: "grid grid-cols-2 gap-2 text-xs text-text",
		children: [
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Mean:"
				}),
				" ",
				F_(e.mean)
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Median:"
				}),
				" ",
				F_(e.median)
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Min:"
				}),
				" ",
				F_(e.min)
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Max:"
				}),
				" ",
				F_(e.max)
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Range:"
				}),
				" ",
				F_(e.range)
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Std Dev:"
				}),
				" ",
				F_(e.stddev)
			] })
		]
	});
	if (t === "date") return /* @__PURE__ */ v("div", {
		className: "grid grid-cols-1 gap-2 text-xs text-text",
		children: [
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Earliest Date:"
				}),
				" ",
				e.minDate || e.min ? S_(new Date(e.minDate || e.min), "medium") : "Not available"
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Latest Date:"
				}),
				" ",
				e.maxDate || e.max ? S_(new Date(e.maxDate || e.max), "medium") : "Not available"
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Date Range:"
				}),
				" ",
				(e.minDate || e.min) && (e.maxDate || e.max) ? `${S_(new Date(e.minDate || e.min), "short")} to ${S_(new Date(e.maxDate || e.max), "short")}` : "Not available"
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Most Common Period:"
				}),
				" ",
				e.mostCommonPeriod || "Not available"
			] }),
			/* @__PURE__ */ v("p", { children: [
				/* @__PURE__ */ _("span", {
					className: `font-medium ${n}`,
					children: "Total Range (days):"
				}),
				" ",
				e.timeSpanDays || "Not available"
			] })
		]
	});
	let r = e.categories && typeof e.categories == "object" ? Object.entries(e.categories) : [], i = r.reduce((e, [, t]) => e + (P_(t) ? t : 0), 0);
	return /* @__PURE__ */ v("div", {
		className: "flex flex-col h-full",
		children: [/* @__PURE__ */ _("p", {
			className: `mb-1 text-xs font-medium ${n}`,
			children: "Top Categories:"
		}), /* @__PURE__ */ v("table", {
			className: "min-w-full border border-border-dark bg-background text-xs text-text",
			children: [/* @__PURE__ */ _("thead", {
				className: "border-border-dark bg-background-light text-text-dark",
				children: /* @__PURE__ */ v("tr", { children: [
					/* @__PURE__ */ _("th", {
						className: "px-3 py-1 text-left text-xs font-medium",
						children: "Value"
					}),
					/* @__PURE__ */ _("th", {
						className: "px-3 py-1 text-left text-xs font-medium",
						children: "Count"
					}),
					/* @__PURE__ */ _("th", {
						className: "px-3 py-1 text-left text-xs font-medium",
						children: "%"
					})
				] })
			}), /* @__PURE__ */ _("tbody", {
				className: "border-border-dark bg-background text-text",
				children: r.sort(([, e], [, t]) => Number(t) - Number(e)).slice(0, 10).map(([e, t]) => {
					let n = Number(t), r = i > 0 ? n / i * 100 : 0;
					return /* @__PURE__ */ v("tr", {
						className: "border-b",
						children: [
							/* @__PURE__ */ _("td", {
								className: "px-3 py-1 whitespace-nowrap text-xs",
								children: e || "(empty)"
							}),
							/* @__PURE__ */ _("td", {
								className: "px-3 py-1 whitespace-nowrap text-xs",
								children: I_(n)
							}),
							/* @__PURE__ */ v("td", {
								className: "px-3 py-1 whitespace-nowrap text-xs",
								children: [r.toFixed(1), "%"]
							})
						]
					}, e);
				})
			})]
		})]
	});
}
function U_({ stats: e, columnName: t, tableName: n, testId: r }) {
	let [i, a] = h(!1), [o, s] = h(!1), c = f(() => L_(e), [e]), l = c === "date" ? "line" : "bar", d = f(() => B_(e, c, i), [
		i,
		e,
		c
	]), p = f(() => V_(e, c, t), [
		t,
		e,
		c
	]);
	u(() => {
		s(!1);
		let e = window.setTimeout(() => {
			s(!0);
		}, 120);
		return () => {
			window.clearTimeout(e);
		};
	}, [
		t,
		i,
		e,
		c
	]);
	let m = !!(e?.metadata?.isFiltered ?? e?.metadata?.appliedFilters);
	return /* @__PURE__ */ v("div", {
		className: "flex h-full flex-col",
		"data-testid": r,
		children: [
			/* @__PURE__ */ v("div", {
				className: `mb-2 rounded-lg border bg-background-light p-1 ${R_(c)}`,
				children: [(e?.histogram || e?.data || e?.distribution) && /* @__PURE__ */ _("div", {
					className: "mb-0.5 flex justify-end bg-background-light text-xs text-text-light",
					children: /* @__PURE__ */ v("label", {
						className: "inline-flex cursor-pointer items-center",
						children: [/* @__PURE__ */ _("input", {
							type: "checkbox",
							className: "show-empty-bins-checkbox",
							checked: i,
							onChange: () => a((e) => !e)
						}), /* @__PURE__ */ _("span", {
							className: "ml-1",
							children: "Show empty bins"
						})]
					})
				}), /* @__PURE__ */ _("div", {
					className: "relative h-56 w-full bg-background-light",
					children: d ? /* @__PURE__ */ _("div", {
						className: "h-full transition-opacity duration-300 ease-in-out",
						style: { opacity: +!!o },
						children: o && l === "line" ? /* @__PURE__ */ _(y_, {
							data: d,
							options: p
						}, `${t}-line-${i ? "show" : "hide"}`) : o ? /* @__PURE__ */ _(b_, {
							data: d,
							options: p
						}, `${t}-bar-${i ? "show" : "hide"}`) : null
					}) : /* @__PURE__ */ _("div", {
						className: "flex h-full items-center justify-center text-gray-400",
						children: /* @__PURE__ */ v("div", {
							className: "text-center",
							children: [/* @__PURE__ */ _("p", { children: "No chart data available" }), /* @__PURE__ */ _("p", {
								className: "mt-1 text-xs opacity-70",
								children: c === "numeric" ? "No numeric distribution data" : c === "date" ? "No date distribution data" : "No category data"
							})]
						})
					})
				})]
			}),
			/* @__PURE__ */ _("div", {
				className: `mb-4 rounded-md bg-background-light p-2 text-xs text-text ${m ? "border-l-4" : ""}`,
				style: { borderLeftColor: m ? "var(--color-warning-light)" : void 0 },
				children: /* @__PURE__ */ v("p", { children: [
					e?.metadata?.totalRows ? /* @__PURE__ */ v("span", {
						className: "block",
						children: [
							/* @__PURE__ */ _("span", {
								className: "font-medium",
								children: "Row count:"
							}),
							" ",
							I_(e.metadata.totalRows),
							" records",
							P_(e?.metadata?.samplePercentage) && e.metadata.samplePercentage < 100 ? /* @__PURE__ */ v("span", {
								className: "ml-1",
								children: [
									"(",
									e.metadata.samplePercentage,
									"%)"
								]
							}) : null
						]
					}) : null,
					m ? /* @__PURE__ */ v("span", {
						className: "mt-1 block flex items-center font-medium text-warning-dark",
						children: [/* @__PURE__ */ _(Lo, { className: "mr-1 inline h-3 w-3" }), "Filtered Data"]
					}) : null,
					/* @__PURE__ */ v("span", {
						className: "mt-1 block",
						children: [
							/* @__PURE__ */ _("span", {
								className: "font-medium",
								children: "Column:"
							}),
							" ",
							t
						]
					}),
					n ? /* @__PURE__ */ v("span", {
						className: "block",
						children: [
							/* @__PURE__ */ _("span", {
								className: "font-medium",
								children: "Table:"
							}),
							" ",
							n
						]
					}) : null
				] })
			}),
			/* @__PURE__ */ _("div", {
				className: "flex-1",
				children: H_(e, c)
			})
		]
	});
}
//#endregion
//#region src/components/panel/AnalysisStatistics.tsx
function W_(e) {
	return !!(e?.error || e?.statusCode === 404 || e?.isEmpty === !0 || e?.noDataWithFilters === !0 || typeof e == "object" && "message" in e && "status" in e || !e?.type && e?.metadata?.isFiltered && e?.metadata?.totalRows === 0);
}
var G_ = ({ stats: e, isLoading: t, columnName: n, tableName: r }) => {
	let i = () => /* @__PURE__ */ v("div", {
		className: "flex flex-col items-center justify-center py-12",
		role: "status",
		"aria-live": "polite",
		"aria-busy": "true",
		"data-testid": "statistics-loading-state",
		children: [/* @__PURE__ */ _(Ss, {
			width: "96px",
			height: "48px",
			message: `Fetching ${n}...`,
			className: "mb-4"
		}), /* @__PURE__ */ _("h3", {
			className: "text-base font-small text-gray-300",
			children: "Computing Statistics"
		})]
	});
	if (t) return i();
	if (!e) return /* @__PURE__ */ _("div", {
		className: "p-4 text-center",
		children: /* @__PURE__ */ v("div", {
			className: "bg-amber-50 border border-amber-100 rounded-md p-4 flex flex-col items-center",
			children: [
				/* @__PURE__ */ _(Lo, { className: "h-6 w-6 text-amber-500 mb-2" }),
				/* @__PURE__ */ _("h3", {
					className: "text-base font-medium text-gray-700",
					children: "No Data Available"
				}),
				/* @__PURE__ */ _("p", {
					className: "text-sm text-gray-600 mt-1",
					children: "Statistics could not be loaded for this column."
				}),
				/* @__PURE__ */ _("p", {
					className: "text-xs text-gray-500 mt-3",
					children: "Try again later or select a different column."
				})
			]
		})
	});
	if (W_(e)) {
		let t = e.error?.message || e.message || "The current filter returns no data for this column.";
		return /* @__PURE__ */ _("div", {
			className: "p-4 text-center",
			children: /* @__PURE__ */ v("div", {
				className: "bg-amber-50 border border-amber-100 rounded-md p-4 flex flex-col items-center",
				children: [
					/* @__PURE__ */ _(Lo, { className: "h-6 w-6 text-amber-500 mb-2" }),
					/* @__PURE__ */ _("h3", {
						className: "text-base font-medium text-gray-700",
						children: "No Data Found"
					}),
					/* @__PURE__ */ _("p", {
						className: "text-sm text-gray-600 mt-1",
						children: e.noDataWithFilters ? "The current filter returns no data for this column." : t
					}),
					/* @__PURE__ */ _("p", {
						className: "text-xs text-gray-500 mt-3",
						children: "Try adjusting or removing filters to view statistics."
					})
				]
			})
		});
	}
	return L_(e) === "unknown" ? /* @__PURE__ */ _("div", {
		className: "p-4 text-center text-gray-500",
		children: "Invalid statistics format. Expected type to be numeric, categorical, or date."
	}) : /* @__PURE__ */ _("div", {
		className: "flex flex-col h-full",
		children: /* @__PURE__ */ _(U_, {
			stats: e,
			columnName: n,
			tableName: r
		})
	});
}, K_ = 2, q_ = 5e3, J_ = 1e4, Y_ = new Set([
	"version",
	"source",
	"select",
	"joins",
	"filters",
	"groupBy",
	"orderBy",
	"limit",
	"generatedSql"
]), X_ = new Set([
	"type",
	"left",
	"right"
]), Z_ = new Set([
	"ref",
	"operator",
	"value"
]), Q_ = new Set(["ref", "direction"]), $_ = new Set([
	"schema",
	"table",
	"column"
]), ev = {
	sqlite: {
		dialect: "sqlite",
		identifierQuote: "\"",
		parameterStyle: "qmark",
		supportsLimit: !0,
		supportsOffset: !0,
		supportsContains: !0,
		supportsBooleanParameters: !1,
		supportsDateFilters: !0,
		supportsExplain: !0,
		supportsDryRun: !1,
		supportsLeftJoin: !0,
		identifierCasing: "preserve"
	},
	postgresql: {
		dialect: "postgresql",
		identifierQuote: "\"",
		parameterStyle: "numbered",
		supportsLimit: !0,
		supportsOffset: !0,
		supportsContains: !0,
		supportsBooleanParameters: !0,
		supportsDateFilters: !0,
		supportsExplain: !0,
		supportsDryRun: !1,
		supportsLeftJoin: !0,
		identifierCasing: "preserve"
	},
	snowflake: {
		dialect: "snowflake",
		identifierQuote: "\"",
		parameterStyle: "qmark",
		supportsLimit: !0,
		supportsOffset: !0,
		supportsContains: !0,
		supportsBooleanParameters: !0,
		supportsDateFilters: !0,
		supportsExplain: !0,
		supportsDryRun: !1,
		supportsLeftJoin: !0,
		identifierCasing: "upper"
	},
	bigquery: {
		dialect: "bigquery",
		identifierQuote: "`",
		parameterStyle: "named",
		supportsLimit: !0,
		supportsOffset: !0,
		supportsContains: !0,
		supportsBooleanParameters: !0,
		supportsDateFilters: !0,
		supportsExplain: !1,
		supportsDryRun: !0,
		supportsLeftJoin: !1,
		identifierCasing: "preserve"
	}
}, tv = {
	schema: "analytics",
	name: "orders",
	rowCountEstimate: 25e3,
	columns: [
		{
			name: "order_id",
			type: "number",
			indexed: !0
		},
		{
			name: "customer_id",
			type: "number",
			indexed: !0
		},
		{
			name: "status",
			type: "string",
			indexed: !0
		},
		{
			name: "total_amount",
			type: "number",
			indexed: !1
		},
		{
			name: "created_at",
			type: "date",
			indexed: !0
		}
	]
}, nv = {
	schema: "analytics",
	name: "events",
	rowCountEstimate: 75e3,
	columns: [
		{
			name: "event_id",
			type: "number",
			indexed: !1
		},
		{
			name: "order_id",
			type: "number",
			indexed: !1
		},
		{
			name: "event_name",
			type: "string",
			indexed: !1
		},
		{
			name: "payload",
			type: "string",
			indexed: !1,
			nullable: !0
		}
	]
}, rv = {
	schema: "analytics",
	name: "customers",
	rowCountEstimate: 8e3,
	columns: [
		{
			name: "customer_id",
			type: "number",
			indexed: !0
		},
		{
			name: "account_name",
			type: "string",
			indexed: !0
		},
		{
			name: "region",
			type: "string",
			indexed: !1
		}
	]
}, iv = {
	id: "orders.customer_id->customers.customer_id",
	type: "inner",
	left: {
		schema: "analytics",
		table: "orders",
		column: "customer_id"
	},
	right: {
		schema: "analytics",
		table: "customers",
		column: "customer_id"
	}
}, av = {
	id: "query-builder-fixture-v1",
	tables: [
		tv,
		nv,
		rv,
		{
			schema: "finance",
			name: "invoices",
			rowCountEstimate: 3e3,
			columns: [{
				name: "invoice_id",
				type: "number",
				indexed: !0
			}, {
				name: "order_id",
				type: "number",
				indexed: !0
			}]
		}
	],
	approvedJoins: [iv]
}, ov = [
	{
		schema: "analytics",
		table: "orders",
		indexes: [
			{
				name: "idx_orders_status",
				columns: ["status"]
			},
			{
				name: "idx_orders_created_at",
				columns: ["created_at"]
			},
			{
				name: "idx_orders_customer_id",
				columns: ["customer_id"]
			}
		]
	},
	{
		schema: "analytics",
		table: "events",
		indexes: []
	},
	{
		schema: "analytics",
		table: "customers",
		indexes: [{
			name: "idx_customers_customer_id",
			columns: ["customer_id"],
			unique: !0
		}]
	}
], sv = [
	{
		schema: "analytics",
		table: "orders:indexed",
		accessPath: "indexed-lookup",
		scannedRows: 420,
		returnedRows: 100,
		label: "Fixture trace: indexed status predicate"
	},
	{
		schema: "analytics",
		table: "orders:scan",
		accessPath: "full-table-scan",
		scannedRows: 25e3,
		returnedRows: 100,
		label: "Fixture trace: unindexed order amount predicate"
	},
	{
		schema: "analytics",
		table: "events:scan",
		accessPath: "full-table-scan",
		scannedRows: 75e3,
		returnedRows: 100,
		label: "Fixture trace: unindexed event stream"
	}
];
iv.type, iv.left, iv.right;
var cv = {
	version: 1,
	source: {
		schema: "analytics",
		table: "orders"
	},
	select: [{
		schema: "analytics",
		table: "orders",
		column: "order_id"
	}, {
		schema: "finance",
		table: "invoices",
		column: "invoice_id"
	}],
	joins: [{
		type: "inner",
		left: {
			schema: "analytics",
			table: "orders",
			column: "order_id"
		},
		right: {
			schema: "finance",
			table: "invoices",
			column: "order_id"
		}
	}],
	limit: 100
};
function lv(e, t, n) {
	return {
		code: e,
		path: t,
		message: n
	};
}
function uv(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function dv(e, t) {
	return Object.prototype.hasOwnProperty.call(e, t);
}
function fv(e, t = "sqlite") {
	if (!/^[a-zA-Z_][a-zA-Z0-9_]*$/.test(e)) throw Error(`Unsafe identifier: ${e}`);
	let n = ev[t], r = n.identifierCasing === "upper" ? e.toUpperCase() : n.identifierCasing === "lower" ? e.toLowerCase() : e;
	return `${n.identifierQuote}${r}${n.identifierQuote}`;
}
function pv(e, t) {
	return `${e}.${t}`;
}
function mv(e) {
	return `${e.schema}.${e.table}.${e.column}`;
}
function hv(e, t) {
	return mv(e) === mv(t);
}
function gv(e, t, n) {
	return e.tables.find((e) => e.schema === t && e.name === n);
}
function _v(e, t) {
	return gv(e, t.schema, t.table)?.columns.find((e) => e.name === t.column);
}
function vv(e, t, n, r) {
	if (uv(e)) for (let i of Object.keys(e)) t.has(i) || r.push(lv("unsupported_node", `${n}.${i}`, `Unsupported Query Builder AST node: ${i}`));
}
function yv(e, t, n, r, i) {
	if (vv(e, $_, r, i), !uv(e)) {
		i.push(lv("invalid_ast", r, "Column reference must be an object."));
		return;
	}
	let a = typeof e.schema == "string" ? e.schema : "", o = typeof e.table == "string" ? e.table : "", s = typeof e.column == "string" ? e.column : "";
	if (!a || !t.tables.some((e) => e.schema === a)) {
		i.push(lv("unknown_schema", `${r}.schema`, `Unknown schema: ${a || "<missing>"}`));
		return;
	}
	if (a !== n && i.push(lv("cross_schema_reference", `${r}.schema`, "Query Builder v1 forbids cross-schema references.")), !gv(t, a, o)) {
		i.push(lv("unknown_table", `${r}.table`, `Unknown table: ${o || "<missing>"}`));
		return;
	}
	let c = _v(t, {
		schema: a,
		table: o,
		column: s
	});
	return c || i.push(lv("unknown_column", `${r}.column`, `Unknown column: ${s || "<missing>"}`)), c;
}
function bv(e, t, n, r) {
	if (!t || e.operator === "is_null") return;
	if (e.operator === "contains" && t.type !== "string" && r.push(lv("invalid_filter_operator", `${n}.operator`, "contains is only allowed for string columns.")), e.operator === "between") {
		if (!Array.isArray(e.value) || e.value.length !== 2) {
			r.push(lv("invalid_filter_value", `${n}.value`, "between requires a two-value tuple."));
			return;
		}
	} else if (e.value === void 0 || e.value === null || Array.isArray(e.value)) {
		r.push(lv("invalid_filter_value", `${n}.value`, "Filter operator requires a scalar value."));
		return;
	}
	let i = Array.isArray(e.value) ? e.value : [e.value];
	for (let e of i) t.type === "number" && typeof e != "number" && r.push(lv("invalid_filter_value", `${n}.value`, "Number columns require numeric filter values.")), t.type === "boolean" && typeof e != "boolean" && r.push(lv("invalid_filter_value", `${n}.value`, "Boolean columns require boolean filter values.")), (t.type === "string" || t.type === "date") && typeof e != "string" && r.push(lv("invalid_filter_value", `${n}.value`, "String and date columns require string filter values."));
}
function xv(e, t) {
	return e.approvedJoins.find((e) => e.type === t.type && hv(e.left, t.left) && hv(e.right, t.right));
}
function Sv(e) {
	let t = [];
	return e.trim().toLowerCase().startsWith("select ") || t.push(lv("unsafe_sql", "generatedSql.sql", "Only SELECT previews are allowed.")), (e.includes("--") || e.includes("/*") || e.includes("*/")) && t.push(lv("unsafe_sql", "generatedSql.sql", "SQL comments are not allowed.")), e.includes(";") && t.push(lv("unsafe_sql", "generatedSql.sql", "Multiple statements or statement separators are not allowed.")), /\b(insert|update|delete|drop|alter|create|pragma|attach|detach|vacuum|explain|union|with)\b/i.test(e) && t.push(lv("unsafe_sql", "generatedSql.sql", "Unsafe SQL clause is not allowed.")), t;
}
function Cv(e, t = "sqlite") {
	return `${fv(e.table, t)}.${fv(e.column, t)}`;
}
function wv(e, t) {
	let n = ev[t.dialect], r = t.parameters.length + 1, i = `p${r}`, a = typeof e == "boolean" && !n.supportsBooleanParameters ? +!!e : e;
	return t.parameters.push({
		name: i,
		ordinal: r,
		value: a
	}), n.parameterStyle === "numbered" ? `$${r}` : n.parameterStyle === "named" ? `@${i}` : "?";
}
function Tv(e, t) {
	let n = Cv(e.ref, t.dialect);
	switch (e.operator) {
		case "eq": return `${n} = ${wv(e.value, t)}`;
		case "neq": return `${n} <> ${wv(e.value, t)}`;
		case "contains": {
			let r = wv(e.value, t);
			return t.dialect === "bigquery" ? `${n} LIKE CONCAT('%', ${r}, '%')` : `${n} LIKE '%' || ${r} || '%'`;
		}
		case "gt": return `${n} > ${wv(e.value, t)}`;
		case "gte": return `${n} >= ${wv(e.value, t)}`;
		case "lt": return `${n} < ${wv(e.value, t)}`;
		case "lte": return `${n} <= ${wv(e.value, t)}`;
		case "between": {
			let [r, i] = e.value;
			return `${n} BETWEEN ${wv(r, t)} AND ${wv(i, t)}`;
		}
		case "is_null": return `${n} IS NULL`;
		default: return `${n} = ${wv(e.value, t)}`;
	}
}
function Ev(e, t) {
	let n = ev[t], r = [];
	return (e.joins ?? []).forEach((e, i) => {
		e.type === "left" && !n.supportsLeftJoin && r.push(lv("unsupported_dialect_feature", `joins.${i}.type`, `${t} Query Builder v1 compilation does not support left joins yet.`));
	}), (e.filters ?? []).forEach((e, i) => {
		e.operator === "contains" && !n.supportsContains && r.push(lv("unsupported_dialect_feature", `filters.${i}.operator`, `${t} Query Builder v1 compilation does not support contains filters.`)), _v(av, e.ref)?.type === "date" && !n.supportsDateFilters && r.push(lv("unsupported_dialect_feature", `filters.${i}.ref`, `${t} Query Builder v1 compilation does not support date filters.`));
	}), r;
}
function Dv(e, t = "sqlite") {
	let n = {
		dialect: t,
		parameters: []
	}, r = e.select.map((e) => `${Cv(e, t)} AS ${fv(`${e.table}_${e.column}`, t)}`).join(", "), i = (e.joins ?? []).map((e) => `${e.type.toUpperCase()} JOIN ${fv(e.right.schema, t)}.${fv(e.right.table, t)} ON ${Cv(e.left, t)} = ${Cv(e.right, t)}`).join(" "), a = (e.filters ?? []).map((e) => Tv(e, n)), o = (e.groupBy ?? []).map((e) => Cv(e, t)), s = (e.orderBy ?? []).map((e) => `${Cv(e.ref, t)} ${e.direction.toUpperCase()}`);
	return {
		sql: [
			`SELECT ${r}`,
			`FROM ${fv(e.source.schema, t)}.${fv(e.source.table, t)}`,
			i,
			a.length > 0 ? `WHERE ${a.join(" AND ")}` : "",
			o.length > 0 ? `GROUP BY ${o.join(", ")}` : "",
			s.length > 0 ? `ORDER BY ${s.join(", ")}` : "",
			typeof e.limit == "number" ? `LIMIT ${e.limit}` : ""
		].filter(Boolean).join(" "),
		parameters: n.parameters,
		unsupportedFeatures: Ev(e, t)
	};
}
function Ov(e, t = av, n = {}) {
	let r = n.dialect ?? "sqlite", i = kv({
		...e,
		generatedSql: void 0
	}, t);
	if (!i.valid) throw Error(`Cannot generate SQL for invalid Query Builder AST: ${i.issues.map((e) => e.code).join(", ")}`);
	let a = Dv(e, r);
	return {
		generator: "query-builder.v1",
		dialect: r,
		sql: a.sql,
		parameters: a.parameters,
		metadata: {
			dialect: r,
			capabilities: ev[r],
			parameterStyle: ev[r].parameterStyle,
			unsupportedFeatures: a.unsupportedFeatures
		}
	};
}
function kv(e, t = av) {
	let n = [];
	if (vv(e, Y_, "ast", n), !uv(e)) return {
		valid: !1,
		issues: [lv("invalid_ast", "ast", "Query Builder AST must be an object.")]
	};
	e.version !== 1 && n.push(lv("invalid_ast", "version", "Unsupported Query Builder AST version."));
	let r = uv(e.source) ? e.source : {}, i = typeof r.schema == "string" ? r.schema : "", a = typeof r.table == "string" ? r.table : "", o = gv(t, i, a);
	(!i || !t.tables.some((e) => e.schema === i)) && n.push(lv("unknown_schema", "source.schema", `Unknown source schema: ${i || "<missing>"}`)), o || n.push(lv("unknown_table", "source.table", `Unknown source table: ${a || "<missing>"}`));
	let s = Array.isArray(e.select) ? e.select : [];
	s.length === 0 && n.push(lv("invalid_ast", "select", "At least one selected column is required.")), s.forEach((e, r) => yv(e, t, i, `select.${r}`, n));
	let c = Array.isArray(e.joins) ? e.joins : [];
	c.length > K_ && n.push(lv("join_limit_exceeded", "joins", `At most ${K_} joins are allowed.`)), c.forEach((e, r) => {
		let a = `joins.${r}`;
		if (vv(e, X_, a, n), !uv(e)) {
			n.push(lv("invalid_ast", a, "Join must be an object."));
			return;
		}
		e.type !== "inner" && e.type !== "left" && n.push(lv("unsupported_join_type", `${a}.type`, "Only inner and left joins are allowed.")), yv(e.left, t, i, `${a}.left`, n), yv(e.right, t, i, `${a}.right`, n), uv(e.left) && uv(e.right) && !xv(t, e) && n.push(lv("unknown_join", a, "Join path is not approved by the fixture catalog."));
	});
	let l = Array.isArray(e.filters) ? e.filters : [];
	l.forEach((e, r) => {
		let a = `filters.${r}`;
		if (vv(e, Z_, a, n), !uv(e)) {
			n.push(lv("invalid_ast", a, "Filter must be an object."));
			return;
		}
		let o = yv(e.ref, t, i, `${a}.ref`, n);
		[
			"eq",
			"neq",
			"contains",
			"gt",
			"gte",
			"lt",
			"lte",
			"between",
			"is_null"
		].includes(String(e.operator)) ? bv(e, o, a, n) : n.push(lv("invalid_filter_operator", `${a}.operator`, "Unsupported filter operator."));
	}), (Array.isArray(e.groupBy) ? e.groupBy : []).forEach((e, r) => yv(e, t, i, `groupBy.${r}`, n)), (Array.isArray(e.orderBy) ? e.orderBy : []).forEach((e, r) => {
		let a = `orderBy.${r}`;
		if (vv(e, Q_, a, n), !uv(e)) {
			n.push(lv("invalid_order_by", a, "Sort entry must be an object."));
			return;
		}
		yv(e.ref, t, i, `${a}.ref`, n), e.direction !== "asc" && e.direction !== "desc" && n.push(lv("invalid_order_by", `${a}.direction`, "Sort direction must be asc or desc."));
	}), dv(e, "limit") && (typeof e.limit != "number" || !Number.isInteger(e.limit) || e.limit < 1 || e.limit > q_) && n.push(lv("invalid_limit", "limit", `Limit must be an integer between 1 and ${q_}.`));
	let u = l.some((e) => !uv(e) || !uv(e.ref) ? !1 : !!_v(t, e.ref)?.indexed);
	if (o && o.rowCountEstimate > J_ && !u && typeof e.limit != "number" && n.push(lv("unbounded_scan", "limit", "Large fixture scans need a limit or indexed filter.")), uv(e.generatedSql)) {
		let t = typeof e.generatedSql.sql == "string" ? e.generatedSql.sql : "", r = typeof e.generatedSql.dialect == "string" && e.generatedSql.dialect in ev ? e.generatedSql.dialect : "sqlite";
		if (n.push(...Sv(t)), n.length === 0) {
			let i = Dv(e, r);
			n.push(...i.unsupportedFeatures), n.length === 0 && t !== i.sql && n.push(lv("generated_sql_mismatch", "generatedSql.sql", "Generated SQL must match the validated AST exactly."));
			let a = Array.isArray(e.generatedSql.parameters) ? e.generatedSql.parameters : [];
			n.length === 0 && JSON.stringify(a.map((e) => uv(e) ? e.value : void 0)) !== JSON.stringify(i.parameters.map((e) => e.value)) && n.push(lv("generated_sql_mismatch", "generatedSql.parameters", "Generated SQL parameters must match the validated AST exactly."));
		}
	} else dv(e, "generatedSql") && e.generatedSql !== void 0 && n.push(lv("unsafe_sql", "generatedSql", "Generated SQL metadata must be an object."));
	return {
		valid: n.length === 0,
		issues: n
	};
}
function Av(e) {
	return JSON.parse(JSON.stringify(e));
}
function jv(e) {
	let t = Av(e);
	return delete t.generatedSql, t;
}
function Mv(e) {
	return `${e.table}.${e.column}`;
}
function Nv(e) {
	return e && e.length > 0 ? e.map(Mv).join(", ") : "None";
}
function Pv(e) {
	return e && e.length > 0 ? e.map((e) => `${e.type} ${Mv(e.left)} -> ${Mv(e.right)}`).join(", ") : "None";
}
function Fv(e) {
	return e && e.length > 0 ? e.map((e) => `${Mv(e.ref)} ${e.operator} ${JSON.stringify(e.value ?? null)}`).join(", ") : "None";
}
function Iv(e) {
	return e && e.length > 0 ? e.map((e) => `${Mv(e.ref)} ${e.direction}`).join(", ") : "None";
}
function Lv(e, t) {
	return e === t ? "unchanged" : e === "None" ? "added" : t === "None" ? "removed" : "changed";
}
function Rv(e, t, n, r) {
	return {
		field: e,
		label: t,
		before: n,
		after: r,
		status: Lv(n, r)
	};
}
function zv(e, t) {
	let n = e ? jv(e) : void 0, r = jv(t);
	return [
		Rv("source", "Source table", n ? pv(n.source.schema, n.source.table) : "None", pv(r.source.schema, r.source.table)),
		Rv("select", "Projected columns", Nv(n?.select), Nv(r.select)),
		Rv("joins", "Approved joins", Pv(n?.joins), Pv(r.joins)),
		Rv("filters", "Filters", Fv(n?.filters), Fv(r.filters)),
		Rv("groupBy", "Groups", Nv(n?.groupBy), Nv(r.groupBy)),
		Rv("orderBy", "Sorts", Iv(n?.orderBy), Iv(r.orderBy)),
		Rv("limit", "Limit", typeof n?.limit == "number" ? String(n.limit) : "None", typeof r.limit == "number" ? String(r.limit) : "None")
	];
}
function Bv(e, t, n, r, i, a, o = i === "telemetry-backed" ? "plan-telemetry" : i === "telemetry-unavailable" ? "unavailable" : "fixture-demo") {
	return {
		code: e,
		severity: t,
		label: n,
		message: r,
		evidence: i,
		provenance: o,
		relatedColumns: a
	};
}
function Vv(e) {
	return (e.filters ?? []).map((e) => e.ref.column);
}
function Hv(e) {
	return new Set((e ?? []).flatMap((e) => e.columns));
}
function Uv(e, t) {
	return t.find((t) => t.schema === e.source.schema && t.table === e.source.table);
}
function Wv(e, t) {
	let n = Vv(e).some((e) => t.has(e));
	return e.source.table === "orders" ? n ? "orders:indexed" : "orders:scan" : e.source.table === "events" ? "events:scan" : `${e.source.table}:unknown`;
}
function Gv(e, t, n) {
	let r = Wv(e, t);
	return n.find((t) => t.schema === e.source.schema && t.table === r);
}
function Kv(e) {
	return {
		runId: e.runId ?? null,
		provider: e.provider,
		status: "unavailable",
		source: "unavailable",
		collectedAt: e.collectedAt ?? (/* @__PURE__ */ new Date()).toISOString(),
		staleAt: null,
		estimatedRows: null,
		estimatedBytes: null,
		estimatedCost: null,
		accessPath: "unknown",
		indexUsage: [],
		warnings: [e.reason],
		rawPlanStored: !1,
		unavailableReason: e.reason
	};
}
function qv(e) {
	let t = e.dialect ?? "sqlite", n = ev[t];
	if (!n.supportsExplain && !n.supportsDryRun) return Kv({
		provider: t,
		reason: `${t} plan telemetry is not available in Query Builder v1.`,
		runId: e.runId,
		collectedAt: e.collectedAt
	});
	let r = e.indexes ?? [], i = Vv(e.ast), a = r.filter((e) => e.columns.some((e) => i.includes(e))), o = a.length > 0, s = gv(av, e.ast.source.schema, e.ast.source.table), c = o ? Math.max(1, Math.round((s?.rowCountEstimate ?? 1e3) * .02)) : s?.rowCountEstimate ?? null;
	return {
		runId: e.runId ?? null,
		provider: t,
		status: "available",
		source: e.source ?? (n.supportsExplain ? "explain" : "dry-run"),
		collectedAt: e.collectedAt ?? (/* @__PURE__ */ new Date()).toISOString(),
		staleAt: null,
		estimatedRows: c,
		estimatedBytes: c === null ? null : c * 128,
		estimatedCost: null,
		accessPath: o ? "indexed-lookup" : "full-table-scan",
		indexUsage: a.map((e) => ({
			indexName: e.name,
			columns: e.columns,
			used: !0
		})),
		warnings: o ? [] : ["no-index-used-for-selected-predicates"],
		rawPlanStored: !1,
		unavailableReason: null
	};
}
function Jv(e, t) {
	return !!(e.staleAt && Date.parse(e.staleAt) <= Date.parse(t));
}
function Yv(e, t, n, r) {
	let i = Vv(e);
	if (n.status !== "available") return [Bv("insufficient-evidence", "info", "Plan telemetry unavailable", `Plan telemetry is not available (${n.unavailableReason ?? "unknown reason"}); missing telemetry does not imply low risk.`, "telemetry-unavailable", i)];
	let a = [];
	Jv(n, r) && a.push(Bv("stale-plan-telemetry", "warning", "Stale plan telemetry", "Plan telemetry is older than the freshness window; treat performance guidance as advisory.", "telemetry-unavailable", i)), n.accessPath === "full-table-scan" && a.push(Bv("full-table-scan-warning", "warning", "Telemetry-backed full-table-scan warning", "Plan telemetry reports a full table scan for this AST.", "telemetry-backed", i));
	let o = n.indexUsage.some((e) => e.used);
	return !o && (n.estimatedRows ?? t?.rowCountEstimate ?? 0) > J_ && a.push(Bv("missing-index-performance-risk", "warning", "Telemetry-backed missing-index risk", "Plan telemetry did not report index usage for the selected predicates on a high-row-count table.", "telemetry-backed", i)), n.accessPath === "indexed-lookup" && o && a.push(Bv("selective-index-filter", "info", "Telemetry-backed indexed predicate", "Plan telemetry reports index usage for at least one selected predicate.", "telemetry-backed", n.indexUsage.flatMap((e) => e.columns))), a.length > 0 ? a : [Bv("insufficient-evidence", "info", "No Query Builder risk signals", "Plan telemetry was available but did not produce a risk or indexed-predicate signal.", "telemetry-backed", i)];
}
function Xv(e, t = {}) {
	let n = jv(e), r = kv(n).valid ? gv(av, n.source.schema, n.source.table) ?? null : null, i = t.indexFixtures ?? ov, a = t.traceFixtures ?? sv, o = r ? Uv(n, i) : void 0, s = !!(o && Array.isArray(o.indexes)), c = s ? o?.indexes ?? [] : null, l = Hv(c ?? []), u = r && s ? Gv(n, l, a) ?? null : null, d = t.planTelemetry ?? null, f = Vv(n), p = [];
	return d ? {
		table: r,
		indexes: c,
		trace: u,
		planTelemetry: d,
		signals: Yv(n, r, d, t.now ?? (/* @__PURE__ */ new Date()).toISOString())
	} : !r || !s || !u ? (p.push(Bv("insufficient-evidence", "info", "Insufficient fixture evidence", "Insufficient fixture evidence for index or trace warnings; no production optimizer claim is made.", "insufficient", f)), {
		table: r,
		indexes: c,
		trace: u,
		planTelemetry: d,
		signals: p
	}) : (c && c.length === 0 && r.rowCountEstimate > J_ && p.push(Bv("missing-index-performance-risk", "warning", "Estimated missing-index performance risk", "Estimated warning: this high-row-count fixture table has no index fixtures for the selected predicates.", "estimated", f)), u.accessPath === "full-table-scan" && p.push(Bv("full-table-scan-warning", "warning", "Fixture-backed full-table-scan warning", "Fixture-backed warning: the mocked performance trace reports a full table scan for this draft.", "fixture-backed", f)), u.accessPath === "indexed-lookup" && f.some((e) => l.has(e)) && p.push(Bv("selective-index-filter", "info", "Fixture-backed indexed predicate", "Fixture-backed signal: at least one selected predicate matches an index fixture.", "fixture-backed", f.filter((e) => l.has(e)))), {
		table: r,
		indexes: c,
		trace: u,
		planTelemetry: d,
		signals: p
	});
}
function Zv(e, t, n, r) {
	return `qbir_${r}_${e}_${t}_${n.join("_")}`.replace(/[^a-zA-Z0-9_]+/g, "_").toLowerCase();
}
function Qv(e, t, n) {
	return `idx_qb_${e}_${t}_${n.join("_")}`.replace(/[^a-zA-Z0-9_]+/g, "_").toLowerCase();
}
function $v(e) {
	if (e.dialect === "bigquery") return {
		ddlPreview: null,
		rollbackPreview: null
	};
	let t = Qv(e.schema, e.table, e.columns), n = `${fv(e.schema, e.dialect)}.${fv(e.table, e.dialect)}`, r = `${fv(e.schema, e.dialect)}.${fv(t, e.dialect)}`, i = e.columns.map((t) => fv(t, e.dialect)).join(", ");
	return e.dialect === "snowflake" ? {
		ddlPreview: `CREATE SEARCH OPTIMIZATION ON ${n} (${i})`,
		rollbackPreview: `DROP SEARCH OPTIMIZATION ON ${n}`
	} : {
		ddlPreview: `CREATE INDEX ${r} ON ${n} (${i})`,
		rollbackPreview: `DROP INDEX ${r}`
	};
}
function ey(e) {
	let t = e.evaluation.signals.find((e) => e.code === "missing-index-performance-risk");
	if (!t) return null;
	let n = Array.from(new Set(Vv(e.ast))).filter(Boolean);
	if (n.length === 0) return null;
	let r = e.dialect ?? e.evaluation.planTelemetry?.provider ?? "sqlite", i = $v({
		dialect: r,
		schema: e.ast.source.schema,
		table: e.ast.source.table,
		columns: n
	}), a = e.createdAt ?? (/* @__PURE__ */ new Date()).toISOString();
	return {
		id: Zv(e.ast.source.schema, e.ast.source.table, n, r),
		status: "suggested",
		dialect: r,
		schema: e.ast.source.schema,
		table: e.ast.source.table,
		columns: n,
		reason: t.message,
		evidenceSource: t.provenance === "plan-telemetry" ? "plan-telemetry" : "fixture-demo",
		ddlPreview: i.ddlPreview,
		rollbackPreview: i.rollbackPreview,
		createdAt: a,
		reviewedAt: null,
		appliedAt: null,
		reviewer: null,
		audit: [{
			at: a,
			actor: "query-builder",
			action: "suggested",
			note: t.label
		}]
	};
}
function ty(e) {
	let t = [];
	return e.trim().toLowerCase() || t.push(lv("invalid_ast", "prompt", "Prompt cannot be empty.")), /^\s*(select|with)\b/i.test(e) && t.push(lv("unsafe_sql", "prompt", "Prompt output must be an AST request, not SQL text.")), (e.includes("--") || e.includes("/*") || e.includes("*/")) && t.push(lv("unsafe_sql", "prompt", "SQL comments are not allowed in prompt draft input.")), e.includes(";") && t.push(lv("unsafe_sql", "prompt", "Multiple statements or statement separators are not allowed.")), /\b(insert|update|delete|drop|alter|create|pragma|attach|detach|vacuum|explain|union|with)\b/i.test(e) && t.push(lv("unsafe_sql", "prompt", "Unsafe SQL clause is not allowed in prompt draft input.")), /\b[a-z_][a-z0-9_]*\s*\(/i.test(e) && t.push(lv("unsupported_node", "prompt", "Function-style prompt output is not supported in Query Builder v1.")), t;
}
function ny(e) {
	let t = /\b(?:top|limit)\s+([1-9][0-9]{0,3})\b/i.exec(e);
	return t ? Math.min(Number(t[1]), q_) : 100;
}
function ry(e) {
	let t = e.toLowerCase();
	if (t.includes("finance") || t.includes("invoice")) return Av(cv);
	if (t.includes("event") || t.includes("unbounded")) return {
		version: 1,
		source: {
			schema: "analytics",
			table: "events"
		},
		select: [{
			schema: "analytics",
			table: "events",
			column: "event_id"
		}, {
			schema: "analytics",
			table: "events",
			column: "event_name"
		}]
	};
	let n = t.includes("refund") ? "refunded" : "paid", r = /\b(?:over|above|greater than|at least)\s+\$?([0-9]+)\b/i.exec(e), i = [{
		ref: {
			schema: "analytics",
			table: "orders",
			column: "status"
		},
		operator: "eq",
		value: n
	}];
	return r && i.push({
		ref: {
			schema: "analytics",
			table: "orders",
			column: "total_amount"
		},
		operator: "gte",
		value: Number(r[1])
	}), {
		version: 1,
		source: {
			schema: "analytics",
			table: "orders"
		},
		select: [
			{
				schema: "analytics",
				table: "orders",
				column: "order_id"
			},
			{
				schema: "analytics",
				table: "orders",
				column: "total_amount"
			},
			{
				schema: "analytics",
				table: "orders",
				column: "status"
			}
		],
		filters: i,
		orderBy: [{
			ref: {
				schema: "analytics",
				table: "orders",
				column: "created_at"
			},
			direction: "desc"
		}],
		limit: ny(e)
	};
}
function iy(e, t, n, r) {
	return {
		status: "rejected",
		reason: e,
		issues: t,
		diff: r ? zv(n, r) : []
	};
}
function ay(e, t, n) {
	if (dv(t, "generatedSql") && t.generatedSql !== void 0) {
		let e = kv(t);
		if (!e.valid) return iy("Prompt draft included unsafe generated SQL metadata.", e.issues, n, t);
	}
	let r = jv(t), i = kv(r);
	if (!i.valid) return iy("Prompt draft failed Query Builder AST validation.", i.issues, n, r);
	let a = Ov(r), o = {
		...r,
		generatedSql: a
	}, s = kv(o);
	return s.valid ? {
		status: "draft",
		draft: {
			prompt: e,
			ast: o,
			generatedSql: a,
			validation: s,
			diff: zv(n, o),
			summary: `${r.source.schema}.${r.source.table} with ${r.select.length} projected columns`
		},
		issues: []
	} : iy("Prompt draft generated unsafe SQL preview metadata.", s.issues, n, o);
}
function oy(e) {
	let t = ty(e.prompt);
	return t.length > 0 ? iy("Prompt text did not pass the Query Builder safety gate.", t, e.currentAst) : ay(e.prompt, ry(e.prompt), e.currentAst);
}
function sy(e) {
	if (e.status !== "draft") throw Error("Cannot accept a rejected Query Builder prompt draft.");
	return e.draft.ast;
}
//#endregion
//#region src/contracts/index.ts
var cy = {
	STATS_SAMPLE_V1: "stats.sample.v1",
	STATS_COMPUTE_SUNBURST_V1: "stats.compute-sunburst.v1",
	STATS_COMPUTE_STATS_V1: "stats.compute-stats.v1",
	STATS_COMPUTE_MISSING_DATA_V1: "stats.compute-missing-data.v1",
	STATS_ANOMALY_DETECTION_V1: "stats.anomaly-detection.v1",
	PRIVACY_REIDENTIFICATION_V1: "privacy.reidentification.v1",
	PRIVACY_DIFFERENTIAL_PRIVACY_V1: "privacy.differential-privacy.v1",
	PRIVACY_QUASI_IDENTIFIER_V1: "privacy.quasi-identifier.v1",
	PRIVACY_DATA_MASKING_V1: "privacy.data-masking.v1",
	PRIVACY_PHI_DETECTION_V1: "privacy.phi-detection.v1"
}, ly = [
	"null_rate_pct",
	"distinct_count_delta_pct",
	"value_range"
], uy = [
	{
		checkType: "missing_data",
		validationKey: "completeness",
		processorId: cy.STATS_COMPUTE_MISSING_DATA_V1,
		costHint: "expensive",
		label: "Missing Data Analysis",
		standardDimensions: ["completeness"],
		canRunFrom: ["table", "column"],
		supportsColumnName: !0,
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}, {
			runScopeType: "column",
			targetScopeType: "column",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "data_quality",
		validationKey: "dataQuality",
		costHint: "expensive",
		label: "Data Quality",
		standardDimensions: ["accuracy", "completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "null_check",
		validationKey: "nullCheck",
		costHint: "fast",
		label: "Null Check",
		standardDimensions: ["accuracy", "completeness"],
		canRunFrom: ["table", "column"],
		supportsColumnName: !0,
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}, {
			runScopeType: "column",
			targetScopeType: "column",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "type_inference_table",
		validationKey: "typeInferenceTable",
		costHint: "slow",
		label: "Table Type Inference",
		standardDimensions: ["validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "type_inference_column",
		validationKey: "typeInferenceColumn",
		costHint: "fast",
		label: "Column Type Inference",
		standardDimensions: ["validity"],
		canRunFrom: ["column"],
		supportsColumnName: !0,
		scopeCombinations: [{
			runScopeType: "column",
			targetScopeType: "column",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "pattern",
		validationKey: "patterns",
		costHint: "slow",
		label: "Pattern Validation",
		standardDimensions: ["accuracy", "validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "constraint",
		validationKey: "constraints",
		costHint: "slow",
		label: "Constraint Validation",
		standardDimensions: [
			"accuracy",
			"validity",
			"uniqueness"
		],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "table_structure",
		validationKey: "tableStructure",
		costHint: "fast",
		label: "Table Structure",
		standardDimensions: ["validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "common_table_structure",
		validationKey: "tableStructure",
		costHint: "fast",
		label: "Common Table Structure",
		standardDimensions: ["validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "cross_table",
		validationKey: "referentialIntegrity",
		costHint: "expensive",
		label: "Cross Table Validation",
		standardDimensions: ["consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "time_sequence",
		validationKey: "timeSequence",
		costHint: "slow",
		label: "Time Sequence",
		standardDimensions: ["timeliness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "anomaly_detection",
		validationKey: "anomalyDetection",
		processorId: cy.STATS_ANOMALY_DETECTION_V1,
		costHint: "expensive",
		label: "Anomaly Detection",
		standardDimensions: ["accuracy", "consistency"],
		canRunFrom: ["table", "column"],
		supportsColumnName: !0,
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}, {
			runScopeType: "column",
			targetScopeType: "column",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "business_logic",
		validationKey: "businessLogic",
		costHint: "slow",
		label: "Business Logic",
		standardDimensions: ["accuracy", "consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "privacy",
		validationKey: "privacy",
		costHint: "expensive",
		label: "Privacy Analysis",
		standardDimensions: ["completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "phi_detection",
		validationKey: "phiDetection",
		processorId: cy.PRIVACY_PHI_DETECTION_V1,
		costHint: "expensive",
		label: "PHI Detection",
		standardDimensions: ["accuracy", "completeness"],
		canRunFrom: ["database", "table"],
		scopeCombinations: [{
			runScopeType: "database",
			targetScopeType: "database",
			findingScopeType: "column"
		}, {
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "quasi_identifier",
		validationKey: "quasiIdentifiers",
		processorId: cy.PRIVACY_QUASI_IDENTIFIER_V1,
		costHint: "expensive",
		label: "Quasi-Identifier Detection",
		standardDimensions: ["completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "reidentification_risk",
		validationKey: "reidentificationRisk",
		processorId: cy.PRIVACY_REIDENTIFICATION_V1,
		costHint: "expensive",
		label: "Re-identification Risk",
		standardDimensions: ["completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "row"
		}]
	},
	{
		checkType: "data_masking",
		validationKey: "dataMasking",
		processorId: cy.PRIVACY_DATA_MASKING_V1,
		costHint: "expensive",
		label: "Data Masking",
		standardDimensions: ["accuracy"],
		canRunFrom: ["table", "column"],
		supportsColumnName: !0,
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "column"
		}, {
			runScopeType: "column",
			targetScopeType: "column",
			findingScopeType: "column"
		}]
	},
	{
		checkType: "differential_privacy",
		validationKey: "differentialPrivacy",
		processorId: cy.PRIVACY_DIFFERENTIAL_PRIVACY_V1,
		costHint: "expensive",
		label: "Differential Privacy",
		standardDimensions: ["accuracy"],
		canRunFrom: ["table", "rowset"],
		supportsRowset: !0,
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}, {
			runScopeType: "rowset",
			targetScopeType: "rowset",
			findingScopeType: "rowset"
		}]
	},
	{
		checkType: "quarantine_rescued_records",
		costHint: "fast",
		label: "Quarantine and Rescued Records",
		standardDimensions: ["accuracy"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "row"
		}]
	},
	{
		checkType: "schema_evolution_policy",
		costHint: "fast",
		label: "Schema Evolution Policy",
		standardDimensions: ["validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "freshness_latency",
		costHint: "fast",
		label: "Freshness and Latency",
		standardDimensions: ["timeliness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "cross_batch_deduplication",
		costHint: "slow",
		label: "Cross-Batch Deduplication",
		standardDimensions: ["uniqueness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "row"
		}]
	},
	{
		checkType: "provenance_completeness",
		costHint: "fast",
		label: "Provenance Completeness",
		standardDimensions: ["completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "source_concurrency_consistency",
		costHint: "slow",
		label: "Source and Concurrency Consistency",
		standardDimensions: ["consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "cdm",
		validationKey: "cdmValidation",
		costHint: "slow",
		label: "CDM Validation",
		standardDimensions: ["validity", "consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "fhir_standards",
		validationKey: "fhirStandards",
		costHint: "slow",
		label: "FHIR Standards",
		standardDimensions: ["validity"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "data_dictionary",
		validationKey: "dataDictionary",
		costHint: "fast",
		label: "Data Dictionary",
		standardDimensions: ["validity", "completeness"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "domain_usage_pattern",
		validationKey: "domainMetrics",
		costHint: "slow",
		label: "Domain Usage Pattern",
		standardDimensions: ["consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "domain_behavior_consistency",
		validationKey: "domainMetrics",
		costHint: "slow",
		label: "Domain Behavior Consistency",
		standardDimensions: ["consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	},
	{
		checkType: "domain_outcome_distribution",
		validationKey: "domainMetrics",
		costHint: "slow",
		label: "Domain Outcome Distribution",
		standardDimensions: ["consistency"],
		canRunFrom: ["table"],
		scopeCombinations: [{
			runScopeType: "table",
			targetScopeType: "table",
			findingScopeType: "table"
		}]
	}
], dy = new Map(uy.map((e) => [e.checkType, e])), fy = new Map(uy.filter((e) => typeof e.validationKey == "string").map((e) => [e.validationKey, e])), py = /* @__PURE__ */ new Map();
for (let e of uy) {
	if (!e.processorId) continue;
	let t = py.get(e.processorId) ?? [];
	py.set(e.processorId, [...t, e]);
}
function my(e) {
	return dy.get(e);
}
function hy(e) {
	return fy.get(e);
}
//#endregion
//#region src/services/validationService.ts
function gy(e) {
	return e?.data ?? e;
}
function _y(e) {
	return e.replace(/[_-]+/g, " ").replace(/\s+/g, " ").trim().replace(/\b\w/g, (e) => e.toUpperCase());
}
function vy(e) {
	let t = String(e ?? "").trim().toLowerCase();
	return t ? t.includes("timestamp") ? "timestamp" : t.includes("datetime") ? "datetime" : t.includes("date") ? "date" : t.includes("json") ? "json" : t.includes("bool") ? "boolean" : /(int|serial)/.test(t) ? "integer" : /(real|float|double|decimal|numeric)/.test(t) ? "float" : (/(char|clob|text)/.test(t), "string") : "string";
}
function yy(e) {
	let t = /* @__PURE__ */ new Set();
	for (let n of e.indexes ?? []) if (!(!n?.unique || !Array.isArray(n.columns))) for (let e of n.columns) typeof e == "string" && e.trim() && t.add(e);
	return t;
}
async function by(e, t) {
	return gy((await Z.get(X.endpoints.tables.schema(e, t))).data);
}
async function xy(e, t, n) {
	let r = gy((await Z.get(X.endpoints.tables.tableData(e, t), { params: {
		limit: n,
		offset: 0
	} })).data);
	return Array.isArray(r.rows) ? r.rows : [];
}
async function Sy(e) {
	let t = gy((await Z.get(X.endpoints.database.relationships(e))).data);
	return Array.isArray(t.relationships) ? t.relationships : [];
}
async function Cy(e, t) {
	let n = gy((await Z.get(X.endpoints.governance.columns(e), { params: { tableName: t } })).data);
	return Array.isArray(n.columns) ? n.columns : [];
}
function wy() {
	return {
		completeness: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		dataQuality: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		nullCheck: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		typeInferenceTable: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		typeInferenceColumn: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		patterns: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		constraints: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		tableStructure: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		privacy: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		timeSequence: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		referentialIntegrity: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		businessLogic: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		cdmValidation: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		fhirStandards: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		dataDictionary: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		dataMasking: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		differentialPrivacy: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		populationAnalysis: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		temporalTrends: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		domainMetrics: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		comparativeAnalysis: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		quasiIdentifiers: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		phiDetection: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		reidentificationRisk: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		},
		anomalyDetection: {
			status: "idle",
			data: void 0,
			error: void 0,
			timestamp: ""
		}
	};
}
var Ty = {
	async checkMissingData(e, t, n = 1e3) {
		let r = { sampleSize: n };
		try {
			return (await Z.post(X.endpoints.validation.missingData(e, t), void 0, { params: r })).data;
		} catch (e) {
			throw console.error("Error checking missing data:", e), e;
		}
	},
	async checkDataQuality(e, t, n = 100) {
		try {
			return (await Z.post(X.endpoints.validation.dataQuality(e, t), void 0, { params: { sampleSize: n } })).data;
		} catch (e) {
			throw console.error("Error checking data quality:", e), e;
		}
	},
	async checkNullValues(e, t, n) {
		try {
			let r = {};
			return n && (r.columnName = n), (await Z.get(X.endpoints.validation.nullCheck(e, t), { params: r })).data;
		} catch (e) {
			throw console.error("Error checking NULL values:", e), e;
		}
	},
	async inferTableTypes(e, t, n = 100, r = !0, i = !1) {
		try {
			return (await Z.post(X.endpoints.typeInference.columnTypes(e, t), void 0, { params: {
				sampleSize: n,
				includeExplanations: r,
				includeSampleValues: i
			} })).data;
		} catch (e) {
			throw console.error("Error inferring table types:", e), e;
		}
	},
	async checkPatterns(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.patterns(e, t))).data;
		} catch (e) {
			throw console.error("Error checking patterns:", e), e;
		}
	},
	async checkConstraints(e, t) {
		try {
			let [n, r] = await Promise.all([by(e, t), xy(e, t, 250)]), i = yy(n), a = (n.columns ?? []).map((e) => {
				let t = {};
				return (e.notnull || e.pk) && (t.required = !0), (e.pk || i.has(e.name)) && (t.unique = !0), {
					name: e.name,
					type: vy(e.type),
					title: _y(e.name),
					description: `${_y(e.name)} column`,
					constraints: Object.keys(t).length > 0 ? t : void 0
				};
			});
			return (await Z.post(X.endpoints.validation.constraints(), {
				databaseId: Number(e),
				tableName: t,
				data: r,
				schema: { fields: a }
			})).data;
		} catch (e) {
			throw console.error("Error checking constraints:", e), e;
		}
	},
	async checkTableStructure(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.tableStructure(e, t))).data;
		} catch (e) {
			throw console.error("Error checking table structure:", e), e;
		}
	},
	async checkBusinessLogic(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.businessLogic(e, t))).data;
		} catch (e) {
			throw console.error("Error checking business logic:", e), e;
		}
	},
	async checkReferentialIntegrity(e, t) {
		try {
			let n = (await Sy(e)).filter((e) => e.sourceTable === t || e.targetTable === t);
			if (n.length === 0) throw Error(`No relationships found for table "${t}"`);
			return (await Z.post(X.endpoints.validation.crossTable(e), {
				relationships: n,
				validateReferentialIntegrity: !0,
				validateCardinality: !1,
				sampleSize: 1e3
			})).data;
		} catch (e) {
			throw console.error("Error checking referential integrity:", e), e;
		}
	},
	async checkTimeSequence(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.timeSequence(e, t))).data;
		} catch (e) {
			throw console.error("Error checking time sequence:", e), e;
		}
	},
	async detectAnomalies(e, t, n) {
		try {
			let r = await xy(e, t, 500);
			return (await Z.post(X.endpoints.stats.anomalies, {
				databaseId: Number(e),
				tableName: t,
				data: r,
				options: n ? { columns: [n] } : void 0
			})).data;
		} catch (e) {
			throw console.error("Error detecting anomalies:", e), e;
		}
	},
	async validateCdm(e, t, n = "omop") {
		try {
			return (await Z.post(X.endpoints.validation.cdmValidation(n, e, t))).data;
		} catch (e) {
			throw console.error("Error validating CDM:", e), e;
		}
	},
	async validateFhir(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.fhirStandards(e, t))).data;
		} catch (e) {
			throw console.error("Error validating FHIR standards:", e), e;
		}
	},
	async checkDataDictionary(e, t) {
		try {
			let [n, r] = await Promise.all([by(e, t), Cy(e, t)]), i = new Map(r.map((e) => [e.columnName ?? e.column_name ?? "", e])), a = yy(n), o = (n.columns ?? []).map((e) => {
				let t = i.get(e.name), n = typeof t?.isNullable == "boolean" ? !t.isNullable : typeof t?.is_nullable == "boolean" ? !t.is_nullable : !!(e.notnull || e.pk), r = [];
				return n && r.push("NOT NULL"), e.pk && r.push("PRIMARY KEY"), a.has(e.name) && !e.pk && r.push("UNIQUE"), {
					columnName: e.name,
					description: t?.description?.trim() || t?.businessName?.trim() || t?.business_name?.trim() || `${_y(e.name)} column`,
					dataType: t?.dataType?.trim() || t?.data_type?.trim() || e.type || "TEXT",
					constraints: r,
					required: n
				};
			});
			return (await Z.post(X.endpoints.validation.dataDictionary(e, t), {
				dictionary: { columns: o },
				strictMode: !1
			})).data;
		} catch (e) {
			throw console.error("Error checking data dictionary:", e), e;
		}
	},
	async detectPhi(e, t) {
		try {
			return (await Z.post(X.endpoints.privacy.phiDetection(e, t))).data;
		} catch (e) {
			throw console.error("Error detecting PHI:", e), e;
		}
	},
	async detectDatabasePhi(e) {
		try {
			return (await Z.get(X.endpoints.privacy.phiDetectionDatabase(e))).data;
		} catch (e) {
			throw console.error("Error detecting database PHI:", e), e;
		}
	},
	async detectQuasiIdentifiers(e, t) {
		try {
			return (await Z.post(X.endpoints.privacy.quasiIdentifiers(e, t))).data;
		} catch (e) {
			throw console.error("Error detecting quasi-identifiers:", e), e;
		}
	},
	async assessReidentificationRisk(e, t) {
		try {
			return (await Z.post(X.endpoints.privacy.reidentificationRisk(e, t))).data;
		} catch (e) {
			throw console.error("Error assessing re-identification risk:", e), e;
		}
	},
	async maskData(e, t, n) {
		try {
			if (!n) throw Error("Column name is required for data masking");
			return (await Z.post(X.endpoints.privacy.dataMasking(e, t), {
				columns: [n],
				maskingType: "hash",
				hashAlgorithm: "sha256"
			})).data;
		} catch (e) {
			throw console.error("Error masking data:", e), e;
		}
	},
	async applyDifferentialPrivacy(e, t, n) {
		try {
			return (await Z.post(X.endpoints.privacy.differentialPrivacy(e, t), {
				epsilon: 1,
				delta: 1e-6,
				sampleSize: 1e3,
				...n ? { rowsetKey: n } : {}
			})).data;
		} catch (e) {
			throw console.error("Error applying differential privacy:", e), e;
		}
	},
	async compareDatasets(e, t) {
		try {
			return (await Z.post(X.endpoints.validation.syntheticComparison(e, t))).data;
		} catch (e) {
			throw console.error("Error comparing datasets:", e), e;
		}
	},
	async analysePopulation(e, t) {
		try {
			return (await Z.post(X.endpoints.domainAnalytics.metrics(e, t))).data;
		} catch (e) {
			throw console.error("Error analysing population:", e), e;
		}
	},
	async analyseTemporalTrends(e, t) {
		try {
			return (await Z.post(X.endpoints.domainAnalytics.temporal(e, t))).data;
		} catch (e) {
			throw console.error("Error analysing temporal trends:", e), e;
		}
	},
	async fetchDomainMetrics(e, t) {
		try {
			return (await Z.post(X.endpoints.domainAnalytics.metrics(e, t))).data;
		} catch (e) {
			throw console.error("Error fetching domain metrics:", e), e;
		}
	},
	async getLatestQualityChecks(e, t) {
		try {
			return (await Z.get(`/v1/databases/${e}/quality-checks/latest`, { params: t })).data;
		} catch (e) {
			throw console.error("Error fetching latest quality checks:", e), e;
		}
	},
	async getQualityCheckDefinitions() {
		try {
			return (await Z.get("/v1/databases/quality-check-definitions")).data;
		} catch (e) {
			throw console.error("Error fetching quality check definitions:", e), e;
		}
	},
	async inferColumnType(e, t, n, r = 100, i = !0, a = !1) {
		try {
			return (await Z.get(X.endpoints.typeInference.columnType(e, t, n), { params: {
				sampleSize: r,
				includeExplanations: i,
				includeSampleValues: a
			} })).data;
		} catch (e) {
			throw console.error("Error inferring column type:", e), e;
		}
	}
};
//#endregion
//#region src/components/panel/AnalysisQuality.tsx
function Ey(e) {
	return Array.isArray(e) ? e : Array.isArray(e?.data) ? e.data : Array.isArray(e?.data?.data) ? e.data.data : [];
}
function Dy(e, t, n) {
	return e?.target_scope_type === "column" && e?.table_name === t && e?.target_column_name === n;
}
function Oy(e, t, n, r) {
	let i = hy(r)?.scopeCombinations.some((e) => e.targetScopeType === "column") ?? !1;
	return Dy(e, t, n) ? !0 : e?.target_scope_type == null ? e?.table_name === t : e?.target_scope_type === "table" ? e?.table_name === t && !i : !1;
}
function ky(e) {
	return [
		e.checkType,
		e.targetScopeType ?? "",
		e.tableName ?? "",
		e.targetColumnName ?? "",
		e.targetRowsetKey ?? "",
		e.ruleKind ?? "",
		e.ruleKey ?? "",
		e.runAt
	].join("::");
}
function Ay(e) {
	return {
		checkType: e.check_type,
		status: e.status,
		overallScore: e.overall_score ?? null,
		issuesFound: e.issues_found ?? 0,
		runAt: e.run_at,
		targetScopeType: e.target_scope_type ?? null,
		findingScopeType: e.finding_scope_type ?? null,
		tableName: e.table_name ?? null,
		targetColumnName: e.target_column_name ?? null,
		targetRowsetKey: e.target_rowset_key ?? null,
		ruleKind: e.rule_kind ?? null,
		ruleKey: e.rule_key ?? null
	};
}
function jy(e, t, n, r, i, a) {
	return a ? t === "database" ? e.targetScopeType === "database" || !e.targetScopeType && e.tableName === "__database__" : t === "table" ? e.tableName === n && (e.targetScopeType === "table" || !e.targetScopeType) : Oy({
		target_scope_type: e.targetScopeType,
		table_name: e.tableName,
		target_column_name: e.targetColumnName
	}, n, r, i) : !1;
}
function My(e, t, n) {
	return t === "database" ? !1 : t === "table" ? e.targetScopeType === "database" : e.targetScopeType === "database" ? !0 : e.tableName === n;
}
function Ny(e) {
	let t = e?.standardizedError?.errors?.[0]?.message;
	if (typeof t == "string" && t.trim()) return t;
	let n = e?.response?.data?.error?.message;
	if (typeof n == "string" && n.trim()) return n;
	let r = e?.response?.data?.message;
	return typeof r == "string" && r.trim() ? r : typeof e?.message == "string" && e.message.trim() ? e.message : String(e);
}
function Py(e) {
	if (!e) return "pass";
	if (typeof e.passed == "boolean") return e.passed ? "pass" : "fail";
	if (e.status === "pass" || e.status === "fail") return e.status;
	if (e.data && typeof e.data == "object") return Py(e.data);
	if (typeof e.valid == "boolean") return e.valid ? "pass" : "fail";
	if (typeof e.issuesFound == "number" && e.issuesFound > 0 || typeof e.issues_found == "number" && e.issues_found > 0 || Array.isArray(e.results) && e.results.some((e) => e?.valid === !1) || Array.isArray(e.failures) && e.failures.length > 0) return "fail";
	if (Array.isArray(e.findings)) {
		if (e.findings.some((e) => Array.isArray(e?.mismatches) && e.mismatches.length > 0)) return "fail";
		if (e.findings.every((e) => e && typeof e == "object" && typeof e.inferredType == "string")) return "pass";
		if (e.findings.length > 0) return "fail";
	}
	if (Array.isArray(e.quasiIdentifiers) && e.quasiIdentifiers.length > 0 || Array.isArray(e.issues) && e.issues.length > 0 || Array.isArray(e.anomalies) && e.anomalies.length > 0 || typeof e.maxRisk == "number" && e.maxRisk > .1) return "fail";
	if (Array.isArray(e.columnResults)) return e.columnResults.some((e) => e?.hasIssues || typeof e?.flaggedCount == "number" && e.flaggedCount > 0) ? "fail" : "pass";
	if (Array.isArray(e.columns)) return e.columns.some((e) => typeof e?.missingCount == "number" && e.missingCount > 0) ? "fail" : "pass";
	if (e.summary && typeof e.summary == "object") {
		let t = e.summary;
		if (typeof t.totalIssues == "number" && t.totalIssues > 0 || typeof t.columnsWithIssues == "number" && t.columnsWithIssues > 0 || typeof t.violations == "number" && t.violations > 0) return "fail";
	}
	return Array.isArray(e.missingColumns) && e.missingColumns.length > 0 || Array.isArray(e.extraColumns) && e.extraColumns.length > 0 || Array.isArray(e.typeMismatches) && e.typeMismatches.length > 0 || Array.isArray(e.orderIssues) && e.orderIssues.length > 0 || typeof e.duplicateRows == "number" && e.duplicateRows > 0 || typeof e.broken == "number" && e.broken > 0 || typeof e.outOfOrder == "number" && e.outOfOrder > 0 ? "fail" : "pass";
}
var Fy = ({ checkStatus: e }) => e === "running" ? /* @__PURE__ */ _(Ma, { className: "w-3.5 h-3.5 text-blue-400 animate-spin flex-shrink-0 mt-0.5" }) : e === "pass" ? /* @__PURE__ */ _(oo, { className: "w-3.5 h-3.5 text-green-500 flex-shrink-0 mt-0.5" }) : e === "fail" ? /* @__PURE__ */ _(ys, { className: "w-3.5 h-3.5 text-red-500 flex-shrink-0 mt-0.5" }) : /* @__PURE__ */ _("span", { className: "w-3.5 h-3.5 rounded-full border border-gray-300 flex-shrink-0 mt-0.5 inline-block" }), Iy = ({ resultData: e, error: t, persisted: n }) => {
	let [r, i] = h(!1);
	if (t) return /* @__PURE__ */ v("div", {
		className: "text-xs text-red-600 bg-red-50 border border-red-100 p-2 rounded-md",
		children: [/* @__PURE__ */ _("span", {
			className: "font-medium",
			children: "Error: "
		}), t]
	});
	if (!e && !n) return /* @__PURE__ */ _("p", {
		className: "text-xs text-gray-400 italic",
		children: "Run the check to see results."
	});
	let a = n?.status ?? (e ? Py(e) : void 0), o = n?.overallScore ?? null, s = n?.issuesFound ?? null, c = n?.runAt ?? null;
	return /* @__PURE__ */ v("div", {
		className: "space-y-1.5",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex items-center gap-1.5 flex-wrap",
				children: [
					a && /* @__PURE__ */ _("span", {
						className: `px-1.5 py-0.5 rounded text-xs font-semibold ${a === "pass" ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`,
						children: a === "pass" ? "PASS" : "FAIL"
					}),
					typeof o == "number" && /* @__PURE__ */ v("span", {
						className: `px-1.5 py-0.5 rounded text-xs font-medium ${o >= 80 ? "bg-green-50 text-green-600" : o >= 50 ? "bg-amber-50 text-amber-700" : "bg-red-50 text-red-600"}`,
						children: ["Score: ", o.toFixed(1)]
					}),
					typeof s == "number" && s > 0 && /* @__PURE__ */ v("span", {
						className: "px-1.5 py-0.5 rounded text-xs font-medium bg-amber-50 text-amber-700",
						children: [
							s,
							" issue",
							s === 1 ? "" : "s"
						]
					}),
					c && /* @__PURE__ */ _("span", {
						className: "text-xs text-gray-400",
						children: new Date(c).toLocaleString()
					})
				]
			}),
			e && /* @__PURE__ */ _("button", {
				onClick: () => i((e) => !e),
				className: "text-xs text-gray-400 hover:text-gray-600 underline",
				children: r ? "Hide raw data" : "Show raw data"
			}),
			r && e && /* @__PURE__ */ _("pre", {
				className: "text-xs bg-gray-50 border border-gray-100 p-2 rounded-md overflow-auto max-h-40",
				children: JSON.stringify(e, null, 2)
			})
		]
	});
}, Ly = ({ stats: e, isLoading: t, columnName: n, tableName: r, databaseId: i, filters: a = {}, sampling: o, tableData: s = [], activeCohortName: c, activeCohortRowsetKey: l, auditSummary: d, auditReports: p = [], auditRuleCount: m = 0, auditLoading: y = !1, auditError: b = null, onGenerateAuditReport: x, onDownloadAuditReport: S, onRefreshAudit: C }) => {
	let w = Di(), T = typeof w.runQualityCheck == "function", E = f(() => {
		let { __sampling: e, ...t } = a ?? {};
		return t;
	}, [a]), D = f(() => {
		let e = a?.__sampling, t = o?.samplingState;
		return e && typeof e == "object" ? {
			sampleStrategy: e.strategy,
			samplePercentage: e.samplePercentage,
			stratifyColumn: e.stratifyColumn,
			seed: e.seed
		} : t?.isSamplingEnabled ? {
			sampleStrategy: t.currentStrategy?.id,
			samplePercentage: t.samplePercentage,
			stratifyColumn: t.selectedColumn,
			seed: t.seed
		} : {};
	}, [a, o]), O = Object.keys(E).length, k = typeof D.samplePercentage == "number" ? D.samplePercentage : null, [A, j] = h(wy()), [M, N] = h(!1), [P, F] = h(/* @__PURE__ */ new Set()), [I, L] = h(!1), [R, z] = h([]), [B, V] = h("all"), [H, ee] = h(""), [U, te] = h("all"), [W, ne] = h(n ? "column" : r ? "table" : "database"), [re, ie] = h(!1), [ae, oe] = h(!1), [se, ce] = h(null), [le, ue] = h({
		completeness: !0,
		qualityMetrics: !0,
		dataQuality: !1,
		nullCheck: !1,
		typeInferenceTable: !1,
		typeInferenceColumn: !1,
		patterns: !1,
		constraints: !1,
		tableStructure: !1,
		privacy: !1,
		timeSequence: !1,
		referentialIntegrity: !1,
		businessLogic: !1,
		cdmValidation: !1,
		fhirStandards: !1,
		dataDictionary: !1,
		dataMasking: !1,
		differentialPrivacy: !1,
		populationAnalysis: !1,
		temporalTrends: !1,
		domainMetrics: !1,
		comparativeAnalysis: !1,
		quasiIdentifiers: !1,
		phiDetection: !1,
		reidentificationRisk: !1,
		anomalyDetection: !1
	});
	if (u(() => {
		ne(n ? "column" : r ? "table" : "database"), F(/* @__PURE__ */ new Set());
	}, [n, r]), u(() => {
		if (i) {
			if (T) {
				z([]);
				return;
			}
			Promise.all([Ty.getLatestQualityChecks(i, { scopeType: "database" }), r ? Ty.getLatestQualityChecks(i, { tableName: r }) : Promise.resolve({ data: [] })]).then((e) => {
				let t = /* @__PURE__ */ new Map();
				for (let n of e) {
					let e = Ey(n);
					for (let n of e) {
						let e = Ay(n);
						r && e.tableName && e.tableName !== r && e.targetScopeType !== "database" || t.set(ky(e), e);
					}
				}
				z(Array.from(t.values()));
			}).catch(() => {});
		}
	}, [
		i,
		r,
		T
	]), u(() => {
		N(Object.values(A).some((e) => e.status === "running"));
	}, [A]), t) return /* @__PURE__ */ v("div", {
		className: "flex flex-col items-center justify-center py-12",
		role: "status",
		"aria-live": "polite",
		"aria-busy": "true",
		"data-testid": "quality-loading-state",
		children: [/* @__PURE__ */ _("div", { className: "animate-pulse w-3/4 h-6 bg-background-light rounded mb-4" }), /* @__PURE__ */ _("div", { className: "animate-pulse w-2/3 h-4 bg-background-light rounded" })]
	});
	if (!e || !r || !i) return /* @__PURE__ */ _("div", {
		className: "p-4 text-center",
		children: /* @__PURE__ */ v("div", {
			className: "bg-amber-50 border border-amber-100 rounded-md p-4 flex flex-col items-center",
			children: [/* @__PURE__ */ _(Uo, { className: "h-6 w-6 text-amber-500 mb-2" }), /* @__PURE__ */ _("p", {
				className: "text-sm text-amber-800",
				children: e ? r ? i ? "Unable to run validations with the provided information." : "Database ID is required for validation." : "Table name is required for validation." : "No quality data available for this column."
			})]
		})
	});
	let de = (e) => {
		ue((t) => ({
			...t,
			[e]: !t[e]
		}));
	}, fe = {}, pe = [];
	for (let e of R) {
		let t = my(e.checkType), i = t?.validationKey;
		if (i) {
			if (jy(e, W, r, n, i, t?.canRunFrom.includes(W) ?? !1)) {
				fe[i] || (fe[i] = {
					status: e.status,
					overallScore: e.overallScore ?? null,
					issuesFound: e.issuesFound ?? 0,
					runAt: e.runAt
				});
				continue;
			}
			My(e, W, r) && (pe.some((t) => ky(t) === ky(e)) || pe.push(e));
		}
	}
	let me = (e) => {
		let t = new Set(P);
		t.has(e) ? t.delete(e) : (t.add(e), ue((t) => ({
			...t,
			[e]: !0
		})), e === "completeness" && ue((e) => ({
			...e,
			qualityMetrics: !0
		}))), F(t);
	}, he = (e) => {
		j((t) => ({
			...t,
			[e]: {
				...t[e],
				status: "running",
				data: void 0,
				error: void 0,
				timestamp: (/* @__PURE__ */ new Date()).toISOString()
			}
		}));
	}, ge = (e, t) => {
		j((n) => ({
			...n,
			[e]: {
				status: "success",
				data: t,
				error: void 0,
				timestamp: (/* @__PURE__ */ new Date()).toISOString()
			}
		}));
	}, _e = (e, t) => {
		j((n) => ({
			...n,
			[e]: {
				status: "error",
				data: void 0,
				error: Ny(t),
				timestamp: (/* @__PURE__ */ new Date()).toISOString()
			}
		}));
	}, ve = async (e, t) => !T || !w.runQualityCheck || !i || !r ? null : w.runQualityCheck(i, r, e, {
		columnName: n,
		scopeType: W,
		rowsetKey: t,
		visibleRows: s,
		filters: E,
		...D
	}), ye = async (e, t, n = {}) => {
		he(e), n.expand && ue((e) => ({
			...e,
			...n.expand
		}));
		try {
			ge(e, await ve(e, n.rowsetKey) ?? await t());
		} catch (t) {
			_e(e, t);
		}
	}, be = (e) => {
		let t = A[e];
		return t ? t.status === "running" ? "running" : t.status === "error" ? "fail" : t.status === "success" ? Py(t.data) : fe[e] ? fe[e].status : "unchecked" : fe[e] ? fe[e].status : "unchecked";
	}, xe = () => {
		ye("completeness", () => Ty.checkMissingData(i, r), { expand: {
			completeness: !0,
			qualityMetrics: !0
		} });
	}, Se = async () => {
		await ye("dataQuality", () => Ty.checkDataQuality(i, r), { expand: { dataQuality: !0 } });
	}, Ce = async () => {
		await ye("nullCheck", () => Ty.checkNullValues(i, r, n), { expand: { nullCheck: !0 } });
	}, we = async () => {
		await ye("typeInferenceTable", () => Ty.inferTableTypes(i, r, 100, !0, !1), { expand: { typeInferenceTable: !0 } });
	}, G = async () => {
		if (!n) {
			_e("typeInferenceColumn", /* @__PURE__ */ Error("Column name is required for column type inference"));
			return;
		}
		await ye("typeInferenceColumn", () => Ty.inferColumnType(i, r, n, 100, !0, !0), { expand: { typeInferenceColumn: !0 } });
	}, Te = async () => {
		await ye("patterns", () => Ty.checkPatterns(i, r), { expand: { patterns: !0 } });
	}, Ee = async () => {
		await ye("constraints", () => Ty.checkConstraints(i, r), { expand: { constraints: !0 } });
	}, K = async () => {
		await ye("tableStructure", () => Ty.checkTableStructure(i, r), { expand: { tableStructure: !0 } });
	}, De = async () => {
		await ye("businessLogic", () => Ty.checkBusinessLogic(i, r), { expand: { businessLogic: !0 } });
	}, Oe = async () => {
		await ye("referentialIntegrity", () => Ty.checkReferentialIntegrity(i, r), { expand: { referentialIntegrity: !0 } });
	}, ke = async () => {
		await ye("timeSequence", () => Ty.checkTimeSequence(i, r), { expand: { timeSequence: !0 } });
	}, Ae = async () => {
		await ye("anomalyDetection", () => Ty.detectAnomalies(i, r, n), { expand: { anomalyDetection: !0 } });
	}, je = async () => {
		await ye("cdmValidation", () => Ty.validateCdm(i, r), { expand: { cdmValidation: !0 } });
	}, Me = async () => {
		await ye("fhirStandards", () => Ty.validateFhir(i, r), { expand: { fhirStandards: !0 } });
	}, Ne = async () => {
		await ye("dataDictionary", () => Ty.checkDataDictionary(i, r), { expand: { dataDictionary: !0 } });
	}, Pe = async () => {
		await ye("phiDetection", () => W === "database" ? Ty.detectDatabasePhi(i) : Ty.detectPhi(i, r), { expand: { phiDetection: !0 } });
	}, Fe = async () => {
		await ye("quasiIdentifiers", () => Ty.detectQuasiIdentifiers(i, r), { expand: { quasiIdentifiers: !0 } });
	}, Ie = async () => {
		await ye("reidentificationRisk", () => Ty.assessReidentificationRisk(i, r), { expand: { reidentificationRisk: !0 } });
	}, Le = async () => {
		await ye("dataMasking", () => Ty.maskData(i, r, n), { expand: { dataMasking: !0 } });
	}, Re = async (e) => {
		await ye("differentialPrivacy", () => Ty.applyDifferentialPrivacy(i, r, e), {
			expand: { differentialPrivacy: !0 },
			rowsetKey: e
		});
	}, ze = {
		completeness: xe,
		dataQuality: Se,
		nullCheck: Ce,
		typeInferenceTable: we,
		typeInferenceColumn: G,
		patterns: Te,
		constraints: Ee,
		tableStructure: K,
		businessLogic: De,
		referentialIntegrity: Oe,
		timeSequence: ke,
		anomalyDetection: Ae,
		cdmValidation: je,
		fhirStandards: Me,
		dataDictionary: Ne,
		phiDetection: Pe,
		quasiIdentifiers: Fe,
		reidentificationRisk: Ie,
		dataMasking: Le,
		differentialPrivacy: Re,
		comparativeAnalysis: async () => {
			await ye("comparativeAnalysis", () => Ty.compareDatasets(i, r), { expand: { comparativeAnalysis: !0 } });
		},
		populationAnalysis: async () => {
			await ye("populationAnalysis", () => Ty.analysePopulation(i, r), { expand: { populationAnalysis: !0 } });
		},
		temporalTrends: async () => {
			await ye("temporalTrends", () => Ty.analyseTemporalTrends(i, r), { expand: { temporalTrends: !0 } });
		},
		domainMetrics: async () => {
			await ye("domainMetrics", () => Ty.fetchDomainMetrics(i, r), { expand: { domainMetrics: !0 } });
		}
	}, Be = { differentialPrivacy: (e) => Re(e) }, Ve = async () => {
		if (P.size === 0 || !i || W !== "database" && !r) return;
		let e = { ...A };
		P.forEach((t) => {
			t in e && (e[t] = {
				...e[t],
				status: "running",
				data: void 0,
				error: void 0,
				timestamp: (/* @__PURE__ */ new Date()).toISOString()
			});
		}), j(e);
		let t = { ...le };
		P.forEach((e) => {
			t[e] = !0, e === "completeness" && (t.qualityMetrics = !0);
		}), ue(t), await Promise.all(Array.from(P).map((e) => {
			let t = ze[e];
			return t ? t() : Promise.resolve();
		}));
	}, He = () => {
		let e = new Set(Je.map((e) => e.key));
		F(e), ue({
			completeness: e.has("completeness"),
			qualityMetrics: e.has("completeness"),
			dataQuality: e.has("dataQuality"),
			nullCheck: e.has("nullCheck"),
			typeInferenceTable: e.has("typeInferenceTable"),
			typeInferenceColumn: e.has("typeInferenceColumn"),
			patterns: e.has("patterns"),
			constraints: e.has("constraints"),
			tableStructure: e.has("tableStructure"),
			privacy: le.privacy,
			timeSequence: e.has("timeSequence"),
			referentialIntegrity: e.has("referentialIntegrity"),
			businessLogic: e.has("businessLogic"),
			anomalyDetection: e.has("anomalyDetection"),
			cdmValidation: e.has("cdmValidation"),
			fhirStandards: e.has("fhirStandards"),
			dataDictionary: e.has("dataDictionary"),
			dataMasking: e.has("dataMasking"),
			differentialPrivacy: e.has("differentialPrivacy"),
			populationAnalysis: e.has("populationAnalysis"),
			temporalTrends: e.has("temporalTrends"),
			domainMetrics: e.has("domainMetrics"),
			comparativeAnalysis: e.has("comparativeAnalysis"),
			quasiIdentifiers: e.has("quasiIdentifiers"),
			phiDetection: e.has("phiDetection"),
			reidentificationRisk: e.has("reidentificationRisk")
		});
		let t = { ...A };
		e.forEach((e) => {
			e in t && (t[e] = {
				...t[e],
				status: "running",
				data: void 0,
				error: void 0,
				timestamp: (/* @__PURE__ */ new Date()).toISOString()
			});
		}), j(t), Promise.all(Array.from(e).map((e) => {
			let t = ze[e];
			return t ? t() : Promise.resolve();
		}));
	}, Ue = {
		dimension1_coreValidation: {
			completeness: A.completeness?.data,
			dataQuality: A.dataQuality?.data,
			nullCheck: A.nullCheck?.data,
			typeInferenceTable: A.typeInferenceTable?.data,
			typeInferenceColumn: A.typeInferenceColumn?.data,
			patterns: A.patterns?.data,
			constraints: A.constraints?.data,
			tableStructure: A.tableStructure?.data
		},
		dimension2_anomalyDetection: {
			anomalyDetection: A.anomalyDetection?.data,
			businessLogic: A.businessLogic?.data,
			referentialIntegrity: A.referentialIntegrity?.data,
			timeSequence: A.timeSequence?.data
		},
		dimension3_complianceChecks: {
			cdmValidation: A.cdmValidation?.data,
			fhirStandards: A.fhirStandards?.data,
			dataDictionary: A.dataDictionary?.data
		},
		dimension4_privacyProtection: {
			privacy: A.privacy?.data,
			phiDetection: A.phiDetection?.data,
			quasiIdentifiers: A.quasiIdentifiers?.data,
			reidentificationRisk: A.reidentificationRisk?.data,
			dataMasking: A.dataMasking?.data,
			differentialPrivacy: A.differentialPrivacy?.data
		},
		dimension5_syntheticAI: {
			comparativeAnalysis: A.comparativeAnalysis?.data,
			populationAnalysis: A.populationAnalysis?.data,
			temporalTrends: A.temporalTrends?.data,
			domainMetrics: A.domainMetrics?.data
		}
	}, q = (e) => {
		let t = `quality_results.${e}`;
		if (e === "json") {
			let e = JSON.stringify(Ue, null, 2), n = new Blob([e], { type: "application/json" }), r = URL.createObjectURL(n), i = document.createElement("a");
			i.href = r, i.download = t, i.click(), URL.revokeObjectURL(r);
		} else if (e === "csv") {
			let e = "Dimension,Check,Result\n";
			Object.entries(Ue).forEach(([t, n]) => {
				Object.entries(n).forEach(([n, r]) => {
					e += `"${t}","${n}","${typeof r == "object" ? JSON.stringify(r) : r}"\n`;
				});
			});
			let n = new Blob([e], { type: "text/csv" }), r = URL.createObjectURL(n), i = document.createElement("a");
			i.href = r, i.download = t, i.click(), URL.revokeObjectURL(r);
		}
	}, We = Object.values(A).some((e) => e.status === "success" && e.data), J = [
		{
			title: "Dimension 1 — Core Validation",
			items: [
				{
					key: "completeness",
					label: "Missing Data Analysis: missingness, stratification, visualization"
				},
				{
					key: "dataQuality",
					label: "Data Quality: table & field validation, presence, naming, formats"
				},
				{
					key: "nullCheck",
					label: "Null/Missing Value Analysis"
				},
				{
					key: "typeInferenceTable",
					label: "Table Type Inference"
				},
				{
					key: "typeInferenceColumn",
					label: "Column Type Inference"
				},
				{
					key: "patterns",
					label: "Pattern Validation: field format and regex conformance"
				},
				{
					key: "constraints",
					label: "Constraint Validation: uniqueness, ranges, allowed values"
				},
				{
					key: "tableStructure",
					label: "Table Structure Checks: required columns, types, naming"
				}
			]
		},
		{
			title: "Dimension 2 — Anomaly Detection",
			items: [
				{
					key: "anomalyDetection",
					label: "Anomaly Detection: statistical outliers and unusual patterns"
				},
				{
					key: "businessLogic",
					label: "Business Logic: logical attribute combinations"
				},
				{
					key: "referentialIntegrity",
					label: "Referential Integrity: parent-child relationships"
				},
				{
					key: "timeSequence",
					label: "Time Sequence Checks: valid event order, observation windows"
				}
			]
		},
		{
			title: "Dimension 3 — Compliance Checks",
			items: [
				{
					key: "cdmValidation",
					label: "CDM Validation: Common Data Model conformance"
				},
				{
					key: "fhirStandards",
					label: "FHIR Standards: HL7 FHIR resource compliance"
				},
				{
					key: "dataDictionary",
					label: "Data Dictionary: field definitions and metadata alignment"
				}
			]
		},
		{
			title: "Dimension 4 — Privacy Protection",
			items: [
				{
					key: "privacy",
					label: "Privacy Analysis"
				},
				{
					key: "phiDetection",
					label: "Protected Health Information (PHI) Detection"
				},
				{
					key: "quasiIdentifiers",
					label: "Quasi-Identifiers: detects attributes that may reveal identity"
				},
				{
					key: "reidentificationRisk",
					label: "Risk of Re-identification: max/avg risk per row"
				},
				{
					key: "dataMasking",
					label: "Data Masking: anonymise or pseudonymise sensitive fields"
				},
				{
					key: "differentialPrivacy",
					label: "Differential Privacy: noise injection for statistical queries"
				}
			]
		},
		{
			title: "Dimension 5 — Synthetic & AI",
			items: [
				{
					key: "comparativeAnalysis",
					label: "Comparative Analysis: benchmarking, external validation"
				},
				{
					key: "populationAnalysis",
					label: "Population Analysis: record/entity counts, subpopulations"
				},
				{
					key: "temporalTrends",
					label: "Temporal Trends: event rates, seasonality"
				},
				{
					key: "domainMetrics",
					label: "Domain Metrics: usage, behavior, outcomes"
				}
			]
		}
	], Ge = String(e?.type ?? e?.metadata?.type ?? e?.inferredType ?? "Unknown"), Ke = r.toLowerCase().includes("visit") || r.toLowerCase().includes("encounter") || r.toLowerCase().includes("order") || r.toLowerCase().includes("claim"), qe = J.flatMap((e) => e.items.map((t) => {
		let i = t.label.toLowerCase(), a = hy(t.key), o = a?.scopeCombinations.some((e) => e.targetScopeType === "column") ?? !1, s = t.key === "nullCheck" ? "Useful for every column, especially sparse ones." : t.key === "typeInferenceColumn" && n ? `Focused on ${n} and its observed values.` : t.key === "typeInferenceTable" ? "Good first pass to understand the whole table shape." : t.key === "patterns" && /status|code|id|email|phone|zip|date/.test(n.toLowerCase()) ? `Pattern-heavy column detected: ${n}.` : t.key === "anomalyDetection" && /number|float|int|decimal|numeric/i.test(Ge) ? `Numerical column type (${Ge}) benefits from anomaly scans.` : t.key === "timeSequence" && /date|time|timestamp/i.test(Ge) ? `Temporal type (${Ge}) makes sequence validation relevant.` : t.key === "phiDetection" && /name|email|phone|birth|address|zip|ssn|patient/i.test(n.toLowerCase()) ? `Sensitive-looking column name: ${n}.` : t.key === "referentialIntegrity" && Ke ? `Table name ${r} suggests relational links worth validating.` : t.key === "dataQuality" || t.key === "completeness" ? "Strong baseline checks for every table." : null;
		return {
			...t,
			dimensionTitle: e.title,
			isColumnScoped: o,
			supportsRowset: a?.supportsRowset ?? !1,
			isEntityScoped: a ? a.canRunFrom.includes(W) : !1,
			isRecommended: s !== null,
			recommendedBecause: s,
			searchText: `${e.title} ${t.label} ${n} ${r} ${Ge} ${i} ${a?.supportsRowset ? "rowset cohort filtered subset" : ""}`
		};
	})), Je = qe.filter((e) => e.isEntityScoped), Ye = Je, Xe = Ye.filter(({ key: e }) => be(e) === "pass").length, Ze = Ye.filter(({ key: e }) => be(e) === "fail").length, Qe = Ye.filter(({ key: e }) => be(e) === "unchecked").length, $e = Je.filter((e) => e.isRecommended).length, et = Je.filter((e) => P.has(e.key)).length, tt = (() => {
		let e = Je.map((e) => fe[e.key]?.overallScore).filter((e) => typeof e == "number");
		return e.length === 0 ? null : e.reduce((e, t) => e + t, 0) / e.length;
	})(), nt = Je.map((e) => fe[e.key]?.runAt).filter((e) => typeof e == "string").sort().at(-1), rt = (e) => B === "all" ? e : e.filter(({ key: e }) => {
		let t = be(e);
		return B === "pass" ? t === "pass" : B === "fail" ? t === "fail" : B === "unchecked" ? t === "unchecked" : !0;
	}), it = (e) => U === "all" ? e : e.filter((e) => U === "recommended" ? e.isRecommended : U === "selected" ? P.has(e.key) : U === "column" ? e.isColumnScoped : U === "table" ? !e.isColumnScoped : !0), at = (e) => {
		let t = H.trim().toLowerCase();
		return t ? e.filter((e) => e.searchText.toLowerCase().includes(t)) : e;
	}, ot = at(it(rt(Je))), st = J.map((e) => {
		let t = at(it(rt(Je))).filter((t) => t.dimensionTitle === e.title), n = t.filter((e) => be(e.key) === "pass").length, r = t.filter((e) => be(e.key) === "fail").length, i = t.map((e) => fe[e.key]?.overallScore).filter((e) => typeof e == "number"), a = i.length > 0 ? i.reduce((e, t) => e + t, 0) / i.length : null;
		return {
			...e,
			items: t,
			dimensionPass: n,
			dimensionFail: r,
			averageScore: a
		};
	}), ct = () => {
		F(new Set(ot.map((e) => e.key)));
	}, lt = () => {
		F(new Set(Je.filter((e) => e.isRecommended).map((e) => e.key)));
	}, ut = pe.filter((e) => W === "table" ? e.targetScopeType === "database" : W === "column" ? e.targetScopeType !== "column" : !1), dt = () => {
		F(new Set(qe.filter((e) => be(e.key) === "fail").map((e) => e.key)));
	}, Y = (e) => e === "pass" ? "border-green-200 bg-green-50 text-green-700" : e === "fail" ? "border-red-200 bg-red-50 text-red-700" : e === "running" ? "border-blue-200 bg-blue-50 text-blue-700" : "border-gray-200 bg-gray-50 text-gray-500", ft = (e) => typeof e == "number" ? e >= 80 ? "bg-green-50 text-green-600" : e >= 50 ? "bg-amber-50 text-amber-700" : "bg-red-50 text-red-600" : "bg-gray-100 text-gray-500", pt = (d?.results ?? []).filter((e) => r ? e.rule.table_name === r : !0), mt = pt.length === 0 ? d?.grade ?? null : pt.some((e) => !e.passed) ? "FAIL" : pt.some((e) => e.warned) ? "WARN" : "PASS", ht = p.find((e) => e.format === "json") ?? null, gt = p.find((e) => e.format === "pdf") ?? null, _t = mt === "FAIL" ? "border-rose-200 bg-rose-50 text-rose-700" : mt === "WARN" ? "border-amber-200 bg-amber-50 text-amber-700" : "border-emerald-200 bg-emerald-50 text-emerald-700", vt = async (e) => {
		if (x) {
			ce(null), e === "json" ? ie(!0) : oe(!0);
			try {
				let t = await x(e);
				t && S && e === "pdf" && await S(t);
			} catch (t) {
				ce(t?.message || `Unable to generate ${e.toUpperCase()} audit report`);
			} finally {
				e === "json" ? ie(!1) : oe(!1);
			}
		}
	};
	return /* @__PURE__ */ v("div", {
		className: "space-y-3 bg-background-ultra-light p-3",
		children: [
			/* @__PURE__ */ v("section", {
				className: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm",
				children: [
					/* @__PURE__ */ v("div", {
						className: "flex items-start justify-between gap-3",
						children: [/* @__PURE__ */ v("div", { children: [
							/* @__PURE__ */ _("div", {
								className: "text-[11px] font-medium uppercase tracking-[0.12em] text-slate-400",
								children: "Vendor Audit"
							}),
							/* @__PURE__ */ _("h2", {
								className: "mt-1 text-sm font-semibold text-slate-900",
								children: m > 0 ? `${m} active SLA rule${m === 1 ? "" : "s"}` : "No SLA rules configured"
							}),
							/* @__PURE__ */ _("p", {
								className: "mt-1 text-xs text-slate-500",
								children: d ? `Latest audit generated ${new Date(d.generated_at).toLocaleString()}` : "Generate an audit report to score the current delivery against SLA rules."
							})
						] }), /* @__PURE__ */ _("div", {
							className: `rounded-full border px-3 py-1 text-xs font-semibold uppercase tracking-[0.14em] ${_t}`,
							children: mt ?? "No audit"
						})]
					}),
					d && /* @__PURE__ */ v("div", {
						className: "mt-3 grid grid-cols-2 gap-2",
						children: [/* @__PURE__ */ v("div", {
							className: "rounded-xl bg-slate-50 px-2.5 py-2",
							children: [/* @__PURE__ */ _("div", {
								className: "text-[10px] uppercase tracking-[0.14em] text-slate-400",
								children: "Scope rules"
							}), /* @__PURE__ */ _("div", {
								className: "mt-1 text-sm font-semibold text-slate-900",
								children: pt.length
							})]
						}), /* @__PURE__ */ v("div", {
							className: "rounded-xl bg-slate-50 px-2.5 py-2",
							children: [/* @__PURE__ */ _("div", {
								className: "text-[10px] uppercase tracking-[0.14em] text-slate-400",
								children: "Overall grade"
							}), /* @__PURE__ */ _("div", {
								className: "mt-1 text-sm font-semibold text-slate-900",
								children: d.grade
							})]
						})]
					}),
					(b || se) && /* @__PURE__ */ _("div", {
						className: "mt-3 rounded-xl border border-rose-100 bg-rose-50 px-3 py-2 text-xs text-rose-700",
						children: se ?? b
					}),
					pt.length > 0 && /* @__PURE__ */ _("div", {
						className: "mt-3 space-y-2",
						children: pt.slice(0, 5).map((e, t) => /* @__PURE__ */ _("div", {
							className: "rounded-xl border border-slate-100 bg-slate-50 px-3 py-2",
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center justify-between gap-2",
								children: [/* @__PURE__ */ v("div", {
									className: "min-w-0",
									children: [/* @__PURE__ */ _("div", {
										className: "text-xs font-semibold text-slate-900 truncate",
										children: [
											e.rule.table_name,
											e.rule.column_name,
											e.rule.rule_key
										].filter(Boolean).join(" • ")
									}), /* @__PURE__ */ v("div", {
										className: "mt-1 text-[11px] text-slate-500",
										children: [
											"Actual ",
											e.actual_value ?? "n/a",
											e.failure_reason ? ` • ${e.failure_reason}` : ""
										]
									})]
								}), /* @__PURE__ */ _("span", {
									className: `rounded-full px-2 py-0.5 text-[11px] font-semibold ${e.passed ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`,
									children: e.passed ? "PASS" : "FAIL"
								})]
							})
						}, `${e.rule.id}-${t}`))
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-3 flex flex-wrap gap-1.5",
						children: [
							/* @__PURE__ */ _("button", {
								onClick: () => void vt("json"),
								disabled: y || re || m === 0,
								className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50",
								children: re ? "Generating JSON…" : "Generate JSON"
							}),
							/* @__PURE__ */ _("button", {
								onClick: () => void vt("pdf"),
								disabled: y || ae || m === 0,
								className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50 disabled:opacity-50",
								children: ae ? "Generating PDF…" : "Generate PDF"
							}),
							ht && S && /* @__PURE__ */ _("button", {
								onClick: () => void S(ht),
								className: "rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-xs font-semibold text-emerald-700 hover:bg-emerald-100",
								children: "Download JSON"
							}),
							gt && S && /* @__PURE__ */ _("button", {
								onClick: () => void S(gt),
								className: "rounded-full border border-sky-200 bg-sky-50 px-3 py-1.5 text-xs font-semibold text-sky-700 hover:bg-sky-100",
								children: "Download PDF"
							}),
							C && /* @__PURE__ */ _("button", {
								onClick: () => void C(),
								className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-50",
								children: "Refresh Audit"
							})
						]
					})
				]
			}),
			c && /* @__PURE__ */ v("div", {
				"data-testid": "quality-cohort-banner",
				className: "flex items-center gap-2 rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs text-blue-800",
				children: [
					/* @__PURE__ */ _(Qa, { className: "w-3.5 h-3.5 flex-shrink-0 text-blue-500" }),
					/* @__PURE__ */ v("span", { children: ["Active cohort: ", /* @__PURE__ */ _("span", {
						className: "font-semibold",
						children: c
					})] }),
					l && /* @__PURE__ */ _("span", {
						className: "ml-auto text-[10px] text-blue-400 font-mono truncate",
						title: l,
						children: l
					})
				]
			}),
			(T || O > 0 || k !== null) && /* @__PURE__ */ v("div", {
				"data-testid": "quality-rowset-banner",
				className: "flex flex-wrap items-center gap-2 rounded-xl border border-sky-100 bg-sky-50 px-3 py-2 text-xs text-sky-800",
				children: [
					/* @__PURE__ */ _(Uo, { className: "w-3.5 h-3.5 flex-shrink-0 text-sky-500" }),
					/* @__PURE__ */ _("span", { children: "Current rowset" }),
					T && /* @__PURE__ */ _("span", {
						className: "rounded-full bg-white/80 px-2 py-0.5 text-[10px] font-semibold text-sky-700",
						children: "Local JSON"
					}),
					/* @__PURE__ */ v("span", {
						className: "rounded-full bg-white/80 px-2 py-0.5 text-[10px] font-semibold text-sky-700",
						children: [
							O,
							" filter",
							O === 1 ? "" : "s"
						]
					}),
					k !== null && k < 100 && /* @__PURE__ */ v("span", {
						className: "rounded-full bg-white/80 px-2 py-0.5 text-[10px] font-semibold text-sky-700",
						children: [k, "% sample"]
					})
				]
			}),
			/* @__PURE__ */ v("section", {
				className: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm",
				children: [
					/* @__PURE__ */ _("div", {
						className: "flex items-start justify-between gap-3",
						children: /* @__PURE__ */ _("div", {
							className: "min-w-0",
							children: /* @__PURE__ */ _("h2", {
								className: "text-sm font-semibold text-slate-900",
								children: "Quality analysis"
							})
						})
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-3 grid grid-cols-2 gap-2",
						children: [/* @__PURE__ */ v("div", {
							className: "rounded-xl bg-slate-50 px-2.5 py-2",
							children: [/* @__PURE__ */ _("div", {
								className: "text-[10px] uppercase tracking-[0.14em] text-slate-400",
								children: "Pass / Fail"
							}), /* @__PURE__ */ v("div", {
								className: "mt-1 text-sm font-semibold text-slate-900",
								children: [
									/* @__PURE__ */ _("span", {
										className: "text-green-600",
										children: Xe
									}),
									" / ",
									/* @__PURE__ */ _("span", {
										className: "text-red-600",
										children: Ze
									})
								]
							})]
						}), /* @__PURE__ */ v("div", {
							className: "rounded-xl bg-slate-50 px-2.5 py-2",
							children: [/* @__PURE__ */ _("div", {
								className: "text-[10px] uppercase tracking-[0.14em] text-slate-400",
								children: "Avg Score"
							}), /* @__PURE__ */ _("div", {
								className: "mt-1 text-sm font-semibold text-slate-900",
								children: typeof tt == "number" ? tt.toFixed(0) : "--"
							})]
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-2 flex flex-wrap gap-1.5 text-[11px] text-slate-500",
						children: [
							/* @__PURE__ */ v("span", { children: [ot.length, " visible"] }),
							/* @__PURE__ */ _("span", { children: "•" }),
							/* @__PURE__ */ v("span", { children: [et, " selected"] }),
							/* @__PURE__ */ _("span", { children: "•" }),
							/* @__PURE__ */ v("span", { children: [$e, " recommended"] }),
							/* @__PURE__ */ _("span", { children: "•" }),
							/* @__PURE__ */ _("span", { children: nt ? `Last run ${new Date(nt).toLocaleTimeString([], {
								hour: "2-digit",
								minute: "2-digit"
							})}` : "Never run" })
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-3 flex flex-wrap items-center gap-1.5",
						children: [/* @__PURE__ */ _("span", {
							className: "text-[11px] font-medium uppercase tracking-[0.12em] text-slate-400",
							children: "Scope"
						}), [
							r ? {
								key: "database",
								label: "Database"
							} : null,
							r ? {
								key: "table",
								label: "Table"
							} : null,
							n ? {
								key: "column",
								label: "Column"
							} : null
						].filter(Boolean).map((e) => /* @__PURE__ */ _("button", {
							onClick: () => ne(e.key),
							className: `rounded-full border px-2.5 py-1 text-[11px] font-medium transition ${W === e.key ? "border-sky-200 bg-sky-50 text-sky-700" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`,
							children: e.label
						}, e.key))]
					})
				]
			}),
			/* @__PURE__ */ v("section", {
				className: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm space-y-2.5",
				children: [
					/* @__PURE__ */ v("label", {
						className: "block",
						children: [/* @__PURE__ */ _("span", {
							className: "sr-only",
							children: "Search checks"
						}), /* @__PURE__ */ _("input", {
							value: H,
							onChange: (e) => ee(e.target.value),
							placeholder: "Search checks",
							className: "w-full rounded-xl border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700 outline-none transition focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
						})]
					}),
					/* @__PURE__ */ _("div", {
						className: "flex flex-wrap items-center gap-1.5",
						children: [
							{
								key: "all",
								label: `All ${qe.length}`
							},
							{
								key: "recommended",
								label: `Recommended ${$e}`
							},
							{
								key: "selected",
								label: `Selected ${et}`
							},
							{
								key: "column",
								label: "Column"
							},
							{
								key: "table",
								label: "Table"
							}
						].map((e) => /* @__PURE__ */ _("button", {
							onClick: () => te(e.key),
							className: `rounded-full border px-2.5 py-1 text-[11px] font-medium transition ${U === e.key ? "border-sky-200 bg-sky-50 text-sky-700" : "border-slate-200 bg-white text-slate-600 hover:bg-slate-50"}`,
							children: e.label
						}, e.key))
					}),
					/* @__PURE__ */ _("div", {
						className: "flex flex-wrap items-center gap-1",
						children: [
							"all",
							"pass",
							"fail",
							"unchecked"
						].map((e) => {
							let t = e === "all" ? `All ${Ye.length}` : e === "pass" ? `Pass ${Xe}` : e === "fail" ? `Fail ${Ze}` : `Unchecked ${Qe}`;
							return /* @__PURE__ */ _("button", {
								onClick: () => V(e),
								className: `rounded-full border px-2 py-0.5 text-[11px] font-medium transition-colors ${B === e ? e === "pass" ? "border-green-200 bg-green-50 text-green-700" : e === "fail" ? "border-red-200 bg-red-50 text-red-700" : "border-sky-200 bg-sky-50 text-sky-700" : "border-slate-200 bg-white text-slate-500 hover:bg-slate-50"}`,
								children: t
							}, e);
						})
					}),
					/* @__PURE__ */ v("div", {
						className: "flex flex-wrap gap-1.5",
						children: [
							/* @__PURE__ */ _("button", {
								onClick: ct,
								disabled: ot.length === 0,
								className: "rounded-full border border-slate-200 bg-white px-2.5 py-1 text-[11px] font-medium text-slate-700 hover:bg-slate-50 disabled:opacity-50",
								children: "Select Visible"
							}),
							/* @__PURE__ */ _("button", {
								onClick: lt,
								disabled: $e === 0,
								className: "rounded-full border border-emerald-200 bg-emerald-50 px-2.5 py-1 text-[11px] font-medium text-emerald-700 hover:bg-emerald-100 disabled:opacity-50",
								children: "Recommended"
							}),
							/* @__PURE__ */ _("button", {
								onClick: dt,
								disabled: Ze === 0,
								className: "rounded-full border border-rose-200 bg-rose-50 px-2.5 py-1 text-[11px] font-medium text-rose-700 hover:bg-rose-100 disabled:opacity-50",
								children: "Failed"
							})
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "flex flex-wrap items-center gap-1.5",
						children: [
							/* @__PURE__ */ _("button", {
								onClick: Ve,
								disabled: P.size === 0 || M,
								className: "flex items-center rounded-full bg-primary px-3 py-1.5 text-xs font-semibold text-white hover:bg-primary-dark focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-60",
								children: M && P.size > 0 ? /* @__PURE__ */ v(g, { children: [
									/* @__PURE__ */ _(Ma, { className: "mr-1 h-3 w-3 animate-spin" }),
									"Running (",
									P.size,
									")"
								] }) : /* @__PURE__ */ v(g, { children: [
									/* @__PURE__ */ _($o, { className: "mr-1 h-3 w-3" }),
									"Run (",
									P.size,
									")"
								] })
							}),
							/* @__PURE__ */ _("button", {
								onClick: He,
								disabled: M,
								className: "rounded-full border border-gray-300 bg-white px-3 py-1.5 text-xs font-semibold text-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-60",
								children: "Run All"
							}),
							We && /* @__PURE__ */ v("div", {
								className: "relative",
								children: [/* @__PURE__ */ v("button", {
									onClick: () => L(!I),
									className: "flex items-center rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-medium text-gray-600 hover:bg-gray-100 focus:outline-none focus:ring-1 focus:ring-gray-200",
									children: [
										/* @__PURE__ */ _(Oa, { className: "mr-1 h-3 w-3" }),
										"Export",
										/* @__PURE__ */ _(uo, { className: "ml-1 h-3 w-3" })
									]
								}), I && /* @__PURE__ */ v("div", {
									className: "absolute top-full right-0 z-20 mt-1 min-w-[80px] rounded border border-border bg-white shadow-lg",
									children: [/* @__PURE__ */ _("button", {
										onClick: () => {
											q("csv"), L(!1);
										},
										className: "w-full px-3 py-1.5 text-left text-xs hover:bg-gray-50 first:rounded-t last:rounded-b",
										children: "CSV"
									}), /* @__PURE__ */ _("button", {
										onClick: () => {
											q("json"), L(!1);
										},
										className: "w-full border-t border-gray-100 px-3 py-1.5 text-left text-xs hover:bg-gray-50 first:rounded-t last:rounded-b",
										children: "JSON"
									})]
								})]
							})
						]
					})
				]
			}),
			ut.length > 0 && /* @__PURE__ */ v("section", {
				className: "rounded-2xl border border-slate-200 bg-slate-50 p-3 shadow-sm",
				children: [/* @__PURE__ */ _("div", {
					className: "text-[11px] font-medium uppercase tracking-[0.12em] text-slate-500",
					children: "Related Higher-Scope Checks"
				}), /* @__PURE__ */ _("div", {
					className: "mt-3 space-y-2",
					children: ut.slice(0, 4).map((e) => {
						let t = my(e.checkType);
						return /* @__PURE__ */ v("div", {
							className: "flex items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-3 py-2",
							children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: e.ruleKind === "custom" ? "Custom rule" : t?.label ?? e.checkType
							}), /* @__PURE__ */ v("div", {
								className: "text-[11px] text-slate-500",
								children: [
									e.targetScopeType ?? "unknown",
									" scope",
									e.tableName ? ` • ${e.tableName}` : "",
									e.targetColumnName ? ` • ${e.targetColumnName}` : "",
									e.targetRowsetKey ? ` • ${e.targetRowsetKey}` : "",
									e.ruleKey ? ` • ${e.ruleKey}` : ""
								]
							})] }), /* @__PURE__ */ _("div", {
								className: `text-xs font-semibold ${e.status === "pass" ? "text-green-700" : "text-red-700"}`,
								children: e.status.toUpperCase()
							})]
						}, `${e.checkType}-${e.runAt}`);
					})
				})]
			}),
			/* @__PURE__ */ v("section", {
				className: "space-y-2",
				children: [
					/* @__PURE__ */ v("div", {
						className: "px-1 text-[11px] font-medium uppercase tracking-[0.12em] text-slate-400",
						children: ["Checks for this ", W]
					}),
					/* @__PURE__ */ v("div", {
						className: "px-1 text-xs text-slate-500",
						children: [
							"Showing checks that can run from this ",
							W,
							"."
						]
					}),
					ot.length === 0 ? /* @__PURE__ */ _("div", {
						className: "rounded-2xl border border-dashed border-slate-300 bg-white p-6 text-center text-sm text-slate-500",
						children: "No checks match the current search and filters."
					}) : /* @__PURE__ */ _("div", {
						className: "space-y-2",
						"data-testid": "quality-visible-checks",
						children: ot.map((e) => {
							let t = be(e.key), n = fe[e.key];
							return /* @__PURE__ */ v("div", {
								"data-testid": `quality-visible-check-${e.key}`,
								className: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm",
								children: [/* @__PURE__ */ v("div", {
									className: "flex items-start gap-2",
									children: [
										/* @__PURE__ */ _("button", {
											type: "button",
											onClick: () => me(e.key),
											disabled: M,
											"aria-pressed": P.has(e.key),
											"aria-label": `${P.has(e.key) ? "Deselect" : "Select"} ${e.label}`,
											className: `mt-0.5 inline-flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border text-[11px] font-semibold transition ${P.has(e.key) ? "border-sky-500 bg-sky-500 text-white" : "border-slate-200 bg-white text-slate-500 hover:border-slate-300 hover:text-slate-700"} disabled:opacity-50`,
											children: P.has(e.key) ? "✓" : "+"
										}),
										/* @__PURE__ */ v("button", {
											type: "button",
											onClick: () => de(e.key),
											className: "flex-1 text-left",
											children: [
												/* @__PURE__ */ v("div", {
													className: "flex flex-wrap items-center gap-1.5",
													children: [
														/* @__PURE__ */ _("span", {
															className: `rounded-full border px-2 py-0.5 text-[11px] font-semibold uppercase tracking-[0.16em] ${Y(t)}`,
															children: t
														}),
														/* @__PURE__ */ _("span", {
															className: `rounded-full px-2 py-0.5 text-xs font-semibold ${ft(n?.overallScore)}`,
															children: typeof n?.overallScore == "number" ? `Score ${n.overallScore.toFixed(0)}` : "No score"
														}),
														/* @__PURE__ */ _("span", {
															className: "rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600",
															children: e.isColumnScoped ? "Column" : "Table"
														}),
														e.supportsRowset && /* @__PURE__ */ _("span", {
															className: "rounded-full bg-amber-50 px-2 py-0.5 text-[11px] font-medium text-amber-700",
															children: "Rowset-ready"
														})
													]
												}),
												/* @__PURE__ */ _("div", {
													className: "mt-2 text-sm font-semibold leading-5 text-slate-900",
													children: e.label
												}),
												/* @__PURE__ */ _("div", {
													className: "mt-1 text-[11px] text-slate-500",
													children: e.dimensionTitle
												}),
												e.recommendedBecause && /* @__PURE__ */ v("div", {
													className: "mt-2 text-[11px] text-emerald-700",
													children: [
														"Recommended for this ",
														e.isColumnScoped ? "column" : "table",
														": ",
														e.recommendedBecause
													]
												})
											]
										}),
										/* @__PURE__ */ _("button", {
											type: "button",
											onClick: () => {
												F(new Set([e.key])), ze[e.key]?.();
											},
											disabled: M,
											className: "rounded-full border border-slate-200 bg-slate-50 px-3 py-1.5 text-xs font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-50",
											children: "Run"
										})
									]
								}), le[e.key] && /* @__PURE__ */ v("div", {
									className: "mt-3 border-t border-slate-100 pt-3 space-y-2",
									children: [/* @__PURE__ */ _(Iy, {
										resultData: A[e.key]?.data,
										error: A[e.key]?.error,
										persisted: n
									}), e.supportsRowset && l && Be[e.key] && /* @__PURE__ */ v("button", {
										type: "button",
										"data-testid": `run-on-cohort-dashboard-${e.key}`,
										onClick: () => Be[e.key](l),
										disabled: M,
										className: "flex items-center gap-1.5 rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1 text-[11px] font-medium text-blue-700 hover:bg-blue-100 disabled:opacity-50 transition-colors",
										children: [/* @__PURE__ */ _(Qa, { className: "w-3 h-3 flex-shrink-0" }), "Run on active cohort"]
									})]
								})]
							}, `dashboard-${e.key}`);
						})
					})
				]
			}),
			/* @__PURE__ */ v("details", {
				className: "rounded-2xl border border-slate-200 bg-white p-3 shadow-sm",
				children: [/* @__PURE__ */ v("summary", {
					className: "flex cursor-pointer list-none items-center justify-between gap-3 text-sm font-semibold text-slate-800",
					children: [/* @__PURE__ */ _("span", { children: "Advanced dimension map" }), /* @__PURE__ */ v("span", {
						className: "rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-600",
						children: [st.length, " dimensions"]
					})]
				}), /* @__PURE__ */ _("div", {
					className: "mt-3 space-y-2",
					children: st.map((e, t) => /* @__PURE__ */ v("section", {
						className: "rounded-xl border border-slate-100 bg-slate-50/70 p-3",
						children: [/* @__PURE__ */ v("div", {
							className: "mb-3 flex items-start justify-between gap-2",
							children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("h3", {
								className: "text-sm font-semibold text-primary",
								children: e.title
							}), /* @__PURE__ */ v("p", {
								className: "mt-1 text-[11px] text-slate-500",
								children: [
									e.items.length,
									" check",
									e.items.length === 1 ? "" : "s",
									" visible in this dimension"
								]
							})] }), /* @__PURE__ */ v("div", {
								className: "flex flex-wrap justify-end gap-1.5",
								children: [
									/* @__PURE__ */ v("span", {
										className: "rounded-full bg-green-50 px-2 py-0.5 text-[11px] font-medium text-green-700",
										children: [e.dimensionPass, " pass"]
									}),
									/* @__PURE__ */ v("span", {
										className: "rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-medium text-red-700",
										children: [e.dimensionFail, " fail"]
									}),
									/* @__PURE__ */ v("span", {
										className: "rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-medium text-slate-700",
										children: ["Avg ", typeof e.averageScore == "number" ? e.averageScore.toFixed(0) : "--"]
									})
								]
							})]
						}), e.items.length === 0 ? /* @__PURE__ */ _("p", {
							className: "text-xs text-gray-400 italic",
							children: "No checks match the current filters in this dimension."
						}) : /* @__PURE__ */ _("ul", {
							className: "space-y-2",
							children: e.items.map((e) => {
								let t = be(e.key), n = fe[e.key];
								return /* @__PURE__ */ _("li", {
									className: "rounded-xl border border-slate-100 bg-white px-3 py-2",
									children: /* @__PURE__ */ v("div", {
										className: "flex items-start gap-2",
										children: [/* @__PURE__ */ _("input", {
											type: "checkbox",
											checked: P.has(e.key),
											onChange: () => me(e.key),
											disabled: M,
											className: "mt-1 h-3.5 w-3.5 flex-shrink-0"
										}), /* @__PURE__ */ v("div", {
											className: "flex-1 min-w-0",
											children: [/* @__PURE__ */ v("div", {
												className: "flex items-start gap-2 cursor-pointer group",
												onClick: () => de(e.key),
												children: [/* @__PURE__ */ _(Fy, { checkStatus: t }), /* @__PURE__ */ v("div", {
													className: "min-w-0 flex-1",
													children: [/* @__PURE__ */ v("div", {
														className: "flex flex-wrap items-center gap-2",
														children: [
															/* @__PURE__ */ _("span", {
																className: "text-xs font-semibold leading-tight text-slate-800 group-hover:text-primary transition-colors",
																children: e.label
															}),
															/* @__PURE__ */ _("span", {
																className: `rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.16em] ${Y(t)}`,
																children: t
															}),
															e.supportsRowset && /* @__PURE__ */ _("span", {
																className: "rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-medium text-amber-700",
																children: "Rowset-ready"
															}),
															typeof n?.overallScore == "number" && /* @__PURE__ */ _("span", {
																className: `rounded-full px-2 py-0.5 text-[11px] font-semibold ${ft(n.overallScore)}`,
																children: n.overallScore.toFixed(0)
															})
														]
													}), /* @__PURE__ */ _("div", {
														className: "mt-1 text-[11px] text-slate-500",
														children: n?.runAt ? `Latest run ${new Date(n.runAt).toLocaleString()}` : "Not run yet"
													})]
												})]
											}), le[e.key] && /* @__PURE__ */ v("div", {
												className: "mt-2 ml-5 space-y-2",
												children: [/* @__PURE__ */ _(Iy, {
													resultData: A[e.key]?.data,
													error: A[e.key]?.error,
													persisted: n
												}), e.supportsRowset && l && Be[e.key] && /* @__PURE__ */ v("button", {
													type: "button",
													"data-testid": `run-on-cohort-${e.key}`,
													onClick: () => Be[e.key](l),
													disabled: M,
													className: "flex items-center gap-1.5 rounded-lg border border-blue-200 bg-blue-50 px-2.5 py-1 text-[11px] font-medium text-blue-700 hover:bg-blue-100 disabled:opacity-50 transition-colors",
													children: [/* @__PURE__ */ _(Qa, { className: "w-3 h-3 flex-shrink-0" }), "Run on active cohort"]
												})]
											})]
										})]
									})
								}, e.key);
							})
						})]
					}, t))
				})]
			})
		]
	});
}, Ry = ({ isOpen: e, onClose: t, animationDuration: n = 300, side: r = "right" }) => {
	let i = m(e), [a, o] = h(e), [c, l] = h(!1), d = m(null), f = m(!1), p = m(!1), g = s(() => {
		d.current &&= (clearTimeout(d.current), null);
	}, []), _ = s((e) => {
		e && "stopPropagation" in e && e.stopPropagation(), t(), f.current = !0, p.current = !0, l(!0), g(), d.current = setTimeout(() => {
			o(!1), l(!1), f.current = !1, p.current = !1, d.current = null;
		}, n);
	}, [
		t,
		g,
		n
	]);
	return u(() => {
		e && !i.current ? (g(), f.current = !1, p.current = !1, l(!1), o(!0)) : !e && i.current && !f.current ? p.current || (f.current = !0, l(!0), g(), d.current = setTimeout(() => {
			o(!1), l(!1), f.current = !1, d.current = null;
		}, n)) : e && c && (!p.current || !f.current) && (l(!1), g()), i.current = e;
	}, [
		e,
		c,
		g,
		n
	]), u(() => () => {
		g();
	}, [g]), {
		shouldRender: a,
		isAnimatingOut: c,
		handleClose: _,
		panelStyle: s((e, t) => ({
			width: t || "280px",
			transform: c ? `translateX(${e === "left" ? "-100%" : "100%"})` : "translateX(0)",
			transition: `transform ${n}ms ease-out`
		}), [c, n])(r)
	};
}, zy = a(({ isOpen: e, onClose: t, stats: n, isLoading: r, columnName: i, tableName: a, databaseId: o, tableData: s, numericColumns: c, filters: l, sampling: d, initialTab: f = "statistics", onTabChange: p, activeCohortName: g, activeCohortRowsetKey: b, auditSummary: x, auditReports: S, auditRuleCount: C, auditLoading: w, auditError: T, onGenerateAuditReport: E, onDownloadAuditReport: D, onRefreshAudit: O }) => {
	let [k, A] = h(f), j = m(f), M = m(document.body), N = m(0), P = m(0), { shouldRender: F, isAnimatingOut: I, handleClose: L, panelStyle: R } = Ry({
		isOpen: e,
		onClose: t,
		animationDuration: 400,
		side: "right"
	}), z = {
		...R,
		transform: I ? "translateX(100%)" : "translateX(0)"
	}, B = (e, t) => {
		if (process.env.NODE_ENV !== "development") return;
		let n = Date.now();
		n - P.current > 1e3 && (console.log(e, t || ""), P.current = n);
	};
	if (u(() => {
		if (!e) return;
		let t = (e) => {
			e.key === "Escape" && L(e);
		};
		return document.addEventListener("keydown", t), () => {
			document.removeEventListener("keydown", t);
		};
	}, [e, L]), u(() => {
		let t = document.body;
		return e ? t.classList.add("stats-panel-open") : t.classList.remove("stats-panel-open"), () => {
			t.classList.remove("stats-panel-open");
		};
	}, [e]), u(() => {
		f && (A(f), j.current = f);
	}, [f]), !F || !M.current) return null;
	N.current++, N.current % 10 == 1 && B(`StatsSidePanel rendering with isOpen: ${e}, renderCount: ${N.current}`);
	let V = (e) => {
		e.stopPropagation(), L(e);
	};
	try {
		return y.createPortal(/* @__PURE__ */ v("div", {
			className: "fixed top-0 right-0 h-full shadow-xl z-[990] bg-background text-text transition-transform duration-400",
			style: { ...z },
			"data-testid": "stats-side-panel",
			children: [
				/* @__PURE__ */ _("div", {
					className: "absolute -left-4 top-1/2 -translate-y-1/2 shadow-md rounded-l-md p-1 cursor-pointer bg-background-light",
					onClick: V,
					"data-testid": "stats-panel-collapse",
					children: /* @__PURE__ */ _(po, { className: "w-5 h-5 hover:text-primary text-primary" })
				}),
				/* @__PURE__ */ v("div", {
					className: "p-3 flex justify-between items-center bg-background-dark text-text",
					children: [/* @__PURE__ */ _("div", {
						className: "flex flex-col",
						children: /* @__PURE__ */ _("h3", {
							className: "font-medium text-sm text-primary",
							children: "Analysis "
						})
					}), /* @__PURE__ */ _("button", {
						onClick: V,
						className: "transition-colors p-1 rounded hover:bg-background-dark",
						"data-testid": "stats-panel-close-button",
						children: /* @__PURE__ */ _(xs, { className: "w-5 h-5 text-muted-dark" })
					})]
				}),
				/* @__PURE__ */ v("div", {
					className: "flex border-b bg-background-light border-border-light",
					children: [/* @__PURE__ */ v("button", {
						className: `flex-1 py-2 text-sm font-medium flex items-center justify-center ${k === "statistics" ? "border-b-2 border-primary text-primary bg-background" : "text-muted-dark bg-background-light"}`,
						onClick: () => {
							A("statistics"), j.current = "statistics", p && p("statistics");
						},
						"data-testid": "statistics-tab-button",
						children: [/* @__PURE__ */ _(io, { className: `h-4 w-4 mr-2 ${k === "statistics" ? "text-primary" : "text-muted-dark"}` }), "Statistics"]
					}), /* @__PURE__ */ v("button", {
						className: `flex-1 py-2 text-sm font-medium flex items-center justify-center ${k === "quality" ? "border-b-2 border-primary text-primary bg-background" : "text-muted-dark bg-background-light"}`,
						onClick: () => {
							A("quality"), j.current = "quality", p && p("quality");
						},
						"data-testid": "quality-tab-button",
						children: [/* @__PURE__ */ _(ss, { className: `h-4 w-4 mr-2 ${k === "quality" ? "text-primary" : "text-muted-dark"}` }), "Quality"]
					})]
				}),
				/* @__PURE__ */ v("div", {
					className: "flex-1 overflow-y-auto p-4 custom-scrollbar",
					style: {
						height: "calc(100% - 154px)",
						backgroundColor: "var(--color-background)"
					},
					children: [/* @__PURE__ */ v("div", {
						className: "mb-4 space-y-2",
						children: [/* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _("span", {
								className: "text-xs font-medium text-muted-dark",
								children: "Column:"
							}), /* @__PURE__ */ _("span", {
								className: "text-xs ml-2 text-text",
								children: i
							})]
						}), n?.type && /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _("span", {
								className: "text-xs font-medium text-muted-dark",
								children: "Type:"
							}), /* @__PURE__ */ _("span", {
								className: "text-xs ml-2 text-info-dark",
								children: n.type === "numeric" ? "Numeric" : n.type === "date" ? "Date" : "Categorical"
							})]
						})]
					}), !I && /* @__PURE__ */ _("div", {
						className: "mt-4",
						children: k === "statistics" ? /* @__PURE__ */ _(G_, {
							stats: n,
							isLoading: r,
							columnName: i,
							tableName: a,
							tableData: s,
							numericColumns: c
						}) : /* @__PURE__ */ _(Ly, {
							stats: n,
							isLoading: r,
							columnName: i,
							tableName: a,
							databaseId: o || n?.metadata?.databaseId,
							filters: l,
							sampling: d,
							tableData: s,
							activeCohortName: g,
							activeCohortRowsetKey: b,
							auditSummary: x,
							auditReports: S,
							auditRuleCount: C,
							auditLoading: w,
							auditError: T,
							onGenerateAuditReport: E,
							onDownloadAuditReport: D,
							onRefreshAudit: O
						})
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "p-3 flex justify-end absolute bottom-0 w-full bg-background-dark border-t border-border-light",
					children: /* @__PURE__ */ _("button", {
						className: "px-3 py-1 rounded transition-colors bg-primary text-background hover:bg-primary-dark",
						onClick: V,
						"data-testid": "stats-panel-footer-close",
						children: "Close"
					})
				})
			]
		}), M.current);
	} catch (e) {
		return console.error("Error rendering StatsSidePanel portal:", e), null;
	}
}, (e, t) => !(e.isOpen !== t.isOpen || e.isLoading !== t.isLoading || e.initialTab !== t.initialTab || t.isOpen && e.columnName !== t.columnName || t.isOpen && e.stats !== t.stats || t.isOpen && e.tableData !== t.tableData || t.isOpen && JSON.stringify(e.numericColumns) !== JSON.stringify(t.numericColumns) || t.isOpen && JSON.stringify(e.filters) !== JSON.stringify(t.filters) || t.isOpen && JSON.stringify(e.sampling?.samplingState) !== JSON.stringify(t.sampling?.samplingState) || e.activeCohortName !== t.activeCohortName || e.activeCohortRowsetKey !== t.activeCohortRowsetKey || e.auditSummary !== t.auditSummary || e.auditReports !== t.auditReports || e.auditRuleCount !== t.auditRuleCount || e.auditLoading !== t.auditLoading || e.auditError !== t.auditError)), By = [
	"Identifiers",
	"Dates & Times",
	"Metadata",
	"Numeric Values",
	"Other Details"
], Vy = {
	Identifiers: Vo,
	"Dates & Times": eo,
	Metadata: _o,
	"Numeric Values": zo,
	"Other Details": Do
}, Hy = 25, Uy = 250;
function Wy(e) {
	return e == null || e === "";
}
function Gy(e, t) {
	return typeof e == "string" || typeof e == "number" ? String(e) : t.replace(/_/g, " ");
}
function Ky(e, t) {
	return e === t || e === "rowid" || /^id$/i.test(e);
}
function qy(e) {
	return /^id$/i.test(e) || /(^|_)id$/i.test(e) || /uuid|guid|key|code|slug/i.test(e);
}
function Jy(e) {
	return /date|time|created|updated|modified|timestamp/i.test(e);
}
function Yy(e) {
	return /meta|type|format|version|status|state|config|source|owner|priority/i.test(e);
}
function Xy(e) {
	return /count|sum|total|amount|price|cost|number|quantity|score|rate|percent|pct|rows|size|duration/i.test(e);
}
function Zy(e, t) {
	return typeof e == "boolean" || /^is_|^has_|_flag$|enabled|active|disabled|bool/i.test(t) ? !0 : typeof e == "string" && /^(true|false|yes|no)$/i.test(e.trim());
}
function Qy(e, t, n) {
	let r = n?.[e];
	return r && r !== "media" ? r : typeof t == "number" ? "numerical" : Jy(e) || t instanceof Date || typeof t == "string" && t.includes("-") && Number.isFinite(Date.parse(t)) ? "date" : "categorical";
}
function $y(e, t, n) {
	let r = Qy(e, t, n);
	return qy(e) ? "Identifiers" : r === "date" || Jy(e) ? "Dates & Times" : r === "numerical" || typeof t == "number" || Xy(e) ? "Numeric Values" : Yy(e) || Zy(t, e) ? "Metadata" : "Other Details";
}
function eb(e) {
	if (e && typeof e == "object") return !0;
	if (typeof e != "string") return !1;
	let t = e.trim();
	return t.startsWith("{") && t.endsWith("}") || t.startsWith("[") && t.endsWith("]");
}
function tb(e, t, n, r, i, a, o) {
	if (Ky(e, i)) return "primary";
	if (Zy(t, e)) return "boolean";
	let s = Qy(e, t, a);
	return s === "date" ? /time|timestamp|created|updated|modified/i.test(e) ? "datetime" : "date" : s === "numerical" ? "number" : o && (n === "Identifiers" || n === "Metadata" || s === "categorical") ? "reference" : eb(t) ? "json" : typeof t == "string" && t.length > 90 || r === "create" && /notes|description|comment|details/i.test(e) ? "textarea" : "text";
}
function nb(e, t) {
	let n = /* @__PURE__ */ new Set(), r = [];
	return t?.forEach((t) => {
		t in e && (r.push([t, e[t]]), n.add(t));
	}), Object.entries(e).forEach(([e, t]) => {
		n.has(e) || r.push([e, t]);
	}), r;
}
function rb(e, t) {
	if (t == null || t === "") return "—";
	if (Jy(e) && Number.isFinite(Date.parse(String(t)))) return new Date(String(t)).toLocaleString();
	if (typeof t == "boolean") return t ? "Yes" : "No";
	if (typeof t == "number") return t.toLocaleString();
	if (typeof t == "object") try {
		return JSON.stringify(t, null, 2);
	} catch {
		return String(t);
	}
	if (eb(t)) try {
		return JSON.stringify(JSON.parse(String(t)), null, 2);
	} catch {
		return String(t);
	}
	return String(t);
}
function ib(e, t) {
	if (Wy(e)) return "";
	let n = new Date(String(e));
	if (Number.isNaN(n.getTime())) return String(e);
	let r = (e) => String(e).padStart(2, "0"), i = n.getFullYear(), a = r(n.getMonth() + 1), o = r(n.getDate());
	return t ? `${i}-${a}-${o}T${r(n.getHours())}:${r(n.getMinutes())}` : `${i}-${a}-${o}`;
}
function ab(e, t) {
	if (e.kind === "number") {
		if (Wy(t)) return null;
		let e = Number(t);
		return Number.isFinite(e) ? e : t;
	}
	if (e.kind === "boolean") return !!t;
	if ((e.kind === "json" || typeof e.value == "object") && typeof t == "string") {
		if (!t.trim()) return null;
		try {
			return JSON.parse(t);
		} catch {
			return t;
		}
	}
	return (e.kind === "date" || e.kind === "datetime") && Wy(t) ? null : t;
}
function ob(e) {
	return e.map((e) => typeof e == "string" ? {
		value: e,
		label: e
	} : {
		value: String(e.value),
		label: e.label ?? String(e.value),
		description: e.description
	});
}
function sb({ column: e, value: t, disabled: n, onChange: r, loadOptions: i, rowData: a, mode: o, inputClassName: s }) {
	let [c, l] = h(!1), [d, p] = h(!1), [g, y] = h([]), b = m(/* @__PURE__ */ new Map()), x = f(() => `datagrid-reference-${e.replace(/[^a-z0-9_-]/gi, "-")}`, [e]), S = t == null ? "" : String(t);
	return u(() => {
		if (!c || !i || n) return;
		let r = S.trim(), s = `${e}::${r.toLowerCase()}`, l = b.current.get(s);
		if (l) {
			y(l);
			return;
		}
		let u = !1;
		p(!0);
		let d = window.setTimeout(async () => {
			try {
				let n = await i({
					column: e,
					searchTerm: r,
					limit: Hy,
					currentValue: t,
					rowData: a,
					mode: o
				});
				if (u) return;
				let c = ob(n).slice(0, Hy);
				b.current.set(s, c), y(c);
			} catch {
				u || y([]);
			} finally {
				u || p(!1);
			}
		}, Uy);
		return () => {
			u = !0, window.clearTimeout(d);
		};
	}, [
		e,
		n,
		c,
		i,
		o,
		a,
		S,
		t
	]), /* @__PURE__ */ v("div", {
		className: "space-y-1",
		children: [
			/* @__PURE__ */ _("input", {
				type: "text",
				list: x,
				value: S,
				disabled: n,
				onFocus: () => l(!0),
				onBlur: () => l(!1),
				onChange: (e) => r(e.target.value),
				className: s,
				"data-datagrid-row-click-ignore": "true"
			}),
			/* @__PURE__ */ _("datalist", {
				id: x,
				children: g.map((t) => /* @__PURE__ */ _("option", {
					value: t.value,
					children: t.description ? `${t.label} - ${t.description}` : t.label
				}, `${e}-${t.value}`))
			}),
			c && (d || g.length > 0) ? /* @__PURE__ */ _("div", {
				className: "text-[11px] text-text-light",
				children: d ? "Searching references" : `${g.length} reference matches`
			}) : null
		]
	});
}
var cb = ({ isOpen: e, onClose: t, rowData: n, title: r = "Row Details", mode: i = "view", onSave: a, columns: o, columnTypes: s = {}, columnLabels: c = {}, idField: l, loadReferenceOptions: d }) => {
	let [p, m] = h(""), [g, y] = h("All"), [b, x] = h({}), [S, C] = h(!1), [w, T] = h(null);
	u(() => {
		if (!n) {
			x({});
			return;
		}
		m(""), y("All"), x({ ...n }), T(null);
	}, [n, i]);
	let E = i === "view" ? n ?? {} : b, D = f(() => nb(E, o).map(([e, t]) => {
		let n = $y(e, t, s), r = tb(e, t, n, i, l, s, !!d), a = c[e], o = Gy(a, e);
		return {
			key: e,
			value: t,
			label: a ?? o,
			labelText: o,
			category: n,
			kind: r,
			readOnly: r === "primary"
		};
	}), [
		E,
		c,
		s,
		o,
		l,
		d,
		i
	]), O = f(() => {
		if (!n) return null;
		let e = D.length, t = D.filter((e) => !Wy(E[e.key])).length;
		return {
			fieldsCount: e,
			nonEmptyFieldsCount: t,
			completeness: e > 0 ? t / e * 100 : 0
		};
	}, [
		E,
		D,
		n
	]), k = f(() => {
		let e = /* @__PURE__ */ new Map();
		return e.set("All", D.length), By.forEach((t) => e.set(t, 0)), D.forEach((t) => {
			e.set(t.category, (e.get(t.category) ?? 0) + 1);
		}), e;
	}, [D]), A = f(() => {
		let e = p.trim().toLowerCase();
		return D.filter((t) => {
			if (g !== "All" && t.category !== g) return !1;
			if (!e) return !0;
			let n = E[t.key];
			return t.key.toLowerCase().includes(e) || t.labelText.toLowerCase().includes(e) || String(n ?? "").toLowerCase().includes(e);
		});
	}, [
		g,
		E,
		D,
		p
	]), j = f(() => By.map((e) => ({
		name: e,
		fields: A.filter((t) => t.category === e).map((e) => [e.key, E[e.key]]),
		isOpen: !0
	})).filter((e) => e.fields.length > 0), [E, A]), M = (e, t) => {
		x((n) => ({
			...n,
			[e]: t
		}));
	}, N = async () => {
		if (a) try {
			C(!0), T(null);
			let e = new Map(D.map((e) => [e.key, e]));
			await a(Object.fromEntries(Object.entries(b).map(([t, n]) => {
				let r = e.get(t);
				return [t, r ? ab(r, n) : n];
			}))) ? t() : T("Failed to save changes");
		} catch (e) {
			T("An error occurred while saving"), console.error("Save error:", e);
		} finally {
			C(!1);
		}
	}, P = () => {
		if (!O) return null;
		let e = O.completeness < 70 ? "bg-error-light" : O.completeness < 90 ? "bg-warning-light" : "bg-success-dark";
		return /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("div", {
			className: "mb-1 flex justify-between text-xs",
			children: [/* @__PURE__ */ v("span", {
				className: "font-medium text-text-light",
				children: [
					"Data Completeness: ",
					O.completeness.toFixed(0),
					"%"
				]
			}), /* @__PURE__ */ v("span", {
				className: "text-text-light",
				children: [
					O.nonEmptyFieldsCount,
					"/",
					O.fieldsCount,
					" fields"
				]
			})]
		}), /* @__PURE__ */ _("div", {
			className: "h-1.5 w-full rounded-full bg-muted-light",
			children: /* @__PURE__ */ _("div", {
				className: `h-1.5 rounded-full transition-all duration-300 ${e}`,
				style: { width: `${O.completeness}%` }
			})
		})] });
	}, F = (e) => {
		let t = "w-full rounded-md border px-3 py-2 text-sm outline-none transition focus:ring-2 focus:ring-primary disabled:cursor-not-allowed disabled:opacity-70";
		return e.category === "Dates & Times" ? `${t} border-form-date-input-border bg-form-date-input-bg text-form-date-input-text` : e.category === "Numeric Values" || e.category === "Identifiers" ? `${t} border-form-numeric-input-border bg-form-numeric-input-bg text-form-numeric-input-text` : `${t} border-form-categorical-input-border bg-form-categorical-input-bg text-form-categorical-input-text`;
	}, I = (e) => {
		let t = b[e.key], r = F(e), a = e.readOnly;
		if (e.kind === "boolean") return /* @__PURE__ */ v("label", {
			className: "flex min-h-[2.5rem] items-center gap-2 rounded-md border border-border-dark bg-background px-3 text-sm text-text",
			children: [/* @__PURE__ */ _("input", {
				type: "checkbox",
				checked: !!t,
				disabled: a,
				onChange: (t) => M(e.key, t.target.checked),
				className: "h-4 w-4 accent-primary",
				"data-datagrid-row-click-ignore": "true"
			}), /* @__PURE__ */ _("span", { children: t ? "Yes" : "No" })]
		});
		if (e.kind === "number") return /* @__PURE__ */ _("input", {
			type: "number",
			step: "any",
			value: t ?? "",
			disabled: a,
			onChange: (t) => M(e.key, t.target.value),
			className: r,
			"data-datagrid-row-click-ignore": "true"
		});
		if (e.kind === "date" || e.kind === "datetime") {
			let n = e.kind === "datetime";
			return /* @__PURE__ */ _("input", {
				type: n ? "datetime-local" : "date",
				value: ib(t, n),
				disabled: a,
				onChange: (t) => M(e.key, t.target.value),
				className: r,
				"data-datagrid-row-click-ignore": "true"
			});
		}
		return e.kind === "reference" ? /* @__PURE__ */ _(sb, {
			column: e.key,
			value: t,
			disabled: a,
			onChange: (t) => M(e.key, t),
			loadOptions: d,
			rowData: n,
			mode: i,
			inputClassName: r
		}) : e.kind === "json" || e.kind === "textarea" ? /* @__PURE__ */ _("textarea", {
			value: e.kind === "json" && typeof t == "object" ? rb(e.key, t) : t ?? "",
			disabled: a,
			onChange: (t) => M(e.key, t.target.value),
			rows: e.kind === "json" ? 5 : 3,
			className: `${r} resize-y`,
			"data-datagrid-row-click-ignore": "true"
		}) : /* @__PURE__ */ _("input", {
			type: "text",
			value: t ?? "",
			disabled: a,
			onChange: (t) => M(e.key, t.target.value),
			className: r,
			"data-datagrid-row-click-ignore": "true"
		});
	}, L = (e) => {
		let t = k.get(e) ?? 0, n = g === e, r = e === "All" ? as : Vy[e];
		return /* @__PURE__ */ v("button", {
			type: "button",
			onClick: () => y(e),
			className: `inline-flex h-8 items-center gap-1.5 rounded-md border px-2.5 text-xs font-medium transition ${n ? "border-primary bg-primary text-background" : "border-border-dark bg-background-light text-text hover:bg-background-dark"}`,
			children: [
				/* @__PURE__ */ _(r, { className: "h-3.5 w-3.5" }),
				/* @__PURE__ */ _("span", { children: e }),
				/* @__PURE__ */ _("span", {
					className: n ? "text-background/80" : "text-text-light",
					children: t
				})
			]
		}, e);
	};
	if (!e || !n) return null;
	let R = i === "create" ? "Will be generated" : n.rowid === void 0 ? n[l ?? ""] ?? "Not available" : n.rowid, z = n.rowid === void 0 ? "Record ID" : "SQLite RowID";
	return /* @__PURE__ */ _("div", {
		className: "fixed inset-0 z-50 overflow-y-auto",
		role: "dialog",
		"aria-modal": "true",
		children: /* @__PURE__ */ v("div", {
			className: "flex min-h-screen items-center justify-center px-4 py-6 text-center",
			children: [/* @__PURE__ */ _("div", {
				className: "fixed inset-0 bg-background-dark/80 transition-opacity",
				onClick: t
			}), /* @__PURE__ */ v("div", {
				className: "relative z-50 flex max-h-[90vh] w-full max-w-5xl flex-col overflow-hidden rounded-lg bg-background text-left shadow-2xl",
				children: [
					/* @__PURE__ */ v("div", {
						className: "border-b border-border-dark bg-background px-5 py-4",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between",
								children: [/* @__PURE__ */ v("div", {
									className: "min-w-0",
									children: [/* @__PURE__ */ v("div", {
										className: "flex items-center gap-2",
										children: [/* @__PURE__ */ _("h2", {
											className: "truncate text-xl font-semibold text-text",
											children: r
										}), /* @__PURE__ */ _("span", {
											className: "rounded-md border border-border-dark bg-background-light px-2 py-0.5 text-xs font-medium text-text-light",
											children: i
										})]
									}), /* @__PURE__ */ v("div", {
										className: "mt-1 text-xs text-text-light",
										children: [/* @__PURE__ */ v("span", {
											className: "font-semibold",
											children: [z, ":"]
										}), /* @__PURE__ */ _("span", {
											className: "ml-1 font-mono text-primary",
											children: String(R)
										})]
									})]
								}), /* @__PURE__ */ v("div", {
									className: "flex min-w-0 items-center gap-2",
									children: [/* @__PURE__ */ v("div", {
										className: "relative min-w-[12rem] flex-1 lg:w-72",
										children: [/* @__PURE__ */ _(Go, { className: "pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-dark" }), /* @__PURE__ */ _("input", {
											type: "text",
											value: p,
											onChange: (e) => m(e.target.value),
											placeholder: "Search fields",
											className: "h-9 w-full rounded-md border border-border-dark bg-background-light pl-9 pr-3 text-sm text-text outline-none focus:ring-2 focus:ring-primary",
											"data-datagrid-row-click-ignore": "true"
										})]
									}), /* @__PURE__ */ _("button", {
										type: "button",
										onClick: t,
										className: "inline-flex h-9 w-9 items-center justify-center rounded-md border border-border-dark bg-background-light text-text-light transition hover:bg-background-dark hover:text-error-dark",
										"aria-label": "Close",
										children: /* @__PURE__ */ _(xs, { className: "h-5 w-5" })
									})]
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "mt-4 flex flex-wrap gap-2",
								children: [L("All"), By.map(L)]
							}),
							i === "view" ? null : /* @__PURE__ */ _("div", {
								className: "mt-4",
								children: P()
							})
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "min-h-0 overflow-y-auto bg-background-light px-5 py-4 modal-scrollbar",
						children: [
							w ? /* @__PURE__ */ _("div", {
								className: "mb-4 rounded-md border border-error-dark bg-error-light px-4 py-3 text-sm text-error-dark",
								children: w
							}) : null,
							O && i === "view" ? /* @__PURE__ */ v("div", {
								className: "mb-4 grid gap-3 md:grid-cols-[1.2fr_repeat(3,minmax(0,0.7fr))]",
								children: [
									/* @__PURE__ */ _("div", {
										className: "rounded-md border border-border-dark bg-background p-3",
										children: P()
									}),
									/* @__PURE__ */ v("div", {
										className: "rounded-md border border-border-dark bg-background p-3",
										children: [/* @__PURE__ */ _("div", {
											className: "text-lg font-semibold text-text",
											children: O.fieldsCount
										}), /* @__PURE__ */ _("div", {
											className: "text-xs text-text-light",
											children: "Total Fields"
										})]
									}),
									/* @__PURE__ */ v("div", {
										className: "rounded-md border border-border-dark bg-background p-3",
										children: [/* @__PURE__ */ _("div", {
											className: "text-lg font-semibold text-text",
											children: O.nonEmptyFieldsCount
										}), /* @__PURE__ */ _("div", {
											className: "text-xs text-text-light",
											children: "Populated"
										})]
									}),
									/* @__PURE__ */ v("div", {
										className: "rounded-md border border-border-dark bg-background p-3",
										children: [/* @__PURE__ */ _("div", {
											className: "text-lg font-semibold text-text",
											children: O.fieldsCount - O.nonEmptyFieldsCount
										}), /* @__PURE__ */ _("div", {
											className: "text-xs text-text-light",
											children: "Empty"
										})]
									})
								]
							}) : null,
							A.length === 0 ? /* @__PURE__ */ _("div", {
								className: "rounded-md border border-border-dark bg-background px-4 py-8 text-center text-sm text-text-light",
								children: "No matching fields found"
							}) : i === "view" ? /* @__PURE__ */ _("div", {
								className: "grid gap-2",
								children: A.map((e) => {
									let t = Vy[e.category];
									return /* @__PURE__ */ v("div", {
										className: "rounded-md border border-border-dark bg-background p-3",
										"data-testid": `view-field-${e.key}`,
										children: [/* @__PURE__ */ v("div", {
											className: "flex flex-wrap items-center justify-between gap-2",
											children: [/* @__PURE__ */ _("div", {
												className: "min-w-0 text-sm font-semibold text-text",
												children: e.label
											}), /* @__PURE__ */ v("span", {
												className: "inline-flex h-6 items-center gap-1 rounded-md border border-border-dark bg-background-light px-2 text-[11px] font-medium text-text-light",
												children: [/* @__PURE__ */ _(t, { className: "h-3 w-3" }), e.category]
											})]
										}), /* @__PURE__ */ _("div", {
											className: "mt-2 whitespace-pre-wrap break-words text-sm text-text",
											children: rb(e.key, e.value)
										})]
									}, e.key);
								})
							}) : /* @__PURE__ */ _("div", {
								className: "space-y-5",
								children: j.map((e) => {
									let t = Vy[e.name], n = e.fields.map(([e]) => A.find((t) => t.key === e)).filter((e) => !!e);
									return /* @__PURE__ */ v("section", {
										className: "rounded-md border border-border-dark bg-background",
										children: [/* @__PURE__ */ v("div", {
											className: "flex items-center gap-2 border-b border-border-dark px-4 py-3",
											children: [
												/* @__PURE__ */ _(t, { className: "h-4 w-4 text-primary" }),
												/* @__PURE__ */ _("h3", {
													className: "text-sm font-semibold text-text",
													children: e.name
												}),
												/* @__PURE__ */ _("span", {
													className: "text-xs text-text-light",
													children: e.fields.length
												})
											]
										}), /* @__PURE__ */ _("div", {
											className: "grid grid-cols-1 gap-3 p-4 md:grid-cols-2",
											children: n.map((e) => /* @__PURE__ */ v("label", {
												className: e.kind === "textarea" || e.kind === "json" ? "md:col-span-2" : "",
												children: [/* @__PURE__ */ v("div", {
													className: "mb-1 flex items-center justify-between gap-2",
													children: [/* @__PURE__ */ _("span", {
														className: "text-xs font-semibold text-text-light",
														children: e.label
													}), e.readOnly ? /* @__PURE__ */ _("span", {
														className: "rounded-md border border-border-dark bg-background-light px-2 py-0.5 text-[11px] text-text-light",
														children: "Locked"
													}) : null]
												}), I(e)]
											}, e.key))
										})]
									}, e.name);
								})
							})
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "flex justify-end gap-2 border-t border-border-dark bg-background px-5 py-3",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							className: "inline-flex h-9 items-center justify-center rounded-md border border-border-dark bg-background-light px-4 text-sm font-medium text-text transition hover:bg-background-dark focus:outline-none focus:ring-2 focus:ring-primary",
							onClick: t,
							children: i === "view" ? "Close" : "Cancel"
						}), (i === "edit" || i === "create") && a ? /* @__PURE__ */ _("button", {
							type: "button",
							className: `inline-flex h-9 items-center justify-center rounded-md border border-transparent bg-primary px-4 text-sm font-semibold text-background transition hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-primary ${S ? "cursor-not-allowed opacity-75" : ""}`,
							onClick: N,
							disabled: S,
							children: S ? "Saving..." : i === "create" ? "Create Record" : "Save Changes"
						}) : null]
					})
				]
			})]
		})
	});
}, lb = (e, t, n = "") => {
	if (!e || !Array.isArray(e) || e.length === 0) return [];
	let r = n.toLowerCase(), i = /* @__PURE__ */ new Set();
	return e.forEach((e) => {
		if (e[t] !== void 0 && e[t] !== null) {
			let a = String(e[t]);
			(!n || a.toLowerCase().includes(r)) && i.add(a);
		}
	}), Array.from(i);
}, ub = (e) => {
	if (!e) return {
		year: "",
		month: "",
		day: ""
	};
	let t = new Date(e);
	return {
		year: t.getFullYear().toString(),
		month: (t.getMonth() + 1).toString().padStart(2, "0"),
		day: t.getDate().toString().padStart(2, "0")
	};
}, db = (e) => {
	if (!e) return "";
	try {
		return new Date(e).toLocaleDateString();
	} catch {
		return "";
	}
}, fb = (e = 10) => {
	let t = (/* @__PURE__ */ new Date()).getFullYear();
	return Array.from({ length: 2 * e + 1 }, (n, r) => t - e + r);
}, pb = () => [
	{
		value: "01",
		label: "January"
	},
	{
		value: "02",
		label: "February"
	},
	{
		value: "03",
		label: "March"
	},
	{
		value: "04",
		label: "April"
	},
	{
		value: "05",
		label: "May"
	},
	{
		value: "06",
		label: "June"
	},
	{
		value: "07",
		label: "July"
	},
	{
		value: "08",
		label: "August"
	},
	{
		value: "09",
		label: "September"
	},
	{
		value: "10",
		label: "October"
	},
	{
		value: "11",
		label: "November"
	},
	{
		value: "12",
		label: "December"
	}
], mb = () => Array.from({ length: 31 }, (e, t) => {
	let n = t + 1;
	return {
		value: n < 10 ? `0${n}` : `${n}`,
		label: n
	};
}), hb = (e) => {
	let t = /* @__PURE__ */ new Date(), n = null, r = new Date(t);
	switch (e) {
		case "today":
			n = new Date(t);
			break;
		case "yesterday":
			n = new Date(t), n.setDate(t.getDate() - 1), r = new Date(n);
			break;
		case "last7days":
			n = new Date(t), n.setDate(t.getDate() - 6);
			break;
		case "last30days":
			n = new Date(t), n.setDate(t.getDate() - 29);
			break;
		case "thisMonth":
			n = new Date(t.getFullYear(), t.getMonth(), 1), r = new Date(t.getFullYear(), t.getMonth() + 1, 0);
			break;
		case "lastMonth":
			n = new Date(t.getFullYear(), t.getMonth() - 1, 1), r = new Date(t.getFullYear(), t.getMonth(), 0);
			break;
		case "thisYear":
			n = new Date(t.getFullYear(), 0, 1), r = new Date(t.getFullYear(), 11, 31);
			break;
		case "lastYear":
			n = new Date(t.getFullYear() - 1, 0, 1), r = new Date(t.getFullYear() - 1, 11, 31);
			break;
	}
	return {
		startDate: n,
		endDate: r
	};
}, gb = (e) => e ? e.toISOString().split("T")[0] : "", _b = ({ year: e, month: t, selectedDay: n, onDayClick: r }) => {
	let i = pb();
	if (!e || !t) return null;
	let a = parseInt(e), o = parseInt(t) - 1, s = new Date(a, o, 1).getDay(), c = new Date(a, o + 1, 0).getDate(), l = [];
	for (let e = 0; e < s; e++) l.push(/* @__PURE__ */ _("div", { className: "p-1" }, `empty-${e}`));
	for (let e = 1; e <= c; e++) {
		let t = e < 10 ? `0${e}` : `${e}`, i = n === t;
		l.push(/* @__PURE__ */ _("div", {
			className: `text-center text-xs p-1 cursor-pointer rounded-full 
          ${i ? "bg-datatype-date text-white border border-datatype-date-light" : "bg-form-date-input-bg text-form-date-input-text border border-form-date-input-border"}`,
			onClick: () => r(t),
			children: e
		}, `day-${e}`));
	}
	return /* @__PURE__ */ v("div", {
		className: "border rounded p-1 bg-form-date-bg border-form-date-border text-form-date-label",
		children: [/* @__PURE__ */ v("div", {
			className: "text-xs font-medium mb-1 text-center text-form-date-label",
			children: [
				i.find((e) => e.value === t)?.label,
				" ",
				e
			]
		}), /* @__PURE__ */ v("div", {
			className: "grid grid-cols-7 gap-0",
			children: [[
				"Su",
				"Mo",
				"Tu",
				"We",
				"Th",
				"Fr",
				"Sa"
			].map((e) => /* @__PURE__ */ _("div", {
				className: "text-center text-xs font-medium p-1 text-form-date-label opacity-80",
				children: e
			}, e)), l]
		})]
	});
}, vb = ({ activePreset: e, onPresetClick: t }) => /* @__PURE__ */ v("div", {
	className: "mb-3 bg-form-date-bg rounded p-2",
	children: [/* @__PURE__ */ _("div", {
		className: "text-xs font-medium mb-1 text-form-date-label",
		children: "Quick Ranges:"
	}), /* @__PURE__ */ _("div", {
		className: "flex flex-wrap gap-1",
		children: [
			{
				id: "today",
				label: "Today"
			},
			{
				id: "yesterday",
				label: "Yesterday"
			},
			{
				id: "last7days",
				label: "Last 7 Days"
			},
			{
				id: "last30days",
				label: "Last 30 Days"
			},
			{
				id: "thisMonth",
				label: "This Month"
			},
			{
				id: "lastMonth",
				label: "Last Month"
			},
			{
				id: "thisYear",
				label: "This Year"
			},
			{
				id: "lastYear",
				label: "Last Year"
			}
		].map((n) => /* @__PURE__ */ _("button", {
			className: `px-2 py-1 text-xs rounded border ${e === n.id ? "bg-datatype-date text-white border-datatype-date-light font-semibold" : "bg-form-date-input-bg text-form-date-input-text border-form-date-input-border font-normal"}`,
			onClick: () => t(n.id),
			children: n.label
		}, n.id))
	})]
}), yb = ({ column: e, rangeValues: t, onDateRangeChange: n, onApplyFilter: r }) => {
	let [i, a] = h(!1), [o, s] = h(null), c = fb(), l = pb(), u = mb(), d = ub(t.min), f = ub(t.max), p = (t, r, i) => {
		s(null);
		let a = t === "min" ? { ...d } : { ...f };
		r === "year" && (a.year = i), r === "month" && (a.month = i), r === "day" && (a.day = i), a.year && a.month && a.day && n(e, t, `${a.year}-${a.month}-${a.day}`);
	};
	return /* @__PURE__ */ v("div", {
		className: "relative p-2 bg-form-date-bg rounded border border-form-date-border",
		children: [
			/* @__PURE__ */ _(vb, {
				activePreset: o,
				onPresetClick: (t) => {
					s(t);
					let { startDate: r, endDate: i } = hb(t);
					r && (n(e, "min", gb(r)), n(e, "max", gb(i)));
				}
			}),
			/* @__PURE__ */ _("div", {
				className: "mb-3",
				children: /* @__PURE__ */ v("button", {
					className: "text-xs text-datatype-date hover:text-datatype-date-light flex items-center",
					onClick: () => a(!i),
					children: [/* @__PURE__ */ _(no, { className: "h-3 w-3 mr-1" }), i ? "Set Date" : "Calendar Mode"]
				})
			}),
			i ? /* @__PURE__ */ v(g, { children: [
				/* @__PURE__ */ v("div", {
					className: "mb-3",
					children: [/* @__PURE__ */ _("label", {
						className: "block text-xs mb-1 text-form-date-label",
						children: "Start Date:"
					}), /* @__PURE__ */ v("div", {
						className: "flex gap-1",
						children: [
							/* @__PURE__ */ v("select", {
								value: d.year,
								onChange: (e) => p("min", "year", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Year"
								}), c.map((e) => /* @__PURE__ */ _("option", {
									value: e,
									children: e
								}, e))]
							}),
							/* @__PURE__ */ v("select", {
								value: d.month,
								onChange: (e) => p("min", "month", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Month"
								}), l.map((e) => /* @__PURE__ */ _("option", {
									value: e.value,
									children: e.label
								}, e.value))]
							}),
							/* @__PURE__ */ v("select", {
								value: d.day,
								onChange: (e) => p("min", "day", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Day"
								}), u.map((e) => /* @__PURE__ */ _("option", {
									value: e.value,
									children: e.label
								}, e.value))]
							})
						]
					})]
				}),
				/* @__PURE__ */ v("div", {
					className: "mb-3",
					children: [/* @__PURE__ */ _("label", {
						className: "block text-xs mb-1 text-form-date-label",
						children: "End Date:"
					}), /* @__PURE__ */ v("div", {
						className: "flex gap-1",
						children: [
							/* @__PURE__ */ v("select", {
								value: f.year,
								onChange: (e) => p("max", "year", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Year"
								}), c.map((e) => /* @__PURE__ */ _("option", {
									value: e,
									children: e
								}, e))]
							}),
							/* @__PURE__ */ v("select", {
								value: f.month,
								onChange: (e) => p("max", "month", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Month"
								}), l.map((e) => /* @__PURE__ */ _("option", {
									value: e.value,
									children: e.label
								}, e.value))]
							}),
							/* @__PURE__ */ v("select", {
								value: f.day,
								onChange: (e) => p("max", "day", e.target.value),
								className: "w-1/3 border rounded px-1 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border",
								children: [/* @__PURE__ */ _("option", {
									value: "",
									children: "Day"
								}), u.map((e) => /* @__PURE__ */ _("option", {
									value: e.value,
									children: e.label
								}, e.value))]
							})
						]
					})]
				}),
				d.year && d.month && /* @__PURE__ */ _("div", {
					className: "mb-3",
					children: /* @__PURE__ */ _(_b, {
						year: d.year,
						month: d.month,
						selectedDay: d.day,
						onDayClick: (e) => p("min", "day", e)
					})
				})
			] }) : /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ v("div", {
				className: "mb-2",
				children: [/* @__PURE__ */ _("label", {
					className: "block text-xs mb-1 text-form-date-label",
					children: "Start Date:"
				}), /* @__PURE__ */ _("input", {
					type: "date",
					value: t.min || "",
					onChange: (t) => {
						n(e, "min", t.target.value), s(null);
					},
					className: "w-full border rounded px-2 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border"
				})]
			}), /* @__PURE__ */ v("div", {
				className: "mb-2",
				children: [/* @__PURE__ */ _("label", {
					className: "block text-xs mb-1 text-form-date-label",
					children: "End Date:"
				}), /* @__PURE__ */ _("input", {
					type: "date",
					value: t.max || "",
					onChange: (t) => {
						n(e, "max", t.target.value), s(null);
					},
					className: "w-full border rounded px-2 py-1 text-xs bg-form-date-input-bg text-form-date-input-text border-form-date-input-border"
				})]
			})] }),
			/* @__PURE__ */ _("div", {
				className: "flex justify-between items-center mt-2 mb-1 text-xs text-form-date-label",
				children: /* @__PURE__ */ v("span", { children: [
					db(t.min) || "Any",
					" to ",
					" ",
					db(t.max) || "Any"
				] })
			}),
			/* @__PURE__ */ _("button", {
				className: "w-full rounded px-2 py-1 text-xs mt-2 bg-datatype-date text-white hover:bg-datatype-date-light transition-colors",
				onClick: () => r(e),
				children: "Apply Filter"
			}),
			(t.min || t.max) && /* @__PURE__ */ _("button", {
				className: "w-full mt-1 text-xs text-error-dark hover:underline",
				onClick: () => {
					n(e, "min", ""), n(e, "max", ""), s(null);
				},
				children: "Clear Dates"
			})
		]
	});
}, bb = (e) => e == null || e === "" ? "" : Number(e).toLocaleString(), xb = (e, t, n) => {
	let r = (n ?? []).filter((e) => typeof e == "number" && !Number.isNaN(e)).sort((e, t) => e - t);
	if (r.length === 0) {
		let n = t - e, r = n / 4;
		return [
			{
				id: "all",
				label: "All Values",
				min: e,
				max: t
			},
			{
				id: "first-quarter",
				label: "First Quarter",
				min: e,
				max: e + r
			},
			{
				id: "second-quarter",
				label: "Second Quarter",
				min: e + r,
				max: e + 2 * r
			},
			{
				id: "third-quarter",
				label: "Third Quarter",
				min: e + 2 * r,
				max: e + 3 * r
			},
			{
				id: "fourth-quarter",
				label: "Fourth Quarter",
				min: e + 3 * r,
				max: t
			},
			{
				id: "above-avg",
				label: "Above Average",
				min: (e + t) / 2,
				max: t
			},
			{
				id: "below-avg",
				label: "Below Average",
				min: e,
				max: (e + t) / 2
			},
			{
				id: "top-10-percent",
				label: "Top 10%",
				min: t - n * .1,
				max: t
			},
			{
				id: "bottom-10-percent",
				label: "Bottom 10%",
				min: e,
				max: e + n * .1
			}
		];
	}
	let i = r.length, a = (e) => r[Math.max(0, Math.min(e, i - 1))], o = a(0), s = a(i - 1), c = Math.max(0, Math.ceil(i * .25) - 1), l = Math.min(i - 1, c + 1), u = Math.max(l, Math.ceil(i * .5) - 1), d = Math.min(i - 1, u + 1), f = Math.max(d, Math.ceil(i * .75) - 1), p = Math.min(i - 1, f + 1), m = Math.max(1, Math.ceil(i * .1)), h = Math.max(1, Math.ceil(i * .1)), g = r.reduce((e, t) => e + t, 0) / i;
	return [
		{
			id: "all",
			label: "All Values",
			min: o,
			max: s
		},
		{
			id: "first-quarter",
			label: "First Quarter",
			min: o,
			max: a(c)
		},
		{
			id: "second-quarter",
			label: "Second Quarter",
			min: a(l),
			max: a(u)
		},
		{
			id: "third-quarter",
			label: "Third Quarter",
			min: a(d),
			max: a(f)
		},
		{
			id: "fourth-quarter",
			label: "Fourth Quarter",
			min: a(p),
			max: s
		},
		{
			id: "above-avg",
			label: "Above Average",
			min: g,
			max: s
		},
		{
			id: "below-avg",
			label: "Below Average",
			min: o,
			max: g
		},
		{
			id: "top-10-percent",
			label: "Top 10%",
			min: a(i - m),
			max: s
		},
		{
			id: "bottom-10-percent",
			label: "Bottom 10%",
			min: o,
			max: a(h - 1)
		}
	];
}, Sb = (e, t) => [
	{
		id: "equals",
		label: "=",
		description: "Equal to"
	},
	{
		id: "greater-than",
		label: ">",
		description: "Greater than"
	},
	{
		id: "less-than",
		label: "<",
		description: "Less than"
	},
	{
		id: "greater-equal",
		label: "≥",
		description: "Greater than or equal to"
	},
	{
		id: "less-equal",
		label: "≤",
		description: "Less than or equal to"
	},
	{
		id: "between",
		label: "⟷",
		description: "Between (inclusive)"
	},
	{
		id: "not-equal",
		label: "≠",
		description: "Not equal to"
	}
], Cb = (e, t, n = 1, r = 10) => {
	let i = t - e, a = i > n * r ? Math.ceil(i / r) : n, o = [];
	for (let n = e; n <= t && o.length < r; n += a) o.push(Number(n.toFixed(2)));
	return o;
}, wb = ({ min: e, max: t, activePreset: n, onPresetClick: r, values: i }) => {
	let a = xb(e, t, i);
	return /* @__PURE__ */ v("div", {
		className: "mb-3 bg-form-numeric-bg rounded p-2",
		children: [/* @__PURE__ */ _("div", {
			className: "text-xs font-medium mb-1 text-form-numeric-label",
			children: "Quick Ranges:"
		}), /* @__PURE__ */ _("div", {
			className: "flex flex-wrap gap-1",
			children: a.map((e) => /* @__PURE__ */ _("button", {
				className: `px-2 py-1 text-xs rounded border ${n === e.id ? "bg-datatype-numeric text-white border-datatype-numeric-light" : "bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border"}`,
				onClick: () => r(e.id, e.min, e.max),
				title: `${bb(e.min)} to ${bb(e.max)}`,
				children: e.label
			}, e.id))
		})]
	});
}, Tb = ({ activeOperation: e, onOperationChange: t }) => {
	let n = Sb(0, 0);
	return /* @__PURE__ */ v("div", {
		className: "mb-3 bg-form-numeric-bg rounded p-2",
		children: [/* @__PURE__ */ _("div", {
			className: "text-xs font-medium mb-1 text-form-numeric-label",
			children: "Comparison:"
		}), /* @__PURE__ */ _("div", {
			className: "flex flex-wrap gap-1",
			children: n.map((n) => /* @__PURE__ */ _("button", {
				className: `px-2 py-1 text-xs rounded border ${e === n.id ? "bg-datatype-numeric text-white border-datatype-numeric-light" : "bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border"}`,
				onClick: () => t(n.id),
				title: n.description,
				children: n.label
			}, n.id))
		})]
	});
}, Eb = ({ min: e, max: t, selectedValue: n, onValueChange: r }) => {
	let i = Cb(e, t);
	return /* @__PURE__ */ v("div", {
		className: "mb-3 bg-form-numeric-bg rounded p-2",
		children: [/* @__PURE__ */ _("div", {
			className: "text-xs font-medium mb-1 text-form-numeric-label",
			children: "Common Values:"
		}), /* @__PURE__ */ _("div", {
			className: "flex flex-wrap gap-1",
			children: i.map((e) => /* @__PURE__ */ _("button", {
				className: `px-2 py-1 text-xs rounded border ${n === e ? "bg-datatype-numeric text-white border-datatype-numeric-light" : "bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border"}`,
				onClick: () => r(e),
				children: bb(e)
			}, e))
		})]
	});
}, Db = ({ value: e, onChange: t, step: n = 1, label: r }) => /* @__PURE__ */ v("div", {
	className: "mb-3",
	children: [/* @__PURE__ */ v("label", {
		className: "block text-xs mb-1 text-form-numeric-label",
		children: [r, ":"]
	}), /* @__PURE__ */ v("div", {
		className: "flex items-center",
		children: [
			/* @__PURE__ */ _("button", {
				className: "border rounded-l px-2 py-1 bg-form-numeric-input-bg text-datatype-numeric border-form-numeric-input-border",
				onClick: () => t(Number((e - n).toFixed(2))),
				children: /* @__PURE__ */ _(qo, { className: "h-3 w-3" })
			}),
			/* @__PURE__ */ _("input", {
				type: "number",
				value: e,
				onChange: (e) => t(Number(e.target.value)),
				className: "w-full border-t border-b px-2 py-1 text-xs text-center bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border",
				step: n
			}),
			/* @__PURE__ */ _("button", {
				className: "border rounded-r px-2 py-1 bg-form-numeric-input-bg text-datatype-numeric border-form-numeric-input-border",
				onClick: () => t(Number((e + n).toFixed(2))),
				children: /* @__PURE__ */ _(rs, { className: "h-3 w-3" })
			})
		]
	})]
}), Ob = ({ min: e, max: t, currentMin: n, currentMax: r, onChange: i }) => {
	let a = t - e, o = (n - e) / a * 100, s = (r - e) / a * 100;
	return /* @__PURE__ */ v("div", {
		className: "mb-4 px-2",
		children: [/* @__PURE__ */ v("div", {
			className: "relative h-6 pt-2",
			children: [
				/* @__PURE__ */ _("div", { className: "absolute h-1 w-full rounded bg-background-light" }),
				/* @__PURE__ */ _("div", {
					className: "absolute h-1 rounded bg-primary",
					style: {
						left: `${o}%`,
						width: `${s - o}%`
					}
				}),
				/* @__PURE__ */ _("div", {
					className: "absolute w-3 h-3 rounded-full border-2 border-white shadow cursor-pointer -mt-1 bg-primary",
					style: { left: `${o}%` }
				}),
				/* @__PURE__ */ _("div", {
					className: "absolute w-3 h-3 rounded-full border-2 border-white shadow cursor-pointer -mt-1 bg-primary",
					style: { left: `${s}%` }
				})
			]
		}), /* @__PURE__ */ v("div", {
			className: "flex justify-between text-xs mt-1 text-text-light",
			children: [/* @__PURE__ */ _("span", { children: bb(n) }), /* @__PURE__ */ _("span", { children: bb(r) })]
		})]
	});
}, kb = ({ column: e, rangeValues: t, onRangeChange: n, onApplyFilter: r, allValues: i, globalMin: a, globalMax: o }) => {
	let [s, c] = h(null), [l, d] = h(!1), [f, p] = h(t.operator ?? "between"), [m, y] = h(null), b = a ?? t.min, x = o ?? t.max, S = t.min, C = t.max;
	return u(() => {
		p(t.operator ?? "between");
	}, [t.operator]), /* @__PURE__ */ v("div", {
		className: "relative p-2 bg-form-numeric-bg rounded border border-form-numeric-border",
		children: [
			/* @__PURE__ */ _(wb, {
				min: b,
				max: x,
				activePreset: s,
				onPresetClick: (t, r, i) => {
					c(t), n(e, "min", r), n(e, "max", i);
				},
				values: i
			}),
			/* @__PURE__ */ _("div", {
				className: "mb-3",
				children: /* @__PURE__ */ v("button", {
					className: "text-xs flex items-center text-datatype-numeric bg-transparent hover:text-datatype-numeric-light",
					onClick: () => d(!l),
					children: [/* @__PURE__ */ _(wa, { className: "h-3 w-3 mr-1" }), l ? "Simple Mode" : "Advanced Mode"]
				})
			}),
			l ? /* @__PURE__ */ v(g, { children: [
				/* @__PURE__ */ _(Tb, {
					activeOperation: f,
					onOperationChange: (t) => {
						if (p(t), t !== "between") if (t === "equals" || t === "not-equal") {
							let t = (S + C) / 2;
							n(e, "min", t), n(e, "max", t);
						} else t === "greater-than" || t === "greater-equal" ? n(e, "max", x) : (t === "less-than" || t === "less-equal") && n(e, "min", b);
					}
				}),
				/* @__PURE__ */ _(Eb, {
					min: b,
					max: x,
					selectedValue: m,
					onValueChange: (t) => {
						y(t), n(e, "min", t), n(e, "max", t), p("equals");
					}
				}),
				(() => {
					switch (f) {
						case "equals":
						case "not-equal": return /* @__PURE__ */ _(Db, {
							value: S,
							onChange: (t) => {
								n(e, "min", t), n(e, "max", t);
							},
							label: f === "equals" ? "Equal to" : "Not equal to"
						});
						case "greater-than":
						case "greater-equal": return /* @__PURE__ */ _(Db, {
							value: S,
							onChange: (t) => n(e, "min", t),
							label: f === "greater-than" ? "Greater than" : "Greater than or equal to"
						});
						case "less-than":
						case "less-equal": return /* @__PURE__ */ _(Db, {
							value: C,
							onChange: (t) => n(e, "max", t),
							label: f === "less-than" ? "Less than" : "Less than or equal to"
						});
						default: return /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
							className: "flex items-center mb-2",
							children: /* @__PURE__ */ _(Db, {
								value: S,
								onChange: (t) => n(e, "min", t),
								label: "Minimum"
							})
						}), /* @__PURE__ */ _("div", {
							className: "flex items-center mb-2",
							children: /* @__PURE__ */ _(Db, {
								value: C,
								onChange: (t) => n(e, "max", t),
								label: "Maximum"
							})
						})] });
					}
				})(),
				f === "between" && /* @__PURE__ */ _(Ob, {
					min: b,
					max: x,
					currentMin: S,
					currentMax: C,
					onChange: (t, r) => n(e, t, r)
				})
			] }) : /* @__PURE__ */ _(g, { children: /* @__PURE__ */ v("div", {
				className: "flex items-center mb-2",
				children: [
					/* @__PURE__ */ _("input", {
						type: "number",
						value: S,
						onChange: (t) => n(e, "min", Number(t.target.value)),
						className: "w-1/2 border rounded px-2 py-1 text-xs mr-1 bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border",
						placeholder: "Min"
					}),
					/* @__PURE__ */ _("span", {
						className: "mx-1 text-xs text-form-numeric-label",
						children: "to"
					}),
					/* @__PURE__ */ _("input", {
						type: "number",
						value: C,
						onChange: (t) => n(e, "max", Number(t.target.value)),
						className: "w-1/2 border rounded px-2 py-1 text-xs ml-1 bg-form-numeric-input-bg text-form-numeric-input-text border-form-numeric-input-border",
						placeholder: "Max"
					})
				]
			}) }),
			/* @__PURE__ */ _("div", {
				className: "flex justify-between items-center mt-2 mb-1 text-xs text-form-numeric-label",
				children: /* @__PURE__ */ _("span", { children: f === "equals" ? `Equal to ${bb(S)}` : f === "not-equal" ? `Not equal to ${bb(S)}` : f === "greater-than" ? `Greater than ${bb(S)}` : f === "greater-equal" ? `Greater than or equal to ${bb(S)}` : f === "less-than" ? `Less than ${bb(C)}` : f === "less-equal" ? `Less than or equal to ${bb(C)}` : `${bb(S)} to ${bb(C)}` })
			}),
			/* @__PURE__ */ _("button", {
				className: "w-full rounded px-2 py-1 text-xs mt-2 bg-datatype-numeric text-white hover:bg-datatype-numeric-light transition-colors",
				onClick: () => r(e, {
					min: S,
					max: C,
					operator: f
				}),
				children: "Apply Filter"
			}),
			/* @__PURE__ */ _("button", {
				className: "w-full mt-1 text-xs text-error-dark bg-transparent hover:underline",
				onClick: () => {
					n(e, "min", b), n(e, "max", x), c(null), y(null), p("between");
				},
				children: "Reset Range"
			})
		]
	});
}, Ab = (e, t) => {
	if (!t.length) return "categorical";
	if ([
		/picture/i,
		/image/i,
		/photo/i,
		/avatar/i,
		/thumbnail/i,
		/\bpic\b/i,
		/\bicon\b/i,
		/\bblob\b/i,
		/binary/i
	].some((t) => t.test(e))) return "media";
	let n = t.find((t) => t[e] != null)?.[e];
	if (n != null && (typeof n == "object" && !Array.isArray(n) && !(n instanceof Date) || typeof n == "string" && /^(0x[0-9a-f]{20,}|data:image\/[a-z]+;base64,)/i.test(n.trim()))) return "media";
	let r = [
		/date/i,
		/data/i,
		/fecha/i,
		/time/i,
		/created_at/i,
		/updated_at/i,
		/timestamp/i
	].some((t) => t.test(e)), i = Math.min(10, t.length), a = !0, o = r, s = 0, c = t.slice(0, i).map((t) => t[e]);
	if (r && C_(c)) return "date";
	for (let n = 0; n < i && (a || o); n++) {
		let i = t[n][e];
		i != null && (typeof i != "number" && (a = !1), o && (x_(i) ? s++ : typeof i == "string" && r || (o = !1)));
	}
	return o && s >= Math.ceil(i / 2) ? "date" : a ? "numerical" : "categorical";
}, jb = (e, t = 50) => {
	if (e == null) return "";
	if (typeof e == "object") {
		if (e instanceof Date) return e.toLocaleDateString();
		if (Array.isArray(e)) {
			let n = e.join(", ");
			return n.length > t ? `${n.substring(0, t)}...` : n;
		}
		let n = JSON.stringify(e);
		return n.length > t ? `${n.substring(0, t)}...` : n;
	}
	let n = String(e);
	return n.length > t ? `${n.substring(0, t)}...` : n;
}, Mb = ({ column: e, uniqueValues: t, selectedValues: r, searchTerm: i, isLoading: a, error: o, searchHandler: c, handleInputFocus: l, handleInputBlur: d, handleCheckboxChange: p, handleSelectAll: m, handleApplyCategoricalFilter: g, fetchColumnValuesForColumn: y }) => {
	let b = `search-input-${e}`, x = n.useRef(null), [S, C] = h(i || "");
	n.useEffect(() => {
		!a && t.length === 0 && !o && y(e);
	}, []), n.useEffect(() => {
		C(i || "");
	}, [i]);
	let w = (e) => {
		C(e.target.value);
	}, T = (t) => {
		(t.key === "Enter" || t.key === "Tab") && (t.preventDefault(), c && c({ target: { value: S } }), y(e, S));
	}, [E, D] = h(!1), [O, k] = h({
		start: 0,
		end: 50
	});
	u(() => {
		t.length > 100 && D(!0);
	}, [t.length]);
	let A = f(() => E ? t.slice(O.start, O.end) : t, [
		t,
		E,
		O
	]), j = s((e) => {
		if (!E) return;
		let { scrollTop: n, scrollHeight: r, clientHeight: i } = e.currentTarget, a = Math.max(0, Math.floor(n / 32) - 10);
		k({
			start: a,
			end: Math.min(t.length, a + Math.ceil(i / 32) + 20)
		});
	}, [E, t.length]);
	return /* @__PURE__ */ v("div", {
		className: "flex flex-col gap-2 p-2 bg-form-categorical-bg rounded border border-form-categorical-border",
		children: [
			/* @__PURE__ */ v("div", {
				className: "relative mb-2",
				children: [
					/* @__PURE__ */ _("div", {
						className: "absolute left-2 top-1/2 transform -translate-y-1/2 pointer-events-none",
						children: /* @__PURE__ */ _("svg", {
							className: "w-3 h-3 text-form-categorical-label",
							xmlns: "http://www.w3.org/2000/svg",
							fill: "none",
							viewBox: "0 0 24 24",
							stroke: "currentColor",
							children: /* @__PURE__ */ _("path", {
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 2,
								d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
							})
						})
					}),
					/* @__PURE__ */ _("input", {
						id: b,
						ref: x,
						type: "text",
						value: S,
						onChange: w,
						onKeyDown: T,
						placeholder: "Type and press Enter to search...",
						className: "w-full pl-7 pr-6 py-1 border rounded text-xs bg-form-categorical-input-bg text-form-categorical-input-text border-form-categorical-input-border focus:outline-none focus:ring-1 focus:ring-datatype-categorical hover:border-form-categorical-label transition-colors",
						autoComplete: "off",
						spellCheck: "false"
					}),
					/* @__PURE__ */ _("button", {
						className: "absolute right-2 top-1/2 transform -translate-y-1/2 text-accent hover:opacity-80 transition-opacity",
						onClick: () => {
							c && c({ target: { value: S } }), y(e, S);
						},
						title: "Search",
						children: /* @__PURE__ */ _("svg", {
							xmlns: "http://www.w3.org/2000/svg",
							className: "h-4 w-4",
							viewBox: "0 0 20 20",
							fill: "currentColor",
							children: /* @__PURE__ */ _("path", {
								fillRule: "evenodd",
								d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
								clipRule: "evenodd"
							})
						})
					})
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex justify-between items-center mb-1",
				children: [/* @__PURE__ */ v("span", {
					className: "text-xs text-form-categorical-label",
					children: [r.size, " selected"]
				}), /* @__PURE__ */ _("button", {
					className: "text-datatype-categorical hover:text-datatype-categorical-light transition-colors text-xs",
					onClick: () => m(e),
					type: "button",
					disabled: a || t.length === 0,
					children: r.size === t.length && t.length > 0 ? "Deselect All" : "Select All"
				})]
			}),
			a ? /* @__PURE__ */ _("div", {
				className: "text-center py-2 flex items-center justify-center",
				children: /* @__PURE__ */ _(Ss, {
					width: "64px",
					height: "32px",
					message: "Loading values...",
					className: "scale-75"
				})
			}) : o ? /* @__PURE__ */ v("div", {
				className: "text-center py-2",
				children: [/* @__PURE__ */ _("p", {
					className: "text-xs text-error-dark",
					children: o
				}), t.length > 0 && o.includes("Cannot connect") ? /* @__PURE__ */ _("p", {
					className: "text-xs text-info-dark",
					children: "Using locally filtered data"
				}) : /* @__PURE__ */ _("button", {
					className: "text-xs text-info-dark underline hover:text-info transition-colors",
					onClick: () => y(e),
					children: "Try again"
				})]
			}) : /* @__PURE__ */ _("div", {
				className: "border rounded mb-2 max-h-40 overflow-y-auto border-form-categorical-border bg-form-categorical-bg",
				onScroll: j,
				children: A.length > 0 ? A.map((t, n) => {
					E && O.start + n;
					let i = jb(t), a = r.has(t);
					return /* @__PURE__ */ v("label", {
						className: `block px-2 py-1 text-xs cursor-pointer flex items-start ${a ? "bg-form-categorical-input-bg" : ""}`,
						title: i,
						children: [/* @__PURE__ */ _("input", {
							type: "checkbox",
							checked: a,
							onChange: () => p(e, t),
							className: "mr-2 mt-0.5 accent-datatype-categorical"
						}), /* @__PURE__ */ _("span", {
							className: "truncate text-form-categorical-input-text",
							children: i
						})]
					}, t);
				}) : /* @__PURE__ */ _("div", {
					className: "text-center py-2 text-xs text-form-categorical-label opacity-75",
					children: i ? "No matching values" : "No values available"
				})
			}),
			/* @__PURE__ */ _("button", {
				className: "w-full rounded px-2 py-1 text-xs bg-datatype-categorical text-white hover:bg-datatype-categorical-light transition-colors",
				onClick: () => g(e),
				disabled: r.size === 0 || a,
				children: "Apply Filter"
			})
		]
	});
}, Nb = D("FilterColumn"), Pb = ({ className: e = "", ...t }) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	className: `w-4 h-4 hover:opacity-80 transition-opacity ${e}`,
	...t,
	children: /* @__PURE__ */ v("g", {
		transform: "translate(1.5, 4)",
		children: [/* @__PURE__ */ _("text", {
			x: "0",
			y: "8",
			fontSize: "9",
			fontWeight: "bold",
			fontFamily: "monospace",
			fill: "currentColor",
			children: "123"
		}), /* @__PURE__ */ _("line", {
			x1: "0",
			y1: "11",
			x2: "15",
			y2: "11",
			stroke: "currentColor",
			strokeWidth: "1"
		})]
	})
}), Fb = ({ column: e, rangeValues: t, handleRangeInputChange: n, handleApplyNumericFilter: r, allValues: i }) => /* @__PURE__ */ _(kb, {
	column: e,
	rangeValues: t,
	onRangeChange: n,
	onApplyFilter: r,
	allValues: i
}), Ib = ({ column: e, rangeValues: t, handleDateRangeInputChange: n, handleApplyDateFilter: r }) => /* @__PURE__ */ _(yb, {
	column: e,
	rangeValues: t,
	onDateRangeChange: n,
	onApplyFilter: r
}), Lb = ({ column: e, isExpanded: t, hasActiveFilter: r, filterType: i, toggleColumnExpansion: a, clearFilter: o, openStatsPanel: s, renderFilterControls: c }) => {
	let [l, u] = n.useState(null), d = n.useCallback((e) => {
		Nb.error("Filter component error:", e), u(e.message);
	}, []), f = n.useCallback((e) => {
		try {
			return c(e);
		} catch (e) {
			return d(e), /* @__PURE__ */ v("div", {
				className: "p-2 text-error-dark",
				children: [/* @__PURE__ */ v("p", {
					className: "text-xs",
					children: ["Filter error: ", l]
				}), /* @__PURE__ */ _("button", {
					onClick: () => u(null),
					className: "text-xs underline",
					children: "Reset"
				})]
			});
		}
	}, [
		c,
		l,
		d
	]), p = (() => {
		switch (i) {
			case "numerical": return Pb;
			case "date": return no;
			default: return io;
		}
	})(), m = ((e) => {
		switch (e) {
			case "numerical": return "text-datatype-numeric";
			case "date": return "text-datatype-date";
			default: return "text-datatype-categorical";
		}
	})(i);
	return /* @__PURE__ */ v("div", {
		className: "border-b border-border-light last:border-b-0",
		children: [/* @__PURE__ */ v("div", {
			className: `px-3 py-2 cursor-pointer flex items-center justify-between ${t ? "bg-background-dark text-text" : "bg-background text-text"}`,
			onClick: () => a(e),
			children: [/* @__PURE__ */ v("div", {
				className: "flex items-center",
				children: [_(t ? uo : ho, { className: `w-4 h-4 hover:opacity-80 transition-opacity ${m}` }), /* @__PURE__ */ _("span", {
					className: `text-xs font-medium ml-1 ${t ? m : "text-text"}`,
					children: e
				})]
			}), /* @__PURE__ */ v("div", {
				className: "flex items-center",
				children: [r && /* @__PURE__ */ v("div", {
					className: "flex items-center",
					children: [/* @__PURE__ */ _(Lo, { className: "w-4 h-4 hover:opacity-80 transition-opacity text-accent" }), /* @__PURE__ */ _("button", {
						className: "text-xs hover:underline mr-2 text-error-dark transition-colors",
						onClick: (t) => {
							t.stopPropagation(), o(e);
						},
						children: "Clear"
					})]
				}), s && /* @__PURE__ */ _("button", {
					className: `flex items-center hover:opacity-80 transition-opacity ${m}`,
					onClick: (t) => {
						t.stopPropagation(), s(e);
					},
					title: `View ${e} statistics`,
					children: /* @__PURE__ */ _(p, { className: `w-4 h-4 ${m}` })
				})]
			})]
		}), t && /* @__PURE__ */ _("div", {
			className: "px-3 py-2 border-t border-border-light bg-background-light text-text",
			children: l ? /* @__PURE__ */ v("div", {
				className: "p-2 text-error-dark",
				children: [/* @__PURE__ */ v("p", {
					className: "text-xs",
					children: ["Filter error: ", l]
				}), /* @__PURE__ */ _("button", {
					onClick: () => u(null),
					className: "text-xs underline",
					children: "Reset"
				})]
			}) : f(e)
		})]
	});
};
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/ArrowDownIcon.js
function Rb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M12 2.25a.75.75 0 0 1 .75.75v16.19l6.22-6.22a.75.75 0 1 1 1.06 1.06l-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 1 1 1.06-1.06l6.22 6.22V3a.75.75 0 0 1 .75-.75Z",
		clipRule: "evenodd"
	}));
}
var zb = /*#__PURE__*/ t.forwardRef(Rb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/ArrowUpIcon.js
function Bb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M11.47 2.47a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 1 1-1.06 1.06l-6.22-6.22V21a.75.75 0 0 1-1.5 0V4.81l-6.22 6.22a.75.75 0 1 1-1.06-1.06l7.5-7.5Z",
		clipRule: "evenodd"
	}));
}
var Vb = /*#__PURE__*/ t.forwardRef(Bb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/Bars4Icon.js
function Hb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M3 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 5.25Zm0 4.5A.75.75 0 0 1 3.75 9h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 9.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Zm0 4.5a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z",
		clipRule: "evenodd"
	}));
}
var Ub = /*#__PURE__*/ t.forwardRef(Hb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/BeakerIcon.js
function Wb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M10.5 3.798v5.02a3 3 0 0 1-.879 2.121l-2.377 2.377a9.845 9.845 0 0 1 5.091 1.013 8.315 8.315 0 0 0 5.713.636l.285-.071-3.954-3.955a3 3 0 0 1-.879-2.121v-5.02a23.614 23.614 0 0 0-3 0Zm4.5.138a.75.75 0 0 0 .093-1.495A24.837 24.837 0 0 0 12 2.25a25.048 25.048 0 0 0-3.093.191A.75.75 0 0 0 9 3.936v4.882a1.5 1.5 0 0 1-.44 1.06l-6.293 6.294c-1.62 1.621-.903 4.475 1.471 4.88 2.686.46 5.447.698 8.262.698 2.816 0 5.576-.239 8.262-.697 2.373-.406 3.092-3.26 1.47-4.881L15.44 9.879A1.5 1.5 0 0 1 15 8.818V3.936Z",
		clipRule: "evenodd"
	}));
}
var Gb = /*#__PURE__*/ t.forwardRef(Wb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/DocumentArrowDownIcon.js
function Kb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z",
		clipRule: "evenodd"
	}), /*#__PURE__*/ t.createElement("path", { d: "M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" }));
}
var qb = /*#__PURE__*/ t.forwardRef(Kb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/FunnelIcon.js
function Jb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M3.792 2.938A49.069 49.069 0 0 1 12 2.25c2.797 0 5.54.236 8.209.688a1.857 1.857 0 0 1 1.541 1.836v1.044a3 3 0 0 1-.879 2.121l-6.182 6.182a1.5 1.5 0 0 0-.439 1.061v2.927a3 3 0 0 1-1.658 2.684l-1.757.878A.75.75 0 0 1 9.75 21v-5.818a1.5 1.5 0 0 0-.44-1.06L3.13 7.938a3 3 0 0 1-.879-2.121V4.774c0-.897.64-1.683 1.542-1.836Z",
		clipRule: "evenodd"
	}));
}
var Yb = /*#__PURE__*/ t.forwardRef(Jb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/PlusIcon.js
function Xb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M12 3.75a.75.75 0 0 1 .75.75v6.75h6.75a.75.75 0 0 1 0 1.5h-6.75v6.75a.75.75 0 0 1-1.5 0v-6.75H4.5a.75.75 0 0 1 0-1.5h6.75V4.5a.75.75 0 0 1 .75-.75Z",
		clipRule: "evenodd"
	}));
}
var Zb = /*#__PURE__*/ t.forwardRef(Xb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/SparklesIcon.js
function Qb({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M9 4.5a.75.75 0 0 1 .721.544l.813 2.846a3.75 3.75 0 0 0 2.576 2.576l2.846.813a.75.75 0 0 1 0 1.442l-2.846.813a3.75 3.75 0 0 0-2.576 2.576l-.813 2.846a.75.75 0 0 1-1.442 0l-.813-2.846a3.75 3.75 0 0 0-2.576-2.576l-2.846-.813a.75.75 0 0 1 0-1.442l2.846-.813A3.75 3.75 0 0 0 7.466 7.89l.813-2.846A.75.75 0 0 1 9 4.5ZM18 1.5a.75.75 0 0 1 .728.568l.258 1.036c.236.94.97 1.674 1.91 1.91l1.036.258a.75.75 0 0 1 0 1.456l-1.036.258c-.94.236-1.674.97-1.91 1.91l-.258 1.036a.75.75 0 0 1-1.456 0l-.258-1.036a2.625 2.625 0 0 0-1.91-1.91l-1.036-.258a.75.75 0 0 1 0-1.456l1.036-.258a2.625 2.625 0 0 0 1.91-1.91l.258-1.036A.75.75 0 0 1 18 1.5ZM16.5 15a.75.75 0 0 1 .712.513l.394 1.183c.15.447.5.799.948.948l1.183.395a.75.75 0 0 1 0 1.422l-1.183.395c-.447.15-.799.5-.948.948l-.395 1.183a.75.75 0 0 1-1.422 0l-.395-1.183a1.5 1.5 0 0 0-.948-.948l-1.183-.395a.75.75 0 0 1 0-1.422l1.183-.395c.447-.15.799-.5.948-.948l.395-1.183A.75.75 0 0 1 16.5 15Z",
		clipRule: "evenodd"
	}));
}
var $b = /*#__PURE__*/ t.forwardRef(Qb);
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/24/solid/esm/TrashIcon.js
function ex({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M16.5 4.478v.227a48.816 48.816 0 0 1 3.878.512.75.75 0 1 1-.256 1.478l-.209-.035-1.005 13.07a3 3 0 0 1-2.991 2.77H8.084a3 3 0 0 1-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 0 1-.256-1.478A48.567 48.567 0 0 1 7.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 0 1 3.369 0c1.603.051 2.815 1.387 2.815 2.951Zm-6.136-1.452a51.196 51.196 0 0 1 3.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 0 0-6 0v-.113c0-.794.609-1.428 1.364-1.452Zm-.355 5.945a.75.75 0 1 0-1.5.058l.347 9a.75.75 0 1 0 1.499-.058l-.346-9Zm5.48.058a.75.75 0 1 0-1.498-.058l-.347 9a.75.75 0 0 0 1.5.058l.345-9Z",
		clipRule: "evenodd"
	}));
}
var tx = /*#__PURE__*/ t.forwardRef(ex), nx = [
	5,
	10,
	25,
	50
], rx = ({ sampling: e, totalRows: t, activeCohortName: r, cohortStatus: i }) => {
	if (!e) return /* @__PURE__ */ _("div", {
		className: "p-4 text-center",
		children: /* @__PURE__ */ _("p", {
			className: "text-gray-500 text-sm",
			children: "Sampling is not available for this table."
		})
	});
	let { samplingState: a, toggleSampling: o, changeStrategy: s, setSamplePercentage: c, setSelectedColumn: l, applySampling: d, samplingStrategies: f, numericColumns: p, pendingSampling: h, setPendingSampling: y } = e, b = [
		...f.filter((e) => e.id === "first-n"),
		...f.filter((e) => e.id === "last-n"),
		...f.filter((e) => e.id !== "first-n" && e.id !== "last-n")
	], x = h?.strategy ?? "first-n", S = b.find((e) => e.id === x) ?? b[0], C = h?.samplePercentage ?? a.samplePercentage, w = h?.selectedColumn ?? a.selectedColumn, T = typeof t == "number" && t > 0 ? t : a.totalRows > 0 ? a.totalRows : 0, E = JSON.stringify({
		enabled: a.isSamplingEnabled,
		strategy: a.currentStrategy.id,
		samplePercentage: a.samplePercentage,
		selectedColumn: a.selectedColumn ?? "",
		seed: a.seed ?? null,
		sortBy: h?.sortBy ?? []
	}) !== JSON.stringify({
		enabled: a.isSamplingEnabled,
		strategy: x,
		samplePercentage: C,
		selectedColumn: w ?? "",
		seed: h?.seed ?? a.seed ?? null,
		sortBy: h?.sortBy ?? []
	}), D = (t) => {
		y && y("seed", t), e.setSeed && e.setSeed(t);
	};
	n.useEffect(() => {
		if (S.id !== "random") y && y("seed", void 0), e.setSeed && e.setSeed(void 0);
		else if (a.seed === void 0) {
			let t = Math.floor(Math.random() * 1e6);
			y && y("seed", t), e.setSeed && e.setSeed(t);
		}
	}, [
		S.id,
		a.seed,
		e,
		y
	]);
	let O = x === "first-n" || x === "last-n", k = h?.sortBy || [], A = e.columns || [], j = (e, t, n) => {
		y && y("sortBy", k.map((r, i) => i === e ? {
			...r,
			[t]: n
		} : r));
	}, M = () => {
		y && y("sortBy", [...k, {
			column: A[0] || "",
			direction: "ASC"
		}]);
	}, N = (e) => {
		y && y("sortBy", k.filter((t, n) => n !== e));
	}, P = (e, t) => {
		if (!y) return;
		let n = [...k];
		t === "up" && e > 0 ? [n[e - 1], n[e]] = [n[e], n[e - 1]] : t === "down" && e < n.length - 1 && ([n[e], n[e + 1]] = [n[e + 1], n[e]]), y("sortBy", n);
	}, F = () => {
		d && d();
	}, I = (e) => {
		let t = Math.max(1, Math.min(100, Math.round(e)));
		y && y("samplePercentage", t), c(t);
	}, L = m(null);
	return u(() => {
		if (L.current) {
			let e = h?.samplePercentage ?? a.samplePercentage;
			L.current.style.setProperty("--slider-percentage", `${e}%`);
		}
	}, [h?.samplePercentage, a.samplePercentage]), /* @__PURE__ */ v("div", {
		className: "p-4 max-w-full overflow-x-hidden custom-scrollbar",
		style: {
			background: "var(--table-body-bg-actual)",
			color: "var(--table-body-text)"
		},
		children: [r && /* @__PURE__ */ v("div", {
			className: "flex items-center gap-2 mb-4 px-3 py-2 rounded-md text-xs",
			style: {
				background: i === "modified" ? "var(--color-warning-bg, rgba(245,158,11,0.08))" : "var(--color-primary-subtle, rgba(99,102,241,0.08))",
				border: `1px solid ${i === "modified" ? "var(--color-warning, #f59e0b)" : "var(--color-primary)"}`,
				color: i === "modified" ? "var(--color-warning, #f59e0b)" : "var(--color-primary)"
			},
			"data-testid": "sampling-cohort-banner",
			children: [/* @__PURE__ */ _(Qa, { className: "w-3.5 h-3.5 shrink-0" }), /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("span", {
				className: "font-medium",
				children: ["Active cohort: ", r]
			}), i === "modified" && /* @__PURE__ */ _("span", {
				className: "ml-1 opacity-80",
				children: "(modified)"
			})] })]
		}), /* @__PURE__ */ v("div", {
			className: "mb-6",
			children: [/* @__PURE__ */ _("div", {
				className: "flex items-center justify-between mb-3",
				children: /* @__PURE__ */ v("label", {
					className: "flex items-center",
					children: [/* @__PURE__ */ _("input", {
						type: "checkbox",
						checked: a.isSamplingEnabled,
						onChange: o,
						className: "mr-2 accent-primary"
					}), /* @__PURE__ */ _("span", {
						className: "text-sm font-medium",
						children: "Enable Data Sampling"
					})]
				})
			}), a.isSamplingEnabled && /* @__PURE__ */ v(g, { children: [
				/* @__PURE__ */ _("p", {
					className: "text-xs mb-4",
					style: { color: "var(--table-header-text)" },
					children: "Sampling allows you to work with a smaller subset of your data for faster analysis and visualization."
				}),
				/* @__PURE__ */ _("p", {
					className: "text-xs mb-4",
					style: { color: "var(--color-text-light)" },
					children: "Sampling is applied after filters."
				}),
				/* @__PURE__ */ v("div", {
					className: "mt-4 mb-4",
					children: [
						/* @__PURE__ */ _("label", {
							className: "block text-sm font-medium mb-1.5",
							children: "Sampling Strategy"
						}),
						/* @__PURE__ */ _("select", {
							value: x,
							onChange: (e) => {
								let t = e.target.value;
								y && y("strategy", t), s(t);
							},
							className: "w-full rounded px-3 py-1.5 text-sm focus:outline-none",
							style: {
								background: "var(--table-header-bg-alt)",
								color: "var(--table-header-text)",
								border: "1.5px solid var(--icon-header-funnelicon-color)"
							},
							disabled: a.isLoading,
							children: b.map((e) => /* @__PURE__ */ _("option", {
								value: e.id,
								children: e.name
							}, e.id))
						}),
						/* @__PURE__ */ _("p", {
							className: "text-xs mt-1.5",
							style: { color: "var(--color-text-light)" },
							children: S.description
						}),
						S.id === "random" && /* @__PURE__ */ v("div", {
							className: "mt-3",
							children: [
								/* @__PURE__ */ _("label", {
									className: "block text-xs font-medium mb-1",
									style: { color: "var(--color-text)" },
									children: "Random Seed"
								}),
								/* @__PURE__ */ _("input", {
									type: "number",
									className: "w-full rounded px-2 py-1 text-xs focus:outline-none focus:ring-1",
									style: {
										border: "1px solid var(--color-border-light)",
										background: "var(--color-background)",
										color: "var(--color-text)"
									},
									onFocus: (e) => {
										e.target.style.boxShadow = "0 0 0 2px var(--color-primary-light)", e.target.style.borderColor = "var(--color-primary)";
									},
									onBlur: (e) => {
										e.target.style.boxShadow = "", e.target.style.borderColor = "var(--color-border-light)";
									},
									value: a.seed ?? "",
									onChange: (e) => D(Number(e.target.value)),
									min: 0,
									step: 1
								}),
								/* @__PURE__ */ _("p", {
									className: "text-xs mt-1",
									style: { color: "var(--color-text-light)" },
									children: "Set a seed for reproducible random sampling."
								})
							]
						}),
						O && /* @__PURE__ */ v("div", {
							className: "mt-4 mb-2",
							children: [
								/* @__PURE__ */ _("label", {
									className: "block text-xs font-medium mb-1",
									children: "Sort By (order matters)"
								}),
								k.length === 0 && /* @__PURE__ */ _("button", {
									type: "button",
									className: "text-xs hover:underline mb-2",
									style: { color: "var(--color-info-dark)" },
									onClick: M,
									children: "+ Add Sort Level"
								}),
								k.map((e, t) => /* @__PURE__ */ v("div", {
									className: "flex items-center gap-1 mb-1 flex-wrap",
									children: [
										/* @__PURE__ */ _("select", {
											className: "border rounded px-2 py-1 text-xs min-w-[90px] max-w-[120px]",
											style: {
												borderColor: "var(--color-border-light)",
												background: "var(--color-background)",
												color: "var(--color-text)"
											},
											value: e.column,
											onChange: (e) => j(t, "column", e.target.value),
											children: A.map((e) => /* @__PURE__ */ _("option", {
												value: e,
												children: e
											}, e))
										}),
										/* @__PURE__ */ v("select", {
											className: "border rounded px-2 py-1 text-xs min-w-[60px] max-w-[80px]",
											style: {
												borderColor: "var(--color-border-light)",
												background: "var(--color-background)",
												color: "var(--color-text)"
											},
											value: e.direction,
											onChange: (e) => j(t, "direction", e.target.value),
											children: [/* @__PURE__ */ _("option", {
												value: "ASC",
												children: "ASC"
											}), /* @__PURE__ */ _("option", {
												value: "DESC",
												children: "DESC"
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "flex flex-col gap-0.5",
											children: [/* @__PURE__ */ _("button", {
												type: "button",
												className: "p-1 hover:bg-background-light rounded",
												onClick: () => P(t, "up"),
												disabled: t === 0,
												title: "Move up",
												children: /* @__PURE__ */ _(Vb, {
													className: "w-4 h-4",
													style: { color: t === 0 ? "var(--icon-color-muted)" : "var(--icon-color)" }
												})
											}), /* @__PURE__ */ _("button", {
												type: "button",
												className: "p-1 hover:bg-background-light rounded",
												onClick: () => P(t, "down"),
												disabled: t === k.length - 1,
												title: "Move down",
												children: /* @__PURE__ */ _(zb, {
													className: "w-4 h-4",
													style: { color: t === k.length - 1 ? "var(--icon-color-muted)" : "var(--icon-color)" }
												})
											})]
										}),
										/* @__PURE__ */ _("button", {
											type: "button",
											className: "p-1 hover:bg-error-light rounded ml-1",
											onClick: () => N(t),
											title: "Remove sort level",
											children: /* @__PURE__ */ _(tx, {
												className: "w-4 h-4",
												style: { color: "var(--color-error-dark)" }
											})
										})
									]
								}, t)),
								/* @__PURE__ */ _("button", {
									type: "button",
									className: "text-xs hover:underline mt-1",
									style: { color: "var(--color-info-dark)" },
									onClick: M,
									children: "+ Add Sort Level"
								})
							]
						})
					]
				}),
				![
					"random",
					"cluster",
					"weighted",
					"stratified"
				].includes(S.id) && /* @__PURE__ */ v("div", {
					className: "mb-4",
					children: [
						/* @__PURE__ */ v("div", {
							className: "flex items-center justify-between mb-1.5",
							children: [/* @__PURE__ */ _("label", {
								className: "block text-sm font-medium",
								children: "Sample Size"
							}), /* @__PURE__ */ v("span", {
								className: "text-sm font-normal",
								style: { color: "var(--color-info-text)" },
								children: [
									(() => {
										let e = h?.samplePercentage ?? a.samplePercentage;
										return T <= 0 ? "Estimated after apply " : `${(e === 100 ? T : Math.max(1, Math.round(e / 100 * T))).toLocaleString()} rows `;
									})(),
									"(",
									h?.samplePercentage ?? a.samplePercentage,
									"%)"
								]
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "flex items-center gap-3",
							children: [/* @__PURE__ */ _("input", {
								ref: L,
								type: "range",
								min: "1",
								max: "100",
								step: "1",
								"aria-label": "Sample percentage",
								value: C,
								onChange: (e) => {
									let t = parseInt(e.target.value, 10);
									I(t), e.target.style.setProperty("--slider-percentage", `${t}%`);
								},
								className: "w-full mr-2 slider-primary",
								style: { height: "8px" },
								disabled: a.isLoading
							}), /* @__PURE__ */ v("div", {
								className: "flex items-center gap-1 shrink-0",
								children: [/* @__PURE__ */ _("input", {
									type: "number",
									min: "1",
									max: "100",
									step: "1",
									inputMode: "numeric",
									"aria-label": "Sample percentage input",
									value: C,
									onChange: (e) => I(Number(e.target.value)),
									className: "w-16 rounded px-2 py-1 text-sm focus:outline-none",
									style: {
										border: "1px solid var(--color-border-light)",
										background: "var(--color-background)",
										color: "var(--color-text)"
									},
									disabled: a.isLoading
								}), /* @__PURE__ */ _("span", {
									className: "text-xs",
									style: { color: "var(--color-text-light)" },
									children: "%"
								})]
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "flex justify-between text-xs mt-1 px-0.5",
							style: { color: "var(--color-text-light)" },
							children: [
								/* @__PURE__ */ _("span", { children: "1%" }),
								/* @__PURE__ */ _("span", { children: "50%" }),
								/* @__PURE__ */ _("span", { children: "100%" })
							]
						}),
						/* @__PURE__ */ v("div", {
							className: "mt-3",
							children: [/* @__PURE__ */ _("div", {
								className: "text-xs mb-1.5",
								style: { color: "var(--color-text-light)" },
								children: "Quick picks"
							}), /* @__PURE__ */ _("div", {
								className: "flex flex-wrap gap-2",
								children: nx.map((e) => /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => I(e),
									disabled: a.isLoading,
									className: "rounded-full px-2.5 py-1 text-xs transition-colors disabled:opacity-50",
									style: {
										border: `1px solid ${C === e ? "var(--color-primary)" : "var(--color-border-light)"}`,
										background: C === e ? "var(--color-primary-subtle, rgba(59,130,246,0.12))" : "var(--color-background)",
										color: "var(--color-text)"
									},
									children: [e, "%"]
								}, e))
							})]
						})
					]
				}),
				S.requiresColumn && /* @__PURE__ */ v("div", {
					className: "mb-5",
					children: [
						/* @__PURE__ */ v("label", {
							className: "block text-sm font-medium mb-1.5",
							children: ["Column for Sampling", S.requiresNumerical && /* @__PURE__ */ _("span", {
								className: "text-xs ml-1",
								style: { color: "var(--table-header-label)" },
								children: "(numerical only)"
							})]
						}),
						/* @__PURE__ */ v("select", {
							value: w || "",
							onChange: (e) => {
								y && y("selectedColumn", e.target.value), l(e.target.value);
							},
							className: "w-full rounded px-3 py-1.5 text-sm focus:outline-none",
							style: {
								border: "1px solid var(--color-border-light)",
								background: "var(--color-background)",
								color: "var(--color-text)"
							},
							disabled: a.isLoading,
							children: [/* @__PURE__ */ _("option", {
								value: "",
								children: "Select a column"
							}), (S.requiresNumerical ? p : e.columns).map((e) => /* @__PURE__ */ _("option", {
								value: e,
								children: e
							}, e))]
						}),
						S.requiresColumn && !w && /* @__PURE__ */ _("p", {
							className: "text-xs mt-1",
							style: { color: "var(--color-error-text)" },
							children: "A column selection is required for this strategy"
						})
					]
				}),
				a.error && /* @__PURE__ */ _("div", {
					className: "mb-4 p-2 rounded text-xs",
					style: {
						background: "var(--color-error-bg)",
						border: "1px solid var(--color-error-border)",
						color: "var(--color-error-text)"
					},
					children: a.error
				}),
				/* @__PURE__ */ _("button", {
					onClick: F,
					disabled: a.isLoading || S.requiresColumn && !w || C <= 0 || !E,
					className: "w-full rounded-md px-4 py-2 text-sm font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed",
					style: {
						background: "var(--color-action-sample)",
						color: "var(--color-background-dark)",
						borderColor: "var(--color-action-sample-hover)",
						border: "1px solid var(--color-action-sample-hover)",
						boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
						fontWeight: "bold"
					},
					onMouseOver: (e) => {
						e.currentTarget.style.background = "var(--color-action-sample-hover)", e.currentTarget.style.color = "var(--color-text)";
					},
					onMouseOut: (e) => {
						e.currentTarget.style.background = "var(--color-action-sample)", e.currentTarget.style.color = "var(--color-background-dark)";
					},
					children: a.isLoading ? /* @__PURE__ */ v("span", {
						className: "flex items-center justify-center",
						children: [/* @__PURE__ */ _(Ss, {
							width: "20px",
							height: "16px",
							message: "",
							className: "-ml-1 mr-2 inline-block align-middle"
						}), "Processing..."]
					}) : E ? "Apply Sampling" : "Sampling Up To Date"
				}),
				E && /* @__PURE__ */ _("p", {
					className: "mt-2 text-xs",
					style: { color: "var(--color-text-light)" },
					children: "Changes stay local until you apply them, so adjusting the sample size will not refresh the table on every drag."
				}),
				a.sampledRows > 0 && a.isSamplingEnabled && /* @__PURE__ */ v("div", {
					className: "mt-4 p-3 rounded-md",
					style: {
						background: "var(--table-header-bg-alt)",
						border: "1px solid var(--table-header-border)",
						color: "var(--table-header-text)"
					},
					children: [/* @__PURE__ */ _("h4", {
						className: "text-xs font-medium mb-1",
						children: "Sampling Summary"
					}), /* @__PURE__ */ v("ul", {
						className: "text-xs",
						children: [
							/* @__PURE__ */ v("li", {
								className: "flex justify-between mb-0.5",
								children: [/* @__PURE__ */ _("span", { children: "Strategy:" }), /* @__PURE__ */ _("span", {
									className: "font-medium",
									children: a.currentStrategy.name
								})]
							}),
							/* @__PURE__ */ v("li", {
								className: "flex justify-between mb-0.5",
								children: [/* @__PURE__ */ _("span", { children: "Total Rows:" }), /* @__PURE__ */ _("span", {
									className: "font-medium",
									children: a.totalRows.toLocaleString()
								})]
							}),
							/* @__PURE__ */ v("li", {
								className: "flex justify-between mb-0.5",
								children: [/* @__PURE__ */ _("span", { children: "Sampled Rows:" }), /* @__PURE__ */ _("span", {
									className: "font-medium",
									children: a.sampledRows.toLocaleString()
								})]
							}),
							/* @__PURE__ */ v("li", {
								className: "flex justify-between",
								children: [/* @__PURE__ */ _("span", { children: "Percentage:" }), /* @__PURE__ */ v("span", {
									className: "font-medium",
									children: [a.samplePercentage, "%"]
								})]
							})
						]
					})]
				})
			] })]
		})]
	});
}, ix = new Set([
	"__sampling",
	"sampling",
	"samplePercentage",
	"isSamplingEnabled",
	"sampledRows",
	"randomSample",
	"randomSeed"
]);
function ax(e) {
	let t = {};
	for (let [n, r] of Object.entries(e)) ix.has(n) || r != null && (t[n] = r);
	return t;
}
function ox(e, t) {
	return {
		enabled: e.isSamplingEnabled,
		strategy: e.currentStrategy.id,
		samplePercentage: e.samplePercentage,
		selectedColumn: e.selectedColumn,
		seed: e.seed,
		sortBy: t?.sortBy ?? []
	};
}
function sx(e) {
	let t = Object.keys(e);
	return t.length === 0 ? "No filters" : t.length <= 3 ? t.join(", ") : `${t.slice(0, 3).join(", ")} +${t.length - 3} more`;
}
function cx(e, t, n) {
	return JSON.stringify(e.filterDefinition) === JSON.stringify(t) ? e.samplingDefinition === null && n === null ? !1 : e.samplingDefinition === null || n === null ? !0 : JSON.stringify(e.samplingDefinition) !== JSON.stringify(n) : !0;
}
//#endregion
//#region src/components/panel/CohortSummaryCard.tsx
var lx = {
	none: "Unsaved filtered view",
	active: "Cohort active",
	modified: "Modified from saved cohort"
}, ux = {
	none: "var(--color-text-light)",
	active: "var(--color-primary)",
	modified: "var(--color-warning, #f59e0b)"
}, dx = ({ tableName: e, filterCount: t, activeFilters: n, samplingEnabled: r, samplingPercentage: i, activeCohort: a, cohortStatus: o, onSaveAsCohort: s, onUpdateCohort: c, onClearCohort: l }) => {
	let u = sx(n);
	return /* @__PURE__ */ v("div", {
		className: "mx-3 mt-3 mb-1 rounded-md p-3 text-xs",
		style: {
			background: "var(--color-background-light)",
			border: "1px solid var(--color-border-light)"
		},
		"data-testid": "cohort-summary-card",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex items-center justify-between mb-1.5",
				children: [/* @__PURE__ */ _("span", {
					className: "font-medium truncate max-w-[60%]",
					style: { color: "var(--color-text)" },
					children: e
				}), /* @__PURE__ */ v("span", {
					className: "flex items-center gap-1",
					style: { color: ux[o] },
					"data-testid": "cohort-status-label",
					children: [_(o === "none" ? Ja : Qa, { className: "w-3.5 h-3.5 shrink-0" }), a ? a.name : lx[o]]
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex flex-wrap gap-x-3 gap-y-0.5 mb-2",
				style: { color: "var(--color-text-light)" },
				children: [/* @__PURE__ */ _("span", { children: t > 0 ? `${t} filter${t === 1 ? "" : "s"}: ${u}` : "No filters" }), r && /* @__PURE__ */ v("span", {
					style: { color: "var(--color-action-sample)" },
					children: [
						"Sampling ",
						i,
						"%"
					]
				})]
			}),
			o === "modified" && /* @__PURE__ */ _("div", {
				className: "mb-2 text-xs",
				style: { color: ux.modified },
				children: lx.modified
			}),
			/* @__PURE__ */ v("div", {
				className: "flex gap-2 flex-wrap",
				children: [
					o === "none" && t > 0 && /* @__PURE__ */ _("button", {
						className: "px-2 py-0.5 rounded text-xs font-medium",
						style: {
							background: "var(--color-primary)",
							color: "var(--color-background)"
						},
						onClick: s,
						"data-testid": "save-as-cohort-btn",
						children: "Save as Cohort"
					}),
					o === "modified" && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("button", {
						className: "px-2 py-0.5 rounded text-xs font-medium",
						style: {
							background: "var(--color-primary)",
							color: "var(--color-background)"
						},
						onClick: c,
						"data-testid": "update-cohort-btn",
						children: "Update Cohort"
					}), /* @__PURE__ */ _("button", {
						className: "px-2 py-0.5 rounded text-xs font-medium",
						style: {
							background: "var(--color-background)",
							color: "var(--color-text-light)",
							border: "1px solid var(--color-border-light)"
						},
						onClick: s,
						"data-testid": "save-as-new-cohort-btn",
						children: "Save as New"
					})] }),
					o !== "none" && /* @__PURE__ */ _("button", {
						className: "px-2 py-0.5 rounded text-xs",
						style: {
							background: "transparent",
							color: "var(--color-text-light)",
							border: "1px solid var(--color-border-light)"
						},
						onClick: l,
						"data-testid": "clear-cohort-btn",
						children: "Clear Cohort"
					})
				]
			})
		]
	});
};
//#endregion
//#region src/components/panel/CohortList.tsx
function fx(e) {
	let t = Date.now() - new Date(e).getTime(), n = Math.floor(t / 6e4);
	if (n < 1) return "just now";
	if (n < 60) return `${n}m ago`;
	let r = Math.floor(n / 60);
	return r < 24 ? `${r}h ago` : `${Math.floor(r / 24)}d ago`;
}
var px = ({ cohorts: e, activeCohortId: t, isLoading: n, error: r, onApply: i, onRename: a, onDuplicate: o, onDelete: s }) => {
	let [c, l] = h(""), u = Array.isArray(e) ? e : [], d = c.trim() ? u.filter((e) => e.name.toLowerCase().includes(c.toLowerCase()) || (e.description ?? "").toLowerCase().includes(c.toLowerCase())) : u;
	return /* @__PURE__ */ v("div", {
		className: "px-3 pb-3",
		"data-testid": "cohort-list",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex items-center justify-between mb-2 mt-3",
				children: [/* @__PURE__ */ _("span", {
					className: "text-xs font-semibold uppercase tracking-wide",
					style: { color: "var(--color-text-light)" },
					children: "Saved Cohorts"
				}), n && /* @__PURE__ */ _("span", {
					className: "text-xs",
					style: { color: "var(--color-text-light)" },
					children: "Loading…"
				})]
			}),
			r && /* @__PURE__ */ _("div", {
				className: "text-xs mb-2 px-2 py-1 rounded",
				style: {
					color: "var(--color-error-text)",
					background: "var(--color-error-bg)"
				},
				children: r
			}),
			u.length > 3 && /* @__PURE__ */ v("div", {
				className: "relative mb-2",
				children: [/* @__PURE__ */ _(Go, {
					className: "absolute left-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5",
					style: { color: "var(--color-text-light)" }
				}), /* @__PURE__ */ _("input", {
					type: "text",
					value: c,
					onChange: (e) => l(e.target.value),
					placeholder: "Search cohorts…",
					className: "w-full pl-7 pr-2 py-1 text-xs rounded",
					style: {
						background: "var(--color-background)",
						border: "1px solid var(--color-border-light)",
						color: "var(--color-text)"
					},
					"data-testid": "cohort-search-input"
				})]
			}),
			!n && d.length === 0 && /* @__PURE__ */ _("div", {
				className: "text-xs py-3 text-center",
				style: { color: "var(--color-text-light)" },
				children: u.length === 0 ? "No saved cohorts yet. Apply filters and save a cohort." : "No cohorts match your search."
			}),
			/* @__PURE__ */ _("div", {
				className: "flex flex-col gap-1.5",
				children: d.map((e) => {
					let n = e.id === t, r = Object.keys(e.filterDefinition);
					return /* @__PURE__ */ v("div", {
						className: "rounded-md p-2.5",
						style: {
							background: n ? "var(--color-primary-subtle, rgba(99,102,241,0.08))" : "var(--color-background-light)",
							border: `1px solid ${n ? "var(--color-primary)" : "var(--color-border-light)"}`
						},
						"data-testid": `cohort-card-${e.id}`,
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex items-start justify-between gap-1 mb-0.5",
								children: [/* @__PURE__ */ _("span", {
									className: "text-xs font-medium truncate",
									style: { color: "var(--color-text)" },
									children: e.name
								}), /* @__PURE__ */ _("span", {
									className: "text-xs shrink-0",
									style: { color: "var(--color-text-light)" },
									children: fx(e.updatedAt)
								})]
							}),
							e.description && /* @__PURE__ */ _("p", {
								className: "text-xs mb-1 line-clamp-1",
								style: { color: "var(--color-text-light)" },
								children: e.description
							}),
							r.length > 0 && /* @__PURE__ */ v("div", {
								className: "flex flex-wrap gap-1 mb-2",
								children: [r.slice(0, 4).map((e) => /* @__PURE__ */ _("span", {
									className: "px-1.5 py-0.5 rounded text-xs",
									style: {
										background: "var(--color-action-filter-subtle, rgba(59,130,246,0.1))",
										color: "var(--color-action-filter, #3b82f6)"
									},
									children: e
								}, e)), r.length > 4 && /* @__PURE__ */ v("span", {
									className: "text-xs",
									style: { color: "var(--color-text-light)" },
									children: ["+", r.length - 4]
								})]
							}),
							e.samplingDefinition?.enabled && /* @__PURE__ */ _("div", {
								className: "mb-1.5",
								children: /* @__PURE__ */ v("span", {
									className: "text-xs px-1.5 py-0.5 rounded",
									style: {
										background: "var(--color-action-sample-subtle, rgba(16,185,129,0.1))",
										color: "var(--color-action-sample, #10b981)"
									},
									children: [
										"Sampling ",
										e.samplingDefinition.samplePercentage,
										"%"
									]
								})
							}),
							/* @__PURE__ */ v("div", {
								className: "flex items-center gap-1.5",
								children: [
									/* @__PURE__ */ v("button", {
										className: "flex items-center gap-1 px-2 py-0.5 rounded text-xs font-medium",
										style: {
											background: n ? "var(--color-primary)" : "var(--color-background)",
											color: n ? "var(--color-background)" : "var(--color-primary)",
											border: "1px solid var(--color-primary)"
										},
										onClick: () => i(e),
										"data-testid": `cohort-apply-${e.id}`,
										children: [/* @__PURE__ */ _($o, { className: "w-3 h-3" }), n ? "Active" : "Apply"]
									}),
									/* @__PURE__ */ _("button", {
										className: "p-1 rounded hover:bg-background-light",
										title: "Rename",
										onClick: () => a(e.id, e.name, e.description),
										"data-testid": `cohort-rename-${e.id}`,
										children: /* @__PURE__ */ _(Zo, {
											className: "w-3.5 h-3.5",
											style: { color: "var(--color-text-light)" }
										})
									}),
									/* @__PURE__ */ _("button", {
										className: "p-1 rounded hover:bg-background-light",
										title: "Duplicate",
										onClick: () => o(e.id),
										"data-testid": `cohort-duplicate-${e.id}`,
										children: /* @__PURE__ */ _(To, {
											className: "w-3.5 h-3.5",
											style: { color: "var(--color-text-light)" }
										})
									}),
									/* @__PURE__ */ _("button", {
										className: "p-1 rounded hover:bg-error-light ml-auto",
										title: "Delete",
										onClick: () => s(e.id, e.name),
										"data-testid": `cohort-delete-${e.id}`,
										children: /* @__PURE__ */ _(hs, {
											className: "w-3.5 h-3.5",
											style: { color: "var(--color-error-dark)" }
										})
									})
								]
							})
						]
					}, e.id);
				})
			})
		]
	});
};
//#endregion
//#region src/components/primitives/classNames.ts
function mx(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
//#region src/components/primitives/Badge.tsx
var hx = {
	neutral: {
		soft: "bg-slate-100 text-slate-700",
		outline: "border border-slate-200 bg-white text-slate-600",
		solid: "bg-slate-900 text-white"
	},
	success: {
		soft: "bg-emerald-100 text-emerald-700",
		outline: "border border-emerald-200 bg-emerald-50 text-emerald-700",
		solid: "bg-emerald-600 text-white"
	},
	danger: {
		soft: "bg-rose-100 text-rose-700",
		outline: "border border-rose-200 bg-rose-50 text-rose-700",
		solid: "bg-rose-600 text-white"
	},
	warning: {
		soft: "bg-amber-100 text-amber-700",
		outline: "border border-amber-200 bg-amber-50 text-amber-700",
		solid: "bg-amber-500 text-white"
	},
	info: {
		soft: "bg-cyan-100 text-cyan-900",
		outline: "border border-cyan-200 bg-cyan-50 text-cyan-900",
		solid: "bg-cyan-700 text-white"
	},
	accent: {
		soft: "bg-teal-100 text-teal-800",
		outline: "border border-teal-200 bg-teal-50 text-teal-700",
		solid: "bg-teal-700 text-white"
	}
}, gx = {
	xs: "px-2 py-0.5 text-[10px] tracking-[0.14em]",
	sm: "px-2.5 py-1 text-[11px] tracking-[0.16em]",
	md: "px-3 py-1 text-xs tracking-[0.18em]"
};
function _x({ tone: e = "neutral", variant: t = "soft", size: n = "sm", uppercase: r = !0, className: i, children: a, ...o }) {
	return /* @__PURE__ */ _("span", {
		className: mx("inline-flex items-center rounded-full font-semibold", gx[n], r ? "uppercase" : void 0, hx[e][t], i),
		...o,
		children: a
	});
}
//#endregion
//#region src/components/primitives/Drawer.tsx
function vx({ open: e, children: t, onClose: n, showBackdrop: r = !1, closeOnBackdrop: i = !0, backdropClassName: a, backdropTestId: o, containerClassName: s, panelClassName: c, panelTestId: l }) {
	return /* @__PURE__ */ v(g, { children: [r ? /* @__PURE__ */ _("div", {
		className: mx("fixed inset-0 z-40 transition-opacity", e ? "opacity-100" : "pointer-events-none opacity-0", a ?? "bg-black/30"),
		onClick: i ? n : void 0,
		"data-testid": o,
		"aria-hidden": "true"
	}) : null, /* @__PURE__ */ _("div", {
		className: mx("fixed inset-y-0 right-0 flex w-full justify-end", e ? void 0 : "pointer-events-none", s ?? "z-50"),
		children: /* @__PURE__ */ _("div", {
			className: mx("h-full w-full transform transition-transform duration-300", e ? "translate-x-0" : "translate-x-full", c ?? "max-w-[480px]"),
			role: "dialog",
			"aria-modal": "true",
			"data-testid": l,
			children: t
		})
	})] });
}
//#endregion
//#region src/components/primitives/Modal.tsx
function yx({ open: e, children: t, onClose: n, closeOnBackdrop: r = !0, backdropClassName: i, backdropTestId: a, containerClassName: o, panelClassName: s, panelTestId: c }) {
	return e ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
		className: mx("fixed inset-0 z-40 bg-slate-950/35", i),
		onClick: r ? n : void 0,
		"data-testid": a,
		"aria-hidden": "true"
	}), /* @__PURE__ */ _("div", {
		className: mx("fixed inset-0 z-50 flex items-center justify-center p-4", o),
		children: /* @__PURE__ */ _("div", {
			className: mx("w-full max-w-xl", s),
			onClick: (e) => e.stopPropagation(),
			role: "dialog",
			"aria-modal": "true",
			"data-testid": c,
			children: t
		})
	})] }) : null;
}
//#endregion
//#region src/components/primitives/Tabs.tsx
var bx = {
	pill: {
		list: "flex gap-2",
		tab: "rounded-full transition",
		active: "bg-slate-900 text-white",
		inactive: "bg-white/80 text-slate-600"
	},
	surface: {
		list: "flex rounded-lg border border-slate-200 bg-slate-50 p-0.5",
		tab: "rounded-md transition",
		active: "bg-white text-slate-900 shadow-sm",
		inactive: "text-slate-500 hover:text-slate-700"
	}
}, xx = {
	sm: "px-3 py-1.5 text-xs font-medium",
	md: "px-4 py-2 text-sm font-medium"
};
function Sx({ items: e, value: t, onChange: n, ariaLabel: r, variant: i = "surface", size: a = "sm", className: o }) {
	let s = bx[i];
	return /* @__PURE__ */ _("div", {
		className: mx(s.list, o),
		role: "tablist",
		"aria-label": r,
		children: e.map((e) => {
			let r = e.value === t;
			return /* @__PURE__ */ _("button", {
				type: "button",
				role: "tab",
				"aria-selected": r,
				"aria-disabled": e.disabled ? "true" : void 0,
				disabled: e.disabled,
				onClick: () => n(e.value),
				className: mx(s.tab, xx[a], r ? s.active : s.inactive),
				children: e.label
			}, e.value);
		})
	});
}
//#endregion
//#region src/components/primitives/treeShared.tsx
function Cx(e, t, n = 0, r = null) {
	return e.flatMap((i, a) => {
		let o = i.children ?? [], s = o.length === 0, c = !s && t.has(i.id);
		return [{
			node: i,
			depth: n,
			index: 0,
			parentId: r,
			isLeaf: s,
			isExpanded: c,
			setSize: e.length,
			posInSet: a + 1
		}, ...c ? Cx(o, t, n + 1, i.id) : []];
	});
}
function wx(e) {
	return e.map((e, t) => ({
		...e,
		index: t
	}));
}
function Tx(e, t) {
	return t ? e.findIndex((e) => e.node.id === t) : -1;
}
function Ex(e, t, n) {
	if (!t) return null;
	let r = t.toLowerCase(), i = [...Array.from({ length: Math.max(0, e.length - n - 1) }, (e, t) => n + t + 1), ...Array.from({ length: n + 1 }, (e, t) => t)].find((t) => e[t]?.node.label.toLowerCase().startsWith(r));
	return i == null ? null : e[i]?.node.id ?? null;
}
function Dx(e) {
	let { items: t, selectedId: n, defaultSelectedId: r = null, expandedIds: i, defaultExpandedIds: a = [], onSelect: o, onExpandedIdsChange: s, onToggle: c } = e, [l, d] = h(r), [p, g] = h(() => new Set(a)), [_, v] = h(r), y = m(/* @__PURE__ */ new Map()), b = m(""), x = m(null), S = f(() => new Set(i ?? Array.from(p.values())), [i, p]), C = n ?? l, w = f(() => wx(Cx(t, S)), [t, S]);
	u(() => {
		if (C && w.some((e) => e.node.id === C)) {
			v(C);
			return;
		}
		if (!_ && w[0]) {
			v(w[0].node.id);
			return;
		}
		_ && !w.some((e) => e.node.id === _) && v(C ?? w[0]?.node.id ?? null);
	}, [
		w,
		_,
		C
	]), u(() => {
		if (!_) return;
		let e = y.current.get(_);
		e && document.activeElement !== e && e.focus();
	}, [w, _]), u(() => () => {
		x.current != null && window.clearTimeout(x.current);
	}, []);
	let T = (e, t) => {
		if (t) {
			y.current.set(e, t);
			return;
		}
		y.current.delete(e);
	}, E = (e) => {
		e && (v(e), window.setTimeout(() => {
			y.current.get(e)?.focus();
		}, 0));
	}, D = (e) => {
		i ?? g(e), s?.(Array.from(e.values()));
	}, O = (e) => {
		if (e.isLeaf || e.node.disabled) return;
		let t = new Set(S), n = !t.has(e.node.id);
		n ? t.add(e.node.id) : t.delete(e.node.id), D(t), c?.(e.node, n);
	}, k = (e) => {
		e.node.disabled || (n ?? d(e.node.id), v(e.node.id), o?.(e.node));
	};
	return {
		flatItems: w,
		selectedId: C,
		focusId: _,
		registerItemRef: T,
		focusItem: E,
		toggleItem: O,
		selectItem: k,
		handleItemKeyDown: (e, t) => {
			let n = w.findIndex((e) => e.node.id === t.node.id);
			if (!(n < 0)) {
				if (e.key.length === 1 && !e.altKey && !e.ctrlKey && !e.metaKey) {
					let t = `${b.current}${e.key.toLowerCase()}`;
					b.current = t, x.current != null && window.clearTimeout(x.current), x.current = window.setTimeout(() => {
						b.current = "";
					}, 350);
					let r = Ex(w, t, n);
					r && (e.preventDefault(), E(r));
					return;
				}
				switch (e.key) {
					case "ArrowDown":
						e.preventDefault(), E(w[n + 1]?.node.id ?? t.node.id);
						return;
					case "ArrowUp":
						e.preventDefault(), E(w[n - 1]?.node.id ?? t.node.id);
						return;
					case "Home":
						e.preventDefault(), E(w[0]?.node.id ?? null);
						return;
					case "End":
						e.preventDefault(), E(w[w.length - 1]?.node.id ?? null);
						return;
					case "ArrowRight": {
						if (e.preventDefault(), !t.isLeaf && !t.isExpanded) {
							O(t);
							return;
						}
						let r = w[n + 1];
						r?.depth === t.depth + 1 && E(r.node.id);
						return;
					}
					case "ArrowLeft": {
						if (e.preventDefault(), !t.isLeaf && t.isExpanded) {
							O(t);
							return;
						}
						let n = Tx(w, t.parentId);
						n >= 0 && E(w[n]?.node.id ?? null);
						return;
					}
					case "Enter":
					case " ":
						e.preventDefault(), k(t);
						return;
					default: return;
				}
			}
		}
	};
}
function Ox({ item: e, isSelected: t, isFocused: n, registerItemRef: r, onSelect: i, onToggle: a, onKeyDown: o, renderNode: s, style: c, rowHeight: l }) {
	let u = s ? s({
		...e,
		isSelected: t,
		isFocused: n
	}) : /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("span", {
		className: "min-w-0 flex-1 truncate text-sm font-medium text-slate-900",
		children: e.node.label
	}), e.node.badge ? /* @__PURE__ */ _("span", {
		className: "shrink-0",
		children: e.node.badge
	}) : null] });
	return /* @__PURE__ */ _("div", {
		role: "treeitem",
		"aria-level": e.depth + 1,
		"aria-expanded": e.isLeaf ? void 0 : e.isExpanded,
		"aria-selected": t,
		"aria-disabled": e.node.disabled || void 0,
		"aria-setsize": e.setSize,
		"aria-posinset": e.posInSet,
		"data-tree-nodeid": e.node.id,
		tabIndex: n ? 0 : -1,
		ref: (t) => r(e.node.id, t),
		onClick: () => i(e),
		onKeyDown: (t) => o(t, e),
		className: "outline-none",
		style: c,
		children: /* @__PURE__ */ v("div", {
			className: mx("flex items-center gap-2 rounded-xl px-3 py-2 transition", t ? "bg-teal-50 text-teal-900 shadow-[inset_0_0_0_1px_rgba(13,148,136,0.18)]" : "text-slate-700 hover:bg-slate-50", n ? "ring-2 ring-teal-400 ring-offset-2 ring-offset-white" : void 0, e.node.disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"),
			style: {
				minHeight: l,
				paddingLeft: `${e.depth * 16 + 12}px`
			},
			children: [
				e.isLeaf ? /* @__PURE__ */ _("span", {
					className: "w-4 shrink-0",
					"aria-hidden": "true"
				}) : /* @__PURE__ */ _("button", {
					type: "button",
					tabIndex: -1,
					onMouseDown: (e) => e.preventDefault(),
					onClick: (t) => {
						t.stopPropagation(), a(e);
					},
					className: "flex h-4 w-4 shrink-0 items-center justify-center rounded text-slate-500 transition hover:bg-slate-200/70 hover:text-slate-700",
					"aria-label": e.isExpanded ? "Collapse node" : "Expand node",
					children: /* @__PURE__ */ _("svg", {
						className: `h-3.5 w-3.5 transition-transform ${e.isExpanded ? "rotate-90" : ""}`,
						fill: "none",
						viewBox: "0 0 24 24",
						stroke: "currentColor",
						children: /* @__PURE__ */ _("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M9 5l7 7-7 7"
						})
					})
				}),
				e.node.icon ? /* @__PURE__ */ _("span", {
					className: "shrink-0",
					children: e.node.icon
				}) : null,
				/* @__PURE__ */ _("div", {
					className: "flex min-w-0 flex-1 items-center gap-2",
					children: u
				})
			]
		})
	});
}
//#endregion
//#region src/components/primitives/TreeView.tsx
function kx(e) {
	let { flatItems: t, focusId: n, registerItemRef: r, selectedId: i, selectItem: a, toggleItem: o, handleItemKeyDown: s } = Dx(e);
	return /* @__PURE__ */ _("div", {
		role: "tree",
		"aria-label": e.ariaLabel,
		className: mx("overflow-auto rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_12px_30px_rgba(15,23,42,0.06)]", e.className),
		children: t.map((t) => /* @__PURE__ */ _(Ox, {
			item: t,
			isSelected: i === t.node.id,
			isFocused: n === t.node.id,
			registerItemRef: r,
			onSelect: a,
			onToggle: o,
			onKeyDown: s,
			renderNode: e.renderNode
		}, t.node.id))
	});
}
//#endregion
//#region src/components/primitives/VirtualTree.tsx
function Ax({ height: e = 360, rowHeight: t = 40, overscan: r = 6, ...i }) {
	let { flatItems: a, focusId: o, registerItemRef: s, selectedId: c, selectItem: l, toggleItem: p, handleItemKeyDown: h } = Dx(i), g = m(null), v = m([]), y = m(0), [b, x] = n.useState({
		top: 0,
		viewport: e
	}), S = a.length * t, C = Math.max(0, Math.floor(b.top / t) - r), w = Math.min(a.length, Math.ceil((b.top + b.viewport) / t) + r), T = f(() => a.slice(C, w), [
		w,
		a,
		C
	]);
	return d(() => {
		let n = g.current;
		if (!n) return;
		let r = a.map((e) => e.node.id), i = v.current;
		if (i.length > 0) {
			let e = Math.min(i.length - 1, Math.floor(y.current / t)), a = i[e], o = y.current - e * t, s = r.indexOf(a);
			if (s >= 0) {
				let e = s * t + o;
				Math.abs(n.scrollTop - e) > 1 && (n.scrollTop = e);
			}
		}
		v.current = r, y.current = n.scrollTop, x({
			top: n.scrollTop,
			viewport: n.clientHeight || e
		});
	}, [
		a,
		e,
		t
	]), u(() => {
		let n = g.current;
		if (!n || !o) return;
		let r = a.findIndex((e) => e.node.id === o);
		if (r < 0) return;
		let i = r * t, s = i + t, c = n.scrollTop, l = c + n.clientHeight;
		i < c ? n.scrollTop = i : s > l && (n.scrollTop = s - n.clientHeight), y.current = n.scrollTop, x({
			top: n.scrollTop,
			viewport: n.clientHeight || e
		});
	}, [
		o,
		e,
		t
	]), /* @__PURE__ */ _("div", {
		role: "tree",
		"aria-label": i.ariaLabel,
		ref: g,
		onScroll: (t) => {
			let n = t.currentTarget;
			y.current = n.scrollTop, x({
				top: n.scrollTop,
				viewport: n.clientHeight || e
			});
		},
		className: mx("overflow-auto rounded-2xl border border-slate-200 bg-white p-2 shadow-[0_12px_30px_rgba(15,23,42,0.06)]", i.className),
		style: { height: e },
		children: /* @__PURE__ */ _("div", {
			style: {
				position: "relative",
				height: S
			},
			children: T.map((e, n) => {
				let r = C + n;
				return /* @__PURE__ */ _(Ox, {
					item: e,
					isSelected: c === e.node.id,
					isFocused: o === e.node.id,
					registerItemRef: s,
					onSelect: l,
					onToggle: p,
					onKeyDown: h,
					renderNode: i.renderNode,
					rowHeight: t,
					style: {
						position: "absolute",
						top: r * t,
						left: 0,
						right: 0
					}
				}, e.node.id);
			})
		})
	});
}
//#endregion
//#region src/components/primitives/VersionHistoryFilmstrip.tsx
function jx(e) {
	let t = [];
	return typeof e.rowCount == "number" && t.push(`${e.rowCount.toLocaleString()} rows`), typeof e.durationMs == "number" && t.push(`${e.durationMs} ms`), typeof e.warningCount == "number" && e.warningCount > 0 && t.push(`${e.warningCount} warning${e.warningCount === 1 ? "" : "s"}`), t.length > 0 ? t.join(" • ") : "Run context pending";
}
function Mx({ items: e, onRestore: t, onBranch: n, onPin: r, onDiff: i, className: a }) {
	return /* @__PURE__ */ _("div", {
		className: `overflow-x-auto pb-1 ${a ?? ""}`.trim(),
		"data-testid": "tables-version-filmstrip",
		children: /* @__PURE__ */ _("div", {
			className: "flex min-w-full gap-3",
			children: e.map((e) => /* @__PURE__ */ v("article", {
				className: `min-w-[16rem] flex-1 rounded-[1.4rem] border px-4 py-3 transition ${e.isActive ? "border-slate-900 bg-slate-900 text-white shadow-[0_18px_36px_rgba(15,23,42,0.18)]" : e.isDiffTarget ? "border-amber-300 bg-amber-50 text-slate-900 shadow-[0_14px_30px_rgba(245,158,11,0.12)]" : "border-slate-200 bg-white text-slate-900 shadow-[0_12px_24px_rgba(15,23,42,0.06)]"}`,
				"data-testid": `version-card-${e.id}`,
				children: [/* @__PURE__ */ _("div", {
					className: "flex items-start justify-between gap-3",
					children: /* @__PURE__ */ v("div", {
						className: "min-w-0",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center gap-2",
								children: [
									/* @__PURE__ */ _("span", {
										className: `rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${e.isActive ? "bg-white/12 text-white" : e.isDiffTarget ? "bg-amber-100 text-amber-700" : "bg-slate-100 text-slate-600"}`,
										children: e.label
									}),
									e.isPinned ? /* @__PURE__ */ _("span", {
										className: `rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${e.isActive ? "bg-emerald-400/20 text-emerald-200" : "bg-emerald-100 text-emerald-700"}`,
										children: "Baseline"
									}) : null,
									e.statusLabel ? /* @__PURE__ */ _("span", {
										className: `rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.18em] ${e.isActive ? "bg-sky-400/20 text-sky-100" : "bg-sky-100 text-sky-700"}`,
										children: e.statusLabel
									}) : null
								]
							}),
							/* @__PURE__ */ _("div", {
								className: `mt-3 text-sm font-semibold ${e.isActive ? "text-white" : "text-slate-900"}`,
								children: e.caption ?? "Immutable query snapshot"
							}),
							/* @__PURE__ */ _("div", {
								className: `mt-1 text-xs leading-5 ${e.isActive ? "text-slate-200" : "text-slate-500"}`,
								children: jx(e)
							})
						]
					})
				}), /* @__PURE__ */ v("div", {
					className: "mt-4 grid grid-cols-2 gap-2",
					children: [
						/* @__PURE__ */ v("button", {
							type: "button",
							disabled: e.actionsDisabled,
							onClick: () => t(e.id),
							className: `inline-flex items-center justify-center gap-1 rounded-full px-3 py-2 text-xs font-medium ${e.actionsDisabled ? e.isActive ? "cursor-not-allowed border border-white/10 bg-white/5 text-white/55" : "cursor-not-allowed border border-slate-200 bg-slate-100 text-slate-400" : e.isActive ? "border border-white/15 bg-white/10 text-white hover:bg-white/15" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`,
							"data-testid": `version-restore-${e.id}`,
							children: [/* @__PURE__ */ _(Ma, {
								className: "h-3.5 w-3.5",
								"aria-hidden": "true"
							}), "Restore"]
						}),
						/* @__PURE__ */ v("button", {
							type: "button",
							disabled: e.actionsDisabled,
							onClick: () => n(e.id),
							className: `inline-flex items-center justify-center gap-1 rounded-full px-3 py-2 text-xs font-medium ${e.actionsDisabled ? e.isActive ? "cursor-not-allowed border border-white/10 bg-white/5 text-white/55" : "cursor-not-allowed border border-slate-200 bg-slate-100 text-slate-400" : e.isActive ? "border border-white/15 bg-white/10 text-white hover:bg-white/15" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`,
							"data-testid": `version-branch-${e.id}`,
							children: [/* @__PURE__ */ _(Ka, {
								className: "h-3.5 w-3.5",
								"aria-hidden": "true"
							}), "Branch"]
						}),
						/* @__PURE__ */ v("button", {
							type: "button",
							disabled: e.actionsDisabled,
							onClick: () => r(e.id),
							className: `inline-flex items-center justify-center gap-1 rounded-full px-3 py-2 text-xs font-medium ${e.actionsDisabled ? e.isActive ? "cursor-not-allowed border border-white/10 bg-white/5 text-white/55" : "cursor-not-allowed border border-slate-200 bg-slate-100 text-slate-400" : e.isPinned ? "border border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100" : e.isActive ? "border border-white/15 bg-white/10 text-white hover:bg-white/15" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`,
							"data-testid": `version-pin-${e.id}`,
							children: [/* @__PURE__ */ _(Xa, {
								className: "h-3.5 w-3.5",
								"aria-hidden": "true"
							}), "Pin"]
						}),
						/* @__PURE__ */ v("button", {
							type: "button",
							disabled: e.actionsDisabled,
							onClick: () => i(e.id),
							className: `inline-flex items-center justify-center gap-1 rounded-full px-3 py-2 text-xs font-medium ${e.actionsDisabled ? e.isActive ? "cursor-not-allowed border border-white/10 bg-white/5 text-white/55" : "cursor-not-allowed border border-slate-200 bg-slate-100 text-slate-400" : e.isDiffTarget ? "border border-amber-300 bg-amber-100 text-amber-800 hover:bg-amber-200" : e.isActive ? "border border-white/15 bg-white/10 text-white hover:bg-white/15" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`,
							"data-testid": `version-diff-${e.id}`,
							children: [/* @__PURE__ */ _(Ha, {
								className: "h-3.5 w-3.5",
								"aria-hidden": "true"
							}), "Diff"]
						})
					]
				})]
			}, e.id))
		})
	});
}
//#endregion
//#region src/components/panel/CohortSaveDialog.tsx
var Nx = ({ mode: e, filterDefinition: t, samplingEnabled: n, initialName: r = "", initialDescription: i = "", onConfirm: a, onCancel: o }) => {
	let [s, c] = h(r), [l, d] = h(i), [f, p] = h(!1), [g, y] = h(!1), [b, x] = h(null), S = m(null);
	u(() => {
		S.current?.focus(), S.current?.select();
	}, []), u(() => {
		let e = (e) => {
			e.key === "Escape" && o();
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [o]);
	let C = async (e) => {
		e.preventDefault();
		let t = s.trim();
		if (!t) {
			x("Name is required"), S.current?.focus();
			return;
		}
		x(null), y(!0);
		try {
			await a(t, l.trim(), f);
		} catch (e) {
			x(e?.message ?? "Failed to save cohort");
		} finally {
			y(!1);
		}
	}, w = sx(t), T = Object.keys(t).length;
	return /* @__PURE__ */ _(yx, {
		open: !0,
		onClose: o,
		backdropClassName: "z-[1000] bg-black/40",
		backdropTestId: "cohort-dialog-backdrop",
		containerClassName: "z-[1001] p-0",
		panelClassName: "w-80 max-w-[20rem] rounded-lg border-[var(--color-border-light)] bg-[var(--color-background)] p-0",
		panelTestId: "cohort-save-dialog",
		children: /* @__PURE__ */ v("div", {
			style: {
				background: "var(--color-background)",
				border: "1px solid var(--color-border-light)"
			},
			children: [/* @__PURE__ */ v("div", {
				className: "flex items-center justify-between px-4 py-3 border-b",
				style: { borderColor: "var(--color-border-light)" },
				children: [/* @__PURE__ */ _("h3", {
					className: "text-sm font-semibold",
					style: { color: "var(--color-text)" },
					children: e === "save" ? "Save as Cohort" : "Rename Cohort"
				}), /* @__PURE__ */ _("button", {
					onClick: o,
					className: "p-1 rounded hover:bg-background-light",
					"data-testid": "cohort-dialog-close",
					children: /* @__PURE__ */ _(xs, {
						className: "w-4 h-4",
						style: { color: "var(--color-text-light)" }
					})
				})]
			}), /* @__PURE__ */ v("form", {
				onSubmit: C,
				className: "px-4 py-3 flex flex-col gap-3",
				children: [
					e === "save" && T > 0 && /* @__PURE__ */ v("div", {
						className: "rounded px-2 py-1.5 text-xs",
						style: {
							background: "var(--color-background-light)",
							border: "1px solid var(--color-border-light)",
							color: "var(--color-text-light)"
						},
						children: [
							/* @__PURE__ */ v("span", {
								className: "font-medium",
								style: { color: "var(--color-action-filter, #3b82f6)" },
								children: [
									T,
									" filter",
									T === 1 ? "" : "s"
								]
							}),
							": ",
							w
						]
					}),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ v("label", {
							className: "block text-xs font-medium mb-1",
							style: { color: "var(--color-text)" },
							children: ["Name ", /* @__PURE__ */ _("span", {
								style: { color: "var(--color-error-text)" },
								children: "*"
							})]
						}),
						/* @__PURE__ */ _("input", {
							ref: S,
							type: "text",
							value: s,
							onChange: (e) => c(e.target.value),
							className: "w-full px-2 py-1.5 text-xs rounded focus:outline-none",
							style: {
								background: "var(--color-background)",
								border: `1px solid ${b ? "var(--color-error-border)" : "var(--color-border-light)"}`,
								color: "var(--color-text)"
							},
							placeholder: "e.g. Active NL adults",
							maxLength: 100,
							"data-testid": "cohort-name-input"
						}),
						b && /* @__PURE__ */ _("p", {
							className: "text-xs mt-0.5",
							style: { color: "var(--color-error-text)" },
							children: b
						})
					] }),
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("label", {
						className: "block text-xs font-medium mb-1",
						style: { color: "var(--color-text)" },
						children: ["Description ", /* @__PURE__ */ _("span", {
							style: { color: "var(--color-text-light)" },
							children: "(optional)"
						})]
					}), /* @__PURE__ */ _("textarea", {
						value: l,
						onChange: (e) => d(e.target.value),
						className: "w-full px-2 py-1.5 text-xs rounded focus:outline-none resize-none",
						style: {
							background: "var(--color-background)",
							border: "1px solid var(--color-border-light)",
							color: "var(--color-text)"
						},
						rows: 2,
						maxLength: 256,
						placeholder: "Short description of this cohort…",
						"data-testid": "cohort-description-input"
					})] }),
					e === "save" && n && /* @__PURE__ */ v("label", {
						className: "flex items-center gap-2 cursor-pointer",
						children: [/* @__PURE__ */ _("input", {
							type: "checkbox",
							checked: f,
							onChange: (e) => p(e.target.checked),
							className: "accent-primary",
							"data-testid": "cohort-include-sampling-checkbox"
						}), /* @__PURE__ */ _("span", {
							className: "text-xs",
							style: { color: "var(--color-text)" },
							children: "Include current sampling settings"
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "flex justify-end gap-2 pt-1",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: o,
							className: "px-3 py-1.5 rounded text-xs",
							style: {
								background: "var(--color-background-light)",
								color: "var(--color-text)",
								border: "1px solid var(--color-border-light)"
							},
							"data-testid": "cohort-dialog-cancel",
							children: "Cancel"
						}), /* @__PURE__ */ _("button", {
							type: "submit",
							disabled: g,
							className: "px-3 py-1.5 rounded text-xs font-medium disabled:opacity-50",
							style: {
								background: "var(--color-primary)",
								color: "var(--color-background)"
							},
							"data-testid": "cohort-dialog-confirm",
							children: g ? "Saving…" : e === "save" ? "Save Cohort" : "Rename"
						})]
					})
				]
			})]
		})
	});
};
//#endregion
//#region src/services/cohortService.ts
function Px(e, t) {
	return `${X.baseUrl}/v1/databases/${e}/tables/${t}/cohorts`;
}
function Fx(e) {
	return e?.data?.data ?? e?.data ?? e;
}
var Ix = {
	async list(e, t) {
		return Fx(await Z.get(Px(e, t)));
	},
	async create(e, t, n) {
		return Fx(await Z.post(Px(e, t), n));
	},
	async update(e, t, n, r) {
		return Fx(await Z.patch(`${Px(e, t)}/${n}`, r));
	},
	async delete(e, t, n) {
		await Z.delete(`${Px(e, t)}/${n}`);
	},
	async duplicate(e, t, n, r) {
		return Fx(await Z.post(`${Px(e, t)}/${n}/duplicate`, r ? { name: r } : {}));
	}
}, Lx = D("useCohort");
function Rx({ databaseId: e, tableName: t, currentFilters: n, currentSampling: r, onApplyCohort: i }) {
	let [a, o] = h([]), [c, l] = h(null), [d, f] = h(!1), [p, g] = h(null), _ = m(e), v = m(t);
	return u(() => {
		_.current = e, v.current = t;
	}, [e, t]), u(() => {
		l(null);
	}, [e, t]), {
		cohorts: a,
		activeCohort: c,
		cohortStatus: c === null ? "none" : cx(c, n, r) ? "modified" : "active",
		isLoading: d,
		error: p,
		loadCohorts: s(async () => {
			if (!(!_.current || !v.current)) {
				f(!0), g(null);
				try {
					let e = await Ix.list(_.current, v.current);
					o(Array.isArray(e) ? e : []);
				} catch (e) {
					Lx.error("Failed to load cohorts", e), g(e?.message ?? "Failed to load cohorts"), o([]);
				} finally {
					f(!1);
				}
			}
		}, []),
		applyCohort: s((e) => {
			l(e), i(e.filterDefinition, e.samplingDefinition);
		}, [i]),
		clearCohort: s(() => {
			l(null);
		}, []),
		saveCohort: s(async (e, t, n, r) => {
			let i = await Ix.create(_.current, v.current, {
				name: e,
				description: t,
				filterDefinition: n,
				samplingDefinition: r
			});
			return o((e) => [i, ...e]), l(i), i;
		}, []),
		updateCohort: s(async (e, t) => {
			if (!c) return;
			let n = await Ix.update(_.current, v.current, c.id, {
				filterDefinition: e,
				samplingDefinition: t
			});
			o((e) => e.map((e) => e.id === n.id ? n : e)), l(n);
		}, [c]),
		renameCohort: s(async (e, t, n) => {
			let r = await Ix.update(_.current, v.current, e, {
				name: t,
				description: n
			});
			o((e) => e.map((e) => e.id === r.id ? r : e)), c?.id === e && l(r);
		}, [c]),
		deleteCohort: s(async (e) => {
			await Ix.delete(_.current, v.current, e), o((t) => t.filter((t) => t.id !== e)), c?.id === e && l(null);
		}, [c]),
		duplicateCohort: s(async (e, t) => {
			let n = await Ix.duplicate(_.current, v.current, e, t);
			o((e) => [n, ...e]);
		}, [])
	};
}
//#endregion
//#region src/components/panel/Filters.tsx
var zx = 0, Bx = ({ isOpen: e, onClose: t, columns: n, data: r, databaseId: i, tableName: a, filters: o, applyFilter: c, clearFilter: l, clearAllFilters: d, columnTypes: p, fetchUniqueValues: y, openStatsPanel: b, initialTab: x = "filters", sampling: S, onTabChange: C, onActiveCohortChange: w }) => {
	let T = Di(), [E, D] = h(x), O = m(x), k = m(null), A = s(() => {
		k.current && (zx = k.current.scrollTop);
	}, []);
	u(() => {
		let e = setTimeout(() => {
			k.current && (k.current.scrollTop = zx);
		}, 100);
		return () => {
			A(), clearTimeout(e);
		};
	}, [E, A]), u(() => {
		D(x), O.current = x, zx = 0, C && C(x);
	}, [x, C]), u(() => {
		E !== O.current && (O.current = E, C && C(E));
	}, [E, C]), u(() => () => {
		A();
	}, [A]);
	let [j, M] = h(() => {
		try {
			let e = localStorage.getItem(`${i}-${a}-expandedFilterColumns`);
			if (e) return new Set(JSON.parse(e));
		} catch (e) {
			console.error("Error loading expanded columns from localStorage:", e);
		}
		return /* @__PURE__ */ new Set();
	});
	u(() => {
		try {
			localStorage.setItem(`${i}-${a}-expandedFilterColumns`, JSON.stringify(Array.from(j)));
		} catch (e) {
			console.error("Error saving expanded columns to localStorage:", e);
		}
	}, [
		j,
		i,
		a
	]), u(() => {
		e && E === "filters" && j.forEach((e) => {
			he(e);
		});
	}, [
		e,
		i,
		a,
		E
	]);
	let [N, P] = h(/* @__PURE__ */ new Map()), [F, I] = h(/* @__PURE__ */ new Map()), [L, R] = h(/* @__PURE__ */ new Map()), [z, B] = h(/* @__PURE__ */ new Map()), [V, H] = h(/* @__PURE__ */ new Set()), [ee, U] = h(/* @__PURE__ */ new Map()), { shouldRender: te, isAnimatingOut: W, handleClose: ne, panelStyle: re } = Ry({
		isOpen: e,
		onClose: t,
		side: "left"
	}), [ie, ae] = h(null), oe = m(null), [se, ce] = h(null), le = m(/* @__PURE__ */ new Map()), ue = m(null), de = m(!1), fe = () => {
		ue.current && !de.current && (zx = ue.current.scrollTop);
	};
	u(() => {
		if (!ue.current || !e) return;
		let t = () => {
			let e = ue.current;
			e && zx > 0 && (de.current = !0, e.scrollTop = zx, setTimeout(() => {
				de.current = !1;
			}, 100));
		};
		t();
		let n = setTimeout(t, 50), r = setTimeout(t, 200);
		return () => {
			clearTimeout(n), clearTimeout(r);
		};
	}, [
		e,
		F,
		o,
		j
	]), u(() => {
		if (!e) return;
		let t = (e) => {
			e.key === "Escape" && ne(e);
		};
		return document.addEventListener("keydown", t), () => {
			document.removeEventListener("keydown", t);
		};
	}, [e, ne]), u(() => () => {
		le.current.forEach((e) => {
			e && clearTimeout(e);
		});
	}, []);
	let pe = (e) => {
		M((t) => {
			let n = new Set(t);
			if (n.has(e)) n.delete(e);
			else {
				n.add(e);
				let t = me(e);
				if (t === "categorical") he(e);
				else if (t === "numerical") {
					let t = r.map((t) => t[e]).filter((e) => typeof e == "number");
					t.length > 0 && B((n) => {
						let r = new Map(n), i = o?.[e];
						return r.set(e, {
							min: i && typeof i == "object" && i && "min" in i ? i.min : Math.min(...t),
							max: i && typeof i == "object" && i && "max" in i ? i.max : Math.max(...t),
							operator: i && typeof i == "object" && i && "operator" in i ? i.operator : "between"
						}), r;
					});
				} else if (t === "date") {
					let t = r.map((t) => t[e]).filter((e) => e && !Number.isNaN(new Date(e).getTime())).map((e) => new Date(e));
					if (t.length > 0) {
						let n = new Date(Math.min(...t.map((e) => e.getTime()))), r = new Date(Math.max(...t.map((e) => e.getTime())));
						B((t) => {
							let i = new Map(t);
							return i.set(e, {
								min: n.toISOString().split("T")[0],
								max: r.toISOString().split("T")[0]
							}), i;
						});
					}
				}
			}
			return n;
		});
	}, me = (e) => e === "rowid" ? "numerical" : p?.[e] || "categorical", he = async (e, t = "") => {
		let n = N.get(e) || "", o = t === void 0 ? n : t;
		H((t) => {
			let n = new Set(t);
			return n.add(e), n;
		});
		try {
			let t = await T.fetchUniqueColumnValues(i, a, e, o), n = [];
			if (Array.isArray(t)) n = t;
			else if (t && typeof t == "object") {
				let e = t;
				e.values && Array.isArray(e.values) ? n = e.values : e.uniqueValues && Array.isArray(e.uniqueValues) ? n = e.uniqueValues : e.rows && Array.isArray(e.rows) && (n = e.rows.map((e) => e[Object.keys(e)[0]]));
			}
			I((t) => {
				let r = new Map(t);
				return r.set(e, n), r;
			}), U((t) => {
				let n = new Map(t);
				return n.delete(e), n;
			});
		} catch (t) {
			console.error(`Error fetching values for ${e}:`, t);
			let n = t.message || "Failed to load values";
			(t.code === "ERR_NETWORK" || n.includes("Network Error")) && (n = "Cannot connect to server. Using local data."), U((t) => {
				let r = new Map(t);
				return r.set(e, n), r;
			});
			let i = lb(r, e, o);
			I((t) => {
				let n = new Map(t);
				return n.set(e, i), n;
			});
		} finally {
			H((t) => {
				let n = new Set(t);
				return n.delete(e), n;
			});
		}
	};
	u(() => {
		if (se) {
			let e = document.getElementById(se);
			if (e && document.activeElement !== e) {
				let t = oe.current?.selectionStart || 0;
				e.focus(), e.setSelectionRange(t, t);
			}
		}
	}, [se]);
	let ge = f(() => {
		let e = /* @__PURE__ */ new Map();
		return n.forEach((t) => {
			e.set(t, (e) => {
				let n = e.target.value, r = `search-input-${t}`;
				oe.current = e.target, ce(r), P((e) => {
					let r = new Map(e);
					return r.set(t, n), r;
				});
				let i = le.current.get(t);
				i && clearTimeout(i);
				let a = setTimeout(() => {
					he(t, n), le.current.set(t, null);
				}, 300);
				le.current.set(t, a);
			});
		}), e;
	}, [n]), _e = (e) => {
		ce(`search-input-${e}`);
	}, ve = () => {
		setTimeout(() => {
			document.activeElement?.classList.contains("filter-search-input") || ce(null);
		}, 100);
	}, ye = (e) => {
		let t = L.get(e) || /* @__PURE__ */ new Set();
		M((t) => {
			let n = new Set(t);
			return n.add(e), n;
		}), c(e, Array.from(t));
	}, be = (e, t) => {
		let n = t || z.get(e) || {
			min: 0,
			max: 0,
			operator: "between"
		};
		M((t) => {
			let n = new Set(t);
			return n.add(e), n;
		}), c(e, n);
	}, xe = (e) => {
		let t = z.get(e) || {
			min: "",
			max: ""
		};
		M((t) => {
			let n = new Set(t);
			return n.add(e), n;
		}), c(e, t);
	}, Se = (e) => {
		let t = F.get(e) || [], n = L.get(e) || /* @__PURE__ */ new Set();
		R((r) => {
			let i = new Map(r);
			return n.size === t.length ? i.set(e, /* @__PURE__ */ new Set()) : i.set(e, new Set(t)), i;
		});
	}, Ce = (e, t) => {
		R((n) => {
			let r = new Map(n), i = r.get(e) || /* @__PURE__ */ new Set(), a = new Set(i);
			return a.has(t) ? a.delete(t) : a.add(t), r.set(e, a), r;
		});
	}, we = (e, t, n) => {
		B((r) => {
			let i = new Map(r), a = i.get(e) || {
				min: 0,
				max: 0,
				operator: "between"
			};
			return i.set(e, {
				...a,
				[t]: n
			}), i;
		});
	}, G = (e, t, n) => {
		B((r) => {
			let i = new Map(r), a = i.get(e) || {
				min: "",
				max: ""
			};
			return i.set(e, {
				...a,
				[t]: n
			}), i;
		});
	}, Te = (e) => {
		let t = me(e), n = V.has(e), i = ee.get(e), a = F.get(e) || [], o = L.get(e) || /* @__PURE__ */ new Set(), s = N.get(e) || "", c = z.get(e) || {
			min: 0,
			max: 0,
			operator: "between"
		}, l = t === "numerical" ? r.map((t) => t[e]).filter((e) => typeof e == "number" && !Number.isNaN(e)) : [], u = ge.get(e);
		return t === "categorical" ? /* @__PURE__ */ _(Mb, {
			column: e,
			uniqueValues: a,
			selectedValues: o,
			searchTerm: s,
			isLoading: n,
			error: i,
			searchHandler: u,
			handleInputFocus: _e,
			handleInputBlur: ve,
			handleCheckboxChange: Ce,
			handleSelectAll: Se,
			handleApplyCategoricalFilter: ye,
			fetchColumnValuesForColumn: he
		}) : t === "numerical" ? /* @__PURE__ */ _(Fb, {
			column: e,
			rangeValues: c,
			handleRangeInputChange: we,
			handleApplyNumericFilter: be,
			allValues: l
		}) : t === "date" ? /* @__PURE__ */ _(Ib, {
			column: e,
			rangeValues: c,
			handleDateRangeInputChange: G,
			handleApplyDateFilter: xe
		}) : /* @__PURE__ */ _("div", {
			className: "text-xs text-gray-500",
			children: "No filter UI for this type yet."
		});
	}, Ee = (e) => {
		D(e), O.current = e, C && C(e), ue.current && (ue.current.scrollTop = 0, zx = 0);
	};
	u(() => {
		e && D(O.current);
	}, [e]);
	let K = m(S), De = m(r);
	u(() => {}, []);
	let [Oe, ke] = h(null), [Ae, je] = h(!1);
	u(() => {
		if (!e || E !== "sampling") return;
		let t = Array.isArray(r) ? r.length : 0;
		if (ke(t > 0 ? t : null), !i || !a || typeof T.fetchTableRowCount != "function") return;
		let n = o && typeof o == "object" ? Object.fromEntries(Object.entries(o).filter(([e]) => e !== "__sampling")) : void 0, s = !1;
		return je(!0), T.fetchTableRowCount(i, a, n).then((e) => {
			s || typeof e != "number" || e < 0 || ke(e);
		}).catch(() => {}).finally(() => {
			s || je(!1);
		}), () => {
			s = !0;
		};
	}, [
		e,
		E,
		r,
		i,
		a,
		T,
		o
	]);
	let [Me, Ne] = h(null), [Pe, Fe] = h(null), Ie = f(() => ax(o), [o]), Le = f(() => K.current?.samplingState ? ox(K.current.samplingState, K.current.pendingSampling ?? null) : null, [S]), Re = Rx({
		databaseId: i,
		tableName: a,
		currentFilters: Ie,
		currentSampling: Le,
		onApplyCohort: s((e, t) => {
			d && d(), Object.entries(e).forEach(([e, t]) => c(e, t));
		}, [d, c])
	});
	u(() => {
		e && i && a && Re.loadCohorts();
	}, [
		e,
		i,
		a
	]);
	let ze = s(async (e, t) => {
		window.confirm(`Delete cohort "${t}"? This cannot be undone.`) && await Re.deleteCohort(e);
	}, [Re]), Be = s(async (e, t, n) => {
		Me === "rename" && Pe ? await Re.renameCohort(Pe.id, e, t) : await Re.saveCohort(e, t, Ie, n ? Le : null), Ne(null), Fe(null);
	}, [
		Me,
		Pe,
		Re,
		Ie,
		Le
	]), Ve = s(async () => {
		await Re.updateCohort(Ie, Le);
	}, [
		Re,
		Ie,
		Le
	]);
	u(() => {
		w && w(Re.activeCohort?.name ?? null, Re.activeCohort?.rowsetKey ?? null);
	}, [Re.activeCohort, w]), u(() => {
		K.current = S;
	}, [S]), u(() => {
		De.current = r;
	}, [r]), u(() => {
		o && (R((e) => {
			let t = new Map(e);
			return Object.entries(o).forEach(([e, n]) => {
				e !== "__sampling" && (Array.isArray(n) ? t.set(e, new Set(n)) : typeof n == "object" && n && ("min" in n || "max" in n) && t.set(e, /* @__PURE__ */ new Set()));
			}), t;
		}), B((e) => {
			let t = new Map(e);
			return Object.entries(o).forEach(([e, n]) => {
				if (e !== "__sampling" && typeof n == "object" && n && ("min" in n || "max" in n)) {
					let r = t.get(e) || {
						min: 0,
						max: 0,
						operator: "between"
					};
					t.set(e, {
						min: n.min ?? r.min,
						max: n.max ?? r.max,
						operator: typeof n.operator == "string" ? n.operator : r.operator ?? "between"
					});
				}
			}), t;
		}));
	}, [o]);
	let He = f(() => {
		if (Object.keys(o).length === 0) return !1;
		let e = ["__sampling"];
		for (let t in o) {
			if (e.includes(t) || t === "__sampling") continue;
			let n = o[t];
			if (Array.isArray(n) && n.length > 0 || typeof n == "object" && n && ("min" in n || "max" in n) || n != null) return !0;
		}
		return !1;
	}, [o]), Ue = f(() => {
		let e = [
			"sampling",
			"samplePercentage",
			"isSamplingEnabled",
			"sampledRows",
			"randomSample",
			"randomSeed",
			"__sampling"
		];
		return Object.keys(o).filter((t) => !e.includes(t)).length;
	}, [o]);
	return te ? /* @__PURE__ */ v("div", {
		className: "fixed top-0 left-0 h-full shadow-xl z-[990] flex flex-col bg-background text-text",
		style: { ...re },
		"data-testid": "filters-side-panel",
		children: [
			/* @__PURE__ */ _("div", {
				className: "absolute -right-4 top-1/2 -translate-y-1/2 shadow-md rounded-r-md p-1 cursor-pointer bg-background-light z-40",
				onClick: ne,
				"data-testid": "filters-panel-collapse",
				children: /* @__PURE__ */ _(ho, { className: "w-5 h-5 hover:text-primary text-primary" })
			}),
			/* @__PURE__ */ v("div", {
				className: "p-3 flex justify-between items-center bg-background-dark text-text",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-col items-start",
					children: [/* @__PURE__ */ v("div", {
						className: "flex items-center",
						children: [/* @__PURE__ */ _("h3", {
							className: "font-medium text-sm text-primary",
							children: "Select Options"
						}), K.current?.samplingState.isSamplingEnabled && /* @__PURE__ */ v("span", {
							className: "ml-2 px-1.5 py-0.5 bg-action-sample/20 rounded text-xs text-action-sample",
							children: [
								"Sampling ",
								K.current.samplingState.samplePercentage,
								"%"
							]
						})]
					}), He && /* @__PURE__ */ v("div", {
						className: "mt-1 flex items-center space-x-1",
						children: [/* @__PURE__ */ v("span", {
							className: "text-xs text-action-filter",
							children: [
								Ue,
								" filter",
								Ue === 1 ? "" : "s",
								" applied"
							]
						}), /* @__PURE__ */ _("button", {
							className: "ml-1 p-0.5 hover:bg-background rounded-sm",
							onClick: d,
							title: "Clear all filters",
							"aria-label": "Clear all filters",
							children: /* @__PURE__ */ _(hs, { className: "h-3.5 w-3.5 text-action-clear" })
						})]
					})]
				}), /* @__PURE__ */ _("button", {
					onClick: ne,
					className: "ml-2 p-2 rounded hover:bg-background-dark transition-colors",
					"data-testid": "filters-panel-close-button",
					children: /* @__PURE__ */ _(xs, { className: "h-5 w-5 text-muted-dark" })
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex border-b bg-background-light border-border-light",
				children: [/* @__PURE__ */ v("button", {
					className: `flex-1 py-2 text-sm font-medium flex items-center justify-center ${E === "filters" ? "border-b-2 border-primary text-primary bg-background" : "text-muted-dark bg-background-light"}`,
					onClick: () => Ee("filters"),
					"data-testid": "filters-tab-button",
					children: [/* @__PURE__ */ _(Lo, { className: `h-4 w-4 mr-2 ${E === "filters" ? "text-primary" : "text-muted-dark"}` }), "Filters"]
				}), /* @__PURE__ */ v("button", {
					className: `flex-1 py-2 text-sm font-medium flex items-center justify-center ${E === "sampling" ? "border-b-2 border-primary text-primary bg-background" : "text-muted-dark bg-background-light"}`,
					onClick: () => Ee("sampling"),
					"data-testid": "sampling-tab-button",
					children: [/* @__PURE__ */ _(Wa, { className: `h-4 w-4 mr-2 ${E === "sampling" ? "text-primary" : "text-muted-dark"}` }), "Sampling"]
				})]
			}),
			/* @__PURE__ */ _("div", {
				className: "flex-1 overflow-y-auto custom-scrollbar",
				ref: ue,
				onScroll: fe,
				children: E === "filters" ? /* @__PURE__ */ v(g, { children: [
					/* @__PURE__ */ _(dx, {
						tableName: a,
						filterCount: Ue,
						activeFilters: Ie,
						samplingEnabled: K.current?.samplingState?.isSamplingEnabled ?? !1,
						samplingPercentage: K.current?.samplingState?.samplePercentage ?? 10,
						activeCohort: Re.activeCohort,
						cohortStatus: Re.cohortStatus,
						onSaveAsCohort: () => Ne("save"),
						onUpdateCohort: Ve,
						onClearCohort: Re.clearCohort
					}),
					n.length > 0 ? n.map((e) => /* @__PURE__ */ _(Lb, {
						column: e,
						isExpanded: j.has(e),
						hasActiveFilter: !!o[e],
						filterType: me(e),
						toggleColumnExpansion: pe,
						clearFilter: l,
						openStatsPanel: b,
						renderFilterControls: Te
					}, e)) : /* @__PURE__ */ _("div", {
						className: "p-4 text-center text-sm text-info-dark",
						children: "No columns available for filtering"
					}),
					/* @__PURE__ */ _(px, {
						cohorts: Re.cohorts,
						activeCohortId: Re.activeCohort?.id ?? null,
						isLoading: Re.isLoading,
						error: Re.error,
						onApply: Re.applyCohort,
						onRename: (e, t, n) => {
							Fe({
								id: e,
								name: t,
								description: n
							}), Ne("rename");
						},
						onDuplicate: Re.duplicateCohort,
						onDelete: ze
					})
				] }) : K.current ? /* @__PURE__ */ _(rx, {
					sampling: K.current,
					totalRows: Oe ?? void 0,
					activeCohortName: Re.activeCohort?.name ?? null,
					cohortStatus: Re.cohortStatus
				}) : null
			}),
			Me !== null && /* @__PURE__ */ _(Nx, {
				mode: Me,
				filterDefinition: Ie,
				samplingEnabled: K.current?.samplingState?.isSamplingEnabled ?? !1,
				initialName: Me === "rename" && Pe ? Pe.name : "",
				initialDescription: Me === "rename" && Pe ? Pe.description ?? "" : "",
				onConfirm: Be,
				onCancel: () => {
					Ne(null), Fe(null);
				}
			}),
			/* @__PURE__ */ _("div", {
				className: "p-3 flex justify-end bg-background-dark border-t border-border-light",
				children: /* @__PURE__ */ _("button", {
					className: "px-3 py-1 rounded transition-colors filters-panel-close bg-primary text-background hover:bg-primary-dark",
					onClick: ne,
					"data-testid": "filters-panel-footer-close",
					children: "Close"
				})
			})
		]
	}) : null;
};
//#endregion
//#region ../node_modules/.pnpm/@heroicons+react@2.2.0_react@19.2.7/node_modules/@heroicons/react/20/solid/esm/QuestionMarkCircleIcon.js
function Vx({ title: e, titleId: n, ...r }, i) {
	return /*#__PURE__*/ t.createElement("svg", Object.assign({
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 20 20",
		fill: "currentColor",
		"aria-hidden": "true",
		"data-slot": "icon",
		ref: i,
		"aria-labelledby": n
	}, r), e ? /*#__PURE__*/ t.createElement("title", { id: n }, e) : null, /*#__PURE__*/ t.createElement("path", {
		fillRule: "evenodd",
		d: "M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0ZM8.94 6.94a.75.75 0 1 1-1.061-1.061 3 3 0 1 1 2.871 5.026v.345a.75.75 0 0 1-1.5 0v-.5c0-.72.57-1.172 1.081-1.287A1.5 1.5 0 1 0 8.94 6.94ZM10 15a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
		clipRule: "evenodd"
	}));
}
var Hx = /*#__PURE__*/ t.forwardRef(Vx), Ux = ({ text: e, children: t, onOpen: n, className: r = "", iconClassName: i = "", style: a, tooltipClassName: o = "", tooltipStyle: s }) => {
	let [c, l] = h(!1), [u, d] = h({
		top: 0,
		left: 0
	}), f = m(null), p = e.split("\n").map((e) => e.trim()).filter(Boolean), g = () => {
		if (f.current) {
			let e = f.current.getBoundingClientRect(), t = Math.min(e.left, window.innerWidth - 296);
			d({
				top: e.bottom + 8,
				left: Math.max(8, t)
			});
		}
		n?.(), l(!0);
	};
	return /* @__PURE__ */ v("div", {
		className: `relative inline-block ${r}`,
		children: [/* @__PURE__ */ _("div", {
			ref: f,
			className: "cursor-pointer",
			onMouseEnter: g,
			onMouseLeave: () => l(!1),
			onFocus: g,
			onBlur: () => l(!1),
			children: t || /* @__PURE__ */ _(Hx, {
				className: `icon icon-tooltip ${i}`,
				style: a || { color: "var(--icon-tooltip-questionmarkcircleicon-color)" },
				onMouseEnter: (e) => e.currentTarget.style.color = "var(--icon-tooltip-questionmarkcircleicon-color-hover)",
				onMouseLeave: (e) => e.currentTarget.style.color = "var(--icon-tooltip-questionmarkcircleicon-color)"
			})
		}), c && b(/* @__PURE__ */ _("div", {
			className: `fixed z-[9999] w-72 rounded-md border p-4 text-sm shadow-md ${o || "rotate-1 border-yellow-300 bg-yellow-200 text-black"}`,
			style: {
				top: u.top,
				left: u.left,
				...s
			},
			children: /* @__PURE__ */ _("div", {
				className: "space-y-1.5 whitespace-pre-wrap leading-snug",
				children: p.map((e, t) => {
					let n = e.indexOf(":");
					if (n <= 0) return /* @__PURE__ */ _("div", { children: e }, `${e}-${t}`);
					let r = e.slice(0, n), i = e.slice(n + 1).trim();
					return /* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ v("strong", { children: [r, ":"] }),
						" ",
						/* @__PURE__ */ _("span", { children: i })
					] }, `${r}-${t}`);
				})
			})
		}), document.body)]
	});
}, Wx = {
	internal: {
		title: "Internal Source",
		description: "Managed databases stored in Dataserver. Best for full exploration, edits, governance, and profiling.",
		capabilities: "Supports filtering, sampling, stats, edits, exports, and governance metadata."
	},
	metadata: {
		title: "Metadata Source",
		description: "System catalog of registered assets, metadata, and governance coverage across available datasets.",
		capabilities: "Best for inventory and governance review. Read-only by design."
	},
	external_pg: {
		title: "External PostgreSQL Source",
		description: "Remote PostgreSQL connections surfaced in the grid without copying data into the managed registry.",
		capabilities: "Currently read-only in this UI and may be unavailable until a connection is configured."
	},
	json: {
		title: "JSON Source",
		description: "Lightweight JSON or URL-backed datasets for quick inspection and exploration.",
		capabilities: "Currently read-only in this UI and may be unavailable until a source is configured."
	}
};
function Gx(e) {
	let t = e?.samplingState;
	if (!t?.isSamplingEnabled) return null;
	let n = t.samplePercentage ?? 0, r = t.sampledRows, i = t.totalRows;
	return typeof r == "number" && r > 0 && typeof i == "number" && i > 0 ? `${n}% (${r.toLocaleString()} / ${i.toLocaleString()} rows)` : typeof r == "number" && r > 0 ? `${n}% (${r.toLocaleString()} rows)` : `${n}%`;
}
function Kx(e) {
	if (e == null || e === "") return null;
	if (typeof e == "boolean") return e ? "Yes" : "No";
	if (typeof e == "number") return Number.isFinite(e) ? e.toLocaleString() : String(e);
	if (typeof e == "string") {
		let t = e.trim();
		if (!t) return null;
		let n = Date.parse(t);
		return !Number.isNaN(n) && /(T|\d{4}-\d{2}-\d{2})/.test(t) ? new Date(n).toLocaleString() : t;
	}
	return String(e);
}
function qx(e) {
	let t = e.source_descriptor ?? e.sourceDescriptor;
	return t && typeof t == "object" ? t : {};
}
function Jx({ tableName: e, databaseLabel: t, sourceTypeLabel: n, originalFileName: r, databaseInfo: i, samplingSummary: a, activeFilterCount: o, totalColumns: s, totalRows: c }) {
	let l = i ?? {}, u = [
		["Table", e],
		["Database", t ?? r ?? l.original_file_name],
		["Source Type", n],
		["Datasource Type", l.datasource_type],
		["Source Key", l.source_database_key],
		["Source File", r ?? l.original_file_name],
		["Description", l.description],
		["Columns", typeof s == "number" ? s : null],
		["Total Rows", typeof c == "number" ? c : null],
		["Rows in View", l.metadataSummary?.activity?.recentEvents],
		["Filters Active", typeof o == "number" ? o : null],
		["Sampling", a]
	].map(([e, t]) => {
		let n = Kx(t);
		return n ? `${e}: ${n}` : null;
	}).filter((e) => !!e);
	return u.length > 0 ? u.join("\n") : "Table metadata unavailable";
}
function Yx({ databaseLabel: e, databaseInfo: t, isLoading: n = !1 }) {
	let r = t ?? {}, i = r.metadataSummary ?? {}, a = r.engineMetadata ?? {}, o = qx(r), s = (Array.isArray(r.ownerships) ? r.ownerships : []).filter((e) => !e?.revoked_at && e?.role && e?.user_id != null).map((e) => `${e.role} (#${e.user_id})`), c = [
		["Database", e ?? r.original_file_name],
		["File", r.original_file_name],
		["Datasource Type", r.datasource_type],
		["Source Key", r.source_database_key],
		["Description", r.description],
		["Author", r.author],
		["Category", r.category],
		["Tags", Array.isArray(r.tags) ? r.tags.join(", ") : r.tags],
		["Version", r.schema_version],
		["Owner ID", r.current_owner_id ?? i.ownership?.primaryOwnerUserId ?? r.activeOwner?.user_id],
		["Steward ID", r.current_steward_id ?? r.activeSteward?.user_id],
		["Ownership Roles", s.length > 0 ? s.join(", ") : null],
		["Created", r.created_at],
		["Updated", r.updated_at],
		["Validated", r.validation_date],
		["Classification", r.classification ?? i.classification?.classification],
		["Retention", i.classification?.retentionPolicy ?? r.retention_policy_days],
		["Quality Score", r.quality_score ?? i.quality?.qualityScore],
		["Last Quality Check", r.last_quality_check_at ?? i.quality?.lastCheckAt],
		["Quality Status", r.last_quality_check_status ?? i.quality?.lastCheckStatus],
		["Tables", r.number_of_tables ?? a.tables_count],
		["Views", a.views_count],
		["Indexes", a.indices_count],
		["Triggers", a.triggers_count],
		["Database Size", r.size ?? a.database_size],
		["SQLite Version", a.version],
		["Encoding", a.encoding],
		["License", r.license],
		["Language", r.language],
		["Source Host", o.host],
		["Source Database", o.databaseName],
		["Credential Configured", o.credentialConfigured],
		["Public", r.is_public]
	].map(([e, t]) => {
		let n = Kx(t);
		return n ? `${e}: ${n}` : null;
	}).filter((e) => !!e);
	return n && c.push("Metadata: Loading..."), c.length > 0 ? c.join("\n") : "Database metadata unavailable";
}
function Xx(e, t) {
	if (!e) return "Source Type: Unknown";
	let n = Wx[e] ?? {
		title: t ?? e,
		description: "Source type metadata is not available for this selection.",
		capabilities: ""
	};
	return [
		["Source Type", t ?? n.title],
		["What It Is", n.description],
		["Capabilities", n.capabilities || null]
	].map(([e, t]) => {
		let n = Kx(t);
		return n ? `${e}: ${n}` : null;
	}).filter((e) => !!e).join("\n");
}
var Zx = ({ label: e, options: t, value: n, onChange: r, loading: i, disabled: a, variant: o = "subtle" }) => o === "primary" ? /* @__PURE__ */ v("div", {
	className: "relative inline-flex items-center gap-1.5 px-3 py-1 rounded-lg border border-accent/30 bg-accent/5 hover:bg-accent/10 hover:border-accent/50 transition-all cursor-pointer group",
	children: [
		/* @__PURE__ */ _("span", {
			className: "font-semibold text-accent text-sm leading-tight",
			children: i ? "…" : e
		}),
		/* @__PURE__ */ _("svg", {
			className: "w-3.5 h-3.5 text-accent/60 group-hover:text-accent transition-colors flex-shrink-0",
			fill: "none",
			viewBox: "0 0 24 24",
			stroke: "currentColor",
			strokeWidth: 2.5,
			children: /* @__PURE__ */ _("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M19 9l-7 7-7-7"
			})
		}),
		/* @__PURE__ */ _("select", {
			className: "absolute inset-0 opacity-0 cursor-pointer w-full h-full",
			value: n,
			onChange: (e) => r(e.target.value),
			disabled: a || i || t.length === 0,
			children: t.map((e) => /* @__PURE__ */ _("option", {
				value: e.value,
				children: e.label
			}, e.value))
		})
	]
}) : /* @__PURE__ */ v("div", {
	className: "relative inline-flex items-center gap-1 cursor-pointer group",
	children: [
		/* @__PURE__ */ _("span", {
			className: "text-xs text-muted-dark group-hover:text-info-dark transition-colors leading-tight",
			children: i ? "…" : e
		}),
		/* @__PURE__ */ _("svg", {
			className: "w-2.5 h-2.5 text-muted-dark/50 group-hover:text-info-dark/70 transition-colors flex-shrink-0",
			fill: "none",
			viewBox: "0 0 24 24",
			stroke: "currentColor",
			strokeWidth: 2.5,
			children: /* @__PURE__ */ _("path", {
				strokeLinecap: "round",
				strokeLinejoin: "round",
				d: "M19 9l-7 7-7-7"
			})
		}),
		/* @__PURE__ */ _("select", {
			className: "absolute inset-0 opacity-0 cursor-pointer w-full h-full",
			value: n,
			onChange: (e) => r(e.target.value),
			disabled: a || i || t.length === 0,
			children: t.map((e) => /* @__PURE__ */ _("option", {
				value: e.value,
				children: e.label
			}, e.value))
		})
	]
}), Qx = ({ databaseId: e, tableName: t, originalFileName: n, databaseInfo: r, databaseInfoLoading: i = !1, onRequestDatabaseInfo: a, totalColumns: o, totalRows: s, effectiveFilters: c, handleClearAllFilters: l, sampling: u, toggleSidebarFilters: d, headerSelectors: f, vendorAudit: p }) => {
	let m = Object.keys(c || {}).filter((e) => e !== "__sampling"), h = Gx(u), y = f?.sourceType?.label ?? null, b = f?.database?.label ?? n ?? null, x = Jx({
		tableName: t,
		databaseLabel: b,
		sourceTypeLabel: y,
		originalFileName: n,
		databaseInfo: r,
		samplingSummary: h,
		activeFilterCount: m.length,
		totalColumns: o,
		totalRows: s
	}), S = Yx({
		databaseLabel: b,
		databaseInfo: r,
		isLoading: i
	}), C = Xx(f?.sourceType?.currentValue, y), { sourceType: w, database: T, table: E, error: D } = f ?? {}, O = p?.tableGrade === "FAIL" ? "border-rose-200 bg-rose-50 text-rose-700" : p?.tableGrade === "WARN" ? "border-amber-200 bg-amber-50 text-amber-700" : "border-emerald-200 bg-emerald-50 text-emerald-700";
	return /* @__PURE__ */ _("div", {
		className: "w-full px-4 py-2 border-b border-border-light bg-background-dark",
		children: /* @__PURE__ */ v("div", {
			className: "flex items-center min-w-0",
			children: [
				/* @__PURE__ */ v("div", {
					className: "flex items-center gap-2 flex-shrink-0 min-w-0",
					children: [
						w ? /* @__PURE__ */ _(Ux, {
							text: C,
							children: /* @__PURE__ */ _(Zx, {
								label: w.label,
								options: w.options,
								value: w.currentValue,
								onChange: w.onChange,
								loading: w.loading,
								disabled: w.disabled,
								variant: "subtle"
							})
						}) : /* @__PURE__ */ v("span", {
							className: "text-xs text-muted-dark",
							children: [
								/* @__PURE__ */ _("span", {
									className: "opacity-60",
									children: "Database:"
								}),
								" ",
								/* @__PURE__ */ _("span", {
									className: "text-info-dark",
									children: e || "N/A"
								})
							]
						}),
						T && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("span", {
							className: "text-border-light select-none",
							children: "/"
						}), /* @__PURE__ */ _(Ux, {
							text: S,
							onOpen: a,
							children: /* @__PURE__ */ _(Zx, {
								label: T.label,
								options: T.options,
								value: T.currentValue,
								onChange: T.onChange,
								loading: T.loading,
								disabled: T.disabled,
								variant: "subtle"
							})
						})] }),
						!w && n && t && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("span", {
							className: "text-border-light select-none",
							children: "/"
						}), /* @__PURE__ */ _("span", {
							className: "text-xs text-info-dark font-medium truncate max-w-[160px]",
							children: n
						})] }),
						D && /* @__PURE__ */ _("span", {
							className: "text-xs text-amber-600 ml-1",
							children: D
						})
					]
				}),
				/* @__PURE__ */ _("div", {
					className: "flex-1 flex justify-center items-center",
					children: E && t ? /* @__PURE__ */ _(Ux, {
						text: x,
						onOpen: a,
						children: /* @__PURE__ */ _(Zx, {
							label: t,
							options: E.options.map((e) => ({
								value: e,
								label: e
							})),
							value: t,
							onChange: E.onChange,
							loading: E.loading,
							disabled: E.disabled,
							variant: "primary"
						})
					}) : /* @__PURE__ */ _(Ux, {
						text: x,
						onOpen: a,
						children: /* @__PURE__ */ _("span", {
							className: "font-medium flex items-center gap-1 text-accent text-sm",
							children: t
						})
					})
				}),
				/* @__PURE__ */ v("div", {
					className: "flex items-center gap-1 flex-shrink-0 text-xs",
					children: [
						p?.hasActiveRules && /* @__PURE__ */ v(g, { children: [
							/* @__PURE__ */ v("span", {
								className: `mr-2 inline-flex items-center rounded-full border px-2 py-1 text-[11px] font-semibold uppercase tracking-[0.14em] ${O}`,
								children: ["Audit ", p.tableGrade ?? p.latestSummary?.grade ?? "Ready"]
							}),
							p.onOpenQualityPanel && /* @__PURE__ */ v("button", {
								onClick: p.onOpenQualityPanel,
								className: "rounded-full border border-border-light px-2 py-1 text-[11px] font-medium text-info-dark hover:bg-background",
								title: `${p.activeRuleCount} active SLA rule${p.activeRuleCount === 1 ? "" : "s"}`,
								children: [p.activeRuleCount, " SLA"]
							}),
							p.latestPdfReport && p.onDownloadLatestPdf && /* @__PURE__ */ _("button", {
								onClick: p.onDownloadLatestPdf,
								className: "rounded-full border border-border-light px-2 py-1 text-[11px] font-medium text-info-dark hover:bg-background",
								children: "PDF"
							})
						] }),
						h && /* @__PURE__ */ v("button", {
							onClick: () => d?.("sampling"),
							className: "mr-2 inline-flex items-center rounded-full border border-action-sample px-2 py-1 text-[11px] font-medium text-action-sample hover:bg-background",
							title: "Open sampling panel",
							children: ["Sampled: ", h]
						}),
						/* @__PURE__ */ _("span", {
							className: "text-muted-dark",
							children: "Active Filters:"
						}),
						/* @__PURE__ */ _("span", {
							className: "text-info-dark",
							children: m.length === 0 ? "None" : m.join(", ")
						}),
						m.length > 0 && /* @__PURE__ */ _("button", {
							onClick: l,
							className: "ml-1 rounded-full px-1 text-action-clear hover:text-action-clear-hover transition-colors",
							title: "Clear all filters",
							children: "(Clear)"
						})
					]
				})
			]
		})
	});
}, $x = ({ heightMode: e, statsPanelOpen: t, onStatsPanelClose: r, statsData: i, isLoadingStats: a, selectedColumn: o, tableName: c, viewModalOpen: l, closeViewModal: u, selectedRow: d, viewModalTitle: f, viewModalMode: p, handleRowSave: m, idField: g, shouldEnableHorizontalScroll: y, tableMaxHeight: b, children: x, databaseId: S, originalFileName: C, databaseInfo: w, databaseInfoLoading: T, onRequestDatabaseInfo: E, totalColumns: D, totalRows: O, effectiveFilters: k, handleClearAllFilters: A, toggleSidebarFilters: j, isSidebarFiltersOpen: M, onSidebarFiltersClose: N, initialSidebarTab: P = "filters", onSidebarTabChange: F, columns: I = [], data: L = [], numericColumns: R = [], filters: z = {}, applyFilter: B, clearFilter: V, columnTypes: H = {}, fetchUniqueValues: ee, openStatsPanel: U, sampling: te, columnOrder: W, pinnedColumns: ne, onColumnPin: re, onColumnReorder: ie, columnWidths: ae, onColumnResize: oe, columnLabels: se, headerSelectors: ce, vendorAudit: le, auditSummary: ue, auditReports: de, auditRuleCount: fe, auditLoading: pe, auditError: me, onGenerateAuditReport: he, onDownloadAuditReport: ge, onRefreshAudit: _e, showHeaderInfoBar: ve = !0 }) => {
	let [ye, be] = h(null), [xe, Se] = h(null), Ce = e === "fill", we = s((e, t) => {
		be(e), Se(t);
	}, []);
	return /* @__PURE__ */ v("div", {
		className: `relative flex min-h-0 min-w-0 w-full flex-row ${Ce ? "h-full" : "h-auto"}  `,
		children: [
			M && S && c && /* @__PURE__ */ _(Bx, {
				isOpen: M,
				onClose: N || (() => {}),
				columns: I,
				data: L,
				databaseId: S,
				tableName: c,
				filters: z,
				applyFilter: B || (() => {}),
				clearFilter: V || (() => {}),
				clearAllFilters: A,
				columnTypes: H,
				fetchUniqueValues: ee || (async () => []),
				openStatsPanel: U,
				initialTab: P,
				onTabChange: F,
				sampling: te,
				onActiveCohortChange: we
			}),
			/* @__PURE__ */ _(zy, {
				isOpen: t,
				onClose: r,
				stats: i,
				isLoading: a,
				columnName: o || "",
				tableName: c,
				databaseId: S,
				tableData: L,
				numericColumns: R,
				filters: z,
				sampling: te,
				activeCohortName: ye,
				activeCohortRowsetKey: xe,
				auditSummary: ue,
				auditReports: de,
				auditRuleCount: fe,
				auditLoading: pe,
				auditError: me,
				onGenerateAuditReport: he,
				onDownloadAuditReport: ge,
				onRefreshAudit: _e
			}),
			/* @__PURE__ */ v("div", {
				className: `flex min-h-0 min-w-0 flex-1 flex-col transition-all duration-300 ${Ce ? "h-full" : "h-auto"}`,
				style: { minWidth: t ? "calc(100% - 350px)" : "100%" },
				children: [
					l && typeof cb == "function" && /* @__PURE__ */ _(cb, {
						isOpen: l,
						onClose: u,
						rowData: d,
						title: f,
						mode: p,
						columns: W && W.length > 0 ? W : I,
						columnTypes: H,
						columnLabels: se,
						idField: g,
						loadReferenceOptions: ee ? async ({ column: e, searchTerm: t, limit: n }) => (await ee(e, t)).slice(0, n) : void 0,
						onSave: async (e) => {
							try {
								return await m(e), !0;
							} catch (e) {
								return console.error("Error saving row:", e), !1;
							}
						}
					}),
					ve ? /* @__PURE__ */ _(Qx, {
						databaseId: S,
						tableName: c,
						originalFileName: C,
						databaseInfo: w,
						databaseInfoLoading: T,
						onRequestDatabaseInfo: E,
						totalColumns: D,
						totalRows: O,
						effectiveFilters: k,
						handleClearAllFilters: A,
						sampling: te,
						toggleSidebarFilters: j,
						headerSelectors: ce,
						vendorAudit: le
					}) : null,
					n.Children.map(x, (e) => n.isValidElement(e) ? n.cloneElement(e, {
						columnOrder: W,
						pinnedColumns: ne,
						onColumnPin: re,
						onColumnReorder: ie,
						columnWidths: ae,
						onColumnResize: oe
					}) : e)
				]
			})
		]
	});
};
//#endregion
//#region src/hooks/useModalLogic.ts
function eS(e, t, n, r, i, a = {}) {
	let o = Di(), [c, l] = h(!1), [u, d] = h(""), [f, p] = h(""), [g, _] = h(null), [v, y] = h([]), [b, x] = h({
		min: 0,
		max: 100
	}), [S, C] = h(/* @__PURE__ */ new Set()), [w, T] = h({
		min: 0,
		max: 100
	}), [E, O] = h(""), [k, A] = h(!1), j = D("useModalLogic"), M = m(!1), N = m(null), P = s((t, n) => {
		if (t !== "Filter") return;
		if (!n) {
			j.warn("Cannot open modal without column name");
			return;
		}
		if (M.current) {
			j.debug("Ignoring modal open request during closing transition");
			return;
		}
		j.debug("Opening modal", {
			option: t,
			column: n
		}), p(n), d(`${t}: ${n}`), l(!0), O("");
		let r = e.map((e) => e[n]), i = r.filter((e) => typeof e == "number");
		if (i.length > 0 && i.length === r.filter(Boolean).length) {
			_("numeric");
			let e = Math.min(...i), t = Math.max(...i);
			T({
				min: e,
				max: t
			}), j.debug("Set numeric filter range", {
				column: n,
				min: e,
				max: t
			});
		} else {
			if (_("categorical"), a && a[n] && Array.isArray(a[n])) {
				let e = new Set(a[n].map(String));
				C(e), j.debug("Restored previous categorical filter selection", {
					column: n,
					selection: Array.from(e)
				});
			} else C(/* @__PURE__ */ new Set());
			L("", n);
		}
	}, [e, a]), F = s(() => {
		l(!1), p(""), d(""), _(null), y([]), C(/* @__PURE__ */ new Set()), T({
			min: 0,
			max: 0
		});
	}, []), I = s(() => {
		r && f && (g === "categorical" && S ? r(f, S instanceof Set ? Array.from(S) : S) : (g === "numeric" || g === "date") && r(f, w)), F();
	}, [
		r,
		F,
		g,
		w,
		f,
		S
	]), L = s((e, r) => {
		let i = r ?? f;
		!n || !t || !i || (N.current && clearTimeout(N.current), A(!0), N.current = setTimeout(async () => {
			try {
				j.debug("Fetching unique values from server", {
					databaseId: n,
					tableName: t,
					column: i,
					searchTerm: e
				});
				let r = await o.fetchUniqueColumnValues(n, t, i, e, 100);
				Array.isArray(r) ? (y(r), j.debug("Received unique values from server", { count: r.length })) : (j.warn("Invalid response format for unique values"), R(e));
			} catch (r) {
				j.error("Failed to fetch unique values", {
					error: r,
					databaseId: n,
					tableName: t,
					column: i
				}), R(e);
			} finally {
				A(!1), N.current = null;
			}
		}, 300));
	}, [
		n,
		t,
		f,
		g,
		e,
		o
	]), R = s((t) => {
		j.debug("Falling back to client-side filtering", { term: t });
		let n = e.map((e) => e[f]).filter((e) => e && e.toString().toLowerCase().includes(t.toLowerCase())), r = new Set(n.map(String));
		y(Array.from(r)), j.debug("Client-side unique values filtered", {
			count: r.size,
			searchTerm: t
		});
	}, [e, f]);
	return {
		isModalOpen: c,
		modalContent: u,
		filterType: g,
		uniqueValues: v,
		minMax: b,
		selectedValues: S,
		setSelectedValues: C,
		rangeValues: w,
		setRangeValues: T,
		closeModal: F,
		applyFilterAndClose: I,
		searchTerm: E,
		setSearchTerm: O,
		openModal: P,
		selectedColumn: f,
		isLoadingValues: k
	};
}
//#endregion
//#region src/components/grid/ColumnMenu.tsx
var tS = ({ options: e, onSelect: t, onClose: n, currentFilter: r, currentWidth: i, isPinned: a = "none" }) => {
	let [o, s] = h(-1), c = m(null);
	u(() => {
		let r = (r) => {
			switch (r.key) {
				case "ArrowDown":
					r.preventDefault(), s((t) => t < e.length - 1 ? t + 1 : 0);
					break;
				case "ArrowUp":
					r.preventDefault(), s((t) => t > 0 ? t - 1 : e.length - 1);
					break;
				case "Enter":
					o >= 0 && o < e.length && t(e[o]);
					break;
				case "Escape":
					n();
					break;
				default: break;
			}
		};
		return document.addEventListener("keydown", r), () => document.removeEventListener("keydown", r);
	}, [
		o,
		e,
		t,
		n
	]), u(() => {
		let e = c.current;
		return e && e.focus(), () => {};
	}, []), u(() => {
		let e = c.current;
		typeof window < "u" && typeof window.getComputedStyle == "function" && typeof document < "u" && document.documentElement && e && (e.style.opacity = getComputedStyle(document.documentElement).getPropertyValue("--dropdown-menu-initial-opacity"), e.style.transform = `translateY(${getComputedStyle(document.documentElement).getPropertyValue("--dropdown-menu-initial-transform")})`, setTimeout(() => {
			e.style.opacity = getComputedStyle(document.documentElement).getPropertyValue("--dropdown-menu-final-opacity"), e.style.transform = `translateY(${getComputedStyle(document.documentElement).getPropertyValue("--dropdown-menu-final-transform")})`;
		}, 10));
	}, []);
	let l = e.reduce((e, t, n) => {
		if (typeof t == "string") e.default ||= [], e.default.push({
			option: t,
			index: n
		});
		else {
			let r = t.section || "default";
			e[r] || (e[r] = []), e[r].push({
				option: t,
				index: n
			});
		}
		return e;
	}, {}), d = {
		default: {
			title: "",
			order: 0
		},
		pinning: {
			title: "Column Pinning",
			order: 1
		},
		width: {
			title: "Width Management",
			order: 2
		}
	}, f = Object.keys(l).sort((e, t) => (d[e]?.order ?? 999) - (d[t]?.order ?? 999)), p = (e) => {
		let t = typeof e == "string" ? e : e.label;
		return t === "Clear Filter" && !r || t === "Unpin Column" && a === "none";
	};
	return /* @__PURE__ */ _("div", {
		ref: c,
		className: "max-h-[min(22rem,calc(100vh-6rem))] min-w-[200px] overflow-y-auto rounded border border-border-light bg-background py-0.5 shadow-lg focus:outline-none",
		tabIndex: 0,
		role: "menu",
		"aria-orientation": "vertical",
		children: f.map((e, n) => {
			let i = l[e], c = d[e]?.title || "";
			return /* @__PURE__ */ v("div", { children: [
				n > 0 && /* @__PURE__ */ _("div", { className: "my-0.5 border-t border-border-light" }),
				c && /* @__PURE__ */ _("div", {
					className: "bg-background-light px-2 py-0.5 text-[10px] font-medium uppercase tracking-wide text-muted-dark",
					children: c
				}),
				i.map(({ option: e, index: n }) => {
					let i = typeof e == "string" ? e : e.label, c = typeof e == "object" ? e.icon : null, l = typeof e == "object" ? e.description : null, u = typeof e == "object" ? e.futureWidth : null, d = p(e);
					return /* @__PURE__ */ v("button", {
						className: [
							"flex w-full items-center px-2.5 py-1.5 text-left text-xs leading-4 transition-colors duration-150",
							"bg-background text-text",
							o === n ? "bg-background-light text-primary" : "",
							d ? "opacity-50 cursor-not-allowed" : "hover:bg-background-light hover:text-primary",
							"focus:outline-none"
						].join(" "),
						role: "menuitem",
						onClick: () => !d && t(e),
						onMouseEnter: () => s(n),
						disabled: d,
						tabIndex: -1,
						type: "button",
						children: [
							c && /* @__PURE__ */ _("span", {
								className: "mr-2 flex h-4 w-4 flex-shrink-0 items-center justify-center [&>svg]:h-4 [&>svg]:w-4",
								children: c
							}),
							/* @__PURE__ */ v("div", {
								className: "flex-1 flex flex-col overflow-hidden",
								children: [/* @__PURE__ */ _("span", {
									className: "truncate",
									children: i
								}), l && /* @__PURE__ */ _("span", {
									className: "truncate text-[10px] leading-3 text-muted-dark",
									children: l
								})]
							}),
							i === "Filter" && r && /* @__PURE__ */ _("span", {
								className: "ml-2 rounded-full bg-accent px-1.5 py-0.5 text-[10px] font-semibold text-background",
								children: "Active"
							}),
							i.includes("Pin") && a !== "none" && /* @__PURE__ */ _("span", {
								className: "ml-2 text-[10px] text-info-dark",
								children: a === "left" ? "Left" : "Right"
							}),
							i.includes("Width") && u && /* @__PURE__ */ v("span", {
								className: "ml-2 font-mono text-[10px] text-accent-dark",
								children: [u, "px"]
							})
						]
					}, n);
				})
			] }, e);
		})
	});
}, nS = ({ missingPercentage: e }) => {
	let t = () => e === 0 ? "bg-success-dark" : e < 0 ? "bg-error-dark" : e < 10 ? "bg-success-light" : e < 50 ? "bg-warning-light" : "bg-error-light", n = 100 - e;
	return /* @__PURE__ */ _("div", {
		className: "w-full h-[2px] bg-border-light rounded",
		title: `${e}% missing data`,
		children: /* @__PURE__ */ _("div", {
			className: `h-full transition-all duration-300 rounded ${t()}`,
			style: { width: `${n}%` }
		})
	});
};
function rS(e) {
	return e?.trim().toLowerCase() === "rowid";
}
function iS(e) {
	return rS(e) ? 88 : 150;
}
function aS(e, t = {}) {
	let n = t[e];
	return Number.isFinite(n) && n > 0 ? n : iS(e);
}
//#endregion
//#region src/components/grid/ColumnHeader.tsx
var oS = ({ className: e, ...t }) => /* @__PURE__ */ _("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	className: `inline-block align-middle w-5 h-5${e ? " " + e : ""}`,
	...t,
	children: /* @__PURE__ */ v("g", {
		transform: "translate(1.5, 4)",
		children: [/* @__PURE__ */ _("text", {
			x: "0",
			y: "8",
			fontSize: "9",
			fontWeight: "bold",
			fontFamily: "monospace",
			children: "123"
		}), /* @__PURE__ */ _("line", {
			x1: "0",
			y1: "11",
			x2: "15",
			y2: "11",
			stroke: "currentColor",
			strokeWidth: "1"
		})]
	})
}), sS = ({ column: e, sortBy: t, order: r, handleSort: i, clearFilter: a, filter: o, openModal: s, openStats: c, missingData: l = {}, columnType: u = "categorical", isPinned: d = "none", pinnedIndex: f = 0, onColumnPin: p, columnWidth: m, onColumnResize: g, pinnedColumns: y = {
	left: [],
	right: []
}, columnWidths: b = {}, actionColumnWidth: x = 0, vendorAuditStatus: S, headerDisplay: C, headerTypography: w, headerLabel: T, renderColumnHeaderAction: E }) => {
	let [D, O] = h(null), [k, A] = h(!1), j = n.useRef(null), M = n.useRef(null), N = rS(e);
	n.useEffect(() => {
		let e = (e) => {
			j.current && !j.current.contains(e.target) && O(null);
		};
		return document.addEventListener("mousedown", e), () => {
			document.removeEventListener("mousedown", e);
		};
	}, []), n.useEffect(() => {
		let e = (e) => {
			D && e.key === "Escape" && O(null);
		};
		return document.addEventListener("keydown", e), () => {
			document.removeEventListener("keydown", e);
		};
	}, [D]);
	let P = () => {
		O(D === e ? null : e);
	}, F = (t) => {
		P(), t === "Filter" ? s(t, e) : t === "Statistics" && (c ? c(e) : s(t, e));
	}, I = (t) => {
		t.stopPropagation(), i(e);
	}, L = (t) => {
		console.log(`Column text clicked: "${e}"`, t);
	}, R = (t) => {
		t.stopPropagation();
		let n = t.currentTarget;
		n.classList.add("animate-pulse"), setTimeout(() => {
			n.classList.remove("animate-pulse");
		}, 500), c ? c(e) : s("Statistics", e);
	}, z = l[e] || 0, B = u === "media", V = (() => {
		switch (u) {
			case "numerical": return oS;
			case "date": return no;
			default: return io;
		}
	})(), H = (() => {
		switch (u) {
			case "numerical": return "Show numerical statistics";
			case "date": return "Show date distribution";
			default: return "Show category statistics";
		}
	})(), ee = () => {
		switch (u) {
			case "numerical": return "text-datatype-numeric";
			case "date": return "text-datatype-date";
			default: return "text-datatype-categorical";
		}
	}, U = () => {
		switch (u) {
			case "numerical": return "hover:text-datatype-numeric-light";
			case "date": return "hover:text-datatype-date-light";
			default: return "hover:text-datatype-categorical-light";
		}
	}, te = S === "FAIL" ? "bg-rose-50 text-rose-700 border-rose-200" : S === "WARN" ? "bg-amber-50 text-amber-700 border-amber-200" : "bg-emerald-50 text-emerald-700 border-emerald-200", W = {
		showColumnMenu: C?.showColumnMenu ?? !0,
		showSortControls: C?.showSortControls ?? !0,
		sortControlVisibility: C?.sortControlVisibility ?? "always",
		showColumnHeaderActions: C?.showColumnHeaderActions ?? !0,
		showFilterControls: C?.showFilterControls ?? !0,
		showStatisticsControls: C?.showStatisticsControls ?? !0,
		showDatatypeIcons: (C?.showDatatypeIcons ?? !0) && (C?.showStatisticsControls ?? !0),
		showMissingDataIndicator: C?.showMissingDataIndicator ?? !0
	}, ne = W.showSortControls && (N ? t === e : W.sortControlVisibility === "always" || t === e), re = () => {
		if (d === "none") return {};
		if (d === "left") {
			let e = x;
			for (let t = 0; t < f; t++) {
				let n = y.left[t], r = aS(n, b);
				e += r;
			}
			return {
				position: "sticky",
				left: `${e}px`,
				zIndex: 15,
				backgroundColor: "var(--color-background)",
				boxShadow: "2px 0 4px rgba(0,0,0,0.1)"
			};
		} else if (d === "right") {
			let e = 0;
			for (let t = f + 1; t < y.right.length; t++) {
				let n = y.right[t], r = aS(n, b);
				e += r;
			}
			return {
				position: "sticky",
				right: `${e}px`,
				zIndex: 15,
				backgroundColor: "var(--color-background)",
				boxShadow: "-2px 0 4px rgba(0,0,0,0.1)"
			};
		}
		return {};
	}, ie = (t) => {
		if (!g) return;
		A(!0);
		let n = t.clientX, r = m || iS(e), i = (t) => {
			let i = t.clientX - n;
			g(e, Math.max(iS(e), r + i));
		}, a = () => {
			A(!1), document.removeEventListener("mousemove", i), document.removeEventListener("mouseup", a);
		};
		document.addEventListener("mousemove", i), document.addEventListener("mouseup", a);
	}, ae = (e, t = "14px sans-serif") => {
		let n = document.createElement("canvas").getContext("2d");
		return n ? (n.font = t, n.measureText(e).width) : e.length * 8;
	}, oe = (t) => {
		if (N) return 88;
		let n = ae(e, "14px medium sans-serif") + 60, r = {
			numerical: 80,
			date: 120,
			categorical: 100,
			media: 100
		}[u] || 80;
		switch (t) {
			case "min": return Math.max(r, n * .8);
			case "avg": return Math.min(Math.max(n, r * (u === "numerical" ? 1.2 : u === "date" ? 1.5 : 1.8)), 500);
			case "auto":
				let e = u === "numerical" ? 1.5 : u === "date" ? 2 : 2.5;
				return Math.min(Math.max(n * e, r * e), 500);
			default: return 150;
		}
	}, se = () => {
		let e = ee(), t = "inline-block align-middle w-4 h-4", n = Math.round(oe("auto")), r = Math.round(oe("min")), i = Math.round(oe("avg")), a = [
			...W.showSortControls ? [{
				label: "Sort Ascending",
				icon: /* @__PURE__ */ _(Ia, { className: `${t} text-muted-dark` })
			}, {
				label: "Sort Descending",
				icon: /* @__PURE__ */ _(Ea, { className: `${t} text-muted-dark` })
			}] : [],
			...!B && W.showStatisticsControls ? [{
				label: "Statistics",
				icon: /* @__PURE__ */ _(V, { className: `${t} ${e}` })
			}] : [],
			...W.showFilterControls ? [{
				label: "Filter",
				icon: /* @__PURE__ */ _(Lo, { className: `${t} text-muted-dark` })
			}, {
				label: "Clear Filter",
				icon: /* @__PURE__ */ _(ys, { className: `${t} text-error-dark` })
			}] : []
		], o = [];
		return p && (d !== "left" && o.push({
			label: "Pin to Left",
			icon: /* @__PURE__ */ _(Aa, { className: `${t} text-info-dark` }),
			section: "pinning"
		}), d !== "right" && o.push({
			label: "Pin to Right",
			icon: /* @__PURE__ */ _(Pa, { className: `${t} text-info-dark` }),
			section: "pinning"
		}), d !== "none" && o.push({
			label: "Unpin Column",
			icon: /* @__PURE__ */ _(Ra, { className: `${t} text-warning-dark` }),
			section: "pinning"
		})), g && o.push({
			label: "Auto-fit Width",
			icon: /* @__PURE__ */ _(Ra, { className: `${t} text-accent` }),
			futureWidth: n,
			section: "width"
		}, {
			label: "Set Minimum Width",
			icon: /* @__PURE__ */ _("span", {
				className: "inline-block align-middle text-accent text-[10px] font-mono",
				children: "Min"
			}),
			futureWidth: r,
			section: "width"
		}, {
			label: "Set Average Width",
			icon: /* @__PURE__ */ _("span", {
				className: "inline-block align-middle text-accent text-[10px] font-mono",
				children: "Avg"
			}),
			futureWidth: i,
			section: "width"
		}), [...a, ...o];
	}, ce = (n) => {
		let o = typeof n == "string" ? n : n.label;
		o === "Pin to Left" && p ? (p(e, "left"), P()) : o === "Pin to Right" && p ? (p(e, "right"), P()) : o === "Unpin Column" && p ? (p(e, "none"), P()) : o === "Auto-fit Width" && g ? (g(e, oe("auto")), P()) : o === "Set Minimum Width" && g ? (g(e, oe("min")), P()) : o === "Set Average Width" && g ? (g(e, oe("avg")), P()) : o === "Sort Ascending" ? (i(e), t === e && r !== "asc" && i(e), P()) : o === "Sort Descending" ? (i(e), (t !== e || r !== "desc") && (t === e && r === "asc" ? i(e) : t !== e && (i(e), i(e))), P()) : o === "Clear Filter" ? (a(e), P()) : o === "Statistics" && c ? (c(e), P()) : F(o);
	}, le = d === "right" && y && f === y.right.length - 1, ue = {
		...re(),
		zIndex: d === "none" ? 10 : 15,
		width: `${m || iS(e)}px`,
		minWidth: `${m || iS(e)}px`,
		maxWidth: `${m || iS(e)}px`,
		borderTop: "1px solid var(--color-border-dark)",
		borderBottom: "1px solid var(--color-border-dark)",
		borderLeft: d === "left" || d === "right" ? "none" : "1px solid var(--color-border-dark)",
		borderRight: d === "left" || d === "right" && !le ? "none" : "1px solid var(--color-border-dark)",
		padding: 0,
		fontFamily: w?.fontFamily,
		fontSize: w?.fontSize,
		lineHeight: w?.lineHeight,
		color: w?.color
	}, de = {
		fontFamily: w?.fontFamily,
		fontSize: w?.fontSize,
		lineHeight: w?.lineHeight,
		fontWeight: w?.fontWeight,
		letterSpacing: w?.letterSpacing,
		textTransform: w?.textTransform,
		color: w?.color
	}, fe = T ?? e, pe = typeof fe == "string" || typeof fe == "number" ? String(fe) : e, me = !N && W.showColumnHeaderActions && !!E, he = !N || ne;
	return /* @__PURE__ */ v("th", {
		className: "relative",
		style: ue,
		children: [
			d === "left" && /* @__PURE__ */ _("div", {
				className: "absolute top-0 bottom-0 right-0",
				style: {
					width: "2px",
					backgroundColor: "var(--color-primary)",
					zIndex: 30,
					padding: 0,
					pointerEvents: "none"
				}
			}),
			d === "left" && f > 0 && /* @__PURE__ */ _("div", {
				className: "absolute top-0 bottom-0 left-0",
				style: {
					width: "2px",
					borderRight: "0px solid var(--color-primary)",
					zIndex: 30,
					pointerEvents: "none"
				}
			}),
			d === "right" && /* @__PURE__ */ _("div", {
				className: "absolute top-0 bottom-0 left-0",
				style: {
					width: "2px",
					backgroundColor: "var(--color-primary)",
					zIndex: 30,
					pointerEvents: "none"
				}
			}),
			d === "right" && y && f < y.right.length - 1 && /* @__PURE__ */ _("div", {
				className: "absolute top-0 bottom-0 right-0",
				style: {
					width: "0px",
					borderRight: "0px solid var(--color-primary)",
					zIndex: 30,
					pointerEvents: "none"
				}
			}),
			/* @__PURE__ */ _("div", {
				className: "datagrid-column-header-content px-2 py-0 relative",
				style: { zIndex: 10 },
				children: /* @__PURE__ */ v("div", {
					className: "flex flex-col space-y-0",
					children: [/* @__PURE__ */ v("div", {
						className: "flex items-center",
						children: [
							W.showColumnMenu ? /* @__PURE__ */ v("div", {
								className: "mr-1 flex-shrink-0 relative",
								ref: j,
								children: [/* @__PURE__ */ _(Ub, {
									className: "text-muted-dark w-5 h-5 cursor-pointer hover:text-muted-light transition-colors",
									onClick: (e) => {
										e.stopPropagation(), P();
									}
								}), D === e && /* @__PURE__ */ _("div", {
									className: "absolute z-50 left-0 top-full mt-1",
									children: /* @__PURE__ */ _(tS, {
										options: se(),
										onSelect: ce,
										onClose: () => O(null),
										currentFilter: o && o[e],
										currentWidth: m,
										isPinned: d
									})
								})]
							}) : null,
							/* @__PURE__ */ v("div", {
								className: "flex-1 min-w-0 flex items-center",
								children: [
									!N && d !== "none" && /* @__PURE__ */ _("span", {
										className: "mr-1 text-primary",
										title: `Pinned to ${d}`,
										children: _(d === "left" ? po : ho, { className: "w-4 h-4 text-primary" })
									}),
									/* @__PURE__ */ _("span", {
										className: "select-text font-medium text-primary truncate",
										onClick: L,
										title: pe,
										style: de,
										children: fe
									}),
									!N && S && /* @__PURE__ */ _("span", {
										className: `ml-2 rounded-full border px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-[0.14em] ${te}`,
										title: `Vendor audit status: ${S}`,
										children: S
									})
								]
							}),
							he ? /* @__PURE__ */ v("div", {
								className: "flex items-center space-x-1 ml-2 mr-1",
								children: [
									me && E ? /* @__PURE__ */ _("div", {
										onClick: (e) => e.stopPropagation(),
										children: E(e)
									}) : null,
									!N && o && o[e] && /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(Yb, {
										onClick: (t) => {
											t.stopPropagation(), a(e);
										},
										className: `${ee()} w-5 h-5 text-primary cursor-pointer hover:text-muted-light transition-colors`
									}) }),
									ne ? /* @__PURE__ */ _("div", { children: t === e ? _(r === "asc" ? Vb : zb, {
										onClick: I,
										className: "text-primary w-5 h-5 cursor-pointer hover:text-muted-light transition-colors"
									}) : /* @__PURE__ */ _("div", {
										onClick: I,
										className: "text-muted-dark w-5 h-5 cursor-pointer hover:text-muted-light transition-colors",
										children: /* @__PURE__ */ _(zb, { className: "w-5 h-5" })
									}) }) : null,
									!N && !B && W.showDatatypeIcons ? /* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(V, {
										onClick: R,
										className: `${ee()} w-5 h-5 cursor-pointer ${U()} transition-colors`,
										title: H
									}) }) : null
								]
							}) : null
						]
					}), !N && W.showMissingDataIndicator ? /* @__PURE__ */ _(nS, { missingPercentage: z }) : null]
				})
			}),
			g && /* @__PURE__ */ v("div", {
				ref: M,
				className: `absolute top-0 right-0 w-2 h-full cursor-col-resize transition-all duration-200 z-20 ${k ? "bg-primary opacity-100" : "bg-transparent hover:bg-primary hover:opacity-50"}`,
				onMouseDown: ie,
				title: k ? `${m}px` : "Drag to resize column",
				children: [
					k && /* @__PURE__ */ v("div", {
						className: "absolute right-3 top-1/2 -translate-y-1/2 px-2 py-1 bg-background-light rounded shadow text-xs font-mono text-accent-dark whitespace-nowrap",
						children: [m, "px"]
					}),
					/* @__PURE__ */ _("div", { className: "absolute inset-y-0 right-0 w-px bg-current opacity-30" }),
					/* @__PURE__ */ _("div", { className: "absolute inset-y-0 right-1 w-px bg-current opacity-30" })
				]
			})
		]
	});
}, cS = {
	[$.SELECT]: "Select",
	[$.VIEW]: "View",
	[$.EDIT]: "Edit",
	[$.DELETE]: "Delete",
	[$.EXPORT]: "Export",
	[$.CREATE]: "Add Record",
	[$.THEME]: "Change Theme"
}, lS = {
	[$.SELECT]: ["row", "header"],
	[$.VIEW]: ["row"],
	[$.EDIT]: ["row"],
	[$.DELETE]: ["row", "bulk"],
	[$.EXPORT]: ["header", "bulk"],
	[$.CREATE]: ["header"],
	[$.THEME]: ["header"]
}, uS = new Set(Object.values($));
function dS(e) {
	return typeof e == "object" && !!e;
}
function fS(e) {
	return uS.has(e);
}
function pS(e, t) {
	if (!e) return t;
	let n = Array.isArray(e) ? e : [e];
	return n.length > 0 ? n : t;
}
function mS(e) {
	return e.split(/[-_\s]+/).filter(Boolean).map((e) => e.charAt(0).toUpperCase() + e.slice(1)).join(" ") || e;
}
function hS(e) {
	let t = fS(e) ? e : void 0, n = t ? cS[t] : mS(e);
	return {
		id: e,
		label: n,
		title: n,
		ariaLabel: n,
		action: t,
		scopes: t ? lS[t] : ["row"],
		legacy: !0
	};
}
function gS(e) {
	let t = "action" in e ? e.action : void 0, n = e.id ?? t ?? "", r = t ? cS[t] : mS(n), i = e.label ?? r, a = e.title ?? (typeof i == "string" ? i : r);
	return {
		id: n,
		label: i,
		title: a,
		ariaLabel: e.ariaLabel ?? a,
		icon: e.icon,
		className: e.className,
		action: t,
		scopes: pS(e.scope, t ? lS[t] : ["row"]),
		disabled: e.disabled,
		visible: e.visible,
		onClick: e.onClick,
		legacy: !1
	};
}
function _S(e = []) {
	return e.map((e) => dS(e) ? gS(e) : hS(String(e)));
}
function vS(e, t) {
	return e.scopes.includes(t);
}
function yS(e, t) {
	return e.action === t;
}
function bS(e, t, n) {
	return e.some((e) => yS(e, t) && (!n || vS(e, n)));
}
function xS(e, t = {}) {
	return e.visible === void 0 ? !0 : typeof e.visible == "function" ? e.visible({
		...t,
		actionId: e.id
	}) : e.visible;
}
function SS(e, t = {}) {
	return e.disabled === void 0 ? !1 : typeof e.disabled == "function" ? e.disabled({
		...t,
		actionId: e.id
	}) : e.disabled;
}
function CS(e, t, n = {}) {
	return e.filter((e) => vS(e, t) && xS(e, n));
}
//#endregion
//#region src/styles/color/palette.black.css?inline
var wS = ":root{--color-primary:#fff;--color-primary-light:#eee;--color-primary-dark:#aaa;--color-secondary:#ddd;--color-secondary-light:#f5f5f5;--color-secondary-dark:#bbb;--color-accent:#ccc;--color-accent-light:#9a9494;--color-accent-dark:#888;--color-background:#000;--color-background-light:#222;--color-background-dark:#000;--color-text:#fff;--color-text-light:#fff;--color-text-dark:#ddd;--color-border-light:#fff;--color-border-dark:#aaa;--color-success-light:#fff;--color-success-dark:#ddd;--color-error-light:#fff;--color-error-dark:#bbb;--color-warning-light:#eee;--color-warning-dark:#aaa;--color-info-light:#fff;--color-info-dark:#ccc;--color-muted-light:#aaa;--color-muted-dark:#777;--color-action-add:#fff;--color-action-filter:#eee;--color-action-sample:#ddd;--color-action-export:#fff;--color-action-delete:#ccc;--color-action-clear:#bbb;--color-action-add-hover:#eee;--color-action-filter-hover:#ddd;--color-action-sample-hover:#ccc;--color-action-export-hover:#f5f5f5;--color-action-delete-hover:#aaa;--color-action-clear-hover:#999;--color-icon-view:#fff;--color-icon-view-hover:#eee;--color-icon-edit:#ddd;--color-icon-edit-hover:#ccc;--color-icon-delete:#bbb;--color-icon-delete-hover:#999;--color-datatype-numeric:#827f7f;--color-datatype-categorical:#827f7f;--color-datatype-date:#827f7f;--color-datatype-numeric-light:#eee;--color-datatype-categorical-light:#ccc;--color-datatype-date-light:#8e8a8a;--color-form-numeric-bg:#000;--color-form-numeric-border:#fff;--color-form-numeric-label:#fff;--color-form-numeric-input-bg:#000;--color-form-numeric-input-text:#fff;--color-form-numeric-input-border:#ddd;--color-form-categorical-bg:#000;--color-form-categorical-border:#eee;--color-form-categorical-label:#eee;--color-form-categorical-input-bg:#000;--color-form-categorical-input-text:#fff;--color-form-categorical-input-border:#ccc;--color-form-date-bg:#000;--color-form-date-border:#ddd;--color-form-date-label:#ddd;--color-form-date-input-bg:#000;--color-form-date-input-text:#fff;--color-form-date-input-border:#bbb}", TS = ":root{--color-primary:#cd8963;--color-primary-light:#bf8e63;--color-primary-dark:#3a1f10;--color-secondary:#e5b996;--color-secondary-light:#f0d6bb;--color-secondary-dark:#bb8e6a;--color-accent:#b25219;--color-accent-light:#7b4d36;--color-accent-dark:#802f0d;--color-background:#1f1912;--color-background-light:#362920;--color-background-dark:#1a140e;--color-text:#f2ebe3;--color-text-light:#d8cec0;--color-text-dark:#fff;--color-border-light:#9e8a6d;--color-border-dark:#6e5842;--color-success-light:#4ccb4c;--color-success-dark:#318731;--color-error-light:#e97f52;--color-error-dark:#d35f2a;--color-warning-light:#ffda6b;--color-warning-dark:#e8b829;--color-info-light:#7bbcd8;--color-info-dark:#4c94af;--color-muted-light:#c8baa8;--color-muted-dark:#a89585;--color-wave-blue:#bf8e63cc;--color-wave-green:#9c876fb3;--color-wave-yellow:#ffda6b99;--color-action-add:#bf8e63;--color-action-filter:#ffda6b;--color-action-sample:#cc9770;--color-action-export:#e5b996;--color-action-delete:#e97f52;--color-action-clear:#f0a17d;--color-action-add-hover:#d9a87a;--color-action-filter-hover:#ffe699;--color-action-sample-hover:#e6b595;--color-action-export-hover:#f7d2b5;--color-action-delete-hover:#ff9774;--color-action-clear-hover:#ffbfa3;--color-icon-view:#bf8e63;--color-icon-view-hover:#d9a87a;--color-icon-edit:#4ccb4c;--color-icon-edit-hover:#7ee67e;--color-icon-delete:#e97f52;--color-icon-delete-hover:#ff9774;--color-datatype-numeric:#7bbcd8;--color-datatype-categorical:#ffda6b;--color-datatype-date:#e5b996;--color-datatype-numeric-light:#4c94af;--color-datatype-categorical-light:#e8b829;--color-datatype-date-light:#cc9770;--color-form-numeric-bg:#202a33;--color-form-numeric-border:#4e5d67;--color-form-numeric-label:#7bbcd8;--color-form-numeric-input-bg:#2a2018;--color-form-numeric-input-text:#f2ebe3;--color-form-numeric-input-border:#4c94af;--color-form-categorical-bg:#332d17;--color-form-categorical-border:#736a3a;--color-form-categorical-label:#ffda6b;--color-form-categorical-input-bg:#2a2018;--color-form-categorical-input-text:#f2ebe3;--color-form-categorical-input-border:#e8b829;--color-form-date-bg:#3d2a1d;--color-form-date-border:#735036;--color-form-date-label:#e5b996;--color-form-date-input-bg:#2a2018;--color-form-date-input-text:#f2ebe3;--color-form-date-input-border:#cc9770}", ES = ":root{--color-primary:#0f1;--color-primary-light:#37fff5;--color-primary-dark:#05501c;--color-secondary:#d37e23;--color-secondary-light:#c1fb00;--color-secondary-dark:#6a1304;--color-accent:#091125;--color-accent-light:#2e624d;--color-accent-dark:#047857;--color-background:#1c1b1b;--color-background-light:#3d3a3a;--color-background-dark:#000;--color-text:#f700ff;--color-text-light:#6b7280;--color-text-dark:#6c8acc;--color-border-light:#2d2f31;--color-border-dark:#374151;--color-success-light:#bbf7d0;--color-success-dark:#15803d;--color-error-light:#fecaca;--color-error-dark:#ea1313;--color-warning-light:#fef08a;--color-warning-dark:#b45309;--color-info-light:#91c6e3;--color-info-dark:#0369a1;--color-muted-light:#c8ccd6;--color-muted-dark:#7c8188;--color-action-add:#0ea5e9;--color-action-filter:#eab308;--color-action-sample:#a855f7;--color-action-export:#f97316;--color-action-delete:#ec1b1b;--color-action-clear:#ec4899;--color-action-add-hover:#38bdf8;--color-action-filter-hover:#facc15;--color-action-sample-hover:#c084fc;--color-action-export-hover:#fb923c;--color-action-delete-hover:#f87171;--color-action-clear-hover:#f472b6;--color-icon-view:#abcbff;--color-icon-view-hover:#2563eb;--color-icon-edit:#eaff00;--color-icon-edit-hover:#d9e417;--color-icon-delete:red;--color-icon-delete-hover:#ef4242;--color-datatype-numeric:#00ccd3;--color-datatype-categorical:#a4c400;--color-datatype-date:#fa0;--color-datatype-numeric-light:#3b82f6;--color-datatype-categorical-light:#fbbf24;--color-datatype-date-light:#fb923c;--color-form-numeric-bg:#0f1a37;--color-form-numeric-border:#304176;--color-form-numeric-label:#a7c0ff;--color-form-numeric-input-bg:#1a2748;--color-form-numeric-input-text:#d1e0ff;--color-form-numeric-input-border:#4f5e8c;--color-form-categorical-bg:#312a04;--color-form-categorical-border:#6d5f18;--color-form-categorical-label:#daf078;--color-form-categorical-input-bg:#404107;--color-form-categorical-input-text:#fbeaaa;--color-form-categorical-input-border:#8c8e25;--color-form-date-bg:#301304;--color-form-date-border:#7c3d11;--color-form-date-label:#faa66f;--color-form-date-input-bg:#41220a;--color-form-date-input-text:#fcc8ac;--color-form-date-input-border:#9a4d1c}", DS = ":root{--color-primary:#e3e4b4;--color-primary-light:#a6c8ff;--color-primary-dark:#cb6;--color-secondary:#ffaa80;--color-secondary-light:#ffd1aa;--color-secondary-dark:#e6a17a;--color-accent:#d6aedd;--color-accent-light:#4b4450;--color-accent-dark:#b98cc7;--color-background:#2a2a36;--color-background-light:#36363f;--color-background-dark:#222230;--color-text:#e0e0e8;--color-text-light:#bcbccc;--color-text-dark:#fff;--color-border-light:#5f5f73;--color-border-dark:#4a4a5e;--color-success-light:#a8e6c3;--color-success-dark:#80dbbc;--color-error-light:#ffabad;--color-error-dark:#f99;--color-warning-light:#ffe0a0;--color-warning-dark:#ffb366;--color-info-light:#b3daff;--color-info-dark:#c8c9b8;--color-muted-light:#aaaabc;--color-muted-dark:#8a8a9c;--color-wave-blue:#a6c8ffb3;--color-wave-green:#a8e6c380;--color-wave-yellow:#ffe0a066;--color-action-add:#80b3ff;--color-action-filter:#ffe0a0;--color-action-sample:#d6aedd;--color-action-export:#ffaa80;--color-action-delete:#f99;--color-action-clear:#ffabad;--color-action-add-hover:#a6c8ff;--color-action-filter-hover:#fff0cc;--color-action-sample-hover:#e6d2f4;--color-action-export-hover:#ffccb3;--color-action-delete-hover:#ffbfbf;--color-action-clear-hover:#fcc;--color-icon-view:#80b3ff;--color-icon-view-hover:#a6c8ff;--color-icon-edit:#80dbbc;--color-icon-edit-hover:#a8e6c3;--color-icon-delete:#f99;--color-icon-delete-hover:#ffabad;--color-datatype-numeric:#9cf;--color-datatype-categorical:#ffe0a0;--color-datatype-date:#ffaa80;--color-datatype-numeric-light:#69c;--color-datatype-categorical-light:#d9bd86;--color-datatype-date-light:#e6a17a;--color-form-numeric-bg:#2a3546;--color-form-numeric-border:#405673;--color-form-numeric-label:#9cf;--color-form-numeric-input-bg:#36363f;--color-form-numeric-input-text:#e0e0e8;--color-form-numeric-input-border:#69c;--color-form-categorical-bg:#3d3d35;--color-form-categorical-border:#5c5c4d;--color-form-categorical-label:#ffe0a0;--color-form-categorical-input-bg:#36363f;--color-form-categorical-input-text:#e0e0e8;--color-form-categorical-input-border:#d9bd86;--color-form-date-bg:#3d3333;--color-form-date-border:#5c4d4d;--color-form-date-label:#ffaa80;--color-form-date-input-bg:#36363f;--color-form-date-input-text:#e0e0e8;--color-form-date-input-border:#e6a17a}", OS = ":root{--color-primary:#009c3b;--color-primary-light:#00b347;--color-primary-dark:#007a2e;--color-secondary:#ffdf00;--color-secondary-light:#ffea5c;--color-secondary-dark:#b39b00;--color-accent:#002776;--color-accent-light:#b4c9f6;--color-accent-dark:#001a4d;--color-background:#fff;--color-background-light:#f5f5f5;--color-background-dark:#e6e6e6;--color-text:#212121;--color-text-light:#555;--color-text-dark:#000;--color-border-light:#ffdf00;--color-border-dark:#002776;--color-success-light:#00b347;--color-success-dark:#009c3b;--color-error-light:#ff3b30;--color-error-dark:#c00;--color-warning-light:#ffdf00;--color-warning-dark:#b39b00;--color-info-light:#59f;--color-info-dark:#002776;--color-muted-light:#a6dfbe;--color-muted-dark:#8aa3b9;--color-action-add:#009c3b;--color-action-filter:#b39b00;--color-action-sample:#002776;--color-action-export:#333;--color-action-delete:#c00;--color-action-clear:#0033a0;--color-action-add-hover:#00b347;--color-action-filter-hover:#ffdf00;--color-action-sample-hover:#0033a0;--color-action-export-hover:#555;--color-action-delete-hover:#ff3b30;--color-action-clear-hover:#59f;--color-icon-view:#002776;--color-icon-view-hover:#0033a0;--color-icon-edit:#009c3b;--color-icon-edit-hover:#00b347;--color-icon-delete:#c00;--color-icon-delete-hover:#ff3b30;--color-datatype-numeric:#002776;--color-datatype-categorical:#b39b00;--color-datatype-date:#009c3b;--color-datatype-numeric-light:#d9e1f7;--color-datatype-categorical-light:#fff7cc;--color-datatype-date-light:#d9f7e6;--color-form-numeric-bg:#e6eefa;--color-form-numeric-border:#002776;--color-form-numeric-label:#002776;--color-form-numeric-input-bg:#f2f6ff;--color-form-numeric-input-text:#333;--color-form-numeric-input-border:#0033a0;--color-form-categorical-bg:#fffae6;--color-form-categorical-border:#b39b00;--color-form-categorical-label:#b39b00;--color-form-categorical-input-bg:#fffdf2;--color-form-categorical-input-text:#333;--color-form-categorical-input-border:#ffdf00;--color-form-date-bg:#e6f7ef;--color-form-date-border:#009c3b;--color-form-date-label:#007a2e;--color-form-date-input-bg:#f2fff8;--color-form-date-input-text:#333;--color-form-date-input-border:#00b347}", kS = ":root{--color-primary:#000;--color-primary-light:#111;--color-primary-dark:#555;--color-secondary:#222;--color-secondary-light:#0a0a0a;--color-secondary-dark:#444;--color-accent:#333;--color-accent-light:#656565;--color-accent-dark:#777;--color-background:#fff;--color-background-light:#ddd;--color-background-dark:#fff;--color-text:#000;--color-text-light:#000;--color-text-dark:#222;--color-border-light:#000;--color-border-dark:#555;--color-success-light:#000;--color-success-dark:#222;--color-error-light:#000;--color-error-dark:#444;--color-warning-light:#111;--color-warning-dark:#555;--color-info-light:#676767;--color-info-dark:#262525;--color-muted-light:#555;--color-muted-dark:#888;--color-action-add:#000;--color-action-filter:#111;--color-action-sample:#222;--color-action-export:#000;--color-action-delete:#333;--color-action-clear:#444;--color-action-add-hover:#111;--color-action-filter-hover:#222;--color-action-sample-hover:#333;--color-action-export-hover:#0a0a0a;--color-action-delete-hover:#555;--color-action-clear-hover:#666;--color-icon-view:#000;--color-icon-view-hover:#111;--color-icon-edit:#222;--color-icon-edit-hover:#333;--color-icon-delete:#444;--color-icon-delete-hover:#666;--color-datatype-numeric:#7b7b7b;--color-datatype-categorical:#7b7b7b;--color-datatype-date:#7b7b7b;--color-datatype-numeric-light:#111;--color-datatype-categorical-light:#333;--color-datatype-date-light:#71767a;--color-form-numeric-bg:#fff;--color-form-numeric-border:#000;--color-form-numeric-label:#000;--color-form-numeric-input-bg:#fff;--color-form-numeric-input-text:#000;--color-form-numeric-input-border:#222;--color-form-categorical-bg:#fff;--color-form-categorical-border:#111;--color-form-categorical-label:#111;--color-form-categorical-input-bg:#fff;--color-form-categorical-input-text:#000;--color-form-categorical-input-border:#333;--color-form-date-bg:#fff;--color-form-date-border:#222;--color-form-date-label:#222;--color-form-date-input-bg:#fff;--color-form-date-input-text:#000;--color-form-date-input-border:#444}", AS = ":root{--color-primary:#1877f2;--color-primary-light:#4293ff;--color-primary-dark:#0d5dc4;--color-secondary:#42b72a;--color-secondary-light:#5bd741;--color-secondary-dark:#36a420;--color-accent:#1877f2;--color-accent-light:#e7f3ff;--color-accent-dark:#166fe5;--color-background:#fff;--color-background-light:#f0f2f5;--color-background-dark:#e4e6eb;--color-text:#050505;--color-text-light:#65676b;--color-text-dark:#1c1e21;--color-border-light:#e4e6eb;--color-border-dark:#ccd0d5;--color-success-light:#42b72a;--color-success-dark:#36a420;--color-error-light:#fa383e;--color-error-dark:#e41e3f;--color-warning-light:#f7b928;--color-warning-dark:#e69500;--color-info-light:#b3c5dc;--color-info-dark:#3c78c5;--color-muted-light:#e4e6eb;--color-muted-dark:#bec3c9;--color-action-add:#42b72a;--color-action-filter:#1877f2;--color-action-sample:#8a8d91;--color-action-export:#1877f2;--color-action-delete:#fa383e;--color-action-clear:#65676b;--color-action-add-hover:#36a420;--color-action-filter-hover:#166fe5;--color-action-sample-hover:#65676b;--color-action-export-hover:#166fe5;--color-action-delete-hover:#e41e3f;--color-action-clear-hover:#50555c;--color-icon-view:#1877f2;--color-icon-view-hover:#166fe5;--color-icon-edit:#42b72a;--color-icon-edit-hover:#36a420;--color-icon-delete:#fa383e;--color-icon-delete-hover:#e41e3f;--color-datatype-numeric:#1877f2;--color-datatype-categorical:#f7b928;--color-datatype-date:#42b72a;--color-datatype-numeric-light:#e7f3ff;--color-datatype-categorical-light:#fef2d1;--color-datatype-date-light:#e3f1df;--color-form-numeric-bg:#f0f2f5;--color-form-numeric-border:#ccd0d5;--color-form-numeric-label:#1877f2;--color-form-numeric-input-bg:#fff;--color-form-numeric-input-text:#1c1e21;--color-form-numeric-input-border:#1877f2;--color-form-categorical-bg:#f0f2f5;--color-form-categorical-border:#ccd0d5;--color-form-categorical-label:#f7b928;--color-form-categorical-input-bg:#fff;--color-form-categorical-input-text:#1c1e21;--color-form-categorical-input-border:#f7b928;--color-form-date-bg:#f0f2f5;--color-form-date-border:#ccd0d5;--color-form-date-label:#42b72a;--color-form-date-input-bg:#fff;--color-form-date-input-text:#1c1e21;--color-form-date-input-border:#42b72a}", jS = ":root{--color-primary:#b1b2b2;--color-primary-light:#b8d2ef;--color-primary-dark:#035185;--color-secondary:#ce9178;--color-secondary-light:#dcdcaa;--color-secondary-dark:#d7ba7d;--color-accent:#c586c0;--color-accent-light:#444449;--color-accent-dark:#7475ab;--color-background:#272727;--color-background-light:#252526;--color-background-dark:#181818;--color-text:#d4d4d4;--color-text-light:#a9a9a9;--color-text-dark:#fff;--color-border-light:#444;--color-border-dark:#333;--color-success-light:#73c991;--color-success-dark:#4ec9b0;--color-error-light:#f14c4c;--color-error-dark:#f44747;--color-warning-light:#cca700;--color-warning-dark:#ff8c00;--color-info-light:#afd2f1;--color-info-dark:#2aaaff;--color-muted-light:#858585;--color-muted-dark:#6c6c6c;--color-wave-blue:#3794ffb3;--color-wave-green:#4ec9b080;--color-wave-yellow:#dcdcaa66;--color-action-add:#007acc;--color-action-filter:#dcdcaa;--color-action-sample:#c586c0;--color-action-export:#ce9178;--color-action-delete:#f44747;--color-action-clear:#f14c4c;--color-action-add-hover:#3794ff;--color-action-filter-hover:#efefbf;--color-action-sample-hover:#d7b0d7;--color-action-export-hover:#e8b199;--color-action-delete-hover:#f66;--color-action-clear-hover:#f77;--color-icon-view:#007acc;--color-icon-view-hover:#3794ff;--color-icon-edit:#4ec9b0;--color-icon-edit-hover:#73c991;--color-icon-delete:#f44747;--color-icon-delete-hover:#f14c4c;--color-datatype-numeric:#4fc1ff;--color-datatype-categorical:#dcdcaa;--color-datatype-date:#ce9178;--color-datatype-numeric-light:#0e639c;--color-datatype-categorical-light:#977a30;--color-datatype-date-light:#964;--color-form-numeric-bg:#102439;--color-form-numeric-border:#1f4662;--color-form-numeric-label:#4fc1ff;--color-form-numeric-input-bg:#252526;--color-form-numeric-input-text:#d4d4d4;--color-form-numeric-input-border:#0e639c;--color-form-categorical-bg:#2d2d1e;--color-form-categorical-border:#494933;--color-form-categorical-label:#dcdcaa;--color-form-categorical-input-bg:#252526;--color-form-categorical-input-text:#d4d4d4;--color-form-categorical-input-border:#977a30;--color-form-date-bg:#2d2318;--color-form-date-border:#49352a;--color-form-date-label:#ce9178;--color-form-date-input-bg:#252526;--color-form-date-input-text:#d4d4d4;--color-form-date-input-border:#964}", MS = /* @__PURE__ */ e({
	AVAILABLE_THEMES: () => NS,
	getCurrentTheme: () => BS,
	initializeTheme: () => VS,
	loadTheme: () => zS
}), NS = [
	{
		id: "default",
		name: "Default"
	},
	{
		id: "vision",
		name: "Très Jolie"
	},
	{
		id: "simple",
		name: "Simple"
	},
	{
		id: "coffee",
		name: "Coffee"
	},
	{
		id: "samba",
		name: "Samba"
	},
	{
		id: "neon",
		name: "Neon"
	},
	{
		id: "pastelnight",
		name: "Pastel Night"
	},
	{
		id: "black",
		name: "Monocroma"
	},
	{
		id: "vscode",
		name: "VSCode Dark"
	}
], PS = {
	black: wS,
	coffee: TS,
	neon: ES,
	pastelnight: DS,
	samba: OS,
	simple: kS,
	vision: AS,
	vscode: jS
}, FS = "datagrid-theme", IS = () => {
	try {
		return typeof localStorage > "u" ? null : localStorage.getItem(FS);
	} catch {
		return null;
	}
}, LS = (e) => {
	try {
		typeof localStorage < "u" && localStorage.setItem(FS, e);
	} catch {}
}, RS = (e) => e === "default" || PS[e] ? e : "default", zS = (e) => {
	let t = RS(e);
	if (LS(t), typeof document > "u") return;
	document.querySelectorAll("link[data-theme], style[data-datagrid-theme]").forEach((e) => e.remove());
	let n = PS[t];
	if (n) {
		let e = document.createElement("style");
		e.textContent = n, e.setAttribute("data-datagrid-theme", t), document.head.appendChild(e);
	}
	let r = new CustomEvent("theme-changed", { detail: { theme: t } });
	document.dispatchEvent(r);
}, BS = () => RS(IS() || "default"), VS = () => {
	let e = BS();
	e !== "default" && zS(e);
}, HS = ({ isActionMenuOpen: e, setIsActionMenuOpen: t, toggleThemeMenu: n, actions: r, actionHandlers: i, handleBulkAction: a, selectedRows: o, isExporting: s, filters: c, toggleSidebarFilters: l, headerDisplay: u, isThemeMenuOpen: d, setIsThemeMenuOpen: f, themeMenuPosition: p, themeMenuRef: m, activeTheme: h, setActiveTheme: y, isColumnMenuOpen: b = !1, setIsColumnMenuOpen: x = () => {}, columnMenuPosition: S = {
	top: 0,
	left: 0
}, columnMenuRef: C, handleColumnAction: w = () => {}, pinnedColumns: T = {
	left: [],
	right: []
}, onColumnPin: E, onColumnResize: D }) => {
	let O = NS, k = {
		showFilterControls: u?.showFilterControls ?? !0,
		showSamplingControls: u?.showSamplingControls ?? !0
	}, A = { selectedRows: o }, j = (e, t) => r.find((n) => yS(n, e) && n.scopes.includes(t) && xS(n, A)), M = j($.CREATE, "header"), N = j($.EXPORT, "bulk"), P = j($.THEME, "header"), F = bS(r, $.DELETE, "bulk"), I = CS(r, "bulk", A).filter((e) => !e.action), L = (e, n) => {
		n.stopPropagation(), !SS(e, {
			...A,
			event: n
		}) && (e.onClick ? e.onClick({
			actionId: e.id,
			selectedRows: o,
			event: n
		}) : a(e.id), t(!1));
	};
	return /* @__PURE__ */ v(g, { children: [
		e && /* @__PURE__ */ _("div", {
			className: "absolute top-6 left-4 z-[999] mt-1 w-56 shadow-lg bg-background-light border border-border-light rounded",
			children: /* @__PURE__ */ v("div", {
				className: "py-1",
				role: "menu",
				"aria-orientation": "vertical",
				children: [
					M && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						disabled: SS(M, A),
						onClick: (e) => {
							M.onClick ? (M.onClick({
								actionId: M.id,
								selectedRows: o,
								event: e
							}), t(!1)) : i.onCreate && (i.onCreate(), t(!1));
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [M.icon ?? /* @__PURE__ */ _(ts, { className: "w-5 h-5 text-action-add group-hover:text-action-add-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: M.label
							})]
						})
					}),
					l && k.showFilterControls && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						onClick: () => {
							l("filters"), t(!1);
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(Lo, { className: "w-5 h-5 text-action-filter group-hover:text-action-filter-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: c && Object.keys(c).some((e) => e !== "sampling") ? "Change Filter" : "Add Filter"
							})]
						})
					}),
					l && k.showSamplingControls && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						onClick: () => {
							l("sampling"), t(!1);
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(Lo, { className: "w-5 h-5 text-action-sample group-hover:text-action-sample-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: c && c.sampling ? "Change Sampling" : "Add Sampling"
							})]
						})
					}),
					N && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						disabled: SS(N, A),
						onClick: (e) => {
							N.onClick ? N.onClick({
								actionId: N.id,
								selectedRows: o,
								event: e
							}) : i.onExport ? i.onExport(-1) : a("exportAll"), t(!1);
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [N.icon ?? /* @__PURE__ */ _(Co, { className: "w-5 h-5 text-action-export group-hover:text-action-export-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: N.label === "Export" ? "Export All" : N.label
							})]
						})
					}),
					(E || D) && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						onClick: () => {
							x && (x(!0), t(!1));
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(_s, { className: "w-5 h-5 text-action-sample group-hover:text-action-sample-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: "Column Management"
							})]
						})
					}),
					P && /* @__PURE__ */ _("button", {
						className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark",
						disabled: SS(P, A),
						onClick: () => {
							n(), t(!1);
						},
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [P.icon ?? /* @__PURE__ */ _(ds, { className: "w-5 h-5 text-action-sample group-hover:text-action-sample-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: P.label
							})]
						})
					}),
					(k.showFilterControls || N || F || I.length > 0) && /* @__PURE__ */ v("div", {
						className: "flex items-center my-0.5",
						children: [
							/* @__PURE__ */ _("span", { className: "flex-grow border-t opacity-40 border-border-light" }),
							/* @__PURE__ */ _("span", {
								className: "mx-2 text-xs font-light text-muted-dark",
								children: "Bulk options"
							}),
							/* @__PURE__ */ _("span", { className: "flex-grow border-t opacity-40 border-border-light" })
						]
					}),
					k.showFilterControls && /* @__PURE__ */ _("button", {
						disabled: o.size === 0,
						className: `block px-4 py-2 text-sm w-full text-left bg-background-light ${o.size === 0 ? "text-muted-dark cursor-not-allowed opacity-50" : "text-text hover:bg-info-light hover:text-info-dark"}`,
						onClick: () => a("filter"),
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(Lo, { className: "w-5 h-5 text-action-filter group-hover:text-action-filter-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: "Filter Selected"
							})]
						})
					}),
					N && /* @__PURE__ */ _("button", {
						className: `block px-4 py-2 text-sm w-full text-left bg-background-light ${o.size === 0 || s ? "text-muted-dark cursor-not-allowed opacity-50" : "text-text hover:bg-info-light hover:text-info-dark"}`,
						onClick: () => a("export"),
						disabled: o.size === 0 || s,
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(Co, { className: `w-5 h-5 text-action-export ${o.size === 0 || s ? "opacity-50" : "group-hover:text-action-export-hover transition-colors"}` }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: s ? "Exporting..." : "Export Selected"
							})]
						})
					}),
					F && /* @__PURE__ */ _("button", {
						disabled: o.size === 0,
						className: `block px-4 py-2 text-sm w-full text-left bg-background-light ${o.size === 0 ? "text-muted-dark cursor-not-allowed opacity-50" : "text-action-delete hover:bg-info-light hover:text-action-delete-hover"}`,
						onClick: () => a("delete"),
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center",
							children: [/* @__PURE__ */ _(hs, { className: "w-5 h-5 text-action-delete group-hover:text-action-delete-hover" }), /* @__PURE__ */ _("span", {
								className: "ml-2",
								children: "Delete Selected"
							})]
						})
					}),
					I.map((e) => {
						let t = o.size === 0 || SS(e, A);
						return /* @__PURE__ */ _("button", {
							disabled: t,
							className: `block px-4 py-2 text-sm w-full text-left bg-background-light ${t ? "text-muted-dark cursor-not-allowed opacity-50" : "text-text hover:bg-info-light hover:text-info-dark"} ${e.className ?? ""}`,
							onClick: (t) => L(e, t),
							title: e.title,
							"aria-label": e.ariaLabel,
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [e.icon ?? /* @__PURE__ */ _("span", {
									className: "w-5 h-5 inline-flex items-center justify-center text-xs font-bold text-action-sample",
									children: "+"
								}), /* @__PURE__ */ _("span", {
									className: "ml-2",
									children: e.label
								})]
							})
						}, e.id);
					})
				]
			})
		}),
		d && /* @__PURE__ */ _("div", {
			className: "absolute z-[999] mt-1 w-56 shadow-lg bg-background-light border border-border-light rounded",
			style: {
				position: "fixed",
				top: `${p.top}px`,
				left: `${p.left}px`
			},
			ref: m,
			children: /* @__PURE__ */ v("div", {
				className: "py-1",
				role: "menu",
				"aria-orientation": "vertical",
				children: [/* @__PURE__ */ _("div", {
					className: "px-4 py-2 text-xs font-medium text-muted-dark border-b border-border-light",
					children: "Select Theme"
				}), O.map((e) => /* @__PURE__ */ _("button", {
					className: `block px-4 py-2 text-sm w-full text-left ${h === e.id ? "bg-info-light text-info-dark font-medium" : "bg-background-light text-text hover:bg-info-light hover:text-info-dark"}`,
					onClick: () => {
						i.onThemeChange && (i.onThemeChange(e.id), y(e.id)), f(!1);
					},
					children: /* @__PURE__ */ v("div", {
						className: "flex items-center",
						children: [/* @__PURE__ */ _(ds, { className: `w-5 h-5 ${h === e.id ? "text-info-dark" : "text-action-sample group-hover:text-action-sample-hover"}` }), /* @__PURE__ */ _("span", {
							className: "ml-2",
							children: e.name
						})]
					})
				}, e.id))]
			})
		}),
		b && (E || D) && /* @__PURE__ */ _("div", {
			className: "absolute top-6 left-0 z-[1001] mt-1 w-64 shadow-xl bg-background-light border border-border-light rounded",
			style: {
				maxHeight: "400px",
				overflowY: "auto"
			},
			ref: C,
			children: /* @__PURE__ */ v("div", {
				className: "py-1",
				role: "menu",
				"aria-orientation": "vertical",
				children: [
					/* @__PURE__ */ _("div", {
						className: "px-4 py-2 text-xs font-medium text-muted-dark border-b border-border-light bg-background",
						children: "Column Management"
					}),
					D && /* @__PURE__ */ v(g, { children: [
						/* @__PURE__ */ _("div", {
							className: "px-4 py-1 text-xs font-medium text-muted-dark bg-background-light",
							children: "Width Control"
						}),
						/* @__PURE__ */ _("button", {
							className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark transition-colors",
							onClick: () => {
								console.log("Auto-fit all clicked"), w?.("auto-fit-all");
							},
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [/* @__PURE__ */ _(Ra, { className: "w-5 h-5 text-accent" }), /* @__PURE__ */ _("span", {
									className: "ml-2",
									children: "Auto-fit All Columns"
								})]
							})
						}),
						/* @__PURE__ */ _("button", {
							className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark transition-colors",
							onClick: () => {
								console.log("Reset all widths clicked"), w?.("reset-all-widths");
							},
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [/* @__PURE__ */ _(Ba, { className: "w-5 h-5 text-warning-dark" }), /* @__PURE__ */ _("span", {
									className: "ml-2",
									children: "Reset All Widths"
								})]
							})
						})
					] }),
					E && /* @__PURE__ */ v(g, { children: [
						/* @__PURE__ */ _("div", {
							className: "px-4 py-1 text-xs font-medium text-muted-dark bg-background-light mt-2",
							children: "Pinning Control"
						}),
						/* @__PURE__ */ _("button", {
							className: `block px-4 py-2 text-sm w-full text-left transition-colors ${T && T.left.length === 0 && T.right.length === 0 ? "text-muted-dark cursor-not-allowed opacity-50" : "bg-background-light text-text hover:bg-info-light hover:text-info-dark"}`,
							onClick: () => {
								T && (T.left.length > 0 || T.right.length > 0) && (console.log("Unpin all clicked"), w?.("unpin-all"));
							},
							disabled: T && T.left.length === 0 && T.right.length === 0,
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [
									/* @__PURE__ */ _(Ra, { className: "w-5 h-5 text-warning-dark" }),
									/* @__PURE__ */ _("span", {
										className: "ml-2",
										children: "Unpin All Columns"
									}),
									T && (T.left.length > 0 || T.right.length > 0) && /* @__PURE__ */ v("span", {
										className: "ml-auto text-xs text-info-dark",
										children: [
											"(",
											T.left.length + T.right.length,
											" pinned)"
										]
									})
								]
							})
						}),
						T && T.left.length > 0 && /* @__PURE__ */ _("div", {
							className: "px-4 py-2 text-xs text-muted-dark bg-background",
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [
									/* @__PURE__ */ _(Aa, { className: "w-4 h-4 text-info-dark mr-2" }),
									/* @__PURE__ */ _("span", {
										className: "font-medium",
										children: "Left:"
									}),
									/* @__PURE__ */ _("span", {
										className: "ml-1",
										children: T.left.join(", ")
									})
								]
							})
						}),
						T && T.right.length > 0 && /* @__PURE__ */ _("div", {
							className: "px-4 py-2 text-xs text-muted-dark bg-background",
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [
									/* @__PURE__ */ _(Pa, { className: "w-4 h-4 text-info-dark mr-2" }),
									/* @__PURE__ */ _("span", {
										className: "font-medium",
										children: "Right:"
									}),
									/* @__PURE__ */ _("span", {
										className: "ml-1",
										children: T.right.join(", ")
									})
								]
							})
						})
					] }),
					/* @__PURE__ */ v("div", {
						className: "border-t border-border-light mt-2 pt-2",
						children: [/* @__PURE__ */ _("div", {
							className: "px-4 py-1 text-xs font-medium text-muted-dark bg-background-light",
							children: "Quick Actions"
						}), /* @__PURE__ */ _("button", {
							className: "block px-4 py-2 text-sm w-full text-left bg-background-light text-text hover:bg-info-light hover:text-info-dark transition-colors",
							onClick: () => {
								console.log("Reset all clicked"), w?.("reset-all");
							},
							children: /* @__PURE__ */ v("div", {
								className: "flex items-center",
								children: [/* @__PURE__ */ _(_s, { className: "w-5 h-5 text-action-sample" }), /* @__PURE__ */ _("span", {
									className: "ml-2",
									children: "Reset All Column Settings"
								})]
							})
						})]
					})
				]
			})
		})
	] });
}, US = 28, WS = 4, GS = 16, KS = 16, qS = 8, JS = 32, YS = 40;
function XS(e) {
	return e.filter((e) => vS(e, "row") ? e.action ? yS(e, $.VIEW) || yS(e, $.EDIT) || yS(e, $.DELETE) : !0 : !1).length;
}
function ZS(e, t) {
	if (e.length === 0) return 0;
	let n = XS(e), r = n > 0 ? n * US + (n - 1) * WS : 0, i = bS(e, $.SELECT, "row"), a = KS + (i ? GS : 0) + (i && n > 0 ? qS : 0) + r, o = 76 + (t?.showFilterControls ?? !0 ? JS : 0) + (bS(e, $.CREATE, "header") ? JS : 0);
	return Math.max(YS, a, o);
}
//#endregion
//#region src/components/grid/HeaderActions.tsx
var QS = ({ selectedRows: e, setSelectedRows: t, isAllSelected: n, onToggleSelectAll: r, onBulkAction: i, toggleSidebarFilters: a, actions: o, actionHandlers: s, filters: c = {}, isExporting: l = !1, currentTheme: d = "default", headerDisplay: f, onColumnPin: p, onColumnResize: g, pinnedColumns: y = {
	left: [],
	right: []
} }) => {
	let [b, x] = h(!1), [S, C] = h(!1), [w, T] = h(!1), [E, D] = h({
		top: 0,
		left: 0
	}), [O, k] = h({
		top: 0,
		left: 0
	}), [A, j] = h(() => d || localStorage.getItem("datagrid-theme") || "default"), M = m(null), N = m(null), P = m(null), F = m(null), I = {
		showFilterControls: f?.showFilterControls ?? !0,
		showSamplingControls: f?.showSamplingControls ?? !0
	}, L = { selectedRows: e }, R = o.find((e) => yS(e, $.SELECT) && e.scopes.includes("header") && xS(e, L)), z = o.find((e) => yS(e, $.CREATE) && e.scopes.includes("header") && xS(e, L)), B = () => {
		x(!b), S && C(!1), w && T(!1);
	}, V = () => {
		if (M.current) {
			let e = M.current.getBoundingClientRect();
			D({
				top: e.bottom + window.scrollY,
				left: e.right + window.scrollX - 150
			});
		}
		C(!S), b && x(!1), w && T(!1);
	}, H = (n) => {
		switch (x(!1), n) {
			case "delete":
				i(n), t(/* @__PURE__ */ new Set());
				break;
			case "filter":
				Array.from(e).length > 0 && i(n);
				break;
			case "export":
				s.onExport ? e.size > 0 ? i(n) : s.onExport(-1) : i(n);
				break;
			case "theme":
				s.onThemeChange && s.onThemeChange(n);
				break;
			default: i(n);
		}
	}, ee = (e) => {
		console.log("handleColumnAction called with:", e), T(!1), e === "reset-all-widths" && g ? s.onColumnManagement && s.onColumnManagement("reset-all-widths") : e === "unpin-all" && p ? [...y.left, ...y.right].forEach((e) => {
			p(e, "none");
		}) : e === "auto-fit-all" && g ? s.onColumnManagement && s.onColumnManagement("auto-fit-all") : e === "reset-all" && s.onColumnManagement && s.onColumnManagement("reset-all");
	};
	u(() => {
		let e = (e) => {
			S && P.current && !P.current.contains(e.target) && M.current && !M.current.contains(e.target) && C(!1), w && F.current && !F.current.contains(e.target) && N.current && !N.current.contains(e.target) && T(!1);
		};
		return document.addEventListener("mousedown", e), () => {
			document.removeEventListener("mousedown", e);
		};
	}, [S, w]), u(() => {
		let e = () => {
			j(localStorage.getItem("datagrid-theme") || "default");
		}, t = (e) => {
			e.detail && e.detail.theme && j(e.detail.theme);
		};
		return window.addEventListener("focus", e), window.addEventListener("storage", e), document.addEventListener("theme-changed", t), () => {
			window.removeEventListener("focus", e), window.removeEventListener("storage", e), document.removeEventListener("theme-changed", t);
		};
	}, []), u(() => {
		d !== A && j(d);
	}, [d, A]);
	let U = y.left.length > 0, te = ZS(o, I);
	return /* @__PURE__ */ _("th", {
		className: "relative bg-background",
		style: {
			position: U ? "sticky" : "relative",
			left: U ? 0 : void 0,
			zIndex: U ? 50 : void 0,
			minWidth: `${te}px`,
			width: `${te}px`,
			padding: 0,
			margin: 0,
			borderTop: "1px solid var(--color-border-dark)",
			borderBottom: "1px solid var(--color-border-dark)",
			borderLeft: "1px solid var(--color-border-dark)",
			borderRight: "none"
		},
		children: /* @__PURE__ */ v("div", {
			style: {
				backgroundColor: "var(--color-background)",
				height: "100%",
				width: "100%",
				position: "relative"
			},
			children: [/* @__PURE__ */ _("div", {
				className: "absolute top-0 bottom-0 right-0",
				style: {
					width: "1px",
					backgroundColor: "var(--color-primary)",
					zIndex: 30,
					pointerEvents: "none"
				}
			}), /* @__PURE__ */ v("div", {
				className: "flex items-center h-[28px] px-2 py-1",
				children: [
					R && /* @__PURE__ */ _("div", {
						className: "flex items-center space-x-1 pl-2",
						children: /* @__PURE__ */ _("input", {
							type: "checkbox",
							checked: n,
							onChange: (e) => {
								e.stopPropagation(), r();
							},
							className: "w-4 h-4 accent-primary",
							"aria-label": R.ariaLabel,
							disabled: SS(R, L)
						})
					}),
					/* @__PURE__ */ _("div", {
						className: "flex items-center space-x-1 pl-2",
						children: /* @__PURE__ */ _("button", {
							onClick: B,
							className: "p-1 text-action-add hover:text-action-add-hover rounded transition-colors",
							title: "Bulk Actions",
							children: /* @__PURE__ */ _(ko, { className: "w-5 h-5" })
						})
					}),
					a && I.showFilterControls && /* @__PURE__ */ _("div", {
						className: "flex items-center space-x-1 pl-1",
						children: /* @__PURE__ */ _("button", {
							onClick: (e) => {
								e.stopPropagation(), a("filters");
							},
							className: "p-1 text-action-filter hover:text-action-filter-hover rounded transition-colors",
							title: "Open filters panel",
							children: /* @__PURE__ */ _(Lo, { className: "w-5 h-5" })
						})
					}),
					z && /* @__PURE__ */ _("div", {
						className: "flex items-center space-x-1 pl-1",
						children: /* @__PURE__ */ _("button", {
							type: "button",
							className: "p-1 text-action-add hover:text-action-add-hover rounded transition-colors",
							onClick: (t) => {
								t.stopPropagation(), z.onClick ? z.onClick({
									actionId: z.id,
									selectedRows: e,
									event: t
								}) : s.onCreate?.();
							},
							title: z.title,
							"aria-label": z.ariaLabel,
							disabled: SS(z, L),
							children: z.icon ?? /* @__PURE__ */ _(Zb, { className: "w-5 h-5" })
						})
					}),
					/* @__PURE__ */ _(HS, {
						isActionMenuOpen: b,
						setIsActionMenuOpen: x,
						toggleThemeMenu: V,
						actions: o,
						actionHandlers: s,
						handleBulkAction: H,
						selectedRows: e,
						isExporting: l,
						filters: c,
						toggleSidebarFilters: a,
						isThemeMenuOpen: S,
						setIsThemeMenuOpen: C,
						headerDisplay: I,
						themeMenuPosition: E,
						themeMenuRef: P,
						activeTheme: A,
						setActiveTheme: j,
						isColumnMenuOpen: w,
						setIsColumnMenuOpen: T,
						columnMenuPosition: O,
						columnMenuRef: F,
						handleColumnAction: ee,
						pinnedColumns: y,
						onColumnPin: p,
						onColumnResize: g
					})
				]
			})]
		})
	});
}, $S = (e, t) => e instanceof Set ? e.has(t) : e.includes(t), eC = (e) => e instanceof Set ? e.size : e.length, tC = ({ isOpen: e, onClose: t, content: n, filterType: r, uniqueValues: i = [], minMax: a, selectedValues: o, setSelectedValues: s, rangeValues: c, setRangeValues: l, applyFilterAndClose: d, searchTerm: f, setSearchTerm: p }) => {
	u(() => {
		let n = (e) => {
			e.key === "Escape" && t();
		};
		return e && document.addEventListener("keydown", n), () => {
			document.removeEventListener("keydown", n);
		};
	}, [e, t]), u(() => (e ? document.body.style.overflow = "hidden" : document.body.style.overflow = "unset", () => {
		document.body.style.overflow = "unset";
	}), [e]);
	let m = (e) => {
		s && s((t) => {
			if (t instanceof Set) {
				let n = new Set(t);
				return n.has(e) ? n.delete(e) : n.add(e), n;
			} else {
				let n = [...t], r = n.indexOf(e);
				return r >= 0 ? n.splice(r, 1) : n.push(e), n;
			}
		});
	}, h = (e, t) => {
		if (l) {
			let n = parseFloat(e.target.value);
			l((e) => ({
				...e,
				[t]: n
			}));
		}
	}, g = () => {
		s && i && i.length > 0 && (i.every((e) => $S(o, e)) ? s(o instanceof Set ? /* @__PURE__ */ new Set() : []) : s(o instanceof Set ? new Set(i) : [...i]));
	}, b = i.filter((e) => e.toLowerCase().includes(f.toLowerCase()));
	if (!e) return null;
	let x = () => n === "Filter" || n.startsWith("Filter:") ? S() : /* @__PURE__ */ _("div", { children: n }), S = () => /* @__PURE__ */ _("div", {
		className: "p-4",
		children: r === "numeric" ? /* @__PURE__ */ v("div", {
			className: "space-y-4",
			children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("label", {
				className: "block text-sm font-medium mb-1",
				children: "Range Filter"
			}), /* @__PURE__ */ v("div", {
				className: "flex items-center space-x-2",
				children: [
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("label", {
						htmlFor: "min",
						className: "block text-xs",
						style: { color: "var(--modal-label-text)" },
						children: "Min"
					}), /* @__PURE__ */ _("input", {
						id: "min",
						type: "number",
						value: c.min,
						onChange: (e) => h(e, "min"),
						className: "rounded px-2 py-1 text-sm w-24",
						style: { border: "1px solid var(--modal-input-border)" },
						disabled: !l
					})] }),
					/* @__PURE__ */ _("div", {
						style: { color: "var(--modal-range-connector-text)" },
						children: "to"
					}),
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("label", {
						htmlFor: "max",
						className: "block text-xs",
						style: { color: "var(--modal-label-text)" },
						children: "Max"
					}), /* @__PURE__ */ _("input", {
						id: "max",
						type: "number",
						value: c.max,
						onChange: (e) => h(e, "max"),
						className: "rounded px-2 py-1 text-sm w-24",
						style: { border: "1px solid var(--modal-input-border)" },
						disabled: !l
					})] })
				]
			})] }), /* @__PURE__ */ v("div", { children: [
				/* @__PURE__ */ _("label", {
					className: "block text-sm font-medium mb-1",
					children: "Range Slider"
				}),
				/* @__PURE__ */ _("input", {
					type: "range",
					min: a?.min || 0,
					max: a?.max || 100,
					value: c.min,
					onChange: (e) => h(e, "min"),
					className: "w-full",
					disabled: !l
				}),
				/* @__PURE__ */ _("input", {
					type: "range",
					min: a?.min || 0,
					max: a?.max || 100,
					value: c.max,
					onChange: (e) => h(e, "max"),
					className: "w-full",
					disabled: !l
				})
			] })]
		}) : r === "categorical" ? /* @__PURE__ */ v("div", {
			className: "space-y-4",
			children: [
				/* @__PURE__ */ v("div", {
					className: "flex justify-between items-center",
					children: [/* @__PURE__ */ _("input", {
						type: "text",
						value: f,
						onChange: (e) => p(e.target.value),
						placeholder: "Search values...",
						className: "rounded px-2 py-1 text-sm w-2/3",
						style: { border: "1px solid var(--modal-input-border)" }
					}), /* @__PURE__ */ _("button", {
						onClick: g,
						className: "text-sm",
						style: { color: "var(--modal-select-all-text)" },
						onMouseOver: (e) => {
							e.currentTarget.style.color = "var(--modal-select-all-hover-text)";
						},
						onMouseOut: (e) => {
							e.currentTarget.style.color = "var(--modal-select-all-text)";
						},
						disabled: !s,
						children: i && i.every((e) => $S(o, e)) ? "Deselect All" : "Select All"
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "max-h-64 overflow-y-auto border rounded",
					children: b.length > 0 ? /* @__PURE__ */ _("ul", {
						style: { borderTop: "none" },
						children: b.map((e) => /* @__PURE__ */ _("li", {
							style: { borderBottom: "1px solid var(--modal-list-divider)" },
							onMouseOver: (e) => {
								e.currentTarget.style.backgroundColor = "var(--modal-list-item-hover-bg)";
							},
							onMouseOut: (e) => {
								e.currentTarget.style.backgroundColor = "transparent";
							},
							children: /* @__PURE__ */ v("label", {
								className: "flex items-center space-x-2 px-3 py-1 cursor-pointer",
								children: [/* @__PURE__ */ _("input", {
									type: "checkbox",
									checked: $S(o, e),
									onChange: () => m(e),
									className: "accent-primary",
									disabled: !s
								}), /* @__PURE__ */ _("span", {
									className: "text-sm",
									children: e || "(empty)"
								})]
							})
						}, e))
					}) : /* @__PURE__ */ _("div", {
						className: "p-3 text-center text-sm",
						style: { color: "var(--modal-no-values-text)" },
						children: f ? "No matching values" : "No values available"
					})
				}),
				/* @__PURE__ */ v("div", {
					className: "text-xs",
					style: { color: "var(--modal-selected-count-text)" },
					children: [
						eC(o),
						" of ",
						i.length,
						" selected"
					]
				})
			]
		}) : /* @__PURE__ */ _("div", {
			className: "text-center",
			style: { color: "var(--modal-filter-type-text)" },
			children: "Select a filter type to continue."
		})
	});
	return y.createPortal(/* @__PURE__ */ v("div", {
		className: "fixed inset-0 z-50",
		children: [/* @__PURE__ */ _("div", {
			className: "fixed inset-0",
			style: { backgroundColor: "var(--modal-overlay-bg)" },
			onClick: t
		}), /* @__PURE__ */ v("div", {
			className: "fixed left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full max-w-md rounded-lg bg-background shadow-lg",
			children: [
				/* @__PURE__ */ v("div", {
					className: "px-4 py-3 flex justify-between items-center border-b border-border-light",
					children: [/* @__PURE__ */ _("h2", {
						className: "text-lg font-medium text-text",
						children: n
					}), /* @__PURE__ */ v("button", {
						type: "button",
						onClick: t,
						className: "rounded-md p-1 inline-flex items-center justify-center focus:outline-none focus:ring-2 focus:ring-inset bg-background text-text hover:text-error-dark hover:bg-background-light",
						children: [/* @__PURE__ */ _("span", {
							className: "sr-only",
							children: "Close modal"
						}), /* @__PURE__ */ _(xs, { className: "w-5 h-5 hover:text-error-dark" })]
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "max-h-[70vh] overflow-y-auto modal-scrollbar",
					children: x()
				}),
				/* @__PURE__ */ v("div", {
					className: "px-4 py-3 flex justify-end space-x-2 rounded-b-lg bg-background-light border-t border-border-light",
					children: [/* @__PURE__ */ _("button", {
						type: "button",
						onClick: t,
						className: "inline-flex justify-center py-1 px-3 shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 text-text bg-background border border-border-light hover:bg-background-dark",
						children: "Cancel"
					}), r && /* @__PURE__ */ _("button", {
						type: "button",
						onClick: d,
						className: "inline-flex justify-center py-1 px-3 border border-transparent shadow-sm text-sm font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 text-background bg-primary hover:bg-primary-dark",
						children: "Apply Filter"
					})]
				})
			]
		})]
	}), document.body);
}, nC = D("useMissingData"), rC = /* @__PURE__ */ new Map(), iC = (e, t, n = {}) => {
	let r = Di(), [i, a] = h({}), [o, s] = h(!1), [c, l] = h(null), d = m(!0), f = m(null), p = JSON.stringify(n);
	return u(() => (d.current = !0, () => {
		d.current = !1;
	}), []), u(() => {
		(async () => {
			if (!e || !t) return;
			let i = `missing-data-${e}-${t}-${p}`;
			if (f.current === i) return;
			if (rC.has(i)) {
				nC.debug("Using existing missing data request");
				try {
					let e = await rC.get(i);
					d.current && a(e);
				} catch {}
				return;
			}
			s(!0), l(null);
			let o;
			try {
				nC.debug("Fetching missing data", {
					databaseId: e,
					tableName: t
				}), o = new Promise(async (i, a) => {
					try {
						let a = await r.fetchMissingData(e, t, {
							maxSampleSize: 1e3,
							fullAnalysis: !1,
							filters: n.filters,
							sampleStrategy: n.sampleStrategy,
							samplePercentage: n.samplePercentage,
							stratifyColumn: n.stratifyColumn,
							seed: n.seed
						}), o = [];
						if (a && typeof a == "object") {
							let e = a.data || a;
							Array.isArray(e) ? o = e : e && typeof e == "object" && "columns" in e && Array.isArray(e.columns) ? o = e.columns : e && typeof e == "object" && "data" in e && typeof e.data == "object" && e.data !== null && "columns" in e.data && Array.isArray(e.data.columns) ? o = e.data.columns : e && typeof e == "object" && (o = Object.entries(e).map(([e, t]) => {
								let n = 0, r = 0, i = 0;
								return typeof t == "number" ? i = t : typeof t == "object" && t && ("missingCount" in t && typeof t.missingCount == "number" && (n = t.missingCount), "totalCount" in t && typeof t.totalCount == "number" && (r = t.totalCount), "missingPercentage" in t && typeof t.missingPercentage == "number" && (i = t.missingPercentage)), {
									name: e,
									missingCount: n,
									totalCount: r,
									missingPercentage: i
								};
							}));
						}
						let s = {};
						Array.isArray(o) && o.forEach((e) => {
							e && e.name && (s[e.name] = e.missingPercentage || 0);
						}), nC.debug("Missing data fetched successfully", {
							columnsProcessed: Object.keys(s).length,
							responseStructure: a ? typeof a : "null"
						}), i(s);
					} catch (e) {
						a(e);
					}
				}), rC.set(i, o);
				let s = await o;
				d.current && (a(s), f.current = i);
			} catch (e) {
				if (d.current) {
					let t = e.response?.data?.message || e.message || "Failed to fetch missing data";
					nC.error("Error fetching missing data", { error: t }), l(t);
				}
			} finally {
				rC.delete(i), d.current && s(!1);
			}
		})();
	}, [
		e,
		t,
		r,
		p
	]), {
		missingData: i,
		isLoading: o,
		error: c
	};
}, aC = ({ columns: e, data: t, sortBy: n, order: r, handleSort: i, tableName: a, databaseId: o, hasActions: s, selectedRows: c, setSelectedRows: l, isAllSelected: d, onToggleSelectAll: y, onBulkAction: b, applyFilter: x, clearFilter: S, filters: C = {}, onStatsPanelChange: w, openStatsPanel: T, toggleSidebarFilters: E, actions: D = [], actionHandlers: O = {}, isExporting: k = !1, sampling: A, columnOrder: j, pinnedColumns: M = {
	left: [],
	right: []
}, onColumnPin: N, onColumnReorder: P, columnWidths: F = {}, onColumnResize: I, currentTheme: L, vendorAuditByColumn: R = {}, headerDisplay: z, headerTypography: B, columnLabels: V, renderColumnHeaderAction: H }) => {
	let ee = Di(), [, U] = p((e) => e + 1, 0), [te, W] = h(L || "default"), [ne, re] = h(""), [ie, ae] = h(null), [oe, se] = h(!1), [ce, le] = h(!1), ue = m(null), { missingData: de, isLoading: fe } = iC(o, a, f(() => {
		let { __sampling: e, ...t } = C ?? {}, n = A?.samplingState;
		return {
			filters: t,
			...n?.isSamplingEnabled ? {
				sampleStrategy: n.currentStrategy?.id,
				samplePercentage: n.samplePercentage,
				stratifyColumn: n.selectedColumn,
				seed: n.seed
			} : {}
		};
	}, [C, A])), pe = f(() => {
		let n = {};
		return t && t.length > 0 && e.forEach((e) => {
			n[e] = Ab(e, t);
		}), n;
	}, [e, t]), { isModalOpen: me, modalContent: he, filterType: ge, uniqueValues: _e, minMax: ve, selectedValues: ye, setSelectedValues: be, rangeValues: xe, setRangeValues: Se, closeModal: Ce, applyFilterAndClose: we, searchTerm: G, setSearchTerm: Te, openModal: Ee } = eS(t, a, o, x, S, C), K = async (e) => {
		if (console.log("Opening stats for column:", e), pe[e] === "media") {
			console.log("Skipping stats for media/binary column:", e);
			return;
		}
		if (T) {
			console.log("Using enhanced openStatsPanel handler"), T(e);
			return;
		}
		console.log("Using legacy stats panel opening method"), re(e), se(!0), le(!0);
		try {
			let t = await ee.fetchColumnStats(o, a, e, {
				samplePercentage: 100,
				filters: C || {}
			});
			if (!t) throw Error("No data received from stats API");
			let n = C && Object.keys(C).length > 0;
			t.metadata ||= {}, t.metadata.isFiltered = n, console.log("Stats data received:", t, "Has active filters:", n), ae(t), w && (console.log("Current column type:", pe[e]), w(!0, e));
		} catch (e) {
			console.error("Failed to fetch stats:", e), ae(null);
		} finally {
			se(!1);
		}
	}, De = () => {
		le(!1), re(""), ae(null), w && w(!1);
	};
	u(() => {
		ne || ae(null);
	}, [ne]), u(() => () => {
		ue.current && clearTimeout(ue.current);
	}, []);
	let Oe = f(() => {
		let t = j || e, n = M.left.filter((e) => t.includes(e)), r = M.right.filter((e) => t.includes(e));
		return {
			left: n,
			center: t.filter((e) => !M.left.includes(e) && !M.right.includes(e)),
			right: r
		};
	}, [
		e,
		j,
		M
	]), ke = f(() => ({
		showColumnMenu: z?.showColumnMenu ?? !0,
		showSortControls: z?.showSortControls ?? !0,
		sortControlVisibility: z?.sortControlVisibility ?? "always",
		showColumnHeaderActions: z?.showColumnHeaderActions ?? !0,
		showFilterControls: z?.showFilterControls ?? !0,
		showSamplingControls: z?.showSamplingControls ?? !0,
		showStatisticsControls: z?.showStatisticsControls ?? !0,
		showDatatypeIcons: (z?.showDatatypeIcons ?? !0) && (z?.showStatisticsControls ?? !0),
		showMissingDataIndicator: z?.showMissingDataIndicator ?? !0
	}), [
		z?.showColumnMenu,
		z?.showColumnHeaderActions,
		z?.showDatatypeIcons,
		z?.showFilterControls,
		z?.showMissingDataIndicator,
		z?.showSamplingControls,
		z?.showSortControls,
		z?.showStatisticsControls,
		z?.sortControlVisibility
	]), Ae = f(() => s ? ZS(D, ke) : 0, [
		D,
		s,
		ke
	]), je = S || (() => {
		console.warn("clearFilter function not provided");
	}), Me = (e) => {
		E && E(e);
	}, Ne = {
		position: "sticky",
		top: 0,
		zIndex: 40,
		backgroundColor: "var(--color-background-light)",
		fontFamily: B?.fontFamily,
		fontSize: B?.fontSize,
		lineHeight: B?.lineHeight,
		color: B?.color
	};
	return /* @__PURE__ */ v(g, { children: [
		me && /* @__PURE__ */ _(tC, {
			isOpen: !0,
			onClose: Ce,
			content: he,
			stats: null,
			filterType: ge,
			uniqueValues: _e,
			minMax: ve,
			selectedValues: ye,
			setSelectedValues: be,
			rangeValues: xe,
			setRangeValues: Se,
			applyFilterAndClose: we,
			searchTerm: G,
			setSearchTerm: Te,
			isLoadingStats: !1
		}),
		/* @__PURE__ */ _("thead", {
			className: "text-xs uppercase bg-background-light text-text sticky top-0 z-40 border-t border-b border-border-dark",
			style: Ne,
			children: /* @__PURE__ */ v("tr", {
				className: "relative",
				children: [
					s && /* @__PURE__ */ _(QS, {
						selectedRows: c,
						setSelectedRows: l,
						isAllSelected: d,
						onToggleSelectAll: y,
						onBulkAction: b,
						toggleSidebarFilters: Me,
						actions: D,
						actionHandlers: {
							...O,
							onThemeChange: (e) => {
								Promise.resolve().then(() => MS).then(({ loadTheme: t }) => {
									t(e), W(e), U();
								});
							},
							onColumnManagement: (e) => {
								console.log("Column management action triggered:", e), (e === "auto-fit-all" || e === "reset-all-widths" || e === "reset-all") && O.onColumnManagement && O.onColumnManagement(e);
							}
						},
						filters: C,
						isExporting: k,
						currentTheme: te,
						headerDisplay: ke,
						onColumnPin: N,
						onColumnResize: I,
						pinnedColumns: M
					}),
					Oe.left.map((e, t) => /* @__PURE__ */ _(sS, {
						column: e,
						sortBy: n || "",
						order: r || "",
						handleSort: i,
						clearFilter: je,
						filter: C,
						openModal: Ee,
						openStats: K,
						missingData: de,
						columnType: pe[e],
						isPinned: "left",
						pinnedIndex: t,
						onColumnPin: N,
						columnWidth: aS(e, F),
						onColumnResize: I,
						pinnedColumns: M,
						columnWidths: F,
						actionColumnWidth: Ae,
						vendorAuditStatus: R[e],
						headerDisplay: ke,
						headerTypography: B,
						headerLabel: V?.[e],
						renderColumnHeaderAction: H
					}, `left-${e}`)),
					Oe.center.map((e) => /* @__PURE__ */ _(sS, {
						column: e,
						sortBy: n || "",
						order: r || "",
						handleSort: i,
						clearFilter: je,
						filter: C,
						openModal: Ee,
						openStats: K,
						missingData: de,
						columnType: pe[e],
						onColumnPin: N,
						columnWidth: aS(e, F),
						onColumnResize: I,
						pinnedColumns: M,
						columnWidths: F,
						actionColumnWidth: Ae,
						vendorAuditStatus: R[e],
						headerDisplay: ke,
						headerTypography: B,
						headerLabel: V?.[e],
						renderColumnHeaderAction: H
					}, e)),
					Oe.right.map((e, t) => /* @__PURE__ */ _(sS, {
						column: e,
						sortBy: n || "",
						order: r || "",
						handleSort: i,
						clearFilter: je,
						filter: C,
						openModal: Ee,
						openStats: K,
						missingData: de,
						columnType: pe[e],
						isPinned: "right",
						pinnedIndex: t,
						onColumnPin: N,
						columnWidth: aS(e, F),
						onColumnResize: I,
						pinnedColumns: M,
						columnWidths: F,
						actionColumnWidth: Ae,
						vendorAuditStatus: R[e],
						headerDisplay: ke,
						headerTypography: B,
						headerLabel: V?.[e],
						renderColumnHeaderAction: H
					}, `right-${e}`))
				]
			})
		}),
		ce && !T && /* @__PURE__ */ _(zy, {
			isOpen: !0,
			onClose: De,
			stats: ie,
			isLoading: oe,
			columnName: ne,
			tableName: a
		})
	] });
}, oC = 2;
function sC(e) {
	return e === void 0 || !Number.isFinite(e) || e < 1 ? oC : Math.min(Math.floor(e), oC);
}
function cC(e) {
	if (typeof e == "number" && Number.isFinite(e)) return e;
	if (typeof e == "string" && e.trim().length > 0) {
		let t = Number(e);
		if (Number.isFinite(t)) return t;
	}
	return null;
}
function lC(e) {
	let t = e.map((e) => cC(e)).filter((e) => e !== null);
	return t.length >= 2 ? t : null;
}
function uC(e, t) {
	let n = e.split(t).map((e) => e.trim()).filter(Boolean);
	return n.length < 3 ? null : lC(n);
}
function dC(e, t) {
	let n = [e, t];
	for (let e of n) {
		if (Array.isArray(e)) {
			let t = lC(e);
			if (t) return t;
			continue;
		}
		if (e && typeof e == "object") {
			let t = e;
			for (let e of [
				"series",
				"values",
				"trend",
				"data"
			]) if (Array.isArray(t[e])) {
				let n = lC(t[e]);
				if (n) return n;
			}
			continue;
		}
		if (typeof e == "string") {
			let t = e.trim();
			if (!t) continue;
			if (t.startsWith("[") && t.endsWith("]") || t.startsWith("{") && t.endsWith("}")) try {
				let e = dC(JSON.parse(t), "");
				if (e) return e;
			} catch {}
			let n = uC(t, "|");
			if (n) return n;
			let r = uC(t, ";");
			if (r) return r;
			if ((t.match(/,/g) ?? []).length >= 2) {
				let e = uC(t, ",");
				if (e) return e;
			}
		}
	}
	return null;
}
function fC(e) {
	let t = e.slice(0, 8).map((e) => e.toLocaleString()).join(", ");
	return `Series (${e.length}): ${t}${e.length > 8 ? ", ..." : ""}`;
}
function pC(e, t = 24) {
	if (e.length <= t) return e;
	let n = (e.length - 1) / (t - 1);
	return Array.from({ length: t }, (t, r) => e[Math.round(r * n)]);
}
function mC(e, t = 84, n = 24, r = 3) {
	let i = Math.min(...e), a = Math.max(...e), o = e.length === 1 ? 0 : (t - r * 2) / (e.length - 1), s = Math.max(a - i, 1);
	return e.map((e, t) => {
		let a = r + o * t, c = n - r - (e - i) / s * (n - r * 2);
		return `${t === 0 ? "M" : "L"} ${a.toFixed(2)} ${c.toFixed(2)}`;
	}).join(" ");
}
var hC = ({ content: e, rawValue: t, renderedContent: n, columnType: r = "text", maxLength: i = 200, isSelected: a = !1, showTooltip: o = !0, rowHeight: s, bodyTypography: c, textOptions: l }) => {
	let d = m(null), [f, p] = h(!1), [g, y] = h(!1);
	u(() => {
		if (d.current) {
			let e = d.current;
			p(e.scrollWidth > e.clientWidth || e.scrollHeight > e.clientHeight);
		}
	}, [
		e,
		i,
		t,
		l?.mode,
		l?.maxLength,
		l?.maxLines
	]);
	let b = (() => {
		if (e == null || e === "") return "";
		if (r === "numeric" && !isNaN(Number(e))) return Number(e).toLocaleString();
		if (r === "date") try {
			let t = new Date(e);
			if (!isNaN(t.getTime())) return t.toLocaleDateString();
		} catch {}
		return e;
	})(), x = n != null, S = x ? null : dC(t, e), C = S ? pC(S) : null, w = S?.[S.length - 1] ?? null, T = C ? mC(C) : null, E = S ? fC(S) : b, D = l?.mode ?? "truncate", O = D === "full" ? void 0 : sC(l?.maxLines), k = D === "full" ? void 0 : l?.maxLength ?? (D === "truncate" ? i : void 0), A = k !== void 0 && b.length > k, j = A ? `${b.substring(0, k)}...` : b, M = A || f, N = `datagrid-cell-content block w-full h-full px-2 py-1 text-sm font-sans overflow-hidden ${r === "numeric" ? "text-right font-mono text-primary" : r === "date" ? "text-center text-accent" : "text-left text-text"} ${a ? "bg-accent-light" : "bg-background"}`, P = x ? !1 : S ? !0 : (l?.showTooltip ?? o) && M, F = O !== void 0 && O > 0, I = D === "wrap" || D === "full";
	return /* @__PURE__ */ v("div", {
		className: "relative group",
		children: [/* @__PURE__ */ _("div", {
			className: N,
			ref: d,
			onMouseEnter: () => y(!0),
			onMouseLeave: () => y(!1),
			style: {
				display: x || !F ? "block" : "-webkit-box",
				minHeight: s ? `${s}px` : void 0,
				alignItems: "center",
				WebkitLineClamp: x || !F ? void 0 : O,
				WebkitBoxOrient: x || !F ? void 0 : "vertical",
				WebkitBoxPack: x || !F ? void 0 : "center",
				whiteSpace: I ? "pre-wrap" : void 0,
				overflow: D === "full" ? "visible" : void 0,
				textOverflow: "ellipsis",
				wordBreak: I ? "normal" : "break-word",
				overflowWrap: "anywhere",
				fontFamily: c?.fontFamily,
				fontSize: c?.fontSize,
				lineHeight: c?.lineHeight,
				fontWeight: c?.fontWeight,
				letterSpacing: c?.letterSpacing,
				textTransform: c?.textTransform,
				color: c?.color
			},
			children: x ? n : S && T && w !== null ? /* @__PURE__ */ v("div", {
				className: "flex h-full w-full items-center justify-between gap-2",
				children: [/* @__PURE__ */ _("svg", {
					viewBox: "0 0 84 24",
					className: "h-6 w-[5.25rem] shrink-0 overflow-visible",
					"data-testid": "sparkline-cell",
					"aria-label": E,
					children: /* @__PURE__ */ _("path", {
						d: T,
						fill: "none",
						stroke: "currentColor",
						strokeWidth: "1.75",
						strokeLinecap: "round",
						strokeLinejoin: "round",
						className: "text-sky-600"
					})
				}), /* @__PURE__ */ _("span", {
					className: "truncate text-xs font-semibold text-slate-700",
					children: w.toLocaleString()
				})]
			}) : j
		}), P && g && /* @__PURE__ */ v("div", {
			className: "absolute z-50 bottom-full left-0 mb-1 px-2 py-1 bg-background-dark text-text text-sm rounded shadow-lg border border-border-light max-w-xs break-words whitespace-pre-wrap",
			children: [E, /* @__PURE__ */ _("div", { className: "absolute top-full left-2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-background-dark" })]
		})]
	});
};
//#endregion
//#region src/components/grid/BodyActions.tsx
function gC(e) {
	return yS(e, $.VIEW) ? /* @__PURE__ */ _(Fo, { className: "w-5 h-5 text-icon-view hover:text-icon-view-hover" }) : yS(e, $.EDIT) ? /* @__PURE__ */ _(Zo, { className: "w-5 h-5 text-icon-edit hover:text-icon-edit-hover" }) : yS(e, $.DELETE) ? /* @__PURE__ */ _(hs, { className: "w-5 h-5 text-icon-delete hover:text-icon-delete-hover" }) : null;
}
function _C(e) {
	return /* @__PURE__ */ _("span", {
		className: "block max-w-16 overflow-hidden text-center text-[11px] font-medium leading-3 text-text",
		style: {
			display: "-webkit-box",
			WebkitLineClamp: 2,
			WebkitBoxOrient: "vertical"
		},
		children: e
	});
}
var vC = ({ rowId: e, rowData: t, actions: n, actionHandlers: r, selectedRows: i, onRowSelect: a }) => {
	let o = {
		rowId: e,
		rowData: t
	}, s = CS(n, "row", o), c = s.some((e) => yS(e, $.SELECT)), l = s.filter((e) => !yS(e, $.SELECT)), u = (n) => {
		if (yS(n, $.VIEW)) {
			(r.onView ?? r[$.VIEW] ?? r[n.id])?.(e, t);
			return;
		}
		if (yS(n, $.EDIT)) {
			(r.onEdit ?? r[$.EDIT] ?? r[n.id])?.(e, t);
			return;
		}
		if (yS(n, $.DELETE)) {
			(r.onDelete ?? r[$.DELETE] ?? r[n.id])?.(e, t);
			return;
		}
		r[n.id]?.(e, t);
	}, d = (e, t) => {
		if (t.stopPropagation(), !SS(e, {
			...o,
			event: t
		})) try {
			if (e.onClick) {
				e.onClick({
					...o,
					actionId: e.id,
					event: t
				});
				return;
			}
			u(e);
		} catch (t) {
			console.error(`Error in datagrid action "${e.id}":`, t);
		}
	}, f = i.has(e);
	return /* @__PURE__ */ v("div", {
		className: "datagrid-actions-shell h-full w-full relative",
		children: [/* @__PURE__ */ _("div", {
			className: "absolute top-0 bottom-0 right-0",
			style: {
				width: "1px",
				backgroundColor: "var(--color-primary)",
				zIndex: 30,
				pointerEvents: "none"
			}
		}), /* @__PURE__ */ _("div", {
			className: "datagrid-actions-content h-full w-full",
			style: {
				display: "flex",
				alignItems: "center",
				backgroundColor: f ? "var(--color-accent-light)" : "var(--color-background)",
				boxShadow: "-1px 0 0 0 var(--color-border-light)",
				position: "relative",
				zIndex: 1,
				minHeight: "var(--datagrid-row-height, 2.75rem)",
				padding: "0.25rem"
			},
			children: /* @__PURE__ */ v("div", {
				className: "flex w-full flex-wrap items-center gap-1 pl-1",
				children: [c && /* @__PURE__ */ _("input", {
					type: "checkbox",
					checked: f,
					onChange: (t) => {
						t.stopPropagation(), a(e);
					},
					className: "h-4 w-4 flex-shrink-0 accent-primary"
				}), /* @__PURE__ */ _("div", {
					className: "flex flex-wrap items-center gap-1",
					children: l.map((e) => {
						let t = SS(e, o), n = e.icon ?? gC(e);
						return /* @__PURE__ */ _("button", {
							type: "button",
							onClick: (t) => d(e, t),
							className: `inline-flex max-h-10 min-h-7 min-w-7 max-w-20 items-center justify-center overflow-hidden rounded p-1 align-middle leading-none transition-colors hover:bg-background-light disabled:cursor-not-allowed disabled:opacity-50 ${e.className ?? ""}`,
							title: e.title,
							"aria-label": e.ariaLabel,
							disabled: t,
							children: n ?? _C(e.label)
						}, e.id);
					})
				})]
			})
		})]
	});
};
//#endregion
//#region src/components/grid/Row.tsx
function yC(e) {
	if (e == null) return "";
	if (typeof e == "string") return e;
	if (typeof e == "object") try {
		return JSON.stringify(e);
	} catch {
		return String(e);
	}
	return String(e);
}
function bC(e) {
	return e instanceof Element ? !!e.closest([
		"a",
		"button",
		"input",
		"select",
		"textarea",
		"[role=\"button\"]",
		"[role=\"checkbox\"]",
		"[data-datagrid-row-click-ignore=\"true\"]",
		".datagrid-actions-cell"
	].join(",")) : !1;
}
function xC(e) {
	return typeof e == "boolean" ? {
		enabled: e,
		saveOnBlur: !0
	} : {
		enabled: e?.enabled ?? !1,
		saveOnBlur: e?.saveOnBlur ?? !0,
		editableColumns: e?.editableColumns,
		readonlyColumns: e?.readonlyColumns
	};
}
function SC(e) {
	return e === "rowid" || /^id$/i.test(e);
}
function CC(e, t) {
	return !(!t.enabled || SC(e) || t.readonlyColumns?.includes(e) || t.editableColumns && !t.editableColumns.includes(e));
}
function wC(e, t, n) {
	return typeof t == "boolean" || /^is_|^has_|enabled|active|disabled|flag/i.test(e) ? "checkbox" : n === "numeric" ? "number" : n === "date" ? /time|timestamp|created|updated|modified/i.test(e) ? "datetime" : "date" : "text";
}
function TC(e, t) {
	if (e == null || e === "") return "";
	let n = new Date(String(e));
	if (Number.isNaN(n.getTime())) return String(e);
	let r = (e) => String(e).padStart(2, "0"), i = `${n.getFullYear()}-${r(n.getMonth() + 1)}-${r(n.getDate())}`;
	return t ? `${i}T${r(n.getHours())}:${r(n.getMinutes())}` : i;
}
function EC(e, t) {
	return t === "checkbox" ? !!e : t === "date" ? TC(e, !1) : t === "datetime" ? TC(e, !0) : e == null ? "" : String(e);
}
function DC(e, t) {
	if (t === "checkbox") return !!e;
	if (t === "number") {
		if (e === "") return null;
		let t = Number(e);
		return Number.isFinite(t) ? t : e;
	}
	return (t === "date" || t === "datetime") && e === "" ? null : e;
}
function OC(e) {
	return e.map((e) => typeof e == "string" ? {
		value: e,
		label: e
	} : {
		value: String(e.value),
		label: e.label ?? String(e.value),
		description: e.description
	});
}
function kC(e) {
	return /(^|_)id$|uuid|guid|key|code|status|type|owner|priority/i.test(e);
}
function AC({ column: e, rowId: t, row: n, value: r, columnType: i, onCancel: a, onCommit: o, saveOnBlur: s, loadReferenceOptions: c }) {
	let l = wC(e, r, i), [d, p] = h(() => EC(r, l)), y = m(d), [b, x] = h(!1), [S, C] = h(!1), [w, T] = h([]), E = m(null), D = m(!1), O = f(() => `datagrid-inline-${e.replace(/[^a-z0-9_-]/gi, "-")}-${String(t).replace(/[^a-z0-9_-]/gi, "-")}`, [e, t]), k = (e) => {
		y.current = e, p(e);
	};
	u(() => {
		E.current?.focus(), E.current?.select?.();
	}, []), u(() => {
		if (!c || l !== "text" || !kC(e)) return;
		let t = !1, i = String(d ?? "").trim(), a = window.setTimeout(async () => {
			try {
				let a = await c({
					column: e,
					searchTerm: i,
					limit: 25,
					currentValue: r,
					rowData: n,
					mode: "edit"
				});
				t || T(OC(a).slice(0, 25));
			} catch {
				t || T([]);
			}
		}, 250);
		return () => {
			t = !0, window.clearTimeout(a);
		};
	}, [
		e,
		d,
		l,
		c,
		n,
		r
	]);
	let A = async () => {
		if (D.current) return;
		D.current = !0, x(!0), C(!1);
		let e = !1;
		try {
			e = await o(DC(y.current, l));
		} catch {
			e = !1;
		} finally {
			x(!1);
		}
		e || (D.current = !1, C(!0));
	}, j = `h-full min-h-[var(--datagrid-row-height,2.75rem)] w-full border px-2 py-1 text-sm outline-none ${S ? "border-error-dark bg-error-light text-error-dark" : "border-primary bg-background-light text-text focus:ring-2 focus:ring-primary"}`;
	return l === "checkbox" ? /* @__PURE__ */ v("label", {
		className: `${j} flex items-center justify-center gap-2`,
		"data-datagrid-row-click-ignore": "true",
		children: [/* @__PURE__ */ _("input", {
			ref: E,
			type: "checkbox",
			checked: !!d,
			disabled: b,
			onChange: (e) => k(e.target.checked),
			onBlur: s ? A : void 0,
			onKeyDown: (e) => {
				e.key === "Escape" && (e.preventDefault(), a());
			},
			className: "h-4 w-4 accent-primary"
		}), /* @__PURE__ */ _("span", { children: d ? "Yes" : "No" })]
	}) : /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("input", {
		ref: E,
		type: l === "datetime" ? "datetime-local" : l,
		step: l === "number" ? "any" : void 0,
		list: w.length > 0 ? O : void 0,
		value: String(d),
		disabled: b,
		onChange: (e) => k(e.target.value),
		onBlur: s ? A : void 0,
		onKeyDown: (e) => {
			e.key === "Enter" && (e.preventDefault(), A()), e.key === "Escape" && (e.preventDefault(), a());
		},
		className: j,
		"data-datagrid-row-click-ignore": "true"
	}), w.length > 0 ? /* @__PURE__ */ _("datalist", {
		id: O,
		children: w.map((t) => /* @__PURE__ */ _("option", {
			value: t.value,
			children: t.description ? `${t.label} - ${t.description}` : t.label
		}, `${e}-${t.value}`))
	}) : null] });
}
function jC({ canEdit: e, column: t, rowId: n, row: r, rawValue: i, content: a, renderedContent: o, columnType: s, isSelected: c, rowHeight: l, bodyTypography: u, textOptions: d, onCellSave: f, saveOnBlur: p, loadReferenceOptions: m }) {
	let [g, v] = h(!1);
	return /* @__PURE__ */ _("div", {
		onDoubleClick: (t) => {
			e && (t.stopPropagation(), v(!0));
		},
		title: e ? "Double-click to edit" : void 0,
		children: g ? /* @__PURE__ */ _(AC, {
			column: t,
			rowId: n,
			row: r,
			value: i,
			columnType: s,
			onCancel: () => v(!1),
			onCommit: async (e) => await f?.({
				rowId: n,
				rowData: r,
				column: t,
				value: e
			}) === !1 ? !1 : (v(!1), !0),
			saveOnBlur: p,
			loadReferenceOptions: m
		}) : /* @__PURE__ */ _(hC, {
			content: a,
			rawValue: i,
			renderedContent: o,
			columnType: s,
			isSelected: c,
			rowHeight: l,
			bodyTypography: u,
			textOptions: d
		})
	});
}
var MC = a(({ rowId: e, rowIndex: t = 0, row: n, columns: r, actions: i, actionHandlers: a, selectedRows: o, onRowSelect: s, onRowClick: c, columnTypes: l, isSelected: u, rowClassName: d = "", style: f, organizedColumns: p, pinnedColumns: m = {
	left: [],
	right: []
}, columnWidths: h = {}, rowHeight: y, bodyTypography: b, cellClassNames: x, cellRenderers: S, cellText: C, headerDisplay: w, inlineEditing: T, onCellSave: E, loadReferenceOptions: D }) => {
	process.env.NODE_ENV;
	let O = i.length > 0, k = xC(T), A = O ? ZS(i, w) : 0, j = (e, t, n) => {
		if (t === "none") return {};
		if (t === "left") {
			let e = A;
			for (let t = 0; t < n; t++) {
				let n = m.left[t], r = aS(n, h);
				e += r;
			}
			return {
				position: "sticky",
				left: `${e}px`,
				zIndex: 15,
				backgroundColor: u ? "var(--color-accent-light)" : "var(--color-background)",
				boxShadow: "5px 0 4px rgba(0,0,0,0.1)"
			};
		} else if (t === "right") {
			let e = 0;
			for (let t = n + 1; t < m.right.length; t++) {
				let n = m.right[t], r = aS(n, h);
				e += r;
			}
			return {
				position: "sticky",
				right: `${e}px`,
				zIndex: 15,
				backgroundColor: u ? "var(--color-accent-light)" : "var(--color-background)",
				boxShadow: "-2px 0 4px rgba(0,0,0,0.1)"
			};
		}
		return {};
	}, M = (e) => {
		switch (l[e] || "text") {
			case "numeric": return "text-right font-mono";
			case "date": return "text-xs text-muted-dark";
			case "text": return "text-left";
			default: return "";
		}
	}, N = (e) => {
		s && s(e);
	}, P = (t) => {
		!c || bC(t.target) || c(e, n);
	}, F = (t) => {
		!c || bC(t.target) || t.key !== "Enter" && t.key !== " " || (t.preventDefault(), c(e, n));
	}, I = () => {
		let t = m.left.length > 0;
		return /* @__PURE__ */ v("td", {
			className: "datagrid-actions-cell relative",
			style: {
				position: t ? "sticky" : "relative",
				left: t ? 0 : void 0,
				zIndex: t ? 25 : void 0,
				minWidth: `${A}px`,
				width: `${A}px`,
				padding: 0,
				margin: 0,
				borderLeft: "1px solid var(--color-border-light)",
				borderTop: "1px solid var(--color-border-light)",
				borderBottom: "0px solid var(--color-border-light)",
				borderRight: "none",
				backgroundColor: u ? "var(--color-accent-light)" : "var(--color-background)",
				verticalAlign: "top"
			},
			children: [/* @__PURE__ */ _("div", {
				className: "datagrid-actions-cell-divider absolute top-0 bottom-0 right-0",
				style: {
					width: "1px",
					backgroundColor: "var(--color-primary)",
					zIndex: 30,
					pointerEvents: "none"
				}
			}), /* @__PURE__ */ _(vC, {
				rowId: e,
				rowData: n,
				actions: i,
				actionHandlers: a,
				selectedRows: o,
				onRowSelect: N
			})]
		});
	}, L = (r, i = "none", a = 0) => {
		let o = n[r], s = yC(o), c = M(r), d = j(r, i, a), f = aS(r, h), p = S?.[r]?.({
			column: r,
			value: o,
			row: n
		}), w = l[r] || "text", T = !p && typeof E == "function" && CC(r, k), O = x?.[r], A = typeof O == "function" ? O({
			column: r,
			value: o,
			row: n,
			rowIndex: t,
			rowId: e,
			isSelected: u
		}) || "" : O ?? "", N = i === "left", P = i === "right", F = a > 0, I = P && m && a === m.right.length - 1;
		return /* @__PURE__ */ _("td", {
			className: `relative ${A}`,
			style: {
				backgroundColor: u ? "var(--color-accent-light)" : "var(--color-background)",
				borderBottom: "1px solid var(--color-border-light)",
				borderTop: "1px solid var(--color-border-light)",
				borderLeft: i === "left" || i === "right" ? "none" : "0px solid var(--color-border-light)",
				borderRight: i === "left" || P && !I ? "none" : "1px solid var(--color-border-light)",
				padding: "0",
				margin: 0,
				...d,
				width: `${f}px`,
				minWidth: `${f}px`,
				maxWidth: `${f}px`,
				verticalAlign: "middle",
				overflow: "hidden"
			},
			children: /* @__PURE__ */ v("div", {
				className: "h-full w-full relative",
				children: [
					N && /* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 right-0",
						style: {
							width: "0px",
							zIndex: 30,
							pointerEvents: "none"
						}
					}),
					N && F && /* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 right-0",
						style: {
							width: "0px",
							borderLeft: "0px solid var(--color-border-light)",
							zIndex: 30,
							pointerEvents: "none"
						}
					}),
					P && /* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 left-0",
						style: {
							width: "0px",
							backgroundColor: "var(--color-border-light)",
							zIndex: 30,
							pointerEvents: "none"
						}
					}),
					P && m && a < m.right.length - 1 && /* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 right-0",
						style: {
							width: "0px",
							borderRight: "0px solid var(--color-primary)",
							zIndex: 30,
							pointerEvents: "none"
						}
					}),
					i === "none" && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 left-0",
						style: {
							width: "0px",
							backgroundColor: "var(--color-border-light)",
							zIndex: 5,
							pointerEvents: "none"
						}
					}), /* @__PURE__ */ _("div", {
						className: "absolute top-0 bottom-0 right-0",
						style: {
							width: "0px",
							backgroundColor: "var(--color-border-light)",
							zIndex: 5,
							pointerEvents: "none"
						}
					})] }),
					/* @__PURE__ */ _("div", {
						className: `px-0 py-0 ${c}`,
						children: /* @__PURE__ */ _(jC, {
							canEdit: T,
							column: r,
							rowId: e,
							row: n,
							rawValue: o,
							content: s,
							renderedContent: p,
							columnType: w,
							isSelected: u,
							rowHeight: y,
							bodyTypography: b,
							textOptions: C?.[r],
							onCellSave: E,
							saveOnBlur: k.saveOnBlur !== !1,
							loadReferenceOptions: D
						})
					})
				]
			})
		}, `${e}-${r}`);
	};
	return /* @__PURE__ */ v("tr", {
		className: `transition-colors ${c ? "cursor-pointer" : ""} ${u ? "bg-accent-light" : "bg-background"} ${d}`,
		style: f,
		tabIndex: c ? 0 : void 0,
		onClick: P,
		onKeyDown: F,
		children: [O && I(), p && p.center.length > 0 ? /* @__PURE__ */ v(g, { children: [
			p.left.map((e, t) => L(e, "left", t)),
			p.center.map((e) => L(e, "none", 0)),
			p.right.map((e, t) => L(e, "right", t))
		] }) : r.map((e) => L(e))]
	});
}, (e, t) => e.row === t.row && e.rowIndex === t.rowIndex && e.isSelected === t.isSelected && e.selectedRows === t.selectedRows && e.onRowClick === t.onRowClick && e.rowHeight === t.rowHeight && e.bodyTypography === t.bodyTypography && e.rowClassName === t.rowClassName && e.cellClassNames === t.cellClassNames && e.cellRenderers === t.cellRenderers && e.cellText === t.cellText && e.inlineEditing === t.inlineEditing && e.onCellSave === t.onCellSave && e.loadReferenceOptions === t.loadReferenceOptions && JSON.stringify(e.columnWidths) === JSON.stringify(t.columnWidths) && JSON.stringify(e.pinnedColumns) === JSON.stringify(t.pinnedColumns)), NC = ({ onLoadMore: e, isLoading: t, hasMore: n, threshold: r = 200, disabled: i = !1, rootMargin: a, intersectionThreshold: o = .01, ariaLabel: s = "Load more items", ariaLive: c = "polite" }) => {
	let l = m(null), d = f(() => ({
		root: null,
		rootMargin: a || `0px 0px ${r}px 0px`,
		threshold: o
	}), [
		a,
		r,
		o
	]);
	return u(() => {
		if (i || !l.current || !n) return;
		let r = !1, a = null, o = (i) => {
			i[0].isIntersecting && n && !t && !r && (r = !0, a && clearTimeout(a), a = setTimeout(() => {
				try {
					e();
				} catch (e) {
					console.error("Error in onLoadMore:", e);
				}
				setTimeout(() => {
					r = !1;
				}, 500);
			}, 100));
		}, s = null;
		try {
			s = new IntersectionObserver(o, d), s.observe(l.current);
		} catch (e) {
			console.error("Error creating IntersectionObserver:", e);
		}
		return () => {
			if (a && clearTimeout(a), s && l.current) try {
				s.unobserve(l.current), s.disconnect();
			} catch (e) {
				console.error("Error cleaning up IntersectionObserver:", e);
			}
		};
	}, [
		e,
		t,
		n,
		i,
		d
	]), /* @__PURE__ */ v("div", {
		ref: l,
		className: "w-full flex justify-center py-6",
		style: { minHeight: "80px" },
		"data-testid": "infinite-scroll-detector",
		role: "region",
		"aria-live": c,
		"aria-label": s,
		children: [t ? /* @__PURE__ */ v("div", {
			className: "flex items-center space-x-2 bg-background-light px-4 py-2 rounded-lg shadow-sm",
			role: "status",
			"aria-live": "polite",
			children: [
				/* @__PURE__ */ _("div", { className: "animate-pulse w-3 h-3 rounded-full bg-primary" }),
				/* @__PURE__ */ _("div", { className: "animate-pulse w-3 h-3 rounded-full bg-primary animation-delay-100" }),
				/* @__PURE__ */ _("div", { className: "animate-pulse w-3 h-3 rounded-full bg-primary animation-delay-200" }),
				/* @__PURE__ */ _("span", {
					className: "text-sm text-muted-dark ml-2",
					children: "Loading more items..."
				})
			]
		}) : n ? /* @__PURE__ */ _("button", {
			onClick: e,
			className: "text-xs text-primary bg-background-light px-4 py-2 rounded-lg hover:bg-background-dark transition-colors",
			disabled: t,
			"aria-label": s,
			tabIndex: 0,
			onKeyDown: (n) => {
				(n.key === "Enter" || n.key === " ") && !t && (n.preventDefault(), e());
			},
			children: "Load more items"
		}) : /* @__PURE__ */ _("span", {
			className: "text-xs text-muted-dark bg-background-light px-4 py-2 rounded-lg",
			"aria-live": "polite",
			children: "All items loaded"
		}), /* @__PURE__ */ _("div", {
			className: "absolute bottom-0 left-0 w-full h-20 opacity-0 pointer-events-none",
			"aria-hidden": "true"
		})]
	});
}, PC = ({ columns: e, data: t, actions: n, actionHandlers: r, selectedRows: i, onRowSelect: a, onRowClick: o, idField: s = "rowid", columnOrder: c, pinnedColumns: l = {
	left: [],
	right: []
}, columnWidths: u = {}, rowHeight: d = 40, bodyTypography: p, rowClassName: m, cellClassNames: h, cellRenderers: g, cellText: v, columnTypes: y, inlineEditing: b, onCellSave: x, loadReferenceOptions: S, headerDisplay: C, height: w = 400 }) => {
	let T = {};
	t.length > 0 && e.forEach((e) => {
		let n = y?.[e];
		if (n === "numerical") {
			T[e] = "numeric";
			return;
		}
		if (n === "date") {
			T[e] = "date";
			return;
		}
		if (n === "categorical") {
			T[e] = "text";
			return;
		}
		let r = t[0][e];
		typeof r == "number" ? T[e] = "numeric" : r instanceof Date || typeof r == "string" && !isNaN(Date.parse(r)) && r.includes("-") ? T[e] = "date" : T[e] = "text";
	});
	let E = f(() => {
		let t = c || e, n = l.left.filter((e) => t.includes(e)), r = l.right.filter((e) => t.includes(e));
		return {
			left: n,
			center: t.filter((e) => !l.left.includes(e) && !l.right.includes(e)),
			right: r
		};
	}, [
		e,
		c,
		l
	]), D = f(() => {
		let e = {};
		return Object.keys(r).forEach((t) => {
			r[t] && (e[t] = (e, n) => {
				r[t]?.(e, n);
			});
		}), e;
	}, [r]);
	return t.length === 0 ? /* @__PURE__ */ _("tbody", { children: /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", {
		colSpan: e.length + +(n.length > 0),
		className: "px-4 py-8 text-center text-muted-dark bg-background",
		children: "No data available"
	}) }) }) : /* @__PURE__ */ _("tbody", { children: t.map((t, r) => {
		let c = Bi(t, s) ?? zi(t, r, s), f = i.has(c);
		return /* @__PURE__ */ _(MC, {
			rowId: c,
			rowIndex: r,
			row: t,
			columns: e,
			actions: n,
			actionHandlers: D,
			selectedRows: i,
			onRowSelect: a,
			onRowClick: o,
			columnTypes: T,
			isSelected: f,
			organizedColumns: E,
			pinnedColumns: l,
			columnWidths: u,
			rowHeight: d,
			rowClassName: typeof m == "function" ? m({
				row: t,
				rowIndex: r,
				rowId: c,
				isSelected: f
			}) || "" : m ?? "",
			bodyTypography: p,
			cellClassNames: h,
			cellRenderers: g,
			cellText: v,
			headerDisplay: C,
			inlineEditing: b,
			onCellSave: x,
			loadReferenceOptions: S
		}, zi(t, r, s));
	}) });
}, FC = ({ columns: e, rowCount: t = 10 }) => /* @__PURE__ */ _(g, { children: Array.from({ length: t }).map((t, n) => /* @__PURE__ */ _("tr", {
	className: "animate-pulse bg-background-light",
	children: e.map((e, t) => /* @__PURE__ */ _("td", {
		className: "px-4 py-3",
		children: /* @__PURE__ */ _("div", { className: "h-4 bg-muted rounded w-3/4 mx-auto" })
	}, t))
}, n)) }), IC = D("TableBody"), LC = a(({ columns: e, data: t, actions: n, actionHandlers: r, selectedRows: i, onRowSelect: a, onRowClick: o, idField: c = "rowid", columnOrder: l, pinnedColumns: d = {
	left: [],
	right: []
}, columnWidths: p = {}, rowHeight: h, bodyTypography: g, rowClassName: y, cellClassNames: b, cellRenderers: x, cellText: S, columnTypes: C, inlineEditing: w, onCellSave: T, loadReferenceOptions: E, headerDisplay: D, isInfiniteScroll: O = !1, isLoading: k = !1, hasMoreItems: A = !1, onLoadMore: j, virtualizationThreshold: M = 100, enableVirtualization: N = !1, infiniteScrollAriaLabel: P = "Load more items", infiniteScrollAriaLive: F = "polite", infiniteScrollDebounceMs: I = 300 }) => {
	let L = t.length > 0 ? "rowid" in t[0] : !1;
	t.length > 0 && !L && IC.warn(`SQLite rowid not found in data. Available fields: ${Object.keys(t[0]).join(", ")}`);
	let R = {};
	t.length > 0 && e.forEach((e) => {
		let n = C?.[e];
		if (n === "numerical") {
			R[e] = "numeric";
			return;
		}
		if (n === "date") {
			R[e] = "date";
			return;
		}
		if (n === "categorical") {
			R[e] = "text";
			return;
		}
		let r = t[0][e];
		typeof r == "number" ? R[e] = "numeric" : r instanceof Date || typeof r == "string" && !isNaN(Date.parse(r)) && r.includes("-") ? R[e] = "date" : R[e] = "text";
	});
	let z = f(() => {
		let t = l || e, n = d.left.filter((e) => t.includes(e)), r = d.right.filter((e) => t.includes(e)), i = {
			left: n,
			center: t.filter((e) => !d.left.includes(e) && !d.right.includes(e)),
			right: r
		};
		return process.env.NODE_ENV === "development" && IC.debug("Organized columns result:", i), i;
	}, [
		e,
		l,
		d
	]), B = f(() => {
		let e = {};
		return Object.keys(r).forEach((t) => {
			r[t] && (e[t] = (e, n) => {
				r[t]?.(e, n);
			});
		}), e;
	}, [r]), V = t, H = m(null), ee = m(null), U = s(() => {
		ee.current &&= (ee.current.disconnect(), null);
	}, []);
	return u(() => {
		if (!O || !j || !A) {
			U();
			return;
		}
		return ee.current = new IntersectionObserver((e) => {
			let [t] = e;
			t.isIntersecting && A && !k && (IC.debug("Load more trigger intersected, loading more data"), j());
		}, {
			root: null,
			rootMargin: "100px",
			threshold: .1
		}), H.current && ee.current.observe(H.current), U;
	}, [
		O,
		j,
		A,
		k,
		U
	]), N && V.length > M ? /* @__PURE__ */ _(PC, {
		columns: e,
		data: V,
		actions: n,
		actionHandlers: B,
		selectedRows: i,
		onRowSelect: a,
		onRowClick: o,
		idField: c,
		columnOrder: l,
		pinnedColumns: d,
		columnWidths: p,
		rowHeight: h,
		bodyTypography: g,
		rowClassName: y,
		cellClassNames: b,
		cellRenderers: x,
		cellText: S,
		headerDisplay: D,
		columnTypes: C,
		inlineEditing: w,
		onCellSave: T,
		loadReferenceOptions: E
	}) : k && V.length === 0 ? /* @__PURE__ */ _("tbody", { children: /* @__PURE__ */ _(FC, {
		columns: e,
		rowCount: 10
	}) }) : !k && V.length === 0 ? /* @__PURE__ */ _("tbody", { children: /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", {
		colSpan: e.length + +(n.length > 0),
		className: "px-4 py-8 text-center text-muted-dark bg-background",
		children: "No data available"
	}) }) }) : (process.env.NODE_ENV === "development" && (IC.debug(`Rendering ${V.length} rows of data, isInfiniteScroll: ${O}`), V.length > 0 && (IC.debug("First row data:", V[0]), IC.debug("Columns:", e), IC.debug(`ID field: ${c}, first row ID: ${V[0][c]}`), IC.debug("Organized columns:", z))), /* @__PURE__ */ v("tbody", {
		className: "bg-background divide-y divide-border-light",
		children: [
			V.map((t, r) => {
				let s = Bi(t, c) ?? zi(t, r, c), l = i.has(s), u = O ? `${zi(t, r, c)}-index-${r}` : zi(t, r, c);
				return /* @__PURE__ */ _(MC, {
					rowId: s,
					rowIndex: r,
					row: t,
					columns: e,
					actions: n,
					actionHandlers: B,
					selectedRows: i,
					onRowSelect: a,
					onRowClick: o,
					columnTypes: R,
					isSelected: l,
					organizedColumns: z,
					pinnedColumns: d,
					columnWidths: p,
					rowHeight: h,
					rowClassName: typeof y == "function" ? y({
						row: t,
						rowIndex: r,
						rowId: s,
						isSelected: l
					}) || "" : y ?? "",
					bodyTypography: g,
					cellClassNames: b,
					cellRenderers: x,
					cellText: S,
					headerDisplay: D,
					inlineEditing: w,
					onCellSave: T,
					loadReferenceOptions: E
				}, u);
			}),
			O && V.length > 0 && j && /* @__PURE__ */ _("tr", {
				className: "infinite-scroll-detector-row",
				children: /* @__PURE__ */ _("td", {
					colSpan: e.length + +(n.length > 0),
					className: "border-t border-border-light",
					children: /* @__PURE__ */ _(NC, {
						onLoadMore: j,
						isLoading: k,
						hasMore: A,
						disabled: !O,
						threshold: 1200,
						ariaLabel: P,
						ariaLive: F
					})
				})
			}),
			O && /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", {
				colSpan: e.length + (n && n.length > 0 ? 1 : 0),
				children: /* @__PURE__ */ _("div", {
					ref: H,
					className: "h-10 w-full",
					"aria-live": "polite",
					"aria-busy": k,
					role: "status",
					children: A && k && /* @__PURE__ */ _("div", {
						className: "py-2 text-center text-xs text-muted-dark",
						children: "Loading more data..."
					})
				})
			}) })
		]
	}));
}, (e, t) => e.data === t.data && e.selectedRows === t.selectedRows && e.onRowClick === t.onRowClick && e.columns === t.columns && e.actions === t.actions && e.isInfiniteScroll === t.isInfiniteScroll && e.isLoading === t.isLoading && e.hasMoreItems === t.hasMoreItems && e.rowClassName === t.rowClassName && e.cellClassNames === t.cellClassNames && e.cellRenderers === t.cellRenderers && e.cellText === t.cellText && e.columnTypes === t.columnTypes && e.inlineEditing === t.inlineEditing && e.onCellSave === t.onCellSave && e.loadReferenceOptions === t.loadReferenceOptions && JSON.stringify(e.columnOrder) === JSON.stringify(t.columnOrder) && JSON.stringify(e.pinnedColumns) === JSON.stringify(t.pinnedColumns) && JSON.stringify(e.columnWidths) === JSON.stringify(t.columnWidths)), RC = a(({ page: e, totalPages: t, pageSize: n, totalRows: r, tableDataLength: i, handlePageChange: a, handlePageSizeChange: o, handleExport: s, toggleSidebarFilters: c, isLoading: l = !1, pageSizeOptions: u = [
	20,
	50,
	100,
	500
], actions: d = [], sampling: f, effectiveFilters: p = {}, headerDisplay: m, isInfiniteScroll: h = !1, onInfiniteScrollChange: g }) => {
	let y = Object.keys(p || {}).filter((e) => e !== "__sampling").length > 0, b = f?.samplingState?.isSamplingEnabled && (f?.samplingState?.samplePercentage ?? 0) > 0, x = b ? `On · ${f.samplingState.samplePercentage}%` : null, S = m?.showFilterControls ?? !0, C = m?.showSamplingControls ?? !0, w = Math.max(1, n || 1), T = Math.max(0, r || 0), E = Math.max(1, t || 0), D = Math.min(Math.max(1, e || 1), E), O = T === 0 ? 0 : (D - 1) * w + 1, k = T === 0 ? 0 : Math.min(D * w, T), A = D <= 1, j = D >= E, M = Math.max(0, i || 0), N = l ? /* @__PURE__ */ v("div", {
		className: "flex items-center text-muted-dark",
		children: [/* @__PURE__ */ _("div", { className: "animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-primary mr-2" }), /* @__PURE__ */ _("span", { children: "Loading more items..." })]
	}) : /* @__PURE__ */ v("div", {
		className: "flex flex-col leading-tight",
		children: [/* @__PURE__ */ v("span", {
			className: "text-xs text-muted-dark",
			children: [
				/* @__PURE__ */ _("strong", { children: M.toLocaleString() }),
				" of ",
				/* @__PURE__ */ _("strong", { children: T.toLocaleString() }),
				" items loaded"
			]
		}), /* @__PURE__ */ _("span", {
			className: "text-xs text-info-dark",
			children: M < T ? "Scroll down to load more" : "All items loaded"
		})]
	});
	return /* @__PURE__ */ v("div", {
		className: "px-2 py-1 flex flex-wrap justify-between items-center text-xs sm:text-sm gap-2 bg-background-dark border-b border-border-light",
		children: [/* @__PURE__ */ v("div", {
			className: "flex items-center gap-4",
			children: [
				/* @__PURE__ */ v("div", {
					className: "flex items-center",
					children: [/* @__PURE__ */ _("label", {
						className: "mr-1 text-muted-dark",
						children: "Display:"
					}), /* @__PURE__ */ v("div", {
						className: "flex",
						children: [/* @__PURE__ */ v("div", {
							className: "flex border border-border-light rounded overflow-hidden",
							children: [/* @__PURE__ */ v("button", {
								onClick: () => g && g(!1),
								className: `flex items-center px-2 py-0.5 ${h ? "bg-background text-text border-r border-border-light hover:bg-background-light" : "bg-primary-light text-primary-dark border-r border-primary"}`,
								title: "Switch to pagination mode",
								disabled: l || !h,
								children: [/* @__PURE__ */ _("svg", {
									xmlns: "http://www.w3.org/2000/svg",
									className: "h-4 w-4 mr-1",
									fill: "none",
									viewBox: "0 0 24 24",
									stroke: "currentColor",
									children: /* @__PURE__ */ _("path", {
										strokeLinecap: "round",
										strokeLinejoin: "round",
										strokeWidth: 2,
										d: "M5 15l7-7 7 7"
									})
								}), /* @__PURE__ */ _("span", { children: "Pages" })]
							}), /* @__PURE__ */ v("button", {
								onClick: () => g && g(!0),
								className: `flex items-center px-2 py-0.5 ${h ? "bg-primary-light text-primary-dark" : "bg-background text-text hover:bg-background-light"}`,
								title: "Switch to infinite scroll mode",
								disabled: l || h,
								children: [/* @__PURE__ */ _("svg", {
									xmlns: "http://www.w3.org/2000/svg",
									className: "h-4 w-4 mr-1",
									fill: "none",
									viewBox: "0 0 24 24",
									stroke: "currentColor",
									children: /* @__PURE__ */ _("path", {
										strokeLinecap: "round",
										strokeLinejoin: "round",
										strokeWidth: 2,
										d: "M19 9l-7 7-7-7"
									})
								}), /* @__PURE__ */ _("span", { children: "Infinite" })]
							})]
						}), !h && /* @__PURE__ */ _("select", {
							value: n,
							onChange: o,
							className: "border border-border-light rounded ml-2 px-1.5 py-0.5 bg-background text-text",
							disabled: l,
							children: u.map((e) => /* @__PURE__ */ v("option", {
								value: e,
								children: [e, " rows"]
							}, e))
						})]
					})]
				}),
				/* @__PURE__ */ _("div", {
					className: "whitespace-nowrap text-info-dark",
					children: h ? N : l ? /* @__PURE__ */ _("span", {
						className: "text-muted-dark",
						children: "Loading..."
					}) : T === 0 ? `0 of ${T.toLocaleString()}` : `${O}-${k} of ${T.toLocaleString()}`
				}),
				c && S && /* @__PURE__ */ v("button", {
					onClick: () => c("filters"),
					className: `flex items-center border rounded px-2 py-1 transition-colors duration-150
              ${y ? "text-action-filter border-action-filter bg-background-light" : "text-text bg-background border-border-light hover:text-action-filter hover:border-action-filter"}
              `,
					title: "Open filters panel",
					disabled: l,
					children: [/* @__PURE__ */ _(Yb, { className: "mr-1 w-5 h-5" }), /* @__PURE__ */ _("span", {
						className: "hidden sm:inline",
						children: "Filters"
					})]
				}),
				c && C && /* @__PURE__ */ v("button", {
					onClick: () => c("sampling"),
					className: `flex items-center border rounded px-2 py-1 transition-colors duration-150
              ${b ? "text-action-sample border-action-sample bg-background-light" : "text-text bg-background border-border-light hover:text-action-sample hover:border-action-sample"}
              `,
					title: b ? `Open sampling panel (${x})` : "Open sampling panel",
					disabled: l,
					children: [/* @__PURE__ */ _(Gb, { className: "mr-1 w-5 h-5" }), /* @__PURE__ */ _("span", {
						className: "hidden sm:inline",
						children: b ? `Sampling ${x}` : "Sampling"
					})]
				}),
				bS(d, $.EXPORT, "header") && /* @__PURE__ */ v("button", {
					onClick: s,
					className: "flex items-center border rounded px-2 py-1 transition-colors duration-150 text-text bg-background border-border-light hover:text-action-export hover:border-action-export",
					title: "Export to CSV",
					disabled: l,
					children: [/* @__PURE__ */ _(qb, { className: "mr-1 w-5 h-5" }), /* @__PURE__ */ _("span", {
						className: "hidden sm:inline",
						children: "Export"
					})]
				})
			]
		}), !h && /* @__PURE__ */ v("div", {
			className: "flex items-center gap-1",
			children: [
				/* @__PURE__ */ _("span", {
					className: "text-xs text-muted-dark mr-2",
					children: "Page:"
				}),
				/* @__PURE__ */ _("button", {
					onClick: () => a(1),
					disabled: A || l,
					className: "px-1.5 py-0.5 rounded bg-background text-text border border-border-light hover:text-primary hover:border-primary",
					title: "First page",
					children: "«"
				}),
				/* @__PURE__ */ _("button", {
					onClick: () => a(D - 1),
					disabled: A || l,
					className: "px-2 py-0.5 rounded bg-background text-text border border-border-light hover:text-primary hover:border-primary",
					children: "Prev"
				}),
				/* @__PURE__ */ _("span", {
					className: "px-1 whitespace-nowrap font-medium text-accent",
					children: l ? /* @__PURE__ */ _("span", {
						className: "text-muted-dark",
						children: "..."
					}) : `${D}/${E}`
				}),
				/* @__PURE__ */ _("button", {
					onClick: () => a(D + 1),
					disabled: j || l,
					className: "px-2 py-0.5 rounded bg-background text-text border border-border-light hover:text-primary hover:border-primary",
					children: "Next"
				}),
				/* @__PURE__ */ _("button", {
					onClick: () => a(E),
					disabled: j || l,
					className: "px-1.5 py-0.5 rounded bg-background text-text border border-border-light hover:text-primary hover:border-primary",
					title: "Last page",
					children: "»"
				})
			]
		})]
	});
}, (e, t) => e.page === t.page && e.totalPages === t.totalPages && e.pageSize === t.pageSize && e.totalRows === t.totalRows && e.isLoading === t.isLoading && e.isInfiniteScroll === t.isInfiniteScroll && JSON.stringify(e.pageSizeOptions) === JSON.stringify(t.pageSizeOptions) && JSON.stringify(e.actions) === JSON.stringify(t.actions) && JSON.stringify(e.sampling?.samplingState) === JSON.stringify(t.sampling?.samplingState) && JSON.stringify(e.effectiveFilters) === JSON.stringify(t.effectiveFilters)), zC = ({ scrollThreshold: e = 300, className: t = "", targetSelector: n = ".table-content-scrollbar" }) => {
	let [r, i] = h(!1);
	return u(() => {
		let t = () => {
			let t = document.querySelector(n);
			i((t ? t.scrollTop : window.pageYOffset || document.documentElement.scrollTop) > e);
		}, r = document.querySelector(n);
		return r && r.addEventListener("scroll", t, { passive: !0 }), window.addEventListener("scroll", t, { passive: !0 }), () => {
			r && r.removeEventListener("scroll", t), window.removeEventListener("scroll", t);
		};
	}, [e, n]), r ? /* @__PURE__ */ _("button", {
		onClick: () => {
			let e = document.querySelector(n);
			e ? e.scrollTo({
				top: 0,
				behavior: "smooth"
			}) : window.scrollTo({
				top: 0,
				behavior: "smooth"
			});
		},
		className: `fixed bottom-16 right-8 z-50 bg-primary text-white px-4 py-2 rounded-full shadow-lg transition-opacity duration-300 opacity-90 hover:opacity-100 ${t}`,
		title: "Back to top",
		"aria-label": "Scroll back to top",
		children: "↑ Top"
	}) : null;
}, BC = a(({ heightMode: e, tableMaxHeight: t, shouldEnableHorizontalScroll: n, effectiveColumns: r, tableData: i, sortBy: a, order: o, handleSort: c, tableName: l, databaseId: u, actions: d, selectedRows: f, setSelectedRows: p, isAllSelected: m, onToggleSelectAll: h, handleBulkAction: g, handleClearFilter: y, effectiveFilters: b, handleApplyFilter: x, onStatsPanelChange: S, onRowSelect: C, onRowClick: w, idField: T, actionHandlers: E, page: D, totalPages: O, pageSize: k, totalRows: A, pageSizeOptions: j, handlePageChange: M, handlePageSizeChange: N, handleExport: P, openStatsPanel: F, toggleSidebarFilters: I, initialSidebarTab: L = "filters", isLoading: R = !1, isExporting: z = !1, sampling: B, currentTheme: V = "default", columnOrder: H, pinnedColumns: ee = {
	left: [],
	right: []
}, onColumnPin: U, onColumnReorder: te, columnWidths: W = {}, onColumnResize: ne, vendorAuditByColumn: re = {}, rowHeight: ie, showFooter: ae = !0, scrollRegionMaxHeight: oe, headerDisplay: se, typography: ce, tableClassName: le, scrollRegionClassName: ue, columnLabels: de, renderColumnHeaderAction: fe, rowClassName: pe, cellClassNames: me, cellRenderers: he, cellText: ge, columnTypes: _e, inlineEditing: ve, onCellSave: ye, loadReferenceOptions: be, isInfiniteScroll: xe = !1, hasMoreItems: Se = !1, onLoadMore: Ce, onInfiniteScrollChange: we }) => {
	let G = e === "fill", Te = {
		...ce?.table,
		...ce?.header
	}, Ee = {
		...ce?.table,
		...ce?.body
	}, K = s((e) => {
		if (xe && Se && !R && Ce) {
			let { scrollTop: t, scrollHeight: n, clientHeight: r } = e.currentTarget;
			n - t <= r + 100 && Ce();
		}
	}, [
		xe,
		Se,
		R,
		Ce
	]);
	return /* @__PURE__ */ v("div", {
		className: `flex min-h-0 min-w-0 w-full flex-col ${G ? "h-full flex-1" : ""}`,
		"data-datagrid-height-mode": e,
		children: [
			xe && /* @__PURE__ */ _(zC, {}),
			/* @__PURE__ */ v("div", {
				"data-testid": "datagrid-table-scroll-region",
				className: `relative min-h-0 min-w-0 w-full bg-background table-content-scrollbar ${G ? "h-full flex-1 overflow-y-auto" : "overflow-y-auto"} ${ue ?? ""}`,
				style: {
					maxHeight: oe,
					overflowX: n ? "auto" : "hidden",
					scrollbarGutter: "stable both-edges"
				},
				onScroll: K,
				children: [R && /* @__PURE__ */ _("div", {
					className: "absolute inset-0 z-30 flex items-center justify-center overflow-hidden bg-background-dark/70",
					children: /* @__PURE__ */ _(Ss, {
						width: "96px",
						height: "48px",
						message: "Loading data..."
					})
				}), /* @__PURE__ */ v("table", {
					className: `min-w-full text-xs text-left text-text bg-background relative border-collapse ${le ?? ""}`,
					style: {
						width: n ? "max-content" : "100%",
						borderLeft: ee.left.length > 0 ? "1px solid var(--color-border-light)" : "none",
						fontFamily: ce?.table?.fontFamily,
						fontSize: ce?.table?.fontSize,
						lineHeight: ce?.table?.lineHeight,
						color: ce?.table?.color
					},
					children: [/* @__PURE__ */ _(aC, {
						columns: r,
						data: i,
						sortBy: a || "",
						order: o || "",
						handleSort: c,
						tableName: l || "",
						databaseId: u || "",
						hasActions: d.length > 0,
						selectedRows: f,
						setSelectedRows: p,
						isAllSelected: m,
						onToggleSelectAll: h,
						onBulkAction: g,
						clearFilter: y,
						filters: b,
						applyFilter: x,
						onStatsPanelChange: S,
						openStatsPanel: F,
						toggleSidebarFilters: I,
						actions: d,
						actionHandlers: E,
						isExporting: z,
						sampling: B,
						currentTheme: V,
						columnOrder: H,
						pinnedColumns: ee,
						onColumnPin: U,
						onColumnReorder: te,
						columnWidths: W,
						onColumnResize: ne,
						vendorAuditByColumn: re,
						headerDisplay: se,
						headerTypography: Te,
						columnLabels: de,
						renderColumnHeaderAction: fe
					}), /* @__PURE__ */ _(LC, {
						columns: r,
						data: i,
						actions: d,
						actionHandlers: E,
						selectedRows: f,
						onRowSelect: C,
						onRowClick: w,
						idField: T,
						columnOrder: H,
						pinnedColumns: ee,
						columnWidths: W,
						rowHeight: ie,
						bodyTypography: Ee,
						rowClassName: pe,
						cellClassNames: me,
						cellRenderers: he,
						cellText: ge,
						columnTypes: _e,
						inlineEditing: ve,
						onCellSave: ye,
						loadReferenceOptions: be,
						headerDisplay: se,
						isInfiniteScroll: xe,
						hasMoreItems: Se,
						isLoading: R,
						onLoadMore: Ce
					})]
				})]
			}),
			ae ? /* @__PURE__ */ _("div", {
				"data-testid": "datagrid-table-footer",
				className: `relative z-[5] w-full shrink-0 bg-background ${G ? "mt-auto" : ""}`,
				children: /* @__PURE__ */ _(RC, {
					page: D,
					totalPages: O,
					pageSize: k,
					totalRows: A,
					tableDataLength: i.length,
					handlePageChange: M,
					handlePageSizeChange: N,
					handleExport: P,
					toggleSidebarFilters: I,
					isLoading: R,
					pageSizeOptions: j,
					actions: d,
					sampling: B && typeof B.toggleSampling == "function" ? B : void 0,
					effectiveFilters: b,
					headerDisplay: se,
					isInfiniteScroll: xe,
					onInfiniteScrollChange: we
				})
			}) : null
		]
	});
}, (e, t) => e.tableData === t.tableData && e.selectedRows === t.selectedRows && e.isLoading === t.isLoading && e.page === t.page && e.pageSize === t.pageSize && e.totalRows === t.totalRows && e.sortBy === t.sortBy && e.order === t.order && e.sampling === t.sampling && e.currentTheme === t.currentTheme && e.rowHeight === t.rowHeight && e.showFooter === t.showFooter && e.scrollRegionMaxHeight === t.scrollRegionMaxHeight && e.headerDisplay === t.headerDisplay && e.typography === t.typography && e.tableClassName === t.tableClassName && e.scrollRegionClassName === t.scrollRegionClassName && e.columnLabels === t.columnLabels && e.rowClassName === t.rowClassName && e.cellClassNames === t.cellClassNames && e.cellRenderers === t.cellRenderers && e.cellText === t.cellText && e.columnTypes === t.columnTypes && e.inlineEditing === t.inlineEditing && e.onCellSave === t.onCellSave && e.loadReferenceOptions === t.loadReferenceOptions && e.onRowClick === t.onRowClick && e.isInfiniteScroll === t.isInfiniteScroll && e.hasMoreItems === t.hasMoreItems && JSON.stringify(e.columnOrder) === JSON.stringify(t.columnOrder) && JSON.stringify(e.pinnedColumns) === JSON.stringify(t.pinnedColumns) && JSON.stringify(e.columnWidths) === JSON.stringify(t.columnWidths) && JSON.stringify(e.effectiveFilters) === JSON.stringify(t.effectiveFilters)), VC = ({ isRefetching: e, tableName: t }) => /* @__PURE__ */ _("div", {
	className: "absolute inset-0 z-30 flex items-center justify-center overflow-hidden",
	style: { backgroundColor: "transparent" },
	children: /* @__PURE__ */ _(Ss, {
		width: "96px",
		height: "48px",
		message: "Loading data..."
	})
}), HC = ({ message: e, onRetry: t }) => {
	let n = e.includes("Cannot connect to the server") || e.includes("Network Error");
	return /* @__PURE__ */ _("div", {
		className: "flex justify-center items-center p-4 min-h-[200px] w-full bg-background",
		children: /* @__PURE__ */ v("div", {
			className: "text-center p-8 max-w-md rounded-lg shadow-lg bg-background-light",
			children: [
				/* @__PURE__ */ _("div", {
					className: `mb-6 ${n ? "text-warning-dark" : "text-error-dark"}`,
					children: n ? /* @__PURE__ */ _("svg", {
						className: "h-16 w-16 mx-auto",
						fill: "none",
						viewBox: "0 0 24 24",
						stroke: "currentColor",
						children: /* @__PURE__ */ _("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
						})
					}) : /* @__PURE__ */ _("svg", {
						className: "h-16 w-16 mx-auto",
						fill: "none",
						viewBox: "0 0 24 24",
						stroke: "currentColor",
						children: /* @__PURE__ */ _("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
						})
					})
				}),
				/* @__PURE__ */ _("div", {
					className: "text-xl font-medium mb-2 text-error-dark",
					children: n ? "Connection Error" : "Error Loading Data"
				}),
				/* @__PURE__ */ _("div", {
					className: "text-sm mt-2 mb-6 text-text",
					children: e
				}),
				n && /* @__PURE__ */ v("div", {
					className: "text-sm rounded p-3 mb-6 text-left border border-warning-dark bg-warning-light text-warning-dark",
					children: [/* @__PURE__ */ _("p", {
						className: "font-medium mb-1",
						children: "Troubleshooting steps:"
					}), /* @__PURE__ */ v("ul", {
						className: "list-disc list-inside space-y-1",
						children: [/* @__PURE__ */ _("li", { children: "Verify your network connection" }), /* @__PURE__ */ _("li", { children: "Contact your system administrator " })]
					})]
				}),
				/* @__PURE__ */ _("button", {
					onClick: t,
					className: "px-4 py-2 text-sm rounded-md transition-colors shadow-sm bg-primary text-background hover:bg-primary-dark",
					children: "Retry Connection"
				})
			]
		})
	});
}, UC = D("useInternalData"), WC = (e, t, n, r, i, a, o, c, l, d, f, p) => {
	let g = e !== void 0, _ = a && a.length > 0 ? a[0] : 20, [v, y] = h([]), [b, x] = h(i || []), [S, C] = h(0), [w, T] = h(!g && !!t && !!n), [E, D] = h(null), [O, k] = h(!1), A = m(null), j = m(0), M = m(""), N = m(null), P = m(""), F = s(() => {
		let e = l?.current ?? o ?? {}, t = d?.current;
		return t ? {
			...e,
			__sampling: t
		} : e;
	}, [
		o,
		l,
		d
	]), I = s(() => {
		A.current &&= (UC.debug("Cancelling ongoing request:", A.current.requestId), A.current.abortController.abort(), null);
	}, []), L = s(async (e = !1) => {
		if (g) return;
		if (!t || !n) {
			UC.warn("Missing databaseId or tableName for data fetch");
			return;
		}
		let i = `fetch-${++j.current}-${Date.now()}`, a = F(), o = JSON.stringify(a || {});
		if (!e && o === M.current && O) {
			UC.debug("Skipping fetch - filters unchanged and not forced");
			return;
		}
		I();
		let s = new AbortController();
		A.current = {
			requestId: i,
			abortController: s,
			timestamp: Date.now()
		}, UC.debug(`Starting data fetch: ${i}`, {
			filters: a,
			force: e
		});
		try {
			if (T(!0), D(null), s.signal.aborted) {
				UC.debug(`Request ${i} was cancelled before API call`);
				return;
			}
			let e = await c?.fetchTableData(t, n, {
				limit: r || _,
				offset: 0,
				...typeof f == "number" && Number.isFinite(f) && f > 0 ? { resultLimit: f } : {},
				...p && p.length > 0 ? { columns: p } : {},
				filters: a || {},
				signal: s.signal
			});
			if (A.current?.requestId !== i) {
				UC.debug(`Request ${i} completed but is no longer current, discarding results`);
				return;
			}
			if (s.signal.aborted) {
				UC.debug(`Request ${i} was cancelled during API call`);
				return;
			}
			if (e?.status === "success" && e.data) {
				let { rows: r = [], columns: s = [], total: l, metadata: u } = e.data, d = typeof l == "number" ? l : typeof u?.totalRows == "number" ? u.totalRows : r.length;
				if (typeof l != "number" && typeof u?.totalRows != "number" && typeof c?.fetchTableRowCount == "function") try {
					let e = await c.fetchTableRowCount(t, n, a || {});
					typeof e == "number" && e >= 0 && (d = e);
				} catch (e) {
					UC.warn("Failed to fetch table row count fallback for internal data", {
						databaseId: t,
						tableName: n,
						error: e
					});
				}
				UC.debug(`Request ${i} completed successfully`, {
					rowCount: r.length,
					columnCount: s.length,
					totalRows: d
				}), y(r), x(s), C(d), k(!0), M.current = o, A.current = null;
			} else throw Error(e?.errors?.[0]?.message || "Failed to fetch data");
		} catch (e) {
			if (e.name === "AbortError" || e.name === "CanceledError" || e.code === "ERR_CANCELED" || s.signal.aborted) {
				UC.debug(`Request ${i} was cancelled`);
				return;
			}
			A.current?.requestId === i && (UC.error(`Request ${i} failed:`, e), D(e.message || "Failed to fetch data"), A.current = null);
		} finally {
			(A.current?.requestId === i || !A.current) && T(!1);
		}
	}, [
		g,
		t,
		n,
		r,
		o,
		F,
		O,
		I,
		_,
		c,
		f,
		p
	]);
	return u(() => {
		let e = `${t ?? ""}:${n ?? ""}:${JSON.stringify(p ?? [])}`;
		e !== P.current && (P.current = e, y([]), x(i || []), C(0), D(null), k(!1));
	}, [
		t,
		n,
		i,
		p
	]), u(() => {
		t && n && !g && !O && (UC.debug("Initial data fetch triggered by core dependency changes"), L(!1));
	}, [
		t,
		n,
		g,
		L,
		O
	]), u(() => {
		if (!(g || !O)) return N.current && clearTimeout(N.current), N.current = setTimeout(() => {
			L(!1);
		}, 150), () => {
			N.current && clearTimeout(N.current);
		};
	}, [
		o,
		L,
		g,
		O
	]), u(() => () => {
		I(), N.current && clearTimeout(N.current);
	}, [I]), {
		internalData: v,
		internalColumns: b,
		internalTotalRows: S,
		isLoading: w,
		fetchError: E,
		setFetchError: D,
		fetchData: (e = !0) => L(e),
		initialDataFetchPerformed: O
	};
};
//#endregion
//#region src/utils/statisticsUtils.ts
function GC(e, t = 10) {
	let n = e.filter((e) => Number.isFinite(e));
	if (n.length === 0) return {
		bins: [],
		counts: [],
		binWidth: 0
	};
	let r = Math.min(...n), i = Math.max(...n);
	if (r === i) {
		let e = Math.max(Math.abs(r) * .1, 1);
		return {
			bins: [r - e / 2, r + e / 2],
			counts: [n.length],
			binWidth: e
		};
	}
	let a = Math.max(1, Math.floor(t)), o = (i - r) / a, s = Array.from({ length: a + 1 }, (e, t) => t === a ? i : r + o * t), c = Array.from({ length: a }, () => 0);
	return n.forEach((e) => {
		let t = e === i ? a - 1 : Math.min(a - 1, Math.max(0, Math.floor((e - r) / o)));
		c[t] += 1;
	}), {
		bins: s,
		counts: c,
		binWidth: o
	};
}
//#endregion
//#region src/hooks/useStatsWithFilters.ts
function KC(e) {
	return e == null || e === "";
}
function qC(e, t) {
	let n = Object.entries(t ?? {}).filter(([e]) => e !== "__sampling");
	return n.length === 0 ? e : e.filter((e) => n.every(([t, n]) => {
		let r = e[t];
		if (KC(r)) return !1;
		if (Array.isArray(n)) return n.some((e) => String(r).toLowerCase() === String(e).toLowerCase());
		if (n && typeof n == "object") {
			let { min: e, max: t } = n, i = Number(r);
			return !(!Number.isFinite(i) || e !== void 0 && i < Number(e) || t !== void 0 && i > Number(t));
		}
		return String(r).toLowerCase() === String(n).toLowerCase();
	}));
}
function JC(e, t) {
	let n = Math.max(0, Math.min(100, t?.samplePercentage ?? 100)), r = n >= 100 ? e.length : Math.max(1, Math.ceil(e.length * (n / 100)));
	return n >= 100 || e.length <= r ? {
		rows: e,
		metadata: {
			samplePercentage: n,
			sampledRows: e.length
		}
	} : t?.strategy === "last-n" ? {
		rows: e.slice(-r),
		metadata: {
			samplePercentage: n,
			sampledRows: r
		}
	} : {
		rows: e.slice(0, r),
		metadata: {
			samplePercentage: n,
			sampledRows: r
		}
	};
}
function YC({ rows: e, columns: t, columnName: n, filters: r, sampling: i }) {
	let a = e ?? [], o = qC(a, r), s = JC(o, i), c = s.rows, l = t && t.length > 0 ? t : Object.keys(a[0] ?? {}), u = n && l.includes(n) ? n : l[0];
	if (!u) return {
		metadata: {
			totalRows: 0,
			sourceRowCount: a.length,
			filteredRows: o.length,
			samplePercentage: s.metadata.samplePercentage
		},
		isEmpty: !0,
		noDataWithFilters: !0,
		type: "empty"
	};
	let d = c.map((e) => e[u]).filter((e) => !KC(e)), f = {
		sourceRowCount: a.length,
		filteredRows: o.length,
		totalRows: c.length,
		sampledRows: s.metadata.sampledRows,
		samplePercentage: s.metadata.samplePercentage
	};
	if (c.length === 0) return {
		metadata: f,
		isEmpty: !0,
		noDataWithFilters: Object.keys(r ?? {}).length > 0,
		type: "empty"
	};
	let p = Ab(u, c), m = c.length - d.length, h = c.length === 0 ? "0" : (m / c.length * 100).toFixed(2);
	if (p === "numerical") {
		let e = d.map((e) => Number(e)).filter((e) => Number.isFinite(e)), t = [...e].sort((e, t) => e - t), n = e.reduce((e, t) => e + t, 0), r = e.length > 0 ? n / e.length : 0, i = e.length > 0 ? e.reduce((e, t) => e + (t - r) ** 2, 0) / e.length : 0, a = Math.floor(t.length / 2), o = t.length === 0 ? 0 : t.length % 2 == 0 ? (t[a - 1] + t[a]) / 2 : t[a];
		return {
			type: "numeric",
			columnType: "REAL",
			totalValues: c.length,
			nonNullValues: e.length,
			nullCount: m,
			nullPercentage: h,
			mean: r,
			median: o,
			min: t[0] ?? 0,
			max: t[t.length - 1] ?? 0,
			range: t.length > 0 ? (t[t.length - 1] ?? 0) - (t[0] ?? 0) : 0,
			stddev: Math.sqrt(i),
			histogram: GC(e),
			metadata: f
		};
	}
	if (p === "date") {
		let e = d.map((e) => new Date(String(e))).filter((e) => !Number.isNaN(e.getTime())).sort((e, t) => e.getTime() - t.getTime()), t = /* @__PURE__ */ new Map();
		return e.forEach((e) => {
			let n = e.toLocaleString("en-US", {
				month: "short",
				year: "2-digit"
			});
			t.set(n, (t.get(n) ?? 0) + 1);
		}), {
			type: "date",
			columnType: "TEXT",
			totalValues: c.length,
			nonNullValues: e.length,
			nullCount: m,
			nullPercentage: h,
			minDate: e[0]?.toISOString() ?? null,
			maxDate: e[e.length - 1]?.toISOString() ?? null,
			distribution: {
				labels: [...t.keys()],
				counts: [...t.values()]
			},
			metadata: f
		};
	}
	let g = d.reduce((e, t) => {
		let n = String(t);
		return e[n] = (e[n] ?? 0) + 1, e;
	}, {});
	return {
		type: "categorical",
		columnType: "TEXT",
		totalValues: c.length,
		nonNullValues: d.length,
		nullCount: m,
		nullPercentage: h,
		categories: g,
		metadata: f
	};
}
var XC = ({ databaseId: e, tableName: t, initialColumn: n, onStatsLoaded: r, provider: i, localRows: a, localColumns: o }) => {
	let [s, c] = h(n || null), [l, u] = h(null), [d, f] = h(!1), [p, g] = h(null), _ = m(null), v = m(null), y = async (n, s) => {
		if (n) {
			f(!0), g(null), v.current = s;
			try {
				let c = s && Object.keys(s).length > 0;
				console.log("Fetching stats with filters:", {
					column: n,
					hasFilters: c,
					filters: s
				});
				let l = s, d = null;
				if (s && typeof s == "object" && "__sampling" in s) {
					let { __sampling: e, ...t } = s;
					l = t, s.__sampling && (d = s.__sampling);
				}
				let f = { filters: l || {} };
				d ? (d.strategy && (f.sampleStrategy = d.strategy), d.samplePercentage && (f.samplePercentage = d.samplePercentage), d.stratifyColumn && (f.stratifyColumn = d.stratifyColumn), d.seed !== void 0 && (f.seed = d.seed)) : f.samplePercentage = 100;
				let p;
				if (a) p = YC({
					rows: a,
					columns: o,
					columnName: n,
					filters: l || {},
					sampling: d
				});
				else try {
					p = await i?.fetchColumnStats(e, t, n, f);
				} catch (e) {
					if (e.status === 404 || e.code === "ERR_BAD_REQUEST" || e.message?.includes("404")) console.warn("No data found for the selected filters - creating empty stats object"), p = {
						metadata: {
							isFiltered: c,
							totalRows: 0,
							samplePercentage: f.samplePercentage || 100
						},
						isEmpty: !0,
						noDataWithFilters: !0,
						type: "empty"
					};
					else throw e;
				}
				return p.metadata ||= {}, p.metadata.isFiltered = c, console.log("Stats response processed:", {
					hasFilters: c,
					metadata: p.metadata,
					isFiltered: p.metadata.isFiltered,
					isEmpty: p.isEmpty,
					filtersChanged: JSON.stringify(_.current) !== JSON.stringify(s)
				}), _.current = s, u(p), r && r(p), p;
			} catch (e) {
				console.error("Failed to fetch stats with filters:", e), g("Failed to load statistics");
				let t = {
					error: e,
					errorMessage: e?.message || "Failed to load statistics",
					metadata: {
						isFiltered: s && Object.keys(s).length > 0,
						totalRows: 0
					},
					isEmpty: !0
				};
				return u(t), r && r(t), t;
			} finally {
				f(!1);
			}
		}
	};
	return {
		stats: l,
		loading: d,
		error: p,
		activeColumn: s,
		fetchStats: y,
		refreshStats: (e) => {
			if (s) {
				if ((!e || Object.keys(e).length === 0) && (console.log("No filters present, ensuring isFiltered flag is false"), l && l.metadata)) {
					let e = {
						...l,
						metadata: {
							...l.metadata,
							isFiltered: !1
						}
					};
					u(e), r && r(e);
				}
				return JSON.stringify(_.current) === JSON.stringify(e) ? Promise.resolve(l) : (console.log("Filters changed, refreshing stats", {
					column: s,
					prevFilters: _.current,
					newFilters: e
				}), y(s, e));
			}
			return Promise.resolve(null);
		},
		changeColumn: (e, t) => (c(e), y(e, t)),
		haveFiltersChanged: (e) => JSON.stringify(v.current) !== JSON.stringify(e),
		currentFilters: v.current
	};
}, ZC = typeof D == "function" ? D("datagrid") : console, QC = (e, t) => {
	if (e.length !== t.length) return !1;
	let n = new Set(t);
	return e.every((e) => n.has(e));
}, $C = ({ mode: e, columns: t = [], queryColumns: n, idField: r, data: i, requestNonce: a, databaseId: o, tableName: c, actions: l = [], actionHandlers: p = {}, onBulkDelete: g, onRowClick: y, sortBy: b, order: x, handleSort: S, handlePageChange: C, handlePageSizeChange: w, page: T, totalPages: E, pageSize: D, pageSizeOptions: O, totalRows: k, resultLimit: A, originalFileName: j, applyFilter: M, clearFilter: N, filters: P, layoutOptions: F, headerSelectors: I, domainAdapters: L, vendorAudit: R, onStatsPanelOpen: z, onWorkspaceStateChange: B, renderColumnHeaderAction: V, presentation: H }) => {
	let { isControlledMode: ee, controlledData: U, providerDatabaseId: te, providerTableName: W, displayDatabaseId: ne, displayTableName: re, hasExternalData: ie, normalizedQueryColumns: ae } = xa({
		mode: e,
		data: i,
		databaseId: o,
		tableName: c,
		queryColumns: n
	}), oe = Di();
	d(() => {
		VS();
	}, []);
	let [se, ce] = h(!1), [le, ue] = h("filters"), [de, fe] = h(() => BS()), [pe, me] = h(!1), [he, ge] = h(null), [_e, ve] = h(null), [ye, be] = h(null), xe = f(() => _S(l), [l]), [Se, Ce] = h(0), we = m("filters"), G = m(P || {}), Te = m(null), Ee = m(() => null), K = m(null), De = m([]), Oe = m(0), ke = m(!1);
	m(""), m("");
	let Ae = m(null), je = s(() => {
		De.current.forEach((e) => clearTimeout(e)), De.current = [];
	}, []), Me = s((e, t) => {
		let n = setTimeout(() => {
			De.current = De.current.filter((e) => e !== n), e();
		}, t);
		return De.current.push(n), n;
	}, []);
	s((e = !0) => {
		let t = Date.now(), n = t - Oe.current;
		if (ke.current || n < 500 && Oe.current > 0) {
			ZC.debug("Throttling refresh, pending or too soon since last refresh", {
				timeSinceLastRefresh: n,
				pendingRefresh: ke.current
			}), ke.current || (ke.current = !0, Me(() => {
				ke.current = !1, Ee.current && (ZC.debug("Executing delayed refresh with latest filters:", { latestFilters: G.current }), Oe.current = Date.now(), Ee.current(e));
			}, 500));
			return;
		}
		Oe.current = t, ZC.debug("Immediate refresh with current filters:", { filters: G.current }), Ee.current && Ee.current(e);
	}, [Me]);
	let { effectiveFilters: Ne, handleApplyFilter: Pe, handleClearFilter: Fe, shouldRefreshImmediately: Ie } = ta({
		externalApplyFilter: M,
		externalClearFilter: N,
		initialFilters: P,
		onFiltersChange: (e) => {
			ZC.debug("Filters changed, updating state:", e), G.current = e, Ce((e) => e + 1), Ee.current && (ZC.debug("Forcing immediate data refresh due to filter change"), Me(() => {
				Ee.current?.();
			}, 0));
		}
	}), { internalData: Le, internalColumns: Re, internalTotalRows: ze, isLoading: Be, fetchError: Ve, fetchData: He } = WC(U, te, W, D, t, O, Ne, oe, G, Te, A, ae);
	u(() => {
		Ee.current = He, ZC.debug("Updated refreshDataRef with new refreshInternalData function");
	}, [He]), u(() => {
		G.current = Ne, ZC.debug("Synchronized filtersRef with effectiveFilters");
	}, [Ne]);
	let Ue = Sa({
		hasExternalData: ie,
		controlledData: U,
		internalData: Le,
		externalColumns: t,
		internalColumns: Re,
		externalSortBy: b,
		externalOrder: x,
		externalPage: T,
		externalPageSize: D,
		externalTotalRows: k,
		internalTotalRows: ze,
		resultLimit: A,
		externalTotalPages: E,
		layoutOptions: F
	}), q = qi({
		databaseId: te,
		tableName: W,
		columns: Ue.columns,
		filters: Ne,
		onSampleApplied: (e) => {
			ZC.debug(`Sampling applied: ${e.length} rows`), Ce((e) => e + 1);
		}
	}), [We, J] = h({
		strategy: q.samplingState.currentStrategy.id,
		samplePercentage: q.samplingState.samplePercentage,
		selectedColumn: q.samplingState.selectedColumn,
		seed: q.samplingState.seed,
		sortBy: []
	});
	u(() => {
		J((e) => ({
			...e,
			strategy: q.samplingState.currentStrategy.id,
			samplePercentage: q.samplingState.samplePercentage,
			selectedColumn: q.samplingState.selectedColumn,
			seed: q.samplingState.seed
		}));
	}, [
		q.samplingState.isSamplingEnabled,
		q.samplingState.sampledRows,
		q.samplingState.seed,
		Se
	]), u(() => {
		let e = (e) => {
			e.detail && e.detail.theme && fe(e.detail.theme);
		}, t = () => {
			fe(BS());
		};
		return document.addEventListener("theme-changed", e), window.addEventListener("storage", t), window.addEventListener("focus", t), () => {
			document.removeEventListener("theme-changed", e), window.removeEventListener("storage", t), window.removeEventListener("focus", t);
		};
	}, []);
	let Ge = s((e, t) => {
		J((n) => {
			if (e !== "strategy") return {
				...n,
				[e]: t
			};
			let r = q.samplingStrategies.find((e) => e.id === t), i = {
				...n,
				strategy: t
			};
			return r?.requiresColumn ? r.requiresNumerical ? {
				...i,
				selectedColumn: q.numericColumns[0]
			} : {
				...i,
				selectedColumn: q.columns[0]
			} : {
				...i,
				selectedColumn: void 0
			};
		}), e === "seed" && q.setSeed(t);
	}, [q]), Ke = s(() => {
		q.changeStrategy(We.strategy), q.setSamplePercentage(We.samplePercentage), q.setSelectedColumn(We.selectedColumn), q.setSeed(We.seed), Ce((e) => e + 1);
	}, [We, q]), qe = s(() => {
		q.samplingState.isSamplingEnabled || (J((e) => ({
			...e,
			strategy: "first-n"
		})), q.samplingState.currentStrategy.id !== "first-n" && q.changeStrategy("first-n")), q.toggleSampling(), Ce((e) => e + 1);
	}, [q]), Je = f(() => ({
		...q,
		toggleSampling: qe,
		changeStrategy: (e) => Ge("strategy", e),
		setSamplePercentage: (e) => Ge("samplePercentage", e),
		setSelectedColumn: (e) => Ge("selectedColumn", e),
		setPendingSampling: Ge,
		applySampling: Ke,
		pendingSampling: We
	}), [
		q,
		qe,
		Ge,
		Ke,
		We
	]), Ye = f(() => q.samplingState.isSamplingEnabled ? {
		...Ne,
		__sampling: {
			strategy: q.samplingState.currentStrategy.id,
			samplePercentage: q.samplingState.samplePercentage,
			stratifyColumn: q.samplingState.selectedColumn,
			seed: q.samplingState.seed
		}
	} : Ne, [
		Ne,
		q.samplingState.isSamplingEnabled,
		q.samplingState.currentStrategy.id,
		q.samplingState.samplePercentage,
		q.samplingState.selectedColumn,
		q.samplingState.seed,
		Se
	]);
	u(() => {
		Te.current = q.samplingState.isSamplingEnabled ? {
			strategy: q.samplingState.currentStrategy.id,
			samplePercentage: q.samplingState.samplePercentage,
			stratifyColumn: q.samplingState.selectedColumn,
			seed: q.samplingState.seed
		} : null;
	}, [
		q.samplingState.isSamplingEnabled,
		q.samplingState.currentStrategy.id,
		q.samplingState.samplePercentage,
		q.samplingState.selectedColumn,
		q.samplingState.seed
	]);
	let { statsPanelOpen: Xe, selectedColumn: Ze, statsData: Qe, isLoadingStats: $e, handleStatsPanelChange: et, openStatsPanel: tt } = Wi({
		initialOpen: !1,
		minLoadingTime: 600
	}), nt = s((e) => {
		et(!0, Ze, e, !1);
	}, [et, Ze]), rt = XC({
		databaseId: te || 0,
		tableName: W || "",
		initialColumn: Ze || void 0,
		onStatsLoaded: nt,
		provider: oe,
		localRows: ie ? Ue.data : void 0,
		localColumns: ie ? Ue.columns : void 0
	}), it = s((e) => {
		ZC.debug(`Data updated: ${e.length} rows`);
	}, []), at = s((e) => {
		let t = e.metadata?.pendingRun, n = e.metadata?.latestRun;
		if (t && typeof t == "object") {
			ve(t);
			return;
		}
		if (n && typeof n == "object") {
			ve(null);
			return;
		}
		ve(null), ge(e);
	}, []), { tableData: ot, refetch: st, isRefetching: ct, sortBy: lt, setSortBy: ut, order: dt, setOrder: Y, page: ft, setPage: pt, pageSize: mt, setPageSize: ht, totalRows: gt, totalPages: _t, isLoading: vt, error: yt, toggleInfiniteScroll: bt, loadMoreData: xt, hasMoreItems: St, updateTableData: Ct } = Ri(Ue.data, te, W, a, Ue.sortBy, Ue.order, Ue.page, Ue.pageSize, Ue.totalRows, Ue.totalPages, Ye, it, O, We.sortBy, S, Ue.isExternallyControlled, pe, at, Ue.resultLimit, ae), wt = f(() => t.length > 0 ? t : Re.length > 0 ? Re : ot.length > 0 ? Object.keys(ot[0]) : [], [
		t,
		Re,
		ot
	]);
	u(() => {
		K.current = st;
	}, [st]);
	let Tt = s((e) => {
		ZC.debug(`Toggling infinite scroll mode: ${e}`), me(e), bt(e);
	}, [bt]), Et = s((e, t) => {
		Pe(e, t);
		let n = {
			...Ye,
			[e]: t
		};
		K.current && (ZC.debug("Forcing immediate data refresh after filter application"), K.current?.()), Xe && Ze && (ZC.debug("Stats panel open, refreshing stats with new filters"), et(!0, Ze, Qe, !0), Me(() => {
			rt.refreshStats(n);
		}, 50));
	}, [
		Pe,
		Xe,
		Ze,
		Qe,
		et,
		Ye,
		rt,
		Me
	]), Dt = s((e) => {
		if (Fe(e), K.current && (ZC.debug("Forcing immediate data refresh after filter cleared"), K.current?.()), Xe && Ze) {
			ZC.debug("Stats panel open, refreshing stats after filter cleared"), et(!0, Ze, Qe, !0);
			let t = { ...Ye };
			delete t[e];
			let n = Object.keys(t).filter((e) => e !== "__sampling").length === 0;
			rt.refreshStats(t).then((e) => {
				n && e && (ZC.debug("Last filter cleared, refreshing stats with all data"), e.metadata && (e.metadata.isFiltered = !1), et(!0, Ze, e, !1));
			});
		}
	}, [
		Fe,
		Xe,
		Ze,
		et,
		Qe,
		Ye,
		rt,
		Me
	]), Ot = s((e) => {
		z?.(e), ZC.debug("Opening stats for column with current filters:", {
			column: e,
			filters: Ye,
			hasFilters: Object.keys(Ye).length > 0
		}), et(!0, e, null, !0), rt.changeColumn(e, Ye).then((t) => {
			t && (ZC.debug("Stats data received, updating panel:", t), et(!0, e, t, !1));
		}).catch((t) => {
			ZC.error("Error loading stats:", t), et(!0, e, null, !1);
		});
	}, [
		et,
		Ye,
		z,
		rt
	]), kt = f(() => JSON.stringify(Ye.__sampling ?? null), [Ye]), At = m({
		statsPanelOpen: Xe,
		selectedColumn: Ze,
		statsData: Qe,
		handleStatsPanelChange: et,
		statsWithFilters: rt,
		mergedFilters: Ye
	});
	u(() => {
		At.current = {
			statsPanelOpen: Xe,
			selectedColumn: Ze,
			statsData: Qe,
			handleStatsPanelChange: et,
			statsWithFilters: rt,
			mergedFilters: Ye
		};
	}), u(() => {
		let e = At.current;
		!e.statsPanelOpen || !e.selectedColumn || (e.handleStatsPanelChange(!0, e.selectedColumn, e.statsData, !0), e.statsWithFilters.refreshStats(e.mergedFilters).then((t) => {
			t && e.handleStatsPanelChange(!0, e.selectedColumn, t, !1);
		}).catch((t) => {
			ZC.error("Error refreshing stats after sampling change:", t), e.handleStatsPanelChange(!0, e.selectedColumn, e.statsData, !1);
		}));
	}, [kt]);
	let jt = s(() => {
		Ue.isExternallyControlled ? st() : He(!0);
	}, [
		st,
		He,
		Ue.isExternallyControlled
	]), Mt = $i({
		databaseId: te,
		tableName: W,
		idField: r,
		onDataRefresh: jt,
		provider: oe
	}), Nt = async (e) => {
		try {
			return await Mt.handleRowSave(e), !0;
		} catch (e) {
			return ZC.error("Error in row save handler:", e), !1;
		}
	}, Pt = Ui(ot, r), { onBulkAction: Ft } = _a({
		databaseId: te,
		tableName: W,
		onDataRefresh: jt,
		onExternalBulkDelete: g,
		onSelectionClear: s(() => {
			Pt.setSelectedRows(/* @__PURE__ */ new Set());
		}, [Pt]),
		provider: oe
	}), { originalFileName: It, databaseInfo: Lt, isLoading: Rt, loadDatabaseInfo: zt } = da(te, oe, L?.databaseInfo), Bt = j ?? It, Vt = ha(te, W, L?.vendorAudit), Ht = f(() => ({
		hasActiveRules: Vt.hasActiveRules,
		activeRuleCount: Vt.activeRuleCount,
		latestSummary: Vt.latestSummary,
		latestPdfReport: Vt.latestPdfReport,
		tableGrade: Vt.tableGrade,
		loading: Vt.loading,
		error: Vt.error,
		onOpenQualityPanel: Ze ? () => et(!0, Ze, Qe, !1) : void 0,
		onDownloadLatestPdf: Vt.latestPdfReport ? () => {
			Vt.downloadReport(Vt.latestPdfReport);
		} : void 0
	}), [
		et,
		Ze,
		Qe,
		Vt.activeRuleCount,
		Vt.downloadReport,
		Vt.error,
		Vt.hasActiveRules,
		Vt.latestPdfReport,
		Vt.latestSummary,
		Vt.loading,
		Vt.tableGrade
	]), Ut = R ?? Ht, { handleExport: Wt, exportSingleRow: Gt, exportMultipleRows: Kt, isExporting: qt } = ia({
		databaseId: te,
		tableName: W,
		data: ot,
		columns: wt,
		filters: Ye,
		customFileName: Bt || I?.database?.label
	}), Jt = f(() => ({
		...p,
		onThemeChange: (e) => {
			fe(e), p.onThemeChange && p.onThemeChange(e);
		}
	}), [p]), [Yt, Xt] = h([]), [Zt, Qt] = h({
		left: [],
		right: []
	}), [$t, en] = h({}), tn = f(() => ({
		...H?.columnWidths ?? {},
		...$t
	}), [H?.columnWidths, $t]);
	u(() => {
		if (wt.length === 0) return;
		if (Yt.length === 0) {
			Xt(wt);
			return;
		}
		if (QC(Yt, wt)) return;
		ZC.debug("Reconciling column state for new schema:", wt), Xt(wt), Qt((e) => ({
			left: e.left.filter((e) => wt.includes(e)),
			right: e.right.filter((e) => wt.includes(e))
		})), en((e) => Object.fromEntries(Object.entries(e).filter(([e]) => wt.includes(e))));
		let e = Yt.some((e) => !wt.includes(e)), t = wt.some((e) => !Yt.includes(e));
		(e || t) && (ZC.debug("Column set changed, dropping stale column state", {
			previousColumns: Yt,
			nextColumns: wt
		}), Xt(wt));
	}, [wt, Yt]);
	let nn = s(() => {
		let e = {
			left: [0],
			right: [0]
		}, t = xe.length === 0 ? 0 : ZS(xe), n = 0;
		Zt.left.forEach((n, r) => {
			e.left[r] = t, t += aS(n, tn);
		});
		for (let t = Zt.right.length - 1; t >= 0; t--) {
			let r = Zt.right[t];
			e.right[t] = n, n += aS(r, tn);
		}
		return e;
	}, [
		Zt,
		tn,
		xe
	]), rn = s((e, t) => {
		Qt((n) => {
			let r = { ...n };
			return r.left = r.left.filter((t) => t !== e), r.right = r.right.filter((t) => t !== e), t === "left" ? r.left.push(e) : t === "right" && r.right.push(e), r;
		}), Me(() => {
			let n = new CustomEvent("column-pin-changed", { detail: {
				column: e,
				position: t,
				offsets: nn()
			} });
			window.dispatchEvent(n);
		}, 50);
	}, [nn, Me]), an = s((e) => {
		Xt(e);
	}, []), on = s((e, t) => {
		en((n) => ({
			...n,
			[e]: t
		}));
	}, []), sn = s((e) => {
		switch (e) {
			case "auto-fit-all": {
				let e = {};
				wt.forEach((t) => {
					let n = iS(t);
					if (n !== 150) {
						e[t] = n;
						return;
					}
					let r = t.length * 8 + 80;
					e[t] = Math.min(Math.max(r, 100), 400);
				}), en(e);
				break;
			}
			case "reset-all-widths":
				en({});
				break;
			case "unpin-all":
				Qt({
					left: [],
					right: []
				});
				break;
			case "reset-all":
				Xt(wt), Qt({
					left: [],
					right: []
				}), en({});
				break;
		}
	}, [wt]), cn = s((e, t) => {
		let n = t || Hi(ot, e, r) || {};
		Mt.openViewModal(n, "view");
	}, [
		ot,
		r,
		Mt
	]), ln = s((e, t) => {
		let n = t || Hi(ot, e, r) || {};
		Mt.openViewModal(n, "edit");
	}, [
		ot,
		r,
		Mt
	]), un = s((e) => {
		be(e);
	}, []), dn = s(() => {
		if (ye === null) return;
		let e = ye;
		be(null), ZC.debug("Deleting row:", e);
		let t = p.delete || p.onDelete || p[$.DELETE];
		t ? (t(e), Me(() => jt(), 300)) : g ? (g([e]), jt()) : ZC.warn("No delete handler provided");
	}, [
		ye,
		p,
		g,
		jt,
		Me
	]), fn = s(() => {
		be(null);
	}, []), pn = s(() => {
		let e = ot[0] ?? {}, t = wt.reduce((t, n) => {
			if (n === r) return t;
			let i = e[n];
			return typeof i == "number" ? t[n] = 0 : typeof i == "boolean" ? t[n] = !1 : t[n] = "", t;
		}, {});
		Mt.openViewModal(t, "create", "Create New Record");
	}, [
		r,
		wt,
		ot,
		Mt
	]), mn = s((e, t) => {
		if (e === -1) {
			Wt();
			return;
		}
		Gt(e, t);
	}, [Gt, Wt]), hn = ca({
		externalHandlers: {
			...Jt,
			onColumnManagement: sn,
			view: cn,
			edit: ln,
			delete: un,
			create: pn,
			export: mn,
			onView: cn,
			onEdit: ln,
			onDelete: un,
			onCreate: pn,
			onExport: mn
		},
		databaseId: te,
		tableName: W,
		onOpenViewModal: (e, t = "view", n) => {
			Mt.openViewModal(e, t, n);
		},
		onFindAndOpenRow: Mt.findAndOpenRow,
		onExportRow: Gt,
		onDataRefresh: jt,
		effectiveData: ot,
		idField: r
	}), gn = ya({
		sortBy: lt,
		setSortBy: ut,
		order: dt,
		setOrder: Y,
		externalHandleSort: S,
		page: ft,
		setPage: pt,
		pageSize: mt,
		setPageSize: ht,
		externalHandlePageChange: C,
		externalHandlePageSizeChange: w,
		effectiveFilters: Ye,
		handleClearFilter: Dt,
		selectedRows: Pt.selectedRows,
		onBulkAction: Ft,
		handleExport: Wt,
		exportSingleRow: Gt,
		exportMultipleRows: Kt,
		isInfiniteScroll: pe,
		setTableData: Ct
	}), { columnTypes: _n, isLoading: vn, error: yn } = Zi(te, W, wt, oe), bn = f(() => {
		if (!ie) return _n;
		let e = { ..._n };
		return wt.forEach((t) => {
			e[t] || (e[t] = Ab(t, Ue.data ?? []));
		}), e;
	}, [
		_n,
		Ue.data,
		ie,
		wt
	]), xn = f(() => wt.filter((e) => bn[e] === "numerical"), [wt, bn]), Sn = s((e, t = "") => lb(ot || [], e, t), [ot]), Cn = s(async (e, t = "") => {
		if (ee) return Sn(e, t);
		if (!te || !W) return ZC.error("Cannot fetch unique values: missing databaseId or tableName"), Sn(e, t);
		try {
			ZC.debug(`Fetching unique values for column: ${e}`, { searchTerm: t });
			let n = await oe.fetchUniqueColumnValues(te, W, e, t, 100);
			return ZC.debug(`Retrieved ${n.length} unique values for ${e}`), n;
		} catch (n) {
			let r = "Error fetching unique values";
			return (n.code === "ERR_NETWORK" || n.message?.includes("Network Error")) && (r = "Cannot connect to the server. Using local fallback."), ZC.error(`${r}:`, {
				error: n,
				column: e,
				searchTerm: t,
				usingFallback: !0
			}), Sn(e, t);
		}
	}, [
		ee,
		te,
		W,
		oe,
		Sn
	]), wn = s(async ({ column: e, searchTerm: t, limit: n }) => (await Cn(e, t)).slice(0, n), [Cn]), Tn = s((e) => {
		ue(e), we.current = e, ce(!0);
	}, []), En = s((e) => {
		e ? (Tn(e), ZC.debug(`Setting sidebar tab to: ${e} and opening sidebar`)) : (ce((e) => !e), se || ue(we.current), ZC.debug(`Toggling sidebar visibility to: ${!se}, keeping tab: ${we.current}`));
	}, [Tn, se]), Dn = s((e) => {
		ue(e), we.current = e;
	}, []), On = s(() => {
		et(!1);
	}, [et]), kn = s(async (e) => {
		if (!await Nt(e)) throw Error("Save failed");
	}, [Nt]), An = f(() => {
		let e = H?.inlineEditing, t = xe.some((e) => e.action === $.EDIT || e.id === $.EDIT);
		return typeof e == "boolean" ? {
			enabled: e,
			saveOnBlur: !0
		} : e ? {
			saveOnBlur: !0,
			...e,
			enabled: e.enabled ?? !0
		} : {
			enabled: t,
			saveOnBlur: !0
		};
	}, [xe, H?.inlineEditing]), jn = s(async ({ rowId: e, rowData: t, column: n, value: i }) => {
		let a = {
			...t,
			[n]: i
		};
		try {
			let o = Bi(t, r) ?? e;
			return te && W ? await oe.updateRecord(te, W, o, a) : (p.onInlineEdit ?? p.inlineEdit)?.(e, a), Ct(ot.map((t, a) => {
				let o = Bi(t, r) ?? a;
				return String(o) === String(e) ? {
					...t,
					[n]: i
				} : t;
			})), !0;
		} catch (t) {
			return ZC.error("Inline cell save failed:", {
				error: t,
				rowId: e,
				column: n
			}), !1;
		}
	}, [
		p,
		r,
		oe,
		te,
		W,
		ot,
		Ct
	]), Mn = s(() => {
		Xe && Ze ? (et(!0, Ze, Qe, !0), Object.keys(Ye).forEach((e) => {
			e !== "__sampling" && Fe(e);
		}), rt.refreshStats({})) : Object.keys(Ye).forEach((e) => {
			e !== "__sampling" && Fe(e);
		}), K.current && (ZC.debug("Forcing immediate data refresh after clearing all filters"), K.current?.());
	}, [
		Xe,
		Ze,
		Qe,
		Ye,
		et,
		Fe,
		rt,
		Me
	]), Nn = s(() => {
		ce(!1);
	}, []), Pn = f(() => ({
		...Je,
		columns: wt,
		numericColumns: xn.length > 0 ? xn : q.numericColumns
	}), [
		Je,
		wt,
		xn,
		q.numericColumns
	]), Fn = f(() => ot.slice(0, 5), [ot]), In = f(() => ({
		enabled: Pn.samplingState.isSamplingEnabled,
		strategy: Pn.samplingState.currentStrategy.id,
		samplePercentage: Pn.samplingState.samplePercentage,
		sampledRows: Pn.samplingState.sampledRows,
		totalRows: Pn.samplingState.totalRows,
		selectedColumn: Pn.samplingState.selectedColumn,
		seed: Pn.samplingState.seed
	}), [
		Pn.samplingState.currentStrategy.id,
		Pn.samplingState.isSamplingEnabled,
		Pn.samplingState.samplePercentage,
		Pn.samplingState.sampledRows,
		Pn.samplingState.seed,
		Pn.samplingState.selectedColumn,
		Pn.samplingState.totalRows
	]), Ln = f(() => {
		let e = he?.metadata?.run;
		if (!(!e || typeof e != "object")) return e;
	}, [he]), Rn = mt, zn = ft, Bn = (() => {
		let e = Ln?.rowCount ?? k ?? gt;
		return typeof A == "number" && Number.isFinite(A) && A > 0 ? Math.min(e, A) : e;
	})(), Vn = f(() => Ln || he ? {
		durationMs: Ln?.executionMs ?? he?.durationMs,
		collectedAt: Ln?.finishedAt ?? Ln?.updatedAt ?? he?.fetchedAt,
		cacheStatus: Ln?.cacheStatus ?? he?.cacheStatus,
		metadata: he?.metadata
	} : void 0, [he, Ln]), Hn = f(() => ({
		filters: Ln?.rawFilters ?? Ye,
		visibleColumns: Ln?.definition.visibleColumns.length ? Ln.definition.visibleColumns : wt,
		columnOrder: Yt.length > 0 ? Yt : Ln?.definition.visibleColumns.length ? Ln.definition.visibleColumns : wt,
		sorts: Ln?.sorts.length ? Ln.sorts : lt ? [{
			column: lt,
			direction: dt === "desc" ? "desc" : "asc"
		}] : [],
		page: zn,
		pageSize: Rn,
		resultLimit: A,
		totalRows: Bn,
		previewRows: Ln?.result?.rows ?? Fn,
		sampling: In,
		execution: Vn,
		appliedRun: Ln,
		pendingRun: _e ?? void 0
	}), [
		Yt,
		Ye,
		dt,
		Fn,
		wt,
		zn,
		Rn,
		Bn,
		A,
		lt,
		Ln,
		Vn,
		In,
		_e
	]), Un = f(() => JSON.stringify(Hn), [Hn]);
	u(() => {
		B && Ae.current !== Un && (Ae.current = Un, B(Hn));
	}, [
		B,
		Hn,
		Un
	]);
	let Wn = s((e) => {
		gn.handlePageSizeChange(e);
	}, [gn]);
	if (u(() => () => {
		je();
	}, [je]), (Be || ct) && ot.length === 0 && wt.length === 0) return /* @__PURE__ */ _(VC, {
		isRefetching: ct,
		tableName: re
	});
	let Gn = Ve || yt;
	if (Gn) return /* @__PURE__ */ _(HC, {
		message: Gn,
		onRetry: He
	});
	let Kn = {
		page: T ?? zn,
		totalPages: E ?? _t,
		pageSize: Rn,
		totalRows: Bn
	}, qn = (() => {
		let e = new Set(O ?? []), t = Kn.pageSize;
		return Number.isFinite(t) && t > 0 && e.add(t), Array.from(e).sort((e, t) => e - t);
	})(), Jn = Ue.heightMode === "fill", Yn = H?.headerDisplay, Xn = H?.typography, Zn = H?.enableHorizontalScroll ?? wt.length > 10, X = {
		height: Jn ? Ue.maxHeight : "auto",
		maxHeight: Ue.maxHeight,
		minHeight: Ue.minHeight,
		"--datagrid-row-height": H?.rowHeight ? `${H.rowHeight}px` : void 0
	};
	return /* @__PURE__ */ v("div", {
		"data-testid": "datagrid-root",
		"data-datagrid-height-mode": Ue.heightMode,
		className: `flex w-full min-h-0 min-w-0 flex-col ${Jn ? "overflow-hidden" : "overflow-visible"} ${H?.rootClassName ?? ""}`,
		style: X,
		children: [/* @__PURE__ */ v($x, {
			heightMode: Ue.heightMode,
			statsPanelOpen: Xe,
			onStatsPanelClose: On,
			statsData: Qe,
			isLoadingStats: $e || rt.loading,
			selectedColumn: Ze,
			tableName: re,
			viewModalOpen: Mt.viewModalOpen,
			closeViewModal: Mt.closeViewModal,
			selectedRow: Mt.selectedRow,
			viewModalTitle: Mt.viewModalTitle,
			viewModalMode: Mt.viewModalMode,
			handleRowSave: kn,
			idField: r,
			databaseId: ne ? String(ne) : "",
			originalFileName: Bt,
			databaseInfo: Lt,
			databaseInfoLoading: Rt,
			onRequestDatabaseInfo: zt,
			totalColumns: wt.length,
			totalRows: Bn,
			effectiveFilters: Ye,
			handleClearAllFilters: Mn,
			vendorAudit: Ut,
			auditSummary: Ut.latestSummary ?? Vt.latestSummary,
			auditReports: Vt.reports,
			auditRuleCount: Ut.activeRuleCount,
			auditLoading: Ut.loading,
			auditError: Ut.error,
			onGenerateAuditReport: Vt.generateReport,
			onDownloadAuditReport: Vt.downloadReport,
			onRefreshAudit: Vt.refresh,
			toggleSidebarFilters: En,
			initialSidebarTab: le,
			isSidebarFiltersOpen: se,
			onSidebarFiltersClose: Nn,
			onSidebarTabChange: Dn,
			sampling: Pn,
			columns: wt,
			data: ot || [],
			numericColumns: xn,
			filters: Ye,
			applyFilter: Et,
			clearFilter: Dt,
			columnTypes: bn,
			fetchUniqueValues: Cn,
			openStatsPanel: Ot,
			shouldEnableHorizontalScroll: Zn,
			tableMaxHeight: Ue.maxHeight,
			columnOrder: Yt,
			pinnedColumns: Zt,
			onColumnPin: rn,
			onColumnReorder: an,
			columnWidths: tn,
			onColumnResize: on,
			columnLabels: H?.columnLabels,
			headerSelectors: I,
			showHeaderInfoBar: H?.showHeaderInfoBar ?? !0,
			children: [/* @__PURE__ */ _(Bx, {
				isOpen: se,
				onClose: Nn,
				columns: wt,
				data: ot || [],
				databaseId: te || "",
				tableName: W || "",
				filters: Ye,
				applyFilter: Et,
				clearFilter: Dt,
				clearAllFilters: Mn,
				columnTypes: bn,
				fetchUniqueValues: Cn,
				openStatsPanel: Ot,
				initialTab: le,
				onTabChange: Dn,
				sampling: Pn
			}), /* @__PURE__ */ _(BC, {
				heightMode: Ue.heightMode,
				tableMaxHeight: Ue.maxHeight,
				shouldEnableHorizontalScroll: Zn,
				effectiveColumns: wt,
				tableData: ot,
				sortBy: lt,
				order: dt,
				handleSort: gn.handleSort,
				tableName: re,
				databaseId: ne ? String(ne) : "",
				actions: xe,
				isInfiniteScroll: pe,
				hasMoreItems: St,
				onLoadMore: xt,
				onInfiniteScrollChange: Tt,
				selectedRows: Pt.selectedRows,
				setSelectedRows: Pt.setSelectedRows,
				isAllSelected: Pt.isAllSelected,
				onToggleSelectAll: Pt.onToggleSelectAll,
				onRowClick: y,
				handleBulkAction: gn.handleBulkAction,
				handleClearFilter: Dt,
				effectiveFilters: Ye,
				handleApplyFilter: Et,
				onStatsPanelChange: et,
				onRowSelect: Pt.onRowSelect,
				idField: r || "",
				actionHandlers: hn,
				...Kn,
				pageSizeOptions: qn,
				handlePageChange: gn.handlePageChange,
				handlePageSizeChange: Wn,
				handleExport: Wt,
				openStatsPanel: Ot,
				toggleSidebarFilters: En,
				initialSidebarTab: le,
				isLoading: vt,
				isExporting: qt,
				sampling: Pn,
				currentTheme: de,
				vendorAuditByColumn: Vt.columnStatusMap,
				columnOrder: Yt,
				pinnedColumns: Zt,
				onColumnPin: rn,
				onColumnReorder: an,
				columnWidths: tn,
				onColumnResize: on,
				rowHeight: H?.rowHeight,
				showFooter: H?.showFooter ?? !0,
				scrollRegionMaxHeight: H?.scrollRegionMaxHeight,
				headerDisplay: Yn,
				typography: Xn,
				tableClassName: H?.tableClassName,
				scrollRegionClassName: H?.scrollRegionClassName,
				columnLabels: H?.columnLabels,
				renderColumnHeaderAction: V,
				rowClassName: H?.rowClassName,
				cellClassNames: H?.cellClassNames,
				cellRenderers: H?.cellRenderers,
				cellText: H?.cellText,
				columnTypes: bn,
				inlineEditing: An,
				onCellSave: jn,
				loadReferenceOptions: wn
			})]
		}), /* @__PURE__ */ _(yx, {
			open: ye !== null,
			onClose: fn,
			panelTestId: "delete-confirm-modal",
			children: /* @__PURE__ */ v("div", {
				className: "rounded-lg bg-white p-6 shadow-xl dark:bg-slate-800",
				children: [
					/* @__PURE__ */ _("h3", {
						className: "mb-2 text-base font-semibold text-slate-900 dark:text-slate-100",
						children: "Delete record"
					}),
					/* @__PURE__ */ _("p", {
						className: "mb-6 text-sm text-slate-600 dark:text-slate-400",
						children: "This action cannot be undone."
					}),
					/* @__PURE__ */ v("div", {
						className: "flex justify-end gap-3",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: fn,
							className: "rounded px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 dark:text-slate-300 dark:hover:bg-slate-700",
							children: "Cancel"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: dn,
							"data-testid": "delete-confirm-button",
							className: "rounded bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700",
							children: "Delete"
						})]
					})
				]
			})
		})]
	});
}, ew = (e) => /* @__PURE__ */ _(Ei, {
	provider: "provider" in e ? e.provider : void 0,
	children: /* @__PURE__ */ _($C, { ...e })
}), tw = "datagrid:toast", nw = 5, rw = r(null);
function iw(e) {
	return e === "error" || e === "loading" ? 0 : 5e3;
}
function aw() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : `toast-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function ow(e) {
	return e === "success" ? /* @__PURE__ */ _(oo, {
		className: "h-5 w-5",
		"aria-hidden": "true"
	}) : e === "error" ? /* @__PURE__ */ _(jo, {
		className: "h-5 w-5",
		"aria-hidden": "true"
	}) : e === "warning" ? /* @__PURE__ */ _(No, {
		className: "h-5 w-5",
		"aria-hidden": "true"
	}) : e === "loading" ? /* @__PURE__ */ _("span", {
		className: "h-4 w-4 animate-spin rounded-full border-2 border-current border-r-transparent",
		"aria-hidden": "true"
	}) : /* @__PURE__ */ _(Uo, {
		className: "h-5 w-5",
		"aria-hidden": "true"
	});
}
function sw(e) {
	return e === "success" ? {
		border: "var(--color-success-dark, #34c759)",
		background: "var(--color-success-light, #d4f8d3)",
		color: "#14532d"
	} : e === "error" ? {
		border: "var(--color-error-dark, #ff3b30)",
		background: "var(--color-error-light, #ffd1d1)",
		color: "#7f1d1d"
	} : e === "warning" ? {
		border: "var(--color-warning-dark, #ff9500)",
		background: "var(--color-warning-light, #fff2cc)",
		color: "#713f12"
	} : e === "loading" ? {
		border: "var(--color-primary, #007aff)",
		background: "var(--color-background-light, #ffffff)",
		color: "var(--color-text-dark, #1c1c1e)"
	} : {
		border: "var(--color-info-dark, #007aff)",
		background: "var(--color-background-light, #ffffff)",
		color: "var(--color-text-dark, #1c1c1e)"
	};
}
function cw(e) {
	typeof window > "u" || window.dispatchEvent(new CustomEvent(tw, { detail: e }));
}
function lw({ children: e }) {
	let [t, n] = h([]), r = m(/* @__PURE__ */ new Map()), i = s((e) => {
		let t = r.current.get(e);
		t && (clearTimeout(t), r.current.delete(e)), n((t) => t.filter((t) => t.id !== e));
	}, []), a = s((e) => {
		let t = aw(), a = {
			...e,
			id: t
		}, o = e.duration ?? iw(e.type);
		if (n((e) => [a, ...e].slice(0, nw)), o > 0) {
			let e = setTimeout(() => i(t), o);
			r.current.set(t, e);
		}
		return t;
	}, [i]);
	u(() => {
		let e = (e) => {
			let t = e.detail;
			!t?.title || !t?.type || a(t);
		};
		return window.addEventListener(tw, e), () => window.removeEventListener(tw, e);
	}, [a]), u(() => () => {
		r.current.forEach((e) => clearTimeout(e)), r.current.clear();
	}, []);
	let o = f(() => ({
		toast: a,
		dismiss: i
	}), [a, i]);
	return /* @__PURE__ */ v(rw.Provider, {
		value: o,
		children: [e, /* @__PURE__ */ _("div", {
			className: "pointer-events-none fixed bottom-4 right-4 z-[1200] flex w-[min(24rem,calc(100vw-2rem))] flex-col gap-2",
			"aria-live": "polite",
			"aria-relevant": "additions",
			"data-testid": "toast-stack",
			children: t.map((e) => {
				let t = sw(e.type), n = e.type === "error" || e.type === "warning" ? "alert" : "status", r = "mt-2 inline-flex rounded-md border border-current px-2 py-1 text-xs font-medium";
				return /* @__PURE__ */ v("div", {
					role: n,
					className: "pointer-events-auto flex items-start gap-3 rounded-md border px-3 py-3 shadow-lg transition-all",
					style: {
						borderColor: t.border,
						background: t.background,
						color: t.color
					},
					"data-testid": `toast-${e.type}`,
					children: [
						/* @__PURE__ */ _("div", {
							className: "mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center",
							children: ow(e.type)
						}),
						/* @__PURE__ */ v("div", {
							className: "min-w-0 flex-1",
							children: [
								/* @__PURE__ */ _("div", {
									className: "break-words text-sm font-semibold",
									children: e.title
								}),
								e.description ? /* @__PURE__ */ _("div", {
									className: "mt-1 break-words text-xs leading-5 opacity-80",
									children: e.description
								}) : null,
								e.action ? e.action.href ? /* @__PURE__ */ _("a", {
									className: r,
									href: e.action.href,
									onClick: () => {
										e.action?.onClick?.(), i(e.id);
									},
									children: e.action.label
								}) : /* @__PURE__ */ _("button", {
									type: "button",
									className: r,
									onClick: () => {
										e.action?.onClick?.(), i(e.id);
									},
									children: e.action.label
								}) : null
							]
						}),
						/* @__PURE__ */ _("button", {
							type: "button",
							className: "shrink-0 rounded-md p-1 opacity-70 hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-current",
							"aria-label": `Dismiss ${e.title}`,
							onClick: () => i(e.id),
							children: /* @__PURE__ */ _(xs, {
								className: "h-4 w-4",
								"aria-hidden": "true"
							})
						})
					]
				}, e.id);
			})
		})]
	});
}
function uw() {
	let e = c(rw);
	if (!e) throw Error("useToast must be used inside ToastProvider");
	return e;
}
//#endregion
//#region src/components/graph/graphTrustOverlay.ts
var dw = [
	{
		id: "type",
		label: "Type",
		description: "Color nodes by high-level graph family.",
		tooltip: "Type is the high-level part of the graph, not a health status.",
		example: "Example: Table, Pipeline, Owner, Report."
	},
	{
		id: "quality",
		label: "Quality",
		description: "Highlight validation health and failing checks.",
		tooltip: "Quality shows whether recent checks, tests, and rules passed for this node.",
		example: "Example: a table passes row-count and null-rate checks."
	},
	{
		id: "governance",
		label: "Governance",
		description: "Highlight ownership, stewardship, SLA, and policy state.",
		tooltip: "Governance reflects the governance score and review state for ownership, stewardship, policy, and contracts.",
		example: "Example: Watch means the score needs attention, but is not a hard breach."
	},
	{
		id: "privacy",
		label: "Privacy",
		description: "Highlight PHI, masking, exposure, and privacy evidence.",
		tooltip: "Privacy shows sensitive-data evidence and whether required controls are present.",
		example: "Example: Watch can mean sensitive data exists and controls should be reviewed."
	},
	{
		id: "freshness",
		label: "Freshness",
		description: "Highlight stale or current source evidence.",
		tooltip: "Freshness compares the latest observed update with the expected freshness window.",
		example: "Example: Pass means the asset is still inside its SLA window."
	},
	{
		id: "operations",
		label: "Operations",
		description: "Highlight job, pipeline, and run-health state.",
		tooltip: "Operations shows whether recent jobs, pipelines, and run signals are healthy.",
		example: "Example: Unknown means this graph node is not connected to a run signal yet."
	}
], fw = {
	pass: {
		label: "Pass",
		color: "#22c55e",
		surface: "rgba(34, 197, 94, 0.16)",
		description: "Evidence is currently healthy for this lens."
	},
	watch: {
		label: "Watch",
		color: "#f59e0b",
		surface: "rgba(245, 158, 11, 0.18)",
		description: "Evidence needs attention but is not failing."
	},
	fail: {
		label: "Fail",
		color: "#ef4444",
		surface: "rgba(239, 68, 68, 0.18)",
		description: "Evidence is failing or requires remediation."
	},
	stale: {
		label: "Stale",
		color: "#a855f7",
		surface: "rgba(168, 85, 247, 0.17)",
		description: "Evidence exists but is stale for this lens."
	},
	unknown: {
		label: "Unknown",
		color: "#94a3b8",
		surface: "rgba(148, 163, 184, 0.16)",
		description: "Evidence is missing or inconclusive."
	},
	"not-scanned": {
		label: "Not scanned",
		color: "#64748b",
		surface: "rgba(100, 116, 139, 0.14)",
		description: "This lens has not scanned the node yet."
	}
}, pw = {
	quality: {
		pass: "Latest quality evidence passed its checks.",
		watch: "Quality evidence has warnings, partial coverage, or review items.",
		fail: "One or more quality checks failed and need remediation.",
		stale: "Quality checks exist, but the latest run is older than the expected scan window.",
		unknown: "Quality evidence exists but cannot be interpreted for this node.",
		"not-scanned": "No quality scan has run for this node yet."
	},
	governance: {
		pass: "Governance score, ownership, and policy evidence are healthy.",
		watch: "Governance score or review state needs attention, but is not a hard breach.",
		fail: "Governance evidence shows a policy, ownership, SLA, or contract breach.",
		stale: "Governance evidence exists, but the score or review is older than the expected refresh window.",
		unknown: "Governance evidence is missing or not linked to the scorecard for this node.",
		"not-scanned": "No governance assessment has scored this node yet."
	},
	privacy: {
		pass: "Privacy evidence shows no sensitive exposure or confirms required controls.",
		watch: "Sensitive data or privacy controls need review, but no confirmed breach is recorded.",
		fail: "Privacy evidence shows exposed sensitive data or a required-control gap.",
		stale: "Privacy evidence exists, but the latest scan is older than the expected scan window.",
		unknown: "Privacy evidence exists but cannot confirm sensitivity or control state.",
		"not-scanned": "No privacy scan has classified this node yet."
	},
	freshness: {
		pass: "Latest update evidence is inside the expected freshness or SLA window.",
		watch: "Freshness is near its SLA edge or only partially confirmed.",
		fail: "Freshness evidence shows the SLA was breached.",
		stale: "Latest observed data is older than the accepted freshness window.",
		unknown: "No reliable update timestamp or freshness window is linked to this node.",
		"not-scanned": "No freshness job has checked this node yet."
	},
	operations: {
		pass: "Recent run, job, or pipeline evidence is healthy.",
		watch: "Operations evidence shows retry, backlog, queueing, or degraded run state.",
		fail: "Recent operational evidence shows a failed job, pipeline, or run.",
		stale: "Operational evidence exists, but no recent run has refreshed it.",
		unknown: "This node is not tied to a job, pipeline, or run signal yet.",
		"not-scanned": "No operations check has inspected this node yet."
	}
}, mw = {
	quality: {
		primaryLabel: "Queue quality scan",
		primaryHref: "/runs/schedules?lens=quality&type=FULL_COLUMN_ANALYSIS",
		secondaryLabel: "Open Quality",
		secondaryHref: "/observatory/quality",
		prompt: "Queue a quality job in Runs; the map status updates after the completed job refreshes evidence."
	},
	governance: {
		primaryLabel: "Open Governance Score",
		primaryHref: "/governance",
		secondaryLabel: "Review Runs",
		secondaryHref: "/runs?lens=governance",
		prompt: "Review the Governance Score and refresh scoring evidence when ownership, policy, or contract data changes."
	},
	privacy: {
		primaryLabel: "Queue privacy scan",
		primaryHref: "/runs/intake?lens=privacy",
		secondaryLabel: "Open Privacy",
		secondaryHref: "/observatory/privacy",
		prompt: "Queue a privacy scan in Runs; sensitive-data status updates after the completed job refreshes evidence."
	},
	freshness: {
		primaryLabel: "Queue freshness check",
		primaryHref: "/runs/intake?lens=freshness",
		secondaryLabel: "Open Runs",
		secondaryHref: "/runs?lens=freshness",
		prompt: "Queue a freshness check in Runs; stale/pass status updates after the completed job refreshes evidence."
	},
	operations: {
		primaryLabel: "Open Runs",
		primaryHref: "/runs?lens=operations",
		secondaryLabel: "Open Gate",
		secondaryHref: "/ops/gate",
		prompt: "Connect this node to job or pipeline runs; operations status updates as run evidence is refreshed."
	}
};
function hw(e, t) {
	return e === "type" ? fw[t].description : pw[e][t];
}
function gw(e) {
	return dw.some((t) => t.id === e);
}
function _w(e, t) {
	return t === "type" ? e.status ?? "unknown" : e[`${t}Status`] ?? e.status ?? "unknown";
}
function vw(e, t, n) {
	return t === "type" ? n ?? fw.unknown.color : fw[_w(e, t)].color;
}
//#endregion
//#region src/components/graph/graphExplorerViewModel.ts
var yw = 1200, bw = {
	scale: 1,
	offsetX: 0,
	offsetY: 0,
	rotation: 0
}, xw = [
	{
		id: "cluster",
		label: "Clusters",
		description: "Entity families",
		tone: "2D"
	},
	{
		id: "force3d",
		label: "3D Space",
		description: "Rotating force map",
		tone: "3D"
	},
	{
		id: "circular",
		label: "Circle",
		description: "One-ring scan",
		tone: "2D"
	},
	{
		id: "concentric",
		label: "Concentric",
		description: "Hubs in center",
		tone: "2D"
	},
	{
		id: "radial",
		label: "Radial",
		description: "Outward dependency fan",
		tone: "2D"
	},
	{
		id: "tree",
		label: "Tree",
		description: "Left-right paths",
		tone: "2D"
	},
	{
		id: "hierarchy",
		label: "Hierarchy",
		description: "Top-down lanes",
		tone: "2D"
	},
	{
		id: "forceatlas",
		label: "ForceAtlas",
		description: "Community structure",
		tone: "2D"
	}
], Sw = [
	{
		id: "pan",
		label: "Pan"
	},
	{
		id: "rotate",
		label: "Rotate"
	},
	{
		id: "orbit",
		label: "Orbit"
	}
], Cw = [{
	id: "find",
	label: "Find Relationships Fast",
	combo: "Global + Compact",
	description: "Use the ranked overview to spot clusters, bridges, and surprising cross-links without getting buried in every edge."
}, {
	id: "inspect",
	label: "Inspect One Node Deeply",
	combo: "Local + Full",
	description: "Pin a node, then expand its neighborhood so you can follow incoming and outgoing links around that single point of interest."
}], ww = {
	workflow: !0,
	view: !1,
	overlays: !0,
	layers: !1,
	status: !1
}, Tw = [
	"pass",
	"watch",
	"fail",
	"stale",
	"unknown",
	"not-scanned"
];
function Ew(e) {
	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		maximumFractionDigits: 1
	}).format(e);
}
function Dw(e, t) {
	let n = t.x - e.x, r = t.y - e.y, i = e.x + n * .5 + (e.type === t.type ? r * .08 : 0), a = e.y + r * .5 - (e.type === t.type ? n * .08 : 0);
	return `M ${e.x} ${e.y} Q ${i} ${a} ${t.x} ${t.y}`;
}
function Ow(e) {
	let t = {}, n = yw * .5, r = yw * .42;
	return e.forEach((i, a) => {
		let o = -Math.PI / 2 + a / Math.max(e.length, 1) * Math.PI * 2;
		t[i] = {
			x: n + Math.cos(o) * r,
			y: 410 + Math.sin(o) * 319.8
		};
	}), t;
}
function kw(e, t) {
	let n = t.indexOf(e);
	return n >= 0 ? n : t.length;
}
function Aw(e, t, n, r) {
	let i = kw(e.type, n) - kw(t.type, n);
	if (i !== 0) return i;
	let a = (r.get(t.id)?.degree ?? 0) - (r.get(e.id)?.degree ?? 0);
	return a === 0 ? e.name.localeCompare(t.name) : a;
}
function jw(e, t, n, r) {
	let i = t.get(e.id) ?? {
		degree: 0,
		inbound: 0,
		outbound: 0
	};
	return {
		...e,
		...i,
		x: n,
		y: r
	};
}
function Mw(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let e of t) r.set(e, []);
	for (let t of e) {
		let e = r.get(t.type) ?? [];
		e.push(t), r.set(t.type, e);
	}
	let i = Ow(t), a = [];
	for (let e of t) {
		let o = [...r.get(e) ?? []].sort((e, r) => Aw(e, r, t, n)), s = i[e] ?? {
			x: 1200 / 2,
			y: 820 / 2
		};
		o.forEach((t, r) => {
			let i = r * .61803398875 * Math.PI * 2, o = 26 + Math.sqrt(r) * (e.toLowerCase().includes("function") ? 28 : 24);
			a.push(jw(t, n, s.x + Math.cos(i) * o, s.y + Math.sin(i) * o));
		});
	}
	return a;
}
function Nw(e, t, n) {
	let r = [...e].sort((e, r) => Aw(e, r, t, n)), i = yw * .5, a = yw * .44;
	return r.map((e, t) => {
		let o = -Math.PI / 2 + t / Math.max(r.length, 1) * Math.PI * 2;
		return jw(e, n, i + Math.cos(o) * a, 410 + Math.sin(o) * 319.8);
	});
}
function Pw(e, t, n) {
	let r = [...e].sort((e, r) => {
		let i = (n.get(r.id)?.degree ?? 0) - (n.get(e.id)?.degree ?? 0);
		return i === 0 ? Aw(e, r, t, n) : i;
	}), i = yw * .5, a = Math.max(8, Math.ceil(Math.sqrt(r.length)));
	return r.map((e, t) => {
		let o = Math.floor(t / a), s = t % a, c = Math.min(a, r.length - o * a), l = -Math.PI / 2 + s / Math.max(c, 1) * Math.PI * 2, u = 38 + o * 58;
		return jw(e, n, i + Math.cos(l) * u, 410 + Math.sin(l) * u * .74);
	});
}
function Fw(e, t, n) {
	let r = /* @__PURE__ */ new Map();
	for (let t of e) {
		let e = r.get(t.type) ?? [];
		e.push(t), r.set(t.type, e);
	}
	let i = t.filter((e) => r.has(e)), a = yw - 160, o = [];
	return i.forEach((e, s) => {
		let c = [...r.get(e) ?? []].sort((e, r) => Aw(e, r, t, n)), l = i.length <= 1 ? yw / 2 : 80 + a * s / (i.length - 1), u = Math.min(72, Math.max(28, 820 / Math.max(c.length + 1, 2)));
		c.forEach((e, t) => {
			let r = t % 2 == 0 ? -10 : 10;
			o.push(jw(e, n, l + r, u * (t + 1)));
		});
	}), o;
}
function Iw(e, t, n, r) {
	switch (r) {
		case "circular":
		case "radial": return Nw(e, t, n);
		case "concentric": return Pw(e, t, n);
		case "tree":
		case "hierarchy": return Fw(e, t, n);
		default: return Mw(e, t, n);
	}
}
function Lw(e, t) {
	return t ? e.replace(t, "").replace(/^\/+/, "") : e;
}
function Rw(e) {
	if (!e) return "Not published yet";
	let t = new Date(e);
	if (Number.isNaN(t.getTime())) return e;
	let n = (e) => String(e).padStart(2, "0");
	return [`${t.getUTCFullYear()}-${n(t.getUTCMonth() + 1)}-${n(t.getUTCDate())}`, `${n(t.getUTCHours())}:${n(t.getUTCMinutes())} UTC`].join(" ");
}
function zw(e) {
	return e?.graphSource ?? "Direct graph data";
}
function Bw(e) {
	return e.restricted === !0;
}
function Vw(e, t) {
	return t[e.type]?.label ?? e.type;
}
function Hw(e, t) {
	return Bw(e) ? e.redactedName ?? `Restricted ${Vw(e, t)}` : e.name;
}
function Uw(e) {
	return e.type === "TableAsset" || e.type === "ViewAsset" || e.type === "ColumnAsset";
}
function Ww(e) {
	let t = (e.id.includes("#") ? e.id.split("#").pop() ?? e.id : e.id).split(":").map((e) => e.trim()).filter(Boolean), [n] = t;
	if (e.type === "ColumnAsset" && n === "col") {
		if (t.length >= 5) return `${t[2] === "_" ? "main" : t[2]}.${t[3]}.${t[4]}`;
		if (t.length >= 4) return `main.${t[2]}.${t[3]}`;
	}
	if ((e.type === "TableAsset" || e.type === "ViewAsset") && (n === "table" || n === "view")) {
		if (t.length >= 4) return `${t[2] === "_" ? "main" : t[2]}.${t[3]}`;
		if (t.length >= 3) return t[2] ?? null;
	}
	return n === "asset" && t[1] === "catalog" && t[3] ? t[3] : null;
}
function Gw(e, t) {
	return Bw(e) ? Hw(e, t) : Zw(e.physicalName) ?? Zw(e.qualifiedName) ?? Ww(e) ?? e.name;
}
function Kw(e, t, n) {
	return Bw(e) || !Uw(e) ? null : Zw(e.businessName) || Hw(e, t) || n;
}
function qw(e, t) {
	return t === "type" ? e.qualityStatus ?? e.governanceStatus ?? e.privacyStatus ?? e.freshnessStatus ?? e.operationsStatus ?? e.status ?? "unknown" : _w(e, t);
}
function Jw(e) {
	return e.toLocaleUpperCase("en-US");
}
function Yw(e, t, n) {
	return Bw(e) ? `${Hw(e, t)} ${Vw(e, t)}` : [
		e.name,
		e.physicalName,
		e.qualifiedName,
		e.businessName,
		e.description,
		e.owner,
		e.ownerEmail,
		e.steward,
		e.stewardEmail,
		e.domain,
		...tT(e.profile),
		Lw(e.filePath, n)
	].filter(Boolean).join(" ");
}
function Xw(e, t) {
	let n = typeof e == "string" && e.trim() ? e.trim() : null, r = typeof t == "string" && t.trim() ? t.trim() : null;
	return n && r ? `${n} (${r})` : n ?? r;
}
function Zw(e) {
	return typeof e == "string" && e.trim() ? e.trim() : null;
}
function Qw(e) {
	return typeof e == "number" && Number.isFinite(e) ? e : null;
}
function $w(e) {
	return typeof e == "string" ? e : Math.abs(e) >= 1e3 ? Ew(e) : Number.isInteger(e) ? String(e) : e.toLocaleString("en-US", { maximumFractionDigits: 2 });
}
function eT(e) {
	return `${e.toLocaleString("en-US", { maximumFractionDigits: 2 })}%`;
}
function tT(e) {
	if (!e) return [];
	let t = [], n = Zw(e.dataType) ?? Zw(e.inferredType), r = Zw(e.inferredType), i = Qw(e.rowCount), a = Qw(e.sampleSize), o = Qw(e.samplePercentage), s = Qw(e.nonNullCount), c = Qw(e.nullCount), l = Qw(e.nullPercentage), u = Qw(e.distinctCount), d = Qw(e.qualityScore), f = Qw(e.checksRun), p = Qw(e.failingChecks), m = Qw(e.issuesFound);
	if (n && t.push(`Data type ${n}${r && r !== n ? `, inferred ${r}` : ""}`), typeof e.nullable == "boolean" && t.push(`Nullable ${e.nullable ? "yes" : "no"}`), i !== null && t.push(`Rows ${$w(i)}`), a !== null && t.push(`Sample ${$w(a)}${o === null ? "" : ` (${eT(o)})`}`), l !== null) {
		let e = c !== null && i !== null ? ` (${$w(c)}/${$w(i)})` : "";
		t.push(`Nulls ${eT(l)}${e}`);
	} else c !== null && t.push(`Nulls ${$w(c)}`);
	if (s !== null && t.push(`Populated ${$w(s)}`), u !== null && t.push(`Distinct ${$w(u)}`), e.min !== null && e.min !== void 0 && e.max !== null && e.max !== void 0 && t.push(`Range ${$w(e.min)} to ${$w(e.max)}`), e.mean !== null && e.mean !== void 0 && t.push(`Mean ${$w(e.mean)}`), e.median !== null && e.median !== void 0 && t.push(`Median ${$w(e.median)}`), e.qualityStatus || d !== null || f !== null || m !== null) {
		let n = [
			e.qualityStatus ? String(e.qualityStatus).replace(/-/g, " ") : null,
			d === null ? null : `${eT(d)} score`,
			f === null ? null : `${$w(f)} checks`,
			p !== null && p > 0 ? `${$w(p)} failing` : null,
			m !== null && m > 0 ? `${$w(m)} issues` : null
		].filter(Boolean);
		t.push(`Quality ${n.join(", ")}`);
	}
	return t;
}
function nT(e) {
	return Math.max(.35, Math.min(4, e));
}
function rT(e) {
	let t = e % 360;
	return t < 0 ? t + 360 : t;
}
function iT(e) {
	let t = `translate(${e.offsetX} ${e.offsetY}) scale(${e.scale})`;
	return Math.abs(e.rotation) < .01 ? t : [
		`translate(${yw / 2} ${820 / 2})`,
		`rotate(${Number(e.rotation.toFixed(2))})`,
		`translate(${-1200 / 2} ${-820 / 2})`,
		t
	].join(" ");
}
function aT(e) {
	return e.replace(/[^a-zA-Z0-9_-]+/g, "-").replace(/^-+|-+$/g, "").toLowerCase() || "node";
}
function oT(e) {
	return xw.some((t) => t.id === e);
}
function sT(e) {
	if (typeof window > "u") return {
		selectedNodeId: null,
		overlayMode: e,
		localDepth: 1,
		layoutMode: "cluster"
	};
	let t = new URLSearchParams(window.location.search), n = t.get("overlay"), r = Number(t.get("depth")), i = t.get("layout");
	return {
		selectedNodeId: t.get("node") || null,
		overlayMode: gw(n) ? n : e,
		localDepth: Number.isFinite(r) && r >= 1 && r <= 4 ? r : 1,
		layoutMode: oT(i) ? i : "cluster"
	};
}
function cT({ selectedNodeId: e, overlayMode: t, layoutMode: n, localDepth: r }) {
	if (typeof window > "u") return;
	let i = new URL(window.location.href);
	e ? i.searchParams.set("node", e) : i.searchParams.delete("node"), t === "type" ? i.searchParams.delete("overlay") : i.searchParams.set("overlay", t), n === "cluster" ? i.searchParams.delete("layout") : i.searchParams.set("layout", n), r === 1 ? i.searchParams.delete("depth") : i.searchParams.set("depth", String(r)), window.history.replaceState(window.history.state, "", `${i.pathname}${i.search}${i.hash}`);
}
function lT(e) {
	if (!e || typeof document > "u") return null;
	let t = document.getElementById(e);
	if (!t) return null;
	if (typeof window < "u" && typeof window.getComputedStyle == "function") {
		let e = t;
		for (; e;) {
			let t = window.getComputedStyle(e);
			if (t.display === "none" || t.visibility === "hidden") return null;
			e = e.parentElement;
		}
	}
	return t;
}
function uT(e) {
	return `${e.source}->${e.target}:${e.type}`;
}
function dT(e, t) {
	return e.source === t || e.target === t;
}
function fT(e, t, n) {
	if (!n) return e.slice(0, t);
	let r = [], i = /* @__PURE__ */ new Set(), a = (e) => {
		let t = uT(e);
		i.has(t) || (i.add(t), r.push(e));
	};
	for (let t of e) dT(t, n) && a(t);
	for (let n of e) {
		if (r.length >= t) break;
		a(n);
	}
	return r;
}
function pT(e, t) {
	return t[e.type]?.stroke ?? "rgba(255,255,255,0.18)";
}
function mT(e, t, n, r) {
	if (e === t) return [e];
	let i = [e], a = new Map([[e, null]]);
	for (; i.length > 0;) {
		let e = i.shift();
		if (!e) continue;
		let o = new Set([...n.get(e) ?? [], ...r.get(e) ?? []]);
		for (let n of o) if (!a.has(n)) {
			if (a.set(n, e), n === t) {
				let n = [t], r = e;
				for (; r;) n.unshift(r), r = a.get(r) ?? null;
				return n;
			}
			i.push(n);
		}
	}
	return null;
}
function hT(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map();
	for (let a of e.nodes) t.set(a.id, {
		degree: 0,
		inbound: 0,
		outbound: 0
	}), n.set(a.id, /* @__PURE__ */ new Set()), r.set(a.id, /* @__PURE__ */ new Set()), i.set(a.id, a);
	for (let i of e.edges) {
		let e = t.get(i.source), a = t.get(i.target);
		e && (e.degree += 1, e.outbound += 1), a && (a.degree += 1, a.inbound += 1), n.get(i.source)?.add(i.target), r.get(i.target)?.add(i.source);
	}
	return {
		metrics: t,
		outgoing: n,
		incoming: r,
		nodeById: i,
		rankedNodes: [...e.nodes].sort((e, n) => {
			let r = (t.get(n.id)?.degree ?? 0) - (t.get(e.id)?.degree ?? 0);
			return r === 0 ? e.name.localeCompare(n.name) : r;
		})
	};
}
function gT({ graph: e, typeOrder: t, typeMeta: n, selectedTypes: r, scopeMode: i, localRootNodeId: a, localDepth: o, query: s, selectedNodeId: c, initialSelectedNodeId: l, viewMode: u, compactNodeLimit: d, compactEdgeLimit: f, layoutMode: p, derived: m }) {
	let h = s.trim().toLowerCase(), g = new Set(t.filter((e) => r[e])), _ = i === "local" && !!a, v = e.nodes.filter((t) => g.has(t.type) ? h ? Yw(t, n, e.meta?.sourceRoot).toLowerCase().includes(h) : !0 : !1), y = /* @__PURE__ */ new Set();
	if (_ && a) {
		let e = [{
			id: a,
			depth: 0
		}], t = /* @__PURE__ */ new Set();
		for (; e.length > 0;) {
			let n = e.shift();
			if (!n || t.has(n.id)) continue;
			t.add(n.id);
			let r = m.nodeById.get(n.id);
			if (r && g.has(r.type) && y.add(r.id), !(n.depth >= o)) {
				for (let r of m.outgoing.get(n.id) ?? []) t.has(r) || e.push({
					id: r,
					depth: n.depth + 1
				});
				for (let r of m.incoming.get(n.id) ?? []) t.has(r) || e.push({
					id: r,
					depth: n.depth + 1
				});
			}
		}
	} else if (h) for (let e of v.slice(0, 36)) {
		y.add(e.id);
		for (let t of m.outgoing.get(e.id) ?? []) {
			let e = m.nodeById.get(t);
			e && g.has(e.type) && y.add(e.id);
		}
		for (let t of m.incoming.get(e.id) ?? []) {
			let e = m.nodeById.get(t);
			e && g.has(e.type) && y.add(e.id);
		}
	}
	else for (let e of m.rankedNodes) if (g.has(e.type) && (y.add(e.id), u === "compact" && y.size >= d)) break;
	let b = l ? m.nodeById.get(l) ?? null : null;
	b && g.has(b.type) && y.add(b.id);
	let x = c ? m.nodeById.get(c) ?? null : null;
	if (x && g.has(x.type)) {
		y.add(x.id);
		for (let e of m.outgoing.get(x.id) ?? []) {
			let t = m.nodeById.get(e);
			t && g.has(t.type) && y.add(t.id);
		}
		for (let e of m.incoming.get(x.id) ?? []) {
			let t = m.nodeById.get(e);
			t && g.has(t.type) && y.add(t.id);
		}
	}
	let S = Iw(e.nodes.filter((e) => y.has(e.id)), t, m.metrics, p), C = new Map(S.map((e) => [e.id, e])), w = e.edges.filter((e) => C.has(e.source) && C.has(e.target));
	return {
		nodes: S,
		nodesById: C,
		edges: u === "compact" ? fT(w, f, c) : w,
		totalConnectedEdges: w.length
	};
}
function _T({ selectedNodeId: e, hoveredNodeId: t, visible: n, nodeById: r, typeMeta: i }) {
	if (!e || !t || e === t) return null;
	let a = /* @__PURE__ */ new Map(), o = /* @__PURE__ */ new Map();
	for (let e of n.nodes) a.set(e.id, /* @__PURE__ */ new Set()), o.set(e.id, /* @__PURE__ */ new Set());
	for (let e of n.edges) a.get(e.source)?.add(e.target), o.get(e.target)?.add(e.source);
	let s = mT(e, t, a, o);
	if (!s || s.length < 2) return null;
	let c = new Set(s), l = /* @__PURE__ */ new Set();
	for (let e = 0; e < s.length - 1; e += 1) {
		let t = s[e], r = s[e + 1];
		for (let e of n.edges) {
			let n = e.source === t && e.target === r, i = e.source === r && e.target === t;
			(n || i) && l.add(uT(e));
		}
	}
	return {
		nodeIds: c,
		edgeIds: l,
		nodeNames: s.map((e) => {
			let t = r.get(e);
			return t ? Hw(t, i) : e;
		}),
		hopCount: s.length - 1
	};
}
function vT(e, t, n) {
	return e ? {
		incoming: [...t.incoming.get(e.id) ?? []].map((e) => n.nodesById.get(e)).filter((e) => !!e).slice(0, 10),
		outgoing: [...t.outgoing.get(e.id) ?? []].map((e) => n.nodesById.get(e)).filter((e) => !!e).slice(0, 10)
	} : {
		incoming: [],
		outgoing: []
	};
}
function yT(e, t, n) {
	let r = /* @__PURE__ */ new Set();
	if (e) for (let n of t) (n.source === e.id || n.target === e.id) && r.add(uT(n));
	for (let e of n?.edgeIds ?? []) r.add(e);
	return r;
}
function bT(e, t, n) {
	if (!e) return null;
	let r = new Set([e.id]);
	for (let n of t.outgoing.get(e.id) ?? []) r.add(n);
	for (let n of t.incoming.get(e.id) ?? []) r.add(n);
	let i = /* @__PURE__ */ new Set();
	for (let t of n) (t.source === e.id || t.target === e.id) && i.add(uT(t));
	return {
		nodeIds: r,
		edgeIds: i
	};
}
function xT(e, t, n) {
	return e.map((e) => ({
		type: e,
		visibleCount: n.filter((t) => t.type === e).length,
		totalCount: t.filter((t) => t.type === e).length
	}));
}
function ST({ layerGroups: e, selectedTypes: t, statsByTypeMap: n, typeOrder: r }) {
	let i = new Set(r);
	return (e ?? []).map((e) => {
		let r = e.types.filter((e) => i.has(e)), a = r.filter((e) => t[e]).length, o = r.reduce((e, t) => e + (n.get(t)?.totalCount ?? 0), 0), s = r.reduce((e, t) => e + (n.get(t)?.visibleCount ?? 0), 0);
		return {
			...e,
			types: r,
			active: r.length > 0 && a === r.length,
			partial: a > 0 && a < r.length,
			enabledTypeCount: a,
			totalNodeCount: o,
			visibleNodeCount: s
		};
	}).filter((e) => e.types.length > 0);
}
function CT({ scopeMode: e, localRootNodeId: t, visible: n, localDepth: r, query: i, graphNodes: a, selectedTypes: o, viewMode: s, activeLayoutLabel: c }) {
	if (e === "local" && !t) return "Local scope: choose a node";
	if (e === "local") return `Local scope: ${n.nodes.length} nodes / ${n.edges.length} edges / ${r} hop${r === 1 ? "" : "s"}`;
	if (i.trim()) return `Search matches: ${n.nodes.length} nodes / ${n.edges.length} edges`;
	let l = a.filter((e) => o[e.type]).length;
	return s === "full" ? `${c}: ${n.nodes.length} nodes / ${n.edges.length} edges` : `${c}: ${n.nodes.length}/${l} nodes / ${n.edges.length}/${n.totalConnectedEdges} edges`;
}
function wT(e, t) {
	let n = Object.fromEntries(Tw.map((e) => [e, 0]));
	if (t === "type") return n;
	for (let r of e) n[_w(r, t)] += 1;
	return n;
}
//#endregion
//#region src/components/graph/graphExplorerReagraphRuntime.ts
var TT = null;
function ET() {
	return TT ??= import("reagraph").then((e) => {
		let t = e, n = t.GraphCanvas;
		return typeof n != "function" && typeof n != "object" || n === null ? null : {
			GraphCanvas: n,
			darkTheme: t.darkTheme
		};
	}).catch(() => null), TT;
}
function DT(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function OT(e, t) {
	let n = e?.[t];
	return DT(n) ? n : {};
}
function kT(e) {
	let t = OT(e, "node"), n = OT(e, "edge"), r = OT(e, "arrow"), i = OT(e, "ring"), a = OT(e, "lasso"), o = OT(e, "cluster"), s = "rgba(148, 163, 184, 0.84)";
	return {
		...e ?? {},
		canvas: {
			...OT(e, "canvas"),
			background: null,
			fog: null
		},
		node: {
			...t,
			fill: "#38bdf8",
			activeFill: "#f8fafc",
			opacity: .92,
			selectedOpacity: 1,
			inactiveOpacity: .16,
			label: {
				...OT(t, "label"),
				color: "#000000",
				activeColor: "#000000",
				backgroundColor: "#ffffff",
				backgroundOpacity: .82,
				padding: 5,
				radius: 5,
				fontSize: 10
			},
			subLabel: {
				...OT(t, "subLabel"),
				color: "#000000",
				activeColor: "#000000",
				fontSize: 7
			}
		},
		edge: {
			...n,
			fill: "rgba(148, 163, 184, 0.58)",
			activeFill: s,
			opacity: .58,
			selectedOpacity: .96,
			inactiveOpacity: .12,
			label: {
				...OT(n, "label"),
				color: "#000000",
				activeColor: "#000000",
				fontSize: 10
			}
		},
		arrow: {
			...r,
			fill: "rgba(148, 163, 184, 0.5)",
			activeFill: s
		},
		ring: {
			...i,
			fill: "rgba(56, 189, 248, 0.18)",
			activeFill: "rgba(248, 250, 252, 0.22)"
		},
		lasso: {
			...a,
			background: "rgba(34, 211, 238, 0.12)",
			border: "1px solid rgba(125, 211, 252, 0.72)"
		},
		cluster: {
			...o,
			fill: "rgba(15, 23, 42, 0.6)",
			stroke: "rgba(148, 163, 184, 0.28)",
			opacity: .3,
			selectedOpacity: .56,
			inactiveOpacity: .1,
			label: void 0
		}
	};
}
function AT() {
	if (typeof document > "u" || typeof window > "u" || window.ResizeObserver === void 0) return !1;
	try {
		let e = document.createElement("canvas");
		return !!(e.getContext("webgl2") || e.getContext("webgl") || e.getContext("experimental-webgl"));
	} catch {
		return !1;
	}
}
function jT(e) {
	switch (e) {
		case "force3d": return "forceDirected3d";
		case "circular": return "circular2d";
		case "concentric": return "concentric2d";
		case "radial": return "radialOut2d";
		case "tree": return "treeLr2d";
		case "hierarchy": return "hierarchicalTd";
		case "forceatlas": return "forceatlas2";
		default: return "forceDirected2d";
	}
}
function MT({ visibleNodes: e, visibleEdges: t, typeMeta: n, edgeMeta: r, overlayMode: i }) {
	return {
		nodes: e.map((e) => {
			let t = n[e.type], r = Hw(e, n), a = _w(e, i), o = vw(e, i, t?.accent), s = 8.5 + Math.min(22, Math.sqrt(Math.max(e.degree, 1)) * 3);
			return {
				id: e.id,
				label: r,
				subLabel: t?.label ?? e.type,
				fill: o,
				size: s,
				cluster: e.type,
				labelVisible: !1,
				data: {
					...e,
					degree: Math.max(e.degree, 1),
					type: e.type,
					typeLabel: t?.label ?? e.type,
					overlayStatus: a
				}
			};
		}),
		edges: t.map((e, t) => ({
			id: `${uT(e)}:${t}`,
			source: e.source,
			target: e.target,
			label: r[e.type]?.label ?? e.type,
			fill: r[e.type]?.stroke ?? "rgba(148, 163, 184, 0.42)",
			size: 1.8,
			interpolation: "curved",
			arrowPlacement: "end",
			dashed: !1,
			data: { ...e }
		}))
	};
}
//#endregion
//#region src/components/graph/GraphExplorer.tsx
function NT({ badgeLabel: e, title: t, description: r, searchPlaceholder: i, graph: a, typeOrder: o, typeMeta: s, edgeMeta: c, defaultSelectedTypes: l, defaultViewMode: d = "compact", compactNodeLimit: p = 220, compactEdgeLimit: y = 520, containerClassName: x, testIdPrefix: S = "graph-explorer", glossary: C, renderInspectorActions: w, defaultOverlayMode: T = "type", syncUrlState: E = !1, sideMenuPortalId: D, fitHeightToContainer: O = !1, layerGroups: k, enableWebGlRenderer: A = !1 }) {
	let j = f(() => sT(T), [T]), [M, N] = h(""), [P, F] = h(d), [I, L] = h("global"), [R, z] = h(j.localDepth), [B, V] = h(j.selectedNodeId), [H, ee] = h(null), [U, te] = h(j.overlayMode), [W, ne] = h(j.layoutMode), [re, ie] = h("pan"), [ae, oe] = h(!1), [se, ce] = h(null), [le, ue] = h(bw), [de, fe] = h(l ?? Object.fromEntries(o.map((e) => [e, !0]))), [pe, me] = h(ww), he = H ?? B, ge = I === "local" ? B : null, _e = m(j.selectedNodeId), ve = m(null), ye = m(null), [be, xe] = h(!1), Se = m(null), Ce = m(!1);
	u(() => {
		let e = !1;
		return !A || !AT() ? (oe(!1), ce(null), () => {
			e = !0;
		}) : (ET().then((t) => {
			e || (ce(t), oe(!!t));
		}), () => {
			e = !0;
		});
	}, [A]), u(() => {
		!E || typeof window > "u" || cT({
			selectedNodeId: B,
			overlayMode: U,
			layoutMode: W,
			localDepth: R
		});
	}, [
		W,
		R,
		U,
		B,
		E
	]), u(() => {
		if (typeof window > "u") return;
		let e = (e) => {
			e.key === "Escape" && (V(null), ee(null));
		};
		return window.addEventListener("keydown", e), () => window.removeEventListener("keydown", e);
	}, []);
	let we = f(() => hT(a), [a]);
	u(() => {
		B && !we.nodeById.has(B) && V(null);
	}, [we.nodeById, B]);
	let G = f(() => gT({
		graph: a,
		typeOrder: o,
		typeMeta: s,
		selectedTypes: de,
		scopeMode: I,
		localRootNodeId: ge,
		localDepth: R,
		query: M,
		selectedNodeId: B,
		initialSelectedNodeId: _e.current,
		viewMode: P,
		compactNodeLimit: p,
		compactEdgeLimit: y,
		layoutMode: W,
		derived: we
	}), [
		y,
		p,
		we,
		a,
		W,
		R,
		ge,
		M,
		B,
		de,
		I,
		s,
		o,
		P
	]), Te = B ? G.nodesById.get(B) ?? null : null, Ee = he ? G.nodesById.get(he) ?? null : null, K = Te ?? Ee, De = f(() => _T({
		selectedNodeId: B,
		hoveredNodeId: H,
		visible: G,
		nodeById: we.nodeById,
		typeMeta: s
	}), [
		we.nodeById,
		H,
		B,
		s,
		G
	]), Oe = f(() => vT(K, we, G), [
		we,
		K,
		G
	]), ke = f(() => yT(Ee, G.edges, De), [
		Ee,
		De,
		G.edges
	]), Ae = f(() => bT(Ee, we, G.edges), [
		Ee,
		we,
		G.edges
	]), je = f(() => MT({
		visibleNodes: G.nodes,
		visibleEdges: G.edges,
		typeMeta: s,
		edgeMeta: c,
		overlayMode: U
	}), [
		c,
		U,
		s,
		G.edges,
		G.nodes
	]), Me = f(() => {
		let e = /* @__PURE__ */ new Set();
		for (let t of Ae?.nodeIds ?? []) G.nodesById.has(t) && e.add(t);
		for (let t of De?.nodeIds ?? []) G.nodesById.has(t) && e.add(t);
		return [...e];
	}, [
		Ae?.nodeIds,
		De?.nodeIds,
		G.nodesById
	]), Ne = f(() => xT(o, a.nodes, G.nodes), [
		a.nodes,
		o,
		G.nodes
	]), Pe = f(() => new Map(Ne.map((e) => [e.type, e])), [Ne]), Fe = o.filter((e) => de[e]).length, Ie = Object.keys(c).length, Le = f(() => ST({
		layerGroups: k,
		selectedTypes: de,
		statsByTypeMap: Pe,
		typeOrder: o
	}), [
		k,
		de,
		Pe,
		o
	]), Re = Le.filter((e) => e.active).length, ze = Le.length > 0 ? `${Re}/${Le.length} graph layers • ${Fe}/${o.length} node types` : `${Fe}/${o.length} node types • ${Ie} relationship types`, Be = xw.find((e) => e.id === W) ?? xw[0], Ve = se?.GraphCanvas ?? null, He = f(() => kT(se?.darkTheme), [se?.darkTheme]), Ue = jT(W), q = W === "cluster" && Ue === "forceDirected2d" ? "type" : void 0, We = f(() => CT({
		scopeMode: I,
		localRootNodeId: ge,
		visible: G,
		localDepth: R,
		query: M,
		graphNodes: a.nodes,
		selectedTypes: de,
		viewMode: P,
		activeLayoutLabel: Be.label
	}), [
		Be.label,
		a.nodes,
		R,
		ge,
		M,
		I,
		de,
		P,
		G
	]), J = f(() => Ow(o), [o]), Ge = !!Ae, Ke = dw.find((e) => e.id === U) ?? dw[0], qe = Ee ? Hw(Ee, s) : null, Je = K ? Hw(K, s) : null, Ye = Rw(a.meta?.builtAt), Xe = zw(a.meta), Ze = f(() => wT(a.nodes, U), [a.nodes, U]), Qe = U === "type" ? null : mw[U], $e = U === "type" ? 0 : Ze["not-scanned"], [et, tt] = h(() => lT(D));
	u(() => {
		if (!D || typeof window > "u") {
			tt(null);
			return;
		}
		let e = () => {
			tt(lT(D));
		};
		return e(), window.addEventListener("resize", e), () => window.removeEventListener("resize", e);
	}, [D]), u(() => {
		if (ae || re !== "orbit" || typeof window > "u") return;
		let e = 0, t = window.performance.now(), n = (r) => {
			let i = Math.min(64, r - t);
			t = r, ue((e) => ({
				...e,
				rotation: rT(e.rotation + i * .018)
			})), e = window.requestAnimationFrame(n);
		};
		return e = window.requestAnimationFrame(n), () => window.cancelAnimationFrame(e);
	}, [re, ae]);
	let nt = (e) => {
		e.preventDefault();
		let t = ve.current;
		if (!t) return;
		let n = t.getBoundingClientRect();
		if (n.width === 0 || n.height === 0) return;
		let r = (e.clientX - n.left) / n.width * yw, i = (e.clientY - n.top) / n.height * 820, a = e.deltaY < 0 ? 1.12 : .89;
		ue((e) => {
			let t = nT(e.scale * a), n = (r - e.offsetX) / e.scale, o = (i - e.offsetY) / e.scale;
			return {
				scale: t,
				offsetX: r - n * t,
				offsetY: i - o * t,
				rotation: e.rotation
			};
		});
	}, rt = () => {
		if (ae) {
			ye.current?.fitNodesInView?.(G.nodes.length > 0 ? G.nodes.map((e) => e.id) : void 0);
			return;
		}
		if (G.nodes.length === 0) {
			ue(bw);
			return;
		}
		let e = Infinity, t = -Infinity, n = Infinity, r = -Infinity;
		for (let i of G.nodes) e = Math.min(e, i.x), t = Math.max(t, i.x), n = Math.min(n, i.y), r = Math.max(r, i.y);
		let i = Math.max(160, t - e), a = Math.max(160, r - n), o = yw / (i + 104), s = 820 / (a + 104), c = nT(Math.min(o, s)), l = (e + t) / 2, u = (n + r) / 2;
		ue((e) => ({
			scale: c,
			offsetX: yw / 2 - l * c,
			offsetY: 820 / 2 - u * c,
			rotation: e.rotation
		}));
	}, it = () => {
		let e = B ? G.nodesById.get(B) ?? null : null;
		if (e) {
			if (ae) {
				ye.current?.centerGraph?.([e.id]);
				return;
			}
			ue((t) => ({
				...t,
				offsetX: yw / 2 - e.x * t.scale,
				offsetY: 820 / 2 - e.y * t.scale
			}));
		}
	}, at = () => {
		ae && ye.current?.resetControls?.(!0), ue(bw);
	}, ot = (e) => {
		ne(e), e === "force3d" && ie((e) => e === "pan" ? "rotate" : e);
	}, st = () => {
		fe(Object.fromEntries(o.map((e) => [e, !0])));
	}, ct = () => {
		fe(Object.fromEntries(o.map((e) => [e, !1])));
	}, lt = (e, t) => {
		fe((n) => ({
			...n,
			...Object.fromEntries(e.map((e) => [e, t]))
		}));
	}, ut = () => {
		L("global"), F("compact"), rt();
	}, dt = () => {
		L("local"), F("full"), it();
	}, Y = (e) => {
		e.button === 0 && (e.preventDefault(), Se.current = {
			pointerId: e.pointerId,
			startClientX: e.clientX,
			startClientY: e.clientY,
			startOffsetX: le.offsetX,
			startOffsetY: le.offsetY,
			startRotation: le.rotation,
			moved: !1
		}, xe(!0), typeof e.currentTarget.setPointerCapture == "function" && e.currentTarget.setPointerCapture(e.pointerId));
	}, ft = (e) => {
		let t = Se.current, n = ve.current;
		if (!t || !n || t.pointerId !== e.pointerId) return;
		let r = n.getBoundingClientRect();
		if (r.width === 0 || r.height === 0) return;
		let i = (e.clientX - t.startClientX) / r.width * yw, a = (e.clientY - t.startClientY) / r.height * 820;
		if ((Math.abs(i) > 2 || Math.abs(a) > 2) && (t.moved = !0, Ce.current = !0), !ae && re !== "pan") {
			let n = t.startRotation + (e.clientX - t.startClientX) / r.width * 180;
			ue((e) => ({
				...e,
				rotation: rT(n)
			}));
			return;
		}
		ue((e) => ({
			...e,
			offsetX: t.startOffsetX + i,
			offsetY: t.startOffsetY + a
		}));
	}, pt = (e) => {
		let t = Se.current;
		!t || t.pointerId !== e.pointerId || (Se.current = null, xe(!1), typeof e.currentTarget.hasPointerCapture == "function" && e.currentTarget.hasPointerCapture(e.pointerId) && e.currentTarget.releasePointerCapture(e.pointerId));
	}, mt = et ? "flex max-h-none flex-col gap-2 overflow-visible rounded-[22px] border border-transparent bg-transparent p-0 shadow-none" : "flex max-h-none flex-col gap-2 overflow-visible rounded-[28px] border border-white/10 bg-[rgba(5,9,19,0.78)] p-3 shadow-[0_18px_60px_rgba(3,7,18,0.28)] backdrop-blur-xl xl:sticky xl:top-4 xl:max-h-[calc(100vh-2rem)] xl:overflow-auto", ht = (e) => {
		me((t) => ({
			...t,
			[e]: !t[e]
		}));
	}, gt = (e, t, n, r, i = {}) => {
		let a = pe[e], o = a ? uo : ho, s = `${S}-menu-section-${e}-content`;
		return /* @__PURE__ */ v("section", {
			className: "overflow-hidden rounded-[18px] border border-white/10 bg-[rgba(15,23,42,0.74)] shadow-[inset_0_1px_0_rgba(255,255,255,0.04)] backdrop-blur-xl",
			"data-testid": `${S}-menu-section-${e}`,
			children: [/* @__PURE__ */ v("button", {
				type: "button",
				onClick: () => ht(e),
				"aria-expanded": a,
				"aria-controls": s,
				className: "flex w-full min-w-0 items-center justify-between gap-3 px-3 py-2.5 text-left transition hover:bg-white/6",
				"data-testid": `${S}-menu-section-${e}-toggle`,
				children: [/* @__PURE__ */ v("span", {
					className: "min-w-0",
					children: [/* @__PURE__ */ _("span", {
						className: "block truncate text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-200",
						children: t
					}), /* @__PURE__ */ _("span", {
						className: "mt-1 block truncate text-[11px] text-slate-500",
						children: n
					})]
				}), /* @__PURE__ */ v("span", {
					className: "flex shrink-0 items-center gap-2",
					children: [i.badge, /* @__PURE__ */ _(o, {
						className: "h-4 w-4 text-slate-400",
						"aria-hidden": "true"
					})]
				})]
			}), a ? /* @__PURE__ */ _("div", {
				id: s,
				className: i.contentClassName ?? "border-t border-white/10 px-3 py-3",
				"data-testid": s,
				children: r
			}) : null]
		});
	}, _t = (e, t) => e.length === 0 ? /* @__PURE__ */ _("span", {
		className: "text-slate-500",
		children: t
	}) : e.map((e, t) => /* @__PURE__ */ v(n.Fragment, { children: [t > 0 ? /* @__PURE__ */ _("span", {
		className: "text-slate-400",
		children: ","
	}) : null, /* @__PURE__ */ _("button", {
		type: "button",
		onClick: () => V(e.id),
		className: "border-b border-dotted border-slate-500 text-slate-900 transition hover:border-slate-950 hover:text-cyan-800",
		children: Hw(e, s)
	})] }, e.id)), vt = () => {
		if (!K || !Je) return /* @__PURE__ */ _("aside", {
			className: "pointer-events-none absolute inset-x-3 bottom-3 z-20",
			"aria-live": "polite",
			"data-testid": `${S}-details-footer`,
			children: /* @__PURE__ */ v("div", {
				className: "pointer-events-auto rounded-lg border border-slate-950/10 bg-white/72 px-4 py-3 font-serif text-[12px] leading-5 text-slate-800 shadow-[0_18px_44px_rgba(15,23,42,0.18)] backdrop-blur-xl",
				children: [/* @__PURE__ */ _("span", {
					className: "mr-2 font-sans text-[10px] font-bold uppercase tracking-[0.22em] text-slate-500",
					children: "Table note"
				}), /* @__PURE__ */ v("span", { children: [
					"No node selected. Current view: ",
					G.nodes.length,
					" nodes, ",
					G.edges.length,
					" relationships, ",
					Ke.label.toLowerCase(),
					" evidence lens."
				] })]
			})
		});
		let e = Bw(K), t = Vw(K, s), n = _w(K, U), r = fw[qw(K, U)], i = e ? K.redactionReason ?? "Restricted evidence is hidden for this shared view." : K.statusReason, a = e ? null : Xw(K.owner, K.ownerEmail), o = e ? null : Xw(K.steward, K.stewardEmail), c = e ? null : Zw(K.description), l = e ? null : Zw(K.domain), u = e ? [] : tT(K.profile), d = Gw(K, s), f = Kw(K, s, d) ?? Je, p = Jw(t), m = Jw(r.label);
		return /* @__PURE__ */ _("aside", {
			className: "pointer-events-none absolute inset-x-3 bottom-3 z-20",
			"aria-live": "polite",
			"data-testid": `${S}-details-footer`,
			children: /* @__PURE__ */ v("div", {
				className: "pointer-events-auto max-h-[34vh] overflow-y-auto rounded-lg border border-slate-950/10 bg-white/78 px-4 py-3 text-slate-900 shadow-[0_18px_44px_rgba(15,23,42,0.2)] backdrop-blur-xl",
				"data-testid": `${S}-inspector`,
				children: [
					/* @__PURE__ */ v("div", {
						className: "grid min-w-0 grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)_minmax(0,1fr)] items-baseline gap-3 border-b border-slate-950/10 pb-2",
						"data-testid": `${S}-inspector-header`,
						children: [
							/* @__PURE__ */ v("span", {
								className: "min-w-0 truncate text-left font-sans text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-700",
								"data-testid": `${S}-inspector-node-heading`,
								title: `Node: ${d}`,
								children: [
									"Node:",
									" ",
									/* @__PURE__ */ _("strong", {
										className: "font-serif text-[14px] font-semibold normal-case tracking-normal text-slate-950",
										children: d
									})
								]
							}),
							/* @__PURE__ */ _("span", {
								className: "min-w-0 truncate text-center font-serif text-[14px] font-semibold text-slate-950",
								"data-testid": `${S}-inspector-name-heading`,
								title: f,
								children: f
							}),
							/* @__PURE__ */ v("span", {
								className: "min-w-0 truncate text-right font-sans text-[11px] font-semibold uppercase tracking-[0.14em]",
								style: { color: s[K.type]?.accent ?? "#334155" },
								"data-testid": `${S}-inspector-type-heading`,
								title: `${p} (${m})`,
								children: [
									/* @__PURE__ */ _("strong", {
										className: "font-semibold",
										children: p
									}),
									" ",
									/* @__PURE__ */ v("span", {
										style: { color: r.color },
										"data-testid": `${S}-inspector-overlay-status`,
										children: [
											"(",
											m,
											")"
										]
									})
								]
							})
						]
					}),
					a || o || l ? /* @__PURE__ */ v("div", {
						className: "mt-2 flex flex-wrap gap-x-4 gap-y-1 font-sans text-[11px] font-semibold uppercase tracking-[0.12em] text-slate-600",
						children: [
							a ? /* @__PURE__ */ v("span", {
								"data-testid": `${S}-inspector-owner`,
								children: [
									"Owner:",
									" ",
									/* @__PURE__ */ _("strong", {
										className: "font-semibold normal-case tracking-normal text-slate-950",
										children: a
									})
								]
							}) : null,
							o ? /* @__PURE__ */ v("span", {
								"data-testid": `${S}-inspector-steward`,
								children: [
									"Steward:",
									" ",
									/* @__PURE__ */ _("strong", {
										className: "font-semibold normal-case tracking-normal text-slate-950",
										children: o
									})
								]
							}) : null,
							l ? /* @__PURE__ */ v("span", {
								"data-testid": `${S}-inspector-domain`,
								children: [
									"Domain:",
									" ",
									/* @__PURE__ */ _("strong", {
										className: "font-semibold normal-case tracking-normal text-slate-950",
										children: l
									})
								]
							}) : null
						]
					}) : null,
					c ? /* @__PURE__ */ v("p", {
						className: "mt-2 font-serif text-[12.5px] leading-5 text-slate-900",
						"data-testid": `${S}-inspector-description`,
						children: [
							/* @__PURE__ */ _("em", {
								className: "font-semibold text-slate-950",
								children: "Description:"
							}),
							" ",
							c
						]
					}) : null,
					u.length > 0 ? /* @__PURE__ */ v("p", {
						className: "mt-2 font-serif text-[12.5px] leading-5 text-slate-900",
						"data-testid": `${S}-inspector-profile`,
						children: [
							/* @__PURE__ */ _("em", {
								className: "font-semibold text-slate-950",
								children: "Profile:"
							}),
							" ",
							u.join(". "),
							"."
						]
					}) : null,
					/* @__PURE__ */ v("p", {
						className: "mt-2 font-serif text-[12.5px] leading-5 text-slate-900",
						children: [
							/* @__PURE__ */ _("em", {
								className: "font-semibold text-slate-950",
								children: "Details."
							}),
							" ",
							/* @__PURE__ */ _("span", {
								className: "italic",
								children: d
							}),
							" is a ",
							t,
							" node with degree ",
							K.degree,
							", including ",
							K.inbound,
							" incoming and ",
							K.outbound,
							" outgoing visible relationships under the ",
							Be.label.toLowerCase(),
							" layout.",
							" ",
							e ? /* @__PURE__ */ _("span", { children: i }) : /* @__PURE__ */ _(g, { children: K.line ? /* @__PURE__ */ v("span", { children: [
								"Line: ",
								K.line,
								". "
							] }) : null }),
							/* @__PURE__ */ _("em", {
								className: "font-semibold text-slate-950",
								children: " Evidence."
							}),
							" ",
							U === "type" ? `This lens is grouping by graph family, so the note reports the node as ${t}.` : hw(U, n),
							i && !e ? /* @__PURE__ */ v("span", { children: [" ", /* @__PURE__ */ _("span", {
								className: "italic",
								children: i
							})] }) : null,
							K.statusUpdatedAt ? /* @__PURE__ */ v("span", { children: [
								" Updated: ",
								new Date(K.statusUpdatedAt).toLocaleDateString(),
								"."
							] }) : null
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-2 flex flex-wrap gap-x-3 gap-y-1 border-t border-slate-950/10 pt-2 font-serif text-[11.5px] leading-5 text-slate-700",
						children: [/* @__PURE__ */ v("span", { children: [
							/* @__PURE__ */ _("em", {
								className: "text-slate-950",
								children: "Incoming"
							}),
							" ",
							_t(Oe.incoming, "no visible incoming links")
						] }), /* @__PURE__ */ v("span", { children: [
							/* @__PURE__ */ _("em", {
								className: "text-slate-950",
								children: "Outgoing"
							}),
							" ",
							_t(Oe.outgoing, "no visible outgoing links")
						] })]
					}),
					Bw(K) ? /* @__PURE__ */ _("div", {
						className: "mt-2 border-t border-slate-950/10 pt-2 font-serif text-[11.5px] italic leading-5 text-slate-600",
						children: "Route actions are redacted for this node until the recipient has permission."
					}) : w ? /* @__PURE__ */ _("div", {
						className: "mt-2 border-t border-slate-950/10 pt-2",
						children: w(K)
					}) : null
				]
			})
		});
	}, yt = /* @__PURE__ */ v("div", {
		className: mt,
		"aria-label": `${t} options`,
		"data-testid": `${S}-side-menu`,
		children: [
			gt("workflow", "Find & Focus", B ? `Pinned: ${Te ? Hw(Te, s) : qe ?? "selected node"}` : We, /* @__PURE__ */ v("div", {
				className: "grid gap-2",
				children: [
					/* @__PURE__ */ v("label", {
						className: "grid gap-2 rounded-[16px] border border-cyan-300/25 bg-[linear-gradient(135deg,rgba(8,145,178,0.12),rgba(15,23,42,0.54))] px-3 py-3 shadow-[0_18px_42px_rgba(8,47,73,0.16)]",
						children: [
							/* @__PURE__ */ _("span", {
								className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-cyan-100",
								children: "Search"
							}),
							/* @__PURE__ */ _("input", {
								value: M,
								onChange: (e) => N(e.target.value),
								placeholder: i,
								className: "min-w-0 rounded-2xl border border-white/10 bg-slate-950/45 px-4 py-3 text-sm text-white outline-none transition placeholder:text-slate-500 focus:border-cyan-300/45 focus:bg-slate-950/65",
								"data-testid": `${S}-search`
							}),
							M.trim() ? /* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => N(""),
								className: "justify-self-start rounded-full border border-white/10 bg-slate-950/35 px-3 py-1.5 text-xs font-medium text-slate-300 transition hover:border-white/20 hover:text-white",
								"data-testid": `${S}-clear-search`,
								children: "Clear search"
							}) : null
						]
					}),
					/* @__PURE__ */ _("div", {
						className: "grid grid-cols-2 gap-2",
						children: Cw.map((e) => {
							let t = e.id === "find" ? I === "global" && P === "compact" : I === "local" && P === "full", n = e.id === "inspect" && !B;
							return /* @__PURE__ */ v("button", {
								type: "button",
								onClick: e.id === "find" ? ut : dt,
								disabled: n,
								className: `rounded-[16px] border px-3 py-3 text-left transition ${n ? "cursor-not-allowed border-white/10 bg-white/5 text-slate-500" : t ? "border-cyan-300/45 bg-cyan-100/90 text-slate-950 shadow-[0_16px_40px_rgba(8,47,73,0.22)]" : "border-white/10 bg-[linear-gradient(180deg,rgba(15,23,42,0.46),rgba(2,6,23,0.32))] text-slate-200 hover:border-white/20 hover:text-white"}`,
								"data-testid": `${S}-workflow-${e.id}`,
								children: [/* @__PURE__ */ _("span", {
									className: "block text-[10px] font-semibold uppercase tracking-[0.18em] opacity-70",
									children: e.combo
								}), /* @__PURE__ */ _("span", {
									className: "mt-1 block text-sm font-semibold",
									children: e.id === "find" ? "Overview" : "Inspect"
								})]
							}, e.id);
						})
					}),
					/* @__PURE__ */ v("div", {
						className: "grid gap-2 rounded-[16px] border border-white/8 bg-slate-950/25 px-3 py-3",
						children: [
							/* @__PURE__ */ _("div", {
								className: "inline-flex rounded-full border border-white/10 bg-slate-950/45 p-1",
								children: ["global", "local"].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => L(e),
									className: `flex-1 rounded-full px-3 py-2 text-sm font-medium capitalize transition ${I === e ? "bg-white text-slate-950" : "text-slate-400 hover:text-white"}`,
									"data-testid": `${S}-scope-${e}`,
									children: e
								}, e))
							}),
							/* @__PURE__ */ _("div", {
								className: "inline-flex rounded-full border border-white/10 bg-slate-950/45 p-1",
								children: ["compact", "full"].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => F(e),
									className: `flex-1 rounded-full px-3 py-2 text-sm font-medium capitalize transition ${P === e ? "bg-white text-slate-950" : "text-slate-400 hover:text-white"}`,
									"data-testid": `${S}-view-${e}`,
									children: e
								}, e))
							}),
							I === "local" ? /* @__PURE__ */ v("label", {
								className: "flex items-center gap-3 rounded-full border border-cyan-200/20 bg-cyan-100/10 px-4 py-2 text-sm text-cyan-50 shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]",
								children: [
									/* @__PURE__ */ _("span", {
										className: "uppercase tracking-[0.18em] text-cyan-100",
										children: "Depth"
									}),
									/* @__PURE__ */ _("input", {
										type: "range",
										min: "1",
										max: "4",
										step: "1",
										value: R,
										onChange: (e) => z(Number(e.target.value)),
										className: "w-full accent-cyan-300",
										"data-testid": `${S}-local-depth`
									}),
									/* @__PURE__ */ _("span", {
										className: "w-6 text-center font-semibold text-cyan-50",
										children: R
									})
								]
							}) : null,
							/* @__PURE__ */ v("div", {
								className: "grid grid-cols-2 gap-2",
								children: [/* @__PURE__ */ _("button", {
									type: "button",
									onClick: rt,
									className: "rounded-full border border-white/10 bg-slate-950/35 px-3 py-2 text-sm font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10",
									"data-testid": `${S}-menu-fit`,
									children: "Fit"
								}), /* @__PURE__ */ _("button", {
									type: "button",
									onClick: it,
									disabled: !B,
									className: "rounded-full border border-white/10 bg-slate-950/35 px-3 py-2 text-sm font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-40",
									"data-testid": `${S}-menu-center`,
									children: "Center"
								})]
							}),
							/* @__PURE__ */ _("div", {
								className: "rounded-2xl border border-white/10 bg-slate-950/25 px-3 py-2 text-sm text-slate-300",
								"data-testid": `${S}-focus-summary`,
								children: We
							})
						]
					}),
					De ? /* @__PURE__ */ v("div", {
						className: "rounded-[16px] border border-amber-200/20 bg-amber-300/10 px-3 py-2 text-xs font-semibold uppercase tracking-[0.16em] text-amber-100",
						"data-testid": `${S}-path-preview`,
						children: [
							"Path: ",
							De.nodeNames.join(" -> "),
							" • ",
							De.hopCount,
							" ",
							De.hopCount === 1 ? "hop" : "hops"
						]
					}) : null
				]
			})),
			gt("overlays", "Evidence", U === "type" ? "Entity colors" : `${Ke.label} Status`, /* @__PURE__ */ v("div", {
				className: "grid gap-3 rounded-2xl border border-white/8 bg-[linear-gradient(180deg,rgba(15,23,42,0.42)_0%,rgba(2,6,23,0.28)_100%)] px-3 py-3",
				"data-testid": `${S}-overlay-controls`,
				children: [
					/* @__PURE__ */ _("div", {
						className: "flex flex-wrap items-center gap-2",
						children: dw.map((e) => {
							let t = U === e.id;
							return /* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => te(e.id),
								title: `${e.tooltip} ${e.example}`,
								className: `rounded-full border px-3 py-2 text-sm font-medium transition ${t ? "border-cyan-200/45 bg-cyan-100 text-slate-950" : "border-white/10 bg-transparent text-slate-400 hover:border-white/20 hover:bg-white/6 hover:text-white"}`,
								"data-testid": `${S}-overlay-${e.id}`,
								children: e.label
							}, e.id);
						})
					}),
					/* @__PURE__ */ v("p", {
						className: "text-xs leading-5 text-slate-400",
						"data-testid": `${S}-overlay-help`,
						children: [
							Ke.tooltip,
							" ",
							/* @__PURE__ */ _("span", {
								className: "text-slate-500",
								children: Ke.example
							})
						]
					}),
					U === "type" ? null : /* @__PURE__ */ _("div", {
						className: "grid grid-cols-2 gap-2",
						children: Tw.map((e) => {
							let t = fw[e], n = Ze[e], r = e === "not-scanned" && n > 0;
							return /* @__PURE__ */ v("span", {
								title: hw(U, e),
								className: `inline-flex items-center gap-2 rounded-full border px-2.5 py-1 text-xs text-slate-300 ${r ? "animate-pulse border-slate-200/35 bg-slate-100/10 ring-1 ring-slate-200/30" : "border-white/10 bg-slate-950/35"}`,
								"data-testid": `${S}-overlay-status-${e}`,
								children: [
									/* @__PURE__ */ _("span", {
										className: "h-2 w-2 rounded-full",
										style: { backgroundColor: t.color }
									}),
									t.label,
									/* @__PURE__ */ _("span", {
										className: "ml-auto text-slate-500",
										children: n
									})
								]
							}, e);
						})
					}),
					U !== "type" && $e > 0 && Qe ? /* @__PURE__ */ v("div", {
						className: "rounded-[16px] border border-slate-200/15 bg-slate-50/8 px-3 py-3 text-xs leading-5 text-slate-300",
						"data-testid": `${S}-overlay-not-scanned-action`,
						children: [/* @__PURE__ */ v("p", { children: [
							/* @__PURE__ */ _("span", {
								className: "font-semibold text-slate-100",
								children: "Action needed."
							}),
							" ",
							$e,
							" ",
							$e === 1 ? "node has" : "nodes have",
							" no ",
							Ke.label.toLowerCase(),
							" evidence yet.",
							" ",
							Qe.prompt
						] }), /* @__PURE__ */ v("div", {
							className: "mt-2 flex flex-wrap gap-2",
							children: [/* @__PURE__ */ _("a", {
								href: Qe.primaryHref,
								className: "rounded-full bg-cyan-200 px-3 py-1.5 text-xs font-semibold text-slate-950 transition hover:bg-cyan-100",
								children: Qe.primaryLabel
							}), /* @__PURE__ */ _("a", {
								href: Qe.secondaryHref,
								className: "rounded-full border border-white/10 px-3 py-1.5 text-xs font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10",
								children: Qe.secondaryLabel
							})]
						})]
					}) : null,
					U === "governance" && Ze.watch > 0 ? /* @__PURE__ */ _("p", {
						className: "rounded-[16px] border border-amber-200/20 bg-amber-200/10 px-3 py-2 text-xs leading-5 text-amber-50",
						"data-testid": `${S}-overlay-governance-watch-note`,
						children: "Watch is the Governance Score attention state: review ownership, stewardship, policy, contract, or SLA evidence before it becomes a failure."
					}) : null
				]
			})),
			gt("layers", "Layers", ze, /* @__PURE__ */ v("div", {
				className: "rounded-2xl border border-white/8 bg-[linear-gradient(180deg,rgba(15,23,42,0.42)_0%,rgba(2,6,23,0.28)_100%)] px-3 py-3",
				children: [
					/* @__PURE__ */ v("div", {
						className: "flex flex-wrap items-center justify-between gap-2",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400",
							children: "Source Layers"
						}), /* @__PURE__ */ v("div", {
							className: "flex items-center gap-2",
							children: [/* @__PURE__ */ _("button", {
								type: "button",
								onClick: st,
								className: "rounded-full border border-white/10 bg-slate-950/35 px-2.5 py-1 text-xs font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10",
								"data-testid": `${S}-layers-all`,
								children: "All"
							}), /* @__PURE__ */ _("button", {
								type: "button",
								onClick: ct,
								className: "rounded-full border border-white/10 bg-transparent px-2.5 py-1 text-xs font-medium text-slate-400 transition hover:border-white/20 hover:text-white",
								"data-testid": `${S}-layers-none`,
								children: "None"
							})]
						})]
					}),
					Le.length > 0 ? /* @__PURE__ */ _("div", {
						className: "mt-3 grid gap-2",
						children: Le.map((e) => {
							let t = e.active ? !0 : e.partial ? "mixed" : !1, n = !e.active, r = e.accent ?? s[e.types[0]]?.accent ?? "#38bdf8";
							return /* @__PURE__ */ v("button", {
								type: "button",
								onClick: () => lt(e.types, n),
								"aria-pressed": t,
								className: `flex min-w-0 items-center gap-3 rounded-[16px] border px-3 py-3 text-left transition ${e.active ? "border-cyan-200/35 bg-cyan-100/10 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.08)]" : e.partial ? "border-amber-200/25 bg-amber-200/8 text-slate-100" : "border-white/10 bg-slate-950/25 text-slate-400 hover:border-white/20 hover:bg-white/6 hover:text-white"}`,
								"data-testid": `${S}-layer-group-${e.id}`,
								children: [
									/* @__PURE__ */ _("span", {
										className: "h-3 w-3 shrink-0 rounded-full shadow-[0_0_16px_currentColor]",
										style: {
											color: r,
											backgroundColor: r
										}
									}),
									/* @__PURE__ */ v("span", {
										className: "min-w-0 flex-1",
										children: [
											/* @__PURE__ */ _("span", {
												className: "block text-sm font-semibold text-slate-100",
												children: e.label
											}),
											e.description ? /* @__PURE__ */ _("span", {
												className: "mt-1 block text-xs leading-5 text-slate-400",
												children: e.description
											}) : null,
											/* @__PURE__ */ v("span", {
												className: "mt-1 block text-[11px] font-medium uppercase tracking-[0.14em] text-slate-500",
												children: [
													e.enabledTypeCount,
													"/",
													e.types.length,
													" types • ",
													e.visibleNodeCount,
													"/",
													e.totalNodeCount,
													" nodes"
												]
											})
										]
									}),
									/* @__PURE__ */ _("span", {
										className: `relative h-5 w-9 shrink-0 rounded-full border transition ${e.active ? "border-cyan-200/60 bg-cyan-200/80" : e.partial ? "border-amber-200/50 bg-amber-200/35" : "border-white/15 bg-slate-950/60"}`,
										"aria-hidden": "true",
										children: /* @__PURE__ */ _("span", { className: `absolute top-1/2 h-3.5 w-3.5 -translate-y-1/2 rounded-full bg-white shadow transition ${e.active ? "translate-x-[18px]" : e.partial ? "translate-x-[10px]" : "translate-x-1"}` })
									})
								]
							}, e.id);
						})
					}) : null,
					/* @__PURE__ */ v("div", {
						className: `${Le.length > 0 ? "mt-3 border-t border-white/10 pt-3" : "mt-3"}`,
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400",
							children: "Node Types"
						}), /* @__PURE__ */ _("div", {
							className: "mt-2 flex flex-wrap items-center gap-2",
							children: o.map((e) => {
								let t = s[e], n = de[e], r = Pe.get(e);
								return /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => fe((t) => ({
										...t,
										[e]: !t[e]
									})),
									"aria-pressed": n,
									className: `group rounded-full border px-3 py-2 text-sm font-medium transition ${n ? "border-white/20 bg-white/12 text-white shadow-[inset_0_1px_0_rgba(255,255,255,0.1)]" : "border-white/10 bg-transparent text-slate-400 hover:border-white/20 hover:bg-white/6 hover:text-white"}`,
									"data-testid": `${S}-filter-${e.toLowerCase()}`,
									children: [
										/* @__PURE__ */ _("span", {
											className: "mr-2 inline-block h-2.5 w-2.5 rounded-full",
											style: { backgroundColor: t?.accent ?? "#fff" }
										}),
										t?.label ?? e,
										r ? /* @__PURE__ */ v("span", {
											className: "ml-2 text-xs opacity-70",
											children: [
												r.visibleCount,
												"/",
												r.totalCount
											]
										}) : null
									]
								}, e);
							})
						})]
					}),
					Object.keys(c).length > 0 ? /* @__PURE__ */ v("div", {
						className: "mt-3 border-t border-white/10 pt-3",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400",
							children: "Relationship Types"
						}), /* @__PURE__ */ _("div", {
							className: "mt-2 flex flex-wrap items-center gap-2",
							children: Object.entries(c).map(([e, t]) => {
								let n = a.edges.filter((t) => t.type === e).length;
								return /* @__PURE__ */ v("span", {
									className: "inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/6 px-3 py-1.5 text-xs font-medium text-slate-300",
									children: [
										/* @__PURE__ */ _("span", {
											className: "h-2.5 w-2.5 rounded-full",
											style: { backgroundColor: t.stroke }
										}),
										t.label,
										/* @__PURE__ */ _("span", {
											className: "text-slate-500",
											children: n
										})
									]
								}, e);
							})
						})]
					}) : null,
					C && C.length > 0 && Le.length === 0 ? /* @__PURE__ */ v("div", {
						className: "mt-3 border-t border-white/10 pt-3",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400",
							children: "Layer Notes"
						}), /* @__PURE__ */ _("div", {
							className: "mt-2 grid gap-2",
							children: C.map((e) => /* @__PURE__ */ v("div", {
								className: "rounded-[14px] border border-white/10 bg-slate-950/35 px-3 py-2 text-xs text-slate-300",
								children: [/* @__PURE__ */ _("span", {
									className: "block font-semibold text-slate-200",
									children: e.title
								}), /* @__PURE__ */ _("span", {
									className: "mt-1 block leading-5 text-slate-500",
									children: e.description
								})]
							}, e.title))
						})]
					}) : null
				]
			})),
			gt("view", "Layout", `${Be.label} • ${re}`, /* @__PURE__ */ v("div", {
				className: "grid gap-3 rounded-2xl border border-white/8 bg-slate-950/25 px-3 py-3",
				children: [
					/* @__PURE__ */ _("div", {
						className: "grid grid-cols-2 gap-2",
						children: xw.map((e) => {
							let t = W === e.id, n = e.tone === "3D" && !ae;
							return /* @__PURE__ */ v("button", {
								type: "button",
								onClick: () => ot(e.id),
								disabled: n,
								"aria-pressed": t,
								className: `rounded-[16px] border px-3 py-2.5 text-left transition ${n ? "cursor-not-allowed border-white/10 bg-white/5 text-slate-500" : t ? "border-cyan-200/45 bg-cyan-100 text-slate-950" : "border-white/10 bg-slate-950/35 text-slate-300 hover:border-white/20 hover:bg-white/6 hover:text-white"}`,
								"data-testid": `${S}-layout-${e.id}`,
								children: [/* @__PURE__ */ v("span", {
									className: "flex items-center justify-between gap-2 text-sm font-semibold",
									children: [e.label, /* @__PURE__ */ _("span", {
										className: "text-[10px] font-black uppercase opacity-60",
										children: e.tone
									})]
								}), /* @__PURE__ */ _("span", {
									className: "mt-1 block text-xs opacity-70",
									children: n ? "WebGL required" : e.description
								})]
							}, e.id);
						})
					}),
					/* @__PURE__ */ v("div", {
						className: "grid gap-2",
						children: [/* @__PURE__ */ v("div", {
							className: "flex items-center justify-between gap-2",
							children: [/* @__PURE__ */ _("span", {
								className: "text-[11px] font-semibold uppercase tracking-[0.22em] text-slate-400",
								children: "Camera"
							}), /* @__PURE__ */ _("span", {
								className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
								children: ae ? "Reagraph" : "SVG fallback"
							})]
						}), /* @__PURE__ */ _("div", {
							className: "inline-flex rounded-full border border-white/10 bg-slate-950/45 p-1",
							children: Sw.map((e) => {
								let t = re === e.id;
								return /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => ie(e.id),
									"aria-pressed": t,
									className: `flex-1 rounded-full px-3 py-2 text-sm font-medium transition ${t ? "bg-violet-100 text-slate-950" : "text-slate-400 hover:text-white"}`,
									"data-testid": `${S}-camera-${e.id}`,
									children: e.label
								}, e.id);
							})
						})]
					}),
					/* @__PURE__ */ _("button", {
						type: "button",
						onClick: at,
						className: "rounded-full border border-white/10 bg-slate-950/35 px-3 py-2 text-sm font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10",
						"data-testid": `${S}-reset-view`,
						children: "Reset view"
					})
				]
			})),
			gt("status", "Stats", `${G.nodes.length} nodes • ${G.edges.length} edges`, /* @__PURE__ */ v("div", {
				className: "grid grid-cols-2 gap-2 rounded-2xl border border-white/8 bg-[linear-gradient(180deg,rgba(15,23,42,0.48)_0%,rgba(2,6,23,0.3)_100%)] px-3 py-3",
				"data-testid": `${S}-mode-summary`,
				children: [
					/* @__PURE__ */ v("div", {
						className: "rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Visible"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 text-lg font-semibold text-white",
							children: Ew(G.nodes.length)
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Edges"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 text-lg font-semibold text-white",
							children: Ew(G.edges.length)
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Indexed"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 text-lg font-semibold text-white",
							children: Ew(a.meta?.fileCount ?? a.nodes.length)
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Renderer"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 text-sm font-semibold text-white",
							children: ae ? "WebGL" : "SVG"
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "col-span-2 rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Last updated"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 text-sm font-semibold text-white",
							"data-testid": `${S}-graph-updated-at`,
							children: Ye
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "col-span-2 rounded-2xl border border-white/10 bg-slate-950/35 px-3 py-2.5",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
							children: "Graph file"
						}), /* @__PURE__ */ _("div", {
							className: "mt-1 break-all text-sm font-semibold leading-5 text-white",
							"data-testid": `${S}-graph-source`,
							children: Xe
						})]
					}),
					/* @__PURE__ */ _("div", {
						className: "col-span-2 rounded-2xl border border-white/10 bg-slate-950/30 px-3 py-2 text-sm text-slate-300",
						children: We
					})
				]
			}))
		]
	}), bt = et ? "xl:grid-cols-1" : "xl:grid-cols-[380px_minmax(0,1fr)]", xt = O && !!et, St = xt ? `mx-auto grid h-full min-h-0 min-w-0 w-full max-w-[1880px] grid-cols-1 gap-1 overflow-hidden px-0 py-0 ${bt}` : `mx-auto grid w-full max-w-[1880px] grid-cols-1 gap-3 px-2 py-2 lg:px-3 ${bt}`, Ct = xt ? "grid h-full min-h-0 min-w-0 grid-rows-[minmax(0,1fr)] gap-2 overflow-hidden" : "grid min-h-[calc(100vh-2rem)] gap-3", wt = xt ? "min-h-0 min-w-0 overflow-hidden rounded-[28px] border border-white/10 bg-white/6 p-0 shadow-[0_18px_60px_rgba(3,7,18,0.35)] backdrop-blur" : "rounded-[28px] border border-white/10 bg-white/6 p-0 shadow-[0_18px_60px_rgba(3,7,18,0.35)] backdrop-blur", Tt = xt ? "relative h-full min-h-0 overflow-hidden overscroll-contain rounded-[24px] border border-white/10 bg-transparent" : "relative h-[calc(100vh-3.5rem)] min-h-[720px] overflow-hidden overscroll-contain rounded-[24px] border border-white/10 bg-transparent", Et = x ?? (xt ? "h-full min-h-0 overflow-hidden text-slate-100" : "min-h-full overflow-auto text-slate-100"), Dt = o.map((e) => s[e]?.label ?? e).join(", "), Ot = Le.map((e) => e.label).join(", "), kt = Object.values(c).map((e) => e.label).join(", "), At = Cw.map((e) => e.label).join(", ");
	return /* @__PURE__ */ v("div", {
		className: Et,
		children: [
			/* @__PURE__ */ v("div", {
				className: "sr-only",
				"data-testid": `${S}-semantic-heading`,
				children: [
					/* @__PURE__ */ _("h2", { children: t }),
					/* @__PURE__ */ _("p", { children: r }),
					Ot ? /* @__PURE__ */ v("p", { children: ["Graph layers: ", Ot] }) : null,
					/* @__PURE__ */ v("p", { children: ["Node types: ", Dt] }),
					/* @__PURE__ */ v("p", { children: ["Relationships: ", kt] }),
					/* @__PURE__ */ v("p", { children: ["Workflows: ", At] }),
					/* @__PURE__ */ _("p", { children: "local graph inspection is available." })
				]
			}),
			et ? b(yt, et) : null,
			/* @__PURE__ */ v("div", {
				className: St,
				"data-testid": `${S}-layout-grid`,
				children: [et ? null : yt, /* @__PURE__ */ _("div", {
					className: Ct,
					children: /* @__PURE__ */ _("section", {
						className: wt,
						"data-testid": `${S}-graph-frame`,
						children: /* @__PURE__ */ v("div", {
							className: Tt,
							"data-testid": `${S}-graph-canvas-frame`,
							children: [
								ae && Ve ? /* @__PURE__ */ v("div", {
									className: "h-full w-full",
									role: "img",
									"aria-label": "Graph explorer",
									"data-testid": `${S}-graph`,
									children: [
										/* @__PURE__ */ _(Ve, {
											ref: ye,
											nodes: je.nodes,
											edges: je.edges,
											theme: He,
											layoutType: Ue,
											cameraMode: re,
											animated: !1,
											draggable: !1,
											aggregateEdges: !0,
											labelType: "auto",
											edgeInterpolation: "curved",
											edgeArrowPosition: "end",
											edgeLabelPosition: "natural",
											lassoType: "node",
											selections: B ? [B] : [],
											actives: Me,
											sizingType: "attribute",
											sizingAttribute: "degree",
											minNodeSize: 7,
											maxNodeSize: 28,
											defaultNodeSize: 10,
											clusterAttribute: q,
											onNodeClick: (e) => V((t) => t === e.id ? null : e.id),
											onNodePointerOver: (e) => ee(e.id),
											onNodePointerOut: (e) => ee((t) => t === e.id ? null : t),
											onCanvasClick: () => ee(null),
											onLassoEnd: (e) => {
												e.length > 0 && V(e[0]);
											}
										}),
										/* @__PURE__ */ v("div", {
											className: "pointer-events-none absolute left-3 top-3 z-10 rounded-2xl border border-cyan-200/20 bg-[rgba(5,9,19,0.78)] px-3 py-2 shadow-[0_12px_30px_rgba(0,0,0,0.24)] backdrop-blur-xl",
											children: [/* @__PURE__ */ _("div", {
												className: "text-[11px] font-semibold uppercase tracking-[0.2em] text-cyan-100",
												children: "Reagraph WebGL"
											}), /* @__PURE__ */ v("div", {
												className: "mt-1 text-xs text-slate-400",
												children: [
													Be.label,
													" • ",
													re,
													" camera • lasso selection"
												]
											})]
										}),
										/* @__PURE__ */ _("div", {
											className: "sr-only",
											"aria-label": "Graph node index",
											children: G.nodes.map((e) => /* @__PURE__ */ _("button", {
												type: "button",
												"data-testid": `${S}-node-${aT(e.id)}`,
												onClick: () => V((t) => t === e.id ? null : e.id),
												onMouseOver: () => ee(e.id),
												onFocus: () => ee(e.id),
												children: Hw(e, s)
											}, e.id))
										})
									]
								}) : /* @__PURE__ */ v("svg", {
									ref: ve,
									viewBox: `0 0 ${yw} 820`,
									className: "block h-full w-full",
									role: "img",
									"aria-label": "Graph explorer",
									"data-testid": `${S}-graph`,
									"data-camera-mode": re,
									onWheel: nt,
									onPointerDown: Y,
									onPointerMove: ft,
									onPointerUp: pt,
									onPointerCancel: pt,
									style: {
										cursor: be ? "grabbing" : "grab",
										touchAction: "none"
									},
									children: [
										/* @__PURE__ */ _("defs", { children: /* @__PURE__ */ v("radialGradient", {
											id: "graphExplorerGlow",
											cx: "50%",
											cy: "50%",
											r: "70%",
											children: [/* @__PURE__ */ _("stop", {
												offset: "0%",
												stopColor: "rgba(56, 189, 248, 0.18)"
											}), /* @__PURE__ */ _("stop", {
												offset: "100%",
												stopColor: "rgba(56, 189, 248, 0)"
											})]
										}) }),
										/* @__PURE__ */ _("rect", {
											x: "0",
											y: "0",
											width: yw,
											height: 820,
											fill: "url(#graphExplorerGlow)"
										}),
										/* @__PURE__ */ v("g", {
											transform: iT(le),
											children: [
												W === "cluster" ? o.map((e) => {
													let t = J[e], n = s[e];
													return /* @__PURE__ */ _("g", { children: /* @__PURE__ */ _("circle", {
														cx: t.x,
														cy: t.y,
														r: "110",
														fill: n?.surface ?? "rgba(255,255,255,0.08)"
													}) }, e);
												}) : null,
												G.edges.map((e, t) => {
													let n = G.nodesById.get(e.source), r = G.nodesById.get(e.target);
													if (!n || !r) return null;
													let i = uT(e), a = De?.edgeIds.has(i) ?? !1, o = ke.has(i), s = Ge && !Ae?.edgeIds.has(i) && !a, l = pT(e, c);
													return /* @__PURE__ */ _("path", {
														d: Dw(n, r),
														fill: "none",
														stroke: l,
														strokeWidth: a ? 3.8 : o ? 3.1 : s ? 1 : 1.6,
														opacity: a ? 1 : o ? .98 : s ? .1 : .54,
														strokeDasharray: a ? "9 7" : o ? "11 8" : void 0,
														strokeLinecap: "round",
														strokeLinejoin: "round",
														"data-edge-source": e.source,
														"data-edge-target": e.target,
														"data-edge-type": e.type,
														children: a || o ? /* @__PURE__ */ _("animate", {
															attributeName: "stroke-dashoffset",
															from: "0",
															to: "-32",
															dur: a ? "1.8s" : "2.6s",
															repeatCount: "indefinite"
														}) : null
													}, `${e.source}-${e.target}-${e.type}-${t}`);
												}),
												G.nodes.map((e) => {
													let t = e.id === B, n = e.id === he, r = De?.nodeIds.has(e.id) ?? !1, i = (Ae?.nodeIds.has(e.id) ?? !1) || r, a = Ge && !i, o = vw(e, U, s[e.type]?.accent), c = _w(e, U), l = e.type.toLowerCase(), u = Hw(e, s), d = e.id === H, f = l.includes("subsystem") || l.includes("project") ? 9.4 : l.includes("task") || l.includes("doc") ? 8.4 : l.includes("action") ? 6.2 : l.includes("file") ? 8 : 6.8;
													return /* @__PURE__ */ v("g", {
														transform: `translate(${e.x}, ${e.y})`,
														"data-testid": `${S}-node-${aT(e.id)}`,
														onClick: () => {
															if (Ce.current) {
																Ce.current = !1;
																return;
															}
															V((t) => t === e.id ? null : e.id);
														},
														onMouseEnter: () => ee(e.id),
														onMouseLeave: () => ee((t) => t === e.id ? null : t),
														className: "cursor-pointer",
														children: [
															r ? /* @__PURE__ */ _("circle", {
																r: n ? 28 : 24,
																fill: "none",
																stroke: o,
																strokeWidth: "2"
															}) : null,
															t || n ? /* @__PURE__ */ _("circle", {
																r: n ? 24 : 22,
																fill: s[e.type]?.surface ?? "rgba(255,255,255,0.08)",
																stroke: n ? "rgba(255,255,255,0.34)" : "rgba(255,255,255,0.18)"
															}) : null,
															/* @__PURE__ */ _("circle", {
																r: f,
																fill: o,
																fillOpacity: a ? .16 : n ? 1 : i ? .95 : .82,
																stroke: r ? o : t || n ? "white" : i ? "rgba(255,255,255,0.45)" : "rgba(255,255,255,0.18)",
																strokeWidth: r ? 2.4 : t || n ? 2.2 : i ? 1.2 : 1
															}),
															U === "type" ? null : /* @__PURE__ */ _("circle", {
																r: f + 4,
																fill: "none",
																stroke: fw[c].color,
																strokeDasharray: c === "unknown" || c === "not-scanned" ? "3 3" : void 0,
																strokeOpacity: a ? .16 : .72,
																strokeWidth: "1.4"
															}),
															d ? /* @__PURE__ */ _("text", {
																x: "16",
																y: "-12",
																fill: "#000000",
																fontSize: "15",
																fontWeight: t ? 800 : 650,
																"data-testid": `${S}-node-label-${aT(e.id)}`,
																children: u
															}) : null
														]
													}, e.id);
												})
											]
										})
									]
								}),
								/* @__PURE__ */ _("div", {
									className: "pointer-events-none absolute right-3 top-3 z-10",
									children: /* @__PURE__ */ v("div", {
										className: "pointer-events-auto flex items-center gap-2 rounded-2xl border border-white/10 bg-[rgba(5,9,19,0.82)] px-3 py-2 shadow-[0_12px_30px_rgba(0,0,0,0.28)] backdrop-blur-xl",
										children: [
											/* @__PURE__ */ _("span", {
												className: "min-w-[4.5rem] text-center text-xs font-semibold uppercase tracking-[0.18em] text-slate-300",
												children: ae ? "WebGL" : `${Math.round(le.scale * 100)}%`
											}),
											/* @__PURE__ */ _("button", {
												type: "button",
												onClick: rt,
												className: "rounded-full border border-white/10 px-3 py-1.5 text-xs font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10",
												"data-testid": `${S}-fit`,
												children: "Fit"
											}),
											/* @__PURE__ */ _("button", {
												type: "button",
												onClick: it,
												disabled: !B,
												className: "rounded-full border border-white/10 px-3 py-1.5 text-xs font-medium text-slate-200 transition hover:border-white/20 hover:bg-white/10 disabled:cursor-not-allowed disabled:opacity-40",
												"data-testid": `${S}-center`,
												children: "Center"
											})
										]
									})
								}),
								vt()
							]
						})
					})
				})]
			})
		]
	});
}
//#endregion
//#region src/panels/DataChatPanel/index.tsx
zm.register(Tg, kg, dh, $m, th, eg, bg, Zh);
var PT = D("DataChatPanel"), FT = [
	{
		name: "/table",
		description: "Analyze the current table"
	},
	{
		name: "/quality",
		description: "Check data quality"
	},
	{
		name: "/schema",
		description: "Show table schema"
	},
	{
		name: "/chart",
		description: "Generate a chart"
	},
	{
		name: "/summarize",
		description: "Summarize the dataset"
	}
];
function IT() {
	return typeof crypto < "u" && "randomUUID" in crypto ? crypto.randomUUID() : `msg-${Date.now()}-${Math.random().toString(36).slice(2)}`;
}
function LT(e) {
	let t = e.match(/```chart\n([\s\S]*?)```/);
	if (!t) return {
		text: e,
		chart: null
	};
	try {
		let n = JSON.parse(t[1]);
		return {
			text: e.replace(t[0], "").trim(),
			chart: n
		};
	} catch {
		return {
			text: e,
			chart: null
		};
	}
}
function RT() {
	if (typeof document > "u" || typeof HTMLCanvasElement > "u" || typeof navigator < "u" && /jsdom/i.test(navigator.userAgent)) return !1;
	try {
		let e = document.createElement("canvas");
		return typeof e.getContext == "function" && e.getContext("2d") !== null;
	} catch {
		return !1;
	}
}
function zT() {
	return `${X.baseUrl.replace(/\/$/, "")}/v1/llm/chat`;
}
async function BT(e) {
	try {
		let t = await e.json(), n = t.errors?.[0]?.message ?? (typeof t.error == "string" ? t.error : t.error?.message) ?? t.message;
		if (typeof n == "string" && n.trim()) return n;
	} catch {}
	return `HTTP ${e.status}`;
}
async function VT(e, t) {
	let n = er(), r = (e) => {
		let t = new Headers({ "Content-Type": "application/json" });
		return e && t.set("Authorization", `Bearer ${e}`), t;
	}, i = (n) => fetch(zT(), {
		method: "POST",
		headers: r(n),
		body: JSON.stringify(e),
		signal: t
	}), a = await i(n.getToken?.() ?? null);
	if (a.status === 401 && n.refreshToken) try {
		let e = await n.refreshToken({ force: !0 });
		e && (n.setToken?.(e), a = await i(e));
	} catch (e) {
		PT.warn("Chat auth refresh failed", e);
	}
	if (!a.ok || !a.body) throw Error(await BT(a));
	return a;
}
function HT(e) {
	return !!e?.activeRun?.version?.id;
}
function UT(e) {
	if (e) return HT(e) ? e.activeRun.table.name : e.tableName;
}
function WT(e) {
	if (e) return HT(e) ? typeof e.activeRun.source.id == "number" ? e.activeRun.source.id : void 0 : e.databaseId;
}
function GT(e) {
	let t = UT(e), n = WT(e);
	if (!e || !HT(e)) return t ? `You are a data analysis assistant. The user is working with table "${t}"${n ? ` in database ${n}` : ""}.` : "You are a data analysis assistant.";
	let r = {
		activeRun: {
			source: e.activeRun.source,
			table: e.activeRun.table,
			version: e.activeRun.version,
			queryText: e.activeRun.queryText,
			filters: e.activeRun.filters,
			sorts: e.activeRun.sorts,
			visibleColumns: e.activeRun.visibleColumns,
			previewRows: e.activeRun.previewRows,
			rowCount: e.activeRun.rowCount,
			sourceRowCount: e.activeRun.sourceRowCount,
			sampling: e.activeRun.sampling,
			execution: e.activeRun.execution,
			diffAgainstVersionId: e.activeRun.diffAgainstVersionId
		},
		relatedVersions: e.relatedVersions,
		draft: e.draft,
		attachments: e.attachments
	};
	return [
		"You are a data analysis assistant.",
		"Use the structured query context below as the source of truth for this conversation.",
		"If the context omits something, say it is unavailable instead of guessing.",
		`Structured query context:\n${JSON.stringify(r, null, 2)}`
	].join("\n\n");
}
function KT(e) {
	switch (e) {
		case "provider-reported": return "Provider reported";
		case "client-observed": return "Client observed";
		default: return "Inferred";
	}
}
var qT = ({ context: e, onClose: t, variant: n = "drawer" }) => {
	let [r, i] = h([]), [a, o] = h(""), [c, l] = h(!1), [d, f] = h(!1), [p, g] = h(""), y = m(null), b = m(null), x = m(null), S = RT(), C = UT(e), w = WT(e), T = HT(e) ? e : null;
	u(() => {
		typeof y.current?.scrollIntoView == "function" && y.current.scrollIntoView({ behavior: "smooth" });
	}, [r]);
	let E = (e) => {
		let t = e.target.value;
		o(t), t.startsWith("/") ? (g(t.slice(1).toLowerCase()), f(!0)) : f(!1);
	}, D = (e) => {
		o(e + " "), f(!1), b.current?.focus();
	}, O = s(async () => {
		let t = a.trim();
		if (!t || c) return;
		o(""), f(!1);
		let n = {
			id: IT(),
			role: "user",
			content: t
		}, s = IT(), u = {
			id: s,
			role: "assistant",
			content: "",
			streaming: !0
		};
		i((e) => [
			...e,
			n,
			u
		]), l(!0), x.current = new AbortController();
		let d = "", p = GT(e);
		try {
			let e = await VT({
				messages: [
					{
						role: "system",
						content: p
					},
					...r.filter((e) => !e.streaming).map((e) => ({
						role: e.role,
						content: e.content
					})),
					{
						role: "user",
						content: t
					}
				],
				stream: !0,
				aiContext: T ?? void 0
			}, x.current.signal);
			if (!e.body) throw Error("Streaming response body was unavailable.");
			let n = e.body.getReader(), a = new TextDecoder(), o = "";
			for (;;) {
				let { done: e, value: t } = await n.read();
				if (e) break;
				o += a.decode(t, { stream: !0 });
				let r = o.split("\n\n");
				o = r.pop() ?? "";
				for (let e of r) {
					let t = e.match(/^event:\s*(.+)$/m)?.[1]?.trim() ?? "message", n = e.split("\n").filter((e) => e.startsWith("data: ")).map((e) => e.slice(6)).join("\n").trim();
					if (!(!n || n === "[DONE]")) {
						if (t === "error") try {
							let e = JSON.parse(n);
							throw Error(e.error?.message ?? e.message ?? "Streaming request failed");
						} catch (e) {
							throw e instanceof Error ? e : /* @__PURE__ */ Error("Streaming request failed");
						}
						try {
							let e = JSON.parse(n), t = e.delta ?? e.content ?? "";
							t && (d += t, i((e) => e.map((e) => e.id === s ? {
								...e,
								content: d
							} : e)));
						} catch {}
					}
				}
			}
			let { text: c, chart: l } = LT(d);
			i((e) => e.map((e) => e.id === s ? {
				...e,
				content: c || d,
				streaming: !1,
				chartData: l ?? void 0
			} : e));
		} catch (e) {
			if (e instanceof Error && e.name === "AbortError") {
				let { text: e, chart: t } = LT(d);
				i((n) => n.map((n) => n.id === s ? {
					...n,
					content: e || d || "Response stopped.",
					streaming: !1,
					chartData: t ?? void 0
				} : n));
				return;
			}
			PT.error("Chat streaming error", e), i((t) => t.map((t) => t.id === s ? {
				...t,
				content: e instanceof Error && e.message ? e.message : "Sorry, something went wrong. Please try again.",
				streaming: !1
			} : t));
		} finally {
			l(!1), x.current = null;
		}
	}, [
		a,
		c,
		r,
		e
	]), k = (e) => {
		e.key === "Enter" && !e.shiftKey && (e.preventDefault(), O()), e.key === "Escape" && f(!1);
	}, A = () => {
		x.current?.abort();
	}, j = FT.filter((e) => e.name.slice(1).startsWith(p)), M = n === "embedded" ? "flex h-full min-h-0 flex-col bg-[linear-gradient(180deg,rgba(255,255,255,0.98),rgba(248,250,252,0.94))]" : "flex h-full flex-col border-l border-gray-200 bg-white", N = n === "embedded" ? "flex items-center justify-between shrink-0 border-b border-slate-200 px-4 py-3" : "flex items-center justify-between shrink-0 border-b border-gray-100 px-3 py-2", P = n === "embedded" ? "flex-1 min-h-0 overflow-y-auto px-4 py-4 space-y-3" : "flex-1 min-h-0 overflow-y-auto px-3 py-3 space-y-3", F = n === "embedded" ? "shrink-0 border-t border-slate-200 px-4 py-3 flex items-center gap-2" : "shrink-0 border-t border-gray-100 px-3 py-2 flex items-center gap-2";
	return /* @__PURE__ */ v("div", {
		className: `data-chat-shell ${M}`,
		"data-testid": "data-chat-panel",
		children: [
			/* @__PURE__ */ v("div", {
				className: `data-chat-header ${N}`,
				children: [/* @__PURE__ */ v("div", {
					className: "data-chat-title-row flex items-center gap-2",
					children: [
						/* @__PURE__ */ _($b, {
							className: "w-4 h-4 text-indigo-500",
							"aria-hidden": "true"
						}),
						/* @__PURE__ */ _("span", {
							className: "data-chat-title text-sm font-semibold text-gray-800",
							children: "AI Data Chat"
						}),
						C && /* @__PURE__ */ _("span", {
							className: "data-chat-pill data-chat-pill-muted text-xs text-gray-400 bg-gray-100 rounded px-1.5 py-0.5",
							children: C
						}),
						T ? /* @__PURE__ */ _("span", {
							className: "data-chat-pill data-chat-pill-accent text-xs text-indigo-600 bg-indigo-50 rounded px-1.5 py-0.5",
							children: T.activeRun.version.label
						}) : null
					]
				}), t && /* @__PURE__ */ _("button", {
					type: "button",
					onClick: t,
					className: "data-chat-close-button p-1 text-gray-400 hover:text-gray-600 rounded",
					"aria-label": "Close chat",
					"data-testid": "chat-close",
					children: /* @__PURE__ */ _(xs, { className: "w-4 h-4" })
				})]
			}),
			T ? /* @__PURE__ */ v("div", {
				className: "data-chat-context-summary shrink-0 border-b border-slate-200 bg-white/80 px-4 py-3",
				"data-testid": "chat-context-summary",
				children: [/* @__PURE__ */ v("div", {
					className: "data-chat-context-grid grid gap-3 sm:grid-cols-3",
					children: [
						/* @__PURE__ */ v("div", {
							className: "data-chat-context-card",
							children: [
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-label text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
									children: "Active run"
								}),
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-value mt-1 text-sm font-semibold text-slate-900",
									children: T.activeRun.version.label
								}),
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-meta text-xs text-slate-500",
									children: T.activeRun.source.label
								})
							]
						}),
						/* @__PURE__ */ v("div", {
							className: "data-chat-context-card",
							children: [
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-label text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
									children: "Query context"
								}),
								/* @__PURE__ */ v("div", {
									className: "data-chat-context-value mt-1 text-sm font-semibold text-slate-900",
									children: [
										T.activeRun.filters.length,
										" filter",
										T.activeRun.filters.length === 1 ? "" : "s"
									]
								}),
								/* @__PURE__ */ v("div", {
									className: "data-chat-context-meta text-xs text-slate-500",
									children: [
										T.activeRun.visibleColumns.length,
										" columns • ",
										T.activeRun.previewRows?.length ?? 0,
										" preview rows"
									]
								})
							]
						}),
						/* @__PURE__ */ v("div", {
							className: "data-chat-context-card",
							children: [
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-label text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
									children: "Performance"
								}),
								/* @__PURE__ */ _("div", {
									className: "data-chat-context-value mt-1 text-sm font-semibold text-slate-900",
									children: T.activeRun.execution.durationMs ? `${T.activeRun.execution.durationMs} ms` : "Timing pending"
								}),
								/* @__PURE__ */ v("div", {
									className: "data-chat-context-meta text-xs text-slate-500",
									children: [
										KT(T.activeRun.execution.collectionScope),
										" • ",
										T.activeRun.execution.cacheStatus ?? "unknown",
										" cache",
										T.relatedVersions.diffTargetVersionId ? ` • diff ${T.relatedVersions.diffTargetVersionId}` : ""
									]
								})
							]
						})
					]
				}), /* @__PURE__ */ _("div", {
					className: "data-chat-context-footnote mt-3 text-xs text-slate-500",
					children: T.draft?.hasUnappliedChanges ? "Draft is proposed state. AI grounding stays anchored to the executed active run." : "Draft matches the executed active run."
				})]
			}) : null,
			/* @__PURE__ */ v("div", {
				className: `data-chat-messages ${P}`,
				"data-testid": "chat-messages",
				children: [
					r.length === 0 && /* @__PURE__ */ v("div", {
						className: "data-chat-empty-state flex flex-col items-center justify-center h-full text-sm text-gray-400 gap-2 py-8",
						children: [
							/* @__PURE__ */ _($b, {
								className: "w-8 h-8 text-indigo-200",
								"aria-hidden": "true"
							}),
							/* @__PURE__ */ _("span", {
								className: "data-chat-empty-title",
								children: "Ask me anything about your data."
							}),
							T ? /* @__PURE__ */ v("div", {
								className: "data-chat-empty-meta text-xs text-slate-400",
								children: [
									"Grounded in ",
									T.activeRun.version.label,
									" for ",
									C,
									w ? ` • db ${w}` : ""
								]
							}) : null,
							/* @__PURE__ */ v("div", {
								className: "data-chat-empty-tip text-xs text-gray-300 mt-1",
								children: [
									"Tip: type",
									" ",
									/* @__PURE__ */ _("code", {
										className: "bg-gray-100 px-1 rounded text-gray-400",
										children: "/"
									}),
									" for commands"
								]
							})
						]
					}),
					r.map((e) => {
						let { text: t, chart: n } = LT(e.content), r = e.chartData ?? n, i = e.chartData ? e.content : t;
						return /* @__PURE__ */ _("div", {
							className: `data-chat-message-row flex ${e.role === "user" ? "justify-end" : "justify-start"}`,
							"data-testid": `chat-message-${e.role}`,
							children: /* @__PURE__ */ v("div", {
								className: `data-chat-message-bubble max-w-[85%] rounded-lg px-3 py-2 text-sm ${e.role === "user" ? "data-chat-message-user bg-indigo-600 text-white" : "data-chat-message-assistant bg-gray-50 border border-gray-200 text-gray-800"}`,
								children: [
									i && /* @__PURE__ */ _("p", {
										className: "data-chat-message-text whitespace-pre-wrap break-words",
										children: i
									}),
									e.streaming && !i && /* @__PURE__ */ _("span", {
										className: "data-chat-streaming-indicator inline-block w-2 h-4 bg-current opacity-70 animate-pulse",
										"aria-label": "Streaming"
									}),
									r && /* @__PURE__ */ v("div", {
										className: "data-chat-chart-shell mt-2 bg-white rounded p-2 border border-gray-100",
										style: { minHeight: 160 },
										children: [r.title && /* @__PURE__ */ _("div", {
											className: "data-chat-chart-title text-xs text-gray-500 mb-1 font-medium",
											children: r.title
										}), S ? r.type === "bar" ? /* @__PURE__ */ _(b_, {
											data: {
												labels: r.labels,
												datasets: r.datasets.map((e, t) => ({
													...e,
													backgroundColor: e.backgroundColor ?? `hsl(${t * 60 + 200}, 70%, 60%)`
												}))
											},
											options: {
												responsive: !0,
												plugins: { legend: { display: r.datasets.length > 1 } }
											}
										}) : /* @__PURE__ */ _(y_, {
											data: {
												labels: r.labels,
												datasets: r.datasets.map((e, t) => ({
													...e,
													backgroundColor: e.backgroundColor ?? `hsl(${t * 60 + 200}, 70%, 60%)`,
													borderColor: `hsl(${t * 60 + 200}, 70%, 50%)`
												}))
											},
											options: {
												responsive: !0,
												plugins: { legend: { display: r.datasets.length > 1 } }
											}
										}) : /* @__PURE__ */ v("div", {
											className: "rounded-md border border-dashed border-slate-200 bg-slate-50 px-3 py-2 text-xs text-slate-600",
											"data-testid": "chat-chart-fallback",
											children: [/* @__PURE__ */ _("div", {
												className: "font-semibold uppercase tracking-[0.14em] text-[10px] text-slate-500",
												children: "Chart Preview Unavailable"
											}), /* @__PURE__ */ _("div", {
												className: "mt-1",
												children: r.datasets.map((e) => /* @__PURE__ */ v("div", { children: [
													e.label,
													": ",
													e.data.join(", ")
												] }, e.label))
											})]
										})]
									})
								]
							})
						}, e.id);
					}),
					/* @__PURE__ */ _("div", { ref: y })
				]
			}),
			d && j.length > 0 && /* @__PURE__ */ _("div", {
				className: "data-chat-slash-menu shrink-0 border-t border-gray-100 bg-white",
				"data-testid": "slash-command-menu",
				children: j.map((e) => /* @__PURE__ */ v("button", {
					type: "button",
					className: "data-chat-slash-command flex w-full items-start gap-2 px-3 py-1.5 hover:bg-gray-50 text-left",
					onClick: () => D(e.name),
					children: [/* @__PURE__ */ _("span", {
						className: "data-chat-slash-command-name text-sm font-mono font-medium text-indigo-600",
						children: e.name
					}), /* @__PURE__ */ _("span", {
						className: "data-chat-slash-command-description text-xs text-gray-500",
						children: e.description
					})]
				}, e.name))
			}),
			/* @__PURE__ */ v("div", {
				className: `data-chat-footer ${F}`,
				children: [/* @__PURE__ */ _("input", {
					ref: b,
					type: "text",
					value: a,
					onChange: E,
					onKeyDown: k,
					placeholder: "Ask about your data or type \"/\" for commands…",
					className: "data-chat-input flex-1 rounded-md border border-gray-200 px-2 py-1.5 text-sm focus:outline-none focus:ring-1 focus:ring-indigo-400 disabled:opacity-50",
					disabled: c,
					"data-testid": "chat-input",
					"aria-label": "Chat input"
				}), c ? /* @__PURE__ */ _("button", {
					type: "button",
					onClick: A,
					className: "data-chat-stop-button p-1.5 rounded-md bg-red-100 text-red-600 hover:bg-red-200",
					"aria-label": "Stop streaming",
					"data-testid": "chat-stop",
					children: /* @__PURE__ */ _(co, { className: "w-4 h-4" })
				}) : /* @__PURE__ */ _("button", {
					type: "button",
					onClick: () => void O(),
					disabled: !a.trim(),
					className: "data-chat-send-button p-1.5 rounded-md bg-indigo-600 text-white hover:bg-indigo-700 disabled:opacity-40 disabled:cursor-not-allowed",
					"aria-label": "Send message",
					"data-testid": "chat-send",
					children: /* @__PURE__ */ _(Yo, { className: "w-4 h-4" })
				})]
			})
		]
	});
};
//#endregion
//#region src/panels/GrillMySkillsPanel/IdeaCard.tsx
function JT({ idea: e }) {
	return e.isPublished && e.clawHubUrl ? /* @__PURE__ */ _("a", {
		href: e.clawHubUrl,
		target: "_blank",
		rel: "noopener noreferrer",
		className: "inline-flex items-center rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-800",
		children: "On ClawHub"
	}) : /* @__PURE__ */ _("span", {
		className: "inline-flex items-center rounded-full border border-amber-200 bg-amber-50 px-3 py-1 text-xs font-semibold text-amber-900",
		children: "Upvote to build"
	});
}
function YT({ idea: e, dependencies: t, onLoadDependencies: n, onVote: r }) {
	let [i, a] = h(!1), [o, s] = h(!1), c = !!t?.gaps?.length;
	u(() => {
		a(!1), s(!1);
	}, [e.id]);
	let l = async () => {
		let e = !i;
		if (a(e), e && !t) {
			s(!0);
			try {
				await n();
			} finally {
				s(!1);
			}
		}
	};
	return /* @__PURE__ */ v("article", {
		className: "relative rounded-[1.8rem] border border-white/90 bg-[linear-gradient(180deg,rgba(255,255,255,0.96)_0%,rgba(244,253,255,0.94)_48%,rgba(255,236,228,0.94)_100%)] p-5 text-slate-800 shadow-[0_20px_48px_rgba(73,129,156,0.16)]",
		children: [
			/* @__PURE__ */ v("div", {
				className: "pointer-events-none absolute inset-0 overflow-hidden rounded-[1.8rem]",
				children: [
					/* @__PURE__ */ _("div", { className: "absolute inset-x-0 top-0 h-24 bg-[repeating-linear-gradient(104deg,rgba(255,255,255,0.45)_0px,rgba(255,255,255,0.45)_10px,rgba(255,255,255,0)_10px,rgba(255,255,255,0)_58px)] opacity-55" }),
					/* @__PURE__ */ _("div", { className: "absolute right-0 top-0 h-20 w-20 rounded-full bg-[#ffd977]/30 blur-xl" }),
					/* @__PURE__ */ _("div", { className: "absolute left-0 bottom-0 h-20 w-24 rounded-full bg-[#ff8ab1]/20 blur-xl" })
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "mb-4 flex items-start justify-between gap-4",
				children: [/* @__PURE__ */ v("div", { children: [
					/* @__PURE__ */ _("p", {
						className: "text-xs uppercase tracking-[0.28em] text-[#8b6b2c]/55",
						children: e.installComplexity
					}),
					/* @__PURE__ */ _("h3", {
						className: "font-serif text-2xl text-slate-900 lg:text-3xl",
						children: e.title
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-2 flex flex-wrap items-center gap-2",
						children: [/* @__PURE__ */ _(JT, { idea: e }), c ? /* @__PURE__ */ _("span", {
							className: "inline-flex items-center rounded-full border border-sky-200 bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-800",
							children: "Fills a gap"
						}) : null]
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-2 flex items-center gap-2",
						children: [/* @__PURE__ */ _("p", {
							className: "font-mono text-xs text-slate-500",
							children: e.slug
						}), e.clawHubUrl ? /* @__PURE__ */ _("a", {
							href: e.clawHubUrl,
							target: "_blank",
							rel: "noopener noreferrer",
							className: "font-mono text-xs text-sky-600 underline underline-offset-2 hover:text-sky-800",
							"aria-label": `View ${e.title} on ClawHub`,
							children: "Open in ClawHub →"
						}) : null]
					})
				] }), /* @__PURE__ */ v("div", {
					className: "rounded-full border border-[#f3d07a] bg-[linear-gradient(180deg,#fff5c9_0%,#f5d67d_100%)] px-3 py-1 text-xs font-medium text-[#6e5317]",
					children: ["Score ", e.netVoteScore]
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "rounded-[1.35rem] border border-[#d5edf7] bg-white/65 p-4 text-sm text-slate-700",
				children: [/* @__PURE__ */ _("p", {
					className: "font-medium uppercase tracking-[0.2em] text-sky-800/60",
					children: "Summary"
				}), /* @__PURE__ */ _("p", {
					className: "mt-2",
					children: e.oneLiner
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-4 grid gap-3 text-sm text-slate-700 lg:grid-cols-3",
				children: [
					/* @__PURE__ */ v("div", {
						className: "rounded-[1.25rem] border border-[#f1dca5] bg-[linear-gradient(180deg,#fffaf0_0%,#fff3d2_100%)] p-4",
						children: [/* @__PURE__ */ _("p", {
							className: "text-[10px] uppercase tracking-[0.28em] text-[#8b6b2c]/65",
							children: "Gold Problem"
						}), /* @__PURE__ */ _("p", {
							className: "mt-2 leading-6 text-slate-700",
							children: e.problem
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "rounded-[1.25rem] border border-slate-200 bg-[linear-gradient(180deg,#ffffff_0%,#f4f6fa_100%)] p-4",
						children: [/* @__PURE__ */ _("p", {
							className: "text-[10px] uppercase tracking-[0.28em] text-slate-500",
							children: "Silver Target User"
						}), /* @__PURE__ */ _("p", {
							className: "mt-2 leading-6 text-slate-700",
							children: e.targetUser
						})]
					}),
					/* @__PURE__ */ v("div", {
						className: "rounded-[1.25rem] border border-[#e7c0a0] bg-[linear-gradient(180deg,#fff7f2_0%,#edd0b4_100%)] p-4",
						children: [/* @__PURE__ */ _("p", {
							className: "text-[10px] uppercase tracking-[0.28em] text-[#94633b]/65",
							children: "Bronze Why Now"
						}), /* @__PURE__ */ _("p", {
							className: "mt-2 leading-6 text-slate-700",
							children: e.whyNow
						})]
					})
				]
			}),
			/* @__PURE__ */ _("div", {
				className: "mt-4 flex flex-wrap gap-2",
				children: (e.topics ?? []).map((e) => /* @__PURE__ */ _("span", {
					className: "rounded-full border border-sky-200 bg-[#eefcff] px-3 py-1 text-xs text-sky-900",
					children: e.topic
				}, e.topic))
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-4 rounded-[1.35rem] border border-white/80 bg-white/70 p-4 text-sm text-slate-700",
				children: [/* @__PURE__ */ v("div", {
					className: "flex items-center justify-between gap-3",
					children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
						className: "text-[10px] uppercase tracking-[0.28em] text-slate-500",
						children: "Dependencies"
					}), /* @__PURE__ */ _("p", {
						className: "mt-1 text-slate-600",
						children: "See what this idea depends on and what it unlocks."
					})] }), /* @__PURE__ */ _("button", {
						type: "button",
						onClick: () => void l(),
						className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 transition hover:bg-slate-50",
						children: i ? "Hide" : "Show"
					})]
				}), i ? /* @__PURE__ */ v("div", {
					className: "mt-4 grid gap-4 lg:grid-cols-3",
					children: [
						/* @__PURE__ */ v("div", { children: [
							/* @__PURE__ */ _("p", {
								className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-500",
								children: "Upstream"
							}),
							o ? /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: "Loading…"
							}) : null,
							!o && (t?.upstream?.length ?? 0) === 0 ? /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: "No explicit upstream skills yet."
							}) : null,
							(t?.upstream ?? []).map((e) => /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: e.clawHubUrl ? /* @__PURE__ */ _("a", {
									href: e.clawHubUrl,
									target: "_blank",
									rel: "noopener noreferrer",
									className: "underline underline-offset-2",
									children: e.name
								}) : e.name
							}, `up-${e.slug}`))
						] }),
						/* @__PURE__ */ v("div", { children: [
							/* @__PURE__ */ _("p", {
								className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-500",
								children: "Downstream"
							}),
							!o && (t?.downstream?.length ?? 0) === 0 ? /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: "No downstream matches yet."
							}) : null,
							(t?.downstream ?? []).map((e) => /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: e.clawHubUrl ? /* @__PURE__ */ _("a", {
									href: e.clawHubUrl,
									target: "_blank",
									rel: "noopener noreferrer",
									className: "underline underline-offset-2",
									children: e.name
								}) : e.name
							}, `down-${e.slug}`))
						] }),
						/* @__PURE__ */ v("div", { children: [
							/* @__PURE__ */ _("p", {
								className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-500",
								children: "Gap Fit"
							}),
							!o && (t?.gaps?.length ?? 0) === 0 ? /* @__PURE__ */ _("p", {
								className: "mt-2",
								children: "No matching composability gaps detected."
							}) : null,
							(t?.gaps ?? []).slice(0, 3).map((e) => /* @__PURE__ */ v("p", {
								className: "mt-2",
								children: [
									e.fromType,
									" → ",
									e.toType
								]
							}, `${e.fromType}-${e.toType}`))
						] })
					]
				}) : null]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-6 flex flex-col gap-3 sm:flex-row",
				children: [/* @__PURE__ */ _("button", {
					type: "button",
					onClick: () => r("UP"),
					className: "flex-1 rounded-full bg-[linear-gradient(180deg,#1bd0c1_0%,#0e9f94_100%)] px-4 py-3 text-sm font-semibold text-white transition hover:brightness-105",
					children: "Upvote"
				}), /* @__PURE__ */ _("button", {
					type: "button",
					onClick: () => r("DOWN"),
					className: "flex-1 rounded-full border border-slate-300 bg-white px-4 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50",
					children: "Downvote"
				})]
			})
		]
	});
}
//#endregion
//#region src/panels/GrillMySkillsPanel/grillmyskillsOntologyGraph.ts
var XT = /* #__PURE__ */ Object.assign({ "../../../../services/grillmyskills/memory/ontology/graph.jsonl": "{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"0\",\"title\":\"0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"1\",\"title\":\"second brain\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:1123\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"1123\",\"title\":\"1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/1123\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:123\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"123\",\"title\":\"1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/123\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:1password-1-0-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"1password-1-0-1\",\"title\":\"1password 1.0.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/1password-1-0-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"2\",\"title\":\"2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:20206-02-10-clawhub-summarize-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"20206-02-10-clawhub-summarize-1-0-0\",\"title\":\"20206 02 10 Clawhub Summarize 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/20206-02-10-clawhub-summarize-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:2026-02-10-clawhub-clawvault-1-5-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"2026-02-10-clawhub-clawvault-1-5-1\",\"title\":\"2026 02 10 Clawhub Clawvault 1.5.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/2026-02-10-clawhub-clawvault-1-5-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:2026-3-22dataset\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"2026-3-22dataset\",\"title\":\"2026-3-22dataset\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/2026-3-22dataset\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"3\",\"title\":\"Three body movement simulator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"5\",\"title\":\"58区块同城\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"6\",\"title\":\"6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:7-powers\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"7-powers\",\"title\":\"7 Powers\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/7-powers\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:7sins-infernal-council\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"7sins-infernal-council\",\"title\":\"七宗罪.skill / 7 Sins.skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/7sins-infernal-council\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:8\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"8\",\"title\":\"娱乐八卦\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/8\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:8917-docx-official\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"8917-docx-official\",\"title\":\"8917 DOCX Official\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/8917-docx-official\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:9\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"9\",\"title\":\"Nine Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/9\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:96push\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"96push\",\"title\":\"96push\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/96push\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a\",\"title\":\"a\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-nach-b\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-nach-b\",\"title\":\"A nach B - AT Public Transport Service (VOR)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-nach-b\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-share-pro\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-share-pro\",\"title\":\"A Share Pro\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-share-pro\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-share-real-time-data\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-share-real-time-data\",\"title\":\"A股实时行情数据\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-share-real-time-data\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-share-short-decision\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-share-short-decision\",\"title\":\"A股短线交易决策 A Share Short Term Decision\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-share-short-decision\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-share-stock-dossier\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-share-stock-dossier\",\"title\":\"A Share Stock Dossier\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-share-stock-dossier\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-share-trading\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-share-trading\",\"title\":\"A股数据SKILL\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-share-trading\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-analysis\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-analysis\",\"title\":\"A股分时量能分析\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-analysis\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-analysis-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-analysis-1-0-0\",\"title\":\"A Stock Analysis 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-analysis-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-fundamental-screening\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-fundamental-screening\",\"title\":\"A股基本面筛选\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-fundamental-screening\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-market\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-market\",\"title\":\"A Stock Market\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-market\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-market-sentiment\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-market-sentiment\",\"title\":\"A股市场情绪量化\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-market-sentiment\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-n-pattern\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-n-pattern\",\"title\":\"A Stock N Pattern\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-n-pattern\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-premarket-briefing\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-premarket-briefing\",\"title\":\"A Stock Premarket Briefing\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-premarket-briefing\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:a-stock-trading-assistant\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"a-stock-trading-assistant\",\"title\":\"A Stock Trading Assistant\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/a-stock-trading-assistant\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:adopt-a-hamster\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"adopt-a-hamster\",\"title\":\"Hamster — Adopt a Hamster. Exotic Animal. 仓鼠。Hámster.\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/adopt-a-hamster\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ads-qa-assistant\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ads-qa-assistant\",\"title\":\"Ads Q&A Assistant\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ads-qa-assistant\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:afrexai-ma-diligence\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"afrexai-ma-diligence\",\"title\":\"M&A Due Diligence\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/afrexai-ma-diligence\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:afrexai-ma-playbook\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"afrexai-ma-playbook\",\"title\":\"M&A Playbook\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/afrexai-ma-playbook\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:agent-p-web-recon\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"agent-p-web-recon\",\"title\":\"Agent-P Web Recon - 网站内容侦察\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/agent-p-web-recon\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:agent-pack-n-go\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"agent-pack-n-go\",\"title\":\"agent-pack-n-go\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/agent-pack-n-go\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:agent-s-bridge\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"agent-s-bridge\",\"title\":\"Agent S Bridge\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/agent-s-bridge\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:agente-fisica\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"agente-fisica\",\"title\":\"Agente Fisica\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/agente-fisica\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:agentic-workflow-automation-p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"agentic-workflow-automation-p\",\"title\":\"agentic-workflow-automation-p\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/agentic-workflow-automation-p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ah-llm-architect\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ah-llm-architect\",\"title\":\"llm-architect\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ah-llm-architect\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ah-powershell-7-expert\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ah-powershell-7-expert\",\"title\":\"powershell-7-expert\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ah-powershell-7-expert\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-c-plan\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-c-plan\",\"title\":\"Ai C Plan\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-c-plan\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-image-generation-prompts-9142af54\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-image-generation-prompts-9142af54\",\"title\":\"Ai Image Generation Prompts 9142af54\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-image-generation-prompts-9142af54\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-image-to-video-k\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-image-to-video-k\",\"title\":\"Ai Image To Video K\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-image-to-video-k\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-job-hunter-pro\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-job-hunter-pro\",\"title\":\"AI Job Hunter Pro\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-job-hunter-pro\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-llm-data-automation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-llm-data-automation\",\"title\":\"LLM数据自动化\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-llm-data-automation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ai-video-generator-free-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ai-video-generator-free-i\",\"title\":\"Ai Video Generator Free I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ai-video-generator-free-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:api-gateway-1-0-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"api-gateway-1-0-7\",\"title\":\"Api Gateway 1.0.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/api-gateway-1-0-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ask-ai-1-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ask-ai-1-2\",\"title\":\"ask-ai1.2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ask-ai-1-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:b\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"b\",\"title\":\"B\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/b\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:b-link\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"b-link\",\"title\":\"B Link\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/b-link\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:backup-gog-20260213-121122\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"backup-gog-20260213-121122\",\"title\":\"Backup Gog 20260213 121122\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/backup-gog-20260213-121122\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:banshee-s-last-cry\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"banshee-s-last-cry\",\"title\":\"Banshee's Last Cry Game CN\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/banshee-s-last-cry\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:base-8004\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"base-8004\",\"title\":\"Base 8004\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/base-8004\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:bilibili-anime\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"bilibili-anime\",\"title\":\"B站热门新番推荐\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/bilibili-anime\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:bilibili-hot-monitor\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"bilibili-hot-monitor\",\"title\":\"B站 (bilibili) 热门视频监控\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/bilibili-hot-monitor\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:bilibili-video-publish\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"bilibili-video-publish\",\"title\":\"B站视频发布\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/bilibili-video-publish\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:bilibili-video-transcribe-summary\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"bilibili-video-transcribe-summary\",\"title\":\"B站视频转文字&总结神器-Bilibili video transcribe&summary\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/bilibili-video-transcribe-summary\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:bio-reabilita-z\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"bio-reabilita-z\",\"title\":\"Bio Reabilita Z\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/bio-reabilita-z\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:browser-read-x\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"browser-read-x\",\"title\":\"browser-read-x\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/browser-read-x\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c\",\"title\":\"C\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-cleaner\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-cleaner\",\"title\":\"c-cleaner\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-cleaner\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-level-advisor\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-level-advisor\",\"title\":\"c-level-advisor\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-level-advisor\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-suite-agent-protocol\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-suite-agent-protocol\",\"title\":\"C-Suite Agent Protocol\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-suite-agent-protocol\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-suite-competitive-intel\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-suite-competitive-intel\",\"title\":\"C-Suite Competitive Intel\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-suite-competitive-intel\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-suite-founder-coach\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-suite-founder-coach\",\"title\":\"C-Suite Founder Coach\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-suite-founder-coach\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:c-task-cleanup\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"c-task-cleanup\",\"title\":\"C Task Cleanup\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/c-task-cleanup\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:call-deepseek-v3-llm\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"call-deepseek-v3-llm\",\"title\":\"Call Deepseek V3 Llm\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/call-deepseek-v3-llm\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:call-doubao1-5-llm\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"call-doubao1-5-llm\",\"title\":\"Call Doubao1 5 Llm\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/call-doubao1-5-llm\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:call-o3-llm\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"call-o3-llm\",\"title\":\"Call O3 Llm\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/call-o3-llm\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:captain-lobster\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"captain-lobster\",\"title\":\"Captain Lobster\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/captain-lobster\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:claude-sonnet-4-lite-agent\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"claude-sonnet-4-lite-agent\",\"title\":\"Claude Sonnet 4 Lite Agent\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/claude-sonnet-4-lite-agent\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:claw-store-1-3-3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"claw-store-1-3-3\",\"title\":\"Claw Store 1.3.3\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/claw-store-1-3-3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:clawd-cursor-0-6-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"clawd-cursor-0-6-0\",\"title\":\"Clawd Cursor 0.6.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/clawd-cursor-0-6-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:clawdhub-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"clawdhub-1-0-0\",\"title\":\"Clawdhub 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/clawdhub-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:cn-hot-trends-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"cn-hot-trends-6\",\"title\":\"6大平台热搜聚合\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/cn-hot-trends-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:cn-web-search-2-2-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"cn-web-search-2-2-0\",\"title\":\"Cn Web Search 2.2.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/cn-web-search-2-2-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:code-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"code-1-0-4\",\"title\":\"Code 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/code-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:code-analysis-skills-1-0-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"code-analysis-skills-1-0-6\",\"title\":\"Code Analysis Skills 1.0.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/code-analysis-skills-1-0-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:collective-qa\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"collective-qa\",\"title\":\"Collective Q&A\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/collective-qa\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:compact-test-b\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"compact-test-b\",\"title\":\"Test B\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/compact-test-b\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:constitution-md-trading-intelligence-v-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"constitution-md-trading-intelligence-v-1\",\"title\":\"constitution-md-trading-intelligence-v-1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/constitution-md-trading-intelligence-v-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:control-d\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"control-d\",\"title\":\"Control D\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/control-d\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:creating-r-research-projects\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"creating-r-research-projects\",\"title\":\"Creating R Research Projects\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/creating-r-research-projects\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:d\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"d\",\"title\":\"d\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/d\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:d-va-exa-web-search-free\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"d-va-exa-web-search-free\",\"title\":\"D.Va Exa Web Search Free\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/d-va-exa-web-search-free\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:d365-fo-developer\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"d365-fo-developer\",\"title\":\"D365 F&O Developer\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/d365-fo-developer\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:daily-market-report-md-trading-intelligence-v-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"daily-market-report-md-trading-intelligence-v-1\",\"title\":\"daily-market-report-md-trading-intelligence-v-1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/daily-market-report-md-trading-intelligence-v-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:debugging-r-environment-and-dependencies\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"debugging-r-environment-and-dependencies\",\"title\":\"Debugging R Environment And Dependencies\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/debugging-r-environment-and-dependencies\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:deep-coding-p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"deep-coding-p\",\"title\":\"deep-coding-p\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/deep-coding-p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:deep-framework\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"deep-framework\",\"title\":\"D.E.E.P. Framework\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/deep-framework\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dianping-search\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dianping-search\",\"title\":\"DianPing-Search\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dianping-search\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-claude-opus-4-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-claude-opus-4-7\",\"title\":\"Dlazy Claude Opus 4.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-claude-opus-4-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-gemini-2-5-tts\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-gemini-2-5-tts\",\"title\":\"Dlazy Gemini 2.5 Tts\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-gemini-2-5-tts\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-grok-4-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-grok-4-2\",\"title\":\"Dlazy Grok 4.2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-grok-4-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-jimeng-omnihuman-1-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-jimeng-omnihuman-1-5\",\"title\":\"Dlazy Jimeng Omnihuman 1.5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-jimeng-omnihuman-1-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-seedance-1-5-pro\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-seedance-1-5-pro\",\"title\":\"Dlazy Seedance 1.5 Pro\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-seedance-1-5-pro\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-seedream-4-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-seedream-4-5\",\"title\":\"Dlazy Seedream 4.5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-seedream-4-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-seedream-5-0-lite\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-seedream-5-0-lite\",\"title\":\"Dlazy Seedream 5.0 Lite\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-seedream-5-0-lite\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-veo-3-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-veo-3-1\",\"title\":\"Dlazy Veo 3.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-veo-3-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-wan2-6-r2v\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-wan2-6-r2v\",\"title\":\"Dlazy Wan2.6 R2v\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-wan2-6-r2v\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-wan2-6-r2v-flash\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-wan2-6-r2v-flash\",\"title\":\"Dlazy Wan2.6 R2v Flash\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-wan2-6-r2v-flash\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dlazy-wan2-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dlazy-wan2-7\",\"title\":\"Dlazy Wan2.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dlazy-wan2-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dnd\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dnd\",\"title\":\"D&D 5e Toolkit\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dnd\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:doppel-erc-8004\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"doppel-erc-8004\",\"title\":\"Doppel ERC-8004\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/doppel-erc-8004\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dressup-playable-maker\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dressup-playable-maker\",\"title\":\"Dressup Playable Maker\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dressup-playable-maker\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:dygod-movies\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"dygod-movies\",\"title\":\"Dygod Movies\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/dygod-movies\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e\",\"title\":\"E\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e-commerce-find-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e-commerce-find-skills\",\"title\":\"E-commerce find skills\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e-commerce-find-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e-conomic\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e-conomic\",\"title\":\"E Conomic\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e-conomic\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e-crm-a\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e-crm-a\",\"title\":\"e Crm Autom\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e-crm-a\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e-goi\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e-goi\",\"title\":\"E Goi\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e-goi\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:e-invoice-partner-selection\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"e-invoice-partner-selection\",\"title\":\"Global E-Invoice partner selection\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/e-invoice-partner-selection\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:eight-d-corrective-action-report\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"eight-d-corrective-action-report\",\"title\":\"Eight D Corrective Action Report\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/eight-d-corrective-action-report\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:erc-8004\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"erc-8004\",\"title\":\"ERC-8004 Trustless Agents\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/erc-8004\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:erc-800claw\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"erc-800claw\",\"title\":\"ERC-800Claw\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/erc-800claw\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:evolver-1-17-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"evolver-1-17-1\",\"title\":\"Evolver 1.17.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/evolver-1-17-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:f\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"f\",\"title\":\"DB sql\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/f\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:facebook\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"facebook\",\"title\":\"Facebook\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/facebook\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:fairygui-tools\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"fairygui-tools\",\"title\":\"fairygui-tools\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/fairygui-tools\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:feishu-file-sender-1-0-9\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"feishu-file-sender-1-0-9\",\"title\":\"Feishu File Sender 1.0.9\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/feishu-file-sender-1-0-9\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:fia-signals-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"fia-signals-skill\",\"title\":\"Fía Signals\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/fia-signals-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:figma-design-analyzer\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"figma-design-analyzer\",\"title\":\"figma-design-analyzer\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/figma-design-analyzer\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:filesystem-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"filesystem-1-0-0\",\"title\":\"Filesystem 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/filesystem-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:finance-audit-agent\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"finance-audit-agent\",\"title\":\"Finance Audit Agent\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/finance-audit-agent\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:find-skills-wzr-999\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"find-skills-wzr-999\",\"title\":\"find-skills-wzr-999\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/find-skills-wzr-999\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:finloop-mktdata-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"finloop-mktdata-skills\",\"title\":\"F-AI 金融数据\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/finloop-mktdata-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:finloop-news-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"finloop-news-skills\",\"title\":\"F-AI 资讯搜索\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/finloop-news-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:free-ride-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"free-ride-1-0-4\",\"title\":\"Free Ride 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/free-ride-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:free-ride-1-0-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"free-ride-1-0-5\",\"title\":\"Free Ride 1.0.5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/free-ride-1-0-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:free-video-generator-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"free-video-generator-i\",\"title\":\"Free Video Generator I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/free-video-generator-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:g\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"g\",\"title\":\"Google全家桶入口\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/g\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:g-tts\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"g-tts\",\"title\":\"Google Chirp 3 HD TTS Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/g-tts\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:g0atbot-tiktok-carousel\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"g0atbot-tiktok-carousel\",\"title\":\"TikTok Carousel Generator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/g0atbot-tiktok-carousel\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ga4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ga4\",\"title\":\"GA4 Analytics\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ga4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ga4-analytics\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ga4-analytics\",\"title\":\"GA4 Analytics\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ga4-analytics\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gal-test\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gal-test\",\"title\":\"Don't download\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gal-test\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:game-developer-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"game-developer-skill\",\"title\":\"Claude_Game_Developer\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/game-developer-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:game-theory\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"game-theory\",\"title\":\"Game Theory\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/game-theory\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:games\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"games\",\"title\":\"Games\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/games\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gamma\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gamma\",\"title\":\"Gamma\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gamma\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gemini-deep-research-jclaw\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gemini-deep-research-jclaw\",\"title\":\"Gemini Deep Research (J-claw)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gemini-deep-research-jclaw\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gemini-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gemini-skill\",\"title\":\"Gemini Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gemini-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gemini-watermark-remover\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gemini-watermark-remover\",\"title\":\"Gemini Watermark Remover\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gemini-watermark-remover\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gen-z-design-agent\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gen-z-design-agent\",\"title\":\"Gen Z Design Agent\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gen-z-design-agent\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gen-z-lingo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gen-z-lingo\",\"title\":\"Gen Z Lingo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gen-z-lingo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gerador-receitas\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gerador-receitas\",\"title\":\"Gerador Receitas\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gerador-receitas\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:getnote-1-5-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"getnote-1-5-7\",\"title\":\"Getnote 1.5.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/getnote-1-5-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:github-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"github-1-0-0\",\"title\":\"Github 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/github-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gld-ue-template\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gld-ue-template\",\"title\":\"gld_ue_template\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gld-ue-template\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:glm-v-model\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"glm-v-model\",\"title\":\"glm-v-model\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/glm-v-model\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gmail-1-0-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gmail-1-0-6\",\"title\":\"Gmail 1.0.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gmail-1-0-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gog-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gog-1-0-0\",\"title\":\"Gog 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gog-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gog-jarvis\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gog-jarvis\",\"title\":\"Gog Jarvis\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gog-jarvis\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gog-jasmine\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gog-jasmine\",\"title\":\"Gog Jasmine\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gog-jasmine\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gog-test-demo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gog-test-demo\",\"title\":\"gog-test-demo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gog-test-demo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gpt-image-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gpt-image-2\",\"title\":\"gpt-image-2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gpt-image-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:gworkspace\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"gworkspace\",\"title\":\"G.workspace\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/gworkspace\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:h\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"h\",\"title\":\"Skill 发现中心\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/h\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:h-ear\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"h-ear\",\"title\":\"H-ear\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/h-ear\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:haoning-test-skill6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"haoning-test-skill6\",\"title\":\"Haoning Test Skill6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/haoning-test-skill6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:highlevel-1-0-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"highlevel-1-0-7\",\"title\":\"Highlevel 1.0.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/highlevel-1-0-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:hsa-test\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"hsa-test\",\"title\":\"H test\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/hsa-test\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:html-ppt-zc\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"html-ppt-zc\",\"title\":\"html-ppt-zc\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/html-ppt-zc\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:huanzhi-fa-skill-pro-v2-8-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"huanzhi-fa-skill-pro-v2-8-0\",\"title\":\"Huanzhi Fa Skill Pro V2.8.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/huanzhi-fa-skill-pro-v2-8-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:humanizer-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"humanizer-1-0-0\",\"title\":\"Humanizer 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/humanizer-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:humann-capital\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"humann-capital\",\"title\":\"Humann.Capital\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/humann-capital\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"i\",\"title\":\"Memo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:i-am\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"i-am\",\"title\":\"i-am\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/i-am\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:i-can-see\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"i-can-see\",\"title\":\"i-can-see\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/i-can-see\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:i-love-you-mom\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"i-love-you-mom\",\"title\":\"I Love You Mom\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/i-love-you-mom\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:i-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"i-skill\",\"title\":\"i-skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/i-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ib-dp-english-b\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ib-dp-english-b\",\"title\":\"Ib Dp English B\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ib-dp-english-b\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:icom-7610\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"icom-7610\",\"title\":\"Icom IC-7610\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/icom-7610\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ima-skills-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ima-skills-1-0-4\",\"title\":\"Ima Skills 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ima-skills-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:image-to-video-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"image-to-video-i\",\"title\":\"Image To Video I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/image-to-video-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:j\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"j\",\"title\":\"J\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/j\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:javascript-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"javascript-skills\",\"title\":\"JavaScript\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/javascript-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jclaw-gemini-deep-research\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jclaw-gemini-deep-research\",\"title\":\"Gemini Deep Research (J-Claw)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jclaw-gemini-deep-research\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jclaw-notebooklm-content-creation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jclaw-notebooklm-content-creation\",\"title\":\"NotebookLM Content Creation (J-Claw)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jclaw-notebooklm-content-creation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jclaw-polling-best-practices\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jclaw-polling-best-practices\",\"title\":\"Polling Best Practices (J-Claw)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jclaw-polling-best-practices\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jd-interview-prep-helper\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jd-interview-prep-helper\",\"title\":\"Jd Interview Prep Helper\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jd-interview-prep-helper\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jd-translator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jd-translator\",\"title\":\"Jd Translator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jd-translator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jianying-editor-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jianying-editor-skill\",\"title\":\"Jianying Editor Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jianying-editor-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jike\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jike\",\"title\":\"Jike\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jike\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jina-reader\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jina-reader\",\"title\":\"Jina Reader\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jina-reader\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jtbd-analyzer\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jtbd-analyzer\",\"title\":\"Jobs To Be Done Analyzer\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jtbd-analyzer\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:jx76-gog\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"jx76-gog\",\"title\":\"Google Workspace CLI (gog)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/jx76-gog\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k\",\"title\":\"KnowledgeKeeper Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k-cinema-bridge\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k-cinema-bridge\",\"title\":\"K Cinema Bridge\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k-cinema-bridge\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k-deep-research\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k-deep-research\",\"title\":\"K Deep Research\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k-deep-research\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k-test\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k-test\",\"title\":\"K test\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k-test\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k8s\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k8s\",\"title\":\"Kubernetes\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k8s\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:k8s-browser\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"k8s-browser\",\"title\":\"Kubernetes Skills\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/k8s-browser\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kalshi\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kalshi\",\"title\":\"Kalshi\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kalshi\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kalshi-trading\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kalshi-trading\",\"title\":\"Kalshi Trading\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kalshi-trading\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kameo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kameo\",\"title\":\"kameo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kameo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kim-msg-account\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kim-msg-account\",\"title\":\"Kim Msg Account Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kim-msg-account\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kipris-cli\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kipris-cli\",\"title\":\"kipris-cli\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kipris-cli\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:klaviyo-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"klaviyo-1-0-4\",\"title\":\"Klaviyo 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/klaviyo-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kling-3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kling-3\",\"title\":\"Kling 3.0 video generation\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kling-3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kling-3-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kling-3-0\",\"title\":\"🫧 Kling 3.0 — Pro Pack on RunComfy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kling-3-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kosis-cli\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kosis-cli\",\"title\":\"Kosis Cli\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kosis-cli\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:kucoin-trader\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"kucoin-trader\",\"title\":\"KuCoin Trader\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/kucoin-trader\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:l\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"l\",\"title\":\"L\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/l\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lady-s-man\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lady-s-man\",\"title\":\"浪漫聊天技巧、撩妹情话、恋爱沟通技能。提供分类的情话套路、开场白、调情话术、日常甜言蜜语、应对策略、幽默段子等，覆盖各种恋爱场景。当用户需要约会建议、与女生聊天、编写浪漫消息、撩妹、情话、恋爱调侃、甜言蜜语或回应浪漫情况时使用。也称为\\\"陆小凤\\\"（Lady's Man）。\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lady-s-man\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lebevolae-x-post\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lebevolae-x-post\",\"title\":\"Lebevolae X Post\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lebevolae-x-post\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:leo-x-post\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"leo-x-post\",\"title\":\"Leo X Post\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/leo-x-post\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lightspeed-r-series-integration\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lightspeed-r-series-integration\",\"title\":\"Lightspeed R Series\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lightspeed-r-series-integration\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lily-memory-5-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lily-memory-5-0-0\",\"title\":\"Lily Memory 5.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lily-memory-5-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:live-qa-scripts\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"live-qa-scripts\",\"title\":\"Live Q&A Scripts\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/live-qa-scripts\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:llava-vision\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"llava-vision\",\"title\":\"Llava Vision\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/llava-vision\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:llm-chain\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"llm-chain\",\"title\":\"Llm Chain\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/llm-chain\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:llm-deploy\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"llm-deploy\",\"title\":\"LLM Deploy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/llm-deploy\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:llm-service-manager-4cadc0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"llm-service-manager-4cadc0\",\"title\":\"Llm Service Manager 4cadc0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/llm-service-manager-4cadc0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:local-computer-use\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"local-computer-use\",\"title\":\"local computer use\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/local-computer-use\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lottery-predictor-v3-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lottery-predictor-v3-6\",\"title\":\"双色球预测技能 V3.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lottery-predictor-v3-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:lottery-predictor-v3-8\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"lottery-predictor-v3-8\",\"title\":\"Lottery Predictor V3 8\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/lottery-predictor-v3-8\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:m\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"m\",\"title\":\"m\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/m\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:m-a3-core-suite\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"m-a3-core-suite\",\"title\":\"M A3 Core Suite\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/m-a3-core-suite\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:m-flow-memory\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"m-flow-memory\",\"title\":\"M-Flow Memory\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/m-flow-memory\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:m-valuation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"m-valuation\",\"title\":\"M估值法\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/m-valuation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mad-seo-content\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mad-seo-content\",\"title\":\"M.A.D. SEO CONTENT\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mad-seo-content\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:magyar-szovegfeldolgoz-s\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"magyar-szovegfeldolgoz-s\",\"title\":\"Magyar Szövegfeldolgozás\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/magyar-szovegfeldolgoz-s\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:manual-j-residential-load-calc\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"manual-j-residential-load-calc\",\"title\":\"Manual J Residential Load Calc\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/manual-j-residential-load-calc\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:manus-planning-with-files-2-26-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"manus-planning-with-files-2-26-1\",\"title\":\"类Manus任务规划Planning With Files 2.26.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/manus-planning-with-files-2-26-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:marketplace-fee-calculator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"marketplace-fee-calculator\",\"title\":\"Marketplace Fee Calculator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/marketplace-fee-calculator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mcp-server-discovery-p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mcp-server-discovery-p\",\"title\":\"mcp-server-discovery-p\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mcp-server-discovery-p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mcporter-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mcporter-1-0-0\",\"title\":\"Mcporter 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mcporter-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mdr-745-specialist\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mdr-745-specialist\",\"title\":\"Mdr 745 Specialist\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mdr-745-specialist\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:meituan-c-user-auth\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"meituan-c-user-auth\",\"title\":\"美团C端用户Agent认证工具\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/meituan-c-user-auth\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mental-model-forge\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mental-model-forge\",\"title\":\"F.A.C.E.T. Framework (心智模型：F.A.C.E.T. 框架)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mental-model-forge\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mflow-memory\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mflow-memory\",\"title\":\"M-flow Memory\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mflow-memory\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mia-content-creator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mia-content-creator\",\"title\":\"Mia Content Creator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mia-content-creator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mirothinker1-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mirothinker1-7\",\"title\":\"Mirothinker1.7\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mirothinker1-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mlx-whisper\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mlx-whisper\",\"title\":\"Mlx Whisper\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mlx-whisper\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:moltguard-6-8-16\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"moltguard-6-8-16\",\"title\":\"Moltguard 6.8.16\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/moltguard-6-8-16\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:moltrade-1-0-9\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"moltrade-1-0-9\",\"title\":\"Moltrade 1.0.9\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/moltrade-1-0-9\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:moss-skill-9\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"moss-skill-9\",\"title\":\"Moss Skill-9\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/moss-skill-9\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mpesa-daraja\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mpesa-daraja\",\"title\":\"M-Pesa Daraja\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mpesa-daraja\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:mx-finance-data-1-0-8\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"mx-finance-data-1-0-8\",\"title\":\"Mx Finance Data 1.0.8\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/mx-finance-data-1-0-8\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:n\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"n\",\"title\":\"n Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/n\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:n-central-admin\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"n-central-admin\",\"title\":\"N-central Admin\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/n-central-admin\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:n-plus-one-detector\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"n-plus-one-detector\",\"title\":\"N Plus One Detector\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/n-plus-one-detector\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:n8n-evol-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"n8n-evol-i\",\"title\":\"N8N EVOL I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/n8n-evol-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:n8n-workflow-automation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"n8n-workflow-automation\",\"title\":\"n8n workflow automation\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/n8n-workflow-automation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nano-banana-2-pro\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nano-banana-2-pro\",\"title\":\"nano banana 2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nano-banana-2-pro\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nano-banana-openrouter\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nano-banana-openrouter\",\"title\":\"Nano Banana Openrouter\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nano-banana-openrouter\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nano-banana-pro\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nano-banana-pro\",\"title\":\"Nano Banana Pro\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nano-banana-pro\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nano-pdf\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nano-pdf\",\"title\":\"Nano Pdf\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nano-pdf\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nanophoto-nano-banana-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nanophoto-nano-banana-2\",\"title\":\"Nano Banana 2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nanophoto-nano-banana-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nanophoto-veo-3-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nanophoto-veo-3-1\",\"title\":\"Veo 3.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nanophoto-veo-3-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nate-b-jones-digest\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nate-b-jones-digest\",\"title\":\"Nate B Jones Digest\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nate-b-jones-digest\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:navigation-3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"navigation-3\",\"title\":\"Navigation 3\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/navigation-3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:neon-soul\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"neon-soul\",\"title\":\"NEON-SOUL - Self-Learning Soul Synthesis for AI Agents\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/neon-soul\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:neon-soul-0-4-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"neon-soul-0-4-5\",\"title\":\"Neon Soul 0.4.5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/neon-soul-0-4-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nfs-e-parser\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nfs-e-parser\",\"title\":\"NFS-e Parser — Brazilian invoice field extraction\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nfs-e-parser\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nocodb-official\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nocodb-official\",\"title\":\"NocoDB Skiils\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nocodb-official\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:nota-fiscal-paulistana\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"nota-fiscal-paulistana\",\"title\":\"Emissor de Nota Fiscal Paulistana\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/nota-fiscal-paulistana\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:o\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"o\",\"title\":\"O\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/o\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian\",\"title\":\"Obsidian\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian-1-0-0\",\"title\":\"Obsidian 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian-cli-official\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian-cli-official\",\"title\":\"Obsidian Official CLI\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian-cli-official\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian-daily\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian-daily\",\"title\":\"Obsidian Daily\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian-daily\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian-direct\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian-direct\",\"title\":\"Obsidian - read, search, write and edit direct to obsidian vault.\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian-direct\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:obsidian-ontology-sync\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"obsidian-ontology-sync\",\"title\":\"Obsidian Ontology Sync\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/obsidian-ontology-sync\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ollama-seo-auditor\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ollama-seo-auditor\",\"title\":\"Ollama SEO Auditor\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ollama-seo-auditor\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ollama-x-z-image-turbo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ollama-x-z-image-turbo\",\"title\":\"Image Generation (Ollama x/z-image-turbo · macOS only)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ollama-x-z-image-turbo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ontology-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ontology-1-0-4\",\"title\":\"Ontology 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ontology-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ooo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ooo\",\"title\":\"O\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ooo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:openclaw-aisa-image-video-models-wan2-6-gemini-3-pro-image-nano-banana\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"openclaw-aisa-image-video-models-wan2-6-gemini-3-pro-image-nano-banana\",\"title\":\"Generate images & videos with: Gemini 3 Pro Image (image) + Qwen Wan 2.6 (video) via one API key\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/openclaw-aisa-image-video-models-wan2-6-gemini-3-pro-image-nano-banana\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:openclaw-elontools-optimizer-v3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"openclaw-elontools-optimizer-v3\",\"title\":\"OpenClaw ElonTools Optimizer v3 — Safe Edition\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/openclaw-elontools-optimizer-v3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:openclaw-tokenapi-qiehuan-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"openclaw-tokenapi-qiehuan-skills\",\"title\":\"Openclaw Tokenapi Qiehuan Skills\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/openclaw-tokenapi-qiehuan-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:osv-scanner\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"osv-scanner\",\"title\":\"OSV Scanner\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/osv-scanner\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"p\",\"title\":\"P图\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:p-api\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"p-api\",\"title\":\"P-API - WhatsApp API\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/p-api\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:p-e\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"p-e\",\"title\":\"P-E\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/p-e\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:p-seo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"p-seo\",\"title\":\"pSEO Generator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/p-seo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:parallel-1-0-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"parallel-1-0-1\",\"title\":\"Parallel 1.0.1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/parallel-1-0-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:pilot-e-commerce-ops-setup\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"pilot-e-commerce-ops-setup\",\"title\":\"Pilot E Commerce Ops Setup\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/pilot-e-commerce-ops-setup\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:pinata-erc-8004\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"pinata-erc-8004\",\"title\":\"Pinata ERC-8004\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/pinata-erc-8004\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:plan-c\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"plan-c\",\"title\":\"Plan C\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/plan-c\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:plan-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"plan-i\",\"title\":\"Plan I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/plan-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:pm-requirement-review-simulator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"pm-requirement-review-simulator\",\"title\":\"pm-requirement-review-simulator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/pm-requirement-review-simulator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:polymarket-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"polymarket-1-0-0\",\"title\":\"Polymarket 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/polymarket-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:polymarket-trade-1-0-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"polymarket-trade-1-0-6\",\"title\":\"Polymarket Trade 1.0.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/polymarket-trade-1-0-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:polyv-e-commerce-setup\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"polyv-e-commerce-setup\",\"title\":\"polyv-e-commerce-setup\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/polyv-e-commerce-setup\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:power-trading-96-to-24\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"power-trading-96-to-24\",\"title\":\"电力交易96点转24点\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/power-trading-96-to-24\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:poyo-gpt-image-1-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"poyo-gpt-image-1-5\",\"title\":\"GPT Image 1.5 API\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/poyo-gpt-image-1-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:poyo-kling-2-6-motion-control\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"poyo-kling-2-6-motion-control\",\"title\":\"Kling 2.6 Motion Control\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/poyo-kling-2-6-motion-control\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:poyo-sora-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"poyo-sora-2\",\"title\":\"Sora 2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/poyo-sora-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ppt-generator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ppt-generator\",\"title\":\"description: 将用户讲稿一键生成乔布斯风极简科技感竖屏HTML演示稿。当用户需要生成PPT、演示文稿、Slides、幻灯片，或要求科技风/极简风/乔布斯风格的演示时触发此技能。输出为单个可直接运行的HTML文件。\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ppt-generator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:prd-visualization-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"prd-visualization-skill\",\"title\":\"PRD Visualization Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/prd-visualization-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:pre-judgment-of-similar-cases-wdy\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"pre-judgment-of-similar-cases-wdy\",\"title\":\"Pre judgment of similar cases wdy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/pre-judgment-of-similar-cases-wdy\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:precise-t-trading\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"precise-t-trading\",\"title\":\"Precise T Trading\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/precise-t-trading\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:prompt-architect-p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"prompt-architect-p\",\"title\":\"prompt-architect-p\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/prompt-architect-p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:prompt-inject-removal-p\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"prompt-inject-removal-p\",\"title\":\"prompt-inject-removal-p\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/prompt-inject-removal-p\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q\",\"title\":\"智能多面手工具箱\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q-erp\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q-erp\",\"title\":\"Q Erp\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q-erp\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q-kdb-code-review\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q-kdb-code-review\",\"title\":\"Q Kdb Code Review\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q-kdb-code-review\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q-memory\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q-memory\",\"title\":\"Q Memory\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q-memory\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q-memory-local\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q-memory-local\",\"title\":\"Q Memory (Local)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q-memory-local\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:q-wms\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"q-wms\",\"title\":\"Q Wms\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/q-wms\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qa-prep-partner\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qa-prep-partner\",\"title\":\"Q&A Prep Partner\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qa-prep-partner\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qmd-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qmd-1-0-0\",\"title\":\"Qmd 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qmd-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qoderwork-ppt-jack\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qoderwork-ppt-jack\",\"title\":\"QoderWork PPT (Jack)\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qoderwork-ppt-jack\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qq-hot-trend\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qq-hot-trend\",\"title\":\"Qq\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qq-hot-trend\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qq-mail-read-send\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qq-mail-read-send\",\"title\":\"qq-mail-read-send\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qq-mail-read-send\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qq-zone-photo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qq-zone-photo\",\"title\":\"Qq Zone Photo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qq-zone-photo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qst-memory-v1-8-5-no-crypto\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qst-memory-v1-8-5-no-crypto\",\"title\":\"Qst Memory V1.8.5 No Crypto\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qst-memory-v1-8-5-no-crypto\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:qwen-qwen3-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"qwen-qwen3-5\",\"title\":\"Qwen Qwen3 5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/qwen-qwen3-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:r\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"r\",\"title\":\"R\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/r\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:r-analyst\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"r-analyst\",\"title\":\"R Analyst\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/r-analyst\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:r-ggplot-quickplot\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"r-ggplot-quickplot\",\"title\":\"R ggplot Quickplot\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/r-ggplot-quickplot\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:r-package-dev\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"r-package-dev\",\"title\":\"R Package Development — From Zero to CRAN & Bioconductor\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/r-package-dev\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:r-stats\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"r-stats\",\"title\":\"R Stats\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/r-stats\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:redline-annotate\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"redline-annotate\",\"title\":\"Redline Annotate\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/redline-annotate\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:resource-hunter\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"resource-hunter\",\"title\":\"Resource Hunter\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/resource-hunter\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:rolex-maybeai-sheet\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"rolex-maybeai-sheet\",\"title\":\"1\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/rolex-maybeai-sheet\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:runapi-z-image\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"runapi-z-image\",\"title\":\"z-image\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/runapi-z-image\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:running-r-analysis-in-existing-projects\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"running-r-analysis-in-existing-projects\",\"title\":\"Running R Analysis In Existing Projects\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/running-r-analysis-in-existing-projects\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:s\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"s\",\"title\":\"智能代码助手\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/s\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:s3-pentest-commands\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"s3-pentest-commands\",\"title\":\"S³ Pentest Commands\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/s3-pentest-commands\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:s3-security-audit\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"s3-security-audit\",\"title\":\"S³ Security Audit\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/s3-security-audit\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:save-money-4-2-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"save-money-4-2-0\",\"title\":\"Save Money 4.2.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/save-money-4-2-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:scl-90\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"scl-90\",\"title\":\"scl-90\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/scl-90\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:search-x\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"search-x\",\"title\":\"Search X\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/search-x\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:secret-safe\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"secret-safe\",\"title\":\"Secret's Safe\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/secret-safe\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:seedance-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"seedance-2\",\"title\":\"Seedance 2.0 Video\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/seedance-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:seedance-2-online\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"seedance-2-online\",\"title\":\"Seedance 2 Online\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/seedance-2-online\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:seedance-2-prompts\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"seedance-2-prompts\",\"title\":\"Seedance 2 Prompts\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/seedance-2-prompts\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:self-improving-1-2-10\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"self-improving-1-2-10\",\"title\":\"Self Improving 1.2.10\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/self-improving-1-2-10\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:self-improving-agent-1-0-11\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"self-improving-agent-1-0-11\",\"title\":\"Self Improving Agent 1.0.11\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/self-improving-agent-1-0-11\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:self-improving-agent-3-0-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"self-improving-agent-3-0-6\",\"title\":\"Self Improving Agent 3.0.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/self-improving-agent-3-0-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:serper-v\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"serper-v\",\"title\":\"serper-v\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/serper-v\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:shit-journal-scraper\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"shit-journal-scraper\",\"title\":\"S.H.I.T底刊摘要\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/shit-journal-scraper\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-2\",\"title\":\"Skill 2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-3\",\"title\":\"Skill 3\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-4\",\"title\":\"Skill 4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-9\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-9\",\"title\":\"Agent Reach\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-9\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-9-0-1-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-9-0-1-0\",\"title\":\"Skill 9 0.1.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-9-0-1-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-b-pre-brief\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-b-pre-brief\",\"title\":\"skill-b-pre-brief\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-b-pre-brief\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-d-create-issues\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-d-create-issues\",\"title\":\"skill-d-create-issues\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-d-create-issues\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:skill-h-meeting-sync\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"skill-h-meeting-sync\",\"title\":\"skill-h-meeting-sync\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/skill-h-meeting-sync\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:sora-2-generate\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"sora-2-generate\",\"title\":\"Sora 2 Generate\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/sora-2-generate\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:stock-analysis-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"stock-analysis-6\",\"title\":\"Stock Analysis 6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/stock-analysis-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:stock-analysis-6-2-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"stock-analysis-6-2-0\",\"title\":\"Stock Analysis 6.2.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/stock-analysis-6-2-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:stock-heat-rank\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"stock-heat-rank\",\"title\":\"Stock Heat Rank\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/stock-heat-rank\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:summarize-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"summarize-1-0-0\",\"title\":\"Summarize 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/summarize-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:super-github-s\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"super-github-s\",\"title\":\"super-github-s\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/super-github-s\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:supermap-wasi-geo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"supermap-wasi-geo\",\"title\":\"supermap-wasi-geo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/supermap-wasi-geo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:t\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"t\",\"title\":\"t\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/t\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:t-cpm\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"t-cpm\",\"title\":\"t-cpm自定义技能\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/t-cpm\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:t-trading\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"t-trading\",\"title\":\"T Trading\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/t-trading\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:t-web-searcher\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"t-web-searcher\",\"title\":\"t-web-searcher\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/t-web-searcher\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:tavilysearch-1-0-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"tavilysearch-1-0-4\",\"title\":\"Tavilysearch 1.0.4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/tavilysearch-1-0-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:test-1775879521\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"test-1775879521\",\"title\":\"T\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/test-1775879521\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:test-1775893839\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"test-1775893839\",\"title\":\"T\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/test-1775893839\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:text-to-video-i\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"text-to-video-i\",\"title\":\"Text To Video I\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/text-to-video-i\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:think-x-actually-y-video-gen\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"think-x-actually-y-video-gen\",\"title\":\"think-x-actually-y-video-gen\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/think-x-actually-y-video-gen\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:toby-productivity-helper-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"toby-productivity-helper-2\",\"title\":\"Productivity Helper #2\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/toby-productivity-helper-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:toby-productivity-helper-3\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"toby-productivity-helper-3\",\"title\":\"Productivity Helper #3\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/toby-productivity-helper-3\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:toby-productivity-helper-4\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"toby-productivity-helper-4\",\"title\":\"Productivity Helper #4\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/toby-productivity-helper-4\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:toby-productivity-helper-5\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"toby-productivity-helper-5\",\"title\":\"Productivity Helper #5\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/toby-productivity-helper-5\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:tts-winmsg-free\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"tts-winmsg-free\",\"title\":\"tts-winmsg-free\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/tts-winmsg-free\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:tuebingen-weather\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"tuebingen-weather\",\"title\":\"Tübingen Weather\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/tuebingen-weather\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:tuebingen-weather-graphics\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"tuebingen-weather-graphics\",\"title\":\"Tübingen Weather Graphics\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/tuebingen-weather-graphics\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:twitter-api-v2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"twitter-api-v2\",\"title\":\"X\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/twitter-api-v2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:u\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"u\",\"title\":\"Universal Utility Toolkit - 全能实用工具包\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/u\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:udemy\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"udemy\",\"title\":\"Udemy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/udemy\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ugc\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ugc\",\"title\":\"UGC\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ugc\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui\",\"title\":\"UI\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui-audit\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui-audit\",\"title\":\"UI Audit\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui-audit\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui-skills\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui-skills\",\"title\":\"Ui Skills\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui-skills\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui-ux\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui-ux\",\"title\":\"UI / UX\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui-ux\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui-ux-pro-max\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui-ux-pro-max\",\"title\":\"UI/UX Pro Max\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui-ux-pro-max\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ui-ux-pro-max-2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ui-ux-pro-max-2\",\"title\":\"Ui Ux Pro Max\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ui-ux-pro-max-2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:uid-life\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"uid-life\",\"title\":\"UID.LIFE Compute Node\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/uid-life\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:umeng-uapp-integration\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"umeng-uapp-integration\",\"title\":\"友盟 U-APP 统计 SDK 集成\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/umeng-uapp-integration\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:v\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"v\",\"title\":\"ASCII v\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/v\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:v-identity-ilhant34\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"v-identity-ilhant34\",\"title\":\"V Identity Ilhant34\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/v-identity-ilhant34\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:v-train-data-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"v-train-data-skill\",\"title\":\"V-Train_Data\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/v-train-data-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:var-protocol\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"var-protocol\",\"title\":\"V.A.R. Protocol\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/var-protocol\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:vegas-t-trading\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"vegas-t-trading\",\"title\":\"Vegas T Trading\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/vegas-t-trading\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:veo\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"veo\",\"title\":\"Veo\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/veo\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:veo-3-1\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"veo-3-1\",\"title\":\"Veo 3.1 API\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/veo-3-1\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:video-translator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"video-translator\",\"title\":\"Video Translator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/video-translator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:volcengine-ai-mediakit\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"volcengine-ai-mediakit\",\"title\":\"Volcengine AI MediaKit\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/volcengine-ai-mediakit\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:w\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"w\",\"title\":\"W Skill Pack\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/w\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:walkie-talkie\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"walkie-talkie\",\"title\":\"Walkie-Talkie Mode\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/walkie-talkie\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wan-2-7\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wan-2-7\",\"title\":\"🫧 Wan 2.7 — Pro Pack on RunComfy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wan-2-7\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wan-image-video-generation-editting\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wan-image-video-generation-editting\",\"title\":\"Wan Image and Video Generation and Editting\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wan-image-video-generation-editting\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wangkang-skill-c\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wangkang-skill-c\",\"title\":\"wangkang-skill-c\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wangkang-skill-c\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:weather-1-0-0\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"weather-1-0-0\",\"title\":\"Weather 1.0.0\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/weather-1-0-0\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:web-search-plus-2-8-6\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"web-search-plus-2-8-6\",\"title\":\"Web Search Plus 2.8.6\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/web-search-plus-2-8-6\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wechat-moments-post\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wechat-moments-post\",\"title\":\"WeChat Moments Post\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wechat-moments-post\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wechat-qwen-reply\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wechat-qwen-reply\",\"title\":\"Wechat Qwen Reply\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wechat-qwen-reply\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wendao-partner-qclaw-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wendao-partner-qclaw-skill\",\"title\":\"Wendao Partner Qclaw Skill\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wendao-partner-qclaw-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wishfinity\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wishfinity\",\"title\":\"Wishfinity +W\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wishfinity\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wlcom-gui-automation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wlcom-gui-automation\",\"title\":\"wlcom GUI Automation\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wlcom-gui-automation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:wspaces-deploy\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"wspaces-deploy\",\"title\":\"W-Spaces Deploy\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/wspaces-deploy\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x\",\"title\":\"Moin\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-92bilal26-pptx\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-92bilal26-pptx\",\"title\":\"X 92bilal26 Pptx\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-92bilal26-pptx\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-algorithm\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-algorithm\",\"title\":\"X Algorithm\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-algorithm\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-api\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-api\",\"title\":\"X Api\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-api\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-api-v2\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-api-v2\",\"title\":\"X\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-api-v2\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-post-automation\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-post-automation\",\"title\":\"X(Twitter) Post Automation\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-post-automation\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:x-search\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"x-search\",\"title\":\"X Search\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/x-search\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:xiaomi-mimo-tts\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"xiaomi-mimo-tts\",\"title\":\"Xiaomi MiMo TTS\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/xiaomi-mimo-tts\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:y\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"y\",\"title\":\"yoga\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/y\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:y-combinator\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"y-combinator\",\"title\":\"Y Combinator\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/y-combinator\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yahoo-data-fetcher\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yahoo-data-fetcher\",\"title\":\"yahoo fetch data of stonks\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yahoo-data-fetcher\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yahoo-finance\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yahoo-finance\",\"title\":\"Yahoo Finance\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yahoo-finance\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yahoo-finance-cli\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yahoo-finance-cli\",\"title\":\"Yahoo Finance CLI\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yahoo-finance-cli\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yahoo-finance-forex\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yahoo-finance-forex\",\"title\":\"Yahoo Finance FOREX\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yahoo-finance-forex\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yc-cold-outreach\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yc-cold-outreach\",\"title\":\"YC Cold Outreach\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yc-cold-outreach\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:ydc-ai-sdk-integration\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"ydc-ai-sdk-integration\",\"title\":\"Integrate You.com web tools with Vercel AI SDK\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/ydc-ai-sdk-integration\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yfinance-mcp-server\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yfinance-mcp-server\",\"title\":\"Yfinance\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yfinance-mcp-server\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yidun-skill-sec\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yidun-skill-sec\",\"title\":\"Yidun Skill Sec\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yidun-skill-sec\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yield-agent\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yield-agent\",\"title\":\"Yield Agent\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yield-agent\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yijing-suangua\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yijing-suangua\",\"title\":\"易经占卜-yiJingDivination\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yijing-suangua\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:yuqing-bitable-and-label\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"yuqing-bitable-and-label\",\"title\":\"yuqing-bitable-and-label\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/yuqing-bitable-and-label\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z\",\"title\":\"z\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z-api\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z-api\",\"title\":\"Z Api\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z-api\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z-article-card\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z-article-card\",\"title\":\"z-article-card\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z-article-card\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z-card-image\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z-card-image\",\"title\":\"z-card-image\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z-card-image\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z-image\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z-image\",\"title\":\"Z Image API\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z-image\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n{\"op\":\"create\",\"type\":\"entity\",\"id\":\"skill:z-image-openapi-skill\",\"entityType\":\"Skill\",\"properties\":{\"slug\":\"z-image-openapi-skill\",\"title\":\"Z-Image AI Image Generator – Create High-Quality Images from Text Instantly\",\"inputTypes\":[],\"outputTypes\":[],\"source\":\"published\",\"clawHubUrl\":\"https://clawhub.ai/skills/z-image-openapi-skill\"},\"timestamp\":\"2026-06-02T23:10:40.292Z\"}\n" });
function ZT(e) {
	return e && typeof e == "object" ? e : {};
}
function QT(e, t) {
	let n = e[t];
	return typeof n == "string" && n.trim() ? n : void 0;
}
function $T(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), r;
	for (let i of e.split("\n")) {
		let e = i.trim();
		if (!e) continue;
		let a;
		try {
			a = JSON.parse(e);
		} catch {
			continue;
		}
		if ((!r || a.timestamp > r) && (r = a.timestamp), a.op === "delete") {
			t.delete(a.id), n.delete(a.id);
			continue;
		}
		if (a.type === "entity") {
			t.set(a.id, a), n.delete(a.id);
			continue;
		}
		n.set(a.id, a);
	}
	return {
		entities: t,
		relations: n,
		lastTimestamp: r
	};
}
function eE() {
	let e = Object.values(XT)[0] ?? "";
	if (!e) return {
		nodes: [],
		edges: [],
		meta: { fileCount: 0 }
	};
	let { entities: t, relations: n, lastTimestamp: r } = $T(e), i = [];
	for (let e of t.values()) {
		if (e.entityType !== "Skill" && e.entityType !== "DataType") continue;
		let t = ZT(e.properties), n = QT(t, "title") ?? QT(t, "name") ?? QT(t, "slug") ?? e.id, r = e.entityType === "Skill" ? QT(t, "clawHubUrl") ?? `services/grillmyskills/memory/ontology/graph.jsonl#${e.id}` : `services/grillmyskills/memory/ontology/graph.jsonl#${e.id}`;
		i.push({
			id: e.id,
			type: e.entityType,
			name: n,
			filePath: r,
			confidence: 1
		});
	}
	let a = new Set([
		"feeds_into",
		"covers_gap",
		"depends_on"
	]), o = [], s = /* @__PURE__ */ new Set();
	for (let e of n.values()) {
		if (!a.has(e.relationType)) continue;
		let t = `${e.from}->${e.to}:${e.relationType}`;
		s.has(t) || (s.add(t), o.push({
			source: e.from,
			target: e.to,
			type: e.relationType,
			confidence: 1
		}));
	}
	return {
		nodes: i,
		edges: o,
		meta: {
			builtAt: r,
			fileCount: i.length,
			sourceRoot: ""
		}
	};
}
//#endregion
//#region src/panels/GrillMySkillsPanel/useGrillMySkills.ts
var tE = "grillmyskills-session-id", nE = null;
function rE() {
	return typeof window > "u" ? "" : window.localStorage.getItem(tE) || "";
}
function iE(e) {
	typeof window > "u" || window.localStorage.setItem(tE, e);
}
function aE(e) {
	return e ? e.replace(/<script[\s\S]*?<\/script>/gi, " ").replace(/<style[\s\S]*?<\/style>/gi, " ").replace(/<[^>]+>/g, " ").replace(/[.#]?[a-z][\w-]*(?:\s+[.#]?[a-z][\w-]*)*\s*\{[^}]*\}/gi, " ").replace(/\b[a-z-]+\s*:\s*[^;{}]+;?/gi, " ").replace(/&nbsp;/gi, " ").replace(/&amp;/gi, "&").replace(/&lt;/gi, "<").replace(/&gt;/gi, ">").replace(/\s+/g, " ").trim() : "";
}
function oE(e) {
	if (!e) return null;
	let t = e.trim();
	if (!/^https?:\/\//i.test(t)) return null;
	try {
		return new URL(t).toString();
	} catch {
		return null;
	}
}
function sE(e) {
	return Array.isArray(e) ? e.map((e) => aE(typeof e == "string" ? e : "")).filter(Boolean) : [];
}
function cE(e) {
	return !e || e.length > 90 || /[{};]/.test(e) || /\b(font-family|max-width|padding|margin|viewport|container|text-decoration)\b/i.test(e) ? !1 : e.split(/\s+/).length <= 10;
}
function lE(e) {
	return (aE(e).split(/(?<=[.!?])\s+/)[0] ?? aE(e)).split(/\s+/).filter(Boolean).slice(0, 6).join(" ").replace(/[.,:;!?-]+$/g, "").trim();
}
function uE(e) {
	let t = aE(e.title), n = aE(e.oneLiner), r = aE(e.problem), i = aE(e.targetUser), a = aE(e.whyNow), o = cE(t) ? t : lE(n) || lE(r) || "Untitled Skill Idea", s = oE(e.clawHubUrl || e.hubUrl), c = !!(e.isPublished || s);
	return {
		...e,
		title: o,
		slug: aE(e.slug),
		oneLiner: n,
		problem: r,
		targetUser: i,
		whyNow: a,
		clawHubUrl: s,
		hubUrl: s,
		isPublished: c,
		inputTypes: sE(e.inputTypes),
		outputTypes: sE(e.outputTypes),
		topics: Array.isArray(e.topics) ? e.topics.map((e) => ({ topic: aE(e.topic) })).filter((e) => e.topic) : []
	};
}
function dE(e) {
	let t = X.grillmyskillsBaseUrl;
	if (t.startsWith("http://") || t.startsWith("https://")) {
		let n = t.endsWith("/") ? t : `${t}/`;
		return new URL(e.replace(/^\//, ""), n).toString();
	}
	return `${t.endsWith("/") ? t.slice(0, -1) : t}${e}`;
}
function fE(e) {
	return e instanceof Error && /Failed to fetch|NetworkError/i.test(e.message) ? "GrillMySkills service is unavailable. Start the GrillMySkills service or use `npm run dev:grillmyskills:ui`." : e instanceof Error ? e.message : "Failed to load GrillMySkills";
}
async function pE() {
	return nE ||= (async () => {
		let e = rE(), t = await fetch(dE(X.endpoints.grillmyskills.ideas), { headers: e ? { "x-session-id": e } : void 0 });
		if (!t.ok) throw Error(`Failed to load GrillMySkills feed (HTTP ${t.status})`);
		let n = await t.json(), r = t.headers.get("x-session-id"), i = [], a = {
			nodes: [],
			edges: []
		};
		try {
			let [e, t] = await Promise.all([fetch(dE(X.endpoints.grillmyskills.topics)), fetch(dE(X.endpoints.grillmyskills.graph))]);
			if (e.ok) {
				let t = await e.json();
				i = Array.isArray(t?.topics) ? t.topics : [];
			}
			if (t.ok) {
				let e = await t.json();
				a = {
					nodes: Array.isArray(e?.nodes) ? e.nodes : [],
					edges: Array.isArray(e?.edges) ? e.edges : []
				};
			}
		} catch {
			i = [], a = {
				nodes: [],
				edges: []
			};
		}
		return {
			ideas: Array.isArray(n?.data) ? n.data.map(uE) : [],
			topics: i,
			graph: a,
			sessionId: r
		};
	})().finally(() => {
		nE = null;
	}), nE;
}
function mE() {
	let [e, t] = h([]), [n, r] = h([]), [i, a] = h({
		nodes: [],
		edges: []
	}), [o, s] = h({}), [c, l] = h(() => rE()), [d, p] = h(!0), [m, g] = h(null);
	return u(() => {
		c && iE(c);
	}, [c]), u(() => {
		let e = !1;
		return (async () => {
			try {
				p(!0), g(null);
				let n = await pE();
				if (e) return;
				t(n.ideas), r(n.topics), a(n.graph), n.sessionId && l(n.sessionId);
			} catch (t) {
				e || g(fE(t));
			} finally {
				e || p(!1);
			}
		})(), () => {
			e = !0;
		};
	}, []), {
		ideas: e,
		topics: n,
		graph: i,
		dependenciesByIdea: o,
		sessionId: c,
		isLoading: d,
		error: m,
		...f(() => ({
			async vote(e, n) {
				let r = await fetch(dE(X.endpoints.grillmyskills.vote(e)), {
					method: "POST",
					headers: {
						"content-type": "application/json",
						...c ? { "x-session-id": c } : {}
					},
					body: JSON.stringify({ value: n })
				});
				if (!r.ok) throw Error("Vote failed");
				let i = r.headers.get("x-session-id");
				i && l(i);
				let a = await r.json().catch(() => null);
				t((t) => t.map((t) => t.id === e ? {
					...t,
					netVoteScore: typeof a?.idea?.netVoteScore == "number" ? a.idea.netVoteScore : t.netVoteScore + (n === "UP" ? 1 : -1),
					trendingScore: typeof a?.idea?.trendingScore == "number" ? a.idea.trendingScore : t.trendingScore
				} : t));
			},
			async materialize(e, t) {
				let n = await fetch(dE(X.endpoints.grillmyskills.materialize(e)), {
					method: "POST",
					headers: {
						authorization: `Bearer ${t}`,
						"content-type": "application/json"
					},
					body: JSON.stringify({})
				});
				if (!n.ok) throw Error("Materialization failed");
				return n.json();
			},
			async loadDependencies(e) {
				if (o[e]) return o[e];
				let t = await fetch(dE(X.endpoints.grillmyskills.dependencies(e)));
				if (!t.ok) throw Error("Failed to load idea dependencies");
				let n = await t.json(), r = {
					upstream: Array.isArray(n?.upstream) ? n.upstream : [],
					downstream: Array.isArray(n?.downstream) ? n.downstream : [],
					gaps: Array.isArray(n?.gaps) ? n.gaps : []
				};
				return s((t) => ({
					...t,
					[e]: r
				})), r;
			}
		}), [o, c])
	};
}
//#endregion
//#region src/panels/GrillMySkillsPanel/index.tsx
function hE({ className: e = "" }) {
	return /* @__PURE__ */ v("svg", {
		viewBox: "0 0 220 220",
		"aria-hidden": "true",
		className: e,
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [
			/* @__PURE__ */ _("ellipse", {
				cx: "110",
				cy: "116",
				rx: "34",
				ry: "44",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _("circle", {
				cx: "96",
				cy: "81",
				r: "6",
				fill: "#fff8d6"
			}),
			/* @__PURE__ */ _("circle", {
				cx: "124",
				cy: "81",
				r: "6",
				fill: "#fff8d6"
			}),
			/* @__PURE__ */ _("path", {
				d: "M84 53C70 41 50 34 28 36C40 55 58 67 79 72",
				stroke: "currentColor",
				strokeWidth: "12",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _("path", {
				d: "M136 53C150 41 170 34 192 36C180 55 162 67 141 72",
				stroke: "currentColor",
				strokeWidth: "12",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _("path", {
				d: "M90 161L72 196",
				stroke: "currentColor",
				strokeWidth: "10",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _("path", {
				d: "M110 168L108 205",
				stroke: "currentColor",
				strokeWidth: "10",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _("path", {
				d: "M130 161L148 196",
				stroke: "currentColor",
				strokeWidth: "10",
				strokeLinecap: "round"
			}),
			/* @__PURE__ */ _("path", {
				d: "M97 140C101 144 105 146 110 146C115 146 119 144 123 140",
				stroke: "#fff8d6",
				strokeWidth: "8",
				strokeLinecap: "round"
			})
		]
	});
}
var gE = eE(), _E = ["DataType", "Skill"], vE = {
	DataType: {
		label: "Data Types",
		accent: "#0ea5e9",
		surface: "rgba(14, 165, 233, 0.16)",
		description: "Data Types: ontology entities representing the inputs and outputs that Skills can consume or produce."
	},
	Skill: {
		label: "Skills",
		accent: "#22c55e",
		surface: "rgba(34, 197, 94, 0.16)",
		description: "Skills: ontology entities loaded from the local GrillMySkills graph snapshot."
	}
}, yE = {
	feeds_into: {
		label: "Feeds Into",
		stroke: "rgba(34,197,94,0.28)"
	},
	covers_gap: {
		label: "Covers Gap",
		stroke: "rgba(245,158,11,0.3)"
	},
	depends_on: {
		label: "Depends On",
		stroke: "rgba(148,163,184,0.28)"
	}
};
function bE() {
	let { ideas: e, topics: t, dependenciesByIdea: n, isLoading: r, error: i, vote: a, loadDependencies: o } = mE(), [s, c] = h(0), [l, d] = h("all"), [p, m] = h("review"), g = f(() => e.filter((e) => l === "all" ? !0 : l === "published" ? !!e.isPublished : !e.isPublished), [l, e]);
	if (u(() => {
		if (g.length === 0) {
			c(0);
			return;
		}
		c((e) => Math.min(e, g.length - 1));
	}, [g.length]), r) return /* @__PURE__ */ _("div", {
		className: "rounded-[2rem] border border-[#f6d88d] bg-[linear-gradient(180deg,#f9ffff_0%,#d7fbff_45%,#bceef7_100%)] p-6 text-slate-800 shadow-[0_20px_60px_rgba(46,107,138,0.14)]",
		children: "Loading GrillMySkills..."
	});
	if (i) return /* @__PURE__ */ _("div", {
		className: "rounded-[2rem] border border-rose-200 bg-rose-50 p-6 text-rose-900 shadow-[0_20px_60px_rgba(190,80,100,0.12)]",
		children: i
	});
	let y = g[s] ?? null, b = async (e) => {
		y && (await a(y.id, e), c((e) => g.length <= 1 ? 0 : Math.min(e + 1, g.length - 1)));
	};
	return /* @__PURE__ */ v("section", {
		className: "relative rounded-[2rem] border border-[#f5d48d] bg-[linear-gradient(180deg,#fefdf4_0%,#ddfbff_18%,#bbf0f6_52%,#ffbfc9_100%)] p-6 text-slate-800 shadow-[0_24px_70px_rgba(61,121,149,0.16)]",
		children: [
			/* @__PURE__ */ v("div", {
				className: "pointer-events-none absolute inset-0 overflow-hidden rounded-[2rem]",
				children: [
					/* @__PURE__ */ _("div", { className: "absolute inset-0 bg-[radial-gradient(circle_at_15%_18%,rgba(255,255,255,0.9)_0%,rgba(255,255,255,0)_18%),radial-gradient(circle_at_78%_22%,rgba(255,221,153,0.42)_0%,rgba(255,221,153,0)_20%),radial-gradient(circle_at_26%_82%,rgba(255,122,148,0.26)_0%,rgba(255,122,148,0)_20%),radial-gradient(circle_at_90%_76%,rgba(123,224,255,0.28)_0%,rgba(123,224,255,0)_18%)]" }),
					/* @__PURE__ */ _("div", { className: "absolute inset-x-0 top-0 h-56 bg-[repeating-linear-gradient(102deg,rgba(255,255,255,0.55)_0px,rgba(255,255,255,0.55)_10px,rgba(255,255,255,0)_10px,rgba(255,255,255,0)_56px)] opacity-45" }),
					/* @__PURE__ */ _("div", { className: "absolute bottom-0 left-0 right-0 h-36 bg-[linear-gradient(180deg,rgba(255,144,168,0)_0%,rgba(255,141,161,0.2)_35%,rgba(251,126,155,0.42)_100%)]" }),
					/* @__PURE__ */ _("div", { className: "absolute bottom-4 left-10 h-16 w-32 rounded-[100%_30%_80%_40%] bg-[#ff8ca5]/35 blur-[2px]" }),
					/* @__PURE__ */ _("div", { className: "absolute bottom-2 right-12 h-20 w-36 rounded-[35%_100%_40%_90%] bg-[#ffb45f]/35 blur-[2px]" }),
					/* @__PURE__ */ _("div", { className: "absolute bottom-10 left-1/3 h-12 w-28 rounded-[70%_45%_100%_30%] bg-[#88f2ff]/30 blur-[1px]" }),
					/* @__PURE__ */ _(hE, { className: "absolute left-4 top-6 h-24 w-24 -rotate-12 text-[#ff7c79]/60" }),
					/* @__PURE__ */ _(hE, { className: "absolute right-6 top-10 h-20 w-20 rotate-12 text-[#ff9369]/55" })
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "relative mb-6 flex flex-col gap-5 lg:flex-row lg:items-end lg:justify-between",
				children: [/* @__PURE__ */ v("div", {
					className: "max-w-3xl",
					children: [
						/* @__PURE__ */ _("p", {
							className: "text-xs uppercase tracking-[0.4em] text-[#7a5a1d]",
							children: "GrillMySkills"
						}),
						/* @__PURE__ */ _("h2", {
							className: "mt-3 font-serif text-4xl leading-tight text-slate-900 lg:text-5xl",
							children: "Vote the next interview drill into your practice sprint."
						}),
						/* @__PURE__ */ v("p", {
							className: "mt-3 max-w-2xl text-sm leading-6 text-slate-700",
							children: [
								"Review candidate drills, spot what is already backed by ",
								/* @__PURE__ */ _("a", {
									href: "https://clawhub.ai",
									target: "_blank",
									rel: "noopener noreferrer",
									className: "underline underline-offset-2 hover:opacity-75",
									children: "ClawHub"
								}),
								", and follow the graph to build a focused interview prep pack."
							]
						})
					]
				}), /* @__PURE__ */ _("div", {
					className: "grid grid-cols-2 gap-3 text-sm text-slate-700",
					children: t.slice(0, 4).map((e, t) => /* @__PURE__ */ v("div", {
						className: "rounded-[1.25rem] border border-white/85 bg-white/72 px-4 py-3 shadow-[0_12px_28px_rgba(73,129,156,0.14)] backdrop-blur",
						children: [
							/* @__PURE__ */ _("div", {
								className: "text-[10px] uppercase tracking-[0.3em] text-[#8b6b2c]/55",
								children: t === 0 ? "Gold Current" : t === 1 ? "Silver Current" : t === 2 ? "Bronze Current" : `Current ${t + 1}`
							}),
							/* @__PURE__ */ _("div", {
								className: "mt-1 font-medium text-slate-900",
								children: e.name
							}),
							/* @__PURE__ */ v("div", {
								className: "mt-1 text-slate-600",
								children: [e.netScore, " score"]
							})
						]
					}, e.name))
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "relative mb-5 flex flex-col gap-3 rounded-[1.5rem] border border-white/85 bg-white/78 p-4 shadow-[0_14px_36px_rgba(73,129,156,0.12)] lg:flex-row lg:items-center lg:justify-between",
				children: [/* @__PURE__ */ _("div", {
					className: "flex flex-wrap gap-2",
					children: [
						["all", "All"],
						["published", "On ClawHub"],
						["innovative", "Innovative"]
					].map(([e, t]) => /* @__PURE__ */ _("button", {
						type: "button",
						onClick: () => d(e),
						className: `rounded-full px-4 py-2 text-sm transition ${l === e ? "bg-slate-900 text-white" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`,
						children: t
					}, e))
				}), /* @__PURE__ */ _("div", {
					className: "flex flex-wrap gap-2",
					children: [["review", "Review"], ["graph", "Graph"]].map(([e, t]) => /* @__PURE__ */ _("button", {
						type: "button",
						onClick: () => m(e),
						className: `rounded-full px-4 py-2 text-sm transition ${p === e ? "bg-[#0e9f94] text-white" : "border border-sky-200 bg-white text-slate-700 hover:bg-sky-50"}`,
						children: t
					}, e))
				})]
			}),
			p === "graph" ? /* @__PURE__ */ _("div", {
				className: "-mx-2",
				children: /* @__PURE__ */ _(NT, {
					badgeLabel: "GrillMySkills Ontology",
					title: "Skill Ontology Graph",
					description: "Explore the local GrillMySkills ontology snapshot with Skills, DataTypes, and the relation patterns that connect them.",
					searchPlaceholder: "workflow-dashboard, auto-workflow-builder, feeds_into...",
					graph: gE,
					typeOrder: _E,
					typeMeta: vE,
					edgeMeta: yE,
					defaultSelectedTypes: {
						DataType: !0,
						Skill: !0
					},
					compactNodeLimit: 180,
					compactEdgeLimit: 360
				})
			}) : g.length === 0 ? /* @__PURE__ */ _("div", {
				className: "mt-6 rounded-[1.6rem] border border-white/80 bg-white/80 p-5 text-sm text-slate-700 shadow-[0_16px_40px_rgba(73,129,156,0.12)]",
				children: "No ideas match this filter yet."
			}) : /* @__PURE__ */ v("div", {
				className: "space-y-5",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-col gap-3 rounded-[1.5rem] border border-white/85 bg-white/78 p-4 shadow-[0_14px_36px_rgba(73,129,156,0.12)] lg:flex-row lg:items-center lg:justify-between",
					children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
						className: "text-xs uppercase tracking-[0.25em] text-[#8b6b2c]/55",
						children: "Coral Focus"
					}), /* @__PURE__ */ v("p", {
						className: "mt-1 text-sm text-slate-700",
						children: [
							"Idea ",
							s + 1,
							" of ",
							g.length
						]
					})] }), /* @__PURE__ */ v("div", {
						className: "flex gap-2",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => c((e) => Math.max(0, e - 1)),
							disabled: s === 0,
							className: "rounded-full border border-sky-200 bg-white px-4 py-2 text-sm text-slate-700 transition hover:bg-sky-50 disabled:cursor-not-allowed disabled:opacity-40",
							children: "Previous"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => c((e) => Math.min(g.length - 1, e + 1)),
							disabled: s >= g.length - 1,
							className: "rounded-full border border-sky-200 bg-white px-4 py-2 text-sm text-slate-700 transition hover:bg-sky-50 disabled:cursor-not-allowed disabled:opacity-40",
							children: "Next"
						})]
					})]
				}), y ? /* @__PURE__ */ _(YT, {
					idea: y,
					dependencies: n[y.id] ?? null,
					onLoadDependencies: () => o(y.id),
					onVote: (e) => void b(e)
				}) : null]
			})
		]
	});
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-parser@5.2.3/node_modules/engine.io-parser/build/esm/commons.js
var xE = Object.create(null);
xE.open = "0", xE.close = "1", xE.ping = "2", xE.pong = "3", xE.message = "4", xE.upgrade = "5", xE.noop = "6";
var SE = Object.create(null);
Object.keys(xE).forEach((e) => {
	SE[xE[e]] = e;
});
var CE = {
	type: "error",
	data: "parser error"
}, wE = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", TE = typeof ArrayBuffer == "function", EE = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, DE = ({ type: e, data: t }, n, r) => wE && t instanceof Blob ? n ? r(t) : OE(t, r) : TE && (t instanceof ArrayBuffer || EE(t)) ? n ? r(t) : OE(new Blob([t]), r) : r(xE[e] + (t || "")), OE = (e, t) => {
	let n = new FileReader();
	return n.onload = function() {
		let e = n.result.split(",")[1];
		t("b" + (e || ""));
	}, n.readAsDataURL(e);
};
function kE(e) {
	return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
var AE;
function jE(e, t) {
	if (wE && e.data instanceof Blob) return e.data.arrayBuffer().then(kE).then(t);
	if (TE && (e.data instanceof ArrayBuffer || EE(e.data))) return t(kE(e.data));
	DE(e, !1, (e) => {
		AE ||= new TextEncoder(), t(AE.encode(e));
	});
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-parser@5.2.3/node_modules/engine.io-parser/build/esm/contrib/base64-arraybuffer.js
var ME = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", NE = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < 64; e++) NE[ME.charCodeAt(e)] = e;
var PE = (e) => {
	let t = e.length * .75, n = e.length, r, i = 0, a, o, s, c;
	e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
	let l = new ArrayBuffer(t), u = new Uint8Array(l);
	for (r = 0; r < n; r += 4) a = NE[e.charCodeAt(r)], o = NE[e.charCodeAt(r + 1)], s = NE[e.charCodeAt(r + 2)], c = NE[e.charCodeAt(r + 3)], u[i++] = a << 2 | o >> 4, u[i++] = (o & 15) << 4 | s >> 2, u[i++] = (s & 3) << 6 | c & 63;
	return l;
}, FE = typeof ArrayBuffer == "function", IE = (e, t) => {
	if (typeof e != "string") return {
		type: "message",
		data: RE(e, t)
	};
	let n = e.charAt(0);
	return n === "b" ? {
		type: "message",
		data: LE(e.substring(1), t)
	} : SE[n] ? e.length > 1 ? {
		type: SE[n],
		data: e.substring(1)
	} : { type: SE[n] } : CE;
}, LE = (e, t) => FE ? RE(PE(e), t) : {
	base64: !0,
	data: e
}, RE = (e, t) => {
	switch (t) {
		case "blob": return e instanceof Blob ? e : new Blob([e]);
		default: return e instanceof ArrayBuffer ? e : e.buffer;
	}
}, zE = "", BE = (e, t) => {
	let n = e.length, r = Array(n), i = 0;
	e.forEach((e, a) => {
		DE(e, !1, (e) => {
			r[a] = e, ++i === n && t(r.join(zE));
		});
	});
}, VE = (e, t) => {
	let n = e.split(zE), r = [];
	for (let e = 0; e < n.length; e++) {
		let i = IE(n[e], t);
		if (r.push(i), i.type === "error") break;
	}
	return r;
};
function HE() {
	return new TransformStream({ transform(e, t) {
		jE(e, (n) => {
			let r = n.length, i;
			if (r < 126) i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
			else if (r < 65536) {
				i = new Uint8Array(3);
				let e = new DataView(i.buffer);
				e.setUint8(0, 126), e.setUint16(1, r);
			} else {
				i = new Uint8Array(9);
				let e = new DataView(i.buffer);
				e.setUint8(0, 127), e.setBigUint64(1, BigInt(r));
			}
			e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
		});
	} });
}
var UE;
function WE(e) {
	return e.reduce((e, t) => e + t.length, 0);
}
function GE(e, t) {
	if (e[0].length === t) return e.shift();
	let n = new Uint8Array(t), r = 0;
	for (let i = 0; i < t; i++) n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
	return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function KE(e, t) {
	UE ||= new TextDecoder();
	let n = [], r = 0, i = -1, a = !1;
	return new TransformStream({ transform(o, s) {
		for (n.push(o);;) {
			if (r === 0) {
				if (WE(n) < 1) break;
				let e = GE(n, 1);
				a = (e[0] & 128) == 128, i = e[0] & 127, r = i < 126 ? 3 : i === 126 ? 1 : 2;
			} else if (r === 1) {
				if (WE(n) < 2) break;
				let e = GE(n, 2);
				i = new DataView(e.buffer, e.byteOffset, e.length).getUint16(0), r = 3;
			} else if (r === 2) {
				if (WE(n) < 8) break;
				let e = GE(n, 8), t = new DataView(e.buffer, e.byteOffset, e.length), a = t.getUint32(0);
				if (a > 2 ** 21 - 1) {
					s.enqueue(CE);
					break;
				}
				i = a * 2 ** 32 + t.getUint32(4), r = 3;
			} else {
				if (WE(n) < i) break;
				let e = GE(n, i);
				s.enqueue(IE(a ? e : UE.decode(e), t)), r = 0;
			}
			if (i === 0 || i > e) {
				s.enqueue(CE);
				break;
			}
		}
	} });
}
//#endregion
//#region ../node_modules/.pnpm/@socket.io+component-emitter@3.1.2/node_modules/@socket.io/component-emitter/lib/esm/index.js
function qE(e) {
	if (e) return JE(e);
}
function JE(e) {
	for (var t in qE.prototype) e[t] = qE.prototype[t];
	return e;
}
qE.prototype.on = qE.prototype.addEventListener = function(e, t) {
	return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
}, qE.prototype.once = function(e, t) {
	function n() {
		this.off(e, n), t.apply(this, arguments);
	}
	return n.fn = t, this.on(e, n), this;
}, qE.prototype.off = qE.prototype.removeListener = qE.prototype.removeAllListeners = qE.prototype.removeEventListener = function(e, t) {
	if (this._callbacks = this._callbacks || {}, arguments.length == 0) return this._callbacks = {}, this;
	var n = this._callbacks["$" + e];
	if (!n) return this;
	if (arguments.length == 1) return delete this._callbacks["$" + e], this;
	for (var r, i = 0; i < n.length; i++) if (r = n[i], r === t || r.fn === t) {
		n.splice(i, 1);
		break;
	}
	return n.length === 0 && delete this._callbacks["$" + e], this;
}, qE.prototype.emit = function(e) {
	this._callbacks = this._callbacks || {};
	for (var t = Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++) t[r - 1] = arguments[r];
	if (n) {
		n = n.slice(0);
		for (var r = 0, i = n.length; r < i; ++r) n[r].apply(this, t);
	}
	return this;
}, qE.prototype.emitReserved = qE.prototype.emit, qE.prototype.listeners = function(e) {
	return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
}, qE.prototype.hasListeners = function(e) {
	return !!this.listeners(e).length;
};
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/globals.js
var YE = typeof Promise == "function" && typeof Promise.resolve == "function" ? (e) => Promise.resolve().then(e) : (e, t) => t(e, 0), XE = typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")(), ZE = "arraybuffer";
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/util.js
function QE(e, ...t) {
	return t.reduce((t, n) => (e.hasOwnProperty(n) && (t[n] = e[n]), t), {});
}
var $E = XE.setTimeout, eD = XE.clearTimeout;
function tD(e, t) {
	t.useNativeTimers ? (e.setTimeoutFn = $E.bind(XE), e.clearTimeoutFn = eD.bind(XE)) : (e.setTimeoutFn = XE.setTimeout.bind(XE), e.clearTimeoutFn = XE.clearTimeout.bind(XE));
}
var nD = 1.33;
function rD(e) {
	return typeof e == "string" ? iD(e) : Math.ceil((e.byteLength || e.size) * nD);
}
function iD(e) {
	let t = 0, n = 0;
	for (let r = 0, i = e.length; r < i; r++) t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
	return n;
}
function aD() {
	return Date.now().toString(36).substring(3) + Math.random().toString(36).substring(2, 5);
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/contrib/parseqs.js
function oD(e) {
	let t = "";
	for (let n in e) e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
	return t;
}
function sD(e) {
	let t = {}, n = e.split("&");
	for (let e = 0, r = n.length; e < r; e++) {
		let r = n[e].split("=");
		t[decodeURIComponent(r[0])] = decodeURIComponent(r[1]);
	}
	return t;
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/transport.js
var cD = class extends Error {
	constructor(e, t, n) {
		super(e), this.description = t, this.context = n, this.type = "TransportError";
	}
}, lD = class extends qE {
	constructor(e) {
		super(), this.writable = !1, tD(this, e), this.opts = e, this.query = e.query, this.socket = e.socket, this.supportsBinary = !e.forceBase64;
	}
	onError(e, t, n) {
		return super.emitReserved("error", new cD(e, t, n)), this;
	}
	open() {
		return this.readyState = "opening", this.doOpen(), this;
	}
	close() {
		return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
	}
	send(e) {
		this.readyState === "open" && this.write(e);
	}
	onOpen() {
		this.readyState = "open", this.writable = !0, super.emitReserved("open");
	}
	onData(e) {
		let t = IE(e, this.socket.binaryType);
		this.onPacket(t);
	}
	onPacket(e) {
		super.emitReserved("packet", e);
	}
	onClose(e) {
		this.readyState = "closed", super.emitReserved("close", e);
	}
	pause(e) {}
	createUri(e, t = {}) {
		return e + "://" + this._hostname() + this._port() + this.opts.path + this._query(t);
	}
	_hostname() {
		let e = this.opts.hostname;
		return e.indexOf(":") === -1 ? e : "[" + e + "]";
	}
	_port() {
		return this.opts.port && (this.opts.secure && Number(this.opts.port) !== 443 || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
	}
	_query(e) {
		let t = oD(e);
		return t.length ? "?" + t : "";
	}
}, uD = class extends lD {
	constructor() {
		super(...arguments), this._polling = !1;
	}
	get name() {
		return "polling";
	}
	doOpen() {
		this._poll();
	}
	pause(e) {
		this.readyState = "pausing";
		let t = () => {
			this.readyState = "paused", e();
		};
		if (this._polling || !this.writable) {
			let e = 0;
			this._polling && (e++, this.once("pollComplete", function() {
				--e || t();
			})), this.writable || (e++, this.once("drain", function() {
				--e || t();
			}));
		} else t();
	}
	_poll() {
		this._polling = !0, this.doPoll(), this.emitReserved("poll");
	}
	onData(e) {
		VE(e, this.socket.binaryType).forEach((e) => {
			if (this.readyState === "opening" && e.type === "open" && this.onOpen(), e.type === "close") return this.onClose({ description: "transport closed by the server" }), !1;
			this.onPacket(e);
		}), this.readyState !== "closed" && (this._polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this._poll());
	}
	doClose() {
		let e = () => {
			this.write([{ type: "close" }]);
		};
		this.readyState === "open" ? e() : this.once("open", e);
	}
	write(e) {
		this.writable = !1, BE(e, (e) => {
			this.doWrite(e, () => {
				this.writable = !0, this.emitReserved("drain");
			});
		});
	}
	uri() {
		let e = this.opts.secure ? "https" : "http", t = this.query || {};
		return !1 !== this.opts.timestampRequests && (t[this.opts.timestampParam] = aD()), !this.supportsBinary && !t.sid && (t.b64 = 1), this.createUri(e, t);
	}
}, dD = !1;
try {
	dD = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {}
var fD = dD;
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/transports/polling-xhr.js
function pD() {}
var mD = class extends uD {
	constructor(e) {
		if (super(e), typeof location < "u") {
			let t = location.protocol === "https:", n = location.port;
			n ||= t ? "443" : "80", this.xd = typeof location < "u" && e.hostname !== location.hostname || n !== e.port;
		}
	}
	doWrite(e, t) {
		let n = this.request({
			method: "POST",
			data: e
		});
		n.on("success", t), n.on("error", (e, t) => {
			this.onError("xhr post error", e, t);
		});
	}
	doPoll() {
		let e = this.request();
		e.on("data", this.onData.bind(this)), e.on("error", (e, t) => {
			this.onError("xhr poll error", e, t);
		}), this.pollXhr = e;
	}
}, hD = class e extends qE {
	constructor(e, t, n) {
		super(), this.createRequest = e, tD(this, n), this._opts = n, this._method = n.method || "GET", this._uri = t, this._data = n.data === void 0 ? null : n.data, this._create();
	}
	_create() {
		var t;
		let n = QE(this._opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
		n.xdomain = !!this._opts.xd;
		let r = this._xhr = this.createRequest(n);
		try {
			r.open(this._method, this._uri, !0);
			try {
				if (this._opts.extraHeaders) {
					r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
					for (let e in this._opts.extraHeaders) this._opts.extraHeaders.hasOwnProperty(e) && r.setRequestHeader(e, this._opts.extraHeaders[e]);
				}
			} catch {}
			if (this._method === "POST") try {
				r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
			} catch {}
			try {
				r.setRequestHeader("Accept", "*/*");
			} catch {}
			(t = this._opts.cookieJar) == null || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this._opts.withCredentials), this._opts.requestTimeout && (r.timeout = this._opts.requestTimeout), r.onreadystatechange = () => {
				var e;
				r.readyState === 3 && ((e = this._opts.cookieJar) == null || e.parseCookies(r.getResponseHeader("set-cookie"))), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this._onLoad() : this.setTimeoutFn(() => {
					this._onError(typeof r.status == "number" ? r.status : 0);
				}, 0));
			}, r.send(this._data);
		} catch (e) {
			this.setTimeoutFn(() => {
				this._onError(e);
			}, 0);
			return;
		}
		typeof document < "u" && (this._index = e.requestsCount++, e.requests[this._index] = this);
	}
	_onError(e) {
		this.emitReserved("error", e, this._xhr), this._cleanup(!0);
	}
	_cleanup(t) {
		if (!(this._xhr === void 0 || this._xhr === null)) {
			if (this._xhr.onreadystatechange = pD, t) try {
				this._xhr.abort();
			} catch {}
			typeof document < "u" && delete e.requests[this._index], this._xhr = null;
		}
	}
	_onLoad() {
		let e = this._xhr.responseText;
		e !== null && (this.emitReserved("data", e), this.emitReserved("success"), this._cleanup());
	}
	abort() {
		this._cleanup();
	}
};
if (hD.requestsCount = 0, hD.requests = {}, typeof document < "u") {
	if (typeof attachEvent == "function") attachEvent("onunload", gD);
	else if (typeof addEventListener == "function") {
		let e = "onpagehide" in XE ? "pagehide" : "unload";
		addEventListener(e, gD, !1);
	}
}
function gD() {
	for (let e in hD.requests) hD.requests.hasOwnProperty(e) && hD.requests[e].abort();
}
var _D = (function() {
	let e = yD({ xdomain: !1 });
	return e && e.responseType !== null;
})(), vD = class extends mD {
	constructor(e) {
		super(e);
		let t = e && e.forceBase64;
		this.supportsBinary = _D && !t;
	}
	request(e = {}) {
		return Object.assign(e, { xd: this.xd }, this.opts), new hD(yD, this.uri(), e);
	}
};
function yD(e) {
	let t = e.xdomain;
	try {
		if (typeof XMLHttpRequest < "u" && (!t || fD)) return new XMLHttpRequest();
	} catch {}
	if (!t) try {
		return new XE[["Active", "Object"].join("X")]("Microsoft.XMLHTTP");
	} catch {}
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/transports/websocket.js
var bD = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative", xD = class extends lD {
	get name() {
		return "websocket";
	}
	doOpen() {
		let e = this.uri(), t = this.opts.protocols, n = bD ? {} : QE(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
		this.opts.extraHeaders && (n.headers = this.opts.extraHeaders);
		try {
			this.ws = this.createSocket(e, t, n);
		} catch (e) {
			return this.emitReserved("error", e);
		}
		this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
	}
	addEventListeners() {
		this.ws.onopen = () => {
			this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
		}, this.ws.onclose = (e) => this.onClose({
			description: "websocket connection closed",
			context: e
		}), this.ws.onmessage = (e) => this.onData(e.data), this.ws.onerror = (e) => this.onError("websocket error", e);
	}
	write(e) {
		this.writable = !1;
		for (let t = 0; t < e.length; t++) {
			let n = e[t], r = t === e.length - 1;
			DE(n, this.supportsBinary, (e) => {
				try {
					this.doWrite(n, e);
				} catch {}
				r && YE(() => {
					this.writable = !0, this.emitReserved("drain");
				}, this.setTimeoutFn);
			});
		}
	}
	doClose() {
		this.ws !== void 0 && (this.ws.onerror = () => {}, this.ws.close(), this.ws = null);
	}
	uri() {
		let e = this.opts.secure ? "wss" : "ws", t = this.query || {};
		return this.opts.timestampRequests && (t[this.opts.timestampParam] = aD()), this.supportsBinary || (t.b64 = 1), this.createUri(e, t);
	}
}, SD = XE.WebSocket || XE.MozWebSocket, CD = {
	websocket: class extends xD {
		createSocket(e, t, n) {
			return bD ? new SD(e, t, n) : t ? new SD(e, t) : new SD(e);
		}
		doWrite(e, t) {
			this.ws.send(t);
		}
	},
	webtransport: class extends lD {
		get name() {
			return "webtransport";
		}
		doOpen() {
			try {
				this._transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]);
			} catch (e) {
				return this.emitReserved("error", e);
			}
			this._transport.closed.then(() => {
				this.onClose();
			}).catch((e) => {
				this.onError("webtransport error", e);
			}), this._transport.ready.then(() => {
				this._transport.createBidirectionalStream().then((e) => {
					let t = KE(2 ** 53 - 1, this.socket.binaryType), n = e.readable.pipeThrough(t).getReader(), r = HE();
					r.readable.pipeTo(e.writable), this._writer = r.writable.getWriter();
					let i = () => {
						n.read().then(({ done: e, value: t }) => {
							e || (this.onPacket(t), i());
						}).catch((e) => {});
					};
					i();
					let a = { type: "open" };
					this.query.sid && (a.data = `{"sid":"${this.query.sid}"}`), this._writer.write(a).then(() => this.onOpen());
				});
			});
		}
		write(e) {
			this.writable = !1;
			for (let t = 0; t < e.length; t++) {
				let n = e[t], r = t === e.length - 1;
				this._writer.write(n).then(() => {
					r && YE(() => {
						this.writable = !0, this.emitReserved("drain");
					}, this.setTimeoutFn);
				});
			}
		}
		doClose() {
			var e;
			(e = this._transport) == null || e.close();
		}
	},
	polling: vD
}, wD = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, TD = [
	"source",
	"protocol",
	"authority",
	"userInfo",
	"user",
	"password",
	"host",
	"port",
	"relative",
	"path",
	"directory",
	"file",
	"query",
	"anchor"
];
function ED(e) {
	if (e.length > 8e3) throw "URI too long";
	let t = e, n = e.indexOf("["), r = e.indexOf("]");
	n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
	let i = wD.exec(e || ""), a = {}, o = 14;
	for (; o--;) a[TD[o]] = i[o] || "";
	return n != -1 && r != -1 && (a.source = t, a.host = a.host.substring(1, a.host.length - 1).replace(/;/g, ":"), a.authority = a.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), a.ipv6uri = !0), a.pathNames = DD(a, a.path), a.queryKey = OD(a, a.query), a;
}
function DD(e, t) {
	let n = t.replace(/\/{2,9}/g, "/").split("/");
	return (t.slice(0, 1) == "/" || t.length === 0) && n.splice(0, 1), t.slice(-1) == "/" && n.splice(n.length - 1, 1), n;
}
function OD(e, t) {
	let n = {};
	return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(e, t, r) {
		t && (n[t] = r);
	}), n;
}
//#endregion
//#region ../node_modules/.pnpm/engine.io-client@6.6.5_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/engine.io-client/build/esm/socket.js
var kD = typeof addEventListener == "function" && typeof removeEventListener == "function", AD = [];
kD && addEventListener("offline", () => {
	AD.forEach((e) => e());
}, !1);
var jD = class e extends qE {
	constructor(e, t) {
		if (super(), this.binaryType = ZE, this.writeBuffer = [], this._prevBufferLen = 0, this._pingInterval = -1, this._pingTimeout = -1, this._maxPayload = -1, this._pingTimeoutTime = Infinity, e && typeof e == "object" && (t = e, e = null), e) {
			let n = ED(e);
			t.hostname = n.host, t.secure = n.protocol === "https" || n.protocol === "wss", t.port = n.port, n.query && (t.query = n.query);
		} else t.host && (t.hostname = ED(t.host).host);
		tD(this, t), this.secure = t.secure == null ? typeof location < "u" && location.protocol === "https:" : t.secure, t.hostname && !t.port && (t.port = this.secure ? "443" : "80"), this.hostname = t.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = t.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = [], this._transportsByName = {}, t.transports.forEach((e) => {
			let t = e.prototype.name;
			this.transports.push(t), this._transportsByName[t] = e;
		}), this.opts = Object.assign({
			path: "/engine.io",
			agent: !1,
			withCredentials: !1,
			upgrade: !0,
			timestampParam: "t",
			rememberUpgrade: !1,
			addTrailingSlash: !0,
			rejectUnauthorized: !0,
			perMessageDeflate: { threshold: 1024 },
			transportOptions: {},
			closeOnBeforeunload: !1
		}, t), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = sD(this.opts.query)), kD && (this.opts.closeOnBeforeunload && (this._beforeunloadEventListener = () => {
			this.transport && (this.transport.removeAllListeners(), this.transport.close());
		}, addEventListener("beforeunload", this._beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this._offlineEventListener = () => {
			this._onClose("transport close", { description: "network connection lost" });
		}, AD.push(this._offlineEventListener))), this.opts.withCredentials && (this._cookieJar = void 0), this._open();
	}
	createTransport(e) {
		let t = Object.assign({}, this.opts.query);
		t.EIO = 4, t.transport = e, this.id && (t.sid = this.id);
		let n = Object.assign({}, this.opts, {
			query: t,
			socket: this,
			hostname: this.hostname,
			secure: this.secure,
			port: this.port
		}, this.opts.transportOptions[e]);
		return new this._transportsByName[e](n);
	}
	_open() {
		if (this.transports.length === 0) {
			this.setTimeoutFn(() => {
				this.emitReserved("error", "No transports available");
			}, 0);
			return;
		}
		let t = this.opts.rememberUpgrade && e.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1 ? "websocket" : this.transports[0];
		this.readyState = "opening";
		let n = this.createTransport(t);
		n.open(), this.setTransport(n);
	}
	setTransport(e) {
		this.transport && this.transport.removeAllListeners(), this.transport = e, e.on("drain", this._onDrain.bind(this)).on("packet", this._onPacket.bind(this)).on("error", this._onError.bind(this)).on("close", (e) => this._onClose("transport close", e));
	}
	onOpen() {
		this.readyState = "open", e.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush();
	}
	_onPacket(e) {
		if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") switch (this.emitReserved("packet", e), this.emitReserved("heartbeat"), e.type) {
			case "open":
				this.onHandshake(JSON.parse(e.data));
				break;
			case "ping":
				this._sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong"), this._resetPingTimeout();
				break;
			case "error":
				let t = /* @__PURE__ */ Error("server error");
				t.code = e.data, this._onError(t);
				break;
			case "message":
				this.emitReserved("data", e.data), this.emitReserved("message", e.data);
				break;
		}
	}
	onHandshake(e) {
		this.emitReserved("handshake", e), this.id = e.sid, this.transport.query.sid = e.sid, this._pingInterval = e.pingInterval, this._pingTimeout = e.pingTimeout, this._maxPayload = e.maxPayload, this.onOpen(), this.readyState !== "closed" && this._resetPingTimeout();
	}
	_resetPingTimeout() {
		this.clearTimeoutFn(this._pingTimeoutTimer);
		let e = this._pingInterval + this._pingTimeout;
		this._pingTimeoutTime = Date.now() + e, this._pingTimeoutTimer = this.setTimeoutFn(() => {
			this._onClose("ping timeout");
		}, e), this.opts.autoUnref && this._pingTimeoutTimer.unref();
	}
	_onDrain() {
		this.writeBuffer.splice(0, this._prevBufferLen), this._prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
	}
	flush() {
		if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
			let e = this._getWritablePackets();
			this.transport.send(e), this._prevBufferLen = e.length, this.emitReserved("flush");
		}
	}
	_getWritablePackets() {
		if (!(this._maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1)) return this.writeBuffer;
		let e = 1;
		for (let t = 0; t < this.writeBuffer.length; t++) {
			let n = this.writeBuffer[t].data;
			if (n && (e += rD(n)), t > 0 && e > this._maxPayload) return this.writeBuffer.slice(0, t);
			e += 2;
		}
		return this.writeBuffer;
	}
	_hasPingExpired() {
		if (!this._pingTimeoutTime) return !0;
		let e = Date.now() > this._pingTimeoutTime;
		return e && (this._pingTimeoutTime = 0, YE(() => {
			this._onClose("ping timeout");
		}, this.setTimeoutFn)), e;
	}
	write(e, t, n) {
		return this._sendPacket("message", e, t, n), this;
	}
	send(e, t, n) {
		return this._sendPacket("message", e, t, n), this;
	}
	_sendPacket(e, t, n, r) {
		if (typeof t == "function" && (r = t, t = void 0), typeof n == "function" && (r = n, n = null), this.readyState === "closing" || this.readyState === "closed") return;
		n ||= {}, n.compress = !1 !== n.compress;
		let i = {
			type: e,
			data: t,
			options: n
		};
		this.emitReserved("packetCreate", i), this.writeBuffer.push(i), r && this.once("flush", r), this.flush();
	}
	close() {
		let e = () => {
			this._onClose("forced close"), this.transport.close();
		}, t = () => {
			this.off("upgrade", t), this.off("upgradeError", t), e();
		}, n = () => {
			this.once("upgrade", t), this.once("upgradeError", t);
		};
		return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
			this.upgrading ? n() : e();
		}) : this.upgrading ? n() : e()), this;
	}
	_onError(t) {
		if (e.priorWebsocketSuccess = !1, this.opts.tryAllTransports && this.transports.length > 1 && this.readyState === "opening") return this.transports.shift(), this._open();
		this.emitReserved("error", t), this._onClose("transport error", t);
	}
	_onClose(e, t) {
		if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") {
			if (this.clearTimeoutFn(this._pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), kD && (this._beforeunloadEventListener && removeEventListener("beforeunload", this._beforeunloadEventListener, !1), this._offlineEventListener)) {
				let e = AD.indexOf(this._offlineEventListener);
				e !== -1 && AD.splice(e, 1);
			}
			this.readyState = "closed", this.id = null, this.emitReserved("close", e, t), this.writeBuffer = [], this._prevBufferLen = 0;
		}
	}
};
jD.protocol = 4;
var MD = class extends jD {
	constructor() {
		super(...arguments), this._upgrades = [];
	}
	onOpen() {
		if (super.onOpen(), this.readyState === "open" && this.opts.upgrade) for (let e = 0; e < this._upgrades.length; e++) this._probe(this._upgrades[e]);
	}
	_probe(e) {
		let t = this.createTransport(e), n = !1;
		jD.priorWebsocketSuccess = !1;
		let r = () => {
			n || (t.send([{
				type: "ping",
				data: "probe"
			}]), t.once("packet", (e) => {
				if (!n) if (e.type === "pong" && e.data === "probe") {
					if (this.upgrading = !0, this.emitReserved("upgrading", t), !t) return;
					jD.priorWebsocketSuccess = t.name === "websocket", this.transport.pause(() => {
						n || this.readyState !== "closed" && (l(), this.setTransport(t), t.send([{ type: "upgrade" }]), this.emitReserved("upgrade", t), t = null, this.upgrading = !1, this.flush());
					});
				} else {
					let e = /* @__PURE__ */ Error("probe error");
					e.transport = t.name, this.emitReserved("upgradeError", e);
				}
			}));
		};
		function i() {
			n || (n = !0, l(), t.close(), t = null);
		}
		let a = (e) => {
			let n = /* @__PURE__ */ Error("probe error: " + e);
			n.transport = t.name, i(), this.emitReserved("upgradeError", n);
		};
		function o() {
			a("transport closed");
		}
		function s() {
			a("socket closed");
		}
		function c(e) {
			t && e.name !== t.name && i();
		}
		let l = () => {
			t.removeListener("open", r), t.removeListener("error", a), t.removeListener("close", o), this.off("close", s), this.off("upgrading", c);
		};
		t.once("open", r), t.once("error", a), t.once("close", o), this.once("close", s), this.once("upgrading", c), this._upgrades.indexOf("webtransport") !== -1 && e !== "webtransport" ? this.setTimeoutFn(() => {
			n || t.open();
		}, 200) : t.open();
	}
	onHandshake(e) {
		this._upgrades = this._filterUpgrades(e.upgrades), super.onHandshake(e);
	}
	_filterUpgrades(e) {
		let t = [];
		for (let n = 0; n < e.length; n++) ~this.transports.indexOf(e[n]) && t.push(e[n]);
		return t;
	}
}, ND = class extends MD {
	constructor(e, t = {}) {
		let n = typeof e == "object" ? e : t;
		(!n.transports || n.transports && typeof n.transports[0] == "string") && (n.transports = (n.transports || [
			"polling",
			"websocket",
			"webtransport"
		]).map((e) => CD[e]).filter((e) => !!e)), super(e, n);
	}
};
ND.protocol;
//#endregion
//#region ../node_modules/.pnpm/socket.io-client@4.8.3_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/socket.io-client/build/esm/url.js
function PD(e, t = "", n) {
	let r = e;
	n ||= typeof location < "u" && location, e ??= n.protocol + "//" + n.host, typeof e == "string" && (e.charAt(0) === "/" && (e = e.charAt(1) === "/" ? n.protocol + e : n.host + e), /^(https?|wss?):\/\//.test(e) || (e = n === void 0 ? "https://" + e : n.protocol + "//" + e), r = ED(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
	let i = r.host.indexOf(":") === -1 ? r.host : "[" + r.host + "]";
	return r.id = r.protocol + "://" + i + ":" + r.port + t, r.href = r.protocol + "://" + i + (n && n.port === r.port ? "" : ":" + r.port), r;
}
//#endregion
//#region ../node_modules/.pnpm/socket.io-parser@4.2.6/node_modules/socket.io-parser/build/esm/is-binary.js
var FD = typeof ArrayBuffer == "function", ID = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, LD = Object.prototype.toString, RD = typeof Blob == "function" || typeof Blob < "u" && LD.call(Blob) === "[object BlobConstructor]", zD = typeof File == "function" || typeof File < "u" && LD.call(File) === "[object FileConstructor]";
function BD(e) {
	return FD && (e instanceof ArrayBuffer || ID(e)) || RD && e instanceof Blob || zD && e instanceof File;
}
function VD(e, t) {
	if (!e || typeof e != "object") return !1;
	if (Array.isArray(e)) {
		for (let t = 0, n = e.length; t < n; t++) if (VD(e[t])) return !0;
		return !1;
	}
	if (BD(e)) return !0;
	if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1) return VD(e.toJSON(), !0);
	for (let t in e) if (Object.prototype.hasOwnProperty.call(e, t) && VD(e[t])) return !0;
	return !1;
}
//#endregion
//#region ../node_modules/.pnpm/socket.io-parser@4.2.6/node_modules/socket.io-parser/build/esm/binary.js
function HD(e) {
	let t = [], n = e.data, r = e;
	return r.data = UD(n, t), r.attachments = t.length, {
		packet: r,
		buffers: t
	};
}
function UD(e, t) {
	if (!e) return e;
	if (BD(e)) {
		let n = {
			_placeholder: !0,
			num: t.length
		};
		return t.push(e), n;
	} else if (Array.isArray(e)) {
		let n = Array(e.length);
		for (let r = 0; r < e.length; r++) n[r] = UD(e[r], t);
		return n;
	} else if (typeof e == "object" && !(e instanceof Date)) {
		let n = {};
		for (let r in e) Object.prototype.hasOwnProperty.call(e, r) && (n[r] = UD(e[r], t));
		return n;
	}
	return e;
}
function WD(e, t) {
	return e.data = GD(e.data, t), delete e.attachments, e;
}
function GD(e, t) {
	if (!e) return e;
	if (e && e._placeholder === !0) {
		if (typeof e.num == "number" && e.num >= 0 && e.num < t.length) return t[e.num];
		throw Error("illegal attachments");
	} else if (Array.isArray(e)) for (let n = 0; n < e.length; n++) e[n] = GD(e[n], t);
	else if (typeof e == "object") for (let n in e) Object.prototype.hasOwnProperty.call(e, n) && (e[n] = GD(e[n], t));
	return e;
}
//#endregion
//#region ../node_modules/.pnpm/socket.io-parser@4.2.6/node_modules/socket.io-parser/build/esm/index.js
var KD = /* @__PURE__ */ e({
	Decoder: () => XD,
	Encoder: () => YD,
	PacketType: () => JD,
	isPacketValid: () => rO,
	protocol: () => 5
}), qD = [
	"connect",
	"connect_error",
	"disconnect",
	"disconnecting",
	"newListener",
	"removeListener"
], JD;
(function(e) {
	e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(JD ||= {});
var YD = class {
	constructor(e) {
		this.replacer = e;
	}
	encode(e) {
		return (e.type === JD.EVENT || e.type === JD.ACK) && VD(e) ? this.encodeAsBinary({
			type: e.type === JD.EVENT ? JD.BINARY_EVENT : JD.BINARY_ACK,
			nsp: e.nsp,
			data: e.data,
			id: e.id
		}) : [this.encodeAsString(e)];
	}
	encodeAsString(e) {
		let t = "" + e.type;
		return (e.type === JD.BINARY_EVENT || e.type === JD.BINARY_ACK) && (t += e.attachments + "-"), e.nsp && e.nsp !== "/" && (t += e.nsp + ","), e.id != null && (t += e.id), e.data != null && (t += JSON.stringify(e.data, this.replacer)), t;
	}
	encodeAsBinary(e) {
		let t = HD(e), n = this.encodeAsString(t.packet), r = t.buffers;
		return r.unshift(n), r;
	}
}, XD = class e extends qE {
	constructor(e) {
		super(), this.opts = Object.assign({
			reviver: void 0,
			maxAttachments: 10
		}, typeof e == "function" ? { reviver: e } : e);
	}
	add(e) {
		let t;
		if (typeof e == "string") {
			if (this.reconstructor) throw Error("got plaintext data when reconstructing a packet");
			t = this.decodeString(e);
			let n = t.type === JD.BINARY_EVENT;
			n || t.type === JD.BINARY_ACK ? (t.type = n ? JD.EVENT : JD.ACK, this.reconstructor = new ZD(t), t.attachments === 0 && super.emitReserved("decoded", t)) : super.emitReserved("decoded", t);
		} else if (BD(e) || e.base64) if (this.reconstructor) t = this.reconstructor.takeBinaryData(e), t && (this.reconstructor = null, super.emitReserved("decoded", t));
		else throw Error("got binary data when not reconstructing a packet");
		else throw Error("Unknown type: " + e);
	}
	decodeString(t) {
		let n = 0, r = { type: Number(t.charAt(0)) };
		if (JD[r.type] === void 0) throw Error("unknown packet type " + r.type);
		if (r.type === JD.BINARY_EVENT || r.type === JD.BINARY_ACK) {
			let e = n + 1;
			for (; t.charAt(++n) !== "-" && n != t.length;);
			let i = t.substring(e, n);
			if (i != Number(i) || t.charAt(n) !== "-") throw Error("Illegal attachments");
			let a = Number(i);
			if (!$D(a) || a < 0) throw Error("Illegal attachments");
			if (a > this.opts.maxAttachments) throw Error("too many attachments");
			r.attachments = a;
		}
		if (t.charAt(n + 1) === "/") {
			let e = n + 1;
			for (; ++n && !(t.charAt(n) === "," || n === t.length););
			r.nsp = t.substring(e, n);
		} else r.nsp = "/";
		let i = t.charAt(n + 1);
		if (i !== "" && Number(i) == i) {
			let e = n + 1;
			for (; ++n;) {
				let e = t.charAt(n);
				if (e == null || Number(e) != e) {
					--n;
					break;
				}
				if (n === t.length) break;
			}
			r.id = Number(t.substring(e, n + 1));
		}
		if (t.charAt(++n)) {
			let i = this.tryParse(t.substr(n));
			if (e.isPayloadValid(r.type, i)) r.data = i;
			else throw Error("invalid payload");
		}
		return r;
	}
	tryParse(e) {
		try {
			return JSON.parse(e, this.opts.reviver);
		} catch {
			return !1;
		}
	}
	static isPayloadValid(e, t) {
		switch (e) {
			case JD.CONNECT: return tO(t);
			case JD.DISCONNECT: return t === void 0;
			case JD.CONNECT_ERROR: return typeof t == "string" || tO(t);
			case JD.EVENT:
			case JD.BINARY_EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && qD.indexOf(t[0]) === -1);
			case JD.ACK:
			case JD.BINARY_ACK: return Array.isArray(t);
		}
	}
	destroy() {
		this.reconstructor &&= (this.reconstructor.finishedReconstruction(), null);
	}
}, ZD = class {
	constructor(e) {
		this.packet = e, this.buffers = [], this.reconPack = e;
	}
	takeBinaryData(e) {
		if (this.buffers.push(e), this.buffers.length === this.reconPack.attachments) {
			let e = WD(this.reconPack, this.buffers);
			return this.finishedReconstruction(), e;
		}
		return null;
	}
	finishedReconstruction() {
		this.reconPack = null, this.buffers = [];
	}
};
function QD(e) {
	return typeof e == "string";
}
var $D = Number.isInteger || function(e) {
	return typeof e == "number" && isFinite(e) && Math.floor(e) === e;
};
function eO(e) {
	return e === void 0 || $D(e);
}
function tO(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function nO(e, t) {
	switch (e) {
		case JD.CONNECT: return t === void 0 || tO(t);
		case JD.DISCONNECT: return t === void 0;
		case JD.EVENT: return Array.isArray(t) && (typeof t[0] == "number" || typeof t[0] == "string" && qD.indexOf(t[0]) === -1);
		case JD.ACK: return Array.isArray(t);
		case JD.CONNECT_ERROR: return typeof t == "string" || tO(t);
		default: return !1;
	}
}
function rO(e) {
	return QD(e.nsp) && eO(e.id) && nO(e.type, e.data);
}
//#endregion
//#region ../node_modules/.pnpm/socket.io-client@4.8.3_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/socket.io-client/build/esm/on.js
function iO(e, t, n) {
	return e.on(t, n), function() {
		e.off(t, n);
	};
}
//#endregion
//#region ../node_modules/.pnpm/socket.io-client@4.8.3_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/socket.io-client/build/esm/socket.js
var aO = Object.freeze({
	connect: 1,
	connect_error: 1,
	disconnect: 1,
	disconnecting: 1,
	newListener: 1,
	removeListener: 1
}), oO = class extends qE {
	constructor(e, t, n) {
		super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = e, this.nsp = t, n && n.auth && (this.auth = n.auth), this._opts = Object.assign({}, n), this.io._autoConnect && this.open();
	}
	get disconnected() {
		return !this.connected;
	}
	subEvents() {
		if (this.subs) return;
		let e = this.io;
		this.subs = [
			iO(e, "open", this.onopen.bind(this)),
			iO(e, "packet", this.onpacket.bind(this)),
			iO(e, "error", this.onerror.bind(this)),
			iO(e, "close", this.onclose.bind(this))
		];
	}
	get active() {
		return !!this.subs;
	}
	connect() {
		return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
	}
	open() {
		return this.connect();
	}
	send(...e) {
		return e.unshift("message"), this.emit.apply(this, e), this;
	}
	emit(e, ...t) {
		if (aO.hasOwnProperty(e)) throw Error("\"" + e.toString() + "\" is a reserved event name");
		if (t.unshift(e), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile) return this._addToQueue(t), this;
		let n = {
			type: JD.EVENT,
			data: t
		};
		if (n.options = {}, n.options.compress = this.flags.compress !== !1, typeof t[t.length - 1] == "function") {
			let e = this.ids++, r = t.pop();
			this._registerAckCallback(e, r), n.id = e;
		}
		let r = this.io.engine?.transport?.writable, i = this.connected && !this.io.engine?._hasPingExpired();
		return this.flags.volatile && !r || (i ? (this.notifyOutgoingListeners(n), this.packet(n)) : this.sendBuffer.push(n)), this.flags = {}, this;
	}
	_registerAckCallback(e, t) {
		let n = this.flags.timeout ?? this._opts.ackTimeout;
		if (n === void 0) {
			this.acks[e] = t;
			return;
		}
		let r = this.io.setTimeoutFn(() => {
			delete this.acks[e];
			for (let t = 0; t < this.sendBuffer.length; t++) this.sendBuffer[t].id === e && this.sendBuffer.splice(t, 1);
			t.call(this, /* @__PURE__ */ Error("operation has timed out"));
		}, n), i = (...e) => {
			this.io.clearTimeoutFn(r), t.apply(this, e);
		};
		i.withError = !0, this.acks[e] = i;
	}
	emitWithAck(e, ...t) {
		return new Promise((n, r) => {
			let i = (e, t) => e ? r(e) : n(t);
			i.withError = !0, t.push(i), this.emit(e, ...t);
		});
	}
	_addToQueue(e) {
		let t;
		typeof e[e.length - 1] == "function" && (t = e.pop());
		let n = {
			id: this._queueSeq++,
			tryCount: 0,
			pending: !1,
			args: e,
			flags: Object.assign({ fromQueue: !0 }, this.flags)
		};
		e.push((e, ...r) => (this._queue[0], e === null ? (this._queue.shift(), t && t(null, ...r)) : n.tryCount > this._opts.retries && (this._queue.shift(), t && t(e)), n.pending = !1, this._drainQueue())), this._queue.push(n), this._drainQueue();
	}
	_drainQueue(e = !1) {
		if (!this.connected || this._queue.length === 0) return;
		let t = this._queue[0];
		t.pending && !e || (t.pending = !0, t.tryCount++, this.flags = t.flags, this.emit.apply(this, t.args));
	}
	packet(e) {
		e.nsp = this.nsp, this.io._packet(e);
	}
	onopen() {
		typeof this.auth == "function" ? this.auth((e) => {
			this._sendConnectPacket(e);
		}) : this._sendConnectPacket(this.auth);
	}
	_sendConnectPacket(e) {
		this.packet({
			type: JD.CONNECT,
			data: this._pid ? Object.assign({
				pid: this._pid,
				offset: this._lastOffset
			}, e) : e
		});
	}
	onerror(e) {
		this.connected || this.emitReserved("connect_error", e);
	}
	onclose(e, t) {
		this.connected = !1, delete this.id, this.emitReserved("disconnect", e, t), this._clearAcks();
	}
	_clearAcks() {
		Object.keys(this.acks).forEach((e) => {
			if (!this.sendBuffer.some((t) => String(t.id) === e)) {
				let t = this.acks[e];
				delete this.acks[e], t.withError && t.call(this, /* @__PURE__ */ Error("socket has been disconnected"));
			}
		});
	}
	onpacket(e) {
		if (e.nsp === this.nsp) switch (e.type) {
			case JD.CONNECT:
				e.data && e.data.sid ? this.onconnect(e.data.sid, e.data.pid) : this.emitReserved("connect_error", /* @__PURE__ */ Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
				break;
			case JD.EVENT:
			case JD.BINARY_EVENT:
				this.onevent(e);
				break;
			case JD.ACK:
			case JD.BINARY_ACK:
				this.onack(e);
				break;
			case JD.DISCONNECT:
				this.ondisconnect();
				break;
			case JD.CONNECT_ERROR:
				this.destroy();
				let t = Error(e.data.message);
				t.data = e.data.data, this.emitReserved("connect_error", t);
				break;
		}
	}
	onevent(e) {
		let t = e.data || [];
		e.id != null && t.push(this.ack(e.id)), this.connected ? this.emitEvent(t) : this.receiveBuffer.push(Object.freeze(t));
	}
	emitEvent(e) {
		if (this._anyListeners && this._anyListeners.length) {
			let t = this._anyListeners.slice();
			for (let n of t) n.apply(this, e);
		}
		super.emit.apply(this, e), this._pid && e.length && typeof e[e.length - 1] == "string" && (this._lastOffset = e[e.length - 1]);
	}
	ack(e) {
		let t = this, n = !1;
		return function(...r) {
			n || (n = !0, t.packet({
				type: JD.ACK,
				id: e,
				data: r
			}));
		};
	}
	onack(e) {
		let t = this.acks[e.id];
		typeof t == "function" && (delete this.acks[e.id], t.withError && e.data.unshift(null), t.apply(this, e.data));
	}
	onconnect(e, t) {
		this.id = e, this.recovered = t && this._pid === t, this._pid = t, this.connected = !0, this.emitBuffered(), this._drainQueue(!0), this.emitReserved("connect");
	}
	emitBuffered() {
		this.receiveBuffer.forEach((e) => this.emitEvent(e)), this.receiveBuffer = [], this.sendBuffer.forEach((e) => {
			this.notifyOutgoingListeners(e), this.packet(e);
		}), this.sendBuffer = [];
	}
	ondisconnect() {
		this.destroy(), this.onclose("io server disconnect");
	}
	destroy() {
		this.subs &&= (this.subs.forEach((e) => e()), void 0), this.io._destroy(this);
	}
	disconnect() {
		return this.connected && this.packet({ type: JD.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
	}
	close() {
		return this.disconnect();
	}
	compress(e) {
		return this.flags.compress = e, this;
	}
	get volatile() {
		return this.flags.volatile = !0, this;
	}
	timeout(e) {
		return this.flags.timeout = e, this;
	}
	onAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.push(e), this;
	}
	prependAny(e) {
		return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(e), this;
	}
	offAny(e) {
		if (!this._anyListeners) return this;
		if (e) {
			let t = this._anyListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyListeners = [];
		return this;
	}
	listenersAny() {
		return this._anyListeners || [];
	}
	onAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(e), this;
	}
	prependAnyOutgoing(e) {
		return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(e), this;
	}
	offAnyOutgoing(e) {
		if (!this._anyOutgoingListeners) return this;
		if (e) {
			let t = this._anyOutgoingListeners;
			for (let n = 0; n < t.length; n++) if (e === t[n]) return t.splice(n, 1), this;
		} else this._anyOutgoingListeners = [];
		return this;
	}
	listenersAnyOutgoing() {
		return this._anyOutgoingListeners || [];
	}
	notifyOutgoingListeners(e) {
		if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
			let t = this._anyOutgoingListeners.slice();
			for (let n of t) n.apply(this, e.data);
		}
	}
};
//#endregion
//#region ../node_modules/.pnpm/socket.io-client@4.8.3_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/socket.io-client/build/esm/contrib/backo2.js
function sO(e) {
	e ||= {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
sO.prototype.duration = function() {
	var e = this.ms * this.factor ** + this.attempts++;
	if (this.jitter) {
		var t = Math.random(), n = Math.floor(t * this.jitter * e);
		e = Math.floor(t * 10) & 1 ? e + n : e - n;
	}
	return Math.min(e, this.max) | 0;
}, sO.prototype.reset = function() {
	this.attempts = 0;
}, sO.prototype.setMin = function(e) {
	this.ms = e;
}, sO.prototype.setMax = function(e) {
	this.max = e;
}, sO.prototype.setJitter = function(e) {
	this.jitter = e;
};
//#endregion
//#region ../node_modules/.pnpm/socket.io-client@4.8.3_bufferutil@4.1.0_utf-8-validate@5.0.10/node_modules/socket.io-client/build/esm/manager.js
var cO = class extends qE {
	constructor(e, t) {
		super(), this.nsps = {}, this.subs = [], e && typeof e == "object" && (t = e, e = void 0), t ||= {}, t.path = t.path || "/socket.io", this.opts = t, tD(this, t), this.reconnection(t.reconnection !== !1), this.reconnectionAttempts(t.reconnectionAttempts || Infinity), this.reconnectionDelay(t.reconnectionDelay || 1e3), this.reconnectionDelayMax(t.reconnectionDelayMax || 5e3), this.randomizationFactor(t.randomizationFactor ?? .5), this.backoff = new sO({
			min: this.reconnectionDelay(),
			max: this.reconnectionDelayMax(),
			jitter: this.randomizationFactor()
		}), this.timeout(t.timeout == null ? 2e4 : t.timeout), this._readyState = "closed", this.uri = e;
		let n = t.parser || KD;
		this.encoder = new n.Encoder(), this.decoder = new n.Decoder(), this._autoConnect = t.autoConnect !== !1, this._autoConnect && this.open();
	}
	reconnection(e) {
		return arguments.length ? (this._reconnection = !!e, e || (this.skipReconnect = !0), this) : this._reconnection;
	}
	reconnectionAttempts(e) {
		return e === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = e, this);
	}
	reconnectionDelay(e) {
		var t;
		return e === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = e, (t = this.backoff) == null || t.setMin(e), this);
	}
	randomizationFactor(e) {
		var t;
		return e === void 0 ? this._randomizationFactor : (this._randomizationFactor = e, (t = this.backoff) == null || t.setJitter(e), this);
	}
	reconnectionDelayMax(e) {
		var t;
		return e === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = e, (t = this.backoff) == null || t.setMax(e), this);
	}
	timeout(e) {
		return arguments.length ? (this._timeout = e, this) : this._timeout;
	}
	maybeReconnectOnOpen() {
		!this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
	}
	open(e) {
		if (~this._readyState.indexOf("open")) return this;
		this.engine = new ND(this.uri, this.opts);
		let t = this.engine, n = this;
		this._readyState = "opening", this.skipReconnect = !1;
		let r = iO(t, "open", function() {
			n.onopen(), e && e();
		}), i = (t) => {
			this.cleanup(), this._readyState = "closed", this.emitReserved("error", t), e ? e(t) : this.maybeReconnectOnOpen();
		}, a = iO(t, "error", i);
		if (!1 !== this._timeout) {
			let e = this._timeout, n = this.setTimeoutFn(() => {
				r(), i(/* @__PURE__ */ Error("timeout")), t.close();
			}, e);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
		return this.subs.push(r), this.subs.push(a), this;
	}
	connect(e) {
		return this.open(e);
	}
	onopen() {
		this.cleanup(), this._readyState = "open", this.emitReserved("open");
		let e = this.engine;
		this.subs.push(iO(e, "ping", this.onping.bind(this)), iO(e, "data", this.ondata.bind(this)), iO(e, "error", this.onerror.bind(this)), iO(e, "close", this.onclose.bind(this)), iO(this.decoder, "decoded", this.ondecoded.bind(this)));
	}
	onping() {
		this.emitReserved("ping");
	}
	ondata(e) {
		try {
			this.decoder.add(e);
		} catch (e) {
			this.onclose("parse error", e);
		}
	}
	ondecoded(e) {
		YE(() => {
			this.emitReserved("packet", e);
		}, this.setTimeoutFn);
	}
	onerror(e) {
		this.emitReserved("error", e);
	}
	socket(e, t) {
		let n = this.nsps[e];
		return n ? this._autoConnect && !n.active && n.connect() : (n = new oO(this, e, t), this.nsps[e] = n), n;
	}
	_destroy(e) {
		let t = Object.keys(this.nsps);
		for (let e of t) if (this.nsps[e].active) return;
		this._close();
	}
	_packet(e) {
		let t = this.encoder.encode(e);
		for (let n = 0; n < t.length; n++) this.engine.write(t[n], e.options);
	}
	cleanup() {
		this.subs.forEach((e) => e()), this.subs.length = 0, this.decoder.destroy();
	}
	_close() {
		this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close");
	}
	disconnect() {
		return this._close();
	}
	onclose(e, t) {
		var n;
		this.cleanup(), (n = this.engine) == null || n.close(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", e, t), this._reconnection && !this.skipReconnect && this.reconnect();
	}
	reconnect() {
		if (this._reconnecting || this.skipReconnect) return this;
		let e = this;
		if (this.backoff.attempts >= this._reconnectionAttempts) this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
		else {
			let t = this.backoff.duration();
			this._reconnecting = !0;
			let n = this.setTimeoutFn(() => {
				e.skipReconnect || (this.emitReserved("reconnect_attempt", e.backoff.attempts), !e.skipReconnect && e.open((t) => {
					t ? (e._reconnecting = !1, e.reconnect(), this.emitReserved("reconnect_error", t)) : e.onreconnect();
				}));
			}, t);
			this.opts.autoUnref && n.unref(), this.subs.push(() => {
				this.clearTimeoutFn(n);
			});
		}
	}
	onreconnect() {
		let e = this.backoff.attempts;
		this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", e);
	}
}, lO = {};
function uO(e, t) {
	typeof e == "object" && (t = e, e = void 0), t ||= {};
	let n = PD(e, t.path || "/socket.io"), r = n.source, i = n.id, a = n.path, o = lO[i] && a in lO[i].nsps, s = t.forceNew || t["force new connection"] || !1 === t.multiplex || o, c;
	return s ? c = new cO(r, t) : (lO[i] || (lO[i] = new cO(r, t)), c = lO[i]), n.query && !t.query && (t.query = n.queryKey), c.socket(n.path, t);
}
Object.assign(uO, {
	Manager: cO,
	Socket: oO,
	io: uO,
	connect: uO
});
//#endregion
//#region src/services/jobPipelineService.ts
var dO = D("jobPipelineService");
function fO() {
	let e = X.baseUrl;
	if (!(!e || e === "/")) return e;
}
function pO(e) {
	switch (e?.trim().toLowerCase()) {
		case "submitted": return "submitted";
		case "queued":
		case "pending": return "queued";
		case "running": return "running";
		case "succeeded":
		case "completed": return "succeeded";
		case "failed": return "failed";
		case "canceled":
		case "cancelled": return "canceled";
		case "timed_out":
		case "timedout":
		case "timeout": return "timed_out";
		default: return "queued";
	}
}
function mO(e, t) {
	if (t) return pO(t);
	switch (e?.trim().toUpperCase()) {
		case "PENDING": return "queued";
		case "RUNNING": return "running";
		case "COMPLETED": return "succeeded";
		case "FAILED": return "failed";
		case "CANCELLED": return "canceled";
		default: return pO(e);
	}
}
function hO(e) {
	return e === "job:started" ? "running" : e === "job:completed" ? "succeeded" : "failed";
}
async function gO(e = 120) {
	return xr(`/v1/jobs?limit=${e}`);
}
async function _O(e) {
	return xr(`/v1/jobs/${encodeURIComponent(e)}/pipeline-run`);
}
async function vO(e, t, n) {
	return xr(`/v1/jobs/${encodeURIComponent(e)}/pipeline-run/nodes/${encodeURIComponent(t)}/${n === "retry_node" ? "retry" : n === "retry_from_node" ? "retry-from" : "cancel"}`, { method: "POST" });
}
async function yO(e) {
	return xr(`/v1/jobs/${encodeURIComponent(e)}/pipeline-run/resume`, { method: "POST" });
}
async function bO(e) {
	return xr(`/v1/jobs/${encodeURIComponent(e)}/pipeline-run/cancel`, { method: "POST" });
}
async function xO(e) {
	return xr("/v1/jobs/submit", {
		method: "POST",
		body: e
	});
}
async function SO(e) {
	return xr(`/v1/jobs/${encodeURIComponent(e)}/cancel`, { method: "POST" });
}
async function CO(e) {
	return xr("/v1/jobs/schedules", {
		method: "POST",
		body: e
	});
}
function wO({ userId: e, onEvent: t, onConnectionChange: n }) {
	let r = uO(fO() ?? "", {
		path: "/notifications",
		auth: e ? { userId: e } : void 0,
		reconnectionAttempts: 5,
		reconnectionDelay: 2e3,
		reconnectionDelayMax: 15e3,
		timeout: 5e3
	}), i = !1;
	r.on("connect", () => {
		dO.info("Connected to job pipeline live updates"), i = !1, n?.(!0), e && r.emit("identify", e);
	}), r.on("disconnect", () => {
		n?.(!1);
	}), r.on("connect_error", (e) => {
		i ||= (dO.warn("Unable to connect to job pipeline live updates", e), !0), n?.(!1);
	});
	for (let e of [
		"job:started",
		"job:completed",
		"job:failed"
	]) r.on(e, (n) => {
		let r = hO(e);
		t({
			event: e,
			canonicalStatus: r,
			job: {
				id: n.id,
				type: n.type,
				status: n.status ?? r,
				canonicalStatus: r,
				progress: n.progress,
				result: n.result ?? null,
				error: n.result?.error ?? null,
				workerId: n.workerId
			}
		});
	});
	return { disconnect: () => r.disconnect() };
}
//#endregion
//#region src/panels/JobPipelinePanel/pipelineRunViewModel.ts
function TO(e) {
	return e ? new Date(e).toLocaleString() : "Not yet recorded";
}
function EO(e) {
	switch (e) {
		case "running": return "border-sky-200 bg-sky-50 text-sky-900";
		case "succeeded": return "border-emerald-200 bg-emerald-50 text-emerald-900";
		case "failed": return "border-rose-200 bg-rose-50 text-rose-900";
		case "canceled": return "border-slate-300 bg-slate-100 text-slate-700";
		case "skipped": return "border-violet-200 bg-violet-50 text-violet-900";
		default: return "border-amber-200 bg-amber-50 text-amber-900";
	}
}
function DO(e, t) {
	if (!e || !t || t < e) return "Not complete";
	let n = Math.max(0, Math.round((t - e) / 1e3));
	if (n < 60) return `${n}s`;
	let r = Math.floor(n / 60), i = n % 60;
	return i > 0 ? `${r}m ${i}s` : `${r}m`;
}
function OO(e) {
	let t = /* @__PURE__ */ new Map();
	for (let n of e) t.set(n.level, [...t.get(n.level) ?? [], n]);
	return [...t.entries()].sort(([e], [t]) => e - t).map(([e, t]) => ({
		level: e,
		nodeRuns: [...t].sort((e, t) => e.nodeId.localeCompare(t.nodeId))
	}));
}
function kO(e) {
	let t = e.assetId ?? e.artifactKey;
	return `/catalog?assetId=${encodeURIComponent(t)}`;
}
function AO(e) {
	return e.label ?? e.assetId ?? e.artifactKey;
}
function jO(e) {
	return e.status === "failed" || e.status === "canceled";
}
function MO(e) {
	return e.status !== "running";
}
function NO(e) {
	return e.status === "queued" || e.status === "running";
}
//#endregion
//#region src/panels/JobPipelinePanel/PipelineRunNodeCard.tsx
function PO({ actionPending: e, nodeRun: t, onNodeAction: n }) {
	let r = Math.max(0, Math.min(100, t.progress ?? 0)), i = e?.endsWith(`:${t.nodeId}`) ?? !1;
	return /* @__PURE__ */ v("article", {
		className: `rounded-[1.1rem] border px-3 py-3 ${EO(t.status)}`,
		"data-testid": `pipeline-node-${t.nodeId}`,
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex flex-wrap items-start justify-between gap-3",
				children: [/* @__PURE__ */ v("div", {
					className: "min-w-0",
					children: [
						/* @__PURE__ */ v("p", {
							className: "text-[10px] font-semibold uppercase tracking-[0.16em] opacity-70",
							children: [t.nodeKind, t.recipeKind ? ` / ${t.recipeKind}` : ""]
						}),
						/* @__PURE__ */ _("h3", {
							className: "mt-1 text-sm font-semibold",
							children: t.label ?? t.nodeId
						}),
						/* @__PURE__ */ _("p", {
							className: "mt-1 break-all text-xs opacity-75",
							children: t.nodeId
						})
					]
				}), /* @__PURE__ */ _("span", {
					className: "rounded-full bg-white/70 px-2 py-1 text-[10px] font-semibold uppercase tracking-[0.12em]",
					children: t.status
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-3",
				children: [/* @__PURE__ */ v("div", {
					className: "mb-1 flex items-center justify-between text-[11px] opacity-75",
					children: [/* @__PURE__ */ _("span", { children: "Progress" }), /* @__PURE__ */ v("span", { children: [r, "%"] })]
				}), /* @__PURE__ */ _("div", {
					className: "h-2 overflow-hidden rounded-full bg-white/70",
					children: /* @__PURE__ */ _("div", {
						className: "h-full rounded-full bg-current opacity-70",
						style: { width: `${r}%` }
					})
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-3 grid gap-2 text-xs sm:grid-cols-2",
				children: [
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Attempts:"
						}),
						" ",
						t.attempts
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Worker:"
						}),
						" ",
						t.workerId ?? "Not assigned"
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Started:"
						}),
						" ",
						TO(t.startedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Finished:"
						}),
						" ",
						TO(t.finishedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Duration:"
						}),
						" ",
						DO(t.startedAt, t.finishedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold",
							children: "Outputs:"
						}),
						" ",
						t.outputNodeIds?.length ?? 0
					] })
				]
			}),
			t.error ? /* @__PURE__ */ _("p", {
				className: "mt-3 rounded-[0.9rem] bg-white/72 px-3 py-2 text-xs font-medium text-rose-800",
				children: t.error
			}) : null,
			t.artifacts.length > 0 ? /* @__PURE__ */ v("div", {
				className: "mt-3 border-t border-white/70 pt-3",
				children: [/* @__PURE__ */ _("p", {
					className: "text-[10px] font-semibold uppercase tracking-[0.16em] opacity-70",
					children: "Artifacts"
				}), /* @__PURE__ */ _("div", {
					className: "mt-2 flex flex-wrap gap-2",
					children: t.artifacts.map((e) => /* @__PURE__ */ v("a", {
						href: kO(e),
						className: "rounded-full bg-white/72 px-2.5 py-1 text-[11px] font-semibold text-slate-700 transition hover:bg-white",
						"data-testid": `pipeline-artifact-${e.id}`,
						children: [
							e.direction,
							": ",
							AO(e)
						]
					}, e.id))
				})]
			}) : null,
			/* @__PURE__ */ v("div", {
				className: "mt-3 flex flex-wrap gap-2 border-t border-white/70 pt-3",
				children: [
					/* @__PURE__ */ _("button", {
						type: "button",
						className: "rounded-full bg-white/80 px-2.5 py-1 text-[11px] font-semibold text-slate-700 transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50",
						"data-testid": `pipeline-node-retry-${t.nodeId}`,
						disabled: i || !jO(t),
						onClick: () => n(t.nodeId, "retry_node"),
						children: i ? "Working..." : "Retry"
					}),
					/* @__PURE__ */ _("button", {
						type: "button",
						className: "rounded-full bg-white/80 px-2.5 py-1 text-[11px] font-semibold text-slate-700 transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50",
						"data-testid": `pipeline-node-retry-from-${t.nodeId}`,
						disabled: i || !MO(t),
						onClick: () => n(t.nodeId, "retry_from_node"),
						children: "Retry from here"
					}),
					/* @__PURE__ */ _("button", {
						type: "button",
						className: "rounded-full bg-white/80 px-2.5 py-1 text-[11px] font-semibold text-slate-700 transition hover:bg-white disabled:cursor-not-allowed disabled:opacity-50",
						"data-testid": `pipeline-node-cancel-${t.nodeId}`,
						disabled: i || !NO(t),
						onClick: () => n(t.nodeId, "cancel_node"),
						children: "Cancel node"
					})
				]
			})
		]
	});
}
//#endregion
//#region src/panels/JobPipelinePanel/PipelineRunDetailPanel.tsx
function FO({ actionPending: e, job: t, onCancelRun: n, onNodeAction: r, onResumeRun: i }) {
	let a = t.pipelineRun;
	return a ? /* @__PURE__ */ v("div", {
		className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-4",
		"data-testid": "pipeline-run-detail-panel",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex flex-wrap items-start justify-between gap-3",
				children: [/* @__PURE__ */ v("div", { children: [
					/* @__PURE__ */ _("p", {
						className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
						children: "Pipeline DAG"
					}),
					/* @__PURE__ */ _("h2", {
						className: "mt-2 text-lg font-semibold text-slate-900",
						children: a.pipelineName ?? a.pipelineId ?? "Pipeline run"
					}),
					/* @__PURE__ */ _("p", {
						className: "mt-1 text-xs text-slate-500",
						children: a.id
					})
				] }), /* @__PURE__ */ v("span", {
					className: `rounded-full border px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] ${EO(a.status)}`,
					children: [
						a.status,
						" · ",
						a.progress,
						"%"
					]
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-4 flex flex-wrap gap-2",
				"data-testid": "pipeline-run-controls",
				children: [/* @__PURE__ */ _("button", {
					type: "button",
					className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-50",
					"data-testid": "pipeline-run-resume-button",
					disabled: e !== null || !["failed", "canceled"].includes(a.status),
					onClick: i,
					children: "Resume from last success"
				}), /* @__PURE__ */ _("button", {
					type: "button",
					className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-50",
					"data-testid": "pipeline-run-cancel-button",
					disabled: e !== null || !["queued", "running"].includes(a.status),
					onClick: n,
					children: "Cancel run"
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "mt-4 grid gap-3 text-xs text-slate-600 md:grid-cols-4",
				children: [
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold text-slate-800",
							children: "Started:"
						}),
						" ",
						TO(a.startedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold text-slate-800",
							children: "Finished:"
						}),
						" ",
						TO(a.finishedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold text-slate-800",
							children: "Duration:"
						}),
						" ",
						DO(a.startedAt, a.finishedAt)
					] }),
					/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("span", {
							className: "font-semibold text-slate-800",
							children: "Assets:"
						}),
						" ",
						a.assetIds.length
					] })
				]
			}),
			a.error ? /* @__PURE__ */ _("p", {
				className: "mt-3 rounded-[1rem] border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-900",
				children: a.error
			}) : null,
			/* @__PURE__ */ _("div", {
				className: "mt-5 space-y-4",
				children: OO(a.nodeRuns).map((t) => /* @__PURE__ */ v("section", {
					"data-testid": `pipeline-level-${t.level}`,
					children: [/* @__PURE__ */ v("div", {
						className: "mb-2 flex items-center justify-between gap-3",
						children: [/* @__PURE__ */ v("p", {
							className: "text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-400",
							children: ["Level ", t.level]
						}), /* @__PURE__ */ v("span", {
							className: "rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-600",
							children: [
								t.nodeRuns.length,
								" ",
								t.nodeRuns.length === 1 ? "node" : "nodes"
							]
						})]
					}), /* @__PURE__ */ _("div", {
						className: "grid gap-3 lg:grid-cols-2",
						children: t.nodeRuns.map((t) => /* @__PURE__ */ _(PO, {
							actionPending: e,
							nodeRun: t,
							onNodeAction: r
						}, t.id))
					})]
				}, t.level))
			})
		]
	}) : /* @__PURE__ */ v("div", {
		className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-4",
		"data-testid": "pipeline-run-detail-panel",
		children: [/* @__PURE__ */ _("p", {
			className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
			children: "Pipeline DAG"
		}), /* @__PURE__ */ _("p", {
			className: "mt-2 text-sm text-slate-600",
			children: t.type === "DATA_GOVERNANCE_MARKETPLACE_PIPELINE" ? "Pipeline node details are not available for this run yet." : "This job does not have a pipeline DAG."
		})]
	});
}
//#endregion
//#region src/panels/JobPipelinePanel/index.tsx
var IO = [
	{
		status: "queued",
		label: "Queued",
		accent: "border-amber-200",
		surface: "bg-amber-50/80",
		text: "text-amber-700"
	},
	{
		status: "running",
		label: "Running",
		accent: "border-sky-200",
		surface: "bg-sky-50/85",
		text: "text-sky-700"
	},
	{
		status: "succeeded",
		label: "Succeeded",
		accent: "border-emerald-200",
		surface: "bg-emerald-50/80",
		text: "text-emerald-700"
	},
	{
		status: "failed",
		label: "Failed",
		accent: "border-rose-200",
		surface: "bg-rose-50/80",
		text: "text-rose-700"
	},
	{
		status: "canceled",
		label: "Canceled",
		accent: "border-slate-200",
		surface: "bg-slate-50/90",
		text: "text-slate-600"
	}
], LO = {
	executedToday: 0,
	failedToday: 0,
	activeByStatus: {
		queued: 0,
		running: 0,
		failed: 0,
		succeeded: 0
	},
	executionsByDay: [],
	topErrors: []
};
function RO(e) {
	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		maximumFractionDigits: 1
	}).format(e);
}
function zO(e) {
	return !e || e <= 0 ? "0 B" : e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(1)} KB` : e < 1024 * 1024 * 1024 ? `${(e / (1024 * 1024)).toFixed(1)} MB` : `${(e / (1024 * 1024 * 1024)).toFixed(1)} GB`;
}
function BO(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
function VO(e) {
	return e.split("_").filter(Boolean).map((e) => e.charAt(0) + e.slice(1).toLowerCase()).join(" ");
}
function HO(e) {
	let t = BO(e) ? e : null, n = typeof t?.tableName == "string" ? t.tableName : null, r = typeof t?.databaseId == "number" || typeof t?.databaseId == "string" ? String(t.databaseId) : null, i = typeof t?.campaignId == "number" || typeof t?.campaignId == "string" ? String(t.campaignId) : null, a = typeof t?.offerId == "number" || typeof t?.offerId == "string" ? String(t.offerId) : null, o = typeof t?.creativeId == "number" || typeof t?.creativeId == "string" ? String(t.creativeId) : null, s = typeof t?.query == "string" ? t.query : null;
	return n && r ? `${n} on database ${r}` : n || (i ? `Campaign ${i}` : a ? `Offer ${a}` : o ? `Creative ${o}` : s ? s.length > 44 ? `${s.slice(0, 44)}...` : s : "Shared background pipeline");
}
function UO(e) {
	return HO(e.params);
}
function WO(e) {
	if (e == null) return "No payload captured.";
	try {
		return JSON.stringify(e, null, 2);
	} catch {
		return "Unable to render payload.";
	}
}
function GO(e) {
	return JSON.stringify(e, null, 2);
}
function KO() {
	let e = new Date(Date.now() + 1800 * 1e3);
	return (/* @__PURE__ */ new Date(e.getTime() - e.getTimezoneOffset() * 6e4)).toISOString().slice(0, 16);
}
function qO(e) {
	return `/runs/jobs/${encodeURIComponent(e)}`;
}
function JO(e) {
	return `job-${e}`;
}
function YO(e) {
	let t = e.startsWith("#") ? e.slice(1) : e;
	if (!t.startsWith("job-")) return null;
	try {
		return decodeURIComponent(t.slice(4));
	} catch {
		return t.slice(4);
	}
}
function XO() {
	return typeof window > "u" ? null : YO(window.location.hash);
}
function ZO(e) {
	return (/* @__PURE__ */ new Date(`${e}T00:00:00`)).toLocaleDateString(void 0, {
		month: "short",
		day: "numeric"
	});
}
function QO(e) {
	let t = BO(e.params) ? e.params : null;
	return typeof t?.transport == "string" && t.transport.trim().length > 0 ? t.transport.trim() : typeof e.workerId == "string" && e.workerId.includes(":") ? e.workerId.split(":").pop() ?? e.workerId : typeof e.workerId == "string" && e.workerId.trim().length > 0 ? e.workerId.trim() : $O(e) === "queued" ? "awaiting worker" : "inprocess";
}
function $O(e) {
	let t = mO(e.status, e.canonicalStatus);
	return t === "submitted" ? "queued" : t === "timed_out" ? "failed" : t;
}
function ek(e) {
	return [...e].sort((e, t) => {
		let n = $O(e), r = $O(t), i = IO.findIndex((e) => e.status === n), a = IO.findIndex((e) => e.status === r);
		if (i !== a) return i - a;
		let o = e.started ?? e.created ?? 0;
		return (t.started ?? t.created ?? 0) - o;
	});
}
function tk(e, t) {
	let n = e.findIndex((e) => e.id === t.id);
	if (n === -1) return [...e, t];
	let r = [...e];
	return r[n] = {
		...r[n],
		...t,
		params: t.params ?? r[n].params ?? null,
		result: t.result ?? r[n].result ?? null,
		error: t.error ?? r[n].error ?? null
	}, r;
}
function nk(e, t) {
	return e.filter((e) => $O(e) === t).length;
}
async function rk(e) {
	let t = await _O(e);
	return {
		...t.job,
		pipelineRun: t.pipelineRun ?? void 0
	};
}
function ik({ userId: e, jobDetailHref: t = qO, onOpenJob: n }) {
	let [r, i] = h([]), [a, o] = h(LO), [s, c] = h([]), [l, d] = h([]), [p, g] = h(!0), [y, b] = h(null), [x, S] = h(null), [C, w] = h(!1), [T, E] = h(""), [D, O] = h("{}"), [k, A] = h("now"), [j, M] = h(KO()), [N, P] = h("none"), [F, I] = h(null), [L, R] = h(null), [z, B] = h(!1), [V, H] = h(() => XO()), ee = m(null), U = (e) => {
		i(ek(e.jobs ?? [])), o(e.summary ?? LO), c(e.scheduledJobs ?? []), d(e.availableJobTypes ?? []), b(null), S(Date.now());
	}, te = async (e = !1) => {
		e && g(!0);
		try {
			U(await gO());
		} catch (e) {
			b(e instanceof Error ? e.message : "Unable to load jobs.");
		} finally {
			e && g(!1);
		}
	};
	u(() => {
		let t = !0, n = async (e = !1) => {
			if (t) {
				e && g(!0);
				try {
					let e = await gO();
					if (!t) return;
					U(e);
				} catch (e) {
					if (!t) return;
					b(e instanceof Error ? e.message : "Unable to load jobs.");
				} finally {
					e && t && g(!1);
				}
			}
		};
		n(!0);
		let r = window.setInterval(() => {
			n(!1);
		}, 15e3), a = wO({
			userId: e,
			onEvent: (e) => {
				t && (i((t) => {
					let n = t.find((t) => t.id === e.job.id);
					return ek(tk(t, {
						...n,
						...e.job,
						id: e.job.id,
						type: e.job.type,
						status: e.job.status ?? e.canonicalStatus,
						canonicalStatus: e.canonicalStatus,
						created: n?.created ?? Date.now(),
						result: e.job.result ?? n?.result ?? null,
						error: e.job.error ?? n?.error ?? null
					}));
				}), S(Date.now()), n(!1));
			}
		});
		return () => {
			t = !1, window.clearInterval(r), a.disconnect();
		};
	}, [e]), u(() => {
		if (typeof window > "u") return;
		let e = () => {
			H(XO());
		};
		return window.addEventListener("hashchange", e), () => window.removeEventListener("hashchange", e);
	}, []), u(() => {
		if (!V) {
			ee.current = null;
			return;
		}
		if (ee.current === V || !r.some((e) => e.id === V)) return;
		ee.current = V;
		let e = () => {
			let e = document.getElementById(JO(V));
			e && typeof e.scrollIntoView == "function" && e.scrollIntoView({
				block: "center",
				behavior: "smooth"
			});
		};
		typeof window.requestAnimationFrame == "function" ? window.requestAnimationFrame(e) : e();
	}, [V, r]), u(() => {
		if (l.length === 0 || T) return;
		let e = l[0];
		E(e.type), O(GO(e.defaultParams ?? {}));
	}, [l, T]);
	let W = f(() => Object.fromEntries(IO.map((e) => [e.status, r.filter((t) => $O(t) === e.status)])), [r]), ne = f(() => {
		let e = /* @__PURE__ */ new Map();
		for (let t of r) {
			let n = QO(t);
			e.set(n, (e.get(n) ?? 0) + 1);
		}
		return [...e.entries()].sort((e, t) => t[1] - e[1] || e[0].localeCompare(t[0])).slice(0, 4);
	}, [r]), re = f(() => l.find((e) => e.type === T) ?? null, [l, T]), ie = (e) => {
		E(e), O(GO(l.find((t) => t.type === e)?.defaultParams ?? {})), I(null), R(null);
	}, ae = async () => {
		if (!T) {
			I("Choose a job type before submitting.");
			return;
		}
		let e;
		try {
			let t = JSON.parse(D || "{}");
			if (!BO(t)) throw Error("Parameters must be a JSON object.");
			e = t;
		} catch (e) {
			I(e instanceof Error ? e.message : "Parameters must be valid JSON.");
			return;
		}
		B(!0), I(null), R(null);
		try {
			if (k === "later") {
				if (!j) throw Error("Pick a schedule time before saving.");
				await CO({
					type: T,
					params: e,
					runAt: new Date(j).toISOString(),
					recurrence: N
				}), R(N === "monthly" ? "Monthly job scheduled successfully." : "Job scheduled successfully.");
			} else await xO({
				type: T,
				params: e
			}), R("Job queued successfully.");
			w(!1), M(KO()), P("none"), await te(!1);
		} catch (e) {
			I(e instanceof Error ? e.message : "Unable to save the job request.");
		} finally {
			B(!1);
		}
	};
	return /* @__PURE__ */ v("div", {
		className: "relative flex min-h-full flex-col overflow-hidden bg-[radial-gradient(circle_at_top_left,#fffbea_0%,#fbfffd_34%,#eef6fb_67%,#e5f1f4_100%)]",
		"data-testid": "job-pipeline-panel",
		children: [
			/* @__PURE__ */ _("div", {
				className: "border-b border-white/70 bg-white/70 px-5 py-3 backdrop-blur",
				children: /* @__PURE__ */ v("div", {
					className: "flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-end",
					children: [L ? /* @__PURE__ */ _("span", {
						className: "inline-flex items-center rounded-full bg-emerald-100 px-3 py-1.5 text-xs font-medium text-emerald-800 sm:order-first",
						children: L
					}) : null, /* @__PURE__ */ v("div", {
						className: "flex flex-wrap gap-2 sm:justify-end",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => void te(!1),
							className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-700 transition hover:border-slate-300 hover:bg-slate-50",
							"data-testid": "job-refresh-button",
							"aria-label": x ? `Refresh active runs. Last refreshed ${new Date(x).toLocaleTimeString()}.` : "Refresh active runs.",
							children: "Refresh"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => {
								w((e) => !e), I(null), R(null);
							},
							className: "rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white shadow-[0_10px_24px_rgba(15,23,42,0.18)] transition hover:bg-slate-800",
							"data-testid": "job-create-button",
							children: C ? "Close composer" : "Create new job"
						})]
					})]
				})
			}),
			/* @__PURE__ */ _("div", {
				className: "grid gap-3 border-b border-white/70 bg-white/50 px-5 py-4 xl:grid-cols-6 md:grid-cols-3",
				children: [
					{
						label: "Scheduled",
						value: s.length,
						tone: "text-violet-700"
					},
					{
						label: "Executed today",
						value: a.executedToday,
						tone: "text-slate-900"
					},
					{
						label: "Errors today",
						value: a.failedToday,
						tone: "text-rose-700"
					},
					{
						label: "Queued now",
						value: a.activeByStatus.queued || nk(r, "queued"),
						tone: "text-amber-700"
					},
					{
						label: "Running now",
						value: a.activeByStatus.running || nk(r, "running"),
						tone: "text-sky-700"
					},
					{
						label: "Completed",
						value: a.activeByStatus.succeeded || nk(r, "succeeded"),
						tone: "text-emerald-700"
					}
				].map((e) => /* @__PURE__ */ v("div", {
					className: "rounded-[1.4rem] border border-white/80 bg-white/80 px-4 py-3 shadow-[0_8px_24px_rgba(51,65,85,0.06)]",
					children: [/* @__PURE__ */ _("p", {
						className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
						children: e.label
					}), /* @__PURE__ */ _("p", {
						className: `mt-2 text-3xl font-semibold ${e.tone}`,
						children: e.value
					})]
				}, e.label))
			}),
			C ? /* @__PURE__ */ _("div", {
				className: "border-b border-white/70 bg-white/65 px-5 py-5",
				"data-testid": "job-composer",
				children: /* @__PURE__ */ v("div", {
					className: "grid gap-4 xl:grid-cols-[1.1fr_1fr]",
					children: [/* @__PURE__ */ v("div", {
						className: "rounded-[1.6rem] border border-white/80 bg-white/80 px-4 py-4 shadow-[0_10px_32px_rgba(51,65,85,0.08)]",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center justify-between gap-3",
								children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
									className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
									children: "Composer"
								}), /* @__PURE__ */ _("h2", {
									className: "mt-2 text-lg font-semibold text-slate-900",
									children: "Create or schedule a job"
								})] }), /* @__PURE__ */ _("div", {
									className: "inline-flex rounded-full bg-slate-100 p-1",
									children: [{
										mode: "now",
										label: "Run now"
									}, {
										mode: "later",
										label: "Schedule"
									}].map((e) => /* @__PURE__ */ _("button", {
										type: "button",
										onClick: () => A(e.mode),
										className: `rounded-full px-3 py-1.5 text-xs font-semibold transition ${k === e.mode ? "bg-slate-900 text-white" : "text-slate-600"}`,
										children: e.label
									}, e.mode))
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "mt-4 grid gap-4 md:grid-cols-2",
								children: [
									/* @__PURE__ */ v("label", {
										className: "block",
										children: [/* @__PURE__ */ _("span", {
											className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
											children: "Job type"
										}), /* @__PURE__ */ _("select", {
											value: T,
											onChange: (e) => ie(e.target.value),
											className: "mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition focus:border-slate-400",
											"data-testid": "job-type-select",
											children: l.map((e) => /* @__PURE__ */ _("option", {
												value: e.type,
												children: e.label
											}, e.type))
										})]
									}),
									/* @__PURE__ */ v("label", {
										className: "block",
										children: [/* @__PURE__ */ _("span", {
											className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
											children: k === "later" ? "Run at" : "Queued at"
										}), /* @__PURE__ */ _("input", {
											type: "datetime-local",
											value: j,
											onChange: (e) => M(e.target.value),
											disabled: k !== "later",
											className: "mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition disabled:cursor-not-allowed disabled:bg-slate-50",
											"data-testid": "job-run-at-input"
										})]
									}),
									/* @__PURE__ */ v("label", {
										className: "block",
										children: [/* @__PURE__ */ _("span", {
											className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
											children: "Repeat"
										}), /* @__PURE__ */ v("select", {
											value: N,
											onChange: (e) => P(e.target.value),
											disabled: k !== "later",
											className: "mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition disabled:cursor-not-allowed disabled:bg-slate-50",
											"data-testid": "job-recurrence-select",
											children: [/* @__PURE__ */ _("option", {
												value: "none",
												children: "Once"
											}), /* @__PURE__ */ _("option", {
												value: "monthly",
												children: "Monthly"
											})]
										})]
									})
								]
							}),
							/* @__PURE__ */ v("label", {
								className: "mt-4 block",
								children: [/* @__PURE__ */ _("span", {
									className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
									children: "Parameters JSON"
								}), /* @__PURE__ */ _("textarea", {
									value: D,
									onChange: (e) => O(e.target.value),
									className: "mt-2 min-h-[16rem] w-full rounded-[1.4rem] border border-slate-200 bg-[#0f172a] px-4 py-4 font-mono text-xs leading-6 text-slate-100 outline-none transition focus:border-slate-400",
									spellCheck: !1,
									"data-testid": "job-params-input"
								})]
							}),
							F ? /* @__PURE__ */ _("div", {
								className: "mt-4 rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
								children: F
							}) : null,
							/* @__PURE__ */ v("div", {
								className: "mt-4 flex flex-wrap items-center gap-3",
								children: [/* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => void ae(),
									disabled: z || l.length === 0,
									className: "rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300",
									"data-testid": "job-submit-button",
									children: z ? "Saving..." : k === "later" ? "Schedule job" : "Queue job"
								}), /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => {
										w(!1), P("none"), I(null);
									},
									className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-600 transition hover:border-slate-300 hover:text-slate-900",
									children: "Cancel"
								})]
							})
						]
					}), /* @__PURE__ */ v("div", {
						className: "rounded-[1.6rem] border border-white/80 bg-white/80 px-4 py-4 shadow-[0_10px_32px_rgba(51,65,85,0.08)]",
						children: [
							/* @__PURE__ */ _("p", {
								className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
								children: "Selected job"
							}),
							/* @__PURE__ */ _("h2", {
								className: "mt-2 text-lg font-semibold text-slate-900",
								children: re?.label ?? "Choose a job type"
							}),
							/* @__PURE__ */ _("p", {
								className: "mt-3 text-sm leading-6 text-slate-600",
								children: re?.description ?? "Pick a supported background job to prefill the composer."
							}),
							/* @__PURE__ */ v("div", {
								className: "mt-4 rounded-[1.4rem] border border-slate-200 bg-slate-50 px-4 py-4",
								children: [
									/* @__PURE__ */ _("p", {
										className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
										children: "Default scope"
									}),
									/* @__PURE__ */ _("p", {
										className: "mt-2 text-sm text-slate-700",
										children: re ? HO(re.defaultParams) : "No default payload loaded yet."
									}),
									/* @__PURE__ */ _("pre", {
										className: "mt-3 overflow-x-auto whitespace-pre-wrap rounded-[1rem] bg-white px-3 py-3 text-xs leading-5 text-slate-700",
										children: re ? WO(re.defaultParams) : "No defaults available."
									})
								]
							})
						]
					})]
				})
			}) : null,
			y ? /* @__PURE__ */ _("div", {
				className: "px-5 pt-4",
				children: /* @__PURE__ */ _("div", {
					className: "rounded-[1.4rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
					children: y
				})
			}) : null,
			/* @__PURE__ */ v("div", {
				className: "grid gap-4 border-b border-white/70 bg-white/35 px-5 py-5 xl:grid-cols-[1.15fr_1fr_1fr]",
				children: [
					/* @__PURE__ */ v("section", {
						className: "rounded-[1.6rem] border border-white/80 bg-white/82 px-4 py-4 shadow-[0_10px_30px_rgba(51,65,85,0.08)]",
						"data-testid": "job-daily-summary",
						children: [/* @__PURE__ */ v("div", {
							className: "flex items-center justify-between gap-3",
							children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
								className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
								children: "Jobs per day"
							}), /* @__PURE__ */ _("h2", {
								className: "mt-2 text-lg font-semibold text-slate-900",
								children: "Execution trend"
							})] }), /* @__PURE__ */ _("span", {
								className: "rounded-full bg-slate-900 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white",
								children: "7 days"
							})]
						}), /* @__PURE__ */ _("div", {
							className: "mt-4 grid gap-3 sm:grid-cols-2 xl:grid-cols-4",
							children: a.executionsByDay.length > 0 ? a.executionsByDay.map((e) => /* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-3 py-3",
								children: [/* @__PURE__ */ _("p", {
									className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
									children: ZO(e.date)
								}), /* @__PURE__ */ _("p", {
									className: "mt-2 text-2xl font-semibold text-slate-900",
									children: e.count
								})]
							}, e.date)) : /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-500",
								children: "Daily counters appear once jobs start executing."
							})
						})]
					}),
					/* @__PURE__ */ v("section", {
						className: "rounded-[1.6rem] border border-white/80 bg-white/82 px-4 py-4 shadow-[0_10px_30px_rgba(51,65,85,0.08)]",
						"data-testid": "job-error-summary",
						children: [
							/* @__PURE__ */ _("p", {
								className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
								children: "Error summary"
							}),
							/* @__PURE__ */ _("h2", {
								className: "mt-2 text-lg font-semibold text-slate-900",
								children: "Today's top failures"
							}),
							/* @__PURE__ */ _("div", {
								className: "mt-4 space-y-3",
								children: a.topErrors.length > 0 ? a.topErrors.map((e) => /* @__PURE__ */ v("div", {
									className: "rounded-[1.2rem] border border-rose-100 bg-rose-50 px-4 py-3",
									children: [/* @__PURE__ */ v("div", {
										className: "flex items-center justify-between gap-3",
										children: [/* @__PURE__ */ _("p", {
											className: "text-sm font-semibold text-rose-900",
											children: e.message
										}), /* @__PURE__ */ _("span", {
											className: "rounded-full bg-white px-2.5 py-1 text-[11px] font-semibold text-rose-700",
											children: e.count
										})]
									}), /* @__PURE__ */ v("p", {
										className: "mt-2 text-xs text-rose-700",
										children: [
											"Last seen ",
											new Date(e.lastSeenAt).toLocaleTimeString(),
											"."
										]
									})]
								}, e.message)) : /* @__PURE__ */ _("div", {
									className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-500",
									children: "No errors captured for today."
								})
							})
						]
					}),
					/* @__PURE__ */ v("section", {
						className: "rounded-[1.6rem] border border-white/80 bg-white/82 px-4 py-4 shadow-[0_10px_30px_rgba(51,65,85,0.08)]",
						"data-testid": "job-scheduled-list",
						children: [
							/* @__PURE__ */ _("p", {
								className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
								children: "Upcoming schedules"
							}),
							/* @__PURE__ */ _("h2", {
								className: "mt-2 text-lg font-semibold text-slate-900",
								children: "Queued for later"
							}),
							/* @__PURE__ */ _("div", {
								className: "mt-4 space-y-3",
								children: s.length > 0 ? s.map((e) => /* @__PURE__ */ v("div", {
									className: "rounded-[1.2rem] border border-violet-100 bg-violet-50/80 px-4 py-3",
									children: [
										/* @__PURE__ */ v("div", {
											className: "flex items-center justify-between gap-3",
											children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
												className: "text-sm font-semibold text-slate-900",
												children: VO(e.type)
											}), /* @__PURE__ */ _("p", {
												className: "mt-1 text-xs text-slate-600",
												children: HO(e.params)
											})] }), /* @__PURE__ */ _("span", {
												className: "rounded-full bg-white px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.12em] text-violet-700",
												children: e.recurrence === "monthly" ? "monthly" : e.status
											})]
										}),
										/* @__PURE__ */ v("p", {
											className: "mt-3 text-xs text-slate-600",
											children: [
												e.recurrence === "monthly" ? "Next run" : "Runs",
												" ",
												TO(e.runAt),
												"."
											]
										}),
										e.lastJobId ? /* @__PURE__ */ v("p", {
											className: "mt-2 text-xs text-slate-600",
											children: [
												"Last job ",
												e.lastJobId,
												"."
											]
										}) : null,
										e.lastError ? /* @__PURE__ */ _("p", {
											className: "mt-2 text-xs text-rose-700",
											children: e.lastError
										}) : null
									]
								}, e.id)) : /* @__PURE__ */ _("div", {
									className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-sm text-slate-500",
									children: "No scheduled jobs yet. Use Create new job to line one up."
								})
							})
						]
					})
				]
			}),
			/* @__PURE__ */ _("div", {
				className: "flex min-h-0 flex-1 flex-col gap-5 overflow-hidden p-5",
				children: /* @__PURE__ */ v("section", {
					className: "flex min-h-0 flex-1 flex-col overflow-hidden",
					children: [/* @__PURE__ */ _("div", {
						className: "mb-4 flex flex-wrap items-center gap-2",
						children: ne.length > 0 ? ne.map(([e, t]) => /* @__PURE__ */ v("span", {
							className: "inline-flex items-center rounded-full border border-slate-200 bg-white/80 px-3 py-1 text-[11px] font-medium text-slate-600",
							children: [
								e,
								": ",
								t
							]
						}, e)) : /* @__PURE__ */ _("span", {
							className: "inline-flex items-center rounded-full border border-slate-200 bg-white/80 px-3 py-1 text-[11px] font-medium text-slate-500",
							children: "Transport hints appear once jobs arrive."
						})
					}), /* @__PURE__ */ _("div", {
						className: "grid min-h-0 flex-1 gap-4 overflow-auto xl:grid-cols-5 md:grid-cols-2",
						children: IO.map((e) => {
							let r = W[e.status] ?? [];
							return /* @__PURE__ */ v("section", {
								className: `flex min-h-[16rem] flex-col overflow-hidden rounded-[1.6rem] border ${e.accent} ${e.surface} shadow-[0_16px_40px_rgba(51,65,85,0.07)]`,
								"data-testid": `job-status-column-${e.status}`,
								children: [/* @__PURE__ */ _("div", {
									className: "border-b border-white/70 px-4 py-4",
									children: /* @__PURE__ */ v("div", {
										className: "flex items-center justify-between gap-3",
										children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
											className: `text-xs font-semibold uppercase tracking-[0.2em] ${e.text}`,
											children: e.label
										}), /* @__PURE__ */ v("p", {
											className: "mt-1 text-xs text-slate-500",
											children: [
												r.length,
												" ",
												r.length === 1 ? "job" : "jobs"
											]
										})] }), /* @__PURE__ */ _("span", {
											className: `rounded-full bg-white/80 px-2.5 py-1 text-xs font-semibold ${e.text}`,
											children: r.length
										})]
									})
								}), /* @__PURE__ */ v("div", {
									className: "min-h-0 flex-1 space-y-3 overflow-y-auto px-3 py-3",
									children: [
										p ? /* @__PURE__ */ _("div", {
											className: "rounded-[1.2rem] border border-dashed border-white/80 bg-white/60 px-4 py-6 text-sm text-slate-500",
											children: "Loading jobs..."
										}) : null,
										!p && r.length === 0 ? /* @__PURE__ */ _("div", {
											className: "rounded-[1.2rem] border border-dashed border-white/80 bg-white/60 px-4 py-6 text-sm text-slate-500",
											children: "No jobs in this lane."
										}) : null,
										r.map((e) => {
											let r = V === e.id, i = typeof e.progress == "number" ? Math.max(0, Math.min(100, e.progress)) : null;
											return /* @__PURE__ */ v("a", {
												id: JO(e.id),
												href: t(e.id),
												onClick: (t) => {
													n && (t.preventDefault(), n(e.id));
												},
												className: `w-full rounded-[1.2rem] border px-4 py-3 text-left transition ${r ? "border-slate-900 bg-white text-slate-900 shadow-[0_12px_28px_rgba(15,23,42,0.16)]" : "border-white/80 bg-white/85 text-slate-900 hover:border-slate-300 hover:bg-white"}`,
												"data-testid": `job-card-${e.id}`,
												children: [
													/* @__PURE__ */ v("div", {
														className: "flex items-start justify-between gap-3",
														children: [/* @__PURE__ */ v("div", {
															className: "min-w-0",
															children: [
																/* @__PURE__ */ _("p", {
																	className: "text-[10px] uppercase tracking-[0.18em] text-slate-400",
																	children: e.id
																}),
																/* @__PURE__ */ _("h2", {
																	className: "mt-1 text-sm font-semibold leading-5",
																	children: VO(e.type)
																}),
																/* @__PURE__ */ _("p", {
																	className: "mt-1 text-xs text-slate-500",
																	children: UO(e)
																})
															]
														}), /* @__PURE__ */ _("span", {
															className: "shrink-0 rounded-full bg-slate-100 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-[0.12em] text-slate-600",
															children: QO(e)
														})]
													}),
													i === null ? null : /* @__PURE__ */ v("div", {
														className: "mt-3",
														children: [/* @__PURE__ */ v("div", {
															className: "mb-1 flex items-center justify-between text-[11px] text-slate-500",
															children: [/* @__PURE__ */ _("span", { children: "Progress" }), /* @__PURE__ */ v("span", { children: [i, "%"] })]
														}), /* @__PURE__ */ _("div", {
															className: "h-2 overflow-hidden rounded-full bg-slate-100",
															children: /* @__PURE__ */ _("div", {
																className: "h-full rounded-full bg-slate-900",
																style: { width: `${i}%` }
															})
														})]
													}),
													/* @__PURE__ */ v("div", {
														className: "mt-3 flex items-center justify-between text-[11px] text-slate-500",
														children: [/* @__PURE__ */ _("span", { children: TO(e.started ?? e.created) }), /* @__PURE__ */ _("span", { children: e.error ? "Needs attention" : "Inspect details" })]
													}),
													e.error ? /* @__PURE__ */ _("p", {
														className: "mt-2 text-xs text-rose-600",
														children: e.error
													}) : null
												]
											}, e.id);
										})
									]
								})]
							}, e.status);
						})
					})]
				})
			})
		]
	});
}
function ak({ jobId: e, userId: t, backHref: n = "/runs", onBack: r }) {
	let [i, a] = h(null), [o, s] = h(!0), [c, l] = h(null), [d, f] = h(null), [p, m] = h(null), [y, b] = h(null), [x, S] = h(null), [C, w] = h(!1), [T, E] = h(KO()), [D, O] = h("none"), k = async (t = !1) => {
		t && s(!0);
		try {
			a(await rk(e)), l(null);
		} catch (e) {
			l(e instanceof Error ? e.message : "Unable to load the job.");
		} finally {
			t && s(!1);
		}
	};
	u(() => {
		let n = !0, r = async (t = !1) => {
			if (n) {
				t && s(!0);
				try {
					let t = await rk(e);
					if (!n) return;
					a(t), l(null);
				} catch (e) {
					if (!n) return;
					l(e instanceof Error ? e.message : "Unable to load the job.");
				} finally {
					t && n && s(!1);
				}
			}
		};
		r(!0);
		let i = window.setInterval(() => {
			r(!1);
		}, 15e3), o = wO({
			userId: t,
			onEvent: (t) => {
				!n || t.job.id !== e || (a((e) => e && {
					...e,
					...t.job,
					status: t.job.status ?? t.canonicalStatus,
					canonicalStatus: t.canonicalStatus,
					result: t.job.result ?? e.result ?? null,
					error: t.job.error ?? e.error ?? null
				}), r(!1));
			}
		});
		return () => {
			n = !1, window.clearInterval(i), o.disconnect();
		};
	}, [e, t]);
	let A = i ? [
		"queued",
		"running",
		"submitted"
	].includes(mO(i.status, i.canonicalStatus)) : !1, j = i ? [
		"failed",
		"canceled",
		"timed_out"
	].includes(mO(i.status, i.canonicalStatus)) : !1, M = async () => {
		if (i) {
			b("cancel"), f(null), m(null);
			try {
				await SO(i.id), m("Cancellation requested."), await k(!1);
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to cancel the job.");
			} finally {
				b(null);
			}
		}
	}, N = async () => {
		if (i) {
			b("retry"), f(null), m(null);
			try {
				let e = BO(i.params) ? i.params : {};
				await xO({
					type: i.type,
					params: {
						...e,
						retryOfJobId: i.id
					}
				}), m("Retry queued.");
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to retry the job.");
			} finally {
				b(null);
			}
		}
	}, P = async () => {
		if (i) {
			b("schedule"), f(null), m(null);
			try {
				let e = BO(i.params) ? i.params : {};
				await CO({
					type: i.type,
					params: e,
					runAt: new Date(T).toISOString(),
					recurrence: D
				}), m(D === "monthly" ? "Monthly schedule saved." : "Schedule saved."), w(!1), E(KO()), O("none");
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to schedule the job.");
			} finally {
				b(null);
			}
		}
	}, F = async (e, t) => {
		if (i) {
			S(`${t}:${e}`), f(null), m(null);
			try {
				await vO(i.id, e, t), m(t === "cancel_node" ? "Node cancellation recorded." : t === "retry_from_node" ? "Retry from node queued." : "Node retry queued."), await k(!1);
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to update the pipeline node.");
			} finally {
				S(null);
			}
		}
	}, I = async () => {
		if (i) {
			S("resume"), f(null), m(null);
			try {
				await yO(i.id), m("Pipeline resume queued."), await k(!1);
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to resume the pipeline run.");
			} finally {
				S(null);
			}
		}
	}, L = async () => {
		if (i) {
			S("cancel-run"), f(null), m(null);
			try {
				await bO(i.id), m("Pipeline cancellation requested."), await k(!1);
			} catch (e) {
				f(e instanceof Error ? e.message : "Unable to cancel the pipeline run.");
			} finally {
				S(null);
			}
		}
	};
	return /* @__PURE__ */ _("section", {
		className: "min-h-full overflow-auto bg-[radial-gradient(circle_at_top_left,#fffbea_0%,#fbfffd_34%,#eef6fb_67%,#e5f1f4_100%)] px-5 py-5",
		"data-testid": "job-detail-page",
		children: /* @__PURE__ */ v("div", {
			className: "mx-auto max-w-6xl overflow-hidden rounded-[1.5rem] border border-white/85 bg-white/86 shadow-[0_18px_46px_rgba(75,119,128,0.12)]",
			"data-testid": "job-detail-panel",
			children: [/* @__PURE__ */ v("div", {
				className: "border-b border-slate-100 px-5 py-5",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between",
					children: [/* @__PURE__ */ v("div", {
						className: "min-w-0",
						children: [
							/* @__PURE__ */ _("a", {
								href: n,
								onClick: (e) => {
									r && (e.preventDefault(), r());
								},
								className: "text-xs font-semibold uppercase tracking-[0.18em] text-slate-500 transition hover:text-slate-900",
								children: "Back to Active runs"
							}),
							/* @__PURE__ */ _("p", {
								className: "mt-4 text-xs uppercase tracking-[0.25em] text-slate-400",
								children: "Selected job"
							}),
							/* @__PURE__ */ _("h1", {
								className: "mt-2 text-2xl font-semibold text-slate-900",
								children: i ? VO(i.type) : o ? "Loading job" : "Job unavailable"
							}),
							i ? /* @__PURE__ */ v("div", {
								className: "mt-3 flex flex-wrap gap-2",
								children: [/* @__PURE__ */ _("span", {
									className: "rounded-full bg-slate-900 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-white",
									children: $O(i)
								}), /* @__PURE__ */ _("span", {
									className: "rounded-full bg-slate-100 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-600",
									children: QO(i)
								})]
							}) : null
						]
					}), i ? /* @__PURE__ */ v("div", {
						className: "flex flex-col gap-2 lg:items-end",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-wrap gap-2",
								"data-testid": "job-action-controls",
								children: [
									/* @__PURE__ */ _("button", {
										type: "button",
										onClick: () => void M(),
										disabled: !A || y !== null,
										className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-50",
										"data-testid": "job-cancel-button",
										children: y === "cancel" ? "Cancelling..." : "Cancel"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										onClick: () => void N(),
										disabled: !j || y !== null,
										className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-50",
										"data-testid": "job-retry-button",
										children: y === "retry" ? "Retrying..." : "Retry"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										onClick: () => {
											w((e) => !e), f(null), m(null);
										},
										disabled: y !== null,
										className: "rounded-full border border-slate-200 bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 transition hover:border-slate-300 hover:text-slate-900 disabled:cursor-not-allowed disabled:opacity-50",
										"data-testid": "job-schedule-selected-button",
										children: "Schedule"
									})
								]
							}),
							p ? /* @__PURE__ */ _("p", {
								className: "rounded-[1rem] bg-emerald-50 px-3 py-2 text-xs font-medium text-emerald-800",
								children: p
							}) : null,
							d ? /* @__PURE__ */ _("p", {
								className: "rounded-[1rem] bg-rose-50 px-3 py-2 text-xs font-medium text-rose-800",
								children: d
							}) : null
						]
					}) : null]
				}), C && i ? /* @__PURE__ */ v("form", {
					className: "mt-5 grid gap-3 rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-4 md:grid-cols-[1fr_12rem_auto]",
					"data-testid": "job-detail-schedule-form",
					onSubmit: (e) => {
						e.preventDefault(), P();
					},
					children: [
						/* @__PURE__ */ v("label", {
							className: "block",
							children: [/* @__PURE__ */ _("span", {
								className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
								children: "Run at"
							}), /* @__PURE__ */ _("input", {
								type: "datetime-local",
								value: T,
								onChange: (e) => E(e.target.value),
								className: "mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition",
								"data-testid": "job-detail-run-at-input"
							})]
						}),
						/* @__PURE__ */ v("label", {
							className: "block",
							children: [/* @__PURE__ */ _("span", {
								className: "text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
								children: "Repeat"
							}), /* @__PURE__ */ v("select", {
								value: D,
								onChange: (e) => O(e.target.value),
								className: "mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm outline-none transition",
								"data-testid": "job-detail-recurrence-select",
								children: [/* @__PURE__ */ _("option", {
									value: "none",
									children: "Once"
								}), /* @__PURE__ */ _("option", {
									value: "monthly",
									children: "Monthly"
								})]
							})]
						}),
						/* @__PURE__ */ _("button", {
							type: "submit",
							disabled: y !== null,
							className: "self-end rounded-full bg-slate-900 px-4 py-3 text-sm font-semibold text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60",
							"data-testid": "job-detail-save-schedule",
							children: y === "schedule" ? "Saving..." : "Save schedule"
						})
					]
				}) : null]
			}), /* @__PURE__ */ v("div", {
				className: "space-y-4 px-5 py-5",
				children: [
					o ? /* @__PURE__ */ _("div", {
						className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-4 py-8 text-sm text-slate-500",
						children: "Loading job ticket..."
					}) : null,
					!o && c ? /* @__PURE__ */ _("div", {
						className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-4 text-sm text-rose-900",
						children: c
					}) : null,
					!o && !c && i ? /* @__PURE__ */ v(g, { children: [
						/* @__PURE__ */ _("div", {
							className: "grid gap-3 md:grid-cols-4",
							children: [
								{
									label: "Created",
									value: TO(i.created)
								},
								{
									label: "Started",
									value: TO(i.started)
								},
								{
									label: "Finished",
									value: TO(i.finished)
								},
								{
									label: "Progress",
									value: typeof i.progress == "number" ? `${i.progress}%` : "Not reported"
								}
							].map((e) => /* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-3 py-3",
								children: [/* @__PURE__ */ _("p", {
									className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
									children: e.label
								}), /* @__PURE__ */ _("p", {
									className: "mt-2 text-sm font-medium leading-5 text-slate-900",
									children: e.value
								})]
							}, e.label))
						}),
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-4",
							children: [
								/* @__PURE__ */ _("p", {
									className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
									children: "Scope"
								}),
								/* @__PURE__ */ _("p", {
									className: "mt-2 text-sm text-slate-700",
									children: UO(i)
								}),
								/* @__PURE__ */ v("div", {
									className: "mt-3 grid gap-3 text-xs text-slate-500 md:grid-cols-4",
									children: [
										/* @__PURE__ */ v("div", { children: [
											/* @__PURE__ */ _("span", {
												className: "font-semibold text-slate-700",
												children: "Worker:"
											}),
											" ",
											i.workerId ?? "Not assigned"
										] }),
										/* @__PURE__ */ v("div", { children: [
											/* @__PURE__ */ _("span", {
												className: "font-semibold text-slate-700",
												children: "Parent:"
											}),
											" ",
											i.parentJobId ?? "Root job"
										] }),
										/* @__PURE__ */ v("div", { children: [
											/* @__PURE__ */ _("span", {
												className: "font-semibold text-slate-700",
												children: "Rows:"
											}),
											" ",
											typeof i.rowsProcessed == "number" ? RO(i.rowsProcessed) : "N/A"
										] }),
										/* @__PURE__ */ v("div", { children: [
											/* @__PURE__ */ _("span", {
												className: "font-semibold text-slate-700",
												children: "Bytes:"
											}),
											" ",
											zO(i.bytesRead)
										] })
									]
								})
							]
						}),
						/* @__PURE__ */ _(FO, {
							actionPending: x,
							job: i,
							onCancelRun: () => {
								L();
							},
							onNodeAction: (e, t) => {
								F(e, t);
							},
							onResumeRun: () => {
								I();
							}
						}),
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-4",
							"data-testid": "job-log-panel",
							children: [/* @__PURE__ */ _("p", {
								className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
								children: "Logs"
							}), /* @__PURE__ */ v("div", {
								className: "mt-3 space-y-2 text-xs leading-5 text-slate-700",
								children: [
									/* @__PURE__ */ v("p", { children: [
										TO(i.created),
										" · queued ",
										i.type
									] }),
									i.started ? /* @__PURE__ */ v("p", { children: [
										TO(i.started),
										" · started on ",
										i.workerId ?? "worker pool"
									] }) : null,
									typeof i.progress == "number" ? /* @__PURE__ */ v("p", { children: [i.progress, "% · progress heartbeat received"] }) : null,
									i.finished ? /* @__PURE__ */ v("p", { children: [
										TO(i.finished),
										" · finished with ",
										$O(i)
									] }) : null,
									i.error ? /* @__PURE__ */ _("p", {
										className: "text-rose-700",
										children: i.error
									}) : null
								]
							})]
						}),
						i.error ? /* @__PURE__ */ _("div", {
							className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
							children: i.error
						}) : null,
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.2rem] border border-slate-200 bg-[#0f172a] px-4 py-4 text-slate-100",
							children: [/* @__PURE__ */ _("p", {
								className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
								children: "Parameters"
							}), /* @__PURE__ */ _("pre", {
								className: "mt-3 overflow-x-auto whitespace-pre-wrap text-xs leading-5 text-slate-200",
								children: WO(i.params)
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.2rem] border border-slate-200 bg-[#111827] px-4 py-4 text-slate-100",
							children: [/* @__PURE__ */ _("p", {
								className: "text-[10px] uppercase tracking-[0.16em] text-slate-400",
								children: "Result"
							}), /* @__PURE__ */ _("pre", {
								className: "mt-3 overflow-x-auto whitespace-pre-wrap text-xs leading-5 text-slate-200",
								children: WO(i.result)
							})]
						})
					] }) : null
				]
			})]
		})
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/ScoreRing.tsx
function ok({ score: e, size: t = 56, stroke: n = 5 }) {
	if (e == null) return /* @__PURE__ */ _("div", {
		className: "flex items-center justify-center rounded-full border-2 border-dashed border-slate-200 text-xs text-slate-400",
		style: {
			width: t,
			height: t
		},
		children: "N/A"
	});
	let r = (t - n) / 2, i = 2 * Math.PI * r, a = i - e / 100 * i, o = e >= 80 ? "#059669" : e >= 60 ? "#d97706" : "#dc2626";
	return /* @__PURE__ */ v("div", {
		className: "relative",
		style: {
			width: t,
			height: t
		},
		children: [/* @__PURE__ */ v("svg", {
			width: t,
			height: t,
			children: [/* @__PURE__ */ _("circle", {
				cx: t / 2,
				cy: t / 2,
				r,
				fill: "none",
				stroke: "#e2e8f0",
				strokeWidth: n
			}), /* @__PURE__ */ _("circle", {
				cx: t / 2,
				cy: t / 2,
				r,
				fill: "none",
				stroke: o,
				strokeWidth: n,
				strokeDasharray: i,
				strokeDashoffset: a,
				strokeLinecap: "round",
				transform: `rotate(-90 ${t / 2} ${t / 2})`
			})]
		}), /* @__PURE__ */ _("div", {
			className: "absolute inset-0 flex items-center justify-center text-sm font-bold",
			style: { color: o },
			children: e
		})]
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/reportsPanelUtils.ts
function sk(e) {
	return e < 1024 ? `${e} B` : e < 1024 * 1024 ? `${(e / 1024).toFixed(1)} KB` : `${(e / (1024 * 1024)).toFixed(1)} MB`;
}
function ck(e) {
	return new Date(e).toLocaleString();
}
function lk(e) {
	return e === "pass" ? "text-emerald-700 bg-emerald-50 border-emerald-200" : e === "fail" ? "text-rose-700 bg-rose-50 border-rose-200" : "text-slate-500 bg-slate-50 border-slate-200";
}
function uk(e) {
	return e === "pass" ? "✓" : e === "fail" ? "✗" : "—";
}
function dk(e) {
	return e.includes("Accuracy") ? "🎯" : e.includes("Validity") ? "✓" : e.includes("Completeness") ? "▦" : e.includes("Timeliness") ? "⏱" : e.includes("Uniqueness") ? "◇" : e.includes("Consistency") ? "⇄" : e.includes("Core") ? "🔍" : e.includes("Anomaly") ? "⚡" : e.includes("Compliance") ? "📋" : e.includes("Privacy") ? "🔒" : e.includes("Domain") ? "🧠" : "📊";
}
//#endregion
//#region src/panels/ReportsPanel/components/DimensionCard.tsx
function fk({ dim: e, expanded: t, onToggle: n }) {
	let r = e.totalChecks > 0 ? Math.round(e.passed / (e.passed + e.failed || 1) * 100) : 0, i = {
		fast: "border-emerald-200 bg-emerald-50 text-emerald-700",
		slow: "border-amber-200 bg-amber-50 text-amber-700",
		expensive: "border-rose-200 bg-rose-50 text-rose-700"
	}, a = {
		fast: "Fast",
		slow: "Slow",
		expensive: "Expensive"
	}, o = {
		covered: "border-emerald-200 bg-emerald-50 text-emerald-700",
		partial: "border-amber-200 bg-amber-50 text-amber-700",
		gap: "border-rose-200 bg-rose-50 text-rose-700"
	}, s = e.coverageStatus ?? "gap";
	return /* @__PURE__ */ v("div", {
		className: "overflow-hidden rounded-2xl border border-slate-200 bg-white transition-shadow hover:shadow-md",
		children: [/* @__PURE__ */ _("button", {
			type: "button",
			onClick: n,
			className: "w-full px-5 py-4 text-left",
			children: /* @__PURE__ */ v("div", {
				className: "flex items-center justify-between gap-3",
				children: [/* @__PURE__ */ v("div", {
					className: "min-w-0 flex items-center gap-3",
					children: [/* @__PURE__ */ _("span", {
						className: "text-xl",
						children: dk(e.dimension)
					}), /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("div", {
						className: "flex flex-wrap items-center gap-2",
						children: [/* @__PURE__ */ _("p", {
							className: "text-sm font-semibold text-slate-900",
							children: e.dimension
						}), /* @__PURE__ */ _("span", {
							className: `inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${o[s]}`,
							children: s
						})]
					}), /* @__PURE__ */ v("p", {
						className: "mt-0.5 text-xs text-slate-500",
						children: [
							e.totalChecks,
							" checks · ",
							e.passed,
							" passed ·",
							" ",
							e.failed,
							" failed · ",
							e.notRun,
							" not run"
						]
					})] })]
				}), /* @__PURE__ */ v("div", {
					className: "flex items-center gap-3",
					children: [
						/* @__PURE__ */ _(ok, {
							score: e.avgScore,
							size: 42,
							stroke: 4
						}),
						/* @__PURE__ */ _("div", {
							className: "h-2 w-24 overflow-hidden rounded-full bg-slate-100",
							children: /* @__PURE__ */ _("div", {
								className: "h-full rounded-full transition-all",
								style: {
									width: `${r}%`,
									backgroundColor: r >= 80 ? "#059669" : r >= 60 ? "#d97706" : "#dc2626"
								}
							})
						}),
						/* @__PURE__ */ _("svg", {
							className: `h-4 w-4 text-slate-400 transition-transform ${t ? "rotate-180" : ""}`,
							fill: "none",
							viewBox: "0 0 24 24",
							stroke: "currentColor",
							children: /* @__PURE__ */ _("path", {
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 2,
								d: "M19 9l-7 7-7-7"
							})
						})
					]
				})]
			})
		}), t ? /* @__PURE__ */ v("div", {
			className: "border-t border-slate-100 px-5 py-3",
			children: [
				e.description ? /* @__PURE__ */ _("p", {
					className: "mb-3 text-xs leading-5 text-slate-500",
					children: e.description
				}) : null,
				e.missingCapabilities && e.missingCapabilities.length > 0 ? /* @__PURE__ */ v("div", {
					className: "mb-3 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2",
					children: [/* @__PURE__ */ _("p", {
						className: "text-[10px] font-semibold uppercase tracking-wide text-amber-800",
						children: "Routed gap capabilities"
					}), /* @__PURE__ */ _("ul", {
						className: "mt-2 space-y-1 text-xs text-amber-900",
						children: e.missingCapabilities.map((e) => /* @__PURE__ */ v("li", { children: [
							/* @__PURE__ */ _("span", {
								className: "font-semibold",
								children: e.label
							}),
							" ",
							/* @__PURE__ */ v("span", {
								className: "text-amber-800",
								children: [
									"(",
									e.followUpTodoId,
									")"
								]
							})
						] }, e.id))
					})]
				}) : null,
				/* @__PURE__ */ v("table", {
					className: "w-full text-xs",
					children: [/* @__PURE__ */ _("thead", { children: /* @__PURE__ */ v("tr", {
						className: "text-left uppercase tracking-wider text-slate-400",
						children: [
							/* @__PURE__ */ _("th", {
								className: "pb-2 font-medium",
								children: "Check"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-center font-medium",
								children: "Status"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-center font-medium",
								children: "Score"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-center font-medium",
								children: "Issues"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-right font-medium",
								children: "Table"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-right font-medium",
								children: "Duration"
							}),
							/* @__PURE__ */ _("th", {
								className: "pb-2 text-right font-medium",
								children: "Last Run"
							})
						]
					}) }), /* @__PURE__ */ _("tbody", { children: e.checks.map((e) => (() => {
						let t = my(e.checkType)?.costHint;
						return /* @__PURE__ */ v("tr", {
							className: "border-t border-slate-50 hover:bg-slate-50/50",
							children: [
								/* @__PURE__ */ _("td", {
									className: "py-2 pr-2 font-medium text-slate-700",
									children: /* @__PURE__ */ v("div", {
										className: "flex items-center gap-2",
										children: [/* @__PURE__ */ _("span", { children: e.label }), t ? /* @__PURE__ */ _("span", {
											className: `inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide ${i[t]}`,
											children: a[t]
										}) : null]
									})
								}),
								/* @__PURE__ */ _("td", {
									className: "py-2 text-center",
									children: /* @__PURE__ */ v("span", {
										className: `inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase ${lk(e.status)}`,
										children: [
											uk(e.status),
											" ",
											e.status === "not_run" ? "Not Run" : e.status
										]
									})
								}),
								/* @__PURE__ */ _("td", {
									className: "py-2 text-center",
									children: e.overallScore == null ? /* @__PURE__ */ _("span", {
										className: "text-slate-300",
										children: "—"
									}) : /* @__PURE__ */ _("span", {
										className: `font-semibold ${e.overallScore >= 80 ? "text-emerald-600" : e.overallScore >= 60 ? "text-amber-600" : "text-rose-600"}`,
										children: e.overallScore
									})
								}),
								/* @__PURE__ */ _("td", {
									className: "py-2 text-center",
									children: e.issuesFound > 0 ? /* @__PURE__ */ _("span", {
										className: "font-semibold text-rose-600",
										children: e.issuesFound
									}) : /* @__PURE__ */ _("span", {
										className: "text-slate-300",
										children: "0"
									})
								}),
								/* @__PURE__ */ _("td", {
									className: "max-w-[100px] truncate py-2 text-right text-slate-500",
									children: e.tableName ?? "—"
								}),
								/* @__PURE__ */ _("td", {
									className: "py-2 text-right text-slate-500",
									children: e.durationMs == null ? "—" : `${(e.durationMs / 1e3).toFixed(1)}s`
								}),
								/* @__PURE__ */ _("td", {
									className: "py-2 text-right text-slate-500",
									children: e.runAt ? new Date(e.runAt).toLocaleDateString() : "—"
								})
							]
						}, e.checkType);
					})()) })]
				})
			]
		}) : null]
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/NewInspectionDrawer.tsx
var pk = [
	{
		id: "core",
		label: "Core Validation",
		icon: "🔍",
		checks: [
			"Missing Data Analysis",
			"Data Quality",
			"Null Check",
			"Type Inference",
			"Pattern Validation",
			"Constraint Validation",
			"Table Structure"
		]
	},
	{
		id: "anomaly",
		label: "Anomaly Detection",
		icon: "⚡",
		checks: [
			"Anomaly Detection",
			"Business Logic",
			"Cross Table Validation",
			"Time Sequence"
		]
	},
	{
		id: "compliance",
		label: "Compliance",
		icon: "📋",
		checks: [
			"CDM Validation",
			"FHIR Standards",
			"Data Dictionary"
		]
	},
	{
		id: "privacy",
		label: "Privacy Protection",
		icon: "🔒",
		checks: [
			"Privacy Analysis",
			"PHI Detection",
			"Quasi-Identifier Detection",
			"Re-identification Risk",
			"Data Masking",
			"Differential Privacy"
		]
	},
	{
		id: "synthetic",
		label: "Synthetic & AI",
		icon: "🧠",
		checks: [
			"Domain Usage Pattern",
			"Domain Behavior Consistency",
			"Domain Outcome Distribution"
		]
	}
], mk = 100;
async function hk() {
	let e = await xr("/v1/databases?limit=1000&offset=0");
	return Array.isArray(e) ? e : e.data ?? [];
}
async function gk(e) {
	let t = await xr(`/v1/databases/${e}/tables`);
	return (Array.isArray(t) ? t : t.tables ?? []).map((e) => typeof e == "string" ? e : typeof e == "object" && e && "name" in e ? e.name : null).filter(Boolean);
}
function _k({ onClose: e, onSuccess: t }) {
	let [n, r] = h([]), [i, a] = h([]), [o, s] = h(null), [c, l] = h(""), [d, f] = h(new Set(pk.map((e) => e.id))), [p, m] = h(!0), [g, y] = h(!1), [b, x] = h(!1), [S, C] = h(null), [w, T] = h(null);
	u(() => {
		hk().then((e) => {
			r(e), e[0] && s(e[0].database_id);
		}).catch((e) => C(e.message)).finally(() => m(!1));
	}, []), u(() => {
		if (!o) {
			a([]), l("");
			return;
		}
		y(!0), l(""), gk(o).then((e) => {
			a(e);
		}).catch(() => a([])).finally(() => y(!1));
	}, [o]);
	let E = (e) => {
		f((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, D = async () => {
		if (!o) {
			C("Select a database first.");
			return;
		}
		if (d.size === 0) {
			C("Select at least one quality dimension.");
			return;
		}
		let e = c ? [c] : i;
		if (e.length === 0) {
			C("No tables are available for this database.");
			return;
		}
		x(!0), C(null);
		try {
			for (let t of e) await Ty.checkDataQuality(o, t, mk);
			t();
		} catch (e) {
			C(e instanceof Error ? e.message : "Inspection failed. Please try again.");
		} finally {
			x(!1);
		}
	};
	return /* @__PURE__ */ v(vx, {
		open: !0,
		onClose: e,
		showBackdrop: !0,
		backdropClassName: "z-40 bg-black/30 backdrop-blur-[2px]",
		panelClassName: "flex h-full w-full max-w-[480px] flex-col border-l border-slate-200 bg-white/97 shadow-[-20px_0_60px_rgba(15,118,110,0.12)] backdrop-blur-sm",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex items-center justify-between border-b border-slate-100 px-6 py-5",
				children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
					className: "text-xs uppercase tracking-[0.35em] text-[#7d5f2f]",
					children: "Data Quality"
				}), /* @__PURE__ */ _("h2", {
					className: "mt-1 text-xl font-semibold text-slate-900",
					children: "New Inspection"
				})] }), /* @__PURE__ */ _("button", {
					type: "button",
					onClick: e,
					className: "rounded-full p-2 text-slate-400 transition hover:bg-slate-100 hover:text-slate-600",
					"aria-label": "Close",
					children: /* @__PURE__ */ _("svg", {
						className: "h-5 w-5",
						fill: "none",
						viewBox: "0 0 24 24",
						stroke: "currentColor",
						children: /* @__PURE__ */ _("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M6 18L18 6M6 6l12 12"
						})
					})
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex-1 space-y-6 overflow-y-auto px-6 py-5",
				children: [
					S ? /* @__PURE__ */ _("div", {
						className: "rounded-xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
						children: S
					}) : null,
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("label", {
						className: "mb-1.5 block text-xs font-medium uppercase tracking-[0.25em] text-slate-500",
						children: "Database"
					}), p ? /* @__PURE__ */ _("div", { className: "h-9 animate-pulse rounded-lg bg-slate-100" }) : /* @__PURE__ */ v("select", {
						value: o ?? "",
						onChange: (e) => s(Number(e.target.value)),
						className: "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-teal-400 focus:outline-none focus:ring-1 focus:ring-teal-400",
						children: [n.length === 0 ? /* @__PURE__ */ _("option", {
							value: "",
							children: "No databases available"
						}) : null, n.map((e) => /* @__PURE__ */ _("option", {
							value: e.database_id,
							children: e.original_file_name || `Database ${e.database_id}`
						}, e.database_id))]
					})] }),
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("label", {
						className: "mb-1.5 block text-xs font-medium uppercase tracking-[0.25em] text-slate-500",
						children: [
							"Table",
							" ",
							/* @__PURE__ */ _("span", {
								className: "normal-case font-normal tracking-normal text-slate-400",
								children: "(leave blank to inspect every table)"
							})
						]
					}), g ? /* @__PURE__ */ _("div", { className: "h-9 animate-pulse rounded-lg bg-slate-100" }) : /* @__PURE__ */ v("select", {
						value: c,
						onChange: (e) => l(e.target.value),
						className: "w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-900 shadow-sm focus:border-teal-400 focus:outline-none focus:ring-1 focus:ring-teal-400",
						disabled: i.length === 0,
						children: [/* @__PURE__ */ _("option", {
							value: "",
							children: "All tables (database-level)"
						}), i.map((e) => /* @__PURE__ */ _("option", {
							value: e,
							children: e
						}, e))]
					})] }),
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ v("div", {
						className: "mb-2 flex items-center justify-between",
						children: [/* @__PURE__ */ _("label", {
							className: "text-xs font-medium uppercase tracking-[0.25em] text-slate-500",
							children: "Quality Dimensions"
						}), /* @__PURE__ */ v("div", {
							className: "flex gap-2",
							children: [
								/* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => f(new Set(pk.map((e) => e.id))),
									className: "text-[10px] font-medium text-teal-700 hover:text-teal-900",
									children: "All"
								}),
								/* @__PURE__ */ _("span", {
									className: "text-slate-300",
									children: "·"
								}),
								/* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => f(/* @__PURE__ */ new Set()),
									className: "text-[10px] font-medium text-slate-500 hover:text-slate-700",
									children: "None"
								})
							]
						})]
					}), /* @__PURE__ */ _("div", {
						className: "space-y-1.5",
						children: pk.map((e) => {
							let t = d.has(e.id), n = w === e.id;
							return /* @__PURE__ */ v("div", {
								className: `rounded-xl border transition ${t ? "border-teal-200 bg-teal-50/50" : "border-slate-200 bg-white"}`,
								children: [/* @__PURE__ */ v("div", {
									className: "flex items-center gap-3 px-3 py-2.5",
									children: [
										/* @__PURE__ */ _("input", {
											type: "checkbox",
											id: `dim-${e.id}`,
											checked: t,
											onChange: () => E(e.id),
											className: "h-4 w-4 rounded border-slate-300 text-teal-600 focus:ring-teal-500"
										}),
										/* @__PURE__ */ v("label", {
											htmlFor: `dim-${e.id}`,
											className: "flex flex-1 cursor-pointer items-center gap-2 text-sm font-medium text-slate-800",
											children: [
												/* @__PURE__ */ _("span", { children: e.icon }),
												e.label,
												/* @__PURE__ */ v("span", {
													className: "ml-auto text-[10px] text-slate-400",
													children: [e.checks.length, " checks"]
												})
											]
										}),
										/* @__PURE__ */ _("button", {
											type: "button",
											onClick: () => T(n ? null : e.id),
											className: "text-slate-400 hover:text-slate-600",
											"aria-label": n ? "Collapse" : "Expand",
											children: /* @__PURE__ */ _("svg", {
												className: `h-4 w-4 transition-transform ${n ? "rotate-180" : ""}`,
												fill: "none",
												viewBox: "0 0 24 24",
												stroke: "currentColor",
												children: /* @__PURE__ */ _("path", {
													strokeLinecap: "round",
													strokeLinejoin: "round",
													strokeWidth: 2,
													d: "M19 9l-7 7-7-7"
												})
											})
										})
									]
								}), n ? /* @__PURE__ */ _("div", {
									className: "border-t border-slate-100 px-4 py-2",
									children: /* @__PURE__ */ _("div", {
										className: "flex flex-wrap gap-1.5",
										children: e.checks.map((e) => /* @__PURE__ */ _("span", {
											className: "rounded-full border border-slate-200 bg-white px-2 py-0.5 text-[10px] text-slate-600",
											children: e
										}, e))
									})
								}) : null]
							}, e.id);
						})
					})] }),
					/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("label", {
						className: "mb-1.5 block text-xs font-medium uppercase tracking-[0.25em] text-slate-500",
						children: "Report Output"
					}), /* @__PURE__ */ _("div", {
						className: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-sm text-slate-600",
						children: "The inspection creates a markdown and PDF scorecard in the quality report library."
					})] })
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex gap-3 border-t border-slate-100 px-6 py-4",
				children: [/* @__PURE__ */ _("button", {
					type: "button",
					onClick: e,
					className: "flex-1 rounded-full border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-600 transition hover:bg-slate-50",
					children: "Cancel"
				}), /* @__PURE__ */ _("button", {
					type: "button",
					onClick: () => void D(),
					disabled: b || !o || d.size === 0 || g,
					className: "flex-1 rounded-full bg-slate-900 px-4 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-50",
					children: b ? "Running…" : "Run Inspection"
				})]
			})
		]
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/BarChart.tsx
function vk({ data: e, height: t = 120 }) {
	let n = Math.max(...e.map((e) => e.value), 1), r = Math.min(40, Math.floor(220 / e.length));
	return /* @__PURE__ */ _("svg", {
		width: "100%",
		height: t + 28,
		viewBox: `0 0 ${e.length * (r + 8) + 8} ${t + 28}`,
		children: e.map((e, i) => {
			let a = e.value / n * (t - 12), o = i * (r + 8) + 8, s = o + r / 2;
			return /* @__PURE__ */ v("g", { children: [
				/* @__PURE__ */ _("rect", {
					x: o,
					y: t - a - 4,
					width: r,
					height: a,
					rx: 4,
					fill: e.color,
					opacity: .85
				}),
				/* @__PURE__ */ _("text", {
					x: s,
					y: t + 14,
					textAnchor: "middle",
					fontSize: 9,
					fill: "#64748b",
					children: e.label
				}),
				/* @__PURE__ */ _("text", {
					x: s,
					y: t - a - 8,
					textAnchor: "middle",
					fontSize: 9,
					fontWeight: "600",
					fill: "#334155",
					children: e.value
				})
			] }, e.label);
		})
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/TrendLine.tsx
function yk({ data: e, height: t = 80 }) {
	if (e.length < 2) return /* @__PURE__ */ _("div", {
		className: "py-4 text-xs text-slate-400",
		children: "Not enough data for trend visualization"
	});
	let n = e.map((n, r) => ({
		x: 20 + r / (e.length - 1) * 240,
		y: 20 + (100 - n.passRate) / 100 * (t - 40)
	})), r = n.map((e, t) => `${t === 0 ? "M" : "L"} ${e.x} ${e.y}`).join(" ");
	return /* @__PURE__ */ v("svg", {
		width: "100%",
		height: t + 16,
		viewBox: `0 0 280 ${t + 16}`,
		children: [
			/* @__PURE__ */ _("line", {
				x1: 20,
				x2: 260,
				y1: t - 20,
				y2: t - 20,
				stroke: "#e2e8f0"
			}),
			/* @__PURE__ */ _("line", {
				x1: 20,
				x2: 20,
				y1: 20,
				y2: t - 20,
				stroke: "#e2e8f0"
			}),
			/* @__PURE__ */ _("text", {
				x: 16,
				y: 24,
				fontSize: 8,
				fill: "#94a3b8",
				textAnchor: "end",
				children: "100%"
			}),
			/* @__PURE__ */ _("text", {
				x: 16,
				y: t - 20 + 4,
				fontSize: 8,
				fill: "#94a3b8",
				textAnchor: "end",
				children: "0%"
			}),
			/* @__PURE__ */ _("path", {
				d: r,
				fill: "none",
				stroke: "#0d9488",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			n.map((e, t) => /* @__PURE__ */ _("circle", {
				cx: e.x,
				cy: e.y,
				r: 3,
				fill: "#0d9488",
				stroke: "#fff",
				strokeWidth: 1.5
			}, t)),
			/* @__PURE__ */ _("text", {
				x: 20,
				y: t + 8,
				fontSize: 7,
				fill: "#94a3b8",
				children: e[0].date.slice(5)
			}),
			/* @__PURE__ */ _("text", {
				x: 260,
				y: t + 8,
				fontSize: 7,
				fill: "#94a3b8",
				textAnchor: "end",
				children: e[e.length - 1].date.slice(5)
			})
		]
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/StatisticsPanel.tsx
function bk({ stats: e }) {
	let t = e.scoreDistribution.map((e) => ({
		label: e.bucket,
		value: e.count,
		color: e.bucket === "81-100" ? "#059669" : e.bucket === "61-80" ? "#0d9488" : e.bucket === "41-60" ? "#d97706" : e.bucket === "21-40" ? "#ea580c" : "#dc2626"
	}));
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		children: [
			/* @__PURE__ */ _("div", {
				className: "grid grid-cols-4 gap-3",
				children: [
					{
						label: "Total Runs",
						value: e.totalChecksRun,
						color: "text-slate-900"
					},
					{
						label: "Passed",
						value: e.totalPassed,
						color: "text-emerald-600"
					},
					{
						label: "Failed",
						value: e.totalFailed,
						color: "text-rose-600"
					},
					{
						label: "Pass Rate",
						value: `${e.passRate}%`,
						color: e.passRate >= 80 ? "text-emerald-600" : e.passRate >= 60 ? "text-amber-600" : "text-rose-600"
					}
				].map((e) => /* @__PURE__ */ v("div", {
					className: "rounded-xl border border-slate-200 bg-white px-4 py-3 text-center",
					children: [/* @__PURE__ */ _("p", {
						className: "text-xs uppercase tracking-wider text-slate-400",
						children: e.label
					}), /* @__PURE__ */ _("p", {
						className: `mt-1 text-2xl font-bold ${e.color}`,
						children: e.value
					})]
				}, e.label))
			}),
			/* @__PURE__ */ v("div", {
				className: "grid grid-cols-2 gap-4",
				children: [/* @__PURE__ */ v("div", {
					className: "rounded-xl border border-slate-200 bg-white p-4",
					children: [/* @__PURE__ */ _("p", {
						className: "mb-3 text-xs uppercase tracking-wider text-slate-400",
						children: "Score Distribution"
					}), /* @__PURE__ */ _(vk, { data: t })]
				}), /* @__PURE__ */ v("div", {
					className: "rounded-xl border border-slate-200 bg-white p-4",
					children: [/* @__PURE__ */ _("p", {
						className: "mb-3 text-xs uppercase tracking-wider text-slate-400",
						children: "Pass Rate Trend (14d)"
					}), /* @__PURE__ */ _(yk, { data: e.recentTrend })]
				})]
			}),
			e.topFailingChecks.length > 0 ? /* @__PURE__ */ v("div", {
				className: "rounded-xl border border-slate-200 bg-white p-4",
				children: [/* @__PURE__ */ _("p", {
					className: "mb-3 text-xs uppercase tracking-wider text-slate-400",
					children: "Top Failing Checks"
				}), /* @__PURE__ */ _("div", {
					className: "space-y-2",
					children: e.topFailingChecks.map((t) => /* @__PURE__ */ v("div", {
						className: "flex items-center justify-between",
						children: [/* @__PURE__ */ _("span", {
							className: "text-sm text-slate-700",
							children: t.label
						}), /* @__PURE__ */ v("div", {
							className: "flex items-center gap-2",
							children: [/* @__PURE__ */ _("div", {
								className: "h-2 w-20 overflow-hidden rounded-full bg-slate-100",
								children: /* @__PURE__ */ _("div", {
									className: "h-full rounded-full bg-rose-500",
									style: { width: `${Math.min(100, t.failCount / Math.max(1, e.totalChecksRun) * 500)}%` }
								})
							}), /* @__PURE__ */ _("span", {
								className: "w-8 text-right text-xs font-semibold text-rose-600",
								children: t.failCount
							})]
						})]
					}, t.checkType))
				})]
			}) : null
		]
	});
}
//#endregion
//#region src/panels/ReportsPanel/components/lineageGraph.ts
var xk = [
	"database",
	"table",
	"column",
	"check",
	"issue",
	"report"
], Sk = {
	database: {
		label: "Databases",
		accent: "#06b6d4",
		surface: "rgba(6, 182, 212, 0.16)",
		description: "Database assets anchoring lineage scope."
	},
	table: {
		label: "Tables",
		accent: "#10b981",
		surface: "rgba(16, 185, 129, 0.16)",
		description: "Table assets traced as report sources and downstream dependencies."
	},
	column: {
		label: "Columns",
		accent: "#8b5cf6",
		surface: "rgba(139, 92, 246, 0.16)",
		description: "Columns connected to the current table lineage path."
	},
	check: {
		label: "Checks",
		accent: "#f59e0b",
		surface: "rgba(245, 158, 11, 0.16)",
		description: "Quality checks produced from the traced table asset."
	},
	issue: {
		label: "Issues",
		accent: "#ef4444",
		surface: "rgba(239, 68, 68, 0.16)",
		description: "Quality issues detected by checks in the lineage graph."
	},
	report: {
		label: "Reports",
		accent: "#fb923c",
		surface: "rgba(251, 146, 60, 0.16)",
		description: "Reports summarized from the traced asset."
	}
}, Ck = {
	has_table: {
		label: "Has Table",
		stroke: "rgba(16,185,129,0.28)"
	},
	has_column: {
		label: "Has Column",
		stroke: "rgba(139,92,246,0.28)"
	},
	produced_by: {
		label: "Produced By",
		stroke: "rgba(245,158,11,0.28)"
	},
	has_issue: {
		label: "Has Issue",
		stroke: "rgba(239,68,68,0.3)"
	},
	summarized_in: {
		label: "Summarized In",
		stroke: "rgba(251,146,60,0.28)"
	}
};
function wk(e) {
	return e?.lineage ? {
		nodes: e.lineage.nodes.map((e) => ({
			id: e.id,
			type: e.type,
			name: e.label,
			filePath: typeof e.asset?.assetKey == "string" ? e.asset.assetKey : e.id,
			confidence: 1
		})),
		edges: e.lineage.edges.map((e) => ({
			source: e.from,
			target: e.to,
			type: e.relation,
			confidence: 1
		})),
		meta: {
			builtAt: e.lineage.lastIndexedAt,
			fileCount: e.lineage.nodes.length,
			sourceRoot: ""
		}
	} : null;
}
//#endregion
//#region src/panels/ReportsPanel/index.tsx
function Tk(e) {
	return e.unit === "currency" ? `$${Math.round(e.value).toLocaleString("en-US")}` : e.unit === "percentage" ? `${(e.value * 100).toFixed(1)}%` : e.unit === "months" ? `${e.value.toFixed(1)} mo` : e.unit === "ratio" ? e.value.toFixed(2) : Math.round(e.value).toLocaleString("en-US");
}
function Ek(e) {
	return e.variance ? e.variance.percentChange == null ? `${e.variance.absoluteChange ?? 0}` : `${e.variance.percentChange >= 0 ? "+" : ""}${(e.variance.percentChange * 100).toFixed(1)}%` : "No comparison";
}
function Dk(e) {
	return e === "ready_for_review" || e === "approved" || e === "exported" ? "success" : e === "needs_source_refresh" ? "warning" : "neutral";
}
function Ok(e) {
	return e === "ready" || e === "signed_off" ? "success" : e === "needs_attention" ? "warning" : e === "blocked" ? "danger" : "neutral";
}
function kk(e) {
	return e === "pass" ? "success" : e === "warn" ? "warning" : e === "fail" ? "danger" : e === "not_applicable" ? "neutral" : "info";
}
function Ak({ forcedWorkspaceMode: e, hideSidebar: t } = {}) {
	let [n, r] = h(e ?? "reports"), [i, a] = h([]), [o, s] = h(null), [c, l] = h(null), [d, p] = h(null), [m, y] = h(null), [b, x] = h(null), [S, C] = h(null), [w, T] = h("all"), [E, D] = h("dimensions"), [O, k] = h(/* @__PURE__ */ new Set()), [A, j] = h(!0), [M, N] = h(!1), [P, F] = h(!1), [I, L] = h(!1), [R, z] = h(!1), [B, V] = h(!1), [H, ee] = h(!1), [U, te] = h(!1), [W, ne] = h(!1), [re, ie] = h(""), [ae, oe] = h(""), [se, ce] = h(""), [le, ue] = h(""), [de, fe] = h(null), [pe, me] = h(null), [he, ge] = h(null), [_e, ve] = h(!1), [ye, be] = h(!1);
	u(() => {
		let e = !0;
		return j(!0), fe(null), Ar.listReports().then((t) => {
			e && (a(t), s(t[0]?.fileName ?? null));
		}).catch((t) => {
			e && fe(t.message || "Unable to load reports.");
		}).finally(() => {
			e && j(!1);
		}), () => {
			e = !1;
		};
	}, []);
	let xe = f(() => i.filter((e) => w === "all" ? !0 : e.format === w), [w, i]), Se = xe.find((e) => e.fileName === o) ?? xe[0] ?? null, Ce = f(() => wk(c), [c]);
	u(() => {
		let e = !0;
		if (!Se) {
			l(null);
			return;
		}
		return N(!0), Ar.getReportDetails(Se.fileName).then((t) => {
			e && l(t);
		}).catch(() => {
			e && l(null);
		}).finally(() => {
			e && N(!1);
		}), () => {
			e = !1;
		};
	}, [Se?.fileName]), u(() => {
		let e = !0;
		return n !== "boardPacket" || d ? () => {
			e = !1;
		} : (F(!0), me(null), Ar.previewBoardPacket().then((t) => {
			e && (p(t), F(!1));
		}).catch((t) => {
			e && (me(t.message || "Unable to load board packet."), F(!1));
		}), () => {
			e = !1;
		});
	}, [d, n]), u(() => {
		let e = !0;
		return n !== "readiness" || b ? () => {
			e = !1;
		} : (ee(!0), ge(null), Ar.previewReportReadiness().then((t) => {
			e && (x(t), ee(!1));
		}).catch((t) => {
			e && (ge(t.message || "Unable to load report readiness."), ee(!1));
		}), () => {
			e = !1;
		});
	}, [b, n]);
	let we = () => {
		j(!0), fe(null), Ar.listReports().then((e) => {
			a(e), o || s(e[0]?.fileName ?? null);
		}).catch((e) => fe(e.message || "Unable to load reports.")).finally(() => j(!1));
	}, G = () => {
		ve(!1), be(!0), we(), window.setTimeout(() => be(!1), 4e3);
	}, Te = async (e) => {
		let t = await Ar.downloadReport(e.fileName);
		Ar.triggerBrowserDownload(t, e.fileName);
	}, Ee = () => {
		p(null), y(null);
	}, K = async () => {
		L(!0), me(null);
		try {
			let e = await Ar.exportBoardPacket();
			y(e), p(e.artifact);
		} catch (e) {
			me(e instanceof Error ? e.message : "Unable to export board packet.");
		} finally {
			L(!1);
		}
	}, De = async () => {
		if (!re.trim()) {
			me("Reviewer name is required for packet signoff.");
			return;
		}
		z(!0), me(null);
		try {
			p(await Ar.signOffBoardPacket({
				reviewerName: re.trim(),
				reviewerEmail: ae.trim() || void 0
			}));
		} catch (e) {
			me(e instanceof Error ? e.message : "Unable to sign off board packet.");
		} finally {
			z(!1);
		}
	}, Oe = async () => {
		if (!d?.review.signedOffAt || !d.review.signedOffBy) {
			me("Raw exports can be marked deleted only after packet signoff.");
			return;
		}
		V(!0), me(null);
		try {
			p(await Ar.markBoardPacketRawSourcesDeleted({
				reviewerName: d.review.signedOffBy.name,
				reviewerEmail: d.review.signedOffBy.email,
				signedOffAt: d.review.signedOffAt
			}));
		} catch (e) {
			me(e instanceof Error ? e.message : "Unable to mark raw exports deleted.");
		} finally {
			V(!1);
		}
	}, ke = () => {
		x(null), C(null);
	}, Ae = async () => {
		if (b) {
			te(!0), ge(null);
			try {
				C(await Ar.exportReportReadiness(b));
			} catch (e) {
				ge(e instanceof Error ? e.message : "Unable to export readiness ledger.");
			} finally {
				te(!1);
			}
		}
	}, je = async () => {
		if (b) {
			if (!se.trim()) {
				ge("Attestor name is required for report readiness signoff.");
				return;
			}
			ne(!0), ge(null);
			try {
				x(await Ar.signOffReportReadiness(b, {
					actorName: se.trim(),
					actorEmail: le.trim() || void 0,
					role: b.manifest.signoffRole
				}));
			} catch (e) {
				ge(e instanceof Error ? e.message : "Unable to sign off report readiness.");
			} finally {
				ne(!1);
			}
		}
	}, Me = (e) => {
		k((t) => {
			let n = new Set(t);
			return n.has(e) ? n.delete(e) : n.add(e), n;
		});
	}, Ne = d?.metrics.filter((e) => e.varianceFlag === "material").length ?? 0, Pe = d?.rawSourceRetention.sources.filter((e) => e.deletionDue).length ?? 0, Fe = b?.checkResults.filter((e) => e.status === "fail").length ?? 0, Ie = b?.checkResults.filter((e) => e.status === "warn").length ?? 0;
	return /* @__PURE__ */ v("div", {
		className: "relative flex min-h-full flex-col overflow-hidden bg-[radial-gradient(circle_at_top_left,#fff8ea_0%,#fffefb_30%,#eef7f5_68%,#dceef1_100%)]",
		children: [
			ye && /* @__PURE__ */ _("div", {
				className: "pointer-events-none fixed bottom-6 left-1/2 z-50 -translate-x-1/2",
				children: /* @__PURE__ */ v("div", {
					className: "flex items-center gap-2.5 rounded-2xl border border-emerald-200 bg-emerald-50 px-5 py-3 shadow-lg text-sm font-medium text-emerald-800",
					children: [/* @__PURE__ */ _("svg", {
						className: "h-4 w-4 text-emerald-600",
						fill: "none",
						viewBox: "0 0 24 24",
						stroke: "currentColor",
						children: /* @__PURE__ */ _("path", {
							strokeLinecap: "round",
							strokeLinejoin: "round",
							strokeWidth: 2,
							d: "M5 13l4 4L19 7"
						})
					}), "Inspection started — report will appear in the library shortly."]
				})
			}),
			/* @__PURE__ */ _("div", {
				className: "border-b border-white/70 bg-white/60 px-6 py-5 backdrop-blur",
				children: /* @__PURE__ */ v("div", {
					className: "flex max-w-6xl items-start justify-between gap-4",
					children: [/* @__PURE__ */ v("div", { children: [
						/* @__PURE__ */ _("p", {
							className: "text-xs uppercase tracking-[0.42em] text-[#7d5f2f]",
							children: n === "boardPacket" ? "Board Packet" : n === "readiness" ? "Delivery QA" : "Data Quality Checks"
						}),
						/* @__PURE__ */ _("h1", {
							className: "mt-3 text-4xl font-semibold tracking-tight text-slate-900",
							children: n === "boardPacket" ? "Period-over-period metrics, signoff, and source retention." : n === "readiness" ? "Manifest-first readiness ledger and attestation workflow." : "Quality inspection results at a glance."
						}),
						/* @__PURE__ */ _("p", {
							className: "mt-3 max-w-3xl text-sm leading-6 text-slate-600",
							children: n === "boardPacket" ? "Manage the monthly board metrics packet, track variance flags, validate reviewer signoff, and enforce source retention policy." : n === "readiness" ? "Verify manifested source freshness, run readiness checks, attest the delivery ledger, and export the buyer-facing evidence packet." : "Browse scorecards, drill into dimension-level pass/fail breakdowns, and visualize statistical trends across all quality check runs."
						}),
						e ? null : /* @__PURE__ */ _(Sx, {
							ariaLabel: "Reports workspace mode",
							value: n,
							onChange: (e) => r(e),
							variant: "pill",
							className: "mt-4",
							items: [
								{
									value: "reports",
									label: "Quality Reports"
								},
								{
									value: "boardPacket",
									label: "Board Packet"
								},
								{
									value: "readiness",
									label: "Delivery QA"
								}
							]
						})
					] }), n === "reports" ? /* @__PURE__ */ v("button", {
						type: "button",
						onClick: () => ve(!0),
						className: "mt-4 shrink-0 flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition hover:bg-slate-800",
						children: [/* @__PURE__ */ _("svg", {
							className: "h-4 w-4",
							fill: "none",
							viewBox: "0 0 24 24",
							stroke: "currentColor",
							children: /* @__PURE__ */ _("path", {
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeWidth: 2,
								d: "M12 4v16m8-8H4"
							})
						}), "New Inspection"]
					}) : null]
				})
			}),
			/* @__PURE__ */ v("div", {
				className: "flex min-h-0 flex-1 gap-5 overflow-hidden p-5",
				children: [/* @__PURE__ */ v("aside", {
					className: `flex w-[340px] min-w-[300px] flex-col overflow-hidden rounded-[1.8rem] border border-white/85 bg-white/78 shadow-[0_18px_46px_rgba(75,119,128,0.12)]${t ? " hidden" : ""}`,
					children: [/* @__PURE__ */ _("div", {
						className: "border-b border-slate-100 px-5 py-4",
						children: /* @__PURE__ */ v("div", {
							className: "flex items-center justify-between gap-3",
							children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
								className: "text-xs uppercase tracking-[0.25em] text-[#7d5f2f]/65",
								children: "Library"
							}), /* @__PURE__ */ v("p", {
								className: "mt-1 text-sm text-slate-600",
								children: [i.length, " reports"]
							})] }), /* @__PURE__ */ v("div", {
								className: "flex items-center gap-1.5",
								children: [[
									"all",
									"md",
									"pdf"
								].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => T(e),
									className: `rounded-full px-2.5 py-1 text-[10px] font-medium transition ${w === e ? "bg-slate-900 text-white" : "bg-slate-100 text-slate-600 hover:bg-slate-200"}`,
									children: e === "all" ? "All" : e.toUpperCase()
								}, e)), /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => ve(!0),
									className: "ml-1 flex items-center gap-1 rounded-full bg-teal-700 px-2.5 py-1 text-[10px] font-medium text-white transition hover:bg-teal-800",
									title: "New Inspection",
									children: [/* @__PURE__ */ _("svg", {
										className: "h-3 w-3",
										fill: "none",
										viewBox: "0 0 24 24",
										stroke: "currentColor",
										children: /* @__PURE__ */ _("path", {
											strokeLinecap: "round",
											strokeLinejoin: "round",
											strokeWidth: 2.5,
											d: "M12 4v16m8-8H4"
										})
									}), "New"]
								})]
							})]
						})
					}), /* @__PURE__ */ v("div", {
						className: "min-h-0 flex-1 overflow-y-auto px-3 py-3",
						children: [
							A ? /* @__PURE__ */ _("div", {
								className: "px-2 py-6 text-sm text-slate-500",
								children: "Loading reports…"
							}) : null,
							de ? /* @__PURE__ */ _("div", {
								className: "rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
								children: de
							}) : null,
							!A && !de && xe.length === 0 ? /* @__PURE__ */ v("div", {
								className: "rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-4 py-6 text-center text-sm text-slate-500",
								children: [/* @__PURE__ */ _("p", { children: "No reports match this filter yet." }), /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => ve(!0),
									className: "mt-3 inline-flex items-center gap-1.5 rounded-full border border-teal-300 bg-teal-50 px-3 py-1.5 text-xs font-medium text-teal-700 transition hover:bg-teal-100",
									children: [/* @__PURE__ */ _("svg", {
										className: "h-3.5 w-3.5",
										fill: "none",
										viewBox: "0 0 24 24",
										stroke: "currentColor",
										children: /* @__PURE__ */ _("path", {
											strokeLinecap: "round",
											strokeLinejoin: "round",
											strokeWidth: 2,
											d: "M12 4v16m8-8H4"
										})
									}), "Start first inspection"]
								})]
							}) : null,
							/* @__PURE__ */ _("div", {
								className: "space-y-2",
								children: xe.map((e) => /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => s(e.fileName),
									className: `w-full rounded-[1.2rem] border px-4 py-3 text-left transition ${e.fileName === Se?.fileName ? "border-[#0f766e] bg-[linear-gradient(180deg,#ecfeff_0%,#f8fffe_100%)] shadow-[0_8px_20px_rgba(15,118,110,0.10)]" : "border-slate-200 bg-white hover:border-slate-300 hover:bg-slate-50"}`,
									children: [/* @__PURE__ */ v("div", {
										className: "flex items-center justify-between gap-2",
										children: [/* @__PURE__ */ v("div", {
											className: "min-w-0",
											children: [/* @__PURE__ */ _("p", {
												className: "truncate text-sm font-semibold text-slate-900",
												children: e.datasetName
											}), /* @__PURE__ */ _("p", {
												className: "mt-0.5 truncate text-[11px] text-slate-500",
												children: e.fileName
											})]
										}), /* @__PURE__ */ _(_x, {
											tone: e.format === "pdf" ? "danger" : "success",
											size: "xs",
											className: "shrink-0",
											children: e.format
										})]
									}), /* @__PURE__ */ v("div", {
										className: "mt-2 flex items-center justify-between text-[11px] text-slate-400",
										children: [/* @__PURE__ */ _("span", { children: sk(e.sizeBytes) }), /* @__PURE__ */ _("span", { children: ck(e.updatedAt) })]
									})]
								}, e.fileName))
							})
						]
					})]
				}), /* @__PURE__ */ v("section", {
					className: "flex min-h-0 flex-1 flex-col overflow-hidden rounded-[1.9rem] border border-white/85 bg-white/82 shadow-[0_18px_46px_rgba(75,119,128,0.12)]",
					children: [/* @__PURE__ */ _("div", {
						className: "border-b border-slate-100 px-6 py-4",
						children: n === "readiness" ? /* @__PURE__ */ v("div", {
							className: "flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between",
							children: [/* @__PURE__ */ v("div", { children: [
								/* @__PURE__ */ v("div", {
									className: "flex flex-wrap items-center gap-2",
									children: [/* @__PURE__ */ _(_x, {
										tone: Ok(b?.status),
										size: "xs",
										children: b?.status.replace(/_/g, " ") ?? "loading"
									}), /* @__PURE__ */ _("span", {
										className: "text-xs text-slate-500",
										children: b ? `${b.checkResults.length} checks · ${Fe} failed` : "Manifest-first pilot"
									})]
								}),
								/* @__PURE__ */ _("h2", {
									className: "mt-2 text-xl font-semibold text-slate-900",
									children: b?.manifest.reportName ?? "Report Delivery QA"
								}),
								/* @__PURE__ */ _("p", {
									className: "mt-1 text-xs text-slate-500",
									children: b ? `${b.manifest.owner.name} · ${b.manifest.expectedArtifact.fileName}` : "Preparing readiness ledger"
								})
							] }), /* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center gap-2",
								children: [
									/* @__PURE__ */ _("button", {
										type: "button",
										onClick: ke,
										className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-medium text-slate-700 transition hover:bg-slate-50",
										children: "Refresh"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										disabled: !b || U,
										onClick: () => void Ae(),
										className: "rounded-full bg-slate-900 px-4 py-2 text-xs font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300",
										children: U ? "Exporting" : "Export Ledger"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										disabled: !b || b.status !== "ready" || W,
										onClick: () => void je(),
										className: "rounded-full bg-teal-700 px-4 py-2 text-xs font-medium text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:bg-slate-300",
										children: b?.status === "signed_off" ? "Signed Off" : W ? "Signing" : "Sign Off Readiness"
									})
								]
							})]
						}) : n === "boardPacket" ? /* @__PURE__ */ v("div", {
							className: "flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between",
							children: [/* @__PURE__ */ v("div", { children: [
								/* @__PURE__ */ v("div", {
									className: "flex flex-wrap items-center gap-2",
									children: [/* @__PURE__ */ _(_x, {
										tone: d ? Dk(d.status) : "neutral",
										size: "xs",
										children: d?.status.replace(/_/g, " ") ?? "loading"
									}), /* @__PURE__ */ _("span", {
										className: "text-xs text-slate-500",
										children: d ? `${d.reportingPeriod.periodKey} vs ${d.comparisonPeriod.periodKey}` : "Monthly packet"
									})]
								}),
								/* @__PURE__ */ _("h2", {
									className: "mt-2 text-xl font-semibold text-slate-900",
									children: d?.companyName ?? "Board Metrics Packet"
								}),
								/* @__PURE__ */ _("p", {
									className: "mt-1 text-xs text-slate-500",
									children: d ? `${d.metrics.length} metrics · ${Ne} material variances` : "Preparing packet"
								})
							] }), /* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center gap-2",
								children: [
									/* @__PURE__ */ _("button", {
										type: "button",
										onClick: Ee,
										className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-xs font-medium text-slate-700 transition hover:bg-slate-50",
										children: "Refresh"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										disabled: !d || I,
										onClick: () => void K(),
										className: "rounded-full bg-slate-900 px-4 py-2 text-xs font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:bg-slate-300",
										children: I ? "Exporting" : "Export Preview"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										disabled: !d || d.review.signedOff || R,
										onClick: () => void De(),
										className: "rounded-full bg-teal-700 px-4 py-2 text-xs font-medium text-white transition hover:bg-teal-800 disabled:cursor-not-allowed disabled:bg-slate-300",
										children: d?.review.signedOff ? "Signed Off" : R ? "Signing" : "Sign Off"
									}),
									/* @__PURE__ */ _("button", {
										type: "button",
										disabled: !d?.review.signedOff || d.rawSourceRetention.status === "deleted" || B,
										onClick: () => void Oe(),
										className: "rounded-full border border-amber-300 bg-amber-50 px-4 py-2 text-xs font-medium text-amber-800 transition hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-50",
										children: d?.rawSourceRetention.status === "deleted" ? "Raw Deleted" : B ? "Deleting" : "Mark Raw Deleted"
									})
								]
							})]
						}) : Se ? /* @__PURE__ */ v("div", {
							className: "flex flex-col gap-3 lg:flex-row lg:items-center lg:justify-between",
							children: [/* @__PURE__ */ v("div", {
								className: "flex items-center gap-4",
								children: [/* @__PURE__ */ _(ok, {
									score: c?.statistics.avgScore ?? null,
									size: 52,
									stroke: 5
								}), /* @__PURE__ */ v("div", { children: [
									/* @__PURE__ */ _("h2", {
										className: "text-xl font-semibold text-slate-900",
										children: Se.datasetName
									}),
									/* @__PURE__ */ v("p", {
										className: "text-xs text-slate-500 mt-0.5",
										children: [c ? `${c.qualityCheckRunCount} check runs · ` : "", Se.fileName]
									}),
									c?.sourceAsset?.tableName ? /* @__PURE__ */ v("p", {
										className: "mt-1 text-xs text-emerald-700",
										children: ["Inspecting lineage for table ", /* @__PURE__ */ _("span", {
											className: "font-semibold",
											children: c.sourceAsset.tableName
										})]
									}) : null
								] })]
							}), /* @__PURE__ */ v("div", {
								className: "flex items-center gap-2",
								children: [/* @__PURE__ */ _(Sx, {
									ariaLabel: "Report detail sections",
									value: E,
									onChange: (e) => D(e),
									items: [
										{
											value: "dimensions",
											label: "Dimensions"
										},
										{
											value: "statistics",
											label: "Statistics"
										},
										{
											value: "lineage",
											label: "Lineage"
										},
										{
											value: "raw",
											label: "Raw Report"
										}
									]
								}), /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => void Te(Se),
									className: "rounded-full bg-slate-900 px-4 py-2 text-xs font-medium text-white transition hover:bg-slate-800",
									children: ["Download ", Se.format.toUpperCase()]
								})]
							})]
						}) : /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
							className: "text-xs uppercase tracking-[0.25em] text-[#7d5f2f]/65",
							children: "Selected Report"
						}), /* @__PURE__ */ _("h2", {
							className: "mt-2 text-xl font-semibold text-slate-900",
							children: "Choose a report to inspect"
						})] })
					}), /* @__PURE__ */ _("div", {
						className: "min-h-0 flex-1 overflow-auto p-5",
						children: n === "readiness" ? /* @__PURE__ */ _("div", {
							className: "space-y-4",
							"data-testid": "report-readiness-workspace",
							children: H ? /* @__PURE__ */ _("div", {
								className: "flex items-center justify-center py-16 text-sm text-slate-500",
								children: "Loading report readiness…"
							}) : b ? /* @__PURE__ */ v(g, { children: [
								he ? /* @__PURE__ */ _("div", {
									className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
									children: he
								}) : null,
								/* @__PURE__ */ v("div", {
									className: "grid grid-cols-2 gap-3 xl:grid-cols-4",
									children: [
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Status"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold capitalize text-slate-900",
												children: b.status.replace(/_/g, " ")
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Failed Checks"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: Fe
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Warnings"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: Ie
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Attestation"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: b.attestations.length ? "Complete" : "Pending"
											})]
										})
									]
								}),
								/* @__PURE__ */ v("div", {
									className: "rounded-[1.2rem] border border-cyan-200 bg-cyan-50 px-4 py-3 text-sm text-cyan-950",
									children: [/* @__PURE__ */ _("p", {
										className: "font-semibold",
										children: "Claim boundary"
									}), /* @__PURE__ */ _("p", {
										className: "mt-1 leading-6",
										children: b.manifest.claimBoundary
									})]
								}),
								/* @__PURE__ */ v("div", {
									className: "grid gap-4 xl:grid-cols-[minmax(0,1.35fr)_minmax(300px,0.8fr)]",
									children: [/* @__PURE__ */ v("div", {
										className: "overflow-hidden rounded-[1.3rem] border border-slate-200 bg-white",
										children: [/* @__PURE__ */ v("div", {
											className: "grid grid-cols-[0.7fr_1fr_1.4fr] gap-3 border-b border-slate-100 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400",
											children: [
												/* @__PURE__ */ _("span", { children: "Status" }),
												/* @__PURE__ */ _("span", { children: "Check" }),
												/* @__PURE__ */ _("span", { children: "Evidence" })
											]
										}), b.checkResults.length === 0 ? /* @__PURE__ */ _("div", {
											className: "px-4 py-8 text-center text-sm text-slate-500",
											children: "No readiness checks returned yet."
										}) : b.checkResults.map((e) => /* @__PURE__ */ v("div", {
											className: "grid grid-cols-[0.7fr_1fr_1.4fr] gap-3 border-b border-slate-100 px-4 py-3 text-sm last:border-b-0",
											children: [
												/* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(_x, {
													tone: kk(e.status),
													size: "xs",
													children: e.status.replace(/_/g, " ")
												}) }),
												/* @__PURE__ */ v("div", {
													className: "min-w-0",
													children: [/* @__PURE__ */ _("p", {
														className: "font-semibold text-slate-900",
														children: e.label
													}), /* @__PURE__ */ _("p", {
														className: "mt-1 truncate text-xs text-slate-500",
														children: e.checkId
													})]
												}),
												/* @__PURE__ */ v("div", {
													className: "min-w-0 text-xs leading-5 text-slate-600",
													children: [/* @__PURE__ */ _("p", { children: e.evidence }), e.observedAt ? /* @__PURE__ */ v("p", {
														className: "mt-1 text-slate-400",
														children: ["Observed ", ck(e.observedAt)]
													}) : null]
												})
											]
										}, e.checkId))]
									}), /* @__PURE__ */ v("div", {
										className: "space-y-4",
										children: [
											/* @__PURE__ */ v("div", {
												className: "rounded-[1.3rem] border border-slate-200 bg-white px-4 py-3",
												children: [
													/* @__PURE__ */ _("p", {
														className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
														children: "Report Batch"
													}),
													/* @__PURE__ */ _("h3", {
														className: "mt-2 text-base font-semibold text-slate-900",
														children: b.manifest.reportName
													}),
													/* @__PURE__ */ _("p", {
														className: "mt-1 text-xs text-slate-500",
														children: b.manifest.expectedArtifact.fileName
													}),
													/* @__PURE__ */ v("div", {
														className: "mt-3 space-y-2 text-xs text-slate-600",
														children: [
															/* @__PURE__ */ v("p", { children: ["Owner: ", /* @__PURE__ */ _("span", {
																className: "font-semibold text-slate-800",
																children: b.manifest.owner.name
															})] }),
															/* @__PURE__ */ v("p", { children: ["Due: ", ck(b.manifest.dueWindow.endsAt)] }),
															/* @__PURE__ */ v("p", { children: [
																"Freshness SLA: ",
																b.manifest.thresholds.freshnessSlaHours,
																"h"
															] })
														]
													})
												]
											}),
											/* @__PURE__ */ v("div", {
												className: "rounded-[1.3rem] border border-slate-200 bg-white px-4 py-3",
												children: [/* @__PURE__ */ _("p", {
													className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
													children: "Attestation"
												}), b.attestations.length ? /* @__PURE__ */ _("div", {
													className: "mt-2 text-xs leading-5 text-slate-600",
													children: b.attestations.map((e) => /* @__PURE__ */ v("p", { children: [
														e.actorName,
														" signed on ",
														ck(e.createdAt),
														"."
													] }, e.eventId))
												}) : /* @__PURE__ */ v("div", {
													className: "mt-3 grid gap-2",
													children: [
														/* @__PURE__ */ v("label", {
															className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
															children: ["Attestor", /* @__PURE__ */ _("input", {
																"data-testid": "report-readiness-attestor-name",
																value: se,
																onChange: (e) => ce(e.target.value),
																className: "mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm normal-case tracking-normal text-slate-900"
															})]
														}),
														/* @__PURE__ */ v("label", {
															className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
															children: ["Email", /* @__PURE__ */ _("input", {
																value: le,
																onChange: (e) => ue(e.target.value),
																className: "mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm normal-case tracking-normal text-slate-900"
															})]
														}),
														b.status === "ready" ? null : /* @__PURE__ */ _("p", {
															className: "text-xs text-amber-700",
															children: "Signoff unlocks only when failed checks are resolved."
														})
													]
												})]
											}),
											/* @__PURE__ */ v("div", {
												className: "rounded-[1.3rem] border border-slate-200 bg-white px-4 py-3",
												children: [/* @__PURE__ */ _("p", {
													className: "text-sm font-semibold text-slate-900",
													children: "Declared Sources"
												}), /* @__PURE__ */ _("div", {
													className: "mt-3 space-y-2",
													children: b.manifest.sources.map((e) => /* @__PURE__ */ v("div", {
														className: "rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs",
														children: [/* @__PURE__ */ v("div", {
															className: "flex items-center justify-between gap-2",
															children: [/* @__PURE__ */ _("span", {
																className: "font-semibold text-slate-800",
																children: e.label
															}), /* @__PURE__ */ _("span", {
																className: "text-slate-500",
																children: e.type.replace(/_/g, " ")
															})]
														}), e.observedAt ? /* @__PURE__ */ v("p", {
															className: "mt-1 text-slate-500",
															children: ["Observed ", ck(e.observedAt)]
														}) : null]
													}, `${e.type}-${e.id}`))
												})]
											})
										]
									})]
								}),
								/* @__PURE__ */ v("div", {
									className: "rounded-[1.3rem] border border-slate-200 bg-[linear-gradient(180deg,#fffdfa_0%,#f8ffff_100%)] px-4 py-3",
									children: [/* @__PURE__ */ v("div", {
										className: "flex items-center justify-between gap-3",
										children: [/* @__PURE__ */ _("p", {
											className: "text-sm font-semibold text-slate-900",
											children: "Ledger Export"
										}), /* @__PURE__ */ _("span", {
											className: "text-xs text-slate-500",
											children: S?.fileName ?? b.runId
										})]
									}), S?.markdown ? /* @__PURE__ */ _("pre", {
										className: "mt-3 max-h-64 overflow-auto whitespace-pre-wrap break-words rounded-lg bg-slate-950 px-4 py-3 font-mono text-[12px] leading-5 text-slate-100",
										children: S.markdown
									}) : /* @__PURE__ */ _("p", {
										className: "mt-3 text-sm text-slate-500",
										children: "Export the ledger to preview the buyer-facing evidence packet."
									})]
								})
							] }) : he ? /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
								children: he
							}) : /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-center text-sm text-slate-500",
								children: "No readiness run is loaded."
							})
						}) : n === "boardPacket" ? /* @__PURE__ */ _("div", {
							className: "space-y-4",
							"data-testid": "board-packet-workspace",
							children: P ? /* @__PURE__ */ _("div", {
								className: "flex items-center justify-center py-16 text-sm text-slate-500",
								children: "Loading board packet…"
							}) : d ? /* @__PURE__ */ v(g, { children: [
								pe ? /* @__PURE__ */ _("div", {
									className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
									children: pe
								}) : null,
								/* @__PURE__ */ v("div", {
									className: "grid grid-cols-2 gap-3 xl:grid-cols-4",
									children: [
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Readiness"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold capitalize text-slate-900",
												children: d.status.replace(/_/g, " ")
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Material Variance"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: Ne
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Source Actions"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: Pe
											})]
										}),
										/* @__PURE__ */ v("div", {
											className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Signoff"
											}), /* @__PURE__ */ _("p", {
												className: "mt-2 text-lg font-semibold text-slate-900",
												children: d.review.signedOff ? "Complete" : "Pending"
											})]
										})
									]
								}),
								/* @__PURE__ */ _("div", {
									className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
									children: /* @__PURE__ */ v("div", {
										className: "flex flex-col gap-3 lg:flex-row lg:items-start lg:justify-between",
										children: [/* @__PURE__ */ v("div", { children: [
											/* @__PURE__ */ _("p", {
												className: "text-[10px] font-semibold uppercase tracking-[0.22em] text-slate-400",
												children: "Review Signoff"
											}),
											/* @__PURE__ */ _("h3", {
												className: "mt-2 text-base font-semibold text-slate-900",
												children: d.review.signedOff ? "Packet approved for export" : "Explicit finance review required"
											}),
											/* @__PURE__ */ _("p", {
												className: "mt-1 max-w-2xl text-xs leading-5 text-slate-600",
												children: d.review.disclaimer
											}),
											d.review.signedOffBy ? /* @__PURE__ */ v("p", {
												className: "mt-2 text-xs text-slate-600",
												children: [
													"Signed by ",
													/* @__PURE__ */ _("span", {
														className: "font-semibold",
														children: d.review.signedOffBy.name
													}),
													d.review.signedOffAt ? ` on ${ck(d.review.signedOffAt)}` : ""
												]
											}) : null
										] }), d.review.signedOff ? null : /* @__PURE__ */ v("div", {
											className: "grid min-w-[280px] gap-2 sm:grid-cols-2 lg:grid-cols-1",
											children: [/* @__PURE__ */ v("label", {
												className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
												children: ["Reviewer", /* @__PURE__ */ _("input", {
													"data-testid": "board-packet-reviewer-name",
													value: re,
													onChange: (e) => ie(e.target.value),
													className: "mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm normal-case tracking-normal text-slate-900"
												})]
											}), /* @__PURE__ */ v("label", {
												className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
												children: ["Email", /* @__PURE__ */ _("input", {
													value: ae,
													onChange: (e) => oe(e.target.value),
													className: "mt-1 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm normal-case tracking-normal text-slate-900"
												})]
											})]
										})]
									})
								}),
								/* @__PURE__ */ v("div", {
									className: "grid gap-4 xl:grid-cols-[minmax(0,1.45fr)_minmax(280px,0.75fr)]",
									children: [/* @__PURE__ */ v("div", {
										className: "overflow-hidden rounded-[1.3rem] border border-slate-200 bg-white",
										children: [/* @__PURE__ */ v("div", {
											className: "grid grid-cols-[1.1fr_0.6fr_0.55fr_1fr] gap-3 border-b border-slate-100 px-4 py-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400",
											children: [
												/* @__PURE__ */ _("span", { children: "Metric" }),
												/* @__PURE__ */ _("span", { children: "Value" }),
												/* @__PURE__ */ _("span", { children: "Variance" }),
												/* @__PURE__ */ _("span", { children: "Lineage" })
											]
										}), d.metrics.map((e) => /* @__PURE__ */ v("div", {
											className: "grid grid-cols-[1.1fr_0.6fr_0.55fr_1fr] gap-3 border-b border-slate-100 px-4 py-3 text-sm last:border-b-0",
											children: [
												/* @__PURE__ */ v("div", {
													className: "min-w-0",
													children: [/* @__PURE__ */ _("p", {
														className: "font-semibold text-slate-900",
														children: e.label
													}), /* @__PURE__ */ _("p", {
														className: "mt-1 truncate text-xs text-slate-500",
														children: e.definition.formula
													})]
												}),
												/* @__PURE__ */ _("p", {
													className: "font-semibold text-slate-900",
													children: Tk(e)
												}),
												/* @__PURE__ */ _("div", { children: /* @__PURE__ */ _(_x, {
													tone: e.varianceFlag === "material" ? "warning" : "neutral",
													size: "xs",
													children: Ek(e)
												}) }),
												/* @__PURE__ */ _("div", {
													className: "min-w-0 text-xs text-slate-600",
													children: e.lineage.map((t) => /* @__PURE__ */ v("p", {
														className: "truncate",
														children: [
															t.sourceId,
															" · ",
															t.fields.join(", ")
														]
													}, `${e.metricId}-${t.sourceId}-${t.periodKey}`))
												})
											]
										}, e.metricId))]
									}), /* @__PURE__ */ v("div", {
										className: "space-y-4",
										children: [/* @__PURE__ */ v("div", {
											className: "rounded-[1.3rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ v("div", {
												className: "flex items-center justify-between gap-3",
												children: [/* @__PURE__ */ _("p", {
													className: "text-sm font-semibold text-slate-900",
													children: "Source Retention"
												}), /* @__PURE__ */ _(_x, {
													tone: d.rawSourceRetention.status === "not_due" || d.rawSourceRetention.status === "pending_acceptance" ? "info" : d.rawSourceRetention.status === "deleted" ? "success" : "warning",
													size: "xs",
													children: d.rawSourceRetention.status.replace(/_/g, " ")
												})]
											}), /* @__PURE__ */ _("div", {
												className: "mt-3 space-y-2",
												children: d.rawSourceRetention.sources.map((e) => /* @__PURE__ */ v("div", {
													className: "rounded-lg border border-slate-100 bg-slate-50 px-3 py-2 text-xs",
													children: [/* @__PURE__ */ v("div", {
														className: "flex items-center justify-between gap-2",
														children: [/* @__PURE__ */ _("span", {
															className: "font-semibold text-slate-800",
															children: e.sourceId
														}), /* @__PURE__ */ _("span", {
															className: e.deletionDue ? "text-amber-700" : "text-slate-500",
															children: e.deletionDue ? "Due" : "Retained"
														})]
													}), /* @__PURE__ */ v("p", {
														className: "mt-1 text-slate-500",
														children: ["Until ", ck(e.retainUntil)]
													})]
												}, e.sourceId))
											})]
										}), /* @__PURE__ */ v("div", {
											className: "rounded-[1.3rem] border border-slate-200 bg-white px-4 py-3",
											children: [/* @__PURE__ */ _("p", {
												className: "text-sm font-semibold text-slate-900",
												children: "Likely Board Questions"
											}), /* @__PURE__ */ _("ul", {
												className: "mt-3 space-y-2 text-xs leading-5 text-slate-600",
												children: d.likelyBoardQuestions.slice(0, 5).map((e) => /* @__PURE__ */ _("li", { children: e }, e))
											})]
										})]
									})]
								}),
								/* @__PURE__ */ v("div", {
									className: "rounded-[1.3rem] border border-slate-200 bg-[linear-gradient(180deg,#fffdfa_0%,#f8ffff_100%)] px-4 py-3",
									children: [/* @__PURE__ */ v("div", {
										className: "flex items-center justify-between gap-3",
										children: [/* @__PURE__ */ _("p", {
											className: "text-sm font-semibold text-slate-900",
											children: "Export Preview"
										}), /* @__PURE__ */ _("span", {
											className: "text-xs text-slate-500",
											children: m?.fileName ?? d.packetId
										})]
									}), m?.markdown ? /* @__PURE__ */ _("pre", {
										className: "mt-3 max-h-64 overflow-auto whitespace-pre-wrap break-words rounded-lg bg-slate-950 px-4 py-3 font-mono text-[12px] leading-5 text-slate-100",
										children: m.markdown
									}) : /* @__PURE__ */ _("p", {
										className: "mt-3 text-sm text-slate-500",
										children: "Export preview has not been generated yet."
									})]
								})
							] }) : pe ? /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-900",
								children: pe
							}) : /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-center text-sm text-slate-500",
								children: "No board packet is loaded."
							})
						}) : Se ? M ? /* @__PURE__ */ _("div", {
							className: "flex items-center justify-center py-16 text-sm text-slate-500",
							children: "Loading details…"
						}) : E === "dimensions" ? /* @__PURE__ */ _("div", {
							className: "space-y-3",
							children: c?.dimensions && c.dimensions.length > 0 ? /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
								className: "mb-4 grid grid-cols-2 gap-2 md:grid-cols-3 xl:grid-cols-6",
								children: c.dimensions.map((e) => /* @__PURE__ */ v("div", {
									className: "rounded-xl border border-slate-200 bg-white px-3 py-2 text-center",
									children: [
										/* @__PURE__ */ _("span", {
											className: "text-base",
											children: dk(e.dimension)
										}),
										/* @__PURE__ */ _("p", {
											className: "text-[10px] text-slate-500 mt-1 truncate",
											children: e.dimension
										}),
										/* @__PURE__ */ v("p", {
											className: "text-lg font-bold text-slate-900 mt-0.5",
											children: [
												e.passed,
												"/",
												e.totalChecks
											]
										}),
										/* @__PURE__ */ _("p", {
											className: "text-[10px] text-slate-400",
											children: e.coverageStatus ? `${e.coverageStatus} coverage` : "passed"
										})
									]
								}, e.dimension))
							}), c.dimensions.map((e) => /* @__PURE__ */ _(fk, {
								dim: e,
								expanded: O.has(e.dimension),
								onToggle: () => Me(e.dimension)
							}, e.dimension))] }) : /* @__PURE__ */ _("div", {
								className: "rounded-[1.5rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-sm text-slate-500",
								children: "No quality check dimension data found for this report. Run quality checks on the dataset first."
							})
						}) : E === "statistics" ? c?.statistics ? /* @__PURE__ */ _(bk, { stats: c.statistics }) : /* @__PURE__ */ _("div", {
							className: "rounded-[1.5rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-sm text-slate-500",
							children: "No statistical data available yet."
						}) : E === "lineage" ? Ce && Ce.nodes.length > 0 ? /* @__PURE__ */ v("div", {
							className: "space-y-4",
							children: [/* @__PURE__ */ v("div", {
								className: "rounded-[1.5rem] border border-emerald-100 bg-emerald-50/55 px-5 py-4 text-sm text-emerald-900",
								children: [/* @__PURE__ */ _("p", {
									className: "font-semibold",
									children: "Table lineage"
								}), /* @__PURE__ */ _("p", {
									className: "mt-1 text-emerald-800/80",
									children: "This report follows the inspected source asset through connected tables, columns, checks, issues, and generated reports."
								})]
							}), /* @__PURE__ */ _(NT, {
								badgeLabel: "Reports",
								title: "Inspected Table Lineage",
								description: "Asset-centric lineage for the table inspected by this report.",
								searchPlaceholder: "claims, patients.email, data_quality...",
								graph: Ce,
								typeOrder: xk.filter((e) => Ce.nodes.some((t) => t.type === e)),
								typeMeta: Sk,
								edgeMeta: Object.fromEntries(Object.entries(Ck).filter(([e]) => Ce.edges.some((t) => t.type === e))),
								defaultViewMode: "full",
								compactNodeLimit: 90,
								compactEdgeLimit: 140,
								containerClassName: "border-emerald-100/70 bg-[radial-gradient(circle_at_top,#f7fffb_0%,#effaf6_42%,#e4f4ee_100%)]",
								testIdPrefix: "reports-lineage",
								glossary: [{
									title: "Source Asset",
									description: c?.sourceAsset?.tableName ? `This report is linked to table ${c.sourceAsset.tableName}, and the graph expands from that asset identity.` : "This report is linked to a dataset-level source asset."
								}]
							})]
						}) : /* @__PURE__ */ _("div", {
							className: "rounded-[1.5rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-sm text-slate-500",
							children: "No lineage data is available for this report yet."
						}) : /* @__PURE__ */ _("div", {
							className: "rounded-[1.5rem] border border-slate-200 bg-[linear-gradient(180deg,#fffdfa_0%,#fbffff_100%)] p-5 shadow-inner",
							children: c?.content ? /* @__PURE__ */ _("pre", {
								className: "whitespace-pre-wrap break-words font-mono text-[13px] leading-6 text-slate-800",
								children: c.content
							}) : Se.format === "pdf" ? /* @__PURE__ */ v("div", {
								className: "text-sm text-slate-600",
								children: [/* @__PURE__ */ _("p", {
									className: "font-medium text-slate-900",
									children: "PDF preview stays download-first for now."
								}), /* @__PURE__ */ _("p", {
									className: "mt-2",
									children: "Use the download button to open the polished PDF locally, or switch to Dimensions for the detailed breakdown."
								})]
							}) : /* @__PURE__ */ _("div", {
								className: "text-sm text-slate-500",
								children: "Loading raw content…"
							})
						}) : /* @__PURE__ */ v("div", {
							className: "rounded-[1.5rem] border border-dashed border-slate-200 bg-slate-50 px-6 py-10 text-center text-sm text-slate-500",
							children: [/* @__PURE__ */ _("p", { children: "Select a report from the library to inspect quality check results." }), /* @__PURE__ */ v("button", {
								type: "button",
								onClick: () => ve(!0),
								className: "mt-4 inline-flex items-center gap-2 rounded-full bg-slate-900 px-5 py-2.5 text-sm font-medium text-white transition hover:bg-slate-800",
								children: [/* @__PURE__ */ _("svg", {
									className: "h-4 w-4",
									fill: "none",
									viewBox: "0 0 24 24",
									stroke: "currentColor",
									children: /* @__PURE__ */ _("path", {
										strokeLinecap: "round",
										strokeLinejoin: "round",
										strokeWidth: 2,
										d: "M12 4v16m8-8H4"
									})
								}), "New Inspection"]
							})]
						})
					})]
				})]
			}),
			_e && /* @__PURE__ */ _(_k, {
				onClose: () => ve(!1),
				onSuccess: G
			})
		]
	});
}
//#endregion
//#region src/services/sourceRegistry.ts
function jk(e) {
	return e?.data?.data ?? e?.data ?? [];
}
function Mk(e) {
	return e?.data?.data ?? e?.data ?? null;
}
async function Nk() {
	let e = jk((await Z.get("/v1/databases?limit=1000&offset=0")).data), t = e.filter((e) => (e.datasource_type ?? "internal") === "internal").map((e) => ({
		type: "internal",
		id: e.database_id,
		label: e.original_file_name || `Database ${e.database_id}`
	})), n = e.filter((e) => (e.datasource_type ?? "internal") === "postgres").map((e) => ({
		type: "external_pg",
		id: e.source_database_key || `pg-${e.database_id}`,
		label: e.original_file_name || e.source_database_key || `Postgres ${e.database_id}`,
		connectionId: e.source_database_key || `database-${e.database_id}`,
		databaseId: e.database_id
	})), r = null;
	try {
		Mk((await Z.get("/v1/users/me", { suppressErrorStatuses: [401] })).data)?.status?.toLowerCase() === "admin" && (r = {
			type: "metadata",
			label: "Metadata Sources",
			sources: [{
				type: "metadata",
				id: "system",
				label: "Metadata DB"
			}]
		});
	} catch (e) {
		if (e?.response?.status !== 401) throw e;
	}
	return [
		{
			type: "internal",
			label: "Internal Databases",
			sources: t
		},
		...r ? [r] : [],
		{
			type: "external_pg",
			label: "External PostgreSQL",
			sources: n,
			disabled: n.length === 0
		},
		{
			type: "json",
			label: "JSON Sources",
			sources: [],
			disabled: !0
		}
	];
}
//#endregion
//#region src/services/metadataSourceService.ts
function Pk(e) {
	let t = Z.standardizeResponse(e), n = (t.data?.tables ?? []).map((e) => typeof e == "string" ? e : e?.name).filter((e) => typeof e == "string" && e.length > 0);
	return {
		...t,
		data: {
			tables: n,
			total: t.data?.total ?? n.length
		}
	};
}
function Fk(e) {
	return e && typeof e == "object" && !Array.isArray(e) && ("min" in e || "max" in e);
}
function Ik(e, t) {
	return e == null && t == null ? 0 : e == null ? -1 : t == null ? 1 : typeof e == "number" && typeof t == "number" ? e - t : String(e).localeCompare(String(t), void 0, {
		numeric: !0,
		sensitivity: "base"
	});
}
function Lk(e, t) {
	return !t || Object.keys(t).length === 0 ? e : e.filter((e) => Object.entries(t).every(([t, n]) => {
		let r = e[t];
		if (Array.isArray(n)) return n.length === 0 ? !0 : n.map(String).includes(String(r));
		if (Fk(n)) {
			let e = typeof r == "number" ? r : Number(r);
			if (!Number.isFinite(e)) return !1;
			let t = n.min == null || n.min === "" ? -Infinity : Number(n.min), i = n.max == null || n.max === "" ? Infinity : Number(n.max);
			return e >= t && e <= i;
		}
		return n == null || n === "" ? !0 : String(r ?? "").toLowerCase().includes(String(n).toLowerCase());
	}));
}
function Rk(e, t) {
	let n = t?.sortOptions?.length ? t.sortOptions : t?.sortBy ? [{
		column: t.sortBy,
		direction: (t.order ?? "asc").toUpperCase()
	}] : [];
	return n.length === 0 ? e : [...e].sort((e, t) => {
		for (let r of n) {
			let n = r.direction.toUpperCase() === "DESC" ? -1 : 1, i = Ik(e[r.column], t[r.column]);
			if (i !== 0) return i * n;
		}
		return 0;
	});
}
function zk(e, t, n) {
	let r = typeof n == "number" && n >= 0 ? n : 0, i = typeof t == "number" && t > 0 ? t : e.length;
	return e.slice(r, r + i);
}
function Bk(e, t) {
	let n = Array.from(e.reduce((e, t) => (Object.keys(t).forEach((t) => e.add(t)), e), /* @__PURE__ */ new Set()));
	return n.length > 0 ? n : t ?? [];
}
function Vk(e, t, n) {
	let r = t.map((t) => {
		let n = e.filter((e) => e[t] == null || e[t] === "").length;
		return {
			name: t,
			missingCount: n,
			totalCount: e.length,
			missingPercentage: e.length === 0 ? 0 : n / e.length * 100
		};
	});
	return {
		status: "success",
		columns: r,
		data: { columns: r },
		metadata: {
			totalRows: e.length,
			sampledRows: e.length,
			samplePercentage: 100,
			tableName: n
		}
	};
}
async function Hk(e, t) {
	let n = await Z.get(X.endpoints.metadataSource.tableData(e), {
		params: {
			limit: 1e3,
			offset: 0
		},
		signal: t
	}), r = Z.standardizeResponse(n.data);
	return {
		rows: r.data?.rows ?? [],
		columns: r.data?.columns ?? [],
		total: r.data?.total ?? 0,
		metadata: r.data?.metadata
	};
}
function Uk() {
	return /* @__PURE__ */ Error("Metadata source is read-only");
}
var Wk = {
	async fetchTables(e) {
		return Pk((await Z.get(X.endpoints.metadataSource.tables)).data);
	},
	async fetchTableData(e, t, n) {
		let r = await Hk(t, n?.signal), i = Lk(r.rows, n?.filters ?? void 0), a = Rk(i, n);
		return {
			status: "success",
			data: {
				rows: zk(a, n?.limit, n?.offset),
				columns: Bk(a, r.columns),
				total: i.length,
				metadata: {
					totalRows: i.length,
					source: "metadata",
					tableName: t
				}
			}
		};
	},
	async fetchTableColumns(e, t) {
		return (await this.fetchTableData(e, t, {
			limit: 1,
			offset: 0
		})).data?.columns ?? [];
	},
	async fetchUniqueColumnValues(e, t, n, r, i = 100) {
		let { rows: a } = await Hk(t), o = r?.trim().toLowerCase() ?? "";
		return Array.from(new Set(a.map((e) => e[n]).filter((e) => e != null).map((e) => String(e)).filter((e) => o === "" || e.toLowerCase().includes(o)))).slice(0, i);
	},
	async fetchRecord(e, t, n) {
		let { rows: r } = await Hk(t);
		return r.find((e) => String(e.id ?? e.database_id ?? e.rowid) === String(n)) ?? null;
	},
	async updateRecord() {
		throw Uk();
	},
	async createRecord() {
		throw Uk();
	},
	async deleteRecord() {
		throw Uk();
	},
	async bulkDeleteRecords() {
		throw Uk();
	},
	async fetchColumnStats(e, t, n) {
		let { rows: r } = await Hk(t), i = r.map((e) => e[n]).filter((e) => e != null), a = i.map(Number).filter((e) => Number.isFinite(e));
		return {
			columnName: n,
			totalCount: r.length,
			nonNullCount: i.length,
			nullCount: r.length - i.length,
			uniqueCount: new Set(i.map(String)).size,
			min: a.length > 0 ? Math.min(...a) : null,
			max: a.length > 0 ? Math.max(...a) : null
		};
	},
	async fetchMissingData(e, t) {
		let { rows: n, columns: r } = await Hk(t);
		return Vk(n, Bk(n, r), t);
	},
	async fetchDatabaseInfo() {
		return {
			status: "success",
			data: {
				original_file_name: "Metadata DB",
				database_id: "system"
			}
		};
	},
	async fetchSamplingMethods() {
		return ["head"];
	},
	async applySampling(e, t, n) {
		let { rows: r } = await Hk(t), i = n.samplePercentage ?? 100, a = n.maxRows ?? Math.max(1, Math.floor(r.length * i / 100)), o = r.slice(0, a);
		return {
			rows: o,
			metadata: {
				totalRows: r.length,
				sampledRows: o.length,
				samplingPercentage: r.length === 0 ? 0 : o.length / r.length * 100,
				executionTimeMs: 0,
				method: "head",
				parameters: n
			}
		};
	},
	async fetchColumnTypes(e, t) {
		let { rows: n, columns: r } = await Hk(t), i = Bk(n, r);
		return Object.fromEntries(i.map((e) => {
			let t = n.find((t) => t[e] != null)?.[e];
			return typeof t == "number" ? [e, "numerical"] : t instanceof Date || typeof t == "string" && !Number.isNaN(Date.parse(t)) ? [e, "date"] : [e, "categorical"];
		}));
	},
	async fetchTableRowCount(e, t, n) {
		let { rows: r } = await Hk(t);
		return Lk(r, n ?? void 0).length;
	}
};
//#endregion
//#region src/services/externalPgProvider.ts
function Gk(e) {
	return /* @__PURE__ */ Error(`External PostgreSQL source is read-only for ${e}`);
}
function Kk(e) {
	let t = Z.standardizeResponse(e), n = (t.data?.tables ?? []).map((e) => typeof e == "string" ? e : e?.name).filter((e) => typeof e == "string" && e.length > 0);
	return {
		...t,
		data: {
			tables: n,
			total: t.data?.total ?? n.length
		}
	};
}
function qk(e) {
	let t = Z.standardizeResponse(e);
	return {
		...t,
		data: {
			rows: t.data?.rows ?? [],
			columns: t.data?.columns ?? [],
			total: t.data?.total ?? 0,
			metadata: t.data?.metadata ?? {}
		}
	};
}
var Jk = {
	async fetchTables(e) {
		return Kk((await Z.get(X.endpoints.externalPostgres.tables(String(e)))).data);
	},
	async fetchTableData(e, t, n) {
		let r = { ...n }, i = r.signal;
		return delete r.signal, r.pageSize && !r.limit && (r.limit = r.pageSize, delete r.pageSize), r.page && !r.offset && (r.offset = (r.page - 1) * (r.limit || 20), delete r.page), r.sortOptions?.length && !r.sortBy && (r.sortBy = r.sortOptions[0]?.column, r.order = r.sortOptions[0]?.direction?.toLowerCase() === "desc" ? "desc" : "asc"), delete r.sortOptions, r.filters && typeof r.filters == "object" && (r.filters = JSON.stringify(r.filters)), qk((await Z.get(X.endpoints.externalPostgres.tableData(String(e), t), {
			params: r,
			signal: i
		})).data);
	},
	async fetchTableColumns(e, t) {
		let n = await Z.get(X.endpoints.externalPostgres.schema(String(e), t));
		return (Z.standardizeResponse(n.data).data?.columns ?? []).map((e) => e?.name).filter((e) => typeof e == "string" && e.length > 0);
	},
	async fetchUniqueColumnValues(e, t, n, r, i = 100) {
		let a = await this.fetchTableData(e, t, {
			limit: Math.min(Math.max(i, 50), 500),
			offset: 0,
			filters: r ? { [n]: r } : void 0
		});
		return Array.from(new Set((a.data?.rows ?? []).map((e) => e[n]).filter((e) => e != null).map((e) => String(e)))).slice(0, i);
	},
	async fetchRecord() {
		throw Gk("fetchRecord");
	},
	async updateRecord() {
		throw Gk("updateRecord");
	},
	async createRecord() {
		throw Gk("createRecord");
	},
	async deleteRecord() {
		throw Gk("deleteRecord");
	},
	async bulkDeleteRecords() {
		throw Gk("bulkDeleteRecords");
	},
	async fetchColumnStats() {
		throw Gk("fetchColumnStats");
	},
	async fetchMissingData() {
		throw Gk("fetchMissingData");
	},
	async fetchDatabaseInfo(e) {
		let t = await Z.get(X.endpoints.externalPostgres.info(String(e)));
		return Z.standardizeResponse(t.data).data ?? {};
	},
	async fetchSamplingMethods() {
		return [];
	},
	async applySampling() {
		throw Gk("applySampling");
	},
	async fetchColumnTypes(e, t) {
		let n = await Z.get(X.endpoints.externalPostgres.schema(String(e), t)), r = Z.standardizeResponse(n.data).data?.columns ?? [];
		return Object.fromEntries(r.map((e) => {
			let t = (e.dataType ?? "").toLowerCase();
			return /(int|numeric|decimal|double|real|float)/.test(t) ? [e.name, "numerical"] : /(date|time)/.test(t) ? [e.name, "date"] : [e.name, "categorical"];
		}));
	},
	async fetchTableRowCount(e, t, n) {
		let r = await Z.get(X.endpoints.externalPostgres.count(String(e), t), { params: n ? { filters: JSON.stringify(n) } : void 0 });
		return Z.standardizeResponse(r.data).data?.total ?? 0;
	}
}, Yk = class extends Error {
	sourceType;
	operation;
	constructor(e, t) {
		super(`Source type '${e}' does not support '${t}'.`), this.name = "UnsupportedSourceError", this.sourceType = e, this.operation = t;
	}
};
//#endregion
//#region src/services/jsonSourceProvider.ts
function Xk(e) {
	throw new Yk("json", e);
}
function Zk(e) {
	return e == null || e === "";
}
function Qk(e) {
	if (typeof e == "string") return e;
	if (e && typeof e == "object") try {
		return JSON.stringify(e);
	} catch {
		return String(e);
	}
	return String(e);
}
function $k(e) {
	return e && typeof e == "object" && !Array.isArray(e) ? { ...e } : { value: e };
}
function eA(e) {
	if (!Array.isArray(e)) return null;
	let t = e.map((e) => $k(e)), n = Array.from(t.reduce((e, t) => (Object.keys(t).forEach((t) => e.add(t)), e), /* @__PURE__ */ new Set()));
	return {
		rows: t.map((e, t) => Object.prototype.hasOwnProperty.call(e, "rowid") ? e : {
			rowid: t + 1,
			...e
		}),
		columns: n
	};
}
function tA(e) {
	let t = Object.keys(e);
	return {
		rows: [{
			rowid: 1,
			...e
		}],
		columns: t
	};
}
function nA(e, t, n) {
	let r = eA(n);
	return r ? (e[t] = r, !0) : !1;
}
function rA(e) {
	let t = {};
	if (nA(t, "data", e)) return { tables: t };
	if (!e || typeof e != "object" || Array.isArray(e)) return { tables: { data: eA([e]) ?? {
		rows: [{
			rowid: 1,
			value: e
		}],
		columns: ["value"]
	} } };
	let n = e, r = n.tables;
	return r && typeof r == "object" && !Array.isArray(r) && Object.entries(r).forEach(([e, n]) => {
		nA(t, e, n);
	}), Object.keys(t).length === 0 && nA(t, "data", n.data), Object.keys(t).length === 0 && nA(t, "data", n.rows), Object.keys(t).length === 0 && Object.entries(n).forEach(([e, n]) => {
		nA(t, e, n);
	}), Object.keys(t).length === 0 && (t.data = tA(n)), { tables: t };
}
function iA(e, t) {
	let n = e.tables[t];
	if (n) return n;
	let [r] = Object.values(e.tables);
	if (r && Object.keys(e.tables).length === 1) return r;
	throw Error(`JSON table "${t}" was not found.`);
}
function aA(e, t) {
	let n = e?.url ?? String(t);
	if (!n.trim()) throw Error("JSON source URL is missing.");
	return n.trim();
}
async function oA(e, t) {
	if (e.startsWith("{") || e.startsWith("[")) return JSON.parse(e);
	let n = await fetch(e, { signal: t });
	if (!n.ok) {
		let e = await n.text().catch(() => "");
		throw Error(e || `JSON source request failed with status ${n.status}.`);
	}
	return n.json();
}
function sA(e) {
	if (e) {
		if (typeof e == "string") try {
			return sA(JSON.parse(e));
		} catch {
			return;
		}
		if (typeof e == "object" && !Array.isArray(e)) return e;
	}
}
function cA(e) {
	return Object.entries(sA(e) ?? {}).filter(([e]) => e !== "__sampling");
}
function lA(e, t) {
	let n = cA(t);
	return n.length === 0 ? e : e.filter((e) => n.every(([t, n]) => {
		let r = e[t];
		if (Zk(r)) return !1;
		if (Array.isArray(n)) return n.some((e) => Qk(r).toLowerCase() === Qk(e).toLowerCase());
		if (n && typeof n == "object") {
			let { min: e, max: t } = n, i = Number(r);
			return !(!Number.isFinite(i) || e !== void 0 && i < Number(e) || t !== void 0 && i > Number(t));
		}
		return Qk(r).toLowerCase() === Qk(n).toLowerCase();
	}));
}
function uA(e, t) {
	if (e === t) return 0;
	if (Zk(e)) return 1;
	if (Zk(t)) return -1;
	let n = Number(e), r = Number(t);
	if (Number.isFinite(n) && Number.isFinite(r)) return n - r;
	let i = typeof e == "string" ? Date.parse(e) : NaN, a = typeof t == "string" ? Date.parse(t) : NaN;
	return Number.isFinite(i) && Number.isFinite(a) ? i - a : Qk(e).localeCompare(Qk(t), void 0, {
		numeric: !0,
		sensitivity: "base"
	});
}
function dA(e, t) {
	let n = t?.sortOptions?.[0], r = n?.column ?? t?.sortBy;
	if (!r) return e;
	let i = (n?.direction ?? t?.order)?.toLowerCase() === "desc" ? -1 : 1;
	return [...e].sort((e, t) => uA(e[r], t[r]) * i);
}
function fA(e) {
	return {
		strategy: e?.sampleStrategy,
		samplePercentage: Math.max(0, Math.min(100, Number(e?.samplePercentage ?? 100))),
		maxRows: Number(e?.maxRows ?? e?.maxSampleSize ?? 0)
	};
}
function pA(e, t) {
	let { strategy: n, samplePercentage: r, maxRows: i } = fA(t), a = r >= 100 ? e.length : Math.max(1, Math.ceil(e.length * (r / 100))), o = Number.isFinite(i) && i > 0 ? Math.min(a, i) : a;
	return e.length <= o ? {
		rows: e,
		samplePercentage: r,
		sampledRows: e.length
	} : n === "last-n" ? {
		rows: e.slice(-o),
		samplePercentage: r,
		sampledRows: o
	} : {
		rows: e.slice(0, o),
		samplePercentage: r,
		sampledRows: o
	};
}
function mA(e, t) {
	let n = Number(t?.limit ?? t?.pageSize ?? e.length), r = Number(t?.offset ?? (t?.page && t?.pageSize ? (t.page - 1) * t.pageSize : 0)), i = Number.isFinite(n) && n > 0 ? n : e.length, a = Number.isFinite(r) && r > 0 ? r : 0;
	return {
		rows: e.slice(a, a + i),
		limit: i,
		offset: a,
		hasMore: a + i < e.length
	};
}
function hA(e, t) {
	let n = e.map((e) => e[t]).filter((e) => !Zk(e));
	if (n.length === 0) return "categorical";
	if (n.filter((e) => typeof e == "number" ? Number.isFinite(e) : typeof e == "string" && e.trim() !== "" && Number.isFinite(Number(e))).length === n.length) return "numeric";
	let r = /date|time|created_at|updated_at|timestamp/i.test(t), i = n.filter((e) => e instanceof Date ? Number.isFinite(e.getTime()) : typeof e == "string" && Number.isFinite(Date.parse(e))).length;
	return i >= Math.ceil(n.length / 2) && (r || i === n.length) ? "date" : "categorical";
}
function gA(e, t) {
	let n = e.map((e) => e[t]).filter((e) => !Zk(e)), r = e.length - n.length;
	return {
		totalValues: e.length,
		nonNullValues: n.length,
		nullCount: r,
		nullPercentage: e.length === 0 ? "0" : (r / e.length * 100).toFixed(2),
		distinctCount: new Set(n.map((e) => Qk(e))).size
	};
}
function _A(e, t) {
	let n = e.map((e) => e[t]).filter((e) => !Zk(e)).map((e) => Number(e)).filter((e) => Number.isFinite(e)), r = [...n].sort((e, t) => e - t), i = n.reduce((e, t) => e + t, 0), a = n.length > 0 ? i / n.length : 0, o = n.length > 0 ? n.reduce((e, t) => e + (t - a) ** 2, 0) / n.length : 0, s = Math.floor(r.length / 2), c = r.length === 0 ? 0 : r.length % 2 == 0 ? ((r[s - 1] ?? 0) + (r[s] ?? 0)) / 2 : r[s] ?? 0, l = r[0] ?? 0, u = r[r.length - 1] ?? 0;
	return {
		...gA(e, t),
		type: "numeric",
		columnType: "REAL",
		mean: a,
		median: c,
		min: l,
		max: u,
		range: r.length > 0 ? u - l : 0,
		stddev: Math.sqrt(o),
		histogram: GC(n)
	};
}
function vA(e, t) {
	let n = e.map((e) => e[t]).filter((e) => !Zk(e)).map((e) => new Date(String(e))).filter((e) => Number.isFinite(e.getTime())).sort((e, t) => e.getTime() - t.getTime()), r = /* @__PURE__ */ new Map();
	n.forEach((e) => {
		let t = e.toLocaleString("en-US", {
			month: "short",
			year: "2-digit"
		});
		r.set(t, (r.get(t) ?? 0) + 1);
	});
	let i = n[0] ?? null, a = n[n.length - 1] ?? null, o = i && a ? Math.round((a.getTime() - i.getTime()) / 864e5) : 0, s = [...r.entries()].sort((e, t) => t[1] - e[1])[0]?.[0] ?? null;
	return {
		...gA(e, t),
		type: "date",
		columnType: "TEXT",
		minDate: i?.toISOString() ?? null,
		maxDate: a?.toISOString() ?? null,
		timeSpanDays: o,
		mostCommonPeriod: s,
		distribution: {
			labels: [...r.keys()],
			counts: [...r.values()]
		}
	};
}
function yA(e, t) {
	let n = e.map((e) => e[t]).filter((e) => !Zk(e)).reduce((e, t) => {
		let n = Qk(t);
		return e[n] = (e[n] ?? 0) + 1, e;
	}, {});
	return {
		...gA(e, t),
		type: "categorical",
		columnType: "TEXT",
		categories: n,
		mostCommon: Object.entries(n).sort((e, t) => t[1] - e[1])[0]?.[0] ?? null
	};
}
function bA(e, t) {
	let n = hA(e, t);
	return n === "numeric" ? _A(e, t) : n === "date" ? vA(e, t) : yA(e, t);
}
function xA(e, t, n) {
	return {
		...e,
		metadata: {
			...n,
			tableName: t
		}
	};
}
function SA(e, t, n, r, i) {
	let a = n.map((e) => {
		let n = t.filter((t) => Zk(t[e])).length;
		return {
			name: e,
			missingCount: n,
			totalCount: t.length,
			missingPercentage: t.length === 0 ? 0 : n / t.length * 100
		};
	});
	return {
		status: "success",
		columns: a,
		timestamp: (/* @__PURE__ */ new Date()).toISOString(),
		sampleSize: t.length,
		totalSize: i,
		data: { columns: a },
		metadata: {
			totalRows: i,
			sampledRows: t.length,
			samplePercentage: r,
			tableName: e
		}
	};
}
function CA(e) {
	let t = /* @__PURE__ */ new Map(), n = (n, r) => {
		let i = aA(e, n), a = `${e?.id ?? n}:${i}`, o = t.get(a);
		if (o) return o;
		let s = oA(i, r).then(rA);
		return t.set(a, s), s;
	}, r = async (e, t, r) => {
		let i = iA(await n(e), t), a = lA(i.rows, r?.filters), o = pA(a, r);
		return {
			table: i,
			filteredRows: a,
			rows: o.rows,
			samplePercentage: o.samplePercentage,
			sampledRows: o.sampledRows
		};
	};
	return {
		fetchTables: async (e) => {
			let t = await n(e), r = Object.keys(t.tables);
			return {
				status: "success",
				data: {
					tables: r,
					total: r.length
				}
			};
		},
		fetchTableData: async (e, t, r) => {
			let i = r?.signal, a = iA(await n(e, i), t), o = pA(lA(a.rows, r?.filters), r), s = mA(dA(o.rows, r), r);
			return {
				status: "success",
				data: {
					rows: s.rows,
					columns: a.columns,
					total: o.rows.length,
					metadata: {
						totalRows: o.rows.length,
						sourceRowCount: a.rows.length,
						sampledRows: o.sampledRows,
						samplePercentage: o.samplePercentage,
						appliedLimit: s.limit,
						offset: s.offset,
						hasMore: s.hasMore,
						cacheStatus: "unknown"
					}
				}
			};
		},
		fetchTableIndexes: async () => ({
			indexes: [],
			total: 0
		}),
		fetchTableColumns: async (e, t) => iA(await n(e), t).columns,
		fetchUniqueColumnValues: async (e, t, r, i = "", a = 100) => {
			let o = iA(await n(e), t), s = i.trim().toLowerCase();
			return Array.from(new Set(o.rows.map((e) => e[r]).filter((e) => !Zk(e)).map((e) => Qk(e)))).filter((e) => !s || e.toLowerCase().includes(s)).sort((e, t) => e.localeCompare(t, void 0, {
				numeric: !0,
				sensitivity: "base"
			})).slice(0, a);
		},
		fetchRecord: async (e, t, r) => {
			let i = iA(await n(e), t).rows.find((e, t) => String(e.rowid ?? e.id ?? t + 1) === String(r));
			if (!i) throw Error(`JSON record "${r}" was not found.`);
			return i;
		},
		updateRecord: async () => Xk("updateRecord"),
		createRecord: async () => Xk("createRecord"),
		deleteRecord: async () => Xk("deleteRecord"),
		bulkDeleteRecords: async () => Xk("bulkDeleteRecords"),
		fetchColumnStats: async (e, t, n, i = {}) => {
			let a = Date.now(), { table: o, filteredRows: s, rows: c, samplePercentage: l, sampledRows: u } = await r(e, t, i), d = {
				totalRows: c.length,
				sourceRowCount: o.rows.length,
				filteredRows: s.length,
				sampledRows: u,
				samplePercentage: l,
				isFiltered: cA(i.filters).length > 0,
				executionTimeMs: Date.now() - a
			};
			return n ? xA(bA(c, n), t, {
				...d,
				columnName: n
			}) : {
				type: "comprehensive",
				tableName: t,
				totalRows: c.length,
				totalColumns: o.columns.length,
				sampleSize: c.length,
				samplePercentage: l,
				executionTimeMs: Date.now() - a,
				columnStatistics: Object.fromEntries(o.columns.map((e) => [e, bA(c, e)])),
				metadata: {
					...d,
					tableName: t
				}
			};
		},
		fetchMissingData: async (e, t, n = {}) => {
			let { table: i, filteredRows: a, rows: o, samplePercentage: s } = await r(e, t, n);
			return SA(t, o, n.columnName ? [n.columnName] : i.columns, s, a.length);
		},
		fetchDatabaseInfo: async (t) => {
			let r = await n(t), i = Object.keys(r.tables), a = i.reduce((e, t) => e + r.tables[t].rows.length, 0);
			return {
				id: e?.id ?? t,
				name: e?.label ?? String(t),
				original_file_name: e?.label ?? "JSON source",
				datasource_type: "json",
				source_url: e?.url ?? String(t),
				is_public: !0,
				table_count: i.length,
				total_rows: a,
				tables: i
			};
		},
		fetchSamplingMethods: async () => [
			"first-n",
			"last-n",
			"percentage",
			"random"
		],
		applySampling: async (e, t, r) => {
			let i = lA(iA(await n(e), t).rows, r.filters), a = pA(i, {
				sampleStrategy: r.method,
				samplePercentage: r.samplePercentage,
				maxRows: r.maxRows
			});
			return {
				rows: a.rows,
				data: a.rows,
				metadata: {
					totalRows: i.length,
					sampledRows: a.sampledRows,
					samplingPercentage: a.samplePercentage,
					executionTimeMs: 0,
					method: r.method,
					parameters: r
				}
			};
		},
		fetchColumnTypes: async (e, t) => {
			let r = iA(await n(e), t);
			return Object.fromEntries(r.columns.map((e) => {
				let t = hA(r.rows, e);
				return [e, t === "numeric" ? "numerical" : t];
			}));
		},
		fetchTableRowCount: async (e, t, r) => lA(iA(await n(e), t).rows, r).length
	};
}
//#endregion
//#region src/services/sourceRouter.ts
function wA(e) {
	switch (e.type) {
		case "internal": return Or;
		case "metadata": return Wk;
		case "external_pg": return Jk;
		case "json": return CA(e);
		default: return CA();
	}
}
async function TA(e) {
	return (await wA(e).fetchTables(e.id)).data?.tables ?? [];
}
//#endregion
//#region src/panels/GovernancePanel/privacyMatrix.ts
var EA = [
	"name",
	"email",
	"phone",
	"address",
	"date",
	"ssn",
	"medical_record",
	"account_number",
	"other"
];
function DA(e) {
	if (!e) return "Unknown date";
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : t.toLocaleString();
}
function OA(e) {
	return e >= .95 ? "critical" : e >= .85 ? "high" : e >= .65 ? "medium" : e > 0 ? "low" : "none";
}
function kA(e) {
	return e === "critical" ? "bg-rose-600 text-white border-rose-500" : e === "high" ? "bg-rose-100 text-rose-700 border-rose-200" : e === "medium" ? "bg-amber-100 text-amber-800 border-amber-200" : e === "low" ? "bg-sky-100 text-sky-800 border-sky-200" : "bg-slate-50 text-slate-400 border-slate-200";
}
function AA(e) {
	return e === "identity_disclosure" ? "Identity Disclosure" : e === "attribute_disclosure" ? "Attribute Disclosure" : "Association Disclosure";
}
function jA(e) {
	let t = [
		e.columnName,
		e.phiType,
		e.explanation
	].filter(Boolean).join(" ").toLowerCase();
	return /(^|[^a-z])(name|email|phone|ssn|social security|medical record|mrn|account|passport|license)([^a-z]|$)/.test(t) ? "identity_disclosure" : /(^|[^a-z])(address|zip|postal|age|birth|dob|date|gender|sex|city|state|region|ethnicity|race)([^a-z]|$)/.test(t) ? "attribute_disclosure" : "association_disclosure";
}
function MA(e) {
	let t = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set();
	for (let i of e?.findings ?? []) {
		let e = i.tableName || "Unknown table", a = i.phiType || "other", o = `${e}::${a}`;
		n.add(e), r.add(a);
		let s = t.get(o);
		if (!s) {
			t.set(o, {
				tableName: e,
				phiType: a,
				findings: [i],
				maxConfidence: i.confidence ?? 0
			});
			continue;
		}
		s.findings.push(i), s.maxConfidence = Math.max(s.maxConfidence, i.confidence ?? 0);
	}
	let i = [...EA.filter((e) => r.has(e)), ...[...r].filter((e) => !EA.includes(e)).sort((e, t) => e.localeCompare(t))];
	return {
		tables: [...n].sort((e, t) => e.localeCompare(t)),
		phiTypes: i,
		cells: t
	};
}
//#endregion
//#region src/panels/GovernancePanel/ReviewFlowBoard.tsx
var NA = [
	{
		id: "needs_review",
		title: "Needs Review",
		description: "Auto-populated from the governance review queue.",
		accent: "text-rose-700",
		surface: "border-rose-100 bg-rose-50/80"
	},
	{
		id: "triage",
		title: "Triage",
		description: "Assigned for first-pass owner, classification, and contract review.",
		tagName: "governance-triage",
		accent: "text-amber-800",
		surface: "border-amber-100 bg-amber-50/80"
	},
	{
		id: "approved",
		title: "Approved",
		description: "Approved for regular use while remaining reasons are monitored.",
		tagName: "governance-approved",
		accent: "text-emerald-700",
		surface: "border-emerald-100 bg-emerald-50/80"
	},
	{
		id: "monitoring",
		title: "Monitoring",
		description: "Escalated items that need follow-up after the first decision.",
		tagName: "governance-monitoring",
		accent: "text-sky-700",
		surface: "border-sky-100 bg-sky-50/80"
	}
];
function PA() {
	return {
		needs_review: [],
		triage: [],
		approved: [],
		monitoring: []
	};
}
function FA(e) {
	return e.replace(/_/g, " ");
}
function IA(e, t) {
	return {
		databaseId: e.databaseId,
		name: e.name,
		reasons: "reasons" in e ? e.reasons : [],
		classification: "classification" in e ? e.classification : void 0,
		currentOwnerId: "currentOwnerId" in e ? e.currentOwnerId : void 0,
		qualityScore: "qualityScore" in e ? e.qualityScore : void 0,
		lastCheckStatus: "lastCheckStatus" in e ? e.lastCheckStatus : void 0,
		stage: t
	};
}
function LA({ databaseId: e, renderCardActions: t }) {
	let [n, r] = h(PA), [i, a] = h({}), [o, c] = h(null), [l, d] = h(null), [p, m] = h(!0), [g, y] = h(null), [b, x] = h(null), S = f(() => {
		if (e == null) return null;
		let t = Number(e);
		return Number.isFinite(t) ? t : null;
	}, [e]), C = s(async () => {
		m(!0), y(null);
		try {
			let e = NA.filter((e) => e.tagName), [t, n, ...i] = await Promise.all([
				oi.fetchReviewQueue(),
				oi.listTags(),
				...e.map((e) => oi.searchGovernance({ tag: e.tagName }))
			]);
			a(Object.fromEntries(n.map((e) => [e.name, e])));
			let o = PA(), s = /* @__PURE__ */ new Set();
			i.forEach((t, n) => {
				let r = e[n];
				o[r.id] = t.data.map((e) => (s.add(e.databaseId), IA(e, r.id)));
			}), o.needs_review = t.data.filter((e) => !s.has(e.databaseId)).map((e) => IA(e, "needs_review")), r(o);
		} catch (e) {
			y(e instanceof Error ? e.message : "Unable to load governance review flow.");
		} finally {
			m(!1);
		}
	}, []);
	u(() => {
		C();
	}, [C]);
	let w = s(async (e) => {
		if (!e.tagName) return null;
		let t = i[e.tagName];
		if (t) return t;
		let n = await oi.createTag({
			name: e.tagName,
			namespace: "workflow",
			description: `${e.title} stage for the governance review board.`
		});
		return a((e) => ({
			...e,
			[n.name]: n
		})), n;
	}, [i]), T = s(async (e, t, a) => {
		if (t === a) return;
		let o = n[t].find((t) => t.databaseId === e);
		if (!o) return;
		let s = n, c = NA.find((e) => e.id === t), l = NA.find((e) => e.id === a);
		if (!(!c || !l)) {
			d(e), x(null), r((t) => {
				let n = PA();
				return Object.keys(t).forEach((r) => {
					n[r] = t[r].filter((t) => t.databaseId !== e);
				}), n[a] = [...n[a], {
					...o,
					stage: a
				}], n;
			});
			try {
				if (c.tagName) {
					let t = i[c.tagName];
					t && await oi.detachTagFromDatabase(e, t.id);
				}
				if (l.tagName) {
					let t = await w(l);
					t && await oi.attachTagToDatabase(e, t.id);
				}
				x(`${o.name} moved to ${l.title}.`), await C();
			} catch (e) {
				r(s), y(e instanceof Error ? e.message : "Unable to update governance stage.");
			} finally {
				d(null);
			}
		}
	}, [
		n,
		C,
		w,
		i
	]), E = f(() => Object.values(n).reduce((e, t) => e + t.length, 0), [n]);
	return /* @__PURE__ */ v("div", {
		className: "flex min-h-0 flex-1 flex-col gap-4",
		children: [
			/* @__PURE__ */ _("div", {
				className: "rounded-[1.5rem] border border-white/80 bg-white/78 px-5 py-4 shadow-[0_16px_38px_rgba(75,119,128,0.1)]",
				children: /* @__PURE__ */ v("div", {
					className: "flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between",
					children: [/* @__PURE__ */ v("div", {
						className: "max-w-3xl",
						children: [
							/* @__PURE__ */ _("p", {
								className: "text-xs uppercase tracking-[0.25em] text-slate-400",
								children: "Review Flow"
							}),
							/* @__PURE__ */ _("h2", {
								className: "mt-2 text-2xl font-semibold text-slate-900",
								children: "Kanban board for governance decisions"
							}),
							/* @__PURE__ */ _("p", {
								className: "mt-2 text-sm leading-6 text-slate-600",
								children: "The first lane auto-populates from the review queue, while the other lanes are backed by governance stage tags so drag-and-drop decisions persist between sessions."
							})
						]
					}), /* @__PURE__ */ v("div", {
						className: "flex flex-wrap gap-3",
						children: [/* @__PURE__ */ v("div", {
							className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
							children: [/* @__PURE__ */ _("p", {
								className: "text-[11px] uppercase tracking-[0.18em] text-slate-400",
								children: "Items in flow"
							}), /* @__PURE__ */ _("p", {
								className: "mt-2 text-2xl font-semibold text-slate-900",
								children: E
							})]
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => void C(),
							className: "rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50",
							"data-testid": "governance-refresh-board",
							children: "Refresh board"
						})]
					})]
				})
			}),
			b ? /* @__PURE__ */ _("div", {
				className: "rounded-[1.2rem] border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800",
				children: b
			}) : null,
			g ? /* @__PURE__ */ _("div", {
				className: "rounded-[1.2rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800",
				children: g
			}) : null,
			/* @__PURE__ */ _("div", {
				className: "grid min-h-0 flex-1 gap-4 xl:grid-cols-4",
				children: NA.map((e) => /* @__PURE__ */ v("section", {
					className: `flex min-h-[18rem] min-w-0 flex-col rounded-[1.5rem] border px-4 py-4 shadow-[0_14px_30px_rgba(75,119,128,0.08)] ${e.surface}`,
					onDragOver: (e) => e.preventDefault(),
					onDrop: (t) => {
						t.preventDefault();
						let n = t.dataTransfer.getData("text/plain");
						if (n) try {
							let t = JSON.parse(n);
							T(t.databaseId, t.fromStage, e.id);
						} catch {}
					},
					"data-testid": `governance-column-${e.id}`,
					children: [/* @__PURE__ */ v("div", {
						className: "flex items-start justify-between gap-3",
						children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("h3", {
							className: `text-lg font-semibold ${e.accent}`,
							children: e.title
						}), /* @__PURE__ */ _("p", {
							className: "mt-2 text-sm leading-6 text-slate-600",
							children: e.description
						})] }), /* @__PURE__ */ _("span", {
							className: "rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-slate-500",
							children: n[e.id].length
						})]
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 min-h-0 flex-1 space-y-3 overflow-y-auto",
						children: [
							p && E === 0 ? /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-white/80 px-4 py-6 text-sm text-slate-500",
								children: "Loading governance cards..."
							}) : null,
							!p && n[e.id].length === 0 ? /* @__PURE__ */ _("div", {
								className: "rounded-[1.2rem] border border-dashed border-slate-200 bg-white/80 px-4 py-6 text-sm text-slate-500",
								children: "No items in this stage right now."
							}) : null,
							n[e.id].map((n) => /* @__PURE__ */ v("article", {
								draggable: l !== n.databaseId,
								onDragStart: (t) => {
									c(n.databaseId), t.dataTransfer.setData("text/plain", JSON.stringify({
										databaseId: n.databaseId,
										fromStage: e.id
									})), t.dataTransfer.effectAllowed = "move";
								},
								onDragEnd: () => c(null),
								className: `rounded-[1.2rem] border border-white/90 bg-white/92 px-4 py-4 shadow-[0_10px_24px_rgba(15,23,42,0.08)] transition ${o === n.databaseId ? "opacity-70" : ""} ${S === n.databaseId ? "ring-2 ring-slate-900/15" : ""}`,
								"data-testid": `governance-card-${n.databaseId}`,
								children: [
									/* @__PURE__ */ v("div", {
										className: "flex items-start justify-between gap-3",
										children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
											className: "text-sm font-semibold text-slate-900",
											children: n.name
										}), /* @__PURE__ */ v("p", {
											className: "mt-1 text-xs text-slate-500",
											children: ["Database ", n.databaseId]
										})] }), l === n.databaseId ? /* @__PURE__ */ _("span", {
											className: "rounded-full bg-slate-100 px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-500",
											children: "Saving"
										}) : null]
									}),
									/* @__PURE__ */ _("div", {
										className: "mt-3 flex flex-wrap gap-2",
										children: (n.reasons.length > 0 ? n.reasons : ["tagged_stage"]).map((e) => /* @__PURE__ */ _("span", {
											className: "rounded-full bg-slate-100 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.16em] text-slate-600",
											children: FA(e)
										}, e))
									}),
									/* @__PURE__ */ v("div", {
										className: "mt-4 grid gap-2 text-xs text-slate-500",
										children: [
											/* @__PURE__ */ v("div", {
												className: "flex items-center justify-between gap-3",
												children: [/* @__PURE__ */ _("span", { children: "Classification" }), /* @__PURE__ */ _("span", {
													className: "font-medium text-slate-700",
													children: n.classification ?? "Unclassified"
												})]
											}),
											/* @__PURE__ */ v("div", {
												className: "flex items-center justify-between gap-3",
												children: [/* @__PURE__ */ _("span", { children: "Owner" }), /* @__PURE__ */ _("span", {
													className: "font-medium text-slate-700",
													children: n.currentOwnerId ? `User ${n.currentOwnerId}` : "Unassigned"
												})]
											}),
											/* @__PURE__ */ v("div", {
												className: "flex items-center justify-between gap-3",
												children: [/* @__PURE__ */ _("span", { children: "Quality score" }), /* @__PURE__ */ _("span", {
													className: "font-medium text-slate-700",
													children: typeof n.qualityScore == "number" ? n.qualityScore : "—"
												})]
											})
										]
									}),
									/* @__PURE__ */ _("div", {
										className: "mt-4 flex flex-wrap gap-2",
										children: NA.filter((t) => t.id !== e.id).map((t) => /* @__PURE__ */ v("button", {
											type: "button",
											onClick: () => void T(n.databaseId, e.id, t.id),
											className: "rounded-full border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50",
											"data-testid": `governance-move-${n.databaseId}-${t.id}`,
											children: ["Move to ", t.title]
										}, t.id))
									}),
									t ? /* @__PURE__ */ _("div", {
										className: "mt-4 rounded-[1rem] border border-slate-200 bg-slate-50/90 px-3 py-3",
										children: t(n)
									}) : null
								]
							}, `${e.id}-${n.databaseId}`))
						]
					})]
				}, e.id))
			})
		]
	});
}
//#endregion
//#region src/panels/GovernancePanel/workflows/WorkflowConfigForm.tsx
var RA = {
	name: "Review schema change",
	assigneeRole: "data_steward"
}, zA = [
	{
		value: "SCHEMA_CHANGE",
		label: "Schema change",
		defaultStep: RA
	},
	{
		value: "ACCESS_REQUEST",
		label: "Access request",
		defaultStep: {
			name: "Review access request",
			assigneeRole: "dataset_owner"
		}
	},
	{
		value: "POLICY_REVIEW",
		label: "Policy review",
		defaultStep: {
			name: "Review policy exception",
			assigneeRole: "governance_lead"
		}
	}
];
function BA(e) {
	return zA.find((t) => t.value === e)?.defaultStep ?? RA;
}
function VA(e) {
	return e.map((e) => ({
		name: e.name.trim(),
		assigneeRole: e.assigneeRole.trim()
	}));
}
function HA({ template: e, saving: t = !1, onSave: n, onCancel: r }) {
	let [i, a] = h(""), [o, s] = h("SCHEMA_CHANGE"), [c, l] = h([RA]), [d, f] = h(null);
	u(() => {
		let t = e?.triggerType ?? "SCHEMA_CHANGE";
		a(e?.name ?? ""), s(t), l(e?.steps?.length ? e.steps : [BA(t)]), f(null);
	}, [e]);
	let p = (e, t) => {
		l((n) => n.map((n, r) => r === e ? {
			...n,
			...t
		} : n));
	}, m = (e) => {
		l((t) => t.filter((t, n) => n !== e));
	}, g = async (t) => {
		t.preventDefault();
		let r = i.trim(), a = VA(c);
		if (!r) {
			f("Template name is required.");
			return;
		}
		if (a.length === 0 || a.some((e) => !e.name || !e.assigneeRole)) {
			f("Every workflow step needs a name and assignee role.");
			return;
		}
		f(null), await n({
			...e?.id ? { id: e.id } : {},
			name: r,
			triggerType: o,
			steps: a
		});
	};
	return /* @__PURE__ */ v("form", {
		className: "flex min-h-0 flex-col gap-4 rounded-[1.2rem] border border-slate-200 bg-white px-4 py-4",
		onSubmit: (e) => void g(e),
		"data-testid": "workflow-config-form",
		children: [
			/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
				className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-400",
				children: "Template"
			}), /* @__PURE__ */ _("h3", {
				className: "mt-1 text-lg font-semibold text-slate-900",
				children: e ? "Edit workflow template" : "Create workflow template"
			})] }),
			d ? /* @__PURE__ */ _("div", {
				className: "rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm text-rose-800",
				children: d
			}) : null,
			/* @__PURE__ */ v("label", {
				className: "grid gap-2 text-sm font-medium text-slate-700",
				children: ["Template name", /* @__PURE__ */ _("input", {
					type: "text",
					value: i,
					onChange: (e) => a(e.target.value),
					className: "rounded-lg border border-slate-200 px-3 py-2 text-sm font-normal text-slate-900 outline-none transition focus:border-slate-400",
					placeholder: "Schema change review",
					"data-testid": "workflow-template-name"
				})]
			}),
			/* @__PURE__ */ v("label", {
				className: "grid gap-2 text-sm font-medium text-slate-700",
				children: ["Trigger", /* @__PURE__ */ _("select", {
					value: o,
					onChange: (t) => {
						let n = t.target.value;
						s(n), e || l([BA(n)]);
					},
					className: "rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal text-slate-700",
					"data-testid": "workflow-template-trigger",
					children: zA.map((e) => /* @__PURE__ */ _("option", {
						value: e.value,
						children: e.label
					}, e.value))
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "min-h-0",
				children: [/* @__PURE__ */ v("div", {
					className: "flex items-center justify-between gap-3",
					children: [/* @__PURE__ */ _("p", {
						className: "text-sm font-semibold text-slate-800",
						children: "Steps"
					}), /* @__PURE__ */ _("button", {
						type: "button",
						onClick: () => l((e) => [...e, {
							...RA,
							name: ""
						}]),
						className: "rounded-full border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50",
						"data-testid": "workflow-add-step",
						children: "Add step"
					})]
				}), /* @__PURE__ */ _("div", {
					className: "mt-3 grid gap-3",
					children: c.map((e, t) => /* @__PURE__ */ v("div", {
						className: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-3",
						children: [/* @__PURE__ */ v("div", {
							className: "flex items-center justify-between gap-3",
							children: [/* @__PURE__ */ v("span", {
								className: "text-xs font-semibold uppercase tracking-[0.18em] text-slate-400",
								children: ["Step ", t + 1]
							}), /* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => m(t),
								disabled: c.length === 1,
								className: "rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-500 transition hover:border-slate-300 disabled:cursor-not-allowed disabled:opacity-50",
								children: "Remove"
							})]
						}), /* @__PURE__ */ v("div", {
							className: "mt-3 grid gap-3 md:grid-cols-2",
							children: [/* @__PURE__ */ v("label", {
								className: "grid gap-2 text-sm font-medium text-slate-700",
								children: ["Step name", /* @__PURE__ */ _("input", {
									type: "text",
									value: e.name,
									onChange: (e) => p(t, { name: e.target.value }),
									className: "rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal text-slate-900 outline-none transition focus:border-slate-400",
									"data-testid": `workflow-step-name-${t}`
								})]
							}), /* @__PURE__ */ v("label", {
								className: "grid gap-2 text-sm font-medium text-slate-700",
								children: ["Assignee role", /* @__PURE__ */ _("input", {
									type: "text",
									value: e.assigneeRole,
									onChange: (e) => p(t, { assigneeRole: e.target.value }),
									className: "rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal text-slate-900 outline-none transition focus:border-slate-400",
									"data-testid": `workflow-step-role-${t}`
								})]
							})]
						})]
					}, `${t}-${e.assigneeRole}`))
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex flex-wrap items-center gap-2",
				children: [/* @__PURE__ */ _("button", {
					type: "submit",
					disabled: t,
					className: "rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60",
					"data-testid": "workflow-template-save",
					children: t ? "Saving..." : "Save template"
				}), r ? /* @__PURE__ */ _("button", {
					type: "button",
					onClick: r,
					className: "rounded-full border border-slate-200 px-4 py-2 text-sm font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50",
					"data-testid": "workflow-template-cancel",
					children: "Cancel"
				}) : null]
			})
		]
	});
}
//#endregion
//#region src/panels/GovernancePanel/workflows/RunQueuePanel.tsx
var UA = [
	{
		id: "ALL",
		label: "All"
	},
	{
		id: "PENDING",
		label: "Pending"
	},
	{
		id: "IN_REVIEW",
		label: "In review"
	},
	{
		id: "APPROVED",
		label: "Approved"
	},
	{
		id: "REJECTED",
		label: "Rejected"
	},
	{
		id: "ESCALATED",
		label: "Escalated"
	}
], WA = {
	SCHEMA_CHANGE: "schema-change-event",
	ACCESS_REQUEST: "catalog-access-request",
	POLICY_REVIEW: "policy-review-cycle"
}, GA = {
	SCHEMA_CHANGE: "data_steward",
	ACCESS_REQUEST: "dataset_owner",
	POLICY_REVIEW: "governance_lead"
};
function KA(e) {
	return e.replace(/_/g, " ").toLowerCase();
}
function qA(e) {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : new Intl.DateTimeFormat(void 0, {
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	}).format(t);
}
function JA(e) {
	return e.replace(/_/g, " ").toLowerCase();
}
function YA(e) {
	return e.length <= 10 ? e : e.slice(0, 8);
}
function XA(e) {
	return e.template?.steps[e.currentStep]?.name ?? `Step ${e.currentStep + 1}`;
}
function ZA({ templates: e, runs: t, statusFilter: n, selectedRunId: r, loading: i = !1, triggering: a = !1, actorId: o, onStatusFilterChange: s, onSelectRun: c, onRefresh: l, onTriggerRun: d }) {
	let [f, p] = h(""), [m, g] = h("schema-change-event"), [y, b] = h("data_steward"), [x, S] = h(null);
	u(() => {
		if (e.length === 0) {
			p("");
			return;
		}
		p((t) => t && e.some((e) => e.id === t) ? t : e[0].id);
	}, [e]);
	let C = (t) => {
		p(t);
		let n = e.find((e) => e.id === t)?.triggerType ?? "SCHEMA_CHANGE";
		g(WA[n]), b(GA[n]);
	}, w = async (e) => {
		e.preventDefault();
		let t = m.trim(), n = y.trim();
		if (!f) {
			S("Choose a workflow template before triggering a run.");
			return;
		}
		if (!t || !n) {
			S("Trigger source and assigned steward are required.");
			return;
		}
		S(null), await d({
			templateId: f,
			triggeredBy: t,
			assignedSteward: n,
			...o ? { actorId: o } : {}
		});
	};
	return /* @__PURE__ */ v("section", {
		className: "flex min-h-0 flex-col rounded-[1.2rem] border border-slate-200 bg-white",
		"data-testid": "workflow-run-queue",
		children: [
			/* @__PURE__ */ v("div", {
				className: "border-b border-slate-100 px-4 py-4",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-col gap-3 xl:flex-row xl:items-start xl:justify-between",
					children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
						className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-400",
						children: "Run Queue"
					}), /* @__PURE__ */ _("h3", {
						className: "mt-1 text-lg font-semibold text-slate-900",
						children: "Stewardship workflow runs"
					})] }), /* @__PURE__ */ _("button", {
						type: "button",
						onClick: l,
						className: "self-start rounded-full border border-slate-200 px-3 py-1.5 text-xs font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50",
						"data-testid": "workflow-refresh-runs",
						children: "Refresh"
					})]
				}), /* @__PURE__ */ _("div", {
					className: "mt-4 flex flex-wrap gap-2",
					children: UA.map((e) => /* @__PURE__ */ _("button", {
						type: "button",
						onClick: () => s(e.id),
						className: `rounded-full px-3 py-1.5 text-xs font-medium transition ${n === e.id ? "bg-slate-900 text-white" : "border border-slate-200 bg-white text-slate-600 hover:border-slate-300"}`,
						"data-testid": `workflow-filter-${e.id}`,
						children: e.label
					}, e.id))
				})]
			}),
			/* @__PURE__ */ v("form", {
				className: "grid gap-3 border-b border-slate-100 bg-slate-50 px-4 py-4 lg:grid-cols-[minmax(11rem,1fr)_minmax(10rem,0.8fr)_minmax(10rem,0.8fr)_auto]",
				onSubmit: (e) => void w(e),
				children: [
					/* @__PURE__ */ v("label", {
						className: "grid gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
						children: ["Template", /* @__PURE__ */ v("select", {
							value: f,
							onChange: (e) => C(e.target.value),
							disabled: e.length === 0 || a,
							className: "min-w-0 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal normal-case tracking-normal text-slate-800",
							"data-testid": "workflow-trigger-template",
							children: [e.length === 0 ? /* @__PURE__ */ _("option", {
								value: "",
								children: "No templates"
							}) : null, e.map((e) => /* @__PURE__ */ v("option", {
								value: e.id,
								children: [
									e.name,
									" - ",
									KA(e.triggerType)
								]
							}, e.id))]
						})]
					}),
					/* @__PURE__ */ v("label", {
						className: "grid gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
						children: ["Trigger source", /* @__PURE__ */ _("input", {
							type: "text",
							value: m,
							onChange: (e) => g(e.target.value),
							disabled: a,
							className: "min-w-0 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal normal-case tracking-normal text-slate-800",
							"data-testid": "workflow-triggered-by"
						})]
					}),
					/* @__PURE__ */ v("label", {
						className: "grid gap-2 text-xs font-semibold uppercase tracking-[0.16em] text-slate-400",
						children: ["Steward", /* @__PURE__ */ _("input", {
							type: "text",
							value: y,
							onChange: (e) => b(e.target.value),
							disabled: a,
							className: "min-w-0 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm font-normal normal-case tracking-normal text-slate-800",
							"data-testid": "workflow-assigned-steward"
						})]
					}),
					/* @__PURE__ */ _("button", {
						type: "submit",
						disabled: e.length === 0 || a || !o,
						className: "self-end rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60",
						"data-testid": "workflow-trigger-run",
						children: a ? "Triggering..." : "Trigger run"
					})
				]
			}),
			x ? /* @__PURE__ */ _("div", {
				className: "border-b border-rose-100 bg-rose-50 px-4 py-3 text-sm text-rose-800",
				children: x
			}) : null,
			/* @__PURE__ */ _("div", {
				className: "min-h-0 flex-1 overflow-auto",
				children: /* @__PURE__ */ v("table", {
					className: "min-w-full divide-y divide-slate-200 text-left text-sm",
					children: [/* @__PURE__ */ _("thead", {
						className: "sticky top-0 bg-white text-xs uppercase tracking-[0.16em] text-slate-400",
						children: /* @__PURE__ */ v("tr", { children: [
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Run"
							}),
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Template"
							}),
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Triggered"
							}),
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Current step"
							}),
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Status"
							}),
							/* @__PURE__ */ _("th", {
								className: "px-4 py-3 font-semibold",
								children: "Steward"
							})
						] })
					}), /* @__PURE__ */ v("tbody", {
						className: "divide-y divide-slate-100",
						children: [
							i ? /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", {
								colSpan: 6,
								className: "px-4 py-8 text-sm text-slate-500",
								children: "Loading workflow runs..."
							}) }) : null,
							!i && t.length === 0 ? /* @__PURE__ */ _("tr", { children: /* @__PURE__ */ _("td", {
								colSpan: 6,
								className: "px-4 py-8 text-sm text-slate-500",
								children: "No workflow runs match this filter."
							}) }) : null,
							!i && t.map((e) => /* @__PURE__ */ v("tr", {
								tabIndex: 0,
								onClick: () => c(e),
								onKeyDown: (t) => {
									(t.key === "Enter" || t.key === " ") && (t.preventDefault(), c(e));
								},
								className: `cursor-pointer transition hover:bg-slate-50 ${r === e.id ? "bg-slate-50 ring-1 ring-inset ring-slate-200" : ""}`,
								"data-testid": `workflow-run-row-${e.id}`,
								children: [
									/* @__PURE__ */ _("td", {
										className: "px-4 py-3 font-mono text-xs text-slate-600",
										children: YA(e.id)
									}),
									/* @__PURE__ */ v("td", {
										className: "px-4 py-3",
										children: [/* @__PURE__ */ _("span", {
											className: "block font-medium text-slate-900",
											children: e.template?.name ?? e.templateId
										}), e.template ? /* @__PURE__ */ _("span", {
											className: "mt-1 block text-xs text-slate-500",
											children: KA(e.template.triggerType)
										}) : null]
									}),
									/* @__PURE__ */ _("td", {
										className: "px-4 py-3 text-slate-600",
										children: qA(e.triggeredAt)
									}),
									/* @__PURE__ */ _("td", {
										className: "px-4 py-3 text-slate-600",
										children: XA(e)
									}),
									/* @__PURE__ */ _("td", {
										className: "px-4 py-3",
										children: /* @__PURE__ */ _("span", {
											className: "rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold capitalize text-slate-700",
											children: JA(e.status)
										})
									}),
									/* @__PURE__ */ _("td", {
										className: "px-4 py-3 text-slate-600",
										children: e.assignedSteward
									})
								]
							}, e.id))
						]
					})]
				})
			})
		]
	});
}
//#endregion
//#region src/panels/GovernancePanel/workflows/StepActionPanel.tsx
var QA = new Set([
	"IN_REVIEW",
	"APPROVED",
	"REJECTED",
	"ESCALATED"
]);
function $A(e) {
	let t = new Date(e);
	return Number.isNaN(t.getTime()) ? e : new Intl.DateTimeFormat(void 0, {
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit"
	}).format(t);
}
function ej(e) {
	return e.replace(/_/g, " ").toLowerCase();
}
function tj(e) {
	return e.template?.steps[e.currentStep]?.name ?? `Step ${e.currentStep + 1}`;
}
function nj(e) {
	return `${e.getFullYear()}${`${e.getMonth() + 1}`.padStart(2, "0")}${`${e.getDate()}`.padStart(2, "0")}`;
}
function rj(e, t, n = /* @__PURE__ */ new Date()) {
	return `audit-log-${e}-${nj(n)}.${t}`;
}
function ij(e, t) {
	let n = URL.createObjectURL(e), r = document.createElement("a");
	r.href = n, r.download = t, r.rel = "noopener", document.body.appendChild(r), r.click(), r.remove(), URL.revokeObjectURL(n);
}
function aj({ run: e, workspaceId: t, actorId: n, canAct: r = !0, transitioning: i = !1, onTransition: a }) {
	let [o, s] = h(""), [c, l] = h("json"), [u, d] = h(!1), [p, m] = h(null), g = !!n && r, y = !!(e && e.status === "PENDING" && g && !i), b = !!(e && e.status === "IN_REVIEW" && g && !i), x = !!(e && t && QA.has(e.status)), S = f(() => e ? g ? e.status === "PENDING" ? "Open the run before recording a decision." : e.status === "IN_REVIEW" ? null : "This run is already closed for steward decisions." : "Actions are disabled until an actor can be resolved." : "Select a run to review.", [g, e]), C = async (t) => {
		e && (await a(e.id, t, o.trim()), s(""));
	}, w = async () => {
		if (!(!e || !t || !x)) {
			d(!0), m(null);
			try {
				ij(await oi.exportWorkflowAuditLog(t, e.id, c), rj(e.id, c));
			} catch (e) {
				m(e instanceof Error ? e.message : "Unable to export audit log.");
			} finally {
				d(!1);
			}
		}
	};
	return e ? /* @__PURE__ */ v("aside", {
		className: "flex min-h-0 flex-col rounded-[1.2rem] border border-slate-200 bg-white",
		"data-testid": "workflow-step-action-panel",
		children: [
			/* @__PURE__ */ v("div", {
				className: "border-b border-slate-100 px-4 py-4",
				children: [
					/* @__PURE__ */ _("p", {
						className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-400",
						children: "Step Action"
					}),
					/* @__PURE__ */ _("h3", {
						className: "mt-1 text-lg font-semibold text-slate-900",
						children: tj(e)
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-3 grid gap-2 text-sm text-slate-600",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex justify-between gap-3",
								children: [/* @__PURE__ */ _("span", { children: "Template" }), /* @__PURE__ */ _("span", {
									className: "font-medium text-slate-900",
									children: e.template?.name ?? e.templateId
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "flex justify-between gap-3",
								children: [/* @__PURE__ */ _("span", { children: "Status" }), /* @__PURE__ */ _("span", {
									className: "font-medium text-slate-900",
									children: e.status.replace(/_/g, " ")
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "flex justify-between gap-3",
								children: [/* @__PURE__ */ _("span", { children: "Steward" }), /* @__PURE__ */ _("span", {
									className: "font-medium text-slate-900",
									children: e.assignedSteward
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "flex justify-between gap-3",
								children: [/* @__PURE__ */ _("span", { children: "Triggered" }), /* @__PURE__ */ _("span", {
									className: "font-medium text-slate-900",
									children: $A(e.triggeredAt)
								})]
							})
						]
					})
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "border-b border-slate-100 px-4 py-4",
				children: [
					/* @__PURE__ */ v("label", {
						className: "grid gap-2 text-sm font-medium text-slate-700",
						children: ["Decision note", /* @__PURE__ */ _("textarea", {
							value: o,
							onChange: (e) => s(e.target.value),
							rows: 3,
							className: "resize-none rounded-lg border border-slate-200 px-3 py-2 text-sm font-normal text-slate-900 outline-none transition focus:border-slate-400 disabled:bg-slate-50",
							disabled: !g || i,
							"data-testid": "workflow-action-note"
						})]
					}),
					S ? /* @__PURE__ */ _("p", {
						className: "mt-3 text-xs text-slate-500",
						"data-testid": "workflow-action-disabled-reason",
						children: S
					}) : null,
					/* @__PURE__ */ v("div", {
						className: "mt-4 flex flex-wrap gap-2",
						children: [
							/* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => void C("OPEN"),
								disabled: !y,
								className: "rounded-full border border-slate-200 px-3 py-2 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
								"data-testid": "workflow-action-open",
								children: "Open review"
							}),
							/* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => void C("APPROVE"),
								disabled: !b,
								className: "rounded-full bg-emerald-700 px-3 py-2 text-xs font-medium text-white transition hover:bg-emerald-800 disabled:cursor-not-allowed disabled:opacity-50",
								"data-testid": "workflow-action-approve",
								children: "Approve"
							}),
							/* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => void C("REJECT"),
								disabled: !b,
								className: "rounded-full border border-rose-200 bg-rose-50 px-3 py-2 text-xs font-medium text-rose-800 transition hover:bg-rose-100 disabled:cursor-not-allowed disabled:opacity-50",
								"data-testid": "workflow-action-reject",
								children: "Reject"
							}),
							/* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => void C("ESCALATE"),
								disabled: !b,
								className: "rounded-full border border-amber-200 bg-amber-50 px-3 py-2 text-xs font-medium text-amber-900 transition hover:bg-amber-100 disabled:cursor-not-allowed disabled:opacity-50",
								"data-testid": "workflow-action-escalate",
								children: "Escalate"
							})
						]
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-4 rounded-lg border border-slate-200 bg-slate-50 px-3 py-3",
						"data-testid": "workflow-audit-export",
						children: [/* @__PURE__ */ v("div", {
							className: "flex flex-wrap items-center justify-between gap-3",
							children: [/* @__PURE__ */ _("div", {
								className: "inline-flex rounded-lg border border-slate-200 bg-white p-0.5",
								children: ["json", "csv"].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => l(e),
									disabled: !x || u,
									className: `rounded-md px-3 py-1.5 text-xs font-medium uppercase transition ${c === e ? "bg-slate-900 text-white" : "text-slate-500 hover:text-slate-700"} disabled:cursor-not-allowed disabled:opacity-50`,
									"data-testid": `workflow-export-format-${e}`,
									children: e
								}, e))
							}), /* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => void w(),
								disabled: !x || u,
								className: "rounded-full border border-slate-200 bg-white px-3 py-2 text-xs font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-50",
								"data-testid": "workflow-export-download",
								children: u ? "Exporting..." : "Export audit"
							})]
						}), p ? /* @__PURE__ */ _("p", {
							className: "mt-2 text-xs text-rose-700",
							"data-testid": "workflow-export-error",
							children: p
						}) : null]
					})
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "min-h-0 flex-1 overflow-auto px-4 py-4",
				children: [/* @__PURE__ */ v("div", {
					className: "flex items-center justify-between gap-3",
					children: [/* @__PURE__ */ _("p", {
						className: "text-sm font-semibold text-slate-800",
						children: "Audit log"
					}), /* @__PURE__ */ _("span", {
						className: "rounded-full bg-slate-100 px-2.5 py-1 text-xs font-semibold text-slate-500",
						children: e.auditLog.length
					})]
				}), /* @__PURE__ */ v("ol", {
					className: "mt-3 grid gap-3",
					"data-testid": "workflow-audit-log",
					children: [e.auditLog.length === 0 ? /* @__PURE__ */ _("li", {
						className: "rounded-lg border border-dashed border-slate-200 px-3 py-4 text-sm text-slate-500",
						children: "No audit entries recorded yet."
					}) : null, e.auditLog.map((e) => /* @__PURE__ */ v("li", {
						className: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-3",
						children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center justify-between gap-2",
								children: [/* @__PURE__ */ _("span", {
									className: "text-sm font-semibold capitalize text-slate-900",
									children: ej(e.action)
								}), /* @__PURE__ */ _("span", {
									className: "text-xs text-slate-500",
									children: $A(e.timestamp)
								})]
							}),
							/* @__PURE__ */ v("p", {
								className: "mt-1 text-xs text-slate-500",
								children: [
									e.stepName,
									" by ",
									e.actorId
								]
							}),
							e.note ? /* @__PURE__ */ _("p", {
								className: "mt-2 text-sm leading-6 text-slate-700",
								children: e.note
							}) : null
						]
					}, e.id))]
				})]
			})
		]
	}) : /* @__PURE__ */ _("aside", {
		className: "flex min-h-[22rem] flex-col justify-center rounded-[1.2rem] border border-dashed border-slate-200 bg-white px-5 py-6 text-sm text-slate-500",
		"data-testid": "workflow-step-action-panel",
		children: "Select a run from the queue to review its current step and audit log."
	});
}
//#endregion
//#region src/panels/GovernancePanel/workflows/WorkflowReviewWorkspace.tsx
function oj(e) {
	return e.replace(/_/g, " ").toLowerCase();
}
function sj({ workspaceId: e, actorId: t = "observatory-steward" }) {
	let [n, r] = h([]), [i, a] = h([]), [o, c] = h("ALL"), [l, d] = h(null), [p, m] = h(null), [g, y] = h(!0), [b, x] = h(!1), [S, C] = h(!1), [w, T] = h(null), [E, D] = h(null), [O, k] = h(null), A = s(async () => {
		y(!0), D(null);
		try {
			let [t, n] = await Promise.all([oi.listWorkflowTemplates(e), oi.listWorkflowRuns(e, o === "ALL" ? void 0 : o)]);
			r(t), a(n), d((e) => e && n.some((t) => t.id === e) ? e : n[0]?.id ?? null);
		} catch (e) {
			D(e instanceof Error ? e.message : "Unable to load workflow state.");
		} finally {
			y(!1);
		}
	}, [o, e]);
	u(() => {
		A();
	}, [A]);
	let j = f(() => i.find((e) => e.id === l) ?? null, [i, l]);
	return /* @__PURE__ */ v("div", {
		className: "grid min-h-0 flex-1 gap-4 xl:grid-cols-[22rem_minmax(0,1fr)_24rem]",
		"data-testid": "workflow-review-workspace",
		children: [
			/* @__PURE__ */ v("div", {
				className: "flex min-h-0 flex-col gap-4 overflow-auto",
				children: [/* @__PURE__ */ _(HA, {
					template: p,
					saving: b,
					onSave: async (t) => {
						x(!0), D(null);
						try {
							k(`${(await oi.saveWorkflowTemplate(e, t)).name} saved.`), m(null), await A();
						} catch (e) {
							D(e instanceof Error ? e.message : "Unable to save workflow template.");
						} finally {
							x(!1);
						}
					},
					onCancel: p ? () => m(null) : void 0
				}), /* @__PURE__ */ v("section", {
					className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-4",
					children: [/* @__PURE__ */ _("div", {
						className: "flex items-center justify-between gap-3",
						children: /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("p", {
							className: "text-xs font-semibold uppercase tracking-[0.2em] text-slate-400",
							children: "Templates"
						}), /* @__PURE__ */ v("p", {
							className: "mt-1 text-sm text-slate-600",
							children: [n.length, " active"]
						})] })
					}), /* @__PURE__ */ v("div", {
						className: "mt-3 grid gap-2",
						"data-testid": "workflow-template-list",
						children: [n.length === 0 ? /* @__PURE__ */ _("div", {
							className: "rounded-lg border border-dashed border-slate-200 px-3 py-4 text-sm text-slate-500",
							children: "No workflow templates yet."
						}) : null, n.map((e) => /* @__PURE__ */ v("button", {
							type: "button",
							onClick: () => m(e),
							className: "rounded-lg border border-slate-200 px-3 py-3 text-left transition hover:border-slate-300 hover:bg-slate-50",
							"data-testid": `workflow-edit-template-${e.id}`,
							children: [/* @__PURE__ */ _("span", {
								className: "block text-sm font-semibold text-slate-900",
								children: e.name
							}), /* @__PURE__ */ v("span", {
								className: "mt-1 block text-xs text-slate-500",
								children: [
									e.steps.length,
									" ",
									e.steps.length === 1 ? "step" : "steps"
								]
							})]
						}, e.id))]
					})]
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "flex min-h-0 flex-col gap-3",
				children: [
					O ? /* @__PURE__ */ _("div", {
						className: "rounded-[1rem] border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm text-emerald-800",
						children: O
					}) : null,
					E ? /* @__PURE__ */ _("div", {
						className: "rounded-[1rem] border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-800",
						children: E
					}) : null,
					/* @__PURE__ */ _(ZA, {
						templates: n,
						runs: i,
						statusFilter: o,
						selectedRunId: l,
						loading: g,
						triggering: S,
						actorId: t,
						onStatusFilterChange: c,
						onSelectRun: (e) => d(e.id),
						onRefresh: () => void A(),
						onTriggerRun: async (t) => {
							C(!0), D(null);
							try {
								let n = await oi.triggerWorkflowRun(e, t);
								k(`Run ${n.id.slice(0, 8)} triggered.`), d(n.id), await A();
							} catch (e) {
								D(e instanceof Error ? e.message : "Unable to trigger workflow run.");
							} finally {
								C(!1);
							}
						}
					})
				]
			}),
			/* @__PURE__ */ _(aj, {
				run: j,
				workspaceId: e,
				actorId: t,
				canAct: !!t,
				transitioning: w === j?.id,
				onTransition: async (n, r, i) => {
					T(n), D(null);
					try {
						let a = await oi.transitionWorkflowRun(e, n, r, t, i);
						k(`Run ${a.id.slice(0, 8)} is ${oj(a.status)}.`), d(a.id), await A();
					} catch (e) {
						D(e instanceof Error ? e.message : "Unable to update workflow run.");
					} finally {
						T(null);
					}
				}
			})
		]
	});
}
//#endregion
//#region src/demo/fixtures/nasdaqDemoDataset.ts
var cj = [
	{
		symbol: "NVDA",
		company: "NVIDIA Corp.",
		basePrice: 875.28,
		dailySwing: 7.4,
		baseVolume: 4123e4,
		marketCap: 215e10,
		sector: "Semiconductors"
	},
	{
		symbol: "MSFT",
		company: "Microsoft Corp.",
		basePrice: 427.61,
		dailySwing: 3.1,
		baseVolume: 2389e4,
		marketCap: 318e10,
		sector: "Software"
	},
	{
		symbol: "AAPL",
		company: "Apple Inc.",
		basePrice: 189.35,
		dailySwing: 2.2,
		baseVolume: 5298e4,
		marketCap: 292e10,
		sector: "Devices"
	},
	{
		symbol: "AMZN",
		company: "Amazon.com Inc.",
		basePrice: 183.44,
		dailySwing: 2.8,
		baseVolume: 3557e4,
		marketCap: 19e11,
		sector: "Consumer Internet"
	},
	{
		symbol: "META",
		company: "Meta Platforms Inc.",
		basePrice: 511.9,
		dailySwing: 4.6,
		baseVolume: 1643e4,
		marketCap: 13e11,
		sector: "Digital Ads"
	},
	{
		symbol: "TSLA",
		company: "Tesla Inc.",
		basePrice: 171.22,
		dailySwing: 5.9,
		baseVolume: 8841e4,
		marketCap: 545e9,
		sector: "EV"
	},
	{
		symbol: "AVGO",
		company: "Broadcom Inc.",
		basePrice: 1328.72,
		dailySwing: 11.2,
		baseVolume: 319e4,
		marketCap: 618e9,
		sector: "Semiconductors"
	},
	{
		symbol: "ADBE",
		company: "Adobe Inc.",
		basePrice: 487.11,
		dailySwing: 3.7,
		baseVolume: 287e4,
		marketCap: 22e10,
		sector: "Creative Software"
	},
	{
		symbol: "COST",
		company: "Costco Wholesale",
		basePrice: 733.81,
		dailySwing: 4.1,
		baseVolume: 204e4,
		marketCap: 325e9,
		sector: "Retail"
	},
	{
		symbol: "AMD",
		company: "Advanced Micro Devices",
		basePrice: 164.29,
		dailySwing: 3.9,
		baseVolume: 4932e4,
		marketCap: 266e9,
		sector: "Semiconductors"
	}
];
function lj(e) {
	return Number(e.toFixed(2));
}
function uj(e) {
	let t = new Date(Date.UTC(2026, 2, 30)), n = new Date(t), r = 0;
	for (; r < e;) {
		n.setUTCDate(n.getUTCDate() + 1);
		let e = n.getUTCDay();
		e !== 0 && e !== 6 && (r += 1);
	}
	return n.toISOString().slice(0, 10);
}
function dj(e, t) {
	return t === "FAIL" ? "risk" : t === "WARN" ? "watch" : e > 1.35 ? "breakout" : Math.abs(e) < .25 ? "hold" : "watch";
}
function fj(e, t) {
	return e === 0 && t === 11 || e === 4 && t === 18 || e === 7 && t === 24 ? "FAIL" : e === 0 && t === 5 || e === 2 && t === 7 || e === 5 && t === 12 || e === 9 && t === 26 ? "WARN" : "PASS";
}
function pj(e, t = 0, n = 18) {
	let r = Number.isFinite(e.last) ? e.last : 1, i = Math.max(Math.abs(e.change) * .75, r * .0028, .35), a = e.rowid * .37;
	return Array.from({ length: n }, (e, o) => {
		let s = t - n + o + 1, c = Math.sin((s + 1) * .52 + a) * i, l = Math.cos((s + 3) * .23 + a * .7) * i * .38;
		return lj(Math.max(.01, r + c + l));
	});
}
var mj = cj.flatMap((e, t) => Array.from({ length: 30 }, (n, r) => {
	let i = t * 30 + r + 1, a = Math.sin((r + 1) * (t + 2) * .31) * e.dailySwing, o = lj(e.basePrice + a - e.dailySwing * .18), s = lj(o + Math.cos(r + t) * e.dailySwing * .28), c = lj(e.basePrice + a), l = lj(Math.max(s, c) + e.dailySwing * (.55 + r % 4 * .07)), u = lj(Math.min(s, c) - e.dailySwing * (.42 + r % 3 * .05)), d = fj(t, r), f = d === "FAIL" ? null : c, p = f ?? o, m = lj(p - o), h = Number((m / o * 100).toFixed(2)), g = d === "WARN" ? 2 + t % 2 : 0, _ = d === "WARN" ? 1.65 : d === "FAIL" ? 8.5 : 1, v = Math.round((e.baseVolume + r * 94e3 + t * 21e3) * _);
	return {
		rowid: i,
		symbol: e.symbol,
		company: e.company,
		trade_date: uj(r),
		open: s,
		high: d === "FAIL" && t === 7 ? lj(l * 1.9) : l,
		low: u,
		close: f,
		last: p,
		live_quote: pj({
			rowid: i,
			last: p,
			change: m
		}, 0),
		change: m,
		change_pct: h,
		volume: v,
		market_cap: e.marketCap + r * 125e7,
		sector: e.sector,
		signal: dj(h, d),
		quality_flag: d,
		freshness_lag_days: g,
		data_source: "nasdaq-daily-close-etl",
		trend: m > 0 ? "up" : m < 0 ? "down" : "flat"
	};
})), hj = [
	"North America",
	"EMEA",
	"APAC",
	"LATAM"
], gj = [
	"Ada",
	"Ben",
	"Carla",
	"Diego",
	"Evelyn",
	"Farah"
], _j = [
	"stable",
	"watch",
	"at-risk"
], vj = [
	"Strategic",
	"Enterprise",
	"Mid-market",
	"SMB"
], yj = [
	"clear",
	"delayed",
	"replaying"
], bj = [
	"processing",
	"ready",
	"shipped",
	"complete"
], xj = [
	"queued",
	"picked",
	"packed",
	"shipped"
], Sj = [
	"type",
	"object",
	"location",
	"quality",
	"owner",
	"signals",
	"actions"
], Cj = [
	"symbol",
	"live_quote",
	"company",
	"open",
	"high",
	"low",
	"close",
	"last",
	"change",
	"change_pct",
	"volume",
	"market_cap",
	"sector",
	"signal",
	"quality_flag",
	"freshness_lag_days",
	"data_source",
	"trade_date"
], wj = [
	{
		type: "source",
		object: "Hospital OMOP Warehouse",
		objectDetail: "7 objects across 3 schemas",
		location: "omop-hospital-a",
		locationDetail: "Catalog source",
		quality: "6 passing, 1 failing",
		qualityStatus: "not_run",
		owner: "Clinical Platform",
		ownerDetail: "Source ownership",
		signals: [
			{
				label: "Clinical",
				tone: "taxonomy"
			},
			{
				label: "OMOP",
				tone: "taxonomy"
			},
			{
				label: "Mixed",
				tone: "trust"
			}
		],
		actions: "Inspect",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !0
	},
	{
		type: "table",
		object: "cardiology_patients",
		objectDetail: "Patient cohort selected for the Working Set.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "clinical / clinical.cardiology_patients",
		quality: "PASS 96",
		qualityStatus: "pass",
		owner: "Cardiology Analytics",
		ownerDetail: "Steward: Data Quality",
		signals: [
			{
				label: "Clinical",
				tone: "taxonomy"
			},
			{
				label: "High trust",
				tone: "trust"
			},
			{
				label: "Certified",
				tone: "certification"
			}
		],
		actions: "Added",
		focusAction: "Focused",
		isActive: !0,
		isSelected: !0,
		isSource: !1
	},
	{
		type: "table",
		object: "encounter_summary",
		objectDetail: "Visit-level context used by the same cardiology review.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "clinical / clinical.encounter_summary",
		quality: "PASS 92",
		qualityStatus: "pass",
		owner: "Care Delivery",
		ownerDetail: "Steward: Clinical Ops",
		signals: [{
			label: "Operations",
			tone: "taxonomy"
		}, {
			label: "Owner assigned",
			tone: "trust"
		}],
		actions: "Added",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !0,
		isSource: !1
	},
	{
		type: "view",
		object: "v_readmission_risk",
		objectDetail: "Derived risk view for downstream triage work.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "analytics / analytics.v_readmission_risk",
		quality: "PASS 88",
		qualityStatus: "pass",
		owner: "Population Health",
		ownerDetail: "Steward: Analytics",
		signals: [{
			label: "Risk",
			tone: "taxonomy"
		}, {
			label: "Fresh metadata",
			tone: "trust"
		}],
		actions: "Added",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !0,
		isSource: !1
	},
	{
		type: "report",
		object: "Cardiology Outcomes Brief",
		objectDetail: "Published report attached to the saved context.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "reports / board.cardiology_outcomes",
		quality: "Not run",
		qualityStatus: "not_run",
		owner: "Medical Board",
		ownerDetail: "Steward: Governance",
		signals: [{
			label: "Report",
			tone: "taxonomy"
		}, {
			label: "Board-ready",
			tone: "certification"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "table",
		object: "lab_results",
		objectDetail: "Lab values linked to the selected patient cohort.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "clinical / clinical.lab_results",
		quality: "FAIL 71",
		qualityStatus: "fail",
		owner: "Lab Informatics",
		ownerDetail: "Steward: Data Quality",
		signals: [{
			label: "Labs",
			tone: "taxonomy"
		}, {
			label: "Needs review",
			tone: "sensitivity"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "source",
		object: "Finance Lakehouse",
		objectDetail: "4 objects across 2 schemas",
		location: "lakehouse-finance",
		locationDetail: "Catalog source",
		quality: "4 passing",
		qualityStatus: "not_run",
		owner: "Revenue Ops",
		ownerDetail: "Source ownership",
		signals: [{
			label: "Finance",
			tone: "taxonomy"
		}, {
			label: "Certified",
			tone: "certification"
		}],
		actions: "Inspect",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !0
	},
	{
		type: "table",
		object: "claims_rollup",
		objectDetail: "Claim groupings that can be added to the context.",
		location: "Finance Lakehouse",
		locationDetail: "claims / claims.claims_rollup",
		quality: "PASS 90",
		qualityStatus: "pass",
		owner: "Revenue Cycle",
		ownerDetail: "Steward: Finance Analytics",
		signals: [{
			label: "Claims",
			tone: "taxonomy"
		}, {
			label: "High trust",
			tone: "trust"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "view",
		object: "v_cost_of_care",
		objectDetail: "Operational cost view for cohort-level enrichment.",
		location: "Finance Lakehouse",
		locationDetail: "finance / finance.v_cost_of_care",
		quality: "PASS 86",
		qualityStatus: "pass",
		owner: "Finance Analytics",
		ownerDetail: "Steward: Revenue Ops",
		signals: [{
			label: "Finance",
			tone: "taxonomy"
		}, {
			label: "Owner assigned",
			tone: "trust"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "table",
		object: "medication_orders",
		objectDetail: "Medication orders available for context expansion.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "clinical / clinical.medication_orders",
		quality: "PASS 84",
		qualityStatus: "pass",
		owner: "Pharmacy Informatics",
		ownerDetail: "Steward: Clinical Ops",
		signals: [{
			label: "Medication",
			tone: "taxonomy"
		}, {
			label: "Restricted",
			tone: "sensitivity"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "report",
		object: "Care Pathway Variance",
		objectDetail: "Variance brief that compares current cohort pathways.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "reports / board.care_pathway_variance",
		quality: "Not run",
		qualityStatus: "not_run",
		owner: "Clinical Governance",
		ownerDetail: "Steward: Medical Board",
		signals: [{
			label: "Report",
			tone: "taxonomy"
		}, {
			label: "Unverified",
			tone: "trust"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	},
	{
		type: "table",
		object: "provider_roster",
		objectDetail: "Provider metadata that can explain cohort ownership.",
		location: "Hospital OMOP Warehouse",
		locationDetail: "reference / reference.provider_roster",
		quality: "PASS 93",
		qualityStatus: "pass",
		owner: "Provider Ops",
		ownerDetail: "Steward: Reference Data",
		signals: [{
			label: "Reference",
			tone: "taxonomy"
		}, {
			label: "Fresh metadata",
			tone: "trust"
		}],
		actions: "Add",
		focusAction: "Focus",
		isActive: !1,
		isSelected: !1,
		isSource: !1
	}
];
function Tj(e, t) {
	if (e == null && t == null) return 0;
	if (e == null) return -1;
	if (t == null) return 1;
	if (typeof e == "number" && typeof t == "number") return e - t;
	let n = Date.parse(String(e)), r = Date.parse(String(t));
	return !Number.isNaN(n) && !Number.isNaN(r) ? n - r : String(e).localeCompare(String(t), void 0, {
		numeric: !0,
		sensitivity: "base"
	});
}
function Ej(e) {
	return !!(e && typeof e == "object" && !Array.isArray(e) && ("min" in e || "max" in e));
}
function Dj(e, t) {
	if (!t || Object.keys(t).length === 0) return e;
	let n = Object.entries(t).filter(([e]) => e !== "__sampling");
	return n.length === 0 ? e : e.filter((e) => n.every(([t, n]) => {
		let r = e[t];
		if (Array.isArray(n)) return n.length === 0 ? !0 : n.map(String).includes(String(r));
		if (Ej(n)) {
			let e = typeof r == "number" ? r : Number(r);
			if (!Number.isFinite(e)) return !1;
			let t = n.min == null || n.min === "" ? -Infinity : Number(n.min), i = n.max == null || n.max === "" ? Infinity : Number(n.max);
			return e >= t && e <= i;
		}
		return n == null || n === "" ? !0 : String(r ?? "").toLowerCase().includes(String(n).toLowerCase());
	}));
}
function Oj(e, t = 100) {
	let n = typeof e == "number" ? e : Number(e);
	return Number.isFinite(n) ? Math.max(1, Math.min(100, Math.round(n))) : t;
}
function kj(e, t) {
	if (e === 0) return 0;
	let n = Oj(t?.samplePercentage, 100), r = n >= 100 ? e : Math.max(1, Math.floor(e * n / 100));
	return typeof t?.maxRows == "number" && Number.isFinite(t.maxRows) ? Math.max(0, Math.min(e, Math.floor(t.maxRows))) : typeof t?.maxSampleSize == "number" && Number.isFinite(t.maxSampleSize) ? Math.max(0, Math.min(e, Math.floor(t.maxSampleSize), r)) : r;
}
function Aj(e) {
	let t = String(e ?? "widget-showcase"), n = 2166136261;
	for (let e = 0; e < t.length; e += 1) n ^= t.charCodeAt(e), n = Math.imul(n, 16777619);
	return n >>> 0;
}
function jj(e) {
	let t = e >>> 0;
	return () => {
		t += 1831565813;
		let e = t;
		return e = Math.imul(e ^ e >>> 15, e | 1), e ^= e + Math.imul(e ^ e >>> 7, e | 61), ((e ^ e >>> 14) >>> 0) / 4294967296;
	};
}
function Mj(e, t) {
	let n = jj(Aj(t)), r = [...e];
	for (let e = r.length - 1; e > 0; --e) {
		let t = Math.floor(n() * (e + 1));
		[r[e], r[t]] = [r[t], r[e]];
	}
	return r;
}
function Nj(e) {
	return String(e?.sampleStrategy ?? e?.method ?? (e?.randomSample ? "random" : "first-n"));
}
function Pj(e, t, n, r) {
	let i = /* @__PURE__ */ new Map();
	return e.forEach((e) => {
		let n = String(e[t] ?? "(empty)");
		i.set(n, [...i.get(n) ?? [], e]);
	}), Array.from(i.values()).flatMap((e) => {
		let i = n >= 100 ? e.length : Math.max(1, Math.floor(e.length * n / 100));
		return Mj(e, `${r}:${t}:${String(e[0]?.[t])}`).slice(0, i);
	});
}
function Fj(e, t) {
	let n = Nj(t), r = kj(e.length, t), i = Oj(t?.samplePercentage, 100), a = t?.seed ?? t?.randomSeed ?? n;
	if (r >= e.length) return {
		rows: e,
		metadata: {
			totalRows: e.length,
			sampledRows: e.length,
			samplingPercentage: e.length === 0 ? 0 : 100,
			samplePercentage: e.length === 0 ? 0 : 100,
			method: n,
			parameters: t ?? {}
		}
	};
	let o = (() => {
		if (n === "last-n") return e.slice(Math.max(0, e.length - r));
		if (n === "systematic") {
			let t = e.length / r;
			return Array.from({ length: r }, (n, r) => e[Math.floor(r * t)]).filter((e) => !!e);
		}
		return (n === "stratified" || n === "weighted" || n === "cluster") && t?.stratifyColumn ? Pj(e, t.stratifyColumn, i, a).slice(0, r) : n === "random" ? Mj(e, a).slice(0, r) : e.slice(0, r);
	})();
	return {
		rows: o,
		metadata: {
			totalRows: e.length,
			sampledRows: o.length,
			samplingPercentage: e.length === 0 ? 0 : o.length / e.length * 100,
			samplePercentage: e.length === 0 ? 0 : o.length / e.length * 100,
			method: n,
			parameters: t ?? {}
		}
	};
}
function Ij(e, t) {
	let n = t?.sortOptions?.length ? t.sortOptions : t?.sortBy ? [{
		column: t.sortBy,
		direction: (t.order ?? "asc").toUpperCase()
	}] : [];
	return n.length === 0 ? e : [...e].sort((e, t) => {
		for (let r of n) {
			let n = r.direction.toUpperCase() === "DESC" ? -1 : 1, i = Tj(e[r.column], t[r.column]);
			if (i !== 0) return i * n;
		}
		return 0;
	});
}
function Lj(e, t, n) {
	let r = typeof n == "number" && n >= 0 ? n : 0, i = typeof t == "number" && t > 0 ? t : e.length;
	return e.slice(r, r + i);
}
function Rj(e, t) {
	let n = Array.from(e.reduce((e, t) => (Object.keys(t).forEach((t) => e.add(t)), e), /* @__PURE__ */ new Set()));
	return n.length > 0 ? n : t ?? [];
}
function zj(e, t, n) {
	return {
		...n ?? {},
		totalRows: t,
		sampledRows: typeof n?.sampledRows == "number" ? n.sampledRows : t,
		samplePercentage: typeof n?.samplePercentage == "number" ? n.samplePercentage : 100,
		tableName: e
	};
}
function Bj(e) {
	return Number(e.toFixed(2));
}
function Vj(e, t, n, r) {
	let i = t.map((t) => {
		let n = e.filter((e) => e[t] == null || e[t] === "").length;
		return {
			name: t,
			missingCount: n,
			totalCount: e.length,
			missingPercentage: e.length === 0 ? 0 : n / e.length * 100
		};
	});
	return {
		status: "success",
		columns: i,
		data: { columns: i },
		metadata: zj(n, e.length, r)
	};
}
function Hj(e, t) {
	return Object.fromEntries(t.map((t) => [t, Ab(t, e)]));
}
function Uj(e, t, n, r) {
	let i = n ?? t[0], a = Ab(i, e), o = e.map((e) => e[i]).filter((e) => e != null && e !== ""), s = {
		...r ?? {},
		totalRows: typeof r?.totalRows == "number" ? r.totalRows : e.length,
		samplePercentage: typeof r?.samplePercentage == "number" ? r.samplePercentage : 100
	};
	if (a === "numerical") {
		let t = o.map((e) => Number(e)).filter((e) => Number.isFinite(e)), n = [...t].sort((e, t) => e - t), r = t.reduce((e, t) => e + t, 0), i = t.length > 0 ? r / t.length : 0, a = t.length > 0 ? t.reduce((e, t) => e + (t - i) ** 2, 0) / t.length : 0, c = Math.floor(n.length / 2), l = n.length === 0 ? 0 : n.length % 2 == 0 ? (n[c - 1] + n[c]) / 2 : n[c];
		return {
			type: "numeric",
			columnType: "REAL",
			totalValues: e.length,
			nonNullValues: t.length,
			nullCount: e.length - t.length,
			nullPercentage: e.length === 0 ? "0" : ((e.length - t.length) / e.length * 100).toFixed(2),
			mean: i,
			median: l,
			min: n[0] ?? 0,
			max: n[n.length - 1] ?? 0,
			range: n.length > 0 ? (n[n.length - 1] ?? 0) - (n[0] ?? 0) : 0,
			stddev: Math.sqrt(a),
			histogram: GC(t),
			metadata: s
		};
	}
	if (a === "date") {
		let t = o.map((e) => new Date(String(e))).filter((e) => !Number.isNaN(e.getTime())).sort((e, t) => e.getTime() - t.getTime()), n = /* @__PURE__ */ new Map();
		return t.forEach((e) => {
			let t = e.toLocaleString("en-US", {
				month: "short",
				year: "2-digit"
			});
			n.set(t, (n.get(t) ?? 0) + 1);
		}), {
			type: "date",
			columnType: "TEXT",
			totalValues: e.length,
			nonNullValues: t.length,
			nullCount: e.length - t.length,
			nullPercentage: e.length === 0 ? "0" : ((e.length - t.length) / e.length * 100).toFixed(2),
			minDate: t[0]?.toISOString() ?? null,
			maxDate: t[t.length - 1]?.toISOString() ?? null,
			distribution: {
				labels: [...n.keys()],
				counts: [...n.values()]
			},
			metadata: s
		};
	}
	let c = o.reduce((e, t) => {
		let n = String(t);
		return e[n] = (e[n] ?? 0) + 1, e;
	}, {});
	return {
		type: "categorical",
		columnType: "TEXT",
		totalValues: e.length,
		nonNullValues: o.length,
		nullCount: e.length - o.length,
		nullPercentage: e.length === 0 ? "0" : ((e.length - o.length) / e.length * 100).toFixed(2),
		categories: c,
		metadata: s
	};
}
function Wj(e, t) {
	return t <= 0 ? 100 : Math.max(0, Math.round(100 - e / t * 100));
}
function Gj({ validationKey: e, rows: t, columns: n, tableName: r, columnName: i, metadata: a }) {
	let o = i && n.includes(i) ? i : n[0], s = Vj(t, n, r, a), c = Hj(t, n), l = o ? t.map((e) => e[o]).filter((e) => e != null && e !== "") : [], u = s.columns.filter((e) => e.missingCount > 0), d = t.length - new Set(t.map((e) => String(e.rowid))).size, f = n.filter((e) => /name|email|phone|birth|address|zip|ssn|patient/i.test(e)), p = l.map((e) => Number(e)).filter((e) => Number.isFinite(e)), m = p.length > 0 ? p.reduce((e, t) => e + t, 0) / p.length : 0, h = p.length > 0 ? p.reduce((e, t) => e + (t - m) ** 2, 0) / p.length : 0, g = Math.sqrt(h), _ = g > 0 ? p.filter((e) => Math.abs(e - m) / g > 3) : [], v = (e = {}) => ({
		status: "pass",
		passed: !0,
		overallScore: 100,
		issuesFound: 0,
		runAt: (/* @__PURE__ */ new Date()).toISOString(),
		metadata: a,
		...e
	}), y = (e, r = {}) => ({
		status: "fail",
		passed: !1,
		overallScore: Wj(e, Math.max(t.length, n.length, 1)),
		issuesFound: e,
		runAt: (/* @__PURE__ */ new Date()).toISOString(),
		metadata: a,
		...r
	});
	switch (e) {
		case "completeness": {
			let e = u.reduce((e, t) => e + t.missingCount, 0);
			return e > 0 ? y(e, {
				columns: s.columns,
				summary: {
					totalRows: t.length,
					columnsWithIssues: u.length,
					totalIssues: e
				}
			}) : v({
				columns: s.columns,
				summary: { totalRows: t.length }
			});
		}
		case "nullCheck": {
			let e = s.columns.find((e) => e.name === o), t = e?.missingCount ?? 0;
			return t > 0 ? y(t, {
				columnName: o,
				columns: e ? [e] : []
			}) : v({
				columnName: o,
				columns: e ? [e] : []
			});
		}
		case "typeInferenceTable": return v({
			inferredTypes: c,
			columns: Object.keys(c).length
		});
		case "typeInferenceColumn": return v({
			columnName: o,
			inferredType: o ? c[o] : "unknown",
			sampleSize: l.length
		});
		case "dataQuality": {
			let e = u.length + d;
			return e > 0 ? y(e, { summary: {
				columnsWithIssues: u.length,
				duplicateRows: d,
				totalRows: t.length
			} }) : v({ summary: {
				totalRows: t.length,
				duplicateRows: 0
			} });
		}
		case "patterns": {
			let e = o && /date|time|timestamp/i.test(o) ? l.filter((e) => Number.isNaN(Date.parse(String(e)))) : [];
			return e.length > 0 ? y(e.length, {
				columnName: o,
				failures: e.slice(0, 10)
			}) : v({
				columnName: o,
				checkedPattern: "local inferred pattern"
			});
		}
		case "constraints": return d > 0 ? y(d, { duplicateRows: d }) : v({
			duplicateRows: 0,
			checkedConstraint: "rowid uniqueness"
		});
		case "tableStructure": return t.length > 0 && n.length > 0 ? v({
			rowCount: t.length,
			columnCount: n.length
		}) : y(1, {
			missingColumns: n.length === 0 ? ["columns"] : [],
			rowCount: t.length
		});
		case "anomalyDetection": return _.length > 0 ? y(_.length, {
			columnName: o,
			anomalies: _.slice(0, 20)
		}) : v({
			columnName: o,
			anomalies: []
		});
		case "phiDetection":
		case "quasiIdentifiers":
		case "reidentificationRisk": return f.length > 0 ? y(f.length, { findings: f.map((e) => ({
			column: e,
			reason: "Sensitive-looking column name"
		})) }) : v({ findings: [] });
		case "dataMasking": return f.includes(String(o)) ? y(1, {
			columnName: o,
			issues: [`${o} may need masking`]
		}) : v({ columnName: o });
		case "populationAnalysis":
		case "domainMetrics": return v({ summary: {
			totalRows: t.length,
			totalColumns: n.length,
			numericColumns: Object.values(c).filter((e) => e === "numerical").length,
			categoricalColumns: Object.values(c).filter((e) => e === "categorical").length
		} });
		case "temporalTrends": {
			let e = Object.entries(c).filter(([, e]) => e === "date").map(([e]) => e);
			return e.length > 0 ? v({ dateColumns: e }) : y(1, { missingColumns: ["date-like column"] });
		}
		default: return v({ summary: {
			checked: "local JSON rowset",
			totalRows: t.length,
			totalColumns: n.length
		} });
	}
}
function Kj(e) {
	return new Promise((t) => {
		window.setTimeout(t, e);
	});
}
function qj(e, t, n) {
	return typeof e == "function" ? e(t, n) : e ?? 0;
}
function Jj({ tables: e, databaseLabel: t, delayMs: n }) {
	let r = (t) => e[t]?.rows ?? [], i = (t) => e[t]?.columns ?? Rj(r(t)), a = (e, t) => {
		let n = r(e), i = Dj(n, t?.filters), a = Fj(i, t), o = {
			...a.metadata,
			sourceRowCount: n.length,
			filteredRows: i.length,
			totalRows: a.rows.length,
			sampledRows: a.rows.length,
			samplePercentage: a.metadata.samplePercentage
		};
		return {
			sourceRows: n,
			filteredRows: i,
			rows: a.rows,
			metadata: o
		};
	};
	return {
		async fetchTables() {
			return {
				status: "success",
				data: {
					tables: Object.keys(e),
					total: Object.keys(e).length
				}
			};
		},
		async fetchTableData(e, t, r) {
			let o = qj(n, t, r);
			o > 0 && await Kj(o);
			let s = a(t, r), c = Ij(s.rows, r), l = Lj(c, r?.limit, r?.offset);
			return {
				status: "success",
				data: {
					rows: l,
					columns: i(t),
					total: c.length,
					metadata: {
						...s.metadata,
						pageRows: l.length,
						appliedLimit: r?.limit ?? l.length,
						offset: r?.offset ?? 0
					}
				}
			};
		},
		async fetchTableColumns(e, t) {
			return i(t);
		},
		async fetchUniqueColumnValues(e, t, n, i) {
			let a = r(t), o = i?.toLowerCase().trim();
			return Array.from(new Set(a.map((e) => e[n]).filter((e) => e != null).map(String).filter((e) => o ? e.toLowerCase().includes(o) : !0))).slice(0, 50);
		},
		async fetchRecord(e, t, n) {
			return r(t).find((e) => String(e.rowid) === String(n)) ?? null;
		},
		async updateRecord() {
			return {
				status: "success",
				data: { changes: 1 }
			};
		},
		async createRecord() {
			return {
				status: "success",
				data: { lastID: Date.now() }
			};
		},
		async deleteRecord() {},
		async bulkDeleteRecords() {},
		async fetchColumnStats(e, t, n, r) {
			let o = a(t, r), s = i(t);
			return Uj(o.rows, s, n, o.metadata);
		},
		async fetchMissingData(e, t, n) {
			let r = a(t, n), o = i(t);
			return Vj(r.rows, o, t, r.metadata);
		},
		async fetchDatabaseInfo() {
			return { data: { original_file_name: t } };
		},
		async fetchSamplingMethods() {
			return [
				"first-n",
				"last-n",
				"random",
				"systematic",
				"stratified"
			];
		},
		async applySampling(e, t, n) {
			let i = Fj(Dj(r(t), n.filters), {
				...n,
				sampleStrategy: n.method
			});
			return {
				rows: i.rows,
				metadata: {
					...i.metadata,
					executionTimeMs: 8,
					method: n.method,
					parameters: n
				}
			};
		},
		async fetchColumnTypes(e, t) {
			return Hj(r(t), i(t));
		},
		async fetchTableRowCount(e, t, n) {
			return Dj(r(t), n).length;
		},
		async runQualityCheck(e, t, n, r) {
			let o = a(t, r), s = i(t);
			return Gj({
				validationKey: n,
				rows: o.rows,
				columns: s,
				tableName: t,
				columnName: r?.columnName,
				metadata: {
					...o.metadata,
					scopeType: r?.scopeType ?? (r?.columnName ? "column" : "table"),
					rowsetKey: r?.rowsetKey
				}
			});
		}
	};
}
function Yj(e, t) {
	return Array.from({ length: e }, (e, n) => {
		let r = hj[n % hj.length], i = gj[n % gj.length], a = vj[n % vj.length], o = _j[n % _j.length], s = yj[n % yj.length], c = new Date(Date.UTC(2026, n * 2 % 12, n % 27 + 1)), l = {
			rowid: n + 1,
			account_name: `${a} ${r} Account ${n + 1}`,
			segment: a,
			owner: i,
			region: r,
			status: o === "stable" ? "healthy" : o === "watch" ? "watch" : "risk",
			health_score: 92 - n % 17 * 2,
			monthly_mrr: 4800 + n * 145,
			renewal_date: c.toISOString(),
			open_tickets: n % 5,
			notes: `Long-form implementation note ${n + 1}: this row keeps enough descriptive text to trigger cell truncation, tooltips, and column resizing behavior in the showcase surface.`
		};
		return t !== "focused" && (l.onboarding_stage = [
			"pilot",
			"rollout",
			"adoption"
		][n % 3], l.pipeline_status = s, l.last_qbr_at = new Date(Date.UTC(2026, (n + 5) % 12, (n + 7) % 27 + 1)).toISOString(), l.integrations = [
			"Snowflake",
			"dbt",
			"Salesforce"
		][n % 3], l.exec_sponsor = `Sponsor ${String.fromCharCode(65 + n % 5)}`), t === "audit" && (l.policy_tier = [
			"standard",
			"restricted",
			"critical"
		][n % 3], l.pii_level = [
			"low",
			"medium",
			"high"
		][n % 3], l.sync_lag_minutes = 4 + n % 9 * 3, l.audit_flag = [
			"clear",
			"review",
			"hold"
		][n % 3], l.runbook_owner = `${i} Ops`), l;
	});
}
function Xj(e, t) {
	return Array.from({ length: e }, (e, n) => {
		let r = hj[n % hj.length], i = gj[n % gj.length], a = bj[n % bj.length], o = new Date(Date.UTC(2026, (n + 2) % 12, n % 27 + 1)), s = {
			rowid: n + 1,
			order_id: `ORD-${String(n + 1).padStart(4, "0")}`,
			account_name: `${vj[n % vj.length]} ${r} Account ${n + 1}`,
			order_status: a,
			owner: i,
			region: r,
			gross_amount: 1250 + n * 87,
			margin_pct: 42 - n % 6 * 3,
			booked_at: o.toISOString(),
			fulfillment_eta: new Date(Date.UTC(2026, (n + 2) % 12, (n + 4) % 27 + 1)).toISOString(),
			shipment_note: `Shipment note ${n + 1}: combined order, warehouse split, and packaging detail to pressure-test long text wrapping.`
		};
		return t !== "focused" && (s.invoice_count = 1 + n % 4, s.pipeline_status = yj[n % yj.length], s.customer_health = _j[n % _j.length], s.payment_terms = [
			"Net 15",
			"Net 30",
			"Prepaid"
		][n % 3], s.fulfillment_lane = [
			"Direct",
			"Distributor",
			"Managed"
		][n % 3]), t === "audit" && (s.audit_flag = [
			"clear",
			"review",
			"hold"
		][n % 3], s.policy_tier = [
			"standard",
			"restricted",
			"critical"
		][n % 3], s.manual_override = n % 4 == 0 ? "yes" : "no", s.finance_reviewer = `Reviewer ${String.fromCharCode(65 + n % 4)}`, s.exception_reason = n % 4 == 0 ? "margin review" : ""), s;
	});
}
function Zj(e) {
	return Array.from({ length: e }, (e, t) => {
		let n = wj[t % wj.length] ?? wj[0], r = Math.floor(t / wj.length), i = r > 0 && !n.isSource ? ` ${r + 1}` : "";
		return {
			...n,
			rowid: t + 1,
			object: `${n.object}${i}`,
			isActive: t === 1,
			isSelected: t === 1 || t === 2 || t === 3
		};
	});
}
function Qj(e, t = 0) {
	return Array.from({ length: e }, (e, n) => {
		let r = mj[n % mj.length] ?? mj[0], i = n + 1, a = {
			...r,
			rowid: i
		}, o = pj(a, t), s = o[o.length - 1] ?? r.last, c = Number.isFinite(r.last - r.change) ? r.last - r.change : r.open, l = Bj(s - c), u = c > 0 ? Number((l / c * 100).toFixed(2)) : 0;
		return {
			...a,
			last: s,
			live_quote: o,
			change: l,
			change_pct: u,
			trend: l > 0 ? "up" : l < 0 ? "down" : "flat"
		};
	});
}
function $j({ rowCount: e, columnDensity: t, quoteTick: n = 0 }) {
	return {
		accounts: { rows: Yj(e, t) },
		orders: { rows: Xj(e, t) },
		catalog_context: {
			rows: Zj(e),
			columns: [...Sj]
		},
		nasdaq_market: {
			rows: Qj(e, n),
			columns: [...Cj]
		}
	};
}
var eM = [
	{
		id: "catalog-context",
		label: "Data Catalog Lookalike Table",
		description: "Uses only datagrid presentation parameters to mirror the Data Catalog selected-context table, including row state, chips, labels, widths, and hidden provider controls.",
		tests: [
			"src/tests/vitest/datagrid/ui/tableRendering.test.tsx",
			"src/tests/vitest/datagrid/ui/dataplatformIntegratedRoutes.test.tsx",
			"dataplatform/src/catalog/CatalogSession.tsx"
		],
		config: {
			tableName: "catalog_context",
			rowCount: 12,
			columnDensity: "focused",
			actionMode: "read-only",
			pageSize: 12
		}
	},
	{
		id: "nasdaq-market",
		label: "Nasdaq OHLCV Demo Dataset",
		description: "Loads 300 bundled daily OHLCV rows across 10 recognizable tickers with missing closes, freshness lag, outlier volume, and lineage source markers.",
		tests: ["src/tests/vitest/datagrid/ui/widgetShowcaseDatagridPage.test.tsx", "src/tests/vitest/datagrid/ui/dataplatformIntegratedRoutes.test.tsx"],
		config: {
			tableName: "nasdaq_market",
			rowCount: 300,
			columnDensity: "wide",
			actionMode: "inspect",
			pageSize: 25
		}
	},
	{
		id: "sorting-pagination",
		label: "Sorting & Pagination",
		description: "Keeps the grid on a compact schema with enough rows to exercise column sorting, page jumps, and footer controls.",
		tests: [
			"src/tests/vitest/datagrid/ui/tableSorting.test.tsx",
			"src/tests/vitest/datagrid/ui/tablePagination.test.tsx",
			"src/tests/vitest/datagrid/ui/tablePageSizeChange.test.tsx"
		],
		config: {
			tableName: "orders",
			rowCount: 48,
			columnDensity: "focused",
			actionMode: "inspect",
			pageSize: 10
		}
	},
	{
		id: "filters-workspace",
		label: "Filters & Workspace State",
		description: "Starts on a wider account table so header filters, workspace state callbacks, and long text handling are easy to see.",
		tests: [
			"src/tests/vitest/datagrid/ui/tableRangeFilters.test.tsx",
			"src/tests/vitest/datagrid/ui/tableWorkspaceStateSync.test.tsx",
			"src/tests/vitest/datagrid/ui/tableHeaderSummary.test.tsx"
		],
		config: {
			tableName: "accounts",
			rowCount: 36,
			columnDensity: "wide",
			actionMode: "workflow",
			pageSize: 20
		}
	},
	{
		id: "dense-audit",
		label: "Dense Audit Surface",
		description: "Uses the audit-oriented schema and more rows so column density, resizing, and scroll behavior are visible in one place.",
		tests: [
			"src/tests/vitest/datagrid/ui/tableFooterControls.test.tsx",
			"src/tests/vitest/datagrid/ui/tableInfiniteScrollAndSampling.test.tsx",
			"src/tests/vitest/datagrid/ui/tableAllRowsLoadedFlow.test.tsx"
		],
		config: {
			tableName: "orders",
			rowCount: 120,
			columnDensity: "audit",
			actionMode: "read-only",
			pageSize: 25
		}
	}
];
function tM(e) {
	return Array.from({ length: e }, (e, t) => ({
		rowid: t + 1,
		order_id: `ORD-${String(t + 101).padStart(4, "0")}`,
		account_name: `${vj[t % vj.length]} ${hj[t % hj.length]} Account ${t + 1}`,
		owner: gj[t % gj.length],
		order_status: bj[t % bj.length],
		gross_amount: 4200 + t * 215,
		line_item_count: 3 + t % 5,
		last_sync_at: new Date(Date.UTC(2026, (t + 3) % 12, (t + 5) % 27 + 1)).toISOString()
	}));
}
function nM(e) {
	return Array.from({ length: 5 + e % 4 }, (t, n) => ({
		rowid: e * 100 + n + 1,
		sku: `SKU-${e}-${n + 1}`,
		product_name: [
			"Starter seat",
			"Premium seat",
			"Sync bundle",
			"Alert pack"
		][n % 4],
		category: [
			"subscription",
			"services",
			"usage"
		][n % 3],
		quantity: 1 + n % 4,
		unit_price: 220 + e * 8 + n * 17,
		fulfillment_status: xj[n % xj.length],
		committed_at: new Date(Date.UTC(2026, (e + n) % 12, (n + 9) % 27 + 1)).toISOString()
	}));
}
var rM = [
	150,
	650,
	1200
], iM = [
	"Subsystem",
	"Task",
	"Doc"
], aM = {
	Subsystem: {
		label: "Subsystems",
		accent: "#fb7185",
		surface: "rgba(251, 113, 133, 0.18)",
		description: "Subsystem capsules anchor the broader routing conversation."
	},
	Task: {
		label: "Tasks",
		accent: "#22c55e",
		surface: "rgba(34, 197, 94, 0.16)",
		description: "Task capsules keep implementation acceptance and verification close."
	},
	Doc: {
		label: "Docs",
		accent: "#facc15",
		surface: "rgba(250, 204, 21, 0.18)",
		description: "Architecture and subsystem docs carry the durable shell contract."
	}
}, oM = {
	links: {
		label: "Links",
		stroke: "rgba(250,204,21,0.28)"
	},
	tracks: {
		label: "Tracks",
		stroke: "rgba(34,197,94,0.28)"
	},
	documents: {
		label: "Documents",
		stroke: "rgba(251,113,133,0.28)"
	}
}, sM = {
	nodes: [
		{
			id: "subsystem:data-observatory",
			type: "Subsystem",
			name: "Data Observatory",
			filePath: "workflow/docs/subsystems/data-observatory.md",
			confidence: 1
		},
		{
			id: "subsystem:ux-ui-components",
			type: "Subsystem",
			name: "UX & UI Components",
			filePath: "workflow/docs/subsystems/ux-ui-components.md",
			confidence: 1
		},
		{
			id: "doc:todo-router",
			type: "Doc",
			name: "TODO Router",
			filePath: "workflow/TODO.md",
			confidence: 1
		},
		{
			id: "doc:datagrid-architecture",
			type: "Doc",
			name: "Datagrid Architecture",
			filePath: "workflow/docs/wiki/architecture/datagrid.md",
			confidence: 1
		},
		{
			id: "doc:data-observatory",
			type: "Doc",
			name: "Data Observatory",
			filePath: "workflow/docs/subsystems/data-observatory.md",
			confidence: 1
		},
		{
			id: "doc:ux-ui-components",
			type: "Doc",
			name: "UX & UI Components",
			filePath: "workflow/docs/subsystems/ux-ui-components.md",
			confidence: 1
		},
		{
			id: "task:observatory-statistics",
			type: "Task",
			name: "TODO-0147 Statistics Route",
			filePath: "workflow/docs/tasks/TODO-0147.md",
			confidence: 1
		},
		{
			id: "task:statistics-tests",
			type: "Task",
			name: "TODO-0151 Statistics Route Tests",
			filePath: "workflow/docs/tasks/TODO-0151.md",
			confidence: 1
		}
	],
	edges: [
		{
			source: "subsystem:data-observatory",
			target: "doc:data-observatory",
			type: "documents",
			confidence: 1
		},
		{
			source: "subsystem:ux-ui-components",
			target: "doc:ux-ui-components",
			type: "documents",
			confidence: 1
		},
		{
			source: "subsystem:data-observatory",
			target: "task:observatory-statistics",
			type: "tracks",
			confidence: 1
		},
		{
			source: "subsystem:data-observatory",
			target: "task:statistics-tests",
			type: "tracks",
			confidence: 1
		},
		{
			source: "doc:todo-router",
			target: "task:observatory-statistics",
			type: "links",
			confidence: 1
		},
		{
			source: "doc:todo-router",
			target: "task:statistics-tests",
			type: "links",
			confidence: 1
		},
		{
			source: "doc:datagrid-architecture",
			target: "doc:data-observatory",
			type: "links",
			confidence: 1
		},
		{
			source: "doc:datagrid-architecture",
			target: "doc:ux-ui-components",
			type: "links",
			confidence: 1
		}
	],
	meta: {
		builtAt: "2026-04-22T10:00:00.000Z",
		fileCount: 8,
		sourceRoot: ""
	}
}, cM = wk({ lineage: {
	nodes: [
		{
			id: "database:claims",
			type: "database",
			label: "Claims Warehouse",
			properties: {},
			asset: {
				assetKey: "database:internal:1",
				assetType: "database",
				databaseId: 1,
				datasourceType: "internal"
			}
		},
		{
			id: "table:claims.orders",
			type: "table",
			label: "orders",
			properties: {},
			asset: {
				assetKey: "table:internal:1:_:orders",
				assetType: "table",
				databaseId: 1,
				tableName: "orders",
				datasourceType: "internal"
			}
		},
		{
			id: "table:claims.line_items",
			type: "table",
			label: "line_items",
			properties: {},
			asset: {
				assetKey: "table:internal:1:_:line_items",
				assetType: "table",
				databaseId: 1,
				tableName: "line_items",
				datasourceType: "internal"
			}
		},
		{
			id: "column:orders.status",
			type: "column",
			label: "orders.status",
			properties: {},
			asset: {
				assetKey: "column:internal:1:_:orders:status",
				assetType: "column",
				databaseId: 1,
				tableName: "orders",
				columnName: "status",
				datasourceType: "internal"
			}
		},
		{
			id: "column:line_items.quantity",
			type: "column",
			label: "line_items.quantity",
			properties: {},
			asset: {
				assetKey: "column:internal:1:_:line_items:quantity",
				assetType: "column",
				databaseId: 1,
				tableName: "line_items",
				columnName: "quantity",
				datasourceType: "internal"
			}
		},
		{
			id: "check:quantity-window",
			type: "check",
			label: "Quantity window check",
			properties: {}
		},
		{
			id: "issue:quantity-spike",
			type: "issue",
			label: "Quantity spike detected",
			properties: {}
		},
		{
			id: "report:daily-ops",
			type: "report",
			label: "Daily Operations Brief",
			properties: {}
		}
	],
	edges: [
		{
			from: "database:claims",
			to: "table:claims.orders",
			relation: "has_table"
		},
		{
			from: "database:claims",
			to: "table:claims.line_items",
			relation: "has_table"
		},
		{
			from: "table:claims.orders",
			to: "column:orders.status",
			relation: "has_column"
		},
		{
			from: "table:claims.line_items",
			to: "column:line_items.quantity",
			relation: "has_column"
		},
		{
			from: "table:claims.line_items",
			to: "check:quantity-window",
			relation: "produced_by"
		},
		{
			from: "check:quantity-window",
			to: "issue:quantity-spike",
			relation: "has_issue"
		},
		{
			from: "issue:quantity-spike",
			to: "report:daily-ops",
			relation: "summarized_in"
		}
	],
	lastIndexedAt: "2026-04-22T10:30:00.000Z"
} }), lM = Sk, uM = Ck, dM = xk, fM = [
	{
		id: "overview",
		to: "/ops/widgets",
		label: "Overview",
		description: "Jump to the component families and usage demos."
	},
	{
		id: "datagrid",
		to: "/ops/widgets/datagrid",
		label: "Datagrid",
		description: "Implementation-backed skins, palettes, presets, and live parameter controls."
	},
	{
		id: "crud",
		to: "/ops/widgets/crud",
		label: "CRUD",
		description: "Dedicated create, edit, and delete presentation for the datagrid action contract."
	},
	{
		id: "master-detail",
		to: "/ops/widgets/master-detail",
		label: "Master Detail",
		description: "Two datagrids on one page with selection-driven detail loading."
	},
	{
		id: "graph",
		to: "/ops/widgets/graph",
		label: "Graph Viewer",
		description: "A compact docs-routing graph rendered with the shared explorer."
	},
	{
		id: "lineage",
		to: "/ops/widgets/lineage",
		label: "Lineage DAG",
		description: "A lineage-oriented DAG fixture using the same viewer contract."
	},
	{
		id: "buttons",
		to: "/ops/widgets/buttons",
		label: "Buttons",
		description: "Current shell button language shown in realistic placements."
	},
	{
		id: "tooltips",
		to: "/ops/widgets/tooltips",
		label: "Tooltips",
		description: "Inline metadata hints and styled tooltip patterns."
	},
	{
		id: "query-builder",
		to: "/ops/widgets/query-builder",
		label: "Query Builder",
		description: "Fixture-backed visual query construction with a canonical AST preview."
	}
];
function pM(e) {
	return mx("rounded-full border px-4 py-2 text-sm font-medium transition-all duration-150", e ? "border-slate-900 bg-slate-900 text-white shadow-[0_12px_28px_rgba(15,23,42,0.18)]" : "border-white/80 bg-white/88 text-slate-600 hover:border-slate-200 hover:bg-white hover:text-slate-900");
}
function mM(e) {
	return mx("rounded-full border px-3 py-1.5 text-xs font-medium transition", e ? "border-cyan-300 bg-cyan-100 text-cyan-950" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900");
}
function hM(e = "secondary") {
	return e === "primary" ? "rounded-full bg-slate-950 px-4 py-2 text-sm font-medium text-white transition hover:bg-slate-800" : e === "danger" ? "rounded-full border border-rose-200 bg-rose-50 px-4 py-2 text-sm font-medium text-rose-700 transition hover:border-rose-300 hover:bg-rose-100" : "rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50";
}
function gM({ className: e, children: t }) {
	return /* @__PURE__ */ _("div", {
		className: mx("rounded-[1.7rem] border border-white/80 bg-white/86 p-5 shadow-[0_22px_60px_rgba(15,23,42,0.10)] backdrop-blur", e),
		children: t
	});
}
function _M({ badge: e, title: t, description: n, eyebrow: r }) {
	return /* @__PURE__ */ v("div", {
		className: "space-y-3",
		children: [/* @__PURE__ */ v("div", {
			className: "flex flex-wrap items-center gap-2",
			children: [/* @__PURE__ */ _(_x, {
				tone: "info",
				variant: "soft",
				size: "sm",
				uppercase: !1,
				children: e
			}), r ? /* @__PURE__ */ _(_x, {
				tone: "neutral",
				variant: "outline",
				size: "sm",
				uppercase: !1,
				children: r
			}) : null]
		}), /* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("h2", {
			className: "text-2xl font-semibold tracking-tight text-slate-950",
			children: t
		}), /* @__PURE__ */ _("p", {
			className: "mt-2 max-w-4xl text-sm leading-7 text-slate-600",
			children: n
		})] })]
	});
}
function vM({ page: e }) {
	return /* @__PURE__ */ _(x, {
		to: e.to,
		className: "group rounded-[1.6rem] border border-slate-200 bg-white p-5 shadow-[0_14px_34px_rgba(15,23,42,0.06)] transition hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-[0_20px_44px_rgba(15,23,42,0.10)]",
		children: /* @__PURE__ */ v("div", {
			className: "flex items-start justify-between gap-3",
			children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
				className: "text-sm font-semibold text-slate-950",
				children: e.label
			}), /* @__PURE__ */ _("p", {
				className: "mt-2 text-sm leading-6 text-slate-600",
				children: e.description
			})] }), /* @__PURE__ */ _("div", {
				className: "rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] font-medium text-slate-500 transition group-hover:border-slate-300 group-hover:bg-slate-100 group-hover:text-slate-700",
				children: "Open demo"
			})]
		})
	});
}
function yM(e) {
	let t = e?.sorts[0];
	return t ? `${t.column} ${t.direction}` : "No active sort";
}
function bM(e) {
	return Array.from(new Set([
		e,
		10,
		20,
		25,
		50
	])).sort((e, t) => e - t);
}
var xM = "catalog_context", SM = "nasdaq_market", CM = "crud_work_orders", wM = [
	"rowid",
	"request_id",
	"owner",
	"status",
	"priority",
	"amount",
	"updated_at",
	"notes"
], TM = [
	{
		id: "classic",
		label: "Classic",
		className: "datagrid-palette-classic"
	},
	{
		id: "aurora",
		label: "Aurora",
		className: "datagrid-palette-aurora"
	},
	{
		id: "graphite",
		label: "Graphite",
		className: "datagrid-palette-graphite"
	},
	{
		id: "sunrise",
		label: "Sunrise",
		className: "datagrid-palette-sunrise"
	}
], EM = [
	{
		rowid: 1,
		request_id: "CRUD-1001",
		owner: "Clinical Ops",
		status: "triage",
		priority: "high",
		amount: 1280,
		updated_at: "2026-05-18T08:30:00.000Z",
		notes: "Review an incoming cohort correction and assign stewardship."
	},
	{
		rowid: 2,
		request_id: "CRUD-1002",
		owner: "Data Quality",
		status: "in progress",
		priority: "medium",
		amount: 840,
		updated_at: "2026-05-18T09:05:00.000Z",
		notes: "Patch a stale lookup value after the nightly reconciliation."
	},
	{
		rowid: 3,
		request_id: "CRUD-1003",
		owner: "Platform",
		status: "ready",
		priority: "low",
		amount: 430,
		updated_at: "2026-05-18T10:15:00.000Z",
		notes: "Publish a small metadata cleanup once approval lands."
	}
], DM = {
	rowHeight: 52,
	showHeaderInfoBar: !1,
	columnWidths: {
		rowid: 74,
		request_id: 140,
		owner: 150,
		status: 138,
		priority: 116,
		amount: 110,
		updated_at: 190,
		notes: 340
	},
	cellText: { notes: {
		mode: "wrap",
		maxLines: 2
	} },
	headerDisplay: {
		showDatatypeIcons: !1,
		showMissingDataIndicator: !1,
		showSamplingControls: !1
	},
	columnLabels: {
		request_id: "Request",
		updated_at: "Updated"
	},
	cellRenderers: {
		status: ({ value: e }) => {
			let t = String(e);
			return /* @__PURE__ */ _(_x, {
				tone: t === "ready" ? "success" : t === "in progress" ? "info" : "warning",
				variant: "soft",
				size: "xs",
				uppercase: !1,
				children: t
			});
		},
		priority: ({ value: e }) => {
			let t = String(e);
			return /* @__PURE__ */ _(_x, {
				tone: t === "high" ? "danger" : t === "medium" ? "warning" : "neutral",
				variant: "outline",
				size: "xs",
				uppercase: !1,
				children: t
			});
		},
		amount: ({ value: e }) => {
			let t = Number(e);
			return /* @__PURE__ */ _("span", {
				className: "font-mono text-sm text-slate-700",
				children: Number.isFinite(t) ? `$${t.toLocaleString()}` : String(e)
			});
		}
	}
};
function OM(e) {
	return e.charAt(0).toUpperCase() + e.slice(1);
}
function kM(e) {
	return mx("datagrid-catalog-label-chip", e === "taxonomy" ? "datagrid-catalog-taxonomy-chip" : null, e === "trust" ? "datagrid-catalog-trust-chip" : null, e === "certification" ? "datagrid-catalog-certification-chip" : null, e === "sensitivity" ? "datagrid-catalog-sensitivity-chip" : null);
}
function AM(e, t, n = "") {
	let r = e[t];
	return typeof r == "string" ? r : n;
}
function jM(e) {
	let t = e.signals;
	return Array.isArray(t) ? t.filter((e) => !!e && typeof e == "object" && typeof e.label == "string" && [
		"taxonomy",
		"trust",
		"certification",
		"sensitivity"
	].includes(String(e.tone))) : [];
}
function MM(e, t, n = 0) {
	let r = e[t];
	return typeof r == "number" && Number.isFinite(r) ? r : n;
}
function NM(e, t) {
	let n = Number(e.amount);
	return {
		rowid: t,
		request_id: String(e.request_id || `CRUD-${String(1e3 + t).padStart(4, "0")}`),
		owner: String(e.owner || "Unassigned"),
		status: String(e.status || "triage"),
		priority: String(e.priority || "medium"),
		amount: Number.isFinite(n) ? n : 0,
		updated_at: String(e.updated_at || (/* @__PURE__ */ new Date()).toISOString()),
		notes: String(e.notes || "")
	};
}
function PM(e) {
	return new Intl.NumberFormat("en-US", {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
		style: "currency",
		currency: "USD"
	}).format(e);
}
function FM(e) {
	return new Intl.NumberFormat("en-US", {
		notation: "compact",
		maximumFractionDigits: 1
	}).format(e);
}
var IM = {
	rootClassName: "datagrid-catalog-context",
	tableClassName: "datagrid-catalog-context-table",
	showHeaderInfoBar: !1,
	showFooter: !1,
	enableHorizontalScroll: !0,
	rowHeight: 75,
	scrollRegionMaxHeight: "44rem",
	columnLabels: {
		type: "Type",
		object: "Object",
		location: "Location",
		quality: "Quality",
		owner: "Owner",
		signals: "Signals",
		actions: "Actions"
	},
	columnWidths: {
		type: 96,
		object: 300,
		location: 260,
		quality: 142,
		owner: 190,
		signals: 230,
		actions: 168
	},
	rowClassName: ({ row: e }) => mx("datagrid-catalog-row", e.isSource ? "datagrid-catalog-row-source" : null, e.isActive ? "datagrid-catalog-row-active" : null, e.isSelected ? "datagrid-catalog-row-selected" : null),
	cellClassNames: Object.fromEntries(Sj.map((e) => [e, `datagrid-catalog-cell datagrid-catalog-cell-${e}`])),
	headerDisplay: {
		showColumnMenu: !1,
		showSortControls: !1,
		showFilterControls: !1,
		showSamplingControls: !1,
		showStatisticsControls: !0,
		showDatatypeIcons: !0,
		showMissingDataIndicator: !1
	},
	typography: {
		header: {
			color: "#475569",
			fontSize: "0.72rem",
			fontWeight: 900,
			letterSpacing: "0.08em",
			textTransform: "uppercase"
		},
		body: {
			color: "#0f172a",
			fontSize: "0.84rem",
			lineHeight: 1.35
		}
	},
	cellRenderers: {
		type: ({ row: e }) => {
			let t = AM(e, "type", "table");
			return /* @__PURE__ */ _("span", {
				className: `datagrid-catalog-object-type datagrid-catalog-object-type-${t}`,
				children: OM(t)
			});
		},
		object: ({ row: e }) => /* @__PURE__ */ v("button", {
			type: "button",
			className: "datagrid-catalog-object-name-button",
			children: [/* @__PURE__ */ _("strong", { children: AM(e, "object") }), /* @__PURE__ */ _("span", { children: AM(e, "objectDetail") })]
		}),
		location: ({ row: e }) => /* @__PURE__ */ v("div", {
			className: "datagrid-catalog-stacked-cell",
			children: [/* @__PURE__ */ _("strong", { children: AM(e, "location") }), /* @__PURE__ */ _("span", { children: AM(e, "locationDetail") })]
		}),
		quality: ({ row: e }) => {
			let t = AM(e, "qualityStatus", "not_run");
			return /* @__PURE__ */ _("span", {
				className: `datagrid-catalog-quality ${t === "pass" ? "datagrid-catalog-quality-pass" : t === "fail" ? "datagrid-catalog-quality-fail" : "datagrid-catalog-quality-unknown"}`,
				children: AM(e, "quality", "Not run")
			});
		},
		owner: ({ row: e }) => /* @__PURE__ */ v("div", {
			className: "datagrid-catalog-stacked-cell",
			children: [/* @__PURE__ */ _("strong", { children: AM(e, "owner", "Unassigned") }), /* @__PURE__ */ _("span", { children: AM(e, "ownerDetail", "No steward") })]
		}),
		signals: ({ row: e }) => /* @__PURE__ */ _("div", {
			className: "datagrid-catalog-signals",
			children: jM(e).map((e) => /* @__PURE__ */ _("span", {
				className: kM(e.tone),
				children: e.label
			}, `${e.tone}-${e.label}`))
		}),
		actions: ({ row: e }) => {
			let t = AM(e, "actions", "Add"), n = AM(e, "focusAction", "Focus");
			return /* @__PURE__ */ v("div", {
				className: "datagrid-catalog-actions",
				children: [/* @__PURE__ */ _("button", {
					type: "button",
					className: "datagrid-catalog-action-button",
					disabled: t === "Added",
					children: t
				}), /* @__PURE__ */ _("button", {
					type: "button",
					className: "datagrid-catalog-action-button",
					disabled: n === "Focused",
					children: n
				})]
			});
		}
	}
}, LM = {
	rootClassName: "datagrid-original-context",
	tableClassName: "datagrid-original-table",
	showHeaderInfoBar: !0,
	showFooter: !0,
	enableHorizontalScroll: !0,
	rowHeight: 54,
	scrollRegionMaxHeight: "44rem",
	typography: {
		header: {
			fontSize: "0.76rem",
			fontWeight: 800,
			letterSpacing: "0.03em"
		},
		body: {
			fontSize: "0.84rem",
			lineHeight: 1.42
		}
	}
}, RM = {
	rootClassName: "datagrid-nasdaq-context",
	tableClassName: "datagrid-nasdaq-table",
	showHeaderInfoBar: !1,
	showFooter: !0,
	enableHorizontalScroll: !0,
	rowHeight: 64,
	scrollRegionMaxHeight: "44rem",
	columnLabels: {
		symbol: "Ticker",
		company: "Company",
		trade_date: "Timestamp",
		open: "Open",
		high: "High",
		low: "Low",
		close: "Close",
		last: "Last",
		live_quote: "Live quote",
		change: "Change",
		change_pct: "%",
		volume: "Volume",
		market_cap: "Mkt Cap",
		sector: "Sector",
		signal: "Signal",
		quality_flag: "Quality",
		freshness_lag_days: "Lag",
		data_source: "Source"
	},
	columnWidths: {
		symbol: 112,
		company: 240,
		trade_date: 196,
		open: 112,
		high: 112,
		low: 112,
		close: 112,
		last: 132,
		live_quote: 164,
		change: 118,
		change_pct: 96,
		volume: 134,
		market_cap: 142,
		sector: 170,
		signal: 132,
		quality_flag: 124,
		freshness_lag_days: 92,
		data_source: 190
	},
	rowClassName: ({ row: e }) => mx("datagrid-nasdaq-row", e.trend === "up" ? "datagrid-nasdaq-row-up" : null, e.trend === "down" ? "datagrid-nasdaq-row-down" : null, e.trend === "flat" ? "datagrid-nasdaq-row-flat" : null),
	cellClassNames: Object.fromEntries(Cj.map((e) => [e, `datagrid-nasdaq-cell datagrid-nasdaq-cell-${e}`])),
	headerDisplay: {
		showColumnMenu: !1,
		showSortControls: !0,
		showFilterControls: !1,
		showSamplingControls: !1,
		showStatisticsControls: !0,
		showDatatypeIcons: !0,
		showMissingDataIndicator: !1
	},
	typography: {
		header: {
			color: "#94a3b8",
			fontSize: "0.72rem",
			fontWeight: 900,
			letterSpacing: "0.08em",
			textTransform: "uppercase"
		},
		body: {
			color: "#e2e8f0",
			fontSize: "0.84rem",
			lineHeight: 1.35
		}
	},
	cellRenderers: {
		symbol: ({ row: e }) => /* @__PURE__ */ v("button", {
			type: "button",
			className: "datagrid-nasdaq-symbol-button",
			children: [/* @__PURE__ */ _("strong", { children: AM(e, "symbol") }), /* @__PURE__ */ _("span", { children: AM(e, "sector") })]
		}),
		company: ({ row: e }) => /* @__PURE__ */ v("div", {
			className: "datagrid-nasdaq-company",
			children: [/* @__PURE__ */ _("strong", { children: AM(e, "company") }), /* @__PURE__ */ _("span", { children: "NASDAQ listed equity" })]
		}),
		trade_date: ({ row: e }) => {
			let t = AM(e, "trade_date"), n = typeof e.rowid == "number" ? e.rowid : 1, r = 57600 - (n * 2347 + 13) % 61, i = Math.floor(r / 3600), a = Math.floor(r % 3600 / 60), o = r % 60, s = (n * 137 + 29) % 1e3, c = `${String(i).padStart(2, "0")}:${String(a).padStart(2, "0")}:${String(o).padStart(2, "0")}.${String(s).padStart(3, "0")}`;
			return /* @__PURE__ */ v("div", {
				className: "datagrid-nasdaq-timestamp",
				children: [/* @__PURE__ */ _("span", { children: t }), /* @__PURE__ */ v("span", { children: [c, " ET"] })]
			});
		},
		open: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-number",
			children: PM(MM(e, "open"))
		}),
		high: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-number",
			children: PM(MM(e, "high"))
		}),
		low: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-number",
			children: PM(MM(e, "low"))
		}),
		close: ({ row: e }) => {
			let t = e.close;
			return t == null || t === "" ? /* @__PURE__ */ _("span", {
				className: "datagrid-nasdaq-missing",
				children: "Missing"
			}) : /* @__PURE__ */ _("span", {
				className: "datagrid-nasdaq-number",
				children: PM(MM(e, "close"))
			});
		},
		last: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-price",
			children: PM(MM(e, "last"))
		}),
		live_quote: ({ row: e }) => {
			let t = Array.isArray(e.live_quote) ? e.live_quote : [], n = MM(e, "open");
			if (t.length === 0) return /* @__PURE__ */ _("span", {
				className: "datagrid-nasdaq-number",
				children: "—"
			});
			let r = Math.min(...t), i = Math.max(...t) - r || 1, a = t.length, o = Math.max(1, Math.floor((144 - (a - 1)) / a)), s = o + 1, c = t[a - 1] ?? n, l = n > 0 ? (c - n) / n * 100 : 0;
			return /* @__PURE__ */ v("div", {
				style: {
					display: "flex",
					alignItems: "center",
					gap: "6px"
				},
				children: [/* @__PURE__ */ _("svg", {
					width: 144,
					height: 34,
					viewBox: "0 0 144 34",
					"data-testid": "sparkline-cell",
					"aria-label": "Intraday price bars",
					style: { flexShrink: 0 },
					children: t.map((e, t) => {
						let c = Math.max(2, Math.round((e - r) / i * 30) + 2);
						return /* @__PURE__ */ _("rect", {
							x: t * s,
							y: 34 - c,
							width: o,
							height: c,
							fill: e >= n ? "#4ade80" : "#fb7185",
							opacity: t === a - 1 ? 1 : .6,
							rx: 1
						}, t);
					})
				}), /* @__PURE__ */ v("span", { children: [
					l > 0 ? "+" : "",
					l.toFixed(2),
					"%"
				] })]
			});
		},
		change: ({ row: e }) => {
			let t = MM(e, "change");
			return /* @__PURE__ */ v("span", {
				className: `datagrid-nasdaq-change ${t > 0 ? "datagrid-nasdaq-positive" : t < 0 ? "datagrid-nasdaq-negative" : "datagrid-nasdaq-neutral"}`,
				children: [t > 0 ? "+" : "", t.toFixed(2)]
			});
		},
		change_pct: ({ row: e }) => {
			let t = MM(e, "change_pct");
			return /* @__PURE__ */ v("span", {
				className: `datagrid-nasdaq-change ${t > 0 ? "datagrid-nasdaq-positive" : t < 0 ? "datagrid-nasdaq-negative" : "datagrid-nasdaq-neutral"}`,
				children: [
					t > 0 ? "+" : "",
					t.toFixed(2),
					"%"
				]
			});
		},
		volume: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-number",
			children: FM(MM(e, "volume"))
		}),
		market_cap: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-number",
			children: FM(MM(e, "market_cap"))
		}),
		sector: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-sector",
			children: AM(e, "sector")
		}),
		signal: ({ row: e }) => {
			let t = AM(e, "signal", "watch");
			return /* @__PURE__ */ _("span", {
				className: `datagrid-nasdaq-signal datagrid-nasdaq-signal-${t}`,
				children: OM(t)
			});
		},
		quality_flag: ({ row: e }) => {
			let t = AM(e, "quality_flag", "PASS").toLowerCase();
			return /* @__PURE__ */ _("span", {
				className: `datagrid-nasdaq-signal datagrid-nasdaq-signal-${t}`,
				children: t.toUpperCase()
			});
		},
		freshness_lag_days: ({ row: e }) => /* @__PURE__ */ v("span", {
			className: "datagrid-nasdaq-number",
			children: [MM(e, "freshness_lag_days"), "d"]
		}),
		data_source: ({ row: e }) => /* @__PURE__ */ _("span", {
			className: "datagrid-nasdaq-sector",
			children: AM(e, "data_source")
		})
	}
}, zM = [
	{
		id: "original",
		label: "Original-like",
		description: "The familiar datagrid shape with lighter polish and palette support.",
		tableName: "orders",
		config: {
			rowCount: 48,
			columnDensity: "focused",
			actionMode: "inspect",
			pageSize: 10
		},
		presentation: LM
	},
	{
		id: "catalog",
		label: "Catalog-like",
		description: "The selected-context table style from the Data Catalog.",
		tableName: xM,
		columns: Sj,
		config: {
			rowCount: 12,
			columnDensity: "focused",
			actionMode: "read-only",
			pageSize: 12
		},
		presentation: IM
	},
	{
		id: "nasdaq",
		label: "Nasdaq-like",
		description: "A compact market-monitor skin with terminal-inspired cells.",
		tableName: SM,
		columns: Cj,
		config: {
			rowCount: 300,
			columnDensity: "wide",
			actionMode: "market",
			pageSize: 25
		},
		presentation: RM
	}
];
function BM(e) {
	return zM.find((t) => t.id === e) ?? zM[0];
}
function VM(e) {
	return TM.find((t) => t.id === e) ?? TM[0];
}
function HM(e) {
	return e === xM ? "catalog" : e === SM ? "nasdaq" : "original";
}
function UM(e, t, n) {
	let r = VM(n);
	return {
		...e,
		rootClassName: mx("datagrid-skin", `datagrid-skin-${t}`, r.className, e.rootClassName)
	};
}
function WM() {
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-overview",
		children: [
			/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
				badge: "Overview",
				eyebrow: "Ops utility route",
				title: "A shell-native playground for the component surfaces we keep reusing.",
				description: "Use this route to pressure-test the datagrid, compare multi-grid composition, inspect graph fixtures, and review the current button and tooltip language without leaving the shell."
			}) }),
			/* @__PURE__ */ _("div", {
				className: "grid gap-4 lg:grid-cols-2 xl:grid-cols-3",
				children: fM.filter((e) => e.id !== "overview").map((e) => /* @__PURE__ */ _(vM, { page: e }, e.id))
			}),
			/* @__PURE__ */ v("div", {
				className: "grid gap-4 xl:grid-cols-[1.2fr_0.8fr]",
				children: [/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ v("div", {
					className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
					children: [/* @__PURE__ */ _(ls, {
						className: "h-4 w-4 text-cyan-600",
						"aria-hidden": "true"
					}), "Why this route exists"]
				}), /* @__PURE__ */ v("div", {
					className: "mt-4 grid gap-3 md:grid-cols-3",
					children: [
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.3rem] border border-slate-200 bg-slate-50 p-4",
							children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-950",
								children: "Real shell context"
							}), /* @__PURE__ */ _("p", {
								className: "mt-2 text-sm leading-6 text-slate-600",
								children: "Every demo lives behind the Ops utility menu, so we can review reusable surfaces without adding another top-level workspace tab."
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.3rem] border border-slate-200 bg-slate-50 p-4",
							children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-950",
								children: "Implementation-backed presets"
							}), /* @__PURE__ */ _("p", {
								className: "mt-2 text-sm leading-6 text-slate-600",
								children: "The datagrid page calls out the existing UI tests that motivated each preset, so demos stay grounded in behavior we already guard."
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "rounded-[1.3rem] border border-slate-200 bg-slate-50 p-4",
							children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-950",
								children: "Composition before reinvention"
							}), /* @__PURE__ */ _("p", {
								className: "mt-2 text-sm leading-6 text-slate-600",
								children: "Graphs, buttons, and tooltips reuse the current primitives and styling patterns instead of introducing a detached showcase-only design system."
							})]
						})
					]
				})] }), /* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ v("div", {
					className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
					children: [/* @__PURE__ */ _(yo, {
						className: "h-4 w-4 text-emerald-600",
						"aria-hidden": "true"
					}), "Quick tour"]
				}), /* @__PURE__ */ v("ol", {
					className: "mt-4 space-y-3 text-sm leading-6 text-slate-600",
					children: [
						/* @__PURE__ */ v("li", {
							className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
							children: [
								"Start on ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Datagrid"
								}),
								" to load a preset and tweak rows, density, actions, and page size."
							]
						}),
						/* @__PURE__ */ v("li", {
							className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
							children: [
								"Move to ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Master Detail"
								}),
								" and click a row in the first grid to trigger a second grid fetch."
							]
						}),
						/* @__PURE__ */ v("li", {
							className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
							children: [
								"Use ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Graph Viewer"
								}),
								", ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Lineage DAG"
								}),
								", ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Buttons"
								}),
								", and ",
								/* @__PURE__ */ _("strong", {
									className: "text-slate-900",
									children: "Tooltips"
								}),
								" for visual polish reviews."
							]
						})
					]
				})] })]
			})
		]
	});
}
function GM({ initialPresetId: e = eM[0]?.id ?? "sorting-pagination", initialSkinId: t, initialPaletteId: n = "classic", onActivationEvent: r } = {}) {
	let i = eM.find((t) => t.id === e) ?? eM[0], a = BM(t ?? HM(i?.config.tableName ?? "orders")), [s, c] = h(i?.id ?? "sorting-pagination"), [l, d] = h(a.id), [p, m] = h(n), [g, y] = h(a.tableName), [b, x] = h(a.config.rowCount), [S, C] = h(a.config.columnDensity), [w, T] = h(a.config.actionMode), [E, D] = h(a.config.pageSize), [O, k] = h(null), [A, j] = h("No row action has fired yet."), [M, N] = h(0), P = f(() => eM.find((e) => e.id === s), [s]), F = f(() => BM(l), [l]), I = f(() => VM(p), [p]), L = f(() => $j({
		rowCount: b,
		columnDensity: S,
		quoteTick: g === SM ? M : 0
	}), [
		S,
		M,
		b,
		g
	]), R = f(() => Jj({
		tables: L,
		databaseLabel: "widget-showcase.db"
	}), [L]), z = f(() => w === "read-only" ? [] : w === "inspect" ? [$.VIEW] : [
		$.SELECT,
		$.VIEW,
		$.EXPORT
	], [w]), B = f(() => ({ table: {
		options: Object.keys(L),
		onChange: (e) => {
			let t = HM(e), n = BM(t);
			d(t), c(t === "catalog" ? "catalog-context" : t === "original" ? "sorting-pagination" : `skin:${t}`), y(e), T(n.config.actionMode), D(n.config.pageSize), j(`Switched datagrid fixture to ${e}.`);
		}
	} }), [L]), V = [
		g,
		b,
		S,
		w,
		E,
		l,
		p
	].join(":"), H = f(() => UM(F.presentation, F.id, I.id), [I.id, F]), ee = F.columns ? [...F.columns] : void 0, U = g === SM && M > 0 ? M : void 0;
	u(() => {
		if (g !== SM) return;
		let e = window.setInterval(() => {
			N((e) => e + 1);
		}, 1800);
		return () => {
			window.clearInterval(e);
		};
	}, [g]);
	let te = (e) => {
		let t = BM(e);
		o(() => {
			d(t.id), c(t.id === "catalog" ? "catalog-context" : t.id === "original" ? "sorting-pagination" : `skin:${t.id}`), y(t.tableName), x(t.config.rowCount), C(t.config.columnDensity), T(t.config.actionMode), D(t.config.pageSize), k(null), j(`Loaded skin ${t.label}.`), r?.("skin_toggled", {
				skinId: t.id,
				tableName: t.tableName
			});
		});
	}, W = (e) => {
		let t = eM.find((t) => t.id === e);
		t && o(() => {
			let e = HM(t.config.tableName);
			c(t.id), d(e), y(t.config.tableName), x(t.config.rowCount), C(t.config.columnDensity), T(t.config.actionMode), D(t.config.pageSize), k(null), j(`Loaded preset ${t.label}.`);
		});
	};
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-datagrid-page",
		children: [/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _(_M, {
			badge: "Datagrid",
			eyebrow: "Implementation-backed presets",
			title: "Load real table scenarios, then tweak the component inputs live.",
			description: "Each preset below points back to the datagrid UI tests that already protect the behavior. Use skins and palettes to swap bundled external presentation configs, then tweak rows, density, actions, and workspace-state callbacks."
		}), /* @__PURE__ */ v("div", {
			className: "mt-4 flex flex-wrap items-center justify-between gap-3 rounded-[1.2rem] border border-cyan-100 bg-cyan-50 px-4 py-3 text-sm text-cyan-950",
			children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
				className: "font-semibold",
				children: "Consumer API guide"
			}), /* @__PURE__ */ _("p", {
				className: "mt-1 text-xs leading-5 text-cyan-800",
				children: "Covers controlled grids, provider grids, pagination, filters, sorting, custom cells, actions, presentation, and domain adapters."
			})] }), /* @__PURE__ */ _("a", {
				href: "https://github.com/vibelibs/datagrid#readme",
				target: "_blank",
				rel: "noreferrer",
				className: "rounded-full border border-cyan-200 bg-white px-3 py-1.5 text-xs font-semibold text-cyan-900 transition hover:border-cyan-300 hover:bg-cyan-100",
				children: "Open guide"
			})]
		})] }), /* @__PURE__ */ v("div", {
			className: "grid gap-4 xl:grid-cols-[430px_minmax(0,1fr)]",
			children: [/* @__PURE__ */ v("div", {
				className: "space-y-4",
				children: [
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(ps, {
							className: "h-4 w-4 text-cyan-600",
							"aria-hidden": "true"
						}), "Presets"]
					}), /* @__PURE__ */ _("div", {
						className: "mt-4 space-y-3",
						children: eM.map((e) => /* @__PURE__ */ v("div", {
							className: mx("rounded-[1.35rem] border p-4 transition", e.id === s ? "border-cyan-300 bg-cyan-50" : "border-slate-200 bg-white"),
							children: [/* @__PURE__ */ v("div", {
								className: "flex items-start justify-between gap-3",
								children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
									className: "text-sm font-semibold text-slate-950",
									children: e.label
								}), /* @__PURE__ */ _("p", {
									className: "mt-2 text-sm leading-6 text-slate-600",
									children: e.description
								})] }), /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => W(e.id),
									className: mx("rounded-full border px-3 py-1 text-[11px] font-medium transition", e.id === s ? "border-cyan-300 bg-white text-cyan-900" : "border-slate-200 bg-slate-50 text-slate-600 hover:border-slate-300 hover:bg-white hover:text-slate-900"),
									children: "Load"
								})]
							}), /* @__PURE__ */ _("div", {
								className: "mt-3 flex flex-wrap gap-2",
								children: e.tests.map((e) => /* @__PURE__ */ _("code", {
									className: "rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-[11px] text-slate-500",
									children: e.split("/").slice(-1)[0]
								}, e))
							})]
						}, e.id))
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(wa, {
							className: "h-4 w-4 text-emerald-600",
							"aria-hidden": "true"
						}), "Live controls"]
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 space-y-4",
						children: [
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Skin"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 grid gap-2",
								children: zM.map((e) => /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => te(e.id),
									className: mx("rounded-lg border px-3 py-2 text-left text-xs font-medium transition", l === e.id ? "border-cyan-300 bg-cyan-50 text-cyan-950" : "border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:text-slate-900"),
									"data-testid": `datagrid-skin-${e.id}`,
									children: [/* @__PURE__ */ _("span", {
										className: "block font-semibold",
										children: e.label
									}), /* @__PURE__ */ _("span", {
										className: "mt-1 block text-[11px] leading-5 text-slate-500",
										children: e.description
									})]
								}, e.id))
							})] }),
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Palette"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 flex flex-wrap gap-2",
								children: TM.map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => m(e.id),
									className: mM(p === e.id),
									"data-testid": `datagrid-palette-${e.id}`,
									children: e.label
								}, e.id))
							})] }),
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Row count"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 flex flex-wrap gap-2",
								children: [
									12,
									36,
									48,
									120
								].map((e) => /* @__PURE__ */ v("button", {
									type: "button",
									onClick: () => x(e),
									className: mM(b === e),
									children: [e, " rows"]
								}, e))
							})] }),
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Column density"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 flex flex-wrap gap-2",
								children: [
									"focused",
									"wide",
									"audit"
								].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => C(e),
									className: mM(S === e),
									children: e
								}, e))
							})] }),
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Action mode"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 flex flex-wrap gap-2",
								children: [
									"read-only",
									"inspect",
									"market",
									"workflow"
								].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => T(e),
									className: mM(w === e),
									children: e
								}, e))
							})] }),
							/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-sm font-semibold text-slate-900",
								children: "Page size"
							}), /* @__PURE__ */ _("div", {
								className: "mt-2 flex flex-wrap gap-2",
								children: [
									10,
									20,
									25,
									50
								].map((e) => /* @__PURE__ */ _("button", {
									type: "button",
									onClick: () => D(e),
									className: mM(E === e),
									children: e
								}, e))
							})] })
						]
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "External presentation config"
					}), /* @__PURE__ */ _("div", {
						className: "mt-4 grid gap-2 text-xs text-slate-600",
						children: [
							"skin.presentation",
							"presentation.rootClassName",
							"presentation.tableClassName",
							"presentation.scrollRegionClassName",
							"presentation.rowHeight",
							"presentation.showHeaderInfoBar",
							"presentation.showFooter",
							"presentation.columnLabels",
							"presentation.columnWidths",
							"presentation.rowClassName",
							"presentation.cellClassNames",
							"presentation.cellRenderers",
							"presentation.cellText",
							"presentation.typography",
							"presentation.headerDisplay"
						].map((e) => /* @__PURE__ */ _("code", {
							className: "rounded-full border border-emerald-200 bg-emerald-50 px-3 py-1.5 text-emerald-900",
							children: e
						}, e))
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Workspace snapshot"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 grid gap-3 sm:grid-cols-2",
						children: [
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Active skin"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: F.label
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Palette"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: I.label
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Sort"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: yM(O)
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Filters"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: Object.keys(O?.filters ?? {}).length
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Visible columns"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: O?.visibleColumns.length ?? 0
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3 sm:col-span-2",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Active preset"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm font-semibold text-slate-950",
									children: P?.label ?? "Custom"
								})]
							}),
							/* @__PURE__ */ v("div", {
								className: "rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3 sm:col-span-2",
								children: [/* @__PURE__ */ _("div", {
									className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
									children: "Last action"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 text-sm leading-6 text-slate-600",
									children: A
								})]
							})
						]
					})] })
				]
			}), /* @__PURE__ */ v(gM, {
				className: "overflow-hidden",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-wrap items-center justify-between gap-3",
					children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Interactive datagrid"
					}), /* @__PURE__ */ _("div", {
						className: "mt-2 text-sm text-slate-600",
						children: "Use the table selector inside the header to switch fixtures without leaving the page."
					})] }), /* @__PURE__ */ v("div", {
						className: "flex flex-wrap gap-2",
						children: [
							/* @__PURE__ */ _(_x, {
								tone: "accent",
								variant: "soft",
								size: "sm",
								uppercase: !1,
								children: g
							}),
							/* @__PURE__ */ v(_x, {
								tone: "neutral",
								variant: "outline",
								size: "sm",
								uppercase: !1,
								children: [b, " rows"]
							}),
							/* @__PURE__ */ _(_x, {
								tone: "neutral",
								variant: "outline",
								size: "sm",
								uppercase: !1,
								children: S
							})
						]
					})]
				}), /* @__PURE__ */ _("div", {
					className: "mt-4 min-h-[46rem] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white",
					children: /* @__PURE__ */ _(ew, {
						mode: "provider",
						provider: R,
						databaseId: "widget-showcase",
						tableName: g,
						requestNonce: U,
						columns: ee,
						idField: "rowid",
						actions: z,
						actionHandlers: { onView: (e) => j(`Viewed row ${e} on ${g}.`) },
						pageSize: E,
						pageSizeOptions: bM(E),
						headerSelectors: B,
						layoutOptions: { maxHeight: "100%" },
						presentation: H,
						onStatsPanelOpen: (e) => r?.("stats_panel_opened", {
							column: e,
							tableName: g
						}),
						onWorkspaceStateChange: k
					}, V)
				})]
			})]
		})]
	});
}
function KM() {
	let [e, t] = h(() => EM.map((e) => ({ ...e }))), [n, r] = h("CRUD fixture ready."), i = s((e) => {
		let n = new Set(e.map(String));
		t((e) => e.filter((e) => !n.has(String(e.rowid)))), r(`Deleted ${e.length} ${e.length === 1 ? "row" : "rows"}.`);
	}, []), a = f(() => ({
		...Jj({
			tables: { [CM]: {
				rows: e,
				columns: [...wM]
			} },
			databaseLabel: "crud-demo.sqlite"
		}),
		async updateRecord(e, n, i, a) {
			return t((e) => e.map((e) => String(e.rowid) === String(i) ? NM({
				...e,
				...a,
				updated_at: (/* @__PURE__ */ new Date()).toISOString()
			}, e.rowid) : e)), r(`Updated row ${i}.`), {
				status: "success",
				data: { changes: 1 }
			};
		},
		async createRecord(n, i, a) {
			let o = Math.max(0, ...e.map((e) => e.rowid)) + 1, s = NM({
				...a,
				request_id: a.request_id || `CRUD-${1e3 + o}`,
				updated_at: (/* @__PURE__ */ new Date()).toISOString()
			}, o);
			return t((e) => [s, ...e]), r(`Created row ${o}.`), {
				status: "success",
				data: { lastID: o }
			};
		},
		async deleteRecord(e, t, n) {
			i([n]);
		},
		async bulkDeleteRecords(e, t, n) {
			i(n);
		}
	}), [e, i]);
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-crud-page",
		children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
			badge: "CRUD",
			eyebrow: "Dedicated write demo",
			title: "Datagrid CRUD",
			description: "Create, edit, delete, bulk delete, inspect, select, and export are mounted here as the explicit write-enabled presentation."
		}) }), /* @__PURE__ */ v("div", {
			className: "grid gap-4 xl:grid-cols-[minmax(0,1fr)_320px]",
			children: [/* @__PURE__ */ v(gM, {
				className: "overflow-hidden",
				children: [/* @__PURE__ */ v("div", {
					className: "flex flex-wrap items-center justify-between gap-3",
					children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Write-enabled grid"
					}), /* @__PURE__ */ _("div", {
						className: "mt-2 text-sm text-slate-600",
						children: "The action array enables create, edit, delete, and bulk delete only on this route."
					})] }), /* @__PURE__ */ v(_x, {
						tone: "danger",
						variant: "outline",
						size: "sm",
						uppercase: !1,
						children: [e.length, " mutable rows"]
					})]
				}), /* @__PURE__ */ _("div", {
					className: "mt-4 min-h-[32rem] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white",
					children: /* @__PURE__ */ _(ew, {
						mode: "controlled",
						idField: "rowid",
						data: e,
						columns: [...wM],
						actions: [
							$.SELECT,
							$.VIEW,
							$.EDIT,
							$.DELETE,
							$.CREATE,
							$.EXPORT
						],
						actionHandlers: { onDelete: (e) => {
							a.deleteRecord("crud-demo", CM, e);
						} },
						onBulkDelete: i,
						pageSize: 6,
						pageSizeOptions: [6, 12],
						layoutOptions: { maxHeight: "100%" },
						presentation: DM
					})
				})]
			}), /* @__PURE__ */ v(gM, { children: [
				/* @__PURE__ */ _("div", {
					className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
					children: "External parameters"
				}),
				/* @__PURE__ */ _("div", {
					className: "mt-4 grid gap-2 text-xs text-slate-600",
					children: [
						"actions=[select, view, edit, delete, create, export]",
						"provider.createRecord",
						"provider.updateRecord",
						"provider.deleteRecord",
						"onBulkDelete",
						"presentation.cellRenderers"
					].map((e) => /* @__PURE__ */ _("code", {
						className: "rounded-full border border-rose-200 bg-rose-50 px-3 py-1.5 text-rose-900",
						children: e
					}, e))
				}),
				/* @__PURE__ */ v("div", {
					className: "mt-5 rounded-[1.2rem] border border-slate-200 bg-slate-50 px-4 py-3",
					children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
						children: "Last mutation"
					}), /* @__PURE__ */ _("div", {
						className: "mt-2 text-sm leading-6 text-slate-700",
						"data-testid": "crud-demo-summary",
						children: n
					})]
				})
			] })]
		})]
	});
}
function qM() {
	let [e, t] = h(10), [n, r] = h(rM[1] ?? 650), [i, a] = h(null), [c, u] = h("Click a row or use the eye action in the master grid to load the detail grid."), [d, p] = h(!1), m = s((e) => {
		o(() => {
			a(e ?? null), u(e?.order_id ? `Loading detail items for ${String(e.order_id)} with ${n} ms of simulated latency.` : "Click a row or use the eye action in the master grid to load the detail grid.");
		});
	}, [n]), y = l(i), b = f(() => tM(e), [e]), x = f(() => Jj({
		tables: { orders: { rows: b } },
		databaseLabel: "master-detail-master.db"
	}), [b]), S = f(() => y && typeof y.rowid == "number" ? nM(y.rowid) : [], [y]), C = f(() => Jj({
		tables: { line_items: { rows: S } },
		databaseLabel: "master-detail-detail.db",
		delayMs: y ? n : 0
	}), [
		y,
		n,
		S
	]), w = `${y?.rowid ?? "none"}:${n}`, T = i?.rowid ?? null, E = f(() => {
		let e = UM(LM, "original", "classic");
		return {
			...e,
			rootClassName: mx(e.rootClassName, "datagrid-master-detail-master-context"),
			rowClassName: ({ row: e }) => e.rowid === T ? "datagrid-master-detail-row-selected" : null
		};
	}, [T]);
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-master-detail-page",
		children: [
			/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ v("div", {
				className: "flex items-start justify-between gap-4",
				children: [/* @__PURE__ */ _(_M, {
					badge: "Master Detail",
					eyebrow: "Multi-grid composition",
					title: "Two datagrids on one page, with the second loading from the selection in the first.",
					description: "This pattern keeps the selection contract explicit: the master grid owns row choice, and the detail grid remounts against a second provider-backed fetch so loading, empty, and refreshed states stay honest."
				}), /* @__PURE__ */ v("div", {
					className: "relative flex-shrink-0 self-start pt-1",
					children: [/* @__PURE__ */ v("button", {
						type: "button",
						onClick: () => p((e) => !e),
						className: mx("flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-medium transition", d ? "border-slate-900 bg-slate-900 text-white" : "border-slate-200 bg-white text-slate-700 hover:border-slate-300 hover:bg-slate-50"),
						children: [/* @__PURE__ */ _(wa, {
							className: "h-4 w-4",
							"aria-hidden": "true"
						}), "Flow controls"]
					}), d && /* @__PURE__ */ v(g, { children: [/* @__PURE__ */ _("div", {
						className: "fixed inset-0 z-40",
						onClick: () => p(!1)
					}), /* @__PURE__ */ v("div", {
						className: "absolute right-0 top-full z-50 mt-2 w-72 rounded-[1.5rem] border border-slate-200 bg-white p-5 shadow-[0_22px_60px_rgba(15,23,42,0.14)]",
						children: [/* @__PURE__ */ v("div", {
							className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: [/* @__PURE__ */ _(Ha, {
								className: "h-4 w-4 text-cyan-600",
								"aria-hidden": "true"
							}), "Flow controls"]
						}), /* @__PURE__ */ v("div", {
							className: "mt-4 space-y-4",
							children: [
								/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
									className: "text-sm font-semibold text-slate-900",
									children: "Master rows"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 flex flex-wrap gap-2",
									children: [
										6,
										10,
										14
									].map((n) => /* @__PURE__ */ _("button", {
										type: "button",
										onClick: () => t(n),
										className: mM(e === n),
										children: n
									}, n))
								})] }),
								/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
									className: "text-sm font-semibold text-slate-900",
									children: "Detail latency"
								}), /* @__PURE__ */ _("div", {
									className: "mt-2 flex flex-wrap gap-2",
									children: rM.map((e) => /* @__PURE__ */ v("button", {
										type: "button",
										onClick: () => r(e),
										className: mM(n === e),
										children: [e, " ms"]
									}, e))
								})] }),
								/* @__PURE__ */ v("div", {
									className: "rounded-[1.3rem] border border-slate-200 bg-slate-50 px-4 py-3",
									children: [
										/* @__PURE__ */ _("div", {
											className: "text-[11px] font-semibold uppercase tracking-[0.16em] text-slate-500",
											children: "Current selection"
										}),
										/* @__PURE__ */ _("div", {
											className: "mt-2 text-sm font-semibold text-slate-950",
											children: i?.order_id ? String(i.order_id) : "No order selected"
										}),
										i && y?.rowid !== i.rowid ? /* @__PURE__ */ _(_x, {
											tone: "warning",
											variant: "soft",
											size: "sm",
											uppercase: !1,
											className: "mt-3",
											children: "Updating deferred detail selection…"
										}) : null
									]
								})
							]
						})]
					})] })]
				})]
			}) }),
			/* @__PURE__ */ v("div", {
				className: mx("flex items-center gap-3 rounded-[1.4rem] border px-5 py-3 text-sm transition-colors", i ? "border-cyan-200 bg-cyan-50 text-cyan-900" : "border-slate-200 bg-slate-50 text-slate-500"),
				children: [
					/* @__PURE__ */ _(Uo, {
						className: mx("h-4 w-4 flex-shrink-0", i ? "text-cyan-600" : "text-slate-400"),
						"aria-hidden": "true"
					}),
					/* @__PURE__ */ _("span", {
						className: "flex-1",
						children: i ? c : "No order selected"
					}),
					i ? y?.rowid === i.rowid ? /* @__PURE__ */ _(_x, {
						tone: "success",
						variant: "soft",
						size: "sm",
						uppercase: !1,
						children: String(i.order_id)
					}) : /* @__PURE__ */ _(_x, {
						tone: "warning",
						variant: "soft",
						size: "sm",
						uppercase: !1,
						children: "Loading…"
					}) : null
				]
			}),
			/* @__PURE__ */ v("div", {
				className: "grid gap-4 xl:grid-cols-2",
				children: [/* @__PURE__ */ v(gM, {
					className: "overflow-hidden",
					children: [
						/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Master grid"
						}),
						/* @__PURE__ */ _("div", {
							className: "mt-2 text-sm leading-6 text-slate-600",
							children: "Click a row or use the row action to select a parent record that drives a second datagrid."
						}),
						/* @__PURE__ */ _("div", {
							className: "mt-4 min-h-[34rem] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white",
							children: /* @__PURE__ */ _(ew, {
								mode: "provider",
								provider: x,
								databaseId: "master-grid",
								tableName: "orders",
								idField: "rowid",
								actions: [$.VIEW],
								actionHandlers: { onView: (e, t) => {
									m(t ?? null);
								} },
								onRowClick: (e, t) => m(t ?? null),
								pageSize: 8,
								pageSizeOptions: [8, 12],
								layoutOptions: { maxHeight: "100%" },
								presentation: E
							})
						})
					]
				}), /* @__PURE__ */ v(gM, {
					className: "overflow-hidden",
					children: [/* @__PURE__ */ v("div", {
						className: "flex items-center justify-between gap-3",
						children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Detail grid"
						}), /* @__PURE__ */ _("div", {
							className: "mt-2 text-sm leading-6 text-slate-600",
							children: "The second grid stays provider-backed, so load timing and row counts reflect the selected parent state."
						})] }), /* @__PURE__ */ v(_x, {
							tone: "neutral",
							variant: "outline",
							size: "sm",
							uppercase: !1,
							children: [n, " ms latency"]
						})]
					}), y ? /* @__PURE__ */ _("div", {
						className: "mt-4 min-h-[34rem] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white",
						children: /* @__PURE__ */ _(ew, {
							mode: "provider",
							provider: C,
							databaseId: "detail-grid",
							tableName: "line_items",
							idField: "rowid",
							actions: [],
							pageSize: 8,
							pageSizeOptions: [8, 12],
							layoutOptions: { maxHeight: "100%" }
						}, w)
					}) : /* @__PURE__ */ _("div", {
						className: "mt-4 flex min-h-[34rem] items-center justify-center rounded-[1.5rem] border border-dashed border-slate-300 bg-slate-50 px-6 text-center text-sm leading-6 text-slate-500",
						children: "Select a row in the master grid to mount the detail datagrid with its own fetch lifecycle."
					})]
				})]
			})
		]
	});
}
function JM() {
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-graph-page",
		children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
			badge: "Graph Viewer",
			eyebrow: "Shared explorer primitive",
			title: "A compact routing graph that shows how docs, tasks, and subsystem anchors connect.",
			description: "This page uses the same graph explorer contract as the larger shell surfaces, but keeps the fixture intentionally small so reviewers can focus on zoom, scope, search, and inspector actions."
		}) }), /* @__PURE__ */ _(gM, {
			className: "overflow-hidden bg-[radial-gradient(circle_at_top,#11223e_0%,#0b1325_46%,#070b14_100%)] p-0",
			children: /* @__PURE__ */ _(NT, {
				badgeLabel: "Ops",
				title: "Docs & Routing Graph",
				description: "A small graph fixture for validating the explorer surface outside the larger observatory map.",
				searchPlaceholder: "TODO-0147, datagrid architecture, UX...",
				graph: sM,
				typeOrder: iM,
				typeMeta: aM,
				edgeMeta: oM,
				defaultViewMode: "full",
				compactNodeLimit: 24,
				compactEdgeLimit: 36,
				containerClassName: "h-[46rem] overflow-auto",
				testIdPrefix: "widget-showcase-graph",
				glossary: [{
					title: "Why this graph exists",
					description: "This route is intentionally smaller than the full Vault graph so we can review the shared explorer primitive without loading the merged observatory topology."
				}]
			})
		})]
	});
}
function YM() {
	let [e, t] = h("Use the inspector to simulate lineage follow-up actions.");
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-lineage-page",
		children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
			badge: "Lineage DAG",
			eyebrow: "Lineage-specific fixture",
			title: "A lineage-oriented DAG that reuses the same explorer while keeping lineage semantics visible.",
			description: "The fixture below mirrors the viewer contract used in the shell lineage route, but with a deterministic sample graph so we can demo upstream tables, downstream issues, and summarized reports without waiting on live route data."
		}) }), /* @__PURE__ */ v("div", {
			className: "grid gap-4 xl:grid-cols-[0.72fr_1.28fr]",
			children: [/* @__PURE__ */ v(gM, { children: [
				/* @__PURE__ */ v("div", {
					className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
					children: [/* @__PURE__ */ _(xo, {
						className: "h-4 w-4 text-emerald-600",
						"aria-hidden": "true"
					}), "Lineage follow-up"]
				}),
				/* @__PURE__ */ _("div", {
					className: "mt-4 rounded-[1.3rem] border border-slate-200 bg-slate-50 px-4 py-4 text-sm leading-6 text-slate-600",
					children: e
				}),
				/* @__PURE__ */ v("div", {
					className: "mt-4 space-y-3 text-sm leading-6 text-slate-600",
					children: [/* @__PURE__ */ _("p", { children: "This sample keeps the lineage semantics obvious: database, table, and column nodes sit upstream; checks, issues, and reports sit downstream." }), /* @__PURE__ */ _("p", { children: "It is meant to demonstrate the DAG surface itself, not to replace the live observatory lineage route." })]
				})
			] }), /* @__PURE__ */ _(gM, {
				className: "overflow-hidden bg-[radial-gradient(circle_at_top,#11223e_0%,#0b1325_46%,#070b14_100%)] p-0",
				children: cM ? /* @__PURE__ */ _(NT, {
					badgeLabel: "Ops",
					title: "Lineage Demo",
					description: "A stable DAG fixture for lineage viewer reviews.",
					searchPlaceholder: "orders, quantity spike, daily ops...",
					graph: cM,
					typeOrder: dM,
					typeMeta: lM,
					edgeMeta: uM,
					defaultViewMode: "full",
					compactNodeLimit: 24,
					compactEdgeLimit: 40,
					containerClassName: "h-[46rem] overflow-auto",
					testIdPrefix: "widget-showcase-lineage",
					renderInspectorActions: (e) => /* @__PURE__ */ v("div", {
						className: "space-y-3",
						children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-400",
							children: "Demo actions"
						}), /* @__PURE__ */ v("div", {
							className: "flex flex-wrap gap-2",
							children: [/* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => t(`Pinned ${e.name}. A live surface could hand off into quality remediation or source exploration from here.`),
								className: "rounded-full bg-emerald-300 px-3 py-2 text-xs font-medium text-slate-950 transition hover:bg-emerald-200",
								children: "Simulate handoff"
							}), /* @__PURE__ */ _("button", {
								type: "button",
								onClick: () => t(`Inspecting node ${e.id} to compare lineage shape with the current DAG fixture.`),
								className: "rounded-full border border-white/15 bg-white/10 px-3 py-2 text-xs font-medium text-white transition hover:bg-white/16",
								children: "Inspect asset"
							})]
						})]
					})
				}) : /* @__PURE__ */ _("div", {
					className: "flex h-[46rem] items-center justify-center text-sm text-slate-300",
					children: "Lineage fixture unavailable."
				})
			})]
		})]
	});
}
function XM() {
	let { toast: e } = uw();
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-buttons-page",
		children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
			badge: "Buttons",
			eyebrow: "Current shell language",
			title: "Review the button patterns we actually use, shown where they normally live.",
			description: "There is not a single exported Button primitive yet, so this page groups the current shell language into realistic placements: hero actions, inline workflows, destructive operations, and dialog footers. Click any button to see the toast feedback."
		}) }), /* @__PURE__ */ v("div", {
			className: "grid gap-4 lg:grid-cols-2",
			children: [
				/* @__PURE__ */ v(gM, { children: [
					/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(ls, {
							className: "h-4 w-4 text-cyan-600",
							"aria-hidden": "true"
						}), "Hero actions"]
					}),
					/* @__PURE__ */ _("p", {
						className: "mt-2 text-xs leading-5 text-slate-400",
						children: "Primary and secondary CTA pair from the top of a route surface."
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-4 flex flex-wrap gap-2",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "success",
								title: "Review launched",
								description: "The review session is now open. Findings will appear in the pipeline gate."
							}),
							className: hM("primary"),
							children: "Launch review"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "info",
								title: "Opening docs",
								description: "Shell button language reference opens in the observatory."
							}),
							className: hM("secondary"),
							children: "Open docs"
						})]
					})
				] }),
				/* @__PURE__ */ v(gM, { children: [
					/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(ps, {
							className: "h-4 w-4 text-emerald-600",
							"aria-hidden": "true"
						}), "Grid workflow"]
					}),
					/* @__PURE__ */ _("p", {
						className: "mt-2 text-xs leading-5 text-slate-400",
						children: "Inline action row inside a datagrid — approve or retry without leaving the table."
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-4 flex flex-wrap gap-2",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "success",
								title: "Batch approved",
								description: "12 records approved and queued for the next publish snapshot."
							}),
							className: "rounded-full bg-emerald-300 px-4 py-2 text-sm font-medium text-slate-950 transition hover:bg-emerald-200",
							children: "Approve batch"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "warning",
								title: "Sync retrying",
								description: "Re-queued the source sync. Previous attempt failed at record 847."
							}),
							className: "rounded-full border border-amber-200 bg-amber-50 px-4 py-2 text-sm font-medium text-amber-800 transition hover:border-amber-300 hover:bg-amber-100",
							children: "Retry sync"
						})]
					})
				] }),
				/* @__PURE__ */ v(gM, { children: [
					/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(Uo, {
							className: "h-4 w-4 text-slate-500",
							"aria-hidden": "true"
						}), "Dialog footer"]
					}),
					/* @__PURE__ */ _("p", {
						className: "mt-2 text-xs leading-5 text-slate-400",
						children: "Confirm / cancel pair at the bottom of a modal or sheet."
					}),
					/* @__PURE__ */ v("div", {
						className: "mt-4 flex flex-wrap gap-2",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "info",
								title: "Cancelled",
								description: "No changes were saved.",
								duration: 3e3
							}),
							className: hM("secondary"),
							children: "Cancel"
						}), /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "success",
								title: "Changes saved",
								description: "Your edits have been persisted and will appear on the next load."
							}),
							className: hM("primary"),
							children: "Save changes"
						})]
					})
				] }),
				/* @__PURE__ */ v(gM, { children: [
					/* @__PURE__ */ v("div", {
						className: "flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: [/* @__PURE__ */ _(yo, {
							className: "h-4 w-4 text-rose-500",
							"aria-hidden": "true"
						}), "Destructive action"]
					}),
					/* @__PURE__ */ _("p", {
						className: "mt-2 text-xs leading-5 text-slate-400",
						children: "High-stakes operation — delete or purge with explicit error-tone feedback."
					}),
					/* @__PURE__ */ _("div", {
						className: "mt-4 flex flex-wrap gap-2",
						children: /* @__PURE__ */ _("button", {
							type: "button",
							onClick: () => e({
								type: "error",
								title: "Publication deleted",
								description: "This action cannot be undone. The snapshot has been removed from the registry."
							}),
							className: hM("danger"),
							children: "Delete publication"
						})
					})
				] })
			]
		})]
	});
}
function ZM() {
	let [e, t] = h("Hover or focus a tooltip target to confirm the copy and placement.");
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "widget-showcase-tooltips-page",
		children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
			badge: "Tooltips",
			eyebrow: "Inline metadata hints",
			title: "Review tooltip copy where it actually sits: in labels, metadata chips, and dense utility rows.",
			description: "These examples use the existing tooltip component directly so we can evaluate copy length, tone, and placement before shipping the same pattern into other shell surfaces."
		}) }), /* @__PURE__ */ v("div", {
			className: "grid gap-4 xl:grid-cols-[0.74fr_1.26fr]",
			children: [/* @__PURE__ */ v(gM, { children: [
				/* @__PURE__ */ _("div", {
					className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
					children: "Tooltip activity"
				}),
				/* @__PURE__ */ _("div", {
					className: "mt-4 rounded-[1.3rem] border border-slate-200 bg-slate-50 px-4 py-4 text-sm leading-6 text-slate-600",
					children: e
				}),
				/* @__PURE__ */ v("div", {
					className: "mt-5 space-y-3",
					children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Tooltip types in this demo"
					}), [
						{
							label: "Plain",
							description: "Single short phrase — button or icon affordance."
						},
						{
							label: "Metadata chip",
							description: "Key: value pairs for scored or measured attributes."
						},
						{
							label: "Inline label",
							description: "Appended to a label inside a text flow."
						},
						{
							label: "Custom tone",
							description: "Amber surface for cautionary or review-stage copy."
						},
						{
							label: "Ticket",
							description: "Trigger is a full styled chip, not just an icon."
						},
						{
							label: "Informative",
							description: "Multi-section explanation with provenance detail."
						}
					].map((e) => /* @__PURE__ */ v("div", {
						className: "rounded-[1.2rem] border border-slate-200 bg-white px-4 py-3",
						children: [/* @__PURE__ */ _("div", {
							className: "text-sm font-semibold text-slate-900",
							children: e.label
						}), /* @__PURE__ */ _("p", {
							className: "mt-1 text-xs leading-5 text-slate-500",
							children: e.description
						})]
					}, e.label))]
				})
			] }), /* @__PURE__ */ v("div", {
				className: "grid gap-4 lg:grid-cols-2",
				children: [
					/* @__PURE__ */ v(gM, { children: [
						/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Plain"
						}),
						/* @__PURE__ */ v("div", {
							className: "mt-4 flex items-center gap-3",
							children: [/* @__PURE__ */ _("button", {
								type: "button",
								className: "rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50",
								children: "Export"
							}), /* @__PURE__ */ _(Ux, {
								text: "Export as CSV",
								onOpen: () => t("Opened the plain export button tooltip.")
							})]
						}),
						/* @__PURE__ */ v("div", {
							className: "mt-4 flex items-center gap-3",
							children: [/* @__PURE__ */ _("button", {
								type: "button",
								className: "rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-slate-50",
								children: "Refresh"
							}), /* @__PURE__ */ _(Ux, {
								text: "Reload from source",
								onOpen: () => t("Opened the plain refresh button tooltip.")
							})]
						})
					] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Metadata chip"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 flex items-center gap-3",
						children: [/* @__PURE__ */ _("span", {
							className: "rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-sm font-medium text-slate-700",
							children: "Quality score 94"
						}), /* @__PURE__ */ _(Ux, {
							text: "Quality score: Weighted from latest checks and issue severity.\nRefresh cadence: Updated when the publication snapshot is regenerated.",
							onOpen: () => t("Opened the quality score metadata tooltip.")
						})]
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Inline label"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 text-sm text-slate-700",
						children: ["Working set", /* @__PURE__ */ _(Ux, {
							text: "Working Set: A pre-filter reduction of the current table.\nExecution order: working_set -> filters/search -> sampling -> stats/view/export.",
							className: "ml-2 align-middle",
							onOpen: () => t("Opened the working set inline tooltip.")
						})]
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Custom tone"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 flex items-center gap-3",
						children: [/* @__PURE__ */ _("button", {
							type: "button",
							className: "rounded-full border border-amber-200 bg-amber-50 px-3 py-2 text-sm font-medium text-amber-900",
							children: "Review notice"
						}), /* @__PURE__ */ _(Ux, {
							text: "Review notice: This tooltip uses a warmer tone for risk or cautionary copy.\nAudience: operators reviewing edge cases before a publish step.",
							onOpen: () => t("Opened the custom-toned review tooltip."),
							tooltipClassName: "rounded-xl border border-amber-300 bg-amber-100 text-amber-950 shadow-lg"
						})]
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Ticket Tooltip"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 flex flex-wrap items-center gap-2 text-sm text-slate-700",
						children: [
							/* @__PURE__ */ _("span", {
								className: "rounded-full border border-slate-200 bg-white px-3 py-1",
								children: "Snapshot created 10:30 UTC"
							}),
							/* @__PURE__ */ _("span", {
								className: "rounded-full border border-slate-200 bg-white px-3 py-1",
								children: "Client visibility: published"
							}),
							/* @__PURE__ */ _(Ux, {
								text: "Snapshot provenance: The client-facing publication is rendered from a persisted snapshot, not from live mutable observatory state.",
								onOpen: () => t("Opened the ticket tooltip (Why snapshot-backed?)."),
								children: /* @__PURE__ */ _("span", {
									className: "inline-flex cursor-pointer rounded-full border border-slate-200 bg-slate-50 px-3 py-1 text-sm font-medium text-slate-700 transition hover:border-slate-300 hover:bg-white",
									children: "Why snapshot-backed?"
								})
							})
						]
					})] }),
					/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Informative"
					}), /* @__PURE__ */ v("div", {
						className: "mt-4 flex items-center gap-3",
						children: [/* @__PURE__ */ _("span", {
							className: "rounded-full border border-indigo-200 bg-indigo-50 px-3 py-1 text-sm font-medium text-indigo-800",
							children: "Data Lineage"
						}), /* @__PURE__ */ _(Ux, {
							text: "Data Lineage: Shows upstream and downstream dependencies for this asset.\nSource systems: 3 upstream systems contribute to this view.\nRefresh cadence: Every 6 hours via scheduled job.\nOwner: Data Engineering.\nLast verified: 2026-05-22 via reconciliation run.",
							onOpen: () => t("Opened the informative data lineage tooltip."),
							tooltipClassName: "rounded-xl border border-indigo-200 bg-white text-slate-800 shadow-xl"
						})]
					})] })
				]
			})]
		})]
	});
}
var QM = [
	{
		rowid: 1,
		order_id: 1001,
		customer_id: 501,
		status: "paid",
		total_amount: 1290,
		created_at: "2026-05-01"
	},
	{
		rowid: 2,
		order_id: 1002,
		customer_id: 502,
		status: "review",
		total_amount: 740,
		created_at: "2026-05-03"
	},
	{
		rowid: 3,
		order_id: 1003,
		customer_id: 501,
		status: "paid",
		total_amount: 2160,
		created_at: "2026-05-06"
	}
];
function $M(e) {
	return av.tables.find((t) => t.name === e) ?? av.tables[0];
}
function eN(e) {
	return e.type === "string" || e.type === "boolean" ? "eq" : "gte";
}
function tN(e) {
	return e.type === "number" ? "100" : e.type === "boolean" ? "true" : e.type === "date" ? "2026-05-01" : e.name === "status" ? "paid" : "north";
}
function nN(e, t) {
	return t.type === "number" ? Number(e) : t.type === "boolean" ? e === "true" : e;
}
function rN(e) {
	return Array.isArray(e) ? e.join("...") : e == null ? "" : String(e);
}
function iN(e) {
	let t = JSON.parse(JSON.stringify(e));
	return delete t.generatedSql, t;
}
function aN(e) {
	return JSON.stringify(e);
}
function oN({ onAddSqlView: e, workingSetAssetCount: t = 0 } = {}) {
	let [n, r] = h("orders"), i = $M(n), [a, o] = h(["order_id", "total_amount"]), [c, l] = h("status"), u = i.columns.find((e) => e.name === c) ?? i.columns[0], [d, p] = h("eq"), [g, y] = h("paid"), [b, x] = h("created_at"), [S, C] = h("desc"), [w, T] = h(100), [E, D] = h(null), [O, k] = h(null), [A, j] = h(null), [M, N] = h("Show paid orders"), [P, F] = h(null), [I, L] = h([]), R = m(1), z = s(() => {
		D(null), k(null), j(null), F(null);
	}, []), B = f(() => Jj({
		databaseLabel: "query-builder-fixture",
		tables: { orders: {
			rows: QM,
			columns: [
				"order_id",
				"customer_id",
				"status",
				"total_amount",
				"created_at"
			]
		} }
	}), []), V = f(() => {
		if (A) return A;
		let e = a.length > 0 ? a : [i.columns[0]?.name ?? "rowid"], t = i.columns.find((e) => e.name === c) ?? i.columns[0], n = i.columns.find((e) => e.name === b) ?? i.columns[0];
		return {
			version: 1,
			source: {
				schema: i.schema,
				table: i.name
			},
			select: e.map((e) => ({
				schema: i.schema,
				table: i.name,
				column: e
			})),
			filters: t ? [{
				ref: {
					schema: i.schema,
					table: i.name,
					column: t.name
				},
				operator: d,
				value: nN(g, t)
			}] : [],
			orderBy: n ? [{
				ref: {
					schema: i.schema,
					table: i.name,
					column: n.name
				},
				direction: S
			}] : [],
			limit: w
		};
	}, [
		A,
		c,
		d,
		g,
		w,
		a,
		b,
		S,
		i
	]), H = f(() => {
		try {
			return Ov(V);
		} catch (e) {
			return {
				generator: "query-builder.v1",
				dialect: "sqlite",
				sql: e instanceof Error ? e.message : "Unable to generate SQL preview.",
				parameters: [],
				metadata: {
					dialect: "sqlite",
					capabilities: ev.sqlite,
					parameterStyle: "qmark",
					unsupportedFeatures: []
				}
			};
		}
	}, [V]), ee = H.sql, U = f(() => ({
		...V,
		generatedSql: H
	}), [V, H]), te = f(() => kv(U), [U]), W = f(() => qv({
		ast: iN(U),
		dialect: "sqlite",
		indexes: ov.find((e) => e.schema === V.source.schema && e.table === V.source.table)?.indexes,
		runId: "widget-showcase-preview",
		collectedAt: "2026-05-15T00:00:00.000Z"
	}), [
		V.source.schema,
		V.source.table,
		U
	]), ne = f(() => Xv(U, { planTelemetry: W }), [U, W]), re = f(() => te.valid ? ey({
		ast: iN(U),
		evaluation: ne,
		dialect: "sqlite",
		createdAt: "2026-05-15T00:00:00.000Z"
	}) : null, [
		U,
		ne,
		te.valid
	]), ie = aN(U), ae = te.valid && E === ie, oe = f(() => te.valid ? [
		"AST validation passed",
		`${a.length} projected columns`,
		`Limit ${w}`
	] : te.issues.map((e) => e.code), [
		w,
		a.length,
		te
	]), se = f(() => Array.from(new Set([...oe, ...ne.signals.map((e) => `${e.code}:${e.evidence}`)])), [oe, ne.signals]), ce = (e) => {
		let t = $M(e), n = t.columns.slice(0, 2).map((e) => e.name), i = t.columns.find((e) => e.indexed)?.name ?? t.columns[0]?.name ?? "", a = t.columns.find((e) => e.name === i) ?? t.columns[0];
		r(t.name), o(n), l(i), p(a ? eN(a) : "eq"), y(a ? tN(a) : ""), x(t.columns[0]?.name ?? ""), C("asc"), T(100), z();
	}, le = (e) => {
		o((t) => {
			let n = t.includes(e) ? t.filter((t) => t !== e) : [...t, e];
			return n.length > 0 ? n : t;
		}), z();
	}, ue = (e) => {
		let t = i.columns.find((t) => t.name === e) ?? i.columns[0];
		l(t.name), p(eN(t)), y(tN(t)), z();
	}, de = (e) => {
		let t = $M(e.source.table), n = e.select.filter((e) => e.schema === t.schema && e.table === t.name).map((e) => e.column).filter((e) => t.columns.some((t) => t.name === e)), i = (e.filters ?? []).find((e) => e.ref.schema === t.schema && e.ref.table === t.name && [
			"eq",
			"neq",
			"contains",
			"gt",
			"gte",
			"lt",
			"lte"
		].includes(e.operator)), a = i ? t.columns.find((e) => e.name === i.ref.column) : void 0, s = e.orderBy?.find((e) => e.ref.schema === t.schema && e.ref.table === t.name);
		r(t.name), o(n.length > 0 ? n : t.columns.slice(0, 2).map((e) => e.name)), i && a && (l(a.name), p(i.operator), y(rN(i.value))), s && t.columns.some((e) => e.name === s.ref.column) && (x(s.ref.column), C(s.direction)), T(typeof e.limit == "number" ? e.limit : 100);
	}, fe = () => {
		F(oy({
			prompt: M,
			currentAst: U
		})), k(null);
	}, pe = () => {
		if (P?.status !== "draft") return;
		let e = iN(sy(P));
		de(e), j(e), D(null), k("Prompt draft accepted. Review AST before save.");
	}, me = (e, t = (/* @__PURE__ */ new Date()).toISOString()) => {
		let n = R.current++, r = JSON.parse(JSON.stringify(U));
		return {
			id: `qbv-${n}`,
			label: `Version ${n}`,
			ast: r,
			generatedSql: H,
			owner: "Query Builder Demo",
			createdAt: t,
			signals: se,
			reviewStatus: e,
			lineageSummary: `${r.source.schema}.${r.source.table} -> ${r.generatedSql?.generator ?? "query-builder.v1"}`
		};
	}, he = (e) => {
		L((t) => [e, ...t]);
	}, ge = () => {
		let e = me(ae ? "reviewed" : "draft");
		he(e), k(`${e.label} saved to Query Builder history.`);
	}, _e = (t) => {
		let n = iN(t.ast);
		de(n), j(n), F(null), D(t.reviewStatus === "reviewed" ? aN(t.ast) : null), k(`${t.label} restored with ${t.reviewStatus} review status.`), t.reviewStatus === "reviewed" && e?.({
			ast: t.ast,
			generatedSql: t.generatedSql,
			owner: t.owner,
			createdAt: t.createdAt,
			signals: t.signals
		});
	};
	return /* @__PURE__ */ v("div", {
		className: "space-y-5",
		"data-testid": "query-builder-route",
		children: [
			/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ _(_M, {
				badge: "Query Builder",
				eyebrow: "AST first",
				title: "Build a governed query visually, then review the canonical AST before save.",
				description: "This contract-backed proof keeps SQL as generated preview output. The JSON AST is the durable contract that preview execution, prompt, signal, and history work reuse."
			}) }),
			/* @__PURE__ */ v("div", {
				className: "grid gap-4 xl:grid-cols-[0.9fr_1.1fr]",
				children: [/* @__PURE__ */ _(gM, { children: /* @__PURE__ */ v("div", {
					className: "flex flex-col gap-4",
					children: [
						/* @__PURE__ */ v("div", {
							className: "rounded-xl border border-cyan-100 bg-cyan-50/70 p-4",
							children: [/* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-start justify-between gap-3",
								children: [/* @__PURE__ */ v("label", {
									className: "min-w-0 flex-1 text-sm font-medium text-slate-700",
									children: ["Prompt Query Builder", /* @__PURE__ */ _("textarea", {
										className: "mt-2 min-h-20 w-full rounded-lg border border-cyan-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-prompt-input",
										onChange: (e) => {
											N(e.target.value), F(null), k(null);
										},
										value: M
									})]
								}), /* @__PURE__ */ v("div", {
									className: "flex flex-wrap gap-2 pt-7",
									children: [/* @__PURE__ */ _("button", {
										className: hM("secondary"),
										"data-testid": "query-builder-prompt-draft",
										onClick: fe,
										type: "button",
										children: "Draft AST"
									}), /* @__PURE__ */ _("button", {
										className: hM("primary"),
										"data-testid": "query-builder-prompt-accept",
										disabled: P?.status !== "draft",
										onClick: pe,
										type: "button",
										children: "Accept draft"
									})]
								})]
							}), P ? /* @__PURE__ */ v("div", {
								className: "mt-3 space-y-3 text-sm text-slate-700",
								children: [/* @__PURE__ */ _("div", {
									"data-testid": "query-builder-prompt-state",
									children: P.status === "draft" ? `Draft ready: ${P.draft.summary}` : `Draft rejected: ${P.issues.map((e) => e.code).join(", ")}`
								}), /* @__PURE__ */ _("div", {
									className: "grid gap-2",
									"data-testid": "query-builder-prompt-diff",
									children: (P.status === "draft" ? P.draft.diff : P.diff).filter((e) => e.status !== "unchanged").map((e) => /* @__PURE__ */ v("div", {
										className: "rounded-lg border border-cyan-100 bg-white px-3 py-2 text-xs text-slate-600",
										children: [/* @__PURE__ */ _("span", {
											className: "font-semibold text-slate-900",
											children: e.label
										}), /* @__PURE__ */ v("span", {
											className: "ml-2",
											children: [
												e.before,
												" -> ",
												e.after
											]
										})]
									}, e.field))
								})]
							}) : null]
						}),
						/* @__PURE__ */ v("label", {
							className: "text-sm font-medium text-slate-700",
							children: ["Table", /* @__PURE__ */ _("select", {
								className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
								"data-testid": "query-builder-table-select",
								onChange: (e) => ce(e.target.value),
								value: n,
								children: av.tables.filter((e) => e.schema === "analytics").map((e) => /* @__PURE__ */ v("option", {
									value: e.name,
									children: [
										e.schema,
										".",
										e.name
									]
								}, e.name))
							})]
						}),
						/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
							className: "text-sm font-medium text-slate-700",
							children: "Columns"
						}), /* @__PURE__ */ _("div", {
							className: "mt-2 grid gap-2 sm:grid-cols-2",
							children: i.columns.map((e) => /* @__PURE__ */ v("label", {
								className: "flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm text-slate-700",
								children: [
									/* @__PURE__ */ _("input", {
										checked: a.includes(e.name),
										"data-testid": `query-builder-column-${e.name}`,
										onChange: () => le(e.name),
										type: "checkbox"
									}),
									/* @__PURE__ */ _("span", { children: e.name }),
									e.indexed ? /* @__PURE__ */ _(_x, {
										tone: "success",
										variant: "soft",
										size: "xs",
										uppercase: !1,
										children: "indexed"
									}) : null
								]
							}, e.name))
						})] }),
						/* @__PURE__ */ v("div", {
							className: "grid gap-3 md:grid-cols-[1fr_0.8fr_1fr]",
							children: [
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Filter column", /* @__PURE__ */ _("select", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-filter-column",
										onChange: (e) => ue(e.target.value),
										value: u.name,
										children: i.columns.map((e) => /* @__PURE__ */ _("option", {
											value: e.name,
											children: e.name
										}, e.name))
									})]
								}),
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Operator", /* @__PURE__ */ _("select", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-filter-operator",
										onChange: (e) => {
											p(e.target.value), z();
										},
										value: d,
										children: [
											"eq",
											"neq",
											"contains",
											"gt",
											"gte",
											"lt",
											"lte"
										].map((e) => /* @__PURE__ */ _("option", {
											value: e,
											children: e
										}, e))
									})]
								}),
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Value", /* @__PURE__ */ _("input", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-filter-value",
										onChange: (e) => {
											y(e.target.value), z();
										},
										value: g
									})]
								})
							]
						}),
						/* @__PURE__ */ v("div", {
							className: "grid gap-3 md:grid-cols-[1fr_0.7fr_0.7fr]",
							children: [
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Sort column", /* @__PURE__ */ _("select", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-sort-column",
										onChange: (e) => {
											x(e.target.value), z();
										},
										value: b,
										children: i.columns.map((e) => /* @__PURE__ */ _("option", {
											value: e.name,
											children: e.name
										}, e.name))
									})]
								}),
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Direction", /* @__PURE__ */ v("select", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-sort-direction",
										onChange: (e) => {
											C(e.target.value), z();
										},
										value: S,
										children: [/* @__PURE__ */ _("option", {
											value: "asc",
											children: "asc"
										}), /* @__PURE__ */ _("option", {
											value: "desc",
											children: "desc"
										})]
									})]
								}),
								/* @__PURE__ */ v("label", {
									className: "text-sm font-medium text-slate-700",
									children: ["Limit", /* @__PURE__ */ _("input", {
										className: "mt-2 w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm",
										"data-testid": "query-builder-limit",
										min: 1,
										onChange: (e) => {
											T(Number(e.target.value)), z();
										},
										type: "number",
										value: w
									})]
								})
							]
						})
					]
				}) }), /* @__PURE__ */ v("div", {
					className: "grid gap-4",
					children: [
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ v("div", {
							className: "flex flex-wrap items-center justify-between gap-3",
							children: [/* @__PURE__ */ v("div", { children: [/* @__PURE__ */ _("div", {
								className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
								children: "Review gate"
							}), /* @__PURE__ */ _("p", {
								className: "mt-2 text-sm text-slate-600",
								"data-testid": "query-builder-validation-state",
								children: te.valid ? "AST validation passed" : te.issues.map((e) => e.code).join(", ")
							})] }), /* @__PURE__ */ v("div", {
								className: "flex flex-wrap gap-2",
								children: [
									/* @__PURE__ */ _("button", {
										className: hM("secondary"),
										"data-testid": "query-builder-review",
										disabled: !te.valid,
										onClick: () => D(ie),
										type: "button",
										children: "Review AST"
									}),
									/* @__PURE__ */ _("button", {
										className: hM("secondary"),
										"data-testid": "query-builder-save-version",
										disabled: !te.valid,
										onClick: ge,
										type: "button",
										children: "Save version"
									}),
									/* @__PURE__ */ _("button", {
										className: hM("primary"),
										"data-testid": "query-builder-add-view",
										disabled: !ae,
										onClick: () => {
											if (!ae) return;
											let t = (/* @__PURE__ */ new Date()).toISOString();
											he(me("reviewed", t)), e?.({
												ast: U,
												generatedSql: H,
												owner: "Query Builder Demo",
												createdAt: t,
												signals: se
											}), k(e ? "SQL view added to active Working Set." : "SQL view reviewed; no Working Set adapter attached.");
										},
										type: "button",
										children: "Add SQL as view"
									})
								]
							})]
						}), /* @__PURE__ */ v("div", {
							className: "mt-4 flex flex-wrap items-center gap-3 text-sm text-slate-600",
							children: [/* @__PURE__ */ v("span", {
								"data-testid": "query-builder-working-set-count",
								children: [t, " Working Set assets"]
							}), O ? /* @__PURE__ */ _("span", {
								className: "font-medium text-emerald-700",
								"data-testid": "query-builder-save-feedback",
								children: O
							}) : null]
						})] }),
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Generated SQL preview"
						}), /* @__PURE__ */ _("pre", {
							className: "mt-3 max-h-44 overflow-auto rounded-xl bg-slate-950 p-4 text-xs leading-6 text-slate-100",
							"data-testid": "query-builder-sql-preview",
							children: ee
						})] }),
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Canonical AST preview"
						}), /* @__PURE__ */ _("pre", {
							className: "mt-3 max-h-56 overflow-auto rounded-xl bg-slate-50 p-4 text-xs leading-6 text-slate-700",
							"data-testid": "query-builder-ast-preview",
							children: JSON.stringify(U, null, 2)
						})] })
					]
				})]
			}),
			/* @__PURE__ */ v("div", {
				className: "grid gap-4 xl:grid-cols-[0.72fr_1.28fr]",
				children: [/* @__PURE__ */ v("div", {
					className: "space-y-4",
					children: [
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Active Summary"
						}), /* @__PURE__ */ v("div", {
							className: "mt-3 space-y-2 text-sm text-slate-600",
							"data-testid": "query-builder-active-summary",
							children: [
								/* @__PURE__ */ v("div", { children: [
									i.schema,
									".",
									i.name
								] }),
								/* @__PURE__ */ v("div", { children: [a.length, " projected columns"] }),
								/* @__PURE__ */ _("div", { children: ae ? "Review complete" : "Awaiting AST review" }),
								/* @__PURE__ */ _("div", {
									"data-testid": "query-builder-active-signals",
									children: ne.signals.map((e) => e.code).join(", ") || "No advisory signals"
								})
							]
						})] }),
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Performance Trace"
						}), /* @__PURE__ */ v("div", {
							className: "mt-3 space-y-3 text-sm text-slate-600",
							"data-testid": "query-builder-performance-trace",
							children: [
								/* @__PURE__ */ _("div", { children: ne.planTelemetry?.status === "available" ? `Plan telemetry (${ne.planTelemetry.source}): ${ne.planTelemetry.accessPath}` : ne.trace ? `${ne.trace.label}: ${ne.trace.accessPath}` : "Telemetry unavailable for this trace." }),
								ne.planTelemetry?.status === "available" ? /* @__PURE__ */ v("div", { children: [
									"Estimated ",
									ne.planTelemetry.estimatedRows?.toLocaleString() ?? "unknown",
									" rows; bytes ",
									ne.planTelemetry.estimatedBytes?.toLocaleString() ?? "unknown",
									"."
								] }) : ne.trace ? /* @__PURE__ */ v("div", { children: [
									"Scanned ",
									ne.trace.scannedRows?.toLocaleString() ?? "unknown",
									" rows; returned ",
									ne.trace.returnedRows?.toLocaleString() ?? "unknown",
									" rows."
								] }) : null,
								/* @__PURE__ */ _("div", {
									className: "space-y-2",
									children: ne.signals.map((e) => /* @__PURE__ */ v("div", {
										className: mx("rounded-lg border px-3 py-2 text-xs", e.severity === "warning" ? "border-amber-200 bg-amber-50 text-amber-900" : "border-slate-200 bg-slate-50 text-slate-600"),
										children: [
											/* @__PURE__ */ _("span", {
												className: "font-semibold",
												children: e.code
											}),
											/* @__PURE__ */ _("span", {
												className: "ml-2",
												children: e.evidence
											}),
											/* @__PURE__ */ _("div", {
												className: "mt-1",
												children: e.message
											})
										]
									}, e.code))
								})
							]
						})] }),
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "Indexes"
						}), /* @__PURE__ */ v("div", {
							className: "mt-3 space-y-2 text-sm text-slate-600",
							"data-testid": "query-builder-indexes-panel",
							children: [ne.indexes === null ? /* @__PURE__ */ _("div", { children: "Telemetry unavailable for indexes." }) : ne.indexes.length === 0 ? /* @__PURE__ */ _("div", { children: "No index evidence for this table. Telemetry-backed missing-index risk may apply." }) : ne.indexes.map((e) => /* @__PURE__ */ v("div", {
								className: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs",
								children: [
									/* @__PURE__ */ _("span", {
										className: "font-semibold text-slate-900",
										children: e.name
									}),
									/* @__PURE__ */ _("span", {
										className: "ml-2",
										children: e.columns.join(", ")
									}),
									e.unique ? /* @__PURE__ */ _("span", {
										className: "ml-2",
										children: "unique"
									}) : null
								]
							}, e.name)), re ? /* @__PURE__ */ v("div", {
								className: "rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs text-amber-900",
								"data-testid": "query-builder-index-recommendation",
								children: [
									/* @__PURE__ */ v("div", {
										className: "font-semibold",
										children: [
											"Recommendation ",
											re.status,
											": ",
											re.columns.join(", ")
										]
									}),
									/* @__PURE__ */ _("div", { children: re.evidenceSource }),
									/* @__PURE__ */ _("code", { children: re.ddlPreview ?? "DDL preview unavailable for this dialect" })
								]
							}) : null]
						})] }),
						/* @__PURE__ */ v(gM, { children: [/* @__PURE__ */ _("div", {
							className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
							children: "History"
						}), /* @__PURE__ */ _("div", {
							className: "mt-3 space-y-2 text-sm text-slate-600",
							"data-testid": "query-builder-history-menu",
							children: I.length === 0 ? /* @__PURE__ */ _("div", { children: "No saved Query Builder versions yet." }) : I.map((e) => /* @__PURE__ */ _("div", {
								className: "rounded-lg border border-slate-200 bg-slate-50 px-3 py-2 text-xs",
								"data-testid": `query-builder-history-item-${e.id}`,
								children: /* @__PURE__ */ v("div", {
									className: "flex flex-wrap items-center justify-between gap-2",
									children: [/* @__PURE__ */ v("div", { children: [
										/* @__PURE__ */ v("div", {
											className: "font-semibold text-slate-900",
											children: [
												e.label,
												" · ",
												e.reviewStatus
											]
										}),
										/* @__PURE__ */ _("div", { children: e.lineageSummary }),
										/* @__PURE__ */ _("div", { children: e.createdAt })
									] }), /* @__PURE__ */ _("button", {
										className: hM("secondary"),
										"data-testid": `query-builder-restore-${e.id}`,
										onClick: () => _e(e),
										type: "button",
										children: "Restore"
									})]
								})
							}, e.id))
						})] })
					]
				}), /* @__PURE__ */ v(gM, {
					className: "overflow-hidden",
					children: [/* @__PURE__ */ _("div", {
						className: "text-[11px] font-semibold uppercase tracking-[0.18em] text-slate-500",
						children: "Result preview lane"
					}), /* @__PURE__ */ _("div", {
						className: "mt-4 min-h-[24rem] overflow-hidden rounded-[1.5rem] border border-slate-200 bg-white",
						"data-testid": "query-builder-result-preview",
						children: /* @__PURE__ */ _(ew, {
							mode: "provider",
							provider: B,
							databaseId: "query-builder-fixture",
							tableName: "orders",
							columns: [
								"order_id",
								"customer_id",
								"status",
								"total_amount",
								"created_at"
							],
							idField: "rowid",
							actions: [$.VIEW],
							pageSize: 5,
							pageSizeOptions: [5, 10],
							layoutOptions: { maxHeight: "100%" }
						})
					})]
				})]
			})
		]
	});
}
function sN() {
	return /* @__PURE__ */ _("div", {
		className: "h-full overflow-auto bg-[radial-gradient(circle_at_top_left,rgba(191,219,254,0.28),transparent_26%),radial-gradient(circle_at_top_right,rgba(196,181,253,0.20),transparent_24%),linear-gradient(180deg,#f8fafc_0%,#eef2ff_48%,#f8fafc_100%)] px-4 py-4",
		"data-testid": "widget-showcase-shell",
		children: /* @__PURE__ */ v("div", {
			className: "mx-auto flex max-w-[1680px] flex-col gap-5",
			children: [
				/* @__PURE__ */ _(gM, {
					className: "bg-[linear-gradient(145deg,rgba(255,255,255,0.94)_0%,rgba(238,242,255,0.88)_45%,rgba(236,253,245,0.9)_100%)]",
					children: /* @__PURE__ */ v("div", {
						className: "flex flex-col gap-4 xl:flex-row xl:items-end xl:justify-between",
						children: [/* @__PURE__ */ v("div", { children: [
							/* @__PURE__ */ v("div", {
								className: "flex flex-wrap items-center gap-2",
								children: [/* @__PURE__ */ _(_x, {
									tone: "accent",
									variant: "soft",
									size: "sm",
									uppercase: !1,
									children: "Ops"
								}), /* @__PURE__ */ _(_x, {
									tone: "neutral",
									variant: "outline",
									size: "sm",
									uppercase: !1,
									children: "Widget Showcase"
								})]
							}),
							/* @__PURE__ */ _("h1", {
								className: "mt-4 text-3xl font-semibold tracking-tight text-slate-950",
								children: "Component demos inside the shell, where they can be reviewed in context."
							}),
							/* @__PURE__ */ _("p", {
								className: "mt-3 max-w-4xl text-sm leading-7 text-slate-600",
								children: "This route collects the shell-native widget demos you asked for: a datagrid playground with test-backed presets, a master-detail multi-grid page, graph and lineage viewer examples, and focused pages for buttons and tooltips."
							})
						] }), /* @__PURE__ */ v("div", {
							className: "flex flex-wrap gap-2",
							children: [/* @__PURE__ */ _(x, {
								to: "/tables",
								className: hM("secondary"),
								children: "Back to tables"
							}), /* @__PURE__ */ _(x, {
								to: "/runs",
								className: hM("primary"),
								children: "Open runs"
							})]
						})]
					})
				}),
				/* @__PURE__ */ _("div", {
					className: "flex flex-wrap gap-2",
					children: fM.map((e) => /* @__PURE__ */ _(S, {
						to: e.to,
						end: e.id === "overview",
						className: ({ isActive: e }) => pM(e),
						"data-testid": `widget-showcase-link-${e.id}`,
						children: e.label
					}, e.id))
				}),
				/* @__PURE__ */ _(C, {})
			]
		})
	});
}
//#endregion
export { U_ as $, bE as A, xi as At, aC as B, xr as Bt, Ak as C, na as Ct, wk as D, Ei as Dt, xk as E, Ri as Et, uw as F, qr as Ft, Sx as G, rr as Gt, Mx as H, tr as Ht, ew as I, Gr as It, _x as J, X as Jt, yx as K, er as Kt, WC as L, Ar as Lt, NT as M, yi as Mt, lw as N, gi as Nt, ak as O, Oi as Ot, cw as P, oi as Pt, ly as Q, RC as R, kr as Rt, Nk as S, $ as St, Sk as T, Ui as Tt, Ax as U, ir as Ut, tC as V, Z as Vt, kx as W, ar as Wt, cb as X, D as Xt, $b as Y, Yn as Yt, Ty as Z, OA as _, Qa as _t, YM as a, as as at, wA as b, oa as bt, oN as c, Lo as ct, sj as d, Co as dt, L_ as et, LA as f, ho as ft, kA as g, io as gt, DA as h, oo as ht, JM as i, ss as it, qT as j, Si as jt, ik as k, Di as kt, sN as l, No as lt, jA as m, uo as mt, KM as n, hs as nt, qM as o, $o as ot, MA as p, po as pt, vx as q, nr as qt, GM as r, ls as rt, WM as s, Uo as st, XM as t, xs as tt, ZM as u, ko as ut, AA as v, Ha as vt, Ck as w, Zi as wt, Yk as x, aa as xt, TA as y, Ma as yt, LC as z, hr as zt };
